import { useState, useEffect, useRef, Fragment } from "react";

// ── Zugangstoken automatisch an eigene Server-Anfragen anhaengen ──────────────
// Der Server prueft seit der neuen Fassung den Header X-SD-Token (_auth_ok).
// Damit nicht jeder einzelne fetch-Aufruf angepasst werden muss, wird fetch
// einmalig zentral umschlossen. Fremde Adressen (Nominatim, Google, ...)
// bleiben unberuehrt - dort hat das Token nichts zu suchen.
(function(){
  if (typeof window === "undefined" || window.__sdFetchPatched) return;
  window.__sdFetchPatched = true;
  const originalFetch = window.fetch.bind(window);

  const eigeneAdresse = (url) => {
    try {
      const u = new URL(url, window.location.href);
      if (u.origin === window.location.origin) return true;
      const srv = (localStorage.getItem("sd_server_url") || "").trim();
      if (srv && u.origin === new URL(srv).origin) return true;
      const lok = (localStorage.getItem("sd_local_server_url") || "").trim();
      if (lok && u.origin === new URL(lok).origin) return true;
      // Lokaler Helfer-Server auf dem eigenen Rechner (Ordneranlage usw.)
      if (u.hostname === "localhost" || u.hostname === "127.0.0.1") return true;
      return false;
    } catch { return false; }
  };

  window.fetch = function(eingabe, optionen) {
    try {
      const url = typeof eingabe === "string" ? eingabe : (eingabe && eingabe.url) || "";
      const token = localStorage.getItem("sd_api_token") || "";
      if (token && url && eigeneAdresse(url)) {
        const opt = { ...(optionen || {}) };
        const kopf = new Headers(opt.headers || (typeof eingabe !== "string" && eingabe && eingabe.headers) || {});
        if (!kopf.has("X-SD-Token")) kopf.set("X-SD-Token", token);
        opt.headers = kopf;
        return originalFetch(eingabe, opt);
      }
    } catch { /* im Zweifel unveraendert weiterreichen */ }
    return originalFetch(eingabe, optionen);
  };
})();

const DARK = {
  bg:"#0F0F0F",surface:"#1A1A1A",tile:"#222222",tileBorder:"#2E2E2E",tileHover:"#2A2A2A",
  accent:"#C9A96E",accentDim:"#C9A96E18",text:"#F0EBE3",muted:"#7A7570",border:"#2A2A2A",
  success:"#6DBF6A",warning:"#D4A84B",danger:"#C0655A",info:"#6A9BC3",
};
const LIGHT = {
  bg:"#F5F3EF",surface:"#FFFFFF",tile:"#FFFFFF",tileBorder:"#E0DDD8",tileHover:"#F0EDE8",
  accent:"#A8843E",accentDim:"#A8843E18",text:"#1A1814",muted:"#8A8075",border:"#E0DDD8",
  success:"#3B7D38",warning:"#8A5E0A",danger:"#8A3028",info:"#1A5A8A",
};

function uid(){return Date.now().toString(36)+Math.random().toString(36).slice(2,6);}

// Zusatzzeilen weiterer Tiere desselben Halters: erkennbar am Flag (Modal)
// oder an der ID-Endung der Online-Buchung (online_<id>_2, _3, ...).
function istZusatzTier(r){return !!(r&&(r.weitererHund||/^online_.+_\d+$/.test(String(r.id||""))));}

// Zaehlt echte Teilnehmer einer Veranstaltung. Quelle ist der
// Veranstaltungsplan, damit ueberall dieselbe Zahl steht. Gezaehlt wird ein
// Teilnehmer, nicht ein Hund: Zusatzzeilen weiterer Hunde haben weder Name
// noch Kontaktdaten und fallen dadurch heraus, blockierte Zeilen ebenso.
function teilnehmerAnzahl(ev){
  if(!ev)return 0;
  try{
    const plaene=JSON.parse(localStorage.getItem("sd_shootingplaene")||"{}");
    const rows=Array.isArray(plaene[ev.id])?plaene[ev.id]:null;
    if(rows)return rows.filter(r=>!r.blocked
      &&((r.name||"").trim()||(r.email||"").trim()||(r.telefon||"").trim())).length;
  }catch(e){}
  // Ohne Plan ersatzweise die Abrechnung auswerten.
  const liste=Array.isArray(ev.teilnehmer)?ev.teilnehmer:[];
  return liste.filter((t,i,arr)=>{
    if(!t)return false;
    if(!((t.name||"").trim()||(t.email||"").trim()||(t.telefon||"").trim()))return false;
    if(t.weitererHund||istZusatzTier(t))return false;
    const vorher=arr[i-1];
    if(i>0&&vorher&&vorher.name&&vorher.name===t.name&&Number(t.gebuehr)===0)return false;
    return true;
  }).length;
}

function _getSig(){try{return JSON.parse(localStorage.getItem('sd_email_sig')||'null')||{text:'',logo:''};}catch{return {text:'',logo:''};}}
function buildScattoDeskMailHtml(text,logo,sigText){
  const sepIdx=text.search(/\n{1,2}--[ \t]*(\n|$)/);
  const mainText=(sepIdx>=0?text.slice(0,sepIdx):text);
  let t=mainText;
  t=t.replace(/!\[([^\]]*)\]\(([^)]+)\)/g,(m,alt,url)=>`<img src="${url}" alt="${alt}" style="max-width:100%;border-radius:6px;margin:8px 0;display:block"/>`);
  t=t.replace(/\[([^\]]+)\]\(([^)]+)\)/g,(m,l,u)=>`<a href="${u}" style="color:#A8843E;font-weight:600">${l}</a>`);
  t=t.replace(/\*\*(.+?)\*\*/gs,(m,inner)=>`<strong>${inner}</strong>`);
  // Jede Zeile wird eine Zeile, jede Leerzeile ein Abstand. Dadurch sieht die
  // Mail genauso aus wie der Text im Vorlagenfeld.
  const parts=t.split(/\n/).map(line=>{
    if(line.trim()==="")return `<div style="height:18px;line-height:18px">&nbsp;</div>`;
    return `<div style="line-height:1.7">${line}</div>`;
  }).join("");
  const logoHtml=logo?`<img src="cid:logo@scattodesk" style="max-height:65px;max-width:200px;display:block;margin-bottom:10px" alt="Logo"/>`:"";
  const sigHtml=sigText?`<div style="font-size:12px;color:#8A8075;line-height:1.8">${sigText.replace(/\n/g,"<br/>")}</div>`:"";
  const fuss=logoHtml||sigHtml?`<div style="margin-top:32px;padding-top:16px">${logoHtml}${sigHtml}</div>`:"";
  return `<!DOCTYPE html><html><head><meta charset="utf-8"/><link href="https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;600;700&display=swap" rel="stylesheet"/></head><body style="margin:0;padding:0;background:#f5f3ef"><div style="max-width:600px;margin:0 auto;padding:40px 32px;font-family:'Open Sans',Verdana,sans-serif;font-size:14px;color:#2c2a26;line-height:2.0">${parts}${fuss}</div></body></html>`;
}
function initials(n){return (n||"?").split(" ").map(x=>x[0]).join("").toUpperCase().slice(0,2);}
function fmtDate(d){if(!d)return"—";return new Date(d).toLocaleDateString("de-DE",{day:"2-digit",month:"2-digit",year:"numeric"});}
function fmtDateRange(ev){if(!ev||!ev.date)return"—";const s=fmtDate(ev.date);if(!ev.dateBis||ev.dateBis===ev.date)return s;return s+" – "+fmtDate(ev.dateBis);}
function fmtDateTime(d){if(!d)return"—";return new Date(d).toLocaleString("de-DE",{day:"2-digit",month:"2-digit",year:"numeric",hour:"2-digit",minute:"2-digit"});}
function daysUntil(d){return Math.ceil((new Date(d)-new Date())/86400000);}
function euroToFloat(s){if(!s)return 0;return parseFloat(String(s).replace(/[^0-9,.-]/g,"").replace(",","."))||0;}
function fmtEuro(v){return v.toLocaleString("de-DE",{minimumFractionDigits:2,maximumFractionDigits:2})+" €";}

const DEFAULT_VEREINBARUNG="Der Fotograf überträgt nach vollständiger Zahlung das einfache Nutzungsrecht an den Fotos für den privaten Gebrauch.";

const STATUS={anfrage:{label:"Anfrage",color:"#D4A84B"},gebucht:{label:"Gebucht",color:"#6A9BC3"},abgeschlossen:{label:"Fertig",color:"#6DBF6A"},storniert:{label:"Storniert",color:"#C0655A"}};

const SEED_CUSTOMERS=[];
const SEED_BOOKINGS=[];
// Vorname aus einem vollen Namen. Akademische Titel und Anreden werden
// uebersprungen, sonst wird aus "Dr. Hans-Joachim Koffmane" ein "Dr.".
const SD_TITEL=/^(dr|prof|dipl|ing|med|rer|nat|phil|habil|mag|mba|msc|bsc|lic|herr|hr|frau|fr|sr|jr)$/i;
function vornameAus(name){
  let roh=String(name||"").trim();
  if(!roh)return "";
  roh=roh.replace(/\.(?=[A-Za-z\u00C4\u00D6\u00DC\u00E4\u00F6\u00FC])/g,". ");
  const teile=roh.split(/\s+/).filter(Boolean);
  for(const t of teile){
    const stuecke=t.replace(/\./g," ").split(/[-\s]+/).filter(Boolean);
    if(stuecke.length>0&&stuecke.every(x=>SD_TITEL.test(x)))continue;
    return t.replace(/[.,;]+$/,"");
  }
  return "";
}
// Zentrale Sprachliste. Deutsch und English sind immer aktiv,
// alles andere ist die frei wählbare dritte Sprache.
const SD_LANGS=[
  {id:"fr",name:"Français"},{id:"it",name:"Italiano"},{id:"es",name:"Español"},
  {id:"nl",name:"Nederlands"},{id:"pl",name:"Polski"},{id:"pt",name:"Português"},
  {id:"tr",name:"Türkçe"},{id:"cs",name:"Čeština"},{id:"hu",name:"Magyar"},
  {id:"sv",name:"Svenska"},{id:"no",name:"Norsk"},{id:"da",name:"Dansk"},
  {id:"gsw",name:"Schweizerdeutsch"},
];
const SD_LANG_NAME=c=>(SD_LANGS.find(l=>l.id===c)||{}).name||c;
// Aktive dritte Sprache aus der globalen Konfiguration ziehen
const SD_L3=cfg=>((cfg&&cfg.sprachen)||[]).find(l=>l!=="de"&&l!=="en")||"";
const SEED_EVENTS=[];

// ── Style helpers ─────────────────────────────────────────────────────────────
function btn(T,v="ghost",sm=false){
  const b={display:"inline-flex",alignItems:"center",gap:6,padding:sm?"5px 10px":"8px 16px",borderRadius:8,border:"none",cursor:"pointer",fontSize:sm?12:13,fontWeight:500,fontFamily:"inherit",transition:"opacity 0.15s"};
  if(v==="primary")return{...b,background:T.accent,color:T.bg};
  if(v==="danger") return{...b,background:"transparent",color:T.danger,border:`1px solid ${T.danger}33`};
  if(v==="success")return{...b,background:T.success+"22",color:T.success,border:`1px solid ${T.success}44`};
  return{...b,background:"transparent",color:T.muted,border:`1px solid ${T.border}`};
}
// ── Gemeinsame Event-Sortierung (Buchungsplan / Veranstaltungsplan / Abrechnung) ──
function useEventSort(){
  const [dir,setDir]=useState(()=>localStorage.getItem("sd_event_sort")||"desc");
  const toggle=()=>setDir(d=>{const n=d==="desc"?"asc":"desc";localStorage.setItem("sd_event_sort",n);return n;});
  const sortEvents=(arr)=>[...arr].sort((a,b)=>{const diff=new Date(a.date||0)-new Date(b.date||0);return dir==="asc"?diff:-diff;});
  return {dir,toggle,sortEvents};
}
function SortBtn({dir,toggle,T}){
  return <button style={btn(T,"ghost",true)} onClick={toggle} title="Sortierung umschalten">
    {dir==="desc"?"Neueste zuerst ↓":"Älteste zuerst ↑"}
  </button>;
}
function Badge({label,color}){return <span style={{display:"inline-block",padding:"2px 10px",borderRadius:20,fontSize:11,fontWeight:600,background:color+"22",color}}>{label}</span>;}
function Modal({title,onClose,T,children,wide,maxW}){
  return(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.75)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:100,padding:20,overflowY:"auto"}}>
      <style>{`.sd-modal-wide * { font-size: ${wide?18:15}px !important; } .sd-modal-wide .sd-modal-title { font-size: ${wide?22:18}px !important; }`}</style>
      <div className={wide?"sd-modal-wide":""} style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:16,padding:"16px 24px",width:"100%",maxWidth:maxW||(wide?980:580),maxHeight:"92vh",overflowY:"auto"}}>
        <div className="sd-modal-title" style={{fontFamily:"Georgia,serif",color:T.accent,marginBottom:20}}>{title}</div>
        {children}
      </div>
    </div>
  );
}
function FG({children}){return <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>{children}</div>;}
function F({label,full,children}){return <div style={{display:"flex",flexDirection:"column",gap:3,gridColumn:full?"1/-1":"auto"}}><label style={{fontSize:11,color:"#8A8075",fontWeight:500}}>{label}</label>{children}</div>;}
function Inp({T,...p}){return <input {...p} style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:"5px 10px",color:T.text,fontSize:12,fontFamily:"inherit",outline:"none",boxSizing:"border-box",width:"100%",...p.style}}/>;}
function Sel({T,children,...p}){return <select {...p} style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:"9px 12px",color:T.text,fontSize:13,fontFamily:"inherit",outline:"none",boxSizing:"border-box",width:"100%"}}>{children}</select>;}
function TA({T,...p}){return <textarea {...p} style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:"5px 10px",color:T.text,fontSize:12,fontFamily:"inherit",outline:"none",boxSizing:"border-box",width:"100%",resize:"vertical",minHeight:50}}/>;}
function NumInp({T,value,onChange}){return <input type="number" value={value} onChange={onChange} style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:"7px 10px",color:T.text,fontSize:13,fontFamily:"inherit",outline:"none",width:"80px",textAlign:"right",MozAppearance:"textfield",appearance:"none"}} className="no-spin"/>;}



function rechnungsProgrammName(){
  try{return JSON.parse(localStorage.getItem("sd_api_settings")||"{}").rechnungsprogramm||"sevDesk";}catch{return "sevDesk";}
}
// ── Resizable Columns Hook ────────────────────────────────────────────────────
function useColW(storageKey,defaults){
  const [colW,setColW]=useState(()=>{
    try{const s=JSON.parse(localStorage.getItem(storageKey)||"null");if(s)return {...defaults,...s};}catch{}
    return {...defaults};
  });
  useEffect(()=>{localStorage.setItem(storageKey,JSON.stringify(colW));},[colW,storageKey]);
  const resizing=useRef(null);
  function startResize(e,key){
    e.preventDefault();e.stopPropagation();
    resizing.current={key,startX:e.clientX,startW:colW[key]||100};
    const move=ev=>{
      const r=resizing.current;if(!r)return;
      setColW(p=>({...p,[r.key]:Math.max(40,r.startW+(ev.clientX-r.startX))}));
    };
    const up=()=>{resizing.current=null;document.removeEventListener("mousemove",move);document.removeEventListener("mouseup",up);};
    document.addEventListener("mousemove",move);
    document.addEventListener("mouseup",up);
  }
  return [colW,startResize,setColW];
}
function ResizeHandle({onMouseDown,T}){
  return(
    <div
      onMouseDown={e=>{e.stopPropagation();e.preventDefault();onMouseDown&&onMouseDown(e);}}
      style={{position:"absolute",right:-3,top:0,height:"100%",width:10,cursor:"col-resize",zIndex:10}}
      onMouseEnter={e=>e.currentTarget.style.background=`${T.accent}88`}
      onMouseLeave={e=>e.currentTarget.style.background="transparent"}/>
  );
}

// ── Minimal SVG Icons ─────────────────────────────────────────────────────────
function Ic({n,s=18}){
  const P={fill:"none",stroke:"currentColor",strokeWidth:1.5,strokeLinecap:"round",strokeLinejoin:"round"};
  const icons={
    save:    <g><path d="M3 2h8l3 3v9a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1z"/><path d="M5 2v4h6V2"/><rect x="5" y="9" width="6" height="5"/></g>,
    folder:  <g><path d="M1.5 4a1 1 0 0 1 1-1h3.5l1.5 2h6a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1V4z"/></g>,
    qr:      <g><rect x="2" y="2" width="5" height="5"/><rect x="9" y="2" width="5" height="5"/><rect x="2" y="9" width="5" height="5"/><path d="M9 9h2v2H9zM12 12h2v2h-2zM12 9h2M9 12v2"/></g>,
    inbox:   <g><path d="M2 9l2-6h8l2 6v4a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V9z"/><path d="M2 9h4l1 2h2l1-2h4"/></g>,
    plus:    <g><line x1="8" y1="3" x2="8" y2="13"/><line x1="3" y1="8" x2="13" y2="8"/></g>,
    minus:   <g><line x1="3" y1="8" x2="13" y2="8"/></g>,
    renum:   <g><path d="M13 7A5 5 0 0 0 4 5"/><path d="M3 9a5 5 0 0 0 9 2"/><polyline points="4,2 4,5 7,5"/><polyline points="12,14 12,11 9,11"/></g>,
    paw:     <g><circle cx="5" cy="5" r="1.6"/><circle cx="11" cy="5" r="1.6"/><circle cx="2.8" cy="8.5" r="1.4"/><circle cx="13.2" cy="8.5" r="1.4"/><path d="M8 8c-2.4 0-4 1.8-4 3.4 0 1 .8 1.6 1.8 1.6.9 0 1.4-.5 2.2-.5s1.3.5 2.2.5c1 0 1.8-.6 1.8-1.6C12 9.8 10.4 8 8 8z"/></g>,
    trash:   <g><path d="M2.5 4h11"/><path d="M5 4V2.5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1V4"/><path d="M4 4l.7 9a1 1 0 0 0 1 .9h4.6a1 1 0 0 0 1-.9L12 4"/><line x1="6.5" y1="7" x2="6.5" y2="11"/><line x1="9.5" y1="7" x2="9.5" y2="11"/></g>,
    pdf:     <g><path d="M4 1.5h5l3 3V13a1.5 1.5 0 0 1-1.5 1.5h-6.5A1.5 1.5 0 0 1 2.5 13V3A1.5 1.5 0 0 1 4 1.5z"/><path d="M9 1.5V5h3.5"/><line x1="5" y1="8" x2="11" y2="8"/><line x1="5" y1="11" x2="9" y2="11"/></g>,
    chart:   <g><line x1="2" y1="14" x2="14" y2="14"/><rect x="3" y="8" width="2.5" height="6"/><rect x="6.75" y="5" width="2.5" height="9"/><rect x="10.5" y="2" width="2.5" height="12"/></g>,
    invoice: <g><rect x="1.5" y="2" width="13" height="12" rx="1.5"/><line x1="5" y1="6" x2="11" y2="6"/><line x1="5" y1="9" x2="11" y2="9"/><line x1="5" y1="12" x2="8" y2="12"/></g>,
    json:    <g><path d="M5 2C3.5 2 3.5 4 3.5 5S3 8 1.5 8c1.5 0 2 2 2 3s0 3 1.5 3"/><path d="M11 2c1.5 0 1.5 2 1.5 3s.5 3 2 3c-1.5 0-2 2-2 3s0 3-1.5 3"/></g>,
    clock:   <g><circle cx="8" cy="8" r="6"/><polyline points="8,4.5 8,8 10.5,9.5"/></g>,
    key:     <g><circle cx="5" cy="11" r="3"/><path d="M7.2 8.8L13.5 2.5"/><path d="M11 5l2 2"/><path d="M9 7l1.5 1.5"/></g>,
    upload:  <g><path d="M8 10V2.5"/><polyline points="4.5,5.5 8,2 11.5,5.5"/><path d="M2.5 10v3a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1v-3"/></g>,
    globe:   <g><circle cx="8" cy="8" r="6"/><line x1="2" y1="8" x2="14" y2="8"/><path d="M8 2c-2 2-2.5 4-2.5 6s.5 4 2.5 6"/><path d="M8 2c2 2 2.5 4 2.5 6s-.5 4-2.5 6"/></g>,
    gear:    <g><circle cx="8" cy="8" r="2.2"/><path d="M8 1.5v2M8 12.5v2M1.5 8h2M12.5 8h2M3.5 3.5l1.4 1.4M11.1 11.1l1.4 1.4M12.5 3.5l-1.4 1.4M4.9 11.1l-1.4 1.4"/></g>,
    edit:    <g><path d="M11 2.5l2.5 2.5L6 12.5l-3.5 1 1-3.5z"/></g>,
    search:  <g><circle cx="7" cy="7" r="4.5"/><line x1="10.5" y1="10.5" x2="14" y2="14"/></g>,
    users:   <g><circle cx="6" cy="5" r="3"/><path d="M1 14c0-3 2-5 5-5s5 2 5 5"/><circle cx="12" cy="5" r="2"/><path d="M14 13c0-2-1-3.5-2.5-4"/></g>,
    calendar:<g><rect x="1.5" y="3" width="13" height="11" rx="1.5"/><line x1="1.5" y1="7" x2="14.5" y2="7"/><line x1="5" y1="1.5" x2="5" y2="4.5"/><line x1="11" y1="1.5" x2="11" y2="4.5"/></g>,
    euro:    <g><path d="M12 3.5A5.5 5.5 0 0 0 4 8a5.5 5.5 0 0 0 8 4.5"/><line x1="2" y1="6.8" x2="9" y2="6.8"/><line x1="2" y1="9.2" x2="8" y2="9.2"/></g>,
    building:<g><rect x="3" y="2" width="10" height="12.5"/><line x1="5.5" y1="5" x2="7" y2="5"/><line x1="9" y1="5" x2="10.5" y2="5"/><line x1="5.5" y1="8" x2="7" y2="8"/><line x1="9" y1="8" x2="10.5" y2="8"/><rect x="6.7" y="11" width="2.6" height="3.5"/></g>,
  };
  return <svg width={s} height={s} viewBox="0 0 16 16" {...P}>{icons[n]||icons.folder}</svg>;
}

function Tile({icon,label,sub,onClick,accent,T}){
  const [hov,setHov]=useState(false);
  return(
    <div onClick={onClick} onMouseEnter={()=>setHov(true)} onMouseLeave={()=>setHov(false)}
      style={{background:hov?T.tileHover:T.tile,border:`1px solid ${accent?T.accent+"66":T.tileBorder}`,borderRadius:10,padding:"14px 10px",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",cursor:onClick?"pointer":"default",transition:"all 0.15s",minHeight:85,gap:5,userSelect:"none"}}>
      <span style={{fontSize:24}}>{icon}</span>
      <span style={{fontSize:11,fontWeight:600,color:accent?T.accent:T.text,textAlign:"center",lineHeight:1.3}}>{label}</span>
      {sub&&<span style={{fontSize:10,color:T.warning}}>{sub}</span>}
    </div>
  );
}
function TileGroup({title,cols=2,children,T}){
  return(
    <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:12,padding:16}}>
      <div style={{fontSize:11,fontWeight:600,color:T.muted,textTransform:"uppercase",letterSpacing:"0.1em",marginBottom:12}}>{title}</div>
      <div style={{display:"grid",gridTemplateColumns:`repeat(${cols},1fr)`,gap:8}}>{children}</div>
    </div>
  );
}
function PlanTile({icon,label,onClick,T}){
  const [hov,setHov]=useState(false);
  return(
    <div onClick={onClick} onMouseEnter={()=>setHov(true)} onMouseLeave={()=>setHov(false)}
      style={{background:hov?T.tileHover:T.tile,border:`1px solid ${T.tileBorder}`,borderRadius:8,padding:"10px 6px",display:"flex",flexDirection:"column",alignItems:"center",gap:6,cursor:"pointer",transition:"all 0.15s",userSelect:"none",minWidth:68,color:T.text}}>
      <Ic n={icon} s={19}/>
      <span style={{fontSize:10,fontWeight:600,color:T.text,textAlign:"center",lineHeight:1.2}}>{label}</span>
    </div>
  );
}

// ── Signature Pad ─────────────────────────────────────────────────────────────
function SignaturePad({onSave,onClose,T}){
  const ref=useRef(null),drawing=useRef(false),last=useRef(null);
  const initCanvas=c=>{
    if(!c)return;ref.current=c;
    const dpr=window.devicePixelRatio||1;
    const rect=c.getBoundingClientRect();
    c.width=(rect.width||424)*dpr;c.height=(rect.height||160)*dpr;
    const ctx=c.getContext("2d");ctx.scale(dpr,dpr);
    ctx.lineWidth=2.5;ctx.lineCap="round";ctx.lineJoin="round";ctx.strokeStyle="#1a1a1a";
  };
  function pos(e,c){const r=c.getBoundingClientRect(),s=e.touches?e.touches[0]:e;return{x:s.clientX-r.left,y:s.clientY-r.top};}
  function start(e){e.preventDefault();const c=ref.current;if(!c)return;drawing.current=true;const p=pos(e,c);last.current=p;const ctx=c.getContext("2d");ctx.beginPath();ctx.arc(p.x,p.y,1,0,6.28,false);ctx.fill();}
  function move(e){e.preventDefault();if(!drawing.current||!ref.current)return;const c=ref.current,ctx=c.getContext("2d"),p=pos(e,c);ctx.beginPath();ctx.moveTo(last.current.x,last.current.y);ctx.lineTo(p.x,p.y);ctx.stroke();last.current=p;}
  return(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.8)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:200}}>
      <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:16,padding:28,width:480}}>
        <div style={{fontFamily:"Georgia,serif",fontSize:18,color:T.accent,marginBottom:16}}>Digitale Unterschrift</div>
        <canvas ref={initCanvas} style={{background:"#fff",borderRadius:8,cursor:"crosshair",width:"100%",height:160,touchAction:"none",display:"block"}}
          onMouseDown={start} onMouseMove={move} onMouseUp={()=>drawing.current=false}
          onTouchStart={start} onTouchMove={move} onTouchEnd={()=>drawing.current=false}/>
        <div style={{display:"flex",gap:8,marginTop:12}}>
          <button onClick={()=>{if(ref.current){const _c=ref.current;_c.getContext("2d").clearRect(0,0,_c.width,_c.height);}}} style={btn(T,"ghost")}>Löschen</button>
          <button onClick={()=>onSave(ref.current.toDataURL())} style={btn(T,"primary")}>Speichern</button>
          <button onClick={onClose} style={btn(T,"ghost")}>Abbrechen</button>
        </div>
      </div>
    </div>
  );
}

// ── Customer / Booking Modals ─────────────────────────────────────────────────

// ── Rasse-Autocomplete ────────────────────────────────────────────────────────
function RasseInput({value, onChange, T, style}){
  const [version,setVersion]=useState(0);
  const [show,setShow]=useState(false);
  const [gemeldet,setGemeldet]=useState("");
  const allRassen=(()=>{try{const p=JSON.parse(localStorage.getItem("sd_rassen_profil")||"{}");return p.rassen||[];}catch{return [];}})();
  void version; // erzwingt Neuaufbau der Liste nach dem Hinzufuegen
  const eingabe=(value||"").trim();
  const filtered=allRassen.filter(r=>r.toLowerCase().includes(eingabe.toLowerCase())).slice(0,10);
  const exakt=allRassen.some(r=>r.toLowerCase()===eingabe.toLowerCase());
  const kannHinzufuegen=eingabe.length>=2&&!exakt;
  const IS={background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:"6px 10px",color:T.text,fontSize:13,outline:"none",width:"100%",...style};

  function rasseMerken(){
    if(!kannHinzufuegen)return;
    try{
      const p=JSON.parse(localStorage.getItem("sd_rassen_profil")||"{}");
      const liste=[...new Set([...(p.rassen||[]),eingabe])].sort((a,b)=>a.localeCompare(b,"de"));
      localStorage.setItem("sd_rassen_profil",JSON.stringify({...p,rassen:liste}));
      setVersion(v=>v+1);
      setGemeldet(eingabe);
      setShow(false);
    }catch(e){
      alert("Rasse konnte nicht gespeichert werden.\n"+(e&&e.name==="QuotaExceededError"?"Der lokale Speicher ist voll.":e.message));
    }
  }

  return(
    <div style={{position:"relative"}}>
      <input value={value||""} onChange={e=>{onChange(e.target.value);setShow(true);setGemeldet("");}}
        onFocus={()=>setShow(true)} onBlur={()=>setTimeout(()=>setShow(false),150)}
        placeholder="Rasse..." style={IS}/>
      {show&&(filtered.length>0||kannHinzufuegen)&&(
        <div style={{position:"absolute",top:"calc(100% + 2px)",left:0,right:0,background:T.surface,border:`1px solid ${T.border}`,borderRadius:8,zIndex:200,maxHeight:200,overflowY:"auto",boxShadow:"0 6px 24px rgba(0,0,0,0.5)"}}>
          {filtered.map(r=>(
            <div key={r} onClick={()=>{onChange(r);setShow(false);}}
              style={{padding:"8px 12px",cursor:"pointer",fontSize:13,color:T.text,borderBottom:`1px solid ${T.border}22`}}
              onMouseEnter={e=>e.currentTarget.style.background=T.accentDim}
              onMouseLeave={e=>e.currentTarget.style.background="transparent"}>{r}</div>
          ))}
          {kannHinzufuegen&&(
            <div onMouseDown={e=>{e.preventDefault();rasseMerken();}}
              style={{padding:"8px 12px",cursor:"pointer",fontSize:13,color:T.accent,fontWeight:600,borderTop:filtered.length?`1px solid ${T.border}`:"none"}}
              onMouseEnter={e=>e.currentTarget.style.background=T.accentDim}
              onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
              + „{eingabe}" zur Rassenliste hinzufügen
            </div>
          )}
        </div>
      )}
      {gemeldet&&<div style={{fontSize:10,color:T.muted,marginTop:3}}>„{gemeldet}" ist jetzt in der Rassenliste.</div>}
    </div>
  );
}

function DokumenteTab({kundId,typ,T}){
  const key="sd_docs_"+(kundId||"neu");
  const [docs,setDocs]=useState(()=>{try{return JSON.parse(localStorage.getItem(key)||"[]");}catch{return [];}});
  const liste=docs.filter(d=>d.typ===typ);
  const saveDocs=(nd)=>{setDocs(nd);if(kundId)localStorage.setItem(key,JSON.stringify(nd));};
  const upload=(e)=>{
    const file=e.target.files[0];if(!file)return;
    const r=new FileReader();
    r.onload=ev=>{
      const neu={id:uid(),name:file.name,typ,datum:new Date().toLocaleDateString("de-DE"),data:ev.target.result};
      saveDocs([...docs,neu]);
    };
    r.readAsDataURL(file);
    e.target.value="";
  };
  const del=(id)=>{if(confirm("Dokument löschen?"))saveDocs(docs.filter(d=>d.id!==id));};
  const label=typ==="vertrag"?"Verträge":"Rechnungen";

  // Archivierte Vertraege liegen als HTML-Data-URL vor. Ein data:-Link laesst sich in
  // Chrome und Firefox nicht direkt als Seite oeffnen, deshalb neues Fenster + write.
  const istHtml=(d)=>typeof d.data==="string"&&d.data.startsWith("data:text/html");
  const drucken=(d)=>{
    try{
      const roh=d.data.slice(d.data.indexOf(",")+1);
      const html=decodeURIComponent(roh);
      // Unsichtbares iframe statt eigenem Fenster: der Druckdialog kommt direkt,
      // ohne dass der Vertrag vorher als Seite aufgeht.
      const frame=document.createElement("iframe");
      frame.style.cssText="position:fixed;top:-9999px;left:-9999px;width:1px;height:1px;border:none;";
      document.body.appendChild(frame);
      frame.contentDocument.open();
      frame.contentDocument.write(html);
      frame.contentDocument.close();
      const los=()=>{
        try{frame.contentWindow.focus();frame.contentWindow.print();}catch{}
        setTimeout(()=>{try{document.body.removeChild(frame);}catch{}},3000);
      };
      frame.onload=los;
      setTimeout(los,900);
    }catch(e){alert("Dokument konnte nicht gedruckt werden: "+e.message);}
  };
  return(
    <div style={{display:"flex",flexDirection:"column",gap:10,minHeight:200}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
        <div style={{fontSize:13,color:T.muted}}>{liste.length} {label}</div>
        <label style={{...btn(T,"primary",true),cursor:"pointer",fontSize:12}}>
          + Hochladen
          <input type="file" accept=".pdf,.doc,.docx,.jpg,.jpeg,.png" style={{display:"none"}} onChange={upload}/>
        </label>
      </div>
      {liste.length===0&&<div style={{textAlign:"center",padding:"40px 0",color:T.muted,fontSize:13}}>Noch keine {label} vorhanden.</div>}
      {liste.map(d=>(
        <div key={d.id} style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:"10px 14px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <div>
            <div style={{fontSize:13,fontWeight:600,color:T.text}}>{d.name}</div>
            <div style={{fontSize:11,color:T.muted}}>{d.datum}</div>
          </div>
          <div style={{display:"flex",gap:6}}>
            {istHtml(d)
              ?<button style={{...btn(T,"ghost",true),fontSize:12}} title="Öffnen / als PDF speichern" onClick={()=>drucken(d)}>🖨️</button>
              :<a href={d.data} download={d.name} title="Herunterladen" style={{...btn(T,"ghost",true),textDecoration:"none",fontSize:12}}>⬇️</a>}
            <button style={{...btn(T,"danger",true),fontSize:12}} onClick={()=>del(d.id)}>✕</button>
          </div>
        </div>
      ))}
    </div>
  );
}


// Alter hochrechnen basierend auf gespeichertem Alter + Datum
// Umrechnung zwischen deutschem Anzeigedatum (17.8.2026) und ISO fuer <input type="date">
function deToIso(v){
  if(!v)return "";
  const t=String(v).trim();
  if(/^\d{4}-\d{2}-\d{2}$/.test(t))return t;
  const m=t.match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})$/);
  if(!m)return "";
  return m[3]+"-"+String(m[2]).padStart(2,"0")+"-"+String(m[1]).padStart(2,"0");
}
function isoToDe(v){
  if(!v)return "";
  const m=String(v).match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if(!m)return v;
  return parseInt(m[3],10)+"."+parseInt(m[2],10)+"."+m[1];
}

function berechneAlter(tier,shootingDatum){
  if(!tier||(!tier.alter&&!tier.alterMonate)||!tier.alterDatum||!shootingDatum) return null;
  const d0=new Date(tier.alterDatum);
  const d1=new Date(shootingDatum);
  if(isNaN(d0)||isNaN(d1)||d1<=d0) return null;
  const diffMs=d1-d0;
  const diffTage=Math.floor(diffMs/(1000*60*60*24));
  const diffMonate=Math.floor(diffTage/30.44);
  const basisJahre=parseInt(tier.alter)||0;
  const basisMonate=parseInt(tier.alterMonate)||0;
  let gesamtMonate=basisJahre*12+basisMonate+diffMonate;
  const jahre=Math.floor(gesamtMonate/12);
  const monate=gesamtMonate%12;
  if(jahre===0) return monate+" M";
  if(monate===0) return jahre+" J";
  return jahre+" J "+monate+" M";
}

// Alter zum Termindatum. Ausgehend vom eingetragenen Alter und dem Tag,
// an dem es erfasst wurde. Unter einem Jahr wird in Monaten gezaehlt,
// ab einem Jahr nur noch in Jahren.
function alterZumDatum(tier,datum){
  const j=parseInt(tier&&tier.alter)||0;
  const m=parseInt(tier&&tier.alterMonate)||0;
  if(!j&&!m)return {alter:"",alterMonate:""};
  let ges=j*12+m;
  if(tier&&tier.alterDatum&&datum){
    const d0=new Date(tier.alterDatum),d1=new Date(datum);
    if(!isNaN(d0)&&!isNaN(d1)&&d1>d0)
      ges+=Math.floor(Math.floor((d1-d0)/86400000)/30.44);
  }
  const jj=Math.floor(ges/12),mm=ges%12;
  return jj>=1?{alter:String(jj),alterMonate:""}:{alter:"",alterMonate:String(mm)};
}

function CustomerModal({customer,onSave,onClose,T,events=[]}){
  const [aktTab,setAktTab]=useState("info");
  const defTier={name:"",rasse:"",alter:"",geschlecht:""};
  const [f,setF]=useState(()=>{
    if(!customer) return {name:"",email:"",phone:"",strasse:"",plz:"",ort:"",dog:"",breed:"",notes:"",tiere:[{...defTier}]};
    return {...customer, tiere: (customer.tiere&&customer.tiere.length>0)?customer.tiere:[{name:customer.dog||"",rasse:customer.breed||"",alter:"",geschlecht:"Hündin"}]};
  });
  const [plzLoading,setPlzLoading]=useState(false);
  const s=(k,v)=>setF(x=>({...x,[k]:v}));
  const updTier=(i,k,v)=>setF(prev=>{
    const tiere=(prev.tiere&&prev.tiere.length>0)?[...prev.tiere]:[{...defTier}];
    tiere[i]={...tiere[i],[k]:v};
    return {...prev,tiere};
  });
  const addTierEntry=()=>setF(prev=>({...prev,tiere:[...(prev.tiere||[{...defTier}]),{...defTier}]}));
  const removeTierEntry=(i)=>setF(prev=>({...prev,tiere:(prev.tiere||[]).filter((_,j)=>j!==i)}));

  async function lookupPLZ(plz){
    if(!plz||plz.length<5)return;
    setPlzLoading(true);
    try{
      const r=await fetch(`https://api.zippopotam.us/de/${plz}`);
      if(r.ok){const d=await r.json();const ort=d.places?.[0]?.["place name"]||"";if(ort)setF(x=>({...x,ort}));}
    }catch{}
    setPlzLoading(false);
  }
  async function lookupOrt(ort){
    if(!ort||ort.length<3)return;
    setPlzLoading(true);
    try{
      const r=await fetch(`https://nominatim.openstreetmap.org/search?format=json&limit=1&country=de&city=${encodeURIComponent(ort)}&postalcode=`);
      const d=await r.json();
      if(d?.[0]?.address?.postcode&&!f.plz)setF(x=>({...x,plz:d[0].address.postcode}));
    }catch{}
    setPlzLoading(false);
  }
  return(
    <Modal title={customer?"Kunde bearbeiten":"Neuer Kunde"} onClose={onClose} T={T} wide>
      <div style={{display:"flex",gap:4,marginBottom:16,borderBottom:`1px solid ${T.border}`,paddingBottom:8}}>
        {[["info","👤 Info"],["vertraege","📋 Verträge"],["rechnungen","🧾 Rechnungen"],["buchungslink","🎁 Buchungslink"]].map(([id,lbl])=>(
          <button key={id} style={{...btn(T,aktTab===id?"active":"ghost",true),fontSize:12}} onClick={()=>setAktTab(id)}>{lbl}</button>
        ))}
      </div>
      {aktTab==="info"&&<div><div style={{display:"grid",gridTemplateColumns:"1fr 2fr",gap:14}}>
        <F label="Anrede">
          <Sel T={T} value={f.anrede||""} onChange={e=>s("anrede",e.target.value)}>
            <option value="">—</option>
            <option value="Frau">Frau</option>
            <option value="Herr">Herr</option>
            <option value="Divers">Divers</option>
          </Sel>
        </F>
        <F label="Name *"><Inp T={T} value={f.name} onChange={e=>s("name",e.target.value)} placeholder="Vorname Nachname"/></F>
      </div>
      <FG>
        <F label="Straße" full><Inp T={T} value={f.strasse||""} onChange={e=>s("strasse",e.target.value)} placeholder="Straße und Hausnummer"/></F>
        <F label={`PLZ${plzLoading?" …":""}`}>
          <Inp T={T} value={f.plz||""} onChange={e=>s("plz",e.target.value)} onBlur={e=>lookupPLZ(e.target.value)} placeholder="z.B. 90429"/>
        </F>
        <F label="Ort">
          <Inp T={T} value={f.ort||""} onChange={e=>s("ort",e.target.value)} onBlur={e=>{if(e.target.value&&!f.plz)lookupOrt(e.target.value);}} placeholder="z.B. Nürnberg"/>
        </F>
        <F label="E-Mail"><Inp T={T} type="email" value={f.email} onChange={e=>s("email",e.target.value)} placeholder="name@domain.de"/></F>
        {f.id&&(()=>{
          const ml=(()=>{try{return JSON.parse(localStorage.getItem("sd_mail_log_"+f.id)||"[]");}catch{return [];}})();
          if(!ml.length)return null;
          const tl={bildauswahl:"📂 Bildauswahl",fertige_bilder:"🖼 Fertige Bilder",erinnerung1:"🔔 Erinnerung Stufe 1",erinnerung2:"🔔 Erinnerung Stufe 2"};
          return(
            <F label=" " full>
              <div style={{display:"flex",flexDirection:"column",gap:4}}>
                {ml.slice(0,5).map((m,i)=>(
                  <div key={i} style={{fontSize:11,color:"#155724",background:"#d4edda",borderRadius:6,padding:"4px 9px"}}>
                    {tl[m.typ]||m.typ} am {new Date(m.datum).toLocaleDateString("de-DE")} versendet{m.event?" ("+m.event+")":""}
                  </div>
                ))}
              </div>
            </F>
          );
        })()}
        <F label="Telefon"><Inp T={T} value={f.phone} onChange={e=>s("phone",e.target.value)} placeholder="0176 ..."/></F>
      </FG>
      <div style={{borderTop:`1px solid ${T.border}`,paddingTop:14,marginTop:6}}>
        <div style={{fontSize:"inherit",fontWeight:700,color:T.text,marginBottom:10}}>Tiere</div>
        {(f.tiere||[defTier]).map((tier,i)=>(
          <div key={i} style={{background:T.bg,borderRadius:8,padding:"10px 12px",marginBottom:8,position:"relative"}}>
            {/* Zeile 1: Hundename + Rasse */}
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginBottom:8}}>
              <div style={{minWidth:0,overflow:"hidden"}}>
                <label style={{fontSize:10,color:T.muted,fontWeight:600,display:"block",marginBottom:3}}>Hundename</label>
                <Inp T={T} value={tier.name||""} onChange={e=>updTier(i,"name",e.target.value)} style={{height:34,boxSizing:"border-box"}}/>
              </div>
              <div style={{minWidth:0,position:"relative"}}>
                <label style={{fontSize:10,color:T.muted,fontWeight:600,display:"block",marginBottom:3}}>Rasse</label>
                <RasseInput T={T} value={tier.rasse||""} onChange={v=>updTier(i,"rasse",v)} style={{height:34,boxSizing:"border-box",width:"100%"}}/>
              </div>
            </div>
            {/* Zeile 2: Alter + Monate + Geschlecht */}
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 2fr",gap:8}}>
              <div>
                <label style={{fontSize:10,color:T.muted,fontWeight:600,display:"block",marginBottom:3}}>Alter (Jahre)</label>
                <input type="number" min={0} max={30} value={tier.alter||""} onChange={e=>updTier(i,"alter",e.target.value)} placeholder="0"
                  style={{background:"transparent",border:`1px solid ${T.border}`,borderRadius:6,padding:"6px 8px",color:T.text,fontSize:"inherit",width:"100%",outline:"none",fontFamily:"inherit",boxSizing:"border-box",height:34}}/>
              </div>
              <div>
                <label style={{fontSize:10,color:T.muted,fontWeight:600,display:"block",marginBottom:3}}>Monate</label>
                <input type="number" min={0} max={11} value={tier.alterMonate||""} onChange={e=>updTier(i,"alterMonate",e.target.value)} placeholder="0"
                  style={{background:"transparent",border:`1px solid ${T.border}`,borderRadius:6,padding:"6px 8px",color:T.text,fontSize:"inherit",width:"100%",outline:"none",fontFamily:"inherit",boxSizing:"border-box",height:34}}/>
              </div>
              <div>
                <label style={{fontSize:10,color:T.muted,fontWeight:600,display:"block",marginBottom:3}}>Geschlecht</label>
                <Sel T={T} value={(tier.geschlecht==="unbekannt"||tier.geschlecht==="Unbekannt")?"":tier.geschlecht||""} onChange={e=>updTier(i,"geschlecht",e.target.value)} style={{height:34,boxSizing:"border-box"}}>
                  <option value="">-</option><option>Hündin</option><option>Rüde</option>
                </Sel>
              </div>
            </div>
            {(f.tiere||[]).length>1&&<button onClick={()=>removeTierEntry(i)}
              style={{position:"absolute",top:6,right:8,background:"none",border:"none",color:T.muted,cursor:"pointer",fontSize:18}}>×</button>}
          </div>
        ))}
        <button onClick={addTierEntry}
          style={{...btn(T,"ghost",true),width:"100%",justifyContent:"center",fontSize:12}}>+ Tier hinzufügen</button>
      </div>
      <FG>
        <F label="Shootings (Anzahl & Art)" full>
          {(()=>{
            const buchungen=(()=>{try{return JSON.parse(localStorage.getItem("sd_bookings")||"[]");}catch{return [];}})();
            const events=(()=>{try{return JSON.parse(localStorage.getItem("sd_events")||"[]");}catch{return [];}})();
            const onlineBuch=(()=>{try{return JSON.parse(localStorage.getItem("sd_buchungen")||"[]");}catch{return [];}})();
            const zaehler={};
            if(customer?.id){
              buchungen.filter(b=>b.customerId===customer.id&&b.status!=="storniert").forEach(b=>{
                // b.location ist der Ort (z.B. "Mannhof"), nicht die Art. Art steht in shootingart/fotoart.
                const art=b.shootingart||b.fotoart||b.shootingType||b.eventName||"Einzelshooting";
                zaehler[art]=(zaehler[art]||0)+1;
              });
              events.forEach(ev=>{
                (ev.teilnehmer||[]).forEach(t=>{
                  const match=t.name&&customer.name&&t.name.trim().toLowerCase()===customer.name.trim().toLowerCase();
                  const emailMatch=t.email&&customer.email&&t.email.toLowerCase()===customer.email.toLowerCase();
                  if((match||emailMatch)&&!t.storniert){
                    const art=ev.shootingart||ev.fotoart||ev.name||"Veranstaltung";
                    zaehler[art]=(zaehler[art]||0)+1;
                  }
                });
              });
              onlineBuch.filter(b=>b.status!=="storniert").forEach(b=>{
                const n=b.formData?.sys_name||"";
                const e=b.formData?.sys_email||"";
                const match=(n&&customer.name&&n.trim().toLowerCase()===customer.name.trim().toLowerCase())||(e&&customer.email&&e.toLowerCase()===customer.email.toLowerCase());
                if(match){
                  const art=b.shootingart||b.fotoart||b.shootingType||"Online-Buchung";
                  zaehler[art]=(zaehler[art]||0)+1;
                }
              });
            }
            const gesamt=Object.values(zaehler).reduce((a,b)=>a+b,0);
            if(gesamt===0) return <div style={{fontSize:"inherit",color:T.muted,padding:"9px 12px",background:T.bg,border:`1px solid ${T.border}`,borderRadius:8}}>Noch keine Shootings erfasst</div>;
            return(
              <div style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:"10px 14px"}}>
                <div style={{display:"flex",flexWrap:"wrap",gap:8,marginBottom:6}}>
                  {Object.entries(zaehler).map(([art,anz])=>(
                    <span key={art} style={{background:T.accentDim,border:`1px solid ${T.accent}44`,borderRadius:20,padding:"3px 10px",fontSize:"inherit",color:T.accent,fontWeight:600}}>
                      {anz}× {art}
                    </span>
                  ))}
                </div>
                <div style={{fontSize:11,color:T.muted}}>Gesamt: {gesamt} Shooting{gesamt!==1?"s":""}</div>
              </div>
            );
          })()}
        </F>
        <F label="Notizen" full><TA T={T} value={f.notes} onChange={e=>s("notes",e.target.value)} placeholder="Besonderheiten..."/></F>
        {f.id&&(()=>{
          const mailLog=(()=>{try{return JSON.parse(localStorage.getItem("sd_mail_log_"+f.id)||"[]");}catch{return [];}})();
          if(!mailLog.length)return null;
          const typLabel={bildauswahl:"📂 Bildauswahl",fertige_bilder:"🖼 Fertige Bilder",erinnerung1:"🔔 Erinnerung Stufe 1",erinnerung2:"🔔 Erinnerung Stufe 2"};
          return(
            <F label="Mail-Verlauf" full>
              <div style={{display:"flex",flexDirection:"column",gap:6}}>
                {mailLog.map((m,i)=>(
                  <div key={i} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"6px 10px",background:T.bg,borderRadius:7,border:`1px solid ${T.border}`,fontSize:12}}>
                    <div>
                      <span style={{fontWeight:600,color:T.text}}>{typLabel[m.typ]||m.typ}</span>
                      {m.event&&<span style={{color:T.muted}}> · {m.event}</span>}
                    </div>
                    <span style={{color:T.muted}}>{new Date(m.datum).toLocaleDateString("de-DE")}</span>
                  </div>
                ))}
              </div>
            </F>
          );
        })()}
        <F label=" " full>
          <label style={{display:"flex",alignItems:"center",gap:8,cursor:"pointer",paddingTop:4}}>
            <input type="checkbox" checked={!!f.newsletter} onChange={e=>s("newsletter",e.target.checked)} style={{accentColor:T.accent,width:15,height:15}}/>
            <span style={{fontSize:"inherit",color:T.text}}>📧 Newsletter-Empfänger</span>
          </label>
        </F>
        <F label=" " full>
          <div style={{display:"flex",alignItems:"center",gap:16,flexWrap:"wrap"}}>
            <label style={{display:"flex",alignItems:"center",gap:8,cursor:"pointer",paddingTop:4}}>
              <input type="checkbox" checked={!!f.rahmenvertrag} onChange={e=>s("rahmenvertrag",e.target.checked)} style={{accentColor:T.accent,width:15,height:15}}/>
              <span style={{fontSize:"inherit",color:T.text}}>📋 Vertrag vorhanden</span>
            </label>
            {f.rahmenvertrag&&(
              <div style={{display:"flex",alignItems:"center",gap:6}}>
                <span style={{fontSize:"inherit",color:T.muted}}>Datum:</span>
                <input type="date" value={f.rahmenvertragDatum||""} onChange={e=>s("rahmenvertragDatum",e.target.value)}
                  style={{fontSize:"inherit",padding:"3px 8px",borderRadius:6,border:`1px solid ${T.border}`,background:T.bg,color:T.text,fontFamily:"inherit"}}/>
              </div>
            )}
          </div>
        </F>
      </FG>
      {/* Statistik-Aufnahme — nur bei Neuanlage */}
      {!customer&&(
        <div style={{background:T.bg,borderRadius:8,padding:"10px 14px",marginBottom:10,marginTop:10}}>
          <label style={{display:"flex",alignItems:"center",gap:10,cursor:"pointer",fontSize:"inherit",color:T.text}}>
            <input type="checkbox" checked={!!f._statistikAufnehmen}
              onChange={e=>setF(x=>({...x,_statistikAufnehmen:e.target.checked}))}
              style={{accentColor:T.accent,width:15,height:15,cursor:"pointer"}}/>
            <span>Hund(e) automatisch in Statistik aufnehmen</span>
            <span style={{fontSize:11,color:T.muted}}>(Einzeltermin)</span>
          </label>
          <div style={{fontSize:10,color:T.muted,marginLeft:25,marginTop:3}}>
            Bei Veranstaltungen: über "→ Statistik" im Veranstaltungsplan exportieren
          </div>
        </div>
      )}
      {f._buchungslink_gesendet&&<div style={{marginTop:12,padding:"8px 14px",background:"#d1fae5",border:"1px solid #6ee7b7",borderRadius:8,fontSize:12,color:"#065f46",fontWeight:600}}>
        🎁 Buchungslink gesendet – {f._buchungslink_gesendet}
      </div>}
      </div>}
      {(aktTab==="vertraege"||aktTab==="rechnungen")&&<DokumenteTab kundId={f.id} typ={aktTab==="vertraege"?"vertrag":"rechnung"} T={T}/>}
      {aktTab==="buchungslink"&&<BuchungslinkModal inline kunde={f} events={events} T={T} onClose={null} onSent={()=>{
        const ts=new Date().toLocaleDateString("de-DE",{day:"2-digit",month:"2-digit",year:"numeric"});
        const updated={...f,_buchungslink_gesendet:ts};
        setF(updated);
        onSave(updated);
        setAktTab("info");
      }}/>}
      <div style={{display:"flex",justifyContent:"flex-end",gap:10,marginTop:16}}>
        <button style={btn(T,"ghost")} onClick={onClose}>Abbrechen</button>
        <button style={btn(T,"primary")} onClick={()=>{
          if(!f.name.trim()){alert("Bitte Namen eingeben.");return;}
          const dog=f.tiere?.[0]?.name||f.dog||"";
          const breed=f.tiere?.[0]?.rasse||f.breed||"";
          const now=new Date();
          const jahr=now.getFullYear();
          let nextNr=f.kundennr;
          if(!nextNr){
            // Höchste Nummer dieses Jahres finden und +1
            const allC=(()=>{try{return JSON.parse(localStorage.getItem("sd_customers")||"[]");}catch{return [];}})();
            const thisYear=allC.filter(c=>(c.kundennr||"").startsWith(String(jahr)));
            const maxNr=thisYear.reduce((max,c)=>{
              const n=parseInt((c.kundennr||"").slice(4)||"0",10);
              return n>max?n:max;
            },0);
            nextNr=`${jahr}${maxNr+1}`;
          }
          const tiereWithDatum=(f.tiere||[]).map(t=>{
            const hatAlter=t.alter||t.alterMonate;
            return hatAlter&&!t.alterDatum?{...t,alterDatum:now.toISOString().slice(0,10)}:t;
          });
          onSave({...f,id:f.id||uid(),dog,breed,kundennr:nextNr,created:f.created||now.toISOString().slice(0,10),tiere:tiereWithDatum});
        }}>Speichern</button>
      </div>
    </Modal>
  );
}
// ── Statistik: Einträge aus einem abgeschlossenen Einzeltermin übernehmen ────
// Schreibt in sd_profiles und meldet es der App, damit der React-State nachzieht.
function STAT_SHOOTINGARTEN(){
  try{
    const profs=JSON.parse(localStorage.getItem("sd_profiles")||"[]");
    const st=(profs[0]?.shootingTypes||[]).filter(x=>x.aktiv&&x.name).map(x=>x.name);
    return st.length?st:["Underglass","Studio","Veranstaltung","Sonstiges"];
  }catch{return ["Underglass","Studio","Veranstaltung","Sonstiges"];}
}

function statistikEintragen({tiere,datum,shootingTyp,notiz}){
  const liste=(tiere||[]).filter(t=>t&&(t.rasse||t.name));
  if(!liste.length)return {ok:false,grund:"keine_tiere"};
  try{
    const profs=JSON.parse(localStorage.getItem("sd_profiles")||"[]");
    if(!profs.length)return {ok:false,grund:"kein_profil"};
    const aktiv=profs[0];
    const typ=shootingTyp
      ||aktiv.shootingTypes?.find(st=>st.aktiv&&st.name==="Sonstiges")?.name
      ||aktiv.shootingTypes?.find(st=>st.aktiv)?.name
      ||"Sonstiges";
    const stichtag=datum||new Date().toISOString().slice(0,10);
    const neue=liste.map(t=>({
      id:uid(),
      datum:stichtag,
      tierName:t.name||"",
      rasse:t.rasse||"",
      geschlecht:t.geschlecht||"",
      // Das Alter zaehlt bis zum Termindatum hoch, sonst stehen vier
      // Termine ueber ein Jahr alle mit demselben Alter in der Statistik.
      alter:alterZumDatum(t,stichtag).alter,
      alterMonate:alterZumDatum(t,stichtag).alterMonate,
      shootingTyp:typ,
      notizen:notiz||"",
    }));
    aktiv.eintraege=[...(aktiv.eintraege||[]),...neue];
    localStorage.setItem("sd_profiles",JSON.stringify(profs));
    window.dispatchEvent(new CustomEvent("sd-profiles-updated"));
    return {ok:true,anzahl:neue.length,typ};
  }catch(e){
    return {ok:false,grund:e.message};
  }
}

// Eingabefeld fuer Betraege. Beim Tippen frei, danach als 560,00 € dargestellt.
function PreisFeld({T,value,onChange,placeholder="0,00 €",mittig=false}){
  const zeig=v=>(v===""||v==null||isNaN(Number(v)))?"":Number(v).toFixed(2).replace(".",",")+" €";
  const [fokus,setFokus]=useState(false);
  const [roh,setRoh]=useState("");
  const lies=t=>{
    const nur=String(t).replace(/[^0-9,.-]/g,"").replace(/\.(?=\d{3}\b)/g,"").replace(",",".");
    return nur.trim()===""?"":Number(nur);
  };
  return(
    <Inp T={T} type="text" inputMode="decimal" placeholder={placeholder}
      style={mittig?{textAlign:"center"}:undefined}
      value={fokus?roh:zeig(value)}
      onFocus={()=>{setRoh(value===""||value==null?"":String(value).replace(".",","));setFokus(true);}}
      onChange={e=>{setRoh(e.target.value);const z=lies(e.target.value);onChange(z===""?"":(isNaN(z)?"":z));}}
      onBlur={()=>setFokus(false)}/>
  );
}

// Gesamtbetrag eines Termins: Grundpreis plus die Aufpreise aller Fototermine.
function terminBetrag(b){
  if(!b)return 0;
  const serie=Array.isArray(b.serie)?b.serie:[];
  return (Number(b.price)||0)+(Number(b.aufpreis)||0)
    +serie.slice(1).reduce((s,z)=>s+(Number(z&&z.aufpreis)||0),0);
}

function BookingModal({booking,customers,setCustomers,onSave,onClose,T}){
  const [f,setF]=useState({customerId:"",date:"",uhrzeit:"",location:"",locationSugg:[],locationLat:null,locationLng:null,status:"anfrage",price:"",galerie:"",galerieFeedback:"",galerieDownload:"",notes:"",bilderAnzahl:"",bilderBestelldatum:"",bilderLinkVerschickt:false,bilderRechnung:false,bilderBezahlt:false,bilderFertig:false,bilderAbgeschlossen:false,...(booking||{})});
  const s=(k,v)=>setF(x=>({...x,[k]:v}));
  // Welcher Fototermin gerade im Bildauftrag bearbeitet wird. 0 ist der
  // Termin oben, alles darueber sind die weiteren Fototermine.
  const [bildIdx,setBildIdx]=useState(0);
  // Zugriff auf den Bildauftrag des gerade gewaehlten Fototermins.
  const _serie=Array.isArray(f.serie)?f.serie:[];
  const bi=Math.max(0,Math.min(bildIdx,Math.max(0,_serie.length-1)));
  const inSerie=_serie.length>0&&bi>0;
  const ba=inSerie?(_serie[bi]||{}):f;
  const sBa=(k,v)=>{
    if(!inSerie){s(k,v);return;}
    setF(x=>({...x,serie:(Array.isArray(x.serie)?x.serie:[]).map((z,j)=>j===bi?{...z,[k]:v}:z)}));
  };
  // Erst wenn jeder Fototermin fertig ist, darf abgeschlossen werden.
  const alleFertig=_serie.length>1
    ?_serie.every((z,i)=>i===0?!!f.bilderFertig:!!(z&&z.bilderFertig))
    :!!f.bilderFertig;
  // Frueher gab es nur ein Feld. Ein alter Termin bekommt seine Adresse
  // in die Feedbackgalerie, das ist der Link, der zuerst verschickt wird.
  useEffect(()=>{
    if(f.galerie&&!f.galerieFeedback&&!f.galerieDownload)s("galerieFeedback",f.galerie);
  },[]);
  // Das Datum oben ist immer der erste Fototermin. Er wird angelegt, sobald ein
  // Datum steht, und folgt danach jeder Aenderung, damit beides nie auseinanderlaeuft.
  useEffect(()=>{
    const datum=String(f.date||"").slice(0,10);
    if(!datum)return;
    setF(x=>{
      const serie=Array.isArray(x.serie)?x.serie:[];
      if(serie.length===0){
        return {...x,serie:[{id:uid(),datum,label:"",location:x.location||"",
                             hunde:Array.isArray(x.hunde)?x.hunde:[],erledigt:false}]};
      }
      if(serie[0]&&serie[0].datum===datum)return x;
      return {...x,serie:serie.map((z,i)=>i===0?{...z,datum}:z)};
    });
  },[f.date]);
  const [showKartenPicker,setShowKartenPicker]=useState(false);
  const [showOrtMail,setShowOrtMail]=useState(false);
  // Frueher konnte je Termin nur ein Hund gewaehlt werden (Feld "hund").
  // Jetzt sind es mehrere (Feld "hunde"). Alte Termine muessen weiter
  // funktionieren, deshalb werden beide gelesen.
  const hundeListe=z=>{
    if(Array.isArray(z?.hunde))return z.hunde;
    return z?.hund?[z.hund]:[];
  };

  const [statFrage,setStatFrage]=useState(null); // {tiere,datum,typ,notiz,onOk}
  // Welche Tiere in die Statistik sollen. Bei mehreren Hunden ist nicht
  // immer jeder beim Termin dabei gewesen.
  const [statGewaehlt,setStatGewaehlt]=useState(new Set());
  useEffect(()=>{
    if(!statFrage)return;
    setStatGewaehlt(new Set((statFrage.tiere||[]).map((_,i)=>i)));
  },[statFrage]);
  const [vertragOffen,setVertragOffen]=useState(false);

  const [nameInput,setNameInput]=useState(()=>{if(booking?.customerId){const c=customers.find(x=>x.id===booking.customerId);return c?c.name:"";}return "";});
  const [nameSugg,setNameSugg]=useState([]);
  function onNameChange(v){
    setNameInput(v);
    if(v.length>=1){
      const vl=v.toLowerCase();
      const sugg=customers.filter(c=>{
        const parts=(c.name||"").toLowerCase().split(" ");
        return parts.some(p=>p.startsWith(vl))||(c.name||"").toLowerCase().startsWith(vl);
      }).slice(0,8);
      setNameSugg(sugg);
    } else {
      setNameSugg([]);
      s("customerId","");
    }
  }
  return(<>
    <Modal title={booking?"Termin bearbeiten":"Neuer Termin"} onClose={onClose} T={T} maxW={1040}>
      {/* Zwei Spalten: links Termin und Fototermine, rechts der Bildauftrag.
          Unter 900 Pixel Bildschirmbreite wieder untereinander, sonst wird
          es auf dem Laptop zu eng. */}
      <style>{`
        .sd-termin-spalten{display:grid;grid-template-columns:1fr;gap:24px}
        @media(min-width:900px){
          .sd-termin-spalten{grid-template-columns:1fr 1fr;column-gap:40px;row-gap:24px;align-items:start}
        }
      `}</style>
      <div className="sd-termin-spalten">
      <div>
      <FG>
        <F label="Kunde *" full>
          <div style={{position:"relative"}}>
            <Inp T={T} value={nameInput} onChange={e=>onNameChange(e.target.value)}
              placeholder="Name eingeben..."
              onBlur={()=>setTimeout(()=>setNameSugg([]),200)}/>
            {nameSugg.length>0&&(
              <div style={{position:"absolute",top:"100%",left:0,right:0,background:T.surface,border:`1px solid ${T.border}`,borderRadius:8,zIndex:300,boxShadow:"0 6px 20px rgba(0,0,0,0.3)",maxHeight:240,overflowY:"auto"}}>
                {nameSugg.map(c=>(
                  <div key={c.id} onClick={()=>{setNameInput(c.name);s("customerId",c.id);setNameSugg([]);}}
                    style={{padding:"9px 14px",cursor:"pointer",fontSize:"inherit",borderBottom:`1px solid ${T.border}22`}}
                    onMouseEnter={e=>e.currentTarget.style.background=T.accentDim}
                    onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
                    <div style={{fontWeight:600,color:T.text}}>{c.name}</div>
                    <div style={{fontSize:11,color:T.muted}}>{[c.email,c.phone,c.tiere?.[0]?.rasse||c.dog].filter(Boolean).join(" · ")}</div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </F>
        {(()=>{const c=customers.find(x=>x.id===f.customerId);if(!c||!c.tiere||c.tiere.length===0)return null;return(
          <div style={{gridColumn:"1/-1",background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:"10px 14px"}}>
            <div style={{fontSize:11,fontWeight:700,color:T.muted,marginBottom:6,textTransform:"uppercase",letterSpacing:".06em"}}>Tiere</div>
            {c.tiere.map((t,i)=>{
              const alterAnzeige=berechneAlter(t,f.date)||(()=>{
                const j=parseInt(t.alter)||0,mo=parseInt(t.alterMonate)||0;
                if(!j&&!mo)return null;
                if(!j)return mo+" M";
                if(!mo)return j+" J";
                return j+" J "+mo+" M";
              })();
              // Reihenfolge aendern. Das erste Tier ist das, was in Listen
              // und Mails als Hauptname erscheint.
              const schieben=(von,nach)=>{
                if(!setCustomers)return;
                const liste=[...c.tiere];
                if(nach<0||nach>=liste.length)return;
                const [weg]=liste.splice(von,1);
                liste.splice(nach,0,weg);
                setCustomers(p=>p.map(x=>x.id===c.id?{...x,tiere:liste}:x));
              };
              const pfeil=(zeichen,titel,aktiv,onClick)=>(
                <button type="button" title={titel} disabled={!aktiv} onClick={onClick}
                  style={{background:"none",border:"none",padding:"0 2px",margin:0,
                    cursor:aktiv?"pointer":"default",opacity:aktiv?0.8:0.2,
                    color:T.accent,fontSize:10,lineHeight:1,fontFamily:"inherit"}}>{zeichen}</button>
              );
              return <div key={i} style={{fontSize:"inherit",color:T.text,marginBottom:3,display:"flex",alignItems:"center",gap:2}}>
                {setCustomers&&c.tiere.length>1&&(
                  <span style={{display:"inline-flex",flexDirection:"column",lineHeight:0,marginRight:4}}>
                    {pfeil("\u25b2","Nach oben",i>0,()=>schieben(i,i-1))}
                    {pfeil("\u25bc","Nach unten",i<c.tiere.length-1,()=>schieben(i,i+1))}
                  </span>
                )}
                <span>🐾 <b>{t.name||"?"}</b> · {t.rasse||""} · {t.geschlecht||""}{alterAnzeige?" · "+alterAnzeige:""}</span>
                {i===0&&c.tiere.length>1&&(
                  <span style={{fontSize:10,color:T.muted,marginLeft:6}}>Reihenfolge in der Kundenkartei</span>
                )}
              </div>;
            })}
          </div>
        );})()}
        <F label="Datum *"><Inp T={T} type="date" value={f.date?f.date.split("T")[0]:f.date||""} onChange={e=>{
          const neu=e.target.value;
          setF(prev=>{
            const alt=Array.isArray(prev.serie)?prev.serie:[];
            // Der 1. Fototermin ist derselbe Termin wie oben und wandert deshalb mit.
            // Bereits erledigte Termine bleiben stehen - die haben ja stattgefunden.
            const serie=alt.length&&!alt[0].erledigt
              ? alt.map((z,i)=>i===0?{...z,datum:String(neu||"").slice(0,10)}:z)
              : alt;
            return {...prev,date:neu,serie};
          });
        }}/></F>
        <F label="Uhrzeit"><Inp T={T} type="time" value={f.uhrzeit||""} onChange={e=>s("uhrzeit",e.target.value)}/></F>
        <F label="Shootingart (für Statistik)" full>
          <select value={f.shootingart||""} onChange={e=>s("shootingart",e.target.value)}
            style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:"5px 10px",color:T.text,fontSize:12,fontFamily:"inherit",outline:"none",width:"100%",boxSizing:"border-box"}}>
            <option value="">— bitte wählen —</option>
            {(()=>{const l=STAT_SHOOTINGARTEN();
              // gespeicherten Wert mit anzeigen, auch wenn er nicht mehr im Profil steht
              return (f.shootingart&&!l.includes(f.shootingart)?[f.shootingart,...l]:l)
                .map(n=><option key={n} value={n}>{n}</option>);})()}
          </select>
        </F>
        <F label="Location" full>
          <div style={{display:"flex",gap:8,alignItems:"center",position:"relative"}}>
            <div style={{flex:1,position:"relative"}}>
              <Inp T={T} value={f.location} onChange={async e=>{s("location",e.target.value);const q=e.target.value;if(q.length<3){s("locationSugg",[]);return;}try{const r=await fetch("https://nominatim.openstreetmap.org/search?q="+encodeURIComponent(q)+"&format=json&limit=5&addressdetails=1",{headers:{"Accept-Language":"de"}});const d=await r.json();s("locationSugg",d.map(x=>x.display_name));}catch{s("locationSugg",[]);}}} placeholder="Englischer Garten"/>
              {(f.locationSugg||[]).length>0&&(
                <div style={{position:"absolute",top:"100%",left:0,right:0,background:T.surface,border:`1px solid ${T.border}`,borderRadius:8,zIndex:50,boxShadow:"0 4px 12px rgba(0,0,0,0.15)",maxHeight:200,overflowY:"auto"}}>
                  {(f.locationSugg||[]).map((sugg,i)=>(
                    <div key={i} onClick={()=>{s("location",sugg.split(",").slice(0,3).join(",").trim());s("locationSugg",[]);}}
                      style={{padding:"8px 12px",fontSize:12,cursor:"pointer",borderBottom:`1px solid ${T.border}`,color:T.text}}
                      onMouseEnter={e=>e.currentTarget.style.background=T.bg}
                      onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
                      {sugg.split(",").slice(0,3).join(", ")}
                    </div>
                  ))}
                </div>
              )}
            </div>
            <button type="button" onClick={()=>setShowKartenPicker(true)}
              title="Auf Karte auswählen"
              style={{background:T.accentDim,border:`1px solid ${T.accent+"55"}`,borderRadius:8,padding:"8px 10px",cursor:"pointer",fontSize:16,color:T.accent,flexShrink:0}}>
              📍
            </button>
          </div>
          {f.location&&(()=>{
            const smtp=(()=>{try{return JSON.parse(localStorage.getItem("sd_smtp_buchung")||localStorage.getItem("sd_smtp_settings")||"{}");}catch{return {};}})();
            const cust=customers.find(c=>c.id===f.customerId);
            const mapsUrl=`https://maps.google.com/?q=${encodeURIComponent(f.location)}`;
            return(
              <div style={{display:"flex",gap:8,marginTop:8}}>
                <button type="button" onClick={()=>{if(!cust?.email)return alert("Kein Kunde oder keine E-Mail hinterlegt.");setShowOrtMail(true);}}
                  style={{flex:1,background:T.accentDim,border:`1px solid ${T.accent+"55"}`,borderRadius:8,padding:"7px 12px",fontSize:12,fontWeight:600,cursor:"pointer",color:T.accent}}>
                  📧 Ort per Mail teilen
                </button>
                <a href={mapsUrl} target="_blank" rel="noreferrer"
                  style={{flex:1,background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:"7px 12px",fontSize:12,fontWeight:600,cursor:"pointer",color:T.text,textDecoration:"none",textAlign:"center"}}>
                  🗺 In Maps öffnen
                </a>
              </div>
            );
          })()}
        </F>

        <F label="Notizen" full><TA T={T} value={f.notes} onChange={e=>s("notes",e.target.value)}/></F>

        {/* ── Fototermine (z.B. Welpenpaket über mehrere Termine) ────────── */}
        {(()=>{
          const serie=Array.isArray(f.serie)?f.serie:[];
          const fertig=serie.filter(x=>x.erledigt).length;
          const upd=(i,k,v)=>s("serie",serie.map((x,j)=>j===i?{...x,[k]:v}:x));
          // Der erste Fototermin ist immer das oben eingetragene Shooting-Datum.
          // Nur bei den Folgeterminen bleibt das Feld leer.
          const add=()=>s("serie",[...serie,{
            id:uid(),
            datum:serie.length===0?String(f.date||"").slice(0,10):"",
            label:"",
            location:serie.length===0?(f.location||""):"",
            hund:"",
            erledigt:false
          }]);
          const del=i=>s("serie",serie.filter((_,j)=>j!==i));
          const kunde=customers.find(x=>x.id===f.customerId);
          const hunde=(kunde?.tiere||[]).filter(t=>t&&(t.name||t.rasse));
          return(
            <div style={{gridColumn:"1/-1",borderTop:`1px solid ${T.border}`,paddingTop:18,marginTop:8}}>
              <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:14}}>
                <div style={{fontSize:14,fontWeight:700,color:T.accent}}>Fototermine</div>
                {serie.length>0&&(
                  <span style={{fontSize:11,color:T.muted,background:T.bg,border:`1px solid ${T.border}`,borderRadius:20,padding:"2px 10px"}}>
                    {fertig} von {serie.length} fertig
                  </span>
                )}
              </div>
              {serie.length>0&&(
                <div style={{height:5,background:T.bg,borderRadius:3,marginBottom:14,overflow:"hidden"}}>
                  <div style={{width:`${Math.round(fertig/serie.length*100)}%`,height:"100%",background:"#27ae60",transition:"width .2s"}}/>
                </div>
              )}
              {serie.length===0&&hunde.length>0&&(
                <div style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,
                             padding:"8px 12px",marginBottom:12}}>
                  <div style={{fontSize:10,color:T.muted,marginBottom:5}}>
                    {(()=>{
                      const namen=hunde.map((t,hi)=>t.name||t.rasse||("Hund "+(hi+1)));
                      const g=(Array.isArray(f.hunde)?f.hunde:[]).filter(x=>namen.includes(x));
                      return g.length===0?"Alle Hunde":g.length+" von "+hunde.length+" ausgewählt";
                    })()}
                  </div>
                  <div style={{display:"flex",flexWrap:"wrap",gap:"4px 10px"}}>
                    {hunde.map((t,hi)=>{
                      const n=t.name||t.rasse||("Hund "+(hi+1));
                      const namen=hunde.map((t2,h2)=>t2.name||t2.rasse||("Hund "+(h2+1)));
                      const g=(Array.isArray(f.hunde)?f.hunde:[]).filter(x=>namen.includes(x));
                      return(
                        <label key={n+hi} style={{display:"flex",alignItems:"center",gap:5,fontSize:12,
                                color:g.includes(n)?T.text:T.muted,cursor:"pointer",whiteSpace:"nowrap"}}>
                          <input type="checkbox" checked={g.includes(n)}
                            onChange={()=>s("hunde",g.includes(n)?g.filter(x=>x!==n):[...g,n])}
                            style={{accentColor:T.accent,width:14,height:14,flexShrink:0,cursor:"pointer"}}/>
                          {n}
                        </label>
                      );
                    })}
                  </div>
                  <div style={{fontSize:10,color:T.muted,marginTop:5,lineHeight:1.4}}>
                    Ohne Haken gelten alle Hunde. Sobald du unten einen Fototermin
                    anlegst, wird die Auswahl dort je Termin getroffen.
                  </div>
                </div>
              )}
              <div style={{display:"flex",flexDirection:"column",gap:8}}>
                {serie.map((z,i)=>(
                  <div key={z.id||i} style={{display:"flex",alignItems:"flex-start",gap:10,
                    background:z.erledigt?"#27ae6010":T.bg,border:`1px solid ${z.erledigt?"#27ae60":T.border}`,
                    borderRadius:8,padding:"9px 12px",transition:"all .15s"}}>
                    <input type="checkbox" checked={!!z.erledigt} onChange={e=>{
                      const an=e.target.checked;
                      if(an&&!z.statExport){
                        const c=customers.find(x=>x.id===f.customerId);
                        setStatFrage({
                          titel:z.label?("Fototermin: "+z.label):"Fototermin erledigt",
                          // Sind Hunde angehakt, gehen nur die in die Statistik.
                          // Ohne Haken zaehlen alle.
                          tiere:(()=>{
                            const alle=(c?.tiere||[]).filter(t=>t&&(t.rasse||t.name));
                            const gew=hundeListe(z);
                            if(!gew.length)return alle;
                            const treffer=alle.filter(t=>gew.includes(t.name||t.rasse));
                            return treffer.length?treffer:alle;
                          })(),
                          datum:(z.datum||f.date||"").slice(0,10),
                          typ:f.shootingart||"",
                          notiz:[z.label?"Fototermin: "+z.label:"Fototermin",z.location||f.location||""].filter(Boolean).join(" · "),
                          onOk:()=>s("serie",serie.map((x,j)=>j===i?{...x,erledigt:true,statExport:true}:x)),
                        });
                      }
                      upd(i,"erledigt",an);
                    }}
                      title="Shooting erledigt — übernimmt die Tiere in die Statistik"
                      style={{accentColor:"#27ae60",width:16,height:16,flexShrink:0,cursor:"pointer"}}/>
                    <span style={{fontSize:12,color:T.muted,width:16,flexShrink:0}}>{i+1}.</span>
                    <div style={{flex:1,minWidth:0,display:"flex",flexDirection:"column",gap:6}}>
                      <div style={{display:"flex",gap:8,alignItems:"center"}}>
                        {i===0&&<span style={{fontSize:10,color:T.muted,whiteSpace:"nowrap",fontWeight:600}}>1. Termin</span>}
                        <Inp T={T} type="date" value={z.datum||""}
                          onChange={e=>{
                            upd(i,"datum",e.target.value);
                            // Erster Fototermin und Datum oben sind dasselbe.
                            if(i===0)s("date",e.target.value);
                          }} style={{flex:1,minWidth:0}}/>
                        <Inp T={T} value={z.label||""} onChange={e=>upd(i,"label",e.target.value)}
                          placeholder={i===0?"Bezeichnung, z.B. Hauptshooting":"Bezeichnung, z.B. 6 Wochen"} style={{flex:1,minWidth:0}}/>
                      </div>
                      <div style={{display:"flex",gap:8}}>
                        {/* Mehrere Hunde je Termin möglich. Keiner angehakt
                            heißt: alle. */}
                        <div style={{flex:1,minWidth:0,background:T.bg,border:`1px solid ${T.border}`,
                                     borderRadius:8,padding:"6px 10px"}}>
                          <div style={{fontSize:10,color:T.muted,marginBottom:hunde.length?4:0}}>
                            {(() => {
                              // Nur mitzaehlen, was es beim Kunden noch gibt.
                              // Umbenannte oder geloeschte Hunde bleiben sonst
                              // als unsichtbarer Eintrag in der Zahl haengen.
                              const namen=hunde.map((t,hi)=>t.name||t.rasse||("Hund "+(hi+1)));
                              const g=hundeListe(z).filter(x=>namen.includes(x));
                              return g.length===0?"Alle Hunde":g.length+" von "+hunde.length+" ausgewählt";
                            })()}
                          </div>
                          <div style={{display:"flex",flexWrap:"wrap",gap:"4px 10px"}}>
                            {hunde.map((t,hi)=>{
                              const n=t.name||t.rasse||("Hund "+(hi+1));
                              const an=hundeListe(z).includes(n);
                              return(
                                <label key={n+hi} title={t.rasse&&t.name?t.rasse:""}
                                  style={{display:"flex",alignItems:"center",gap:5,fontSize:12,
                                          color:an?T.text:T.muted,cursor:"pointer",whiteSpace:"nowrap"}}>
                                  <input type="checkbox" checked={an}
                                    onChange={()=>{
                                      const namen=hunde.map((t2,h2)=>t2.name||t2.rasse||("Hund "+(h2+1)));
                                      const g=hundeListe(z).filter(x=>namen.includes(x));
                                      const neu=g.includes(n)?g.filter(x=>x!==n):[...g,n];
                                      upd(i,"hunde",neu);
                                    }}
                                    style={{accentColor:T.accent,width:14,height:14,flexShrink:0,cursor:"pointer"}}/>
                                  {n}
                                </label>
                              );
                            })}
                            {hunde.length===0&&<span style={{fontSize:12,color:T.muted}}>Beim Kunden ist kein Hund hinterlegt</span>}
                          </div>
                        </div>
                        <Inp T={T} value={z.location||""} onChange={e=>upd(i,"location",e.target.value)}
                          placeholder={f.location?`Location (sonst: ${f.location})`:"Location"}
                          style={{flex:1,minWidth:0,alignSelf:"flex-start"}}/>
                      </div>
                    </div>
                    <span onClick={()=>del(i)} title="Zeile entfernen"
                      style={{color:T.muted,cursor:"pointer",fontSize:15,flexShrink:0,padding:"0 2px"}}>✕</span>
                  </div>
                ))}
              </div>
              <button type="button" onClick={add}
                style={{background:"none",border:`1px dashed ${T.accent}`,borderRadius:7,padding:"6px 14px",fontSize:12,color:T.accent,cursor:"pointer",marginTop:serie.length?12:0,fontFamily:"inherit"}}>
                + Termin hinzufügen
              </button>
              {serie.length>0&&(
                <div style={{fontSize:11,color:T.muted,marginTop:8}}>
                  Der 1. Termin übernimmt das Shooting-Datum von oben. Termine mit Datum erscheinen im Kalender als geplantes Shooting.
                </div>
              )}
              {serie.length>0&&!f.date&&(
                <div style={{fontSize:11,color:T.warning,marginTop:4}}>
                  Oben ist noch kein Datum eingetragen — der 1. Fototermin bleibt deshalb leer.
                </div>
              )}
            </div>
          );
        })()}
      </FG>
      </div>

      <div>
        <div style={{borderTop:`1px solid ${T.border}`,paddingTop:18}}>
          <div style={{fontSize:14,fontWeight:700,color:T.accent,marginBottom:14}}>Bildauftrag</div>
          {(()=>{
            // Jeder Fototermin hat seinen eigenen Bildauftrag: eigene Galerien,
            // eigene Bilderzahl, eigenes Bestelldatum. Der erste Termin nutzt
            // weiterhin die Felder oben, damit alte Daten erhalten bleiben.
            const serie=_serie;
            const kurz=iso=>{
              const t=String(iso||"").slice(0,10);
              return t.length===10?t.slice(8,10)+"."+t.slice(5,7)+".":"";
            };
            return(<>
              {serie.length>1&&(
                <div style={{display:"flex",flexWrap:"wrap",gap:6,marginBottom:14}}>
                  {serie.map((z,i)=>{
                    const aktiv=i===bi;
                    const eigen=i===0?f:z;
                    const belegt=!!(eigen.bilderBestelldatum||eigen.bilderAnzahl||eigen.galerieFeedback||eigen.galerieDownload);
                    return(
                      <button key={i} type="button" onClick={()=>setBildIdx(i)}
                        title={z.bezeichnung||(kurz(z.datum)||("Termin "+(i+1)))}
                        style={{border:`1px solid ${aktiv?T.accent:T.border}`,borderRadius:16,
                                background:aktiv?T.accent:"transparent",color:aktiv?"#fff":T.text,
                                padding:"4px 11px",fontSize:11,fontFamily:"inherit",cursor:"pointer",
                                whiteSpace:"nowrap"}}>
                        {(i+1)+". "+(kurz(z.datum)||"Termin")}{belegt?" •":""}
                      </button>
                    );
                  })}
                </div>
              )}
              {/* Getrennte Adressen: erst wird die Feedbackgalerie zur Auswahl
                  verschickt, spaeter die Downloadgalerie mit den fertigen Bildern.
                  Das alte Feld "galerie" wird mitgepflegt, damit die Symbole in
                  der Terminliste und der Platzhalter in den Mails weiter greifen. */}
              <F label="Feedback-Galerie (Bildauswahl)" full>
                <Inp T={T} value={ba.galerieFeedback||""} placeholder="https://..."
                  onChange={e=>{const v=e.target.value;sBa("galerieFeedback",v);
                    if(!inSerie)s("galerie",(f.galerieDownload||v));}}/>
              </F>
              <F label="Download-Galerie (fertige Bilder)" full>
                <Inp T={T} value={ba.galerieDownload||""} placeholder="https://..."
                  onChange={e=>{const v=e.target.value;sBa("galerieDownload",v);
                    if(!inSerie)s("galerie",(v||f.galerieFeedback||""));}}/>
              </F>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:16,marginBottom:16}}>
                <F label="Anzahl Bilder"><Inp T={T} type="number" value={ba.bilderAnzahl||""}
                  onChange={e=>sBa("bilderAnzahl",Number(e.target.value))}/></F>
                <F label="Bestelldatum"><Inp T={T} type="date" value={ba.bilderBestelldatum||""}
                  onChange={e=>sBa("bilderBestelldatum",e.target.value)}/></F>
              </div>
              {/* Grundpreis gilt fuer den ganzen Termin. Der Aufpreis haengt am
                  einzelnen Fototermin, etwa wenn dort zusaetzliche Bilder
                  gekauft werden. Beides zusammen ist der Gesamtbetrag. */}
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:16,marginBottom:8}}>
                <F label="Grundpreis – ganzer Termin">
                  <PreisFeld T={T} value={f.price??""} onChange={v=>s("price",v)}/>
                </F>
                <F label={serie.length>1?"Aufpreis – dieser Fototermin":"Aufpreis – Zusatzbilder"}>
                  <PreisFeld T={T} value={ba.aufpreis??""} onChange={v=>sBa("aufpreis",v)}/>
                </F>
              </div>
              {(()=>{
                const grund=Number(f.price)||0;
                const zusatz=(Number(f.aufpreis)||0)+_serie.slice(1).reduce((x,z)=>x+(Number(z&&z.aufpreis)||0),0);
                if(!grund&&!zusatz)return null;
                return(
                  <div style={{marginBottom:16,fontSize:12,color:T.muted}}>
                    Gesamtbetrag: <b style={{color:T.accent,fontSize:14}}>{(grund+zusatz).toFixed(2).replace(".",",")} €</b>
                    {zusatz>0?` (Grundpreis ${grund.toFixed(2).replace(".",",")} € + Aufpreise ${zusatz.toFixed(2).replace(".",",")} €)`:""}
                  </div>
                );
              })()}
            </>);
          })()}
          {(()=>{
            const kd=customers.find(x=>x.id===f.customerId);
            return(
              <div style={{marginBottom:14}}>
                <button type="button" disabled={!kd}
                  onClick={()=>setVertragOffen(true)}
                  title={kd?"Vertragsfenster mit den Daten dieses Termins öffnen":"Erst einen Kunden auswählen"}
                  style={{width:"100%",display:"flex",alignItems:"center",justifyContent:"center",gap:8,
                          background:kd?T.accent:T.bg,color:kd?"#fff":T.muted,
                          border:`1px solid ${kd?T.accent:T.border}`,borderRadius:8,
                          padding:"10px 14px",fontSize:14,fontWeight:600,fontFamily:"inherit",
                          cursor:kd?"pointer":"default"}}>
                  📄 Vertrag erstellen
                </button>
                {!kd&&(
                  <div style={{fontSize:11,color:T.muted,marginTop:5}}>
                    Der Vertrag braucht einen Kunden. Trag oben einen Namen ein, dann wird der Knopf aktiv.
                  </div>
                )}
              </div>
            );
          })()}
          <div style={{display:"flex",flexDirection:"column",gap:8}}>
            {[["bilderLinkVerschickt","📤 Galerielink verschickt"],["bilderRechnung","🧾 Rechnung"],["bilderBezahlt","💶 Rechnung bezahlt"],["bilderFertig","✅ Bilder fertig"],["bilderAbgeschlossen","🔒 Abgeschlossen"]].map(([k,lbl])=>{
              // Die ersten vier gelten je Fototermin, abgeschlossen wird der
              // ganze Termin und erst, wenn alle Fototermine fertig sind.
              const proTermin=k!=="bilderAbgeschlossen";
              const q=proTermin?ba:f;
              const setQ=proTermin?sBa:s;
              const gesperrt=k==="bilderAbgeschlossen"&&!alleFertig&&!f.bilderAbgeschlossen;
              return(
              <label key={k} title={gesperrt?"Erst möglich, wenn bei jedem Fototermin die Bilder fertig sind":undefined}
                style={{display:"flex",alignItems:"center",gap:10,fontSize:14,cursor:gesperrt?"not-allowed":"pointer",opacity:gesperrt?0.5:1,color:q[k]?"#27ae60":T.text,background:q[k]?"#27ae6010":T.bg,border:`1px solid ${q[k]?"#27ae60":T.border}`,borderRadius:8,padding:"10px 14px",transition:"all 0.15s"}}>
                <input type="checkbox" checked={!!q[k]} disabled={gesperrt} onChange={e=>{
                  setQ(k,e.target.checked);
                  setQ(k+"Datum",e.target.checked?new Date().toISOString().slice(0,10):"");
                  if(k==="bilderAbgeschlossen"&&e.target.checked){
                    s("status","abgeschlossen");
                    s("bilderAbgeschlossenDatum",new Date().toISOString().slice(0,10));
                    if(!f.statExport){
                      const c=customers.find(x=>x.id===f.customerId);
                      setStatFrage({
                        titel:"Einzeltermin abgeschlossen",
                        // Sind oben Hunde angehakt, gehen nur die in die
                        // Statistik. Ohne Haken zaehlen alle.
                        tiere:(()=>{
                          const alle=(c?.tiere||[]).filter(t=>t&&(t.rasse||t.name));
                          const gew=Array.isArray(f.hunde)?f.hunde:[];
                          if(!gew.length)return alle;
                          const treffer=alle.filter(t=>gew.includes(t.name||t.rasse));
                          return treffer.length?treffer:alle;
                        })(),
                        datum:(f.date||"").slice(0,10),
                        typ:f.shootingart||"",
                        notiz:"Einzeltermin",
                        onOk:()=>s("statExport",true),
                      });
                    }
                  }
                }} style={{accentColor:T.accent,width:16,height:16,flexShrink:0}}/>
                <span style={{flex:1}}>{lbl}{proTermin&&inSerie?" · "+(bi+1)+". Termin":""}</span>
                {q[k]&&q[k+"Datum"]&&(
                  <span style={{fontSize:11,color:T.muted,whiteSpace:"nowrap"}}>
                    {new Date(q[k+"Datum"]).toLocaleDateString("de-DE")}
                  </span>
                )}
              </label>);
            })}
            {_serie.length>1&&!alleFertig&&(
              <div style={{fontSize:11,color:T.muted,lineHeight:1.5}}>
                Abgeschlossen wird erst frei, wenn bei jedem Fototermin die Bilder fertig sind.
              </div>
            )}
          </div>
        </div>
      </div>
      </div>
      <div style={{display:"flex",justifyContent:"flex-end",gap:10,marginTop:20}}>
        <button style={btn(T,"ghost")} onClick={onClose}>Abbrechen</button>
        <button style={btn(T,"primary")} onClick={()=>{if(!f.customerId||!f.date)return;onSave({...f,id:f.id||uid(),signed:f.signed||false,created:f.created||new Date().toISOString().slice(0,10)})}}>Speichern</button>
      </div>
    </Modal>
    {statFrage&&(
      <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.75)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:320,padding:16}}>
        <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:14,padding:24,width:"100%",maxWidth:440,maxHeight:"88vh",overflowY:"auto"}}>
          <div style={{fontFamily:"Georgia,serif",fontSize:18,color:T.accent,marginBottom:4}}>In Statistik übernehmen?</div>
          <div style={{fontSize:12,color:T.muted,marginBottom:18}}>{statFrage.titel}</div>

          <div style={{background:T.bg,borderRadius:10,padding:"12px 14px",marginBottom:14}}>
            <div style={{display:"flex",gap:10,fontSize:13}}>
              <span style={{color:T.muted,width:78,flexShrink:0}}>Shootingart</span>
              <span style={{color:statFrage.typ?T.text:"#e67e22"}}>{statFrage.typ||"nicht gewählt → wird als \u201eSonstiges\u201c gezählt"}</span>
            </div>
          </div>

          {statFrage.tiere.length===0?(
            <div style={{background:"#e74c3c18",border:"1px solid #e74c3c55",borderRadius:10,padding:"12px 14px",fontSize:13,color:T.text,marginBottom:18}}>
              Beim Kunden ist kein Tier hinterlegt. Es gibt nichts zu übernehmen.
              Trag die Tiere zuerst in der Kontaktkarte ein.
            </div>
          ):(<>
            <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:8,gap:10}}>
              <div style={{fontSize:12,color:T.muted,fontWeight:600}}>
                {statGewaehlt.size} von {statFrage.tiere.length} {statFrage.tiere.length===1?"Tier":"Tieren"} wird übernommen
              </div>
              {statFrage.tiere.length>1&&(
                <button style={{background:"none",border:"none",color:T.accent,fontSize:11,cursor:"pointer",
                                fontFamily:"inherit",textDecoration:"underline",padding:0}}
                  onClick={()=>setStatGewaehlt(statGewaehlt.size===statFrage.tiere.length
                    ? new Set() : new Set(statFrage.tiere.map((_,i)=>i)))}>
                  {statGewaehlt.size===statFrage.tiere.length?"Keins":"Alle"}
                </button>
              )}
            </div>
            {statFrage.tiere.length>1&&(
              <div style={{fontSize:11,color:T.muted,marginBottom:10,lineHeight:1.5}}>
                Nur die angehakten Hunde wandern in die Statistik. War ein Hund beim Termin nicht dabei, Haken raus.
              </div>
            )}
            <div style={{display:"flex",flexDirection:"column",gap:8,marginBottom:18}}>
              {statFrage.tiere.map((t,i)=>{
                // Dasselbe Alter anzeigen, das auch gespeichert wird.
                const az=alterZumDatum(t,statFrage.datum);
                const j=parseInt(az.alter)||0,mo=parseInt(az.alterMonate)||0;
                const alt=(!j&&!mo)?null:(!j?mo+" M":(!mo?j+" J":j+" J "+mo+" M"));
                const an=statGewaehlt.has(i);
                return(
                  <label key={i} style={{border:`1px solid ${an?T.accent:T.border}`,borderRadius:8,
                                         padding:"9px 12px",fontSize:13,display:"flex",alignItems:"center",gap:10,
                                         cursor:"pointer",background:an?T.accent+"0e":"transparent"}}>
                    <input type="checkbox" checked={an} style={{width:16,height:16,flexShrink:0}}
                      onChange={()=>setStatGewaehlt(p=>{
                        const n=new Set(p);
                        if(n.has(i))n.delete(i);else n.add(i);
                        return n;
                      })}/>
                    <span style={{minWidth:0}}>
                      <span style={{fontWeight:700,color:an?T.text:T.muted}}>{t.name||"ohne Namen"}</span>
                      <span style={{color:T.muted}}>
                        {t.rasse?" · "+t.rasse:" · Rasse fehlt"}
                        {t.geschlecht?" · "+t.geschlecht:" · Geschlecht fehlt"}
                        {alt?" · "+alt:" · Alter fehlt"}
                      </span>
                    </span>
                  </label>
                );
              })}
            </div>
          </>)}

          <div style={{display:"flex",gap:8}}>
            <button style={{...btn(T,"ghost"),flex:1}} onClick={()=>setStatFrage(null)}>
              {statFrage.tiere.length===0?"Schließen":"Nicht übernehmen"}
            </button>
            {statFrage.tiere.length>0&&(
              <button style={{...btn(T,"primary"),flex:1}} onClick={()=>{
                const gewaehlt=statFrage.tiere.filter((_,i)=>statGewaehlt.has(i));
                if(gewaehlt.length===0){
                  alert("Es ist kein Tier angehakt. Setz mindestens einen Haken oder wähle „Nicht übernehmen“.");
                  return;
                }
                const r=statistikEintragen({tiere:gewaehlt,datum:statFrage.datum,shootingTyp:statFrage.typ,notiz:statFrage.notiz});
                if(r.ok){statFrage.onOk&&statFrage.onOk();setStatFrage(null);}
                else if(r.grund==="kein_profil")alert("Kein Statistik-Profil vorhanden. Bitte zuerst in der Statistik ein Profil anlegen.");
                else alert("Übernahme fehlgeschlagen: "+r.grund);
              }}>{statGewaehlt.size===statFrage.tiere.length?"Übernehmen":statGewaehlt.size+" übernehmen"}</button>
            )}
          </div>
        </div>
      </div>
    )}
    {vertragOffen&&(()=>{
      const kd=customers.find(x=>x.id===f.customerId);
      if(!kd)return null;
      // Termindaten vorbelegen, damit im Vertragsfenster nichts doppelt
      // eingetippt werden muss. Das Datum kommt als ISO und muss ins
      // deutsche Format, sonst steht 2026-09-01 im Vertrag.
      const iso=(f.date||"").slice(0,10);
      const deDatum=iso&&iso.length===10
        ? `${iso.slice(8,10)}.${iso.slice(5,7)}.${iso.slice(0,4)}`
        : "";
      return(
        <VertragModal kunde={kd} T={T} onClose={()=>setVertragOffen(false)}
          termin={{datum:deDatum,uhrzeit:f.uhrzeit||"",ort:f.location||"",
                   lat:f.locationLat,lng:f.locationLng,
                   preis:terminBetrag(f)||"",
                   // Beim Termin ausgewaehlte Hunde und die weiteren
                   // Fototermine wandern in den Vertrag.
                   hunde:Array.isArray(f.hunde)?f.hunde:[],
                   serie:Array.isArray(f.serie)?f.serie:[]}}/>
      );
    })()}
    {showOrtMail&&<OrtMailModal location={f.location} cust={customers.find(c=>c.id===f.customerId)} onClose={()=>setShowOrtMail(false)} T={T}/>}
    {showKartenPicker&&(
      <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.75)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:300,padding:16}}>
        <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:14,padding:16,width:"100%",maxWidth:"90vw",height:"90vh",display:"flex",flexDirection:"column",gap:10}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <div style={{fontFamily:"Georgia,serif",fontSize:17,color:T.accent}}>📍 Location auswählen</div>
            <button onClick={()=>setShowKartenPicker(false)} style={{background:"none",border:"none",fontSize:18,cursor:"pointer",color:T.muted}}>✕</button>
          </div>
          <div style={{fontSize:12,color:T.muted}}>Klick auf einen Pin = übernehmen · Klick auf leere Stelle = neuen Pin setzen</div>
          <div id="bm_karte" style={{flex:1,borderRadius:10,overflow:"hidden",border:`1px solid ${T.border}`}}/>
          <KartenPickerInner T={T} onSelect={(label,lat,lng)=>{s("location",label);s("locationLat",lat);s("locationLng",lng);setShowKartenPicker(false);}}/>
        </div>
      </div>
    )}
  </>);
}

// ── OrtMailModal ──────────────────────────────────────────────────────────────
function OrtMailModal({location,cust,onClose,T}){
  const mapsUrl=`https://maps.google.com/?q=${encodeURIComponent(location)}`;
  const smtp=(()=>{try{const s=JSON.parse(localStorage.getItem("sd_smtp_info")||localStorage.getItem("sd_smtp_buchung")||localStorage.getItem("sd_smtp_settings")||"{}");return {...s,from_email:"info@m-h-photo.de"};}catch{return {};}})();
  const [betreff,setBetreff]=useState(`Location: ${location}`);
  const ortText=["Hallo "+(cust?.name||"")+",","","hier ist die Location fur unser Shooting:","",location,"","Google Maps:",mapsUrl,"","Bis dann!","Markus Heber Photography"].join("\n");
  const [text,setText]=useState(ortText);
  const [sending,setSending]=useState(false);
  return(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.7)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:400,padding:20}}>
      <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:14,padding:24,width:"100%",maxWidth:500,display:"flex",flexDirection:"column",gap:12}}>
        <div style={{fontFamily:"Georgia,serif",fontSize:17,color:T.accent}}>📧 Location per Mail teilen</div>
        <div style={{fontSize:12,color:T.muted}}>An: {cust?.email||"—"}</div>
        <div>
          <div style={{fontSize:11,fontWeight:700,color:T.muted,marginBottom:4,textTransform:"uppercase",letterSpacing:".06em"}}>Betreff</div>
          <input value={betreff} onChange={e=>setBetreff(e.target.value)} style={{width:"100%",boxSizing:"border-box",padding:"8px 10px",border:`1px solid ${T.border}`,borderRadius:7,fontSize:13,background:T.bg,color:T.text,fontFamily:"inherit"}}/>
        </div>
        <div>
          <div style={{fontSize:11,fontWeight:700,color:T.muted,marginBottom:4,textTransform:"uppercase",letterSpacing:".06em"}}>Text</div>
          <textarea value={text} onChange={e=>setText(e.target.value)} rows={8} style={{width:"100%",boxSizing:"border-box",padding:"8px 10px",border:`1px solid ${T.border}`,borderRadius:7,fontSize:13,background:T.bg,color:T.text,fontFamily:"inherit",resize:"vertical"}}/>
        </div>
        <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
          <button onClick={onClose} style={{background:"none",border:`1px solid ${T.border}`,borderRadius:8,padding:"8px 16px",fontSize:13,cursor:"pointer",color:T.text}}>Abbrechen</button>
          <button disabled={sending||!cust?.email} onClick={async()=>{
            setSending(true);
            const serverUrl=(localStorage.getItem("sd_server_url")||"").trim().replace(/\/+$/,"");
            const html=text.split("\n").map(l=>l?`<p>${l}</p>`:"<br/>").join("");
            await fetch(`${serverUrl}/api/newsletter`,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({smtp,recipients:[{name:cust?.name||"",email:cust?.email}],subject:betreff,text,html,logo:""})}).catch(()=>{});
            setSending(false);
            onClose();
            alert("Mail verschickt!");
          }} style={{background:T.accent,color:"#fff",border:"none",borderRadius:8,padding:"8px 16px",fontSize:13,fontWeight:600,cursor:"pointer"}}>
            {sending?"Wird gesendet...":"📧 Senden"}
          </button>
        </div>
      </div>
    </div>
  );
}

// ── KartenPickerInner ─────────────────────────────────────────────────────────
function KartenPickerInner({T,onSelect}){
  const ref=useRef(null);
  useEffect(()=>{
    if(ref.current)return;
    const init=()=>{
      if(!document.getElementById('bm_karte')||!window.L)return;
      const map=window.L.map('bm_karte').setView([51.1657,10.4515],6);
      window.L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',{attribution:'© OpenStreetMap',maxZoom:19}).addTo(map);
      ref.current=map;

      function makeIcon(color){
        const svg=`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="32" viewBox="0 0 24 32"><path d="M12 0C5.37 0 0 5.37 0 12c0 9 12 20 12 20S24 21 24 12C24 5.37 18.63 0 12 0z" fill="${color}"/><circle cx="12" cy="12" r="6" fill="white" opacity="0.9"/></svg>`;
        return window.L.divIcon({html:svg,iconSize:[24,32],iconAnchor:[12,32],className:''});
      }

      // Bestehende Pins laden
      try{
        const poi=JSON.parse(localStorage.getItem('sd_karte_poi')||'[]');
        poi.forEach(p=>{
          if(!p.lat||!p.lng)return;
          const m=window.L.marker([p.lat,p.lng],{icon:makeIcon('#b8952a')}).addTo(map);
          m.bindPopup(`<b>${p.label||'POI'}</b>${p.adresse?'<br>'+p.adresse:''}<br><button onclick="window._kartenPickerSelect('${(p.label||'').replace(/'/g,'\'')}',${p.lat},${p.lng})" style="margin-top:6px;padding:4px 10px;background:#b8952a;color:#fff;border:none;border-radius:6px;cursor:pointer;font-size:12px">Übernehmen</button>`);
          m.on('click',()=>m.openPopup());
        });
        // Buchungen
        const bk=JSON.parse(localStorage.getItem('sd_bookings')||'[]');
        const cu=JSON.parse(localStorage.getItem('sd_customers')||'[]');
        bk.forEach(b=>{
          if(!b.locationLat||!b.locationLng)return;
          const c=cu.find(x=>x.id===b.customerId);
          const lbl=b.location||(c?c.name:'Shooting');
          const m=window.L.marker([b.locationLat,b.locationLng],{icon:makeIcon('#27ae60')}).addTo(map);
          m.bindPopup(`<b>${lbl}</b><br><button onclick="window._kartenPickerSelect('${lbl.replace(/'/g,'\'')}',${b.locationLat},${b.locationLng})" style="margin-top:6px;padding:4px 10px;background:#27ae60;color:#fff;border:none;border-radius:6px;cursor:pointer;font-size:12px">Übernehmen</button>`);
          m.on('click',()=>m.openPopup());
        });
      }catch(e){}

      // Klick auf leere Stelle
      map.on('click',async e=>{
        const lat=e.latlng.lat,lng=e.latlng.lng;
        // Reverse Geocode
        let label='';
        try{
          const r=await fetch('https://nominatim.openstreetmap.org/reverse?lat='+lat+'&lon='+lng+'&format=json',{headers:{'Accept-Language':'de'}});
          const d=await r.json();
          label=d.display_name?d.display_name.split(',').slice(0,3).join(', '):'';
        }catch{}
        const name=window.prompt('Ort-Name:',label||lat.toFixed(4)+', '+lng.toFixed(4));
        if(!name)return;
        window._kartenPickerSelect(name,lat,lng);
      });
    };
    if(!window.L){
      if(!document.getElementById('leaflet-css')){const css=document.createElement('link');css.id='leaflet-css';css.rel='stylesheet';css.href='https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';document.head.appendChild(css);}
      const s=document.createElement('script');s.src='https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';s.onload=()=>setTimeout(init,100);document.head.appendChild(s);
    } else setTimeout(init,100);
  },[]);

  // Global callback für Popup-Buttons
  useEffect(()=>{
    window._kartenPickerSelect=onSelect;
    return()=>{delete window._kartenPickerSelect;};
  },[onSelect]);

  // Cleanup: Karte beim Unmount zerstören
  useEffect(()=>{
    return()=>{
      if(ref.current){try{ref.current.remove();}catch{}ref.current=null;}
    };
  },[]);

  return null;
}

function AgreementModal({booking,customer,onSign,onClose,T}){
  const [showPad,setShowPad]=useState(false);
  const [signed,setSigned]=useState(booking.signed);
  const [sigData,setSigData]=useState(booking.sigData||null);
  const [sendState,setSendState]=useState(null);
  const [sendMsg,setSendMsg]=useState("");
  const tier=(customer.tiere&&customer.tiere[0])||{name:customer.dog||"",rasse:customer.breed||"",alter:"",geschlecht:""};
  const vtext=localStorage.getItem("sd_vereinbarung_text")||DEFAULT_VEREINBARUNG;
  const alterStr=tier.alter?`${tier.alter} J.${tier.alterMonate?` ${tier.alterMonate} M.`:""}`:"—";
  function handleSave(d){setSigData(d);setSigned(true);setShowPad(false);onSign(d);}
  async function vertragSenden(){
    if(!customer.email){setSendState("err");setSendMsg("Dieser Kunde hat keine E-Mail-Adresse. Bitte erst in der Kundenkarte ergänzen.");return;}
    let serverUrl=(localStorage.getItem("sd_server_url")||"").trim().replace(/\/+$/,"");
    if(!serverUrl||(location.protocol==="https:"&&serverUrl.startsWith("http://")))serverUrl=location.origin;
    let smtp={};try{smtp=JSON.parse(localStorage.getItem("sd_smtp_buchung")||localStorage.getItem("sd_smtp_settings")||"{}");}catch{}
    let cfg={};try{cfg=JSON.parse(localStorage.getItem("sd_buchung_config")||"{}");}catch{}
    setSendState("sending");setSendMsg("");
    try{
      const resp=await fetch(serverUrl+"/api/vertrag-senden",{
        method:"POST",headers:{"Content-Type":"application/json"},
        body:JSON.stringify({
          name:customer.name,email:customer.email,
          tier:{name:tier.name||"",rasse:tier.rasse||"",alter:tier.alter||"",alterMonate:tier.alterMonate||"",geschlecht:tier.geschlecht||""},
          datum:fmtDateTime(booking.date),preis:booking.price,
          vereinbarung:vtext,
          studio:{studioname:cfg.studioName||cfg.studioname||"Markus Heber Photography"},
          smtp,
        }),
      });
      const d=await resp.json();
      if(d.ok){setSendState("ok");setSendMsg("Vertrag an "+customer.email+" gesendet.");}
      else{setSendState("err");setSendMsg(d.fehler||"Versand fehlgeschlagen.");}
    }catch(e){setSendState("err");setSendMsg("Server nicht erreichbar.");}
  }
  return(
    <>
      <Modal title="Shooting-Vereinbarung" onClose={onClose} T={T} wide>
        <div style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:16,fontSize:13,lineHeight:1.7,marginBottom:16}}>
          <strong style={{color:T.accent}}>Vereinbarung</strong>
          <p style={{marginTop:12}}>
            <strong>Kunde:</strong> {customer.name||"—"}<br/>
            <strong>Tier:</strong> {tier.name||"—"}<br/>
            <strong>Rasse:</strong> {tier.rasse||"—"}<br/>
            <strong>Alter:</strong> {alterStr}<br/>
            <strong>Geschlecht:</strong> {tier.geschlecht||"—"}<br/>
            <strong>Termin:</strong> {fmtDateTime(booking.date)}<br/>
            <strong>Preis:</strong> {booking.price} €
          </p>
          {vtext.split("\n").filter(l=>l.trim()).map((l,i)=><p key={i} style={{marginTop:8}}>{l}</p>)}
        </div>
        {signed?<div style={{textAlign:"center"}}><p style={{color:T.success,fontWeight:600,marginBottom:8}}>✅ Unterschrift vorhanden</p>{sigData&&<img src={sigData} alt="Unterschrift" style={{maxWidth:300,border:`1px solid ${T.border}`,borderRadius:8}}/>}</div>:<button style={btn(T,"primary")} onClick={()=>setShowPad(true)}>Jetzt unterschreiben</button>}
        <div style={{marginTop:18,borderTop:`1px solid ${T.border}`,paddingTop:16}}>
          <div style={{fontSize:12,color:T.muted,marginBottom:8}}>Oder dem Kunden den Vertrag zum Unterschreiben am Handy schicken:</div>
          <button style={btn(T,"ghost")} disabled={sendState==="sending"} onClick={vertragSenden}>{sendState==="sending"?"Wird gesendet…":"✉ Vertrag per E-Mail senden"}</button>
          {sendMsg&&<div style={{marginTop:8,fontSize:12,color:sendState==="ok"?T.success:T.danger}}>{sendMsg}</div>}
        </div>
        <div style={{display:"flex",justifyContent:"flex-end",marginTop:20}}><button style={btn(T,"ghost")} onClick={onClose}>Schließen</button></div>
      </Modal>
      {showPad&&<SignaturePad onSave={handleSave} onClose={()=>setShowPad(false)} T={T}/>}
    </>
  );
}
function EmailModal({booking,customer,type,onClose,T}){
  const d=daysUntil(booking.date);
  const tpls={
    buchung:`Betreff: Buchungsbestätigung – Shooting ${fmtDate(booking.date)}\n\nHallo ${customer.name},\n\nvielen Dank für deine Buchung!\n\n📅 ${fmtDateTime(booking.date)}\n📍 ${booking.location||"wird mitgeteilt"}\n💰 ${booking.price} €`,
    erinnerung:`Betreff: Erinnerung – Shooting in ${d} Tagen\n\nHallo ${customer.name},\n\nkurze Erinnerung: euer Shooting ist in ${d} Tagen!\n\n📅 ${fmtDateTime(booking.date)}\n📍 ${booking.location||"wie abgesprochen"}`,
    galerie:`Betreff: Deine Bilder sind fertig! 🎉\n\nHallo ${customer.name},\n\ndie Bilder sind fertig!\n\n🖼️ ${booking.galerie||"Link folgt"}`,
  };
  return(
    <Modal title="E-Mail Vorschau" onClose={onClose} T={T}>
      <pre style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:14,fontSize:12,whiteSpace:"pre-wrap",color:T.text,fontFamily:"monospace",maxHeight:200,overflowY:"auto"}}>{tpls[type]}</pre>
      <div style={{display:"flex",justifyContent:"flex-end",gap:10,marginTop:16}}>
        <button style={btn(T,"ghost")} onClick={onClose}>Schließen</button>
        <button style={btn(T,"primary")} onClick={()=>navigator.clipboard.writeText(tpls[type])}>Kopieren</button>
      </div>
    </Modal>
  );
}

// ── Event Modal ───────────────────────────────────────────────────────────────
// ── Preisvorgaben ─────────────────────────────────────────────────────────────
const PREISVORGABEN = {
  Underglass:    {shootingGebuehr:0, preisWeitererHund:0, preisZusatzbild:0, bearbeitungPreis:0, bilderFrei:0},
  Studio:        {shootingGebuehr:0, preisWeitererHund:0, preisZusatzbild:0, bearbeitungPreis:0, bilderFrei:0},
  Veranstaltung: {shootingGebuehr:0, preisWeitererHund:0, preisZusatzbild:0, bearbeitungPreis:0, bilderFrei:0},
};
const FOTOARTEN = Object.keys(PREISVORGABEN);


function EventModal({event,onSave,onClose,onDelete,T,initialDate,datumOptional}){
  const [step,setStep]=useState(event?1:0);
  const [vorgabe,setVorgabe]=useState("Underglass");
  // Lokale editierbare Kopie der Preisvorgaben
  const [localVorgaben,setLocalVorgaben]=useState(()=>{
    try{const s=JSON.parse(localStorage.getItem("sd_preisvorgaben")||"null");if(s)return s;}catch{}
    return JSON.parse(JSON.stringify(PREISVORGABEN));
  });
  useEffect(()=>{localStorage.setItem("sd_preisvorgaben",JSON.stringify(localVorgaben));},[localVorgaben]);
  const initPreise = event ? event.preise : localVorgaben["Underglass"];
  const [f,setF]=useState(event||{
    name:"",date:initialDate||"",location:"",fotoart:"Hundeshooting",shootingart:"Underglass",
    preise:initPreise,
    ausgaben:{stand:0,hotel:0,mietwagen:0,sprit:0,vermieter:""},
    kontakt:{ansprechpartner:"",telefon:"",email:"",homepage:""},
    adresse:{strasse:"",plz:"",ort:""},
    info:"",
    pictrs:0,partnerPct:0,teilnehmer:[],created:""
  });
  const s=(k,v)=>setF(x=>({...x,[k]:v}));
  const sp=(k,v)=>setF(x=>({...x,preise:{...x.preise,[k]:v}}));
  const sa=(k,v)=>setF(x=>({...x,ausgaben:{...x.ausgaben,[k]:v}}));
  const sk=(k,v)=>setF(x=>({...x,kontakt:{...x.kontakt,[k]:v}}));
  const sad=(k,v)=>setF(x=>({...x,adresse:{...x.adresse,[k]:v}}));

  // ── Kontaktvorschläge + Location-Vorschläge aus früheren Veranstaltungen ──
  const [_existingEvents]=useState(()=>{try{return JSON.parse(localStorage.getItem("sd_events")||"[]");}catch{return [];}});
  const [locationDropdown,setLocationDropdown]=useState(false);
  const [showKartenPickerEv,setShowKartenPickerEv]=useState(false);
  const _firmenkontakte=(()=>{try{return JSON.parse(localStorage.getItem("sd_firmenkontakte")||"[]");}catch{return [];}})();
  const _locations=(()=>{
    const seen=new Set(),out=[];
    _existingEvents.forEach(ev=>{
      if(!ev.location) return;
      if(seen.has(ev.location)) return;
      seen.add(ev.location);
      out.push({location:ev.location,strasse:ev.adresse?.strasse||"",plz:ev.adresse?.plz||"",ort:ev.adresse?.ort||""});
    });
    return out;
  })();
  const _hasK=(k)=>!!(k&&(k.ansprechpartner||k.telefon||k.email||k.homepage));
  const _kontakte=(()=>{
    const seen=new Set(),out=[];
    _existingEvents.forEach(ev=>{
      const k=ev.kontakt; if(!_hasK(k))return;
      const key=(k.ansprechpartner||"")+"|"+(k.telefon||"")+"|"+(k.email||"");
      if(seen.has(key))return; seen.add(key);
      out.push({...k,_von:ev.name||""});
    });
    return out;
  })();
  function _findKontaktVorschlag(name){
    const w=(name||"").trim().toLowerCase().split(/\s+/).filter(Boolean);
    if(w.length<1)return null;
    const cnt={}; let best=null,bestN=0;
    _existingEvents.forEach(ev=>{
      const k=ev.kontakt; if(!_hasK(k))return;
      const ew=(ev.name||"").trim().toLowerCase().split(/\s+/).filter(Boolean);
      let m=0; while(m<w.length&&m<ew.length&&w[m]===ew[m])m++;
      if(m<2)return;
      const key=(k.ansprechpartner||"")+"|"+(k.telefon||"")+"|"+(k.email||"");
      cnt[key]=(cnt[key]||0)+1;
      if(cnt[key]>bestN){bestN=cnt[key];best=k;}
    });
    return best;
  }

  function updateLocalVorgabe(vname,field,val){
    setLocalVorgaben(p=>({...p,[vname]:{...p[vname],[field]:Number(val)}}));
  }
  function applyVorgabe(v){
    setVorgabe(v);
    const p=localVorgaben[v];
    setF(x=>({...x,fotoart:v,shootingart:v,preise:{...x.preise,...p}}));
    setStep(1);
  }

  const IS={background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:"4px 10px",color:T.text,fontSize:13,fontFamily:"inherit",outline:"none",boxSizing:"border-box",width:"100%"};
  const NI={background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:"7px 10px",color:T.text,fontSize:13,fontFamily:"inherit",outline:"none",width:90,textAlign:"right"};

  return(<>
    <Modal title={event?"Veranstaltung bearbeiten":"Neue Veranstaltung"} onClose={onClose} T={T} wide>
      {step===0&&!event&&(
        <div>
          <p style={{fontSize:13,color:T.muted,marginBottom:20}}>Welche Preisvorgabe soll verwendet werden?</p>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:16,marginBottom:16}}>
            {Object.entries(PREISVORGABEN).map(([k,p])=>(
              <div key={k}
                style={{background:T.bg,border:`2px solid ${vorgabe===k?T.accent:T.border}`,borderRadius:12,padding:"16px 20px",transition:"border-color 0.15s",position:"relative"}}
                onMouseEnter={e=>e.currentTarget.style.borderColor=T.accent}
                onMouseLeave={e=>e.currentTarget.style.borderColor=vorgabe===k?T.accent:T.border}>
                <div style={{fontSize:13,fontWeight:700,color:T.accent,marginBottom:10}}>{k}</div>
                {[["shootingGebuehr","Shootinggebühr","€"],["preisWeitererHund","je weit. Hund","€"],["preisZusatzbild","Zusatzbild","€"],["bearbeitungPreis","Bearbeitung ext.","€"],["bilderFrei","Bilder frei",""]].map(([field,label,unit])=>(
                  <div key={field} style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
                    <span style={{fontSize:11,color:T.muted}}>{label}</span>
                    <div style={{display:"flex",alignItems:"center",gap:4}}>
                      <input type="number" value={localVorgaben[k][field]}
                        onClick={e=>e.stopPropagation()}
                        onChange={e=>{e.stopPropagation();updateLocalVorgabe(k,field,e.target.value);}}
                        style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:6,padding:"4px 6px",color:T.text,fontSize:12,fontFamily:"inherit",outline:"none",width:60,textAlign:"right"}}/>
                      <span style={{fontSize:10,color:T.muted,whiteSpace:"nowrap",minWidth:28}}>{unit}</span>
                    </div>
                  </div>
                ))}
                <button onClick={()=>applyVorgabe(k)}
                  style={{...btn(T,"primary",true),width:"100%",justifyContent:"center",marginTop:10}}>
                  Auswählen →
                </button>
              </div>
            ))}
          </div>
          <div style={{display:"flex",justifyContent:"flex-end",gap:10}}>
            <button style={btn(T,"ghost")} onClick={onClose}>Abbrechen</button>
          </div>
        </div>
      )}
      {step===1&&(
        <div>
          <FG>
            <F label="Event-Name *" full><Inp T={T} value={f.name} onChange={e=>{
              const name=e.target.value;
              setF(x=>{
                const nx={...x,name};
                if(!event&&!_hasK(x.kontakt)){
                  const v=_findKontaktVorschlag(name);
                  if(v)nx.kontakt={ansprechpartner:v.ansprechpartner||"",telefon:v.telefon||"",email:v.email||"",homepage:v.homepage||""};
                }
                return nx;
              });
            }} placeholder="Tierlieb Festival 2026"/></F>
            {datumOptional?<F label="Datum (optional)"><Inp T={T} type="date" value={f.date||""} onChange={e=>s("date",e.target.value)}/></F>:<F label="Datum *"><Inp T={T} type="date" value={f.date} onChange={e=>s("date",e.target.value)}/></F>}
            <F label="Bis (optional)"><Inp T={T} type="date" value={f.dateBis||""} onChange={e=>s("dateBis",e.target.value)} min={f.date||""}/></F>
            <F label="Anreise (für Google Kalender)"><Inp T={T} type="date" value={f.anreise||(f.date?f.date:"")} onChange={e=>s("anreise",e.target.value)} max={f.date||""}/></F>
            <F label="Abreise (für Google Kalender)"><Inp T={T} type="date" value={f.abreise||""} onChange={e=>s("abreise",e.target.value)} min={f.date||""}/></F>
            <F label="Location / Veranstaltungsort" full>
              <div style={{position:"relative",display:"flex",gap:6}}>
                <div style={{flex:1,position:"relative"}}>
                <Inp T={T} value={f.location}
                  onChange={e=>{s("location",e.target.value);setLocationDropdown(true);}}
                  onFocus={()=>setLocationDropdown(true)}
                  onBlur={()=>setTimeout(()=>setLocationDropdown(false),150)}
                  placeholder="Naturkunde Museum"/>
                {locationDropdown&&(()=>{
                  const hits=_locations.filter(l=>l.location.toLowerCase().includes((f.location||"").toLowerCase())).slice(0,8);
                  return hits.length>0&&<div style={{position:"absolute",top:"100%",left:0,right:0,background:T.surface,border:`1px solid ${T.border}`,borderRadius:8,zIndex:999,boxShadow:"0 4px 12px #0002",marginTop:2}}>
                    {hits.map((l,i)=><div key={i} onMouseDown={()=>{
                      s("location",l.location);
                      if(l.strasse)sad("strasse",l.strasse);
                      if(l.plz)sad("plz",l.plz);
                      if(l.ort)sad("ort",l.ort);
                      setLocationDropdown(false);
                    }} style={{padding:"8px 12px",fontSize:13,cursor:"pointer",color:T.text,borderBottom:`1px solid ${T.border}22`}}>
                      <div style={{fontWeight:600}}>{l.location}</div>
                      {(l.strasse||l.plz||l.ort)&&<div style={{fontSize:11,color:T.muted,marginTop:2}}>{[l.strasse,l.plz,l.ort].filter(Boolean).join(", ")}</div>}
                    </div>)}
                  </div>;
                })()}
                </div>
                <button type="button" onClick={()=>setShowKartenPickerEv(true)} style={{padding:"0 12px",background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,cursor:"pointer",fontSize:16,color:T.accent,flexShrink:0}} title="Auf Karte auswählen">📍</button>
              </div>
            </F>
            <F label="Straße" full><Inp T={T} value={f.adresse?.strasse||""} onChange={e=>sad("strasse",e.target.value)} placeholder="Musterstraße 1"/></F>
            <F label="PLZ"><Inp T={T} value={f.adresse?.plz||""} onChange={e=>{
              const plz=e.target.value;sad("plz",plz);
              if(plz.length===5){
                fetch(`https://api.zippopotam.us/de/${plz}`)
                  .then(r=>r.ok?r.json():null)
                  .then(d=>{if(d?.places?.[0])sad("ort",d.places[0]["place name"]);})
                  .catch(()=>{});
              }
            }} placeholder="12345" maxLength={5}/></F>
            <F label="Ort"><Inp T={T} value={f.adresse?.ort||""} onChange={e=>{
              const ort=e.target.value;sad("ort",ort);
              if(ort.length>=3){
                fetch(`https://api.zippopotam.us/de/${encodeURIComponent(ort)}`)
                  .catch(()=>{});
              }
            }} placeholder="Musterstadt"/></F>
            {_firmenkontakte.length>0&&(
            <F label="Kontakt aus Adressbuch" full>
              <select value="" onChange={e=>{
                const k=_firmenkontakte.find(x=>x.id===e.target.value);if(!k)return;
                setF(x=>({...x,kontakt:{ansprechpartner:[k.name,k.firma].filter(Boolean).join(" · "),telefon:k.handy||"",email:k.email||"",homepage:k.homepage||""}}));
              }} style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:"9px 12px",color:T.text,fontSize:13,fontFamily:"inherit",outline:"none",boxSizing:"border-box",width:"100%"}}>
                <option value="">– Kontakt wählen –</option>
                {_firmenkontakte.map(k=><option key={k.id} value={k.id}>{[k.name,k.firma].filter(Boolean).join(" · ")}</option>)}
              </select>
            </F>
            )}
            <F label="Ansprechpartner"><Inp T={T} value={f.kontakt?.ansprechpartner||""} onChange={e=>sk("ansprechpartner",e.target.value)} placeholder="Max Mustermann"/></F>
            <F label="Telefon"><Inp T={T} value={f.kontakt?.telefon||""} onChange={e=>sk("telefon",e.target.value)} placeholder="+49 123 456789"/></F>
            <F label="E-Mail"><Inp T={T} value={f.kontakt?.email||""} onChange={e=>sk("email",e.target.value)} placeholder="kontakt@veranstaltung.de"/></F>
            <F label="Homepage"><Inp T={T} value={f.kontakt?.homepage||""} onChange={e=>sk("homepage",e.target.value)} placeholder="www.veranstaltung.de"/></F>
            <F label="Fotoart"><Inp T={T} value={f.fotoart} onChange={e=>s("fotoart",e.target.value)} placeholder="Hundeshooting"/></F>
            <F label="Infos / Notizen" full><TA T={T} value={f.info||""} onChange={e=>s("info",e.target.value)} placeholder="Besonderheiten, Parkplatz, Zugang..."/></F>
          </FG>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:16,marginTop:16}}>
            <div style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:14}}>
              <div style={{fontSize:12,fontWeight:600,color:T.accent,marginBottom:10}}>💰 Preise {!event&&<span style={{fontSize:10,color:T.muted,fontWeight:400}}>· Vorgabe: {vorgabe}</span>}</div>
              {[["shootingGebuehr","Shootinggebühr €"],["preisWeitererHund","Aufpreis je weiterem Hund €"],["preisZusatzbild","Preis Zusatzbild €"],["bearbeitungPreis","Externe Bearbeitung €"],["bilderFrei","Bilder frei (Stk.)"]].map(([k,l])=>(
                <div key={k} style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
                  <span style={{fontSize:12,color:T.muted}}>{l}</span>
                  <input type="number" value={f.preise[k]} onChange={e=>sp(k,Number(e.target.value))} style={NI}/>
                </div>
              ))}
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginTop:8}}>
              </div>
              {!event&&<button style={{...btn(T,"ghost",true),marginTop:12,fontSize:11}} onClick={()=>setStep(0)}>← Vorgabe ändern</button>}
            </div>
            <div style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:14}}>
              <div style={{fontSize:12,fontWeight:600,color:T.accent,marginBottom:10}}>💸 Ausgaben</div>
              {[["stand","Standgebühr €"],["hotel","Hotel €"],["sprit","Sprit €"]].map(([k,l])=>(
                <div key={k} style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
                  <span style={{fontSize:12,color:T.muted}}>{l}</span>
                  <input type="number" value={f.ausgaben[k]} onChange={e=>sa(k,Number(e.target.value))} style={NI}/>
                </div>
              ))}
              <div style={{marginBottom:8}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:4}}>
                  <span style={{fontSize:12,color:T.muted}}>Mietwagen €</span>
                  <input type="number" value={f.ausgaben.mietwagen} onChange={e=>sa("mietwagen",Number(e.target.value))} style={NI}/>
                </div>
                <div style={{display:"flex",justifyContent:"flex-end"}}>
                  <input value={f.ausgaben.vermieter} onChange={e=>sa("vermieter",e.target.value)} placeholder="Leihfirma..." style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:6,padding:"4px 8px",color:T.text,fontSize:11,fontFamily:"inherit",outline:"none",width:140}}/>
                </div>
              </div>

            </div>
          </div>
          <div style={{display:"flex",justifyContent:"space-between",gap:10,marginTop:20}}>
            <div>
              {event&&onDelete&&<button style={{...btn(T,"ghost"),color:"#e53935",borderColor:"#e5393544"}} onClick={()=>{if(confirm("Veranstaltung wirklich löschen?"))onDelete(event.id);}}>🗑 Löschen</button>}
            </div>
            <div style={{display:"flex",gap:10}}>
              <button style={btn(T,"ghost")} onClick={onClose}>Abbrechen</button>
              <button style={btn(T,"primary")} onClick={()=>{if(!f.name||(!datumOptional&&!f.date))return;const preiseChanged=event&&event.preise&&(event.preise.shootingGebuehr!==f.preise.shootingGebuehr||event.preise.bilderFrei!==f.preise.bilderFrei);let teiln=f.teilnehmer||[];if(preiseChanged)teiln=teiln.map(t=>({...t,gebuehr:f.preise.shootingGebuehr,bilderFrei:f.preise.bilderFrei}));onSave({...f,id:f.id||uid(),teilnehmer:teiln,created:f.created||new Date().toISOString().slice(0,10),...(datumOptional?{interessenliste_event:true}:{})})}}>Speichern</button>
            </div>
          </div>
        </div>
      )}
    </Modal>
    {showKartenPickerEv&&<div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.75)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:300,padding:16}}>
      <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:14,padding:16,width:"100%",maxWidth:"90vw",height:"90vh",display:"flex",flexDirection:"column",gap:10}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <div style={{fontFamily:"Georgia,serif",fontSize:17,color:T.accent}}>📍 Location auswählen</div>
          <button onClick={()=>setShowKartenPickerEv(false)} style={{background:"none",border:"none",fontSize:18,cursor:"pointer",color:T.muted}}>✕</button>
        </div>
        <div style={{fontSize:12,color:T.muted}}>Klick auf einen Pin = übernehmen</div>
        <div style={{flex:1,minHeight:0,position:"relative"}}>
          <div id="bm_karte" style={{position:"absolute",inset:0,borderRadius:10,overflow:"hidden",border:`1px solid ${T.border}`}}/>
          <KartenPickerInner T={T} onSelect={(label,lat,lng)=>{s("location",label);s("locationLat",lat);s("locationLng",lng);setShowKartenPickerEv(false);}}/>
        </div>
      </div>
    </div>}
  </>);
}

// ── Teilnehmer Mail Modal ──────────────────────────────────────────────────────
// Merkt den Versand dort, wo der Termin tatsaechlich liegt. Einzeltermine
// stehen in sd_bookings, Buchungen aus dem Buchungsplan in sd_buchungen.
// Bisher wurde immer in sd_buchungen geschrieben - bei Einzelterminen ging
// der Eintrag damit ins Leere und war nach dem Schliessen wieder weg.
function mailVersandMerken(bookingId, eintrag, typ){
  if(!bookingId)return;
  const flagge = typ==="bildauswahl" ? "bilderLinkVerschickt"
               : typ==="fertige_bilder" ? "bilderFertig" : null;
  const heute=new Date().toISOString().slice(0,10);
  for(const schluessel of ["sd_bookings","sd_buchungen"]){
    try{
      const alle=JSON.parse(localStorage.getItem(schluessel)||"[]");
      if(!Array.isArray(alle))continue;
      const i=alle.findIndex(b=>b&&b.id===bookingId);
      if(i<0)continue;
      const neu={...alle[i],mailLog:[...(alle[i].mailLog||[]),eintrag]};
      if(flagge&&!neu[flagge]){
        neu[flagge]=true;
        neu[flagge+"Datum"]=heute;
      }
      alle[i]=neu;
      localStorage.setItem(schluessel,JSON.stringify(alle));
    }catch(e){}
  }
}

function BuchungsMailModal({booking,customer,onClose,T}){
  const cfg=(()=>{try{return JSON.parse(localStorage.getItem("sd_buchung_config")||"{}");} catch{return {};}})();
  const vorlagen=(()=>{try{return JSON.parse(localStorage.getItem("sd_email_vorlagen")||"{}");} catch{return {};}})();
  const smtp=(()=>{try{return JSON.parse(localStorage.getItem("sd_smtp_buchung")||localStorage.getItem("sd_smtp_settings")||"{}");} catch{return {};}})();
  const sig=(()=>{try{return JSON.parse(localStorage.getItem("sd_email_sig")||"null")||{text:"",logo:""};} catch{return {text:"",logo:""};}})();
  const studio=cfg.studioName||"Markus Heber Photography";
  const srvUrl=(localStorage.getItem("sd_server_url")||"").replace(/\/+$/,"");
  const anzeigeName=customer?.name||"";
  const vorname=anzeigeName.trim().split(/\s+/)[0]||"";
  const aktuelleEmail=customer?.email||"";
  const datum=booking?.date?(()=>{try{return new Date(booking.date).toLocaleDateString("de-DE",{weekday:"long",day:"2-digit",month:"2-digit",year:"numeric"});}catch{return booking.date;}})():"";
  const ort=booking?.location||"";
  const event=booking?.shootingType||booking?.eventName||"";

  const TYPEN={
    bildauswahl:{label:"Bildauswahl",vlKey:"bildauswahl",defBetreff:`Dein Zugangslink zur Bildauswahl`,defText:`Hallo {{vorname}},\n\nhier ist dein persönlicher Zugangslink zur Bildauswahl:\n{{link}}\n\nHerzliche Grüße\n{{studio}}`},
    fertige_bilder:{label:"Fertige Bilder",vlKey:"fertige_bilder",defBetreff:`Deine fertigen Bilder`,defText:`Hallo {{vorname}},\n\ndeine Bilder sind fertig!\n\nHier ist dein Download-Link:\n{{link}}\n\nHerzliche Grüße\n{{studio}}`},
  };

  // Je nach Mailart die passende Galerie. Fehlt sie, greift das alte
  // gemeinsame Feld, damit bestehende Termine weiter funktionieren.
  // Die Art wird uebergeben, weil beim Umschalten der Zustand noch der
  // alte waere und dann der falsche Link eingesetzt wuerde.
  function linkFuerTyp(t){
    return t==="fertige_bilder"
      ? (booking?.galerieDownload||booking?.galerie||"")
      : (booking?.galerieFeedback||booking?.galerie||"");
  }

  function replacePlatzhalter(str,t){
    const art=t||typ;
    return (str||"").replace(/\{\{vorname\}\}/g,vorname).replace(/\{\{name\}\}/g,anzeigeName).replace(/\{\{datum\}\}/g,datum).replace(/\{\{ort\}\}/g,ort).replace(/\{\{event\}\}/g,event).replace(/\{\{link\}\}/g,linkFuerTyp(art)).replace(/\{\{studio\}\}/g,studio);
  }

  const [typ,setTyp]=useState("bildauswahl");
  const aktTyp=TYPEN[typ];
  const vl=vorlagen[aktTyp.vlKey]||{};
  const [betreff,setBetreff]=useState(()=>replacePlatzhalter(vl.betreff||aktTyp.defBetreff));
  const [text,setText]=useState(()=>replacePlatzhalter(vl.text||aktTyp.defText));
  // Galerien vom Server holen, nach Möglichkeit auf diesen Kunden gefiltert.
  // Passt nichts, werden die neuesten angeboten - besser als eine leere Leiste.
  const [galerien,setGalerien]=useState([]);
  const [galSuche,setGalSuche]=useState(false);
  useEffect(()=>{
    let weg=false;
    fetch(srvUrl+"/api/galerie/alle").then(r=>r.json()).then(d=>{
      if(weg||!Array.isArray(d))return;
      const nam=(anzeigeName||"").toLowerCase().trim();
      const vor=(vorname||"").toLowerCase().trim();
      const treffer=d.filter(g=>{
        const t=((g.titel||"")+" "+(g.vorname||"")).toLowerCase();
        return (nam&&t.includes(nam))||(vor&&vor.length>2&&t.includes(vor));
      });
      setGalSuche(treffer.length>0);
      setGalerien(treffer.length?treffer:d.slice(0,8));
    }).catch(()=>{});
    return()=>{weg=true;};
  },[srvUrl,anzeigeName,vorname]);

  const linkEinsetzen=g=>{
    const url=srvUrl.replace(/\/+$/,"")+"/galerie/"+g.token;
    setText(t=>{
      if(t.indexOf("{{link}}")>=0)return t.split("{{link}}").join(url);
      if(t.indexOf(url)>=0)return t;                        // schon drin
      return t.replace(/\s+$/,"")+"\n\n"+url;
    });
  };
  const [w,setW]=useState(()=>parseInt(localStorage.getItem("sd_mailmodal_w")||"580"));
  const [taH,setTaH]=useState(()=>parseInt(localStorage.getItem("sd_mailmodal_tah")||"200"));
  const [sending,setSending]=useState(false);
  const [result,setResult]=useState(null);
  const [kopieAnMich,setKopieAnMich]=useState(()=>localStorage.getItem("sd_mail_kopie")==="1");
  const [mailLog,setMailLog]=useState((()=>{
    for(const k of ["sd_bookings","sd_buchungen"]){
      try{
        const alle=JSON.parse(localStorage.getItem(k)||"[]");
        const bk=Array.isArray(alle)?alle.find(b=>b&&b.id===booking?.id):null;
        if(bk)return bk.mailLog||[];
      }catch(e){}
    }
    return [];
  })());

  function wechselTyp(neuerTyp){
    setTyp(neuerTyp);
    const nt=TYPEN[neuerTyp];
    const nvl=vorlagen[nt.vlKey]||{};
    setBetreff(replacePlatzhalter(nvl.betreff||nt.defBetreff,neuerTyp));
    setText(replacePlatzhalter(nvl.text||nt.defText,neuerTyp));
    setResult(null);
  }

  function startResize(e){
    e.preventDefault();
    const startX=e.clientX,startW=w;
    const onMove=mv=>{const nw=Math.max(420,Math.min(1100,startW+(mv.clientX-startX)));setW(nw);localStorage.setItem("sd_mailmodal_w",String(nw));};
    const onUp=()=>{window.removeEventListener("mousemove",onMove);window.removeEventListener("mouseup",onUp);};
    window.addEventListener("mousemove",onMove);window.addEventListener("mouseup",onUp);
  }

  async function senden(){
    if(!aktuelleEmail){alert("Keine E-Mail-Adresse vorhanden.");return;}
    if(!smtp.host||!smtp.user||!smtp.pass){alert("SMTP-Einstellungen fehlen.");return;}
    setSending(true);setResult(null);
    try{
      const html=buildScattoDeskMailHtml(text,sig.logo,sig.text);
      const r=await fetch(`${srvUrl}/api/newsletter`,{method:"POST",headers:{"Content-Type":"application/json"},
        body:JSON.stringify({smtp,recipients:[{name:anzeigeName,email:aktuelleEmail},...(kopieAnMich&&smtp.from_email?[{name:"Kopie",email:smtp.from_email}]:[])],subject:betreff,text,html,logo:sig.logo||""})});
      const d=await r.json();
      if(d.ok||d.sent>0){
        setResult("✅ Mail erfolgreich gesendet.");
        const neuerEintrag={typ,datum:new Date().toISOString()};
        setMailLog(prev=>[...prev,neuerEintrag]);
        mailVersandMerken(booking?.id,neuerEintrag,typ);
      }else{setResult(`❌ Fehler: ${d.error||"Unbekannter Fehler"}`);}
    }catch{setResult("❌ Server nicht erreichbar.");}
    setSending(false);
  }

  return(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.78)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:200,padding:20}}>
      <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:16,padding:24,width:w,maxWidth:"95vw",maxHeight:"90vh",overflowY:"auto",position:"relative"}}>
        <div onMouseDown={startResize} style={{position:"absolute",top:0,right:0,width:6,height:"100%",cursor:"ew-resize",zIndex:10,background:`linear-gradient(to right, transparent, ${T.border})`}}/>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:12}}>
          <div>
            <div style={{fontFamily:"Georgia,serif",fontSize:17,color:T.accent,marginBottom:4}}>📧 Mail an {anzeigeName}</div>
            <div style={{fontSize:12,color:T.muted}}>{aktuelleEmail} · {datum}</div>
          </div>
          {sig.logo&&<img src={sig.logo} alt="Logo" style={{height:48,objectFit:"contain"}}/>}
        </div>
        {/* Was schon rausgegangen ist, gehört nach oben - unten grau war es
            leicht zu übersehen. Je Mailart zählt der letzte Versand. */}
        {mailLog.length>0&&(()=>{
          const letzte={};
          mailLog.forEach(m=>{letzte[m.typ]=m.datum;});
          return(
            <div style={{marginBottom:14,padding:"9px 13px",background:"#6dbf6a18",
                         border:"1px solid #6dbf6a55",borderRadius:8,fontSize:12,
                         color:T.text,lineHeight:1.7}}>
              <span style={{fontWeight:600}}>📬 Bereits gesendet</span>
              {Object.entries(letzte).map(([k,d])=>(
                <div key={k} style={{color:T.muted}}>
                  {TYPEN[k]?.label||k} — {new Date(d).toLocaleString("de-DE",
                    {day:"2-digit",month:"2-digit",year:"numeric",hour:"2-digit",minute:"2-digit"})} Uhr
                  {mailLog.filter(m=>m.typ===k).length>1&&
                    " · "+mailLog.filter(m=>m.typ===k).length+"× verschickt"}
                </div>
              ))}
            </div>
          );
        })()}
        <div style={{display:"flex",gap:8,marginBottom:16,flexWrap:"wrap"}}>
          {Object.entries(TYPEN).map(([k,v])=>(
            <button key={k} onClick={()=>wechselTyp(k)} style={{padding:"6px 14px",borderRadius:20,border:`2px solid ${typ===k?T.accent:T.border}`,background:typ===k?T.accentDim:"transparent",color:typ===k?T.accent:T.muted,cursor:"pointer",fontSize:13,fontWeight:typ===k?700:400,fontFamily:"inherit"}}>{v.label}</button>
          ))}
        </div>
        <div style={{marginBottom:10}}>
          <label style={{fontSize:11,color:T.muted,fontWeight:600,display:"block",marginBottom:4}}>BETREFF</label>
          <input value={betreff} onChange={e=>setBetreff(e.target.value)} style={{width:"100%",background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:"10px 14px",color:T.text,fontSize:14,fontFamily:"inherit",outline:"none",boxSizing:"border-box"}}/>
        </div>
        <div style={{fontSize:11,color:T.muted,marginBottom:4,fontWeight:600}}>TEXT — Vorlage: Einstellungen → E-Mail Vorlagen → "{aktTyp.label}"</div>
        <textarea value={text} onChange={e=>setText(e.target.value)} onMouseUp={e=>{{const h=e.target.offsetHeight;setTaH(h);localStorage.setItem("sd_mailmodal_tah",String(h));} }} style={{width:"100%",minHeight:taH,height:taH,background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:"10px 14px",color:T.text,fontSize:13,fontFamily:"inherit",outline:"none",resize:"vertical",lineHeight:1.6,boxSizing:"border-box"}}/>
        <div style={{fontSize:11,color:T.muted,marginTop:4,lineHeight:1.6}}>
          Platzhalter: {"{{vorname}} {{name}} {{event}} {{datum}} {{ort}} {{link}} {{studio}}"}
          {" — doppelte geschweifte Klammern, sonst bleibt der Text stehen."}
        </div>
        {/* Galerien des Kunden anbieten, damit die Adresse nicht von Hand
            kopiert werden muss. Feedback und Download werden getrennt
            ausgewiesen, weil je nach Mailart die andere gemeint ist. */}
        {galerien.length>0&&(
          <div style={{marginTop:10,background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:"9px 12px"}}>
            <div style={{fontSize:11,color:T.muted,marginBottom:6}}>
              Galerie einsetzen {galSuche?"":"(alle auf dem Server)"}
            </div>
            <div style={{display:"flex",flexWrap:"wrap",gap:6}}>
              {galerien.slice(0,8).map(g=>{
                const istFeedback=(g.typ||"")==="feedback";
                const passt=(typ==="bildauswahl")===istFeedback;
                return(
                  <button key={g.token} onClick={()=>linkEinsetzen(g)}
                    title={(istFeedback?"Feedback-Galerie":"Download-Galerie")+" · "+(g.titel||g.token)}
                    style={{border:`1px solid ${passt?T.accent:T.border}`,background:passt?T.accent+"14":"transparent",
                            color:passt?T.accent:T.muted,borderRadius:16,padding:"4px 11px",fontSize:11,
                            cursor:"pointer",fontFamily:"inherit",maxWidth:230,overflow:"hidden",
                            textOverflow:"ellipsis",whiteSpace:"nowrap"}}>
                    {istFeedback?"👍 ":"⬇️ "}{g.titel||g.token}
                  </button>
                );
              })}
            </div>
            <div style={{fontSize:10,color:T.muted,marginTop:6,lineHeight:1.5}}>
              Der Knopf ersetzt {"{{link}}"} beziehungsweise hängt die Adresse unten an.
              Farbig markiert ist die Art, die zur gewählten Mail passt.
            </div>
          </div>
        )}
        {/* Ein Link kann als Platzhalter drinstehen oder von Hand eingesetzt
            sein - je nachdem ob es zur Feedback- oder zur Downloadgalerie
            geht. Gewarnt wird nur, wenn gar keiner da ist. */}
        {(text.indexOf("{{link}}")<0&&!/https?:\/\//.test(text))&&(
          <div style={{fontSize:12,color:"#e67e22",marginTop:6,lineHeight:1.6}}>
            Im Text steht kein Link. Setz die Adresse der Galerie ein oder benutze {"{{link}}"}.
          </div>
        )}
        {(text.indexOf("{{link}}")>=0&&!linkFuerTyp(typ))&&(
          <div style={{fontSize:12,color:"#e67e22",marginTop:6,lineHeight:1.6}}>
            {"{{link}}"} steht im Text, beim Termin ist aber kein Galerie-Link hinterlegt.
            Die Stelle bliebe leer.
          </div>
        )}
                {result&&<div style={{marginTop:10,padding:"8px 12px",borderRadius:8,fontSize:13,background:result.startsWith("✅")?T.success+"22":T.danger+"22",color:result.startsWith("✅")?T.success:T.danger}}>{result}</div>}
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginTop:16}}>
          <div style={{display:"flex",alignItems:"center",gap:12,flexWrap:"wrap"}}>
            <label style={{display:"flex",alignItems:"center",gap:8,cursor:"pointer",fontSize:13}}>
              <input type="checkbox" checked={kopieAnMich} onChange={e=>{setKopieAnMich(e.target.checked);localStorage.setItem("sd_mail_kopie",e.target.checked?"1":"0");}} style={{accentColor:T.accent}}/>
              Kopie an mich
            </label>
            <button onClick={()=>{
              const neuerEintrag={typ,datum:new Date().toISOString()};
              setMailLog(prev=>[...prev,neuerEintrag]);
              mailVersandMerken(booking?.id,neuerEintrag,typ);
              setResult("✅ Als gesendet markiert.");
            }} style={{padding:"6px 14px",borderRadius:8,border:`1px solid ${T.border}`,background:"transparent",color:T.muted,cursor:"pointer",fontSize:12,fontFamily:"inherit"}}>✓ Gesendet</button>
          </div>
          <div style={{display:"flex",gap:8}}>
            <button onClick={onClose} style={{padding:"8px 18px",borderRadius:8,border:`1px solid ${T.border}`,background:"transparent",color:T.muted,cursor:"pointer",fontSize:13,fontFamily:"inherit"}}>Schließen</button>
            <button onClick={senden} disabled={sending} style={{padding:"8px 20px",borderRadius:8,border:"none",background:T.accent,color:"#fff",cursor:"pointer",fontSize:13,fontWeight:700,fontFamily:"inherit",opacity:sending?0.7:1}}>📤 {sending?"Sendet...":"Senden"}</button>
          </div>
        </div>
      </div>
    </div>
  );
}

function TeilnehmerMailModal({teilnehmer,ev,zugangLink,onMailGesendet,onClose,T}){
  const t=teilnehmer;
  const cfg=(()=>{try{return JSON.parse(localStorage.getItem("sd_buchung_config")||"{}");}catch{return {};}})();
  const vorlagen=(()=>{try{return JSON.parse(localStorage.getItem("sd_email_vorlagen")||"{}");}catch{return {};}})();
  const smtp=(()=>{try{const s=JSON.parse(localStorage.getItem("sd_smtp_info")||localStorage.getItem("sd_smtp_buchung")||localStorage.getItem("sd_smtp_settings")||"{}");return {...s,from_email:"info@m-h-photo.de"};}catch{return {};}})();
  const sig=(()=>{try{return JSON.parse(localStorage.getItem("sd_email_sig")||"null")||{text:"",logo:""};}catch{return {text:"",logo:""};} })();
  const studio=cfg.studioName||"Markus Heber Photography";
  const srvUrl=(localStorage.getItem("sd_server_url")||"http://167.233.88.11").replace(/\/+$/,"");
  const datum=ev.date?(()=>{try{return new Date(ev.date).toLocaleDateString("de-DE",{weekday:"long",day:"2-digit",month:"2-digit",year:"numeric"});}catch{return ev.date;}})():"";
  // Name aus Kundenliste übernehmen wenn Match per Email oder Name
  // Vorname = erstes Wort (Vorname Nachname einheitlich)
  const anzeigeName=t.name||"";
  const vorname=anzeigeName.trim().split(/\s+/)[0]||"";
  const allKunden=(()=>{try{return JSON.parse(localStorage.getItem("sd_customers")||"[]");}catch{return [];}})();
  const kundeMatch=allKunden.find(k=>(k.email&&t.email&&k.email.toLowerCase()===t.email.toLowerCase())||(k.name&&t.name&&k.name.toLowerCase()===t.name.toLowerCase()));
  const aktuelleEmail=kundeMatch?.email||t.email||"";

  const TYPEN={
    bildauswahl:{key:"bildauswahl",label:"📂 Bildauswahl",vlKey:"bildauswahl",
      defBetreff:`Dein Zugangslink zur Bildauswahl – ${ev.name||""}`,
      defText:`Hallo {{vorname}},\n\nhier ist dein persönlicher Zugangslink zur Bildauswahl:\n{{link}}\n\nHerzliche Grüße\n{{studio}}`},
    fertige_bilder:{key:"fertige_bilder",label:"🖼 Fertige Bilder",vlKey:"fertige_bilder",
      defBetreff:`Deine fertigen Bilder – ${ev.name||""}`,
      defText:`Hallo {{vorname}},\n\ndeine Bilder vom Fototermin "${ev.name||""}" am ${datum} sind fertig!\n\nHier ist dein persönlicher Zugangslink:\n{{link}}\n\nHerzliche Grüße\n{{studio}}`},
  };

  function replacePlatzhalter(str){
    return (str||"")
      .replace(/\{\{vorname\}\}/g,vorname)
      .replace(/\{\{name\}\}/g,anzeigeName)
      .replace(/\{\{(event|shooting|veranstaltung)\}\}/g,ev.name||"")
      .replace(/\{\{datum\}\}/g,datum)
      .replace(/\{\{link\}\}/g,zugangLink||"")
      .replace(/\{\{studio\}\}/g,studio);
  }

  const [typ,setTyp]=useState("bildauswahl");
  const aktTyp=TYPEN[typ];
  const vl=vorlagen[aktTyp.vlKey]||{};

  // Signatur an Text anhängen
  const sigText=sig.text||"";

  const [betreff,setBetreff]=useState(()=>replacePlatzhalter(vl.betreff||aktTyp.defBetreff));
  const [text,setText]=useState(()=>replacePlatzhalter(vl.text||aktTyp.defText));
  // Breite aus localStorage
  const [w,setW]=useState(()=>parseInt(localStorage.getItem("sd_mailmodal_w")||"580"));
  const [h,setH]=useState(()=>parseInt(localStorage.getItem("sd_mailmodal_h")||"420"));
  const [sending,setSending]=useState(false);
  const [result,setResult]=useState(null);
  const [kopieAnMich,setKopieAnMich]=useState(()=>localStorage.getItem("sd_mail_kopie")==="1");

  // Wenn Typ wechselt, Betreff+Text neu setzen
  function wechselTyp(neuerTyp){
    setTyp(neuerTyp);
    const nt=TYPEN[neuerTyp];
    const nvl=vorlagen[nt.vlKey]||{};
    setBetreff(replacePlatzhalter(nvl.betreff||nt.defBetreff));
    setText(replacePlatzhalter(nvl.text||nt.defText));
    setResult(null);
  }

  function startResize(e){
    e.preventDefault();
    const startX=e.clientX,startW=w;
    const onMove=mv=>{
      const nw=Math.max(420,Math.min(1100,startW+(mv.clientX-startX)));
      setW(nw);
      localStorage.setItem("sd_mailmodal_w",String(nw));
    };
    const onUp=()=>{window.removeEventListener("mousemove",onMove);window.removeEventListener("mouseup",onUp);};
    window.addEventListener("mousemove",onMove);
    window.addEventListener("mouseup",onUp);
  }

  function startResizeH(e){
    e.preventDefault();
    const startY=e.clientY,startH=h;
    const onMove=mv=>{
      const nh=Math.max(200,Math.min(800,startH+(mv.clientY-startY)));
      setH(nh);
      localStorage.setItem("sd_mailmodal_h",String(nh));
    };
    const onUp=()=>{window.removeEventListener("mousemove",onMove);window.removeEventListener("mouseup",onUp);};
    window.addEventListener("mousemove",onMove);
    window.addEventListener("mouseup",onUp);
  }

  async function senden(){
    if(!aktuelleEmail){alert("Keine E-Mail-Adresse vorhanden.");return;}
    if(!smtp.host||!smtp.user||!smtp.pass){alert("SMTP-Einstellungen fehlen. Bitte unter Einstellungen → E-Mail konfigurieren.");return;}
    setSending(true);setResult(null);
    try{
      const html=buildScattoDeskMailHtml(text,sig.logo,sig.text);
      const r=await fetch(`${srvUrl}/api/newsletter`,{
        method:"POST",headers:{"Content-Type":"application/json"},
        body:JSON.stringify({smtp,recipients:[{name:anzeigeName||t.name||"",email:aktuelleEmail},...(kopieAnMich&&(smtp.from_email||smtp.user)?[{name:"Kopie",email:smtp.from_email||smtp.user}]:[])],subject:betreff,text,html,logo:sig.logo||""})
      });
      const d=await r.json();
      if(d.ok||d.sent>0){
        setResult("✅ Mail erfolgreich gesendet.");
        const neuerEintrag={typ,datum:new Date().toISOString()};
        setMailLog(prev=>[...prev,neuerEintrag]);
        onMailGesendet(typ);
        // Mail beim Kunden loggen
        try{
          const allK=(()=>{try{return JSON.parse(localStorage.getItem("sd_customers")||"[]");}catch{return [];}})();
          const kd=allK.find(k=>k.email&&k.email.toLowerCase()===(aktuelleEmail||"").toLowerCase());
          if(kd){
            const lk="sd_mail_log_"+kd.id;
            const best=(()=>{try{return JSON.parse(localStorage.getItem(lk)||"[]");}catch{return [];}})();
            localStorage.setItem(lk,JSON.stringify([{id:uid(),typ,betreff,datum:new Date().toISOString(),event:ev.name||""},...best]));
          }
        }catch{}
      }else{
        setResult(`❌ Fehler: ${d.error||"Unbekannter Fehler"}`);
      }
    }catch{setResult("❌ Server nicht erreichbar.");}
    setSending(false);
  }

  const [mailLog,setMailLog]=useState(t.mailLog||[]);

  return(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.78)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:200,padding:20}}>
      <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:16,padding:24,width:w,maxWidth:"95vw",maxHeight:"90vh",overflowY:"auto",position:"relative"}}>
        <div onMouseDown={startResize} style={{position:"absolute",top:0,right:0,width:6,height:"100%",cursor:"ew-resize",zIndex:10,background:`linear-gradient(to right, transparent, ${T.border})`}}/>

        <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:12}}>
          <div>
            <div style={{fontFamily:"Georgia,serif",fontSize:17,color:T.accent,marginBottom:4}}>📧 Mail an {anzeigeName}</div>
            <div style={{fontSize:12,color:T.muted}}>{aktuelleEmail||"Keine E-Mail-Adresse"} · {ev.name} · {datum}</div>
          </div>
          {sig.logo&&<img src={sig.logo} style={{maxHeight:48,maxWidth:120,borderRadius:4,objectFit:"contain"}} alt="Logo"/>}
        </div>

        {/* Mail-Log */}
        {mailLog.length>0&&(()=>{
          const letztePerTyp={};
          mailLog.forEach(m=>{letztePerTyp[m.typ]=m.datum;});
          return(
            <div style={{marginBottom:12,padding:"9px 13px",background:"#6dbf6a18",borderRadius:8,border:"1px solid #6dbf6a55",fontSize:12,lineHeight:1.7,color:T.text}}>
              <span style={{fontWeight:600}}>📬 Bereits gesendet</span>
              {Object.entries(letztePerTyp).map(([t,datum])=>(
                <div key={t} style={{color:T.muted}}>
                  {t==="bildauswahl"?"📂 Bildauswahl":"🖼 Fertige Bilder"} — {new Date(datum).toLocaleString("de-DE",
                    {day:"2-digit",month:"2-digit",year:"numeric",hour:"2-digit",minute:"2-digit"})} Uhr
                  {mailLog.filter(m=>m.typ===t).length>1&&
                    " · "+mailLog.filter(m=>m.typ===t).length+"× verschickt"}
                </div>
              ))}
            </div>
          );
        })()}

        {/* Typ-Auswahl */}
        <div style={{display:"flex",gap:8,marginBottom:16}}>
          {Object.values(TYPEN).map(ty=>(
            <button key={ty.key} style={{...btn(T,typ===ty.key?"primary":"ghost",true),opacity:typ===ty.key?1:0.6}} onClick={()=>wechselTyp(ty.key)}>{ty.label}</button>
          ))}
        </div>

        <div style={{marginBottom:10}}>
          <label style={{fontSize:11,color:T.muted,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.07em",display:"block",marginBottom:4}}>Betreff</label>
          <input value={betreff} onChange={e=>setBetreff(e.target.value)}
            style={{width:"100%",background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:"9px 12px",color:T.text,fontSize:13,fontFamily:"inherit",outline:"none",boxSizing:"border-box"}}/>
        </div>

        <div style={{marginBottom:14}}>
          <label style={{fontSize:11,color:T.muted,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.07em",display:"block",marginBottom:4}}>
            Text <span style={{fontWeight:400,textTransform:"none",fontSize:10}}>— Vorlage: Einstellungen → E-Mail Vorlagen → "{aktTyp.label}"</span>
          </label>
          <textarea value={text} onChange={e=>setText(e.target.value)}
            style={{width:"100%",background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:"9px 12px",color:T.text,fontSize:13,fontFamily:"inherit",outline:"none",resize:"none",lineHeight:1.6,boxSizing:"border-box",height:h}}/>
          <div onMouseDown={startResizeH} style={{height:4,cursor:"ns-resize",marginBottom:2}}/>
          <div style={{fontSize:10,color:T.muted,marginTop:3}}>{"{{vorname}} {{name}} {{event}} {{datum}} {{link}} {{studio}}"} · **fett**</div>
        </div>

        {result&&<div style={{padding:"10px 14px",borderRadius:8,fontSize:13,marginBottom:12,background:result.startsWith("✅")?"#6dbf6a22":"#e5333322",color:result.startsWith("✅")?"#3a7a38":"#c0655a"}}>{result}</div>}

        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",gap:10,flexWrap:"wrap"}}>
          <button style={{...btn(T,"ghost"),fontSize:12}} onClick={()=>{
            const neuerEintrag={typ,datum:new Date().toISOString()};
            setMailLog(prev=>[...prev,neuerEintrag]);
            onMailGesendet(typ);
            setResult("✅ Als gesendet markiert.");
          }}>
            ✅ Als gesendet markieren
          </button>
          <div style={{display:"flex",alignItems:"center",gap:16,flexWrap:"wrap"}}>
            <label style={{display:"flex",alignItems:"center",gap:6,fontSize:12,color:T.muted,cursor:"pointer"}}>
              <input type="checkbox" checked={kopieAnMich} onChange={e=>{setKopieAnMich(e.target.checked);localStorage.setItem("sd_mail_kopie",e.target.checked?"1":"0");}} style={{accentColor:T.accent}}/>
              Kopie an mich
            </label>
            <div style={{display:"flex",gap:8,marginLeft:"auto"}}>
              <button style={btn(T,"ghost")} onClick={onClose}>Schließen</button>
              <button style={btn(T,"primary")} onClick={senden} disabled={sending||!t.email}>
                {sending?"⏳ Wird gesendet...":"📧 Senden"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// ── Event Detail (Teilnehmerliste + Abrechnung) ────────────────────────────────
function calcEvent(ev){
  const {preise,ausgaben,pictrs,partnerPct,teilnehmer}=ev;
  const bilderFrei=teilnehmer.reduce((s,t)=>s+(t.bilderFrei||0),0);
  const bilderZusatz=teilnehmer.reduce((s,t)=>s+(t.bilderZusatz||0),0);
  const bilderGesamt=bilderFrei+bilderZusatz;
  const shootingSumme=teilnehmer.reduce((s,t)=>s+(t.gebuehr||0),0);
  const zusatzEinnahme=bilderZusatz*(preise.preisZusatzbild||0);
  // Paketpreis: Pauschale statt Einzelabrechnung. Ersetzt bei dieser Zeile
  // Gebuehr und Zusatzbilder nicht, sondern kommt als eigener Betrag dazu.
  const paketSumme=teilnehmer.reduce((s,t)=>s+(Number(t.paket)||0),0);
  const gesamtEinnahme=shootingSumme+zusatzEinnahme+paketSumme+(pictrs||0);
  const bearbeitung=bilderGesamt*(preise.bearbeitungPreis||0);
  const gesamtAusgabe=(ausgaben.stand||0)+(ausgaben.hotel||0)+(ausgaben.mietwagen||0)+(ausgaben.sprit||0)+bearbeitung;
  const ertrag=gesamtEinnahme-gesamtAusgabe;
  const externPct=ev.externPct||0;
  const externBetrag=ertrag*(externPct/100);
  const auszahlung=ertrag-externBetrag;
  // Zusatzzeilen weiterer Tiere sind keine eigenen Kunden. Sie tragen die
  // Kennung der ersten Zeile mit angehaengter Nummer und haben keinen Namen.
  const kunden=teilnehmer.filter(t=>!/^online_.+_\d+$/.test(String(t.id||""))).length;
  return{bilderFrei,bilderZusatz,bilderGesamt,shootingSumme,zusatzEinnahme,paketSumme,gesamtEinnahme,bearbeitung,gesamtAusgabe,ertrag,externBetrag,auszahlung,kunden,durchschnitt:kunden?gesamtEinnahme/kunden:0};
}

function EventDetail({event,onUpdate,onBack,T,onOpenPlan}){
  const [sevProg,setSevProg]=useState(null);
  async function startAbrSevDesk(){
    const token=(JSON.parse(localStorage.getItem("sd_api_settings")||"{}").sevdesk_token||"").trim();
    if(!token){alert("Bitte zuerst den sevDesk API Token unter Einstellungen hinterlegen.");return;}
    const selected=ev.teilnehmer.filter(t=>t._selected&&t.name?.trim());
    const toSend=selected.length>0?selected:ev.teilnehmer.filter(t=>t.name?.trim());
    if(toSend.length===0){alert("Keine Teilnehmer mit Namen vorhanden.");return;}
    if(!confirm(`${toSend.length} ${selected.length>0?"markierte ":""}Teilnehmer an sevDesk übertragen?\nVorhandene Kontakte werden übersprungen, neue werden mit Anrede, Name, Adresse, Telefon und E-Mail angelegt.`))return;
    setSevProg({ok:[],skip:[],err:[],total:toSend.length});
    const results=await sevDeskUebertragen(toSend,token,r=>setSevProg({...r,total:toSend.length}));
    setSevProg({...results,total:toSend.length,done:true});
  }
  const [sortField,setSortField]=useState(null);
  const [sortDir,setSortDir]=useState(1); // 1=asc, -1=desc
  function toggleSort(field){setSortField(f=>f===field?(setSortDir(d=>-d),field):field);if(sortField!==field)setSortDir(1);}
  const [evColW,startEvResize]=useColW("sd_cols_abrechnung",{sel:34,nr:50,name:160,rasse:130,gebuehr:80,frei:55,zusatz:60,extra:75,paket:85,summe:80,bestelldatum:100,rechnung:75,bezahlt:70,fertig:60,verschickt:85,info:60,del:44});
  // Kopfzeile getrennt einstellbar, damit lange Beschriftungen umbrechen koennen.
  const [kopfFont,setKopfFont]=useState(()=>Number(localStorage.getItem("sd_abr_kopf_font"))||12);
  const [kopfHoehe,setKopfHoehe]=useState(()=>Number(localStorage.getItem("sd_abr_kopf_hoehe"))||38);
  const [abrFont,setAbrFont]=useState(()=>{const v=parseInt(localStorage.getItem("sd_abr_fontsize")||"",10);return(Number.isFinite(v)&&v>=14)?v:16;});
  useEffect(()=>{localStorage.setItem("sd_abr_fontsize",String(abrFont));},[abrFont]);
  const [ev,setEv]=useState(event);
  const [editModal,setEditModal]=useState(false);
  const [addRow,setAddRow]=useState(false);
  const [nameAutoSugg,setNameAutoSugg]=useState([]);
  const allKunden=(()=>{try{return JSON.parse(localStorage.getItem("sd_customers")||"[]");}catch{return [];}})();
  const [infoFor,setInfoFor]=useState(null);
  const [mailFor,setMailFor]=useState(null);
  const [editTeil,setEditTeil]=useState(null);
  const [externPct,setExternPct]=useState(ev.externPct||0);
  const [externName,setExternName]=useState(ev.externName||"");
  const [newT,setNewT]=useState({nr:"",name:"",hund:"",gebuehr:ev.preise.shootingGebuehr,bilderFrei:ev.preise.bilderFrei,bilderZusatz:0,bestelldatum:"",rechnung:false,bezahlt:false,bilderFertig:false,bilderVerschickt:false,info:"",notiz:""});

  function saveEv(updated){setEv(updated);onUpdate(updated);setEditModal(false);}
  function updateTeilnehmer(updated){const e={...ev,teilnehmer:updated};setEv(e);onUpdate(e);}
  function toggleCheck(tid,field){
    const t0=ev.teilnehmer.find(t=>t.id===tid);
    if(!t0)return;
    const newVal=!t0[field];
    const name0=(t0.name||'').trim().toLowerCase();
    const statusFelder=['rechnung','bezahlt','bilderFertig','bilderVerschickt','auswahlVerschickt','keinAuftrag'];
    // Beim Anhaken das Datum festhalten, beim Abhaken wieder entfernen.
    const heute=new Date().toISOString().slice(0,10);
    const setzen=t=>{
      const n={...t,[field]:newVal};
      if(['bilderVerschickt','auswahlVerschickt','bilderFertig','rechnung','bezahlt'].includes(field)){
        n[field+"Datum"]=newVal?(t[field+"Datum"]||heute):"";
      }
      return n;
    };
    if(statusFelder.includes(field)&&name0){
      updateTeilnehmer(ev.teilnehmer.map(t=>(t.name||'').trim().toLowerCase()===name0?setzen(t):t));
    }else{
      updateTeilnehmer(ev.teilnehmer.map(t=>t.id===tid?setzen(t):t));
    }
  }
  function updateField(tid,field,val){
    updateTeilnehmer(ev.teilnehmer.map(t=>t.id===tid?{...t,[field]:val}:t));
    // Auch in Shootingplan-Rows speichern
    try{
      const plaene=JSON.parse(localStorage.getItem("sd_shootingplaene")||"{}");
      const rows=Array.isArray(plaene[ev.id])?plaene[ev.id]:[];
      const t0=ev.teilnehmer.find(t=>t.id===tid);
      if(t0){
        const updated=rows.map(r=>(r.name||"").trim().toLowerCase()===(t0.name||"").trim().toLowerCase()||r.id===tid?{...r,[field]:val}:r);
        plaene[ev.id]=updated;
        localStorage.setItem("sd_shootingplaene",JSON.stringify(plaene));
        // Auch zum Server syncen
        const su=(localStorage.getItem("sd_server_url")||"").trim().replace(/\/+$/,"");
        if(su)fetch(su+"/api/shootingplaene",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(plaene)}).catch(()=>{});
      }
    }catch(e){}
  }
  function deleteTeilnehmer(tid){if(confirm("Teilnehmer löschen?"))updateTeilnehmer(ev.teilnehmer.filter(t=>t.id!==tid));}
  function generateLandingPage(evData){generateLandingPageFromEvent(evData,{noPreview:true});}

  function addTeilnehmer(){
    if(!newT.name)return;
    // Mehrere Hunde vom gleichen Besitzer: ab dem 2. Eintrag Gebühr=0, Freibilder=0
    const gleicheName=ev.teilnehmer.some(t=>t.name.trim().toLowerCase()===newT.name.trim().toLowerCase());
    const eintrag={...newT,id:uid(),
      gebuehr:gleicheName?0:newT.gebuehr,
      bilderFrei:gleicheName?0:newT.bilderFrei,
    };
    updateTeilnehmer([...ev.teilnehmer,eintrag]);
    setNewT({nr:"",name:"",hund:"",gebuehr:ev.preise.shootingGebuehr,bilderFrei:ev.preise.bilderFrei,bilderZusatz:0,bestelldatum:"",rechnung:false,bezahlt:false,bilderFertig:false,bilderVerschickt:false,keinAuftrag:false,info:"",notiz:""});
    setAddRow(false);
  }

  const calc=calcEvent(ev);
  const cb=(checked)=>(
    <div style={{width:16,height:16,borderRadius:3,border:`1.5px solid ${checked?"#4caf50":T.text+"99"}`,background:checked?"#4caf50":"transparent",display:"inline-flex",alignItems:"center",justifyContent:"center",margin:"0 auto"}}>
      {checked&&<svg width="10" height="10" viewBox="0 0 10 10"><polyline points="1.5,5 4,7.5 8.5,2" stroke="#fff" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"/></svg>}
    </div>
  );

  const KPI=({label,value,highlight,color})=>(
    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"4px 0",borderBottom:`1px solid ${T.border}22`}}>
      <span style={{fontSize:(highlight||color)?17:15,color:T.muted}}>{label}</span>
      <span style={{fontSize:(highlight||color)?17:15,fontWeight:highlight?700:500,color:color||(highlight?T.accent:T.text)}}>{value}</span>
    </div>
  );

  const numStyle={background:"transparent",border:"none",color:T.accent,fontSize:abrFont,fontFamily:"inherit",width:Math.max(55,Math.round(abrFont*3.2)),outline:"none",fontWeight:600,textAlign:"right",MozAppearance:"textfield"};
  const numStyleNeutral={...numStyle,color:T.text,fontWeight:400};

  return(
    <div>
      <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:24}}>
        <button style={btn(T,"ghost",true)} onClick={onBack}>← Zurück</button>
        <div style={{flex:1}}>
          <div style={{fontFamily:"Georgia,serif",fontSize:22,fontWeight:700,color:T.text}}>{ev.name}</div>
          <div style={{fontSize:13,color:T.muted}}>{fmtDateRange(ev)} · {ev.fotoart}{ev.location?` · ${ev.location}`:""}</div>
          {(ev.adresse?.strasse||ev.adresse?.plz||ev.adresse?.ort)&&(
            <div style={{fontSize:12,color:T.muted}}>{[ev.adresse.strasse,ev.adresse.plz,ev.adresse.ort].filter(Boolean).join(", ")}</div>
          )}
          {(ev.kontakt?.ansprechpartner||ev.kontakt?.telefon||ev.kontakt?.email)&&(
            <div style={{fontSize:12,color:T.muted,display:"flex",gap:12,flexWrap:"wrap",marginTop:2}}>
              {ev.kontakt.ansprechpartner&&<span>👤 {ev.kontakt.ansprechpartner}</span>}
              {ev.kontakt.telefon&&<span>📞 {ev.kontakt.telefon}</span>}
              {ev.kontakt.email&&<a href={`mailto:${ev.kontakt.email}`} style={{color:T.info}}>✉️ {ev.kontakt.email}</a>}
              {ev.kontakt.homepage&&<a href={ev.kontakt.homepage.startsWith("http")?ev.kontakt.homepage:"https://"+ev.kontakt.homepage} target="_blank" rel="noreferrer" style={{color:T.info}}>🌐 {ev.kontakt.homepage}</a>}
            </div>
          )}
          {ev.info&&<div style={{fontSize:12,color:T.muted,marginTop:2,fontStyle:"italic"}}>ℹ️ {ev.info}</div>}
        </div>
        <div style={{display:"flex",gap:6}}>
          <button style={btn(T,"ghost",true)} onClick={()=>onOpenPlan&&onOpenPlan(ev)}><Ic n="calendar" s={13}/> Zum Veranstaltungsplan</button>
          <button style={btn(T,"ghost",true)} onClick={()=>setEditModal(true)}><Ic n="gear" s={13}/> Bearbeiten</button>
          <button style={btn(T,"ghost",true)} onClick={async()=>{
            const ohneBestellung=(ev.teilnehmer||[]).filter(t=>!t.bestelldatum&&t.email);
            if(ohneBestellung.length===0){alert("Alle Teilnehmer haben bereits ein Bestelldatum, oder keine E-Mail-Adresse.");return;}
            if(!confirm(`Erinnerungsmail an ${ohneBestellung.length} Teilnehmer senden?`))return;
            const smtp=(()=>{try{return JSON.parse(localStorage.getItem("sd_smtp_buchung")||localStorage.getItem("sd_smtp_settings")||"{}");}catch{return {};}})();
            const cfg=(()=>{try{return JSON.parse(localStorage.getItem("sd_buchung_config")||"{}");}catch{return {};}})();
            const er=(()=>{try{return JSON.parse(localStorage.getItem("sd_erinnerung_bestellung")||"{}");}catch{return {};}})();
            const vorlagen=(()=>{try{return JSON.parse(localStorage.getItem("sd_email_vorlagen")||"{}");}catch{return {};}})();
            const vEr=vorlagen.erinnerung_bestellung||{};
            const studio=cfg.studioName||"";
            const datum=ev.date?(()=>{try{return new Date(ev.date).toLocaleDateString("de-DE",{day:"2-digit",month:"2-digit",year:"numeric"});}catch{return ev.date;}})():"";
            const betreff=(vEr.betreff||er.betreff||"Erinnerung: Buchung abschließen – {{event}}").replace(/\{\{(event|shooting|veranstaltung)\}\}/g,ev.name||"").replace(/\{\{datum\}\}/g,datum);
            const textTmpl=vEr.text||er.text||"Hallo {{name}},\n\nnur eine kurze Erinnerung: Deine Buchung für {{event}} am {{datum}} ist noch nicht abgeschlossen.\n\nBitte schließe deine Bestellung bald ab.\n\nHerzliche Grüße\n{{studio}}";
            const srvUrl=(localStorage.getItem("sd_server_url")||"").replace(/\/+$/,"");
            let ok=0,fail=0;
            for(const t of ohneBestellung){
              const text=textTmpl.replace(/\{\{name\}\}/g,t.name||"").replace(/\{\{(event|shooting|veranstaltung)\}\}/g,ev.name||"").replace(/\{\{datum\}\}/g,datum).replace(/\{\{studio\}\}/g,studio);
              try{
                const r=await fetch(`${srvUrl}/api/newsletter`,{method:"POST",headers:{"Content-Type":"application/json"},
                  body:JSON.stringify({smtp,recipients:[{name:t.name||"",email:t.email}],subject:betreff,text,html:buildScattoDeskMailHtml(text,_getSig().logo,_getSig().text),logo:_getSig().logo})});
                const d=await r.json();
                if(d.ok||d.sent>0)ok++;else fail++;
              }catch{fail++;}
            }
            alert(`✅ Erinnerung gesendet: ${ok} erfolgreich${fail>0?`, ${fail} fehlgeschlagen`:""}`);
          }}>⏰ Erinnerung senden</button>
        </div>
      </div>

      <div style={{display:"grid",gridTemplateColumns:"1fr 335px",gap:10,marginBottom:16,alignItems:"start"}}>
        {/* Abrechnung Sidebar */}
        <div style={{order:2,display:"flex",flexDirection:"column",gap:12,position:"sticky",top:0,alignSelf:"start"}}>
          {/* Einnahmen */}
          <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:12,padding:"16px 20px",height:311}}>
            <div style={{fontFamily:"Georgia,serif",fontSize:17,color:T.accent,marginBottom:12}}>💰 Einnahmen</div>
            <KPI label="Shootinggebühr" value={fmtEuro(calc.shootingSumme)}/>
            <KPI label={`Bilder gesamt`} value={`${calc.bilderGesamt} Stk.`}/>
            <KPI label={`Zusatzbilder`} value={`${calc.bilderZusatz} Stk.`}/>
            <KPI label="Einnahme Zusatz" value={fmtEuro(calc.zusatzEinnahme)}/>
            {calc.paketSumme>0&&<KPI label="Paketpreise" value={fmtEuro(calc.paketSumme)}/>}
            <KPI label="PICTRS" value={fmtEuro(ev.pictrs||0)}/>
            <div style={{height:16}}/>
            <KPI label="Gesamteinnahme" value={fmtEuro(calc.gesamtEinnahme)} highlight/>
            <div style={{height:4}}/>
            <KPI label="Ø je Kunde" value={fmtEuro(calc.durchschnitt)}/>
          </div>
          {/* Ausgaben */}
          <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:12,padding:"16px 20px",height:269}}>
            <div style={{fontFamily:"Georgia,serif",fontSize:17,color:T.accent,marginBottom:12}}>💸 Ausgaben</div>
            <KPI label="Standgebühr" value={fmtEuro(ev.ausgaben.stand)}/>
            <KPI label="Hotel" value={fmtEuro(ev.ausgaben.hotel)}/>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",padding:"4px 0",borderBottom:`1px solid ${T.border}22`}}>
              <div>
                <div style={{fontSize:15,color:T.muted}}>Mietwagen</div>
                {ev.ausgaben.vermieter&&<div style={{fontSize:Math.max(9,abrFont-2),color:T.muted,fontStyle:"italic"}}>{ev.ausgaben.vermieter}</div>}
              </div>
              <span style={{fontSize:15,fontWeight:500,color:T.text}}>{fmtEuro(ev.ausgaben.mietwagen)}</span>
            </div>
            <KPI label="Sprit" value={fmtEuro(ev.ausgaben.sprit)}/>
            <KPI label="Bearbeitung extern" value={fmtEuro(calc.bearbeitung)}/>
            <div style={{height:16}}/>
            <KPI label="Gesamtausgabe" value={fmtEuro(calc.gesamtAusgabe)} highlight/>
          </div>
          {/* Anteil Extern */}
          <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:12,padding:"16px 20px",height:151}}>
            <div style={{fontFamily:"Georgia,serif",fontSize:17,color:T.accent,marginBottom:12}}>📊 Anteil Extern</div>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10}}>
              <span style={{fontSize:15,color:T.muted}}>Name / Firma</span>
              <input value={externName} onChange={e=>{setExternName(e.target.value);const upd={...ev,externName:e.target.value};setEv(upd);onUpdate(upd);}} placeholder="Partner, Veranstalter..." style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:6,padding:"5px 8px",color:T.text,fontSize:15,fontFamily:"inherit",outline:"none",width:140}}/>
            </div>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10}}>
              <span style={{fontSize:15,color:T.muted}}>Extern Anteil %</span>
              <input type="number" value={externPct} onChange={e=>{const v=Number(e.target.value);setExternPct(v);const upd={...ev,externPct:v};setEv(upd);onUpdate(upd);}} style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:6,padding:"5px 8px",color:T.text,fontSize:15,fontFamily:"inherit",outline:"none",width:70,textAlign:"right"}}/>
            </div>
            <div style={{height:0}}/>
            {externPct>0&&(
              <div style={{borderTop:`1px solid ${T.border}22`,paddingTop:8,marginTop:4}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                  <span style={{fontSize:15,color:T.muted}}>{externName||"Extern"} ({externPct}%)</span>
                  <span style={{fontSize:15,fontWeight:600,color:T.warning}}>{fmtEuro(calc.ertrag*(externPct/100))}</span>
                </div>
              </div>
            )}
          </div>
          {/* Ergebnis */}
          <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:12,padding:"16px 20px",display:"flex",flexDirection:"column"}}>
            <div style={{fontFamily:"Georgia,serif",fontSize:17,color:T.accent,marginBottom:12}}>📈 Ergebnis</div>
            <KPI label="Gesamtertrag" value={fmtEuro(calc.ertrag)}/>
            {externPct>0&&<KPI label={`Anteil Extern (${externPct}%)`} value={`- ${fmtEuro(calc.externBetrag)}`} color={T.warning}/>}
            <KPI label="Ø je Kunde" value={fmtEuro(calc.kunden?calc.auszahlung/calc.kunden:0)}/>
            <div style={{flex:1}}/>
            <div style={{padding:"16px",background:calc.auszahlung>=0?T.success+"22":T.danger+"22",borderRadius:8,border:`1px solid ${calc.auszahlung>=0?T.success:T.danger}44`,display:"flex",justifyContent:"space-between",alignItems:"center",marginTop:10}}>
              <div style={{fontSize:15,color:T.muted,whiteSpace:"nowrap"}}>Auszahlungsbetrag</div>
              <div style={{fontSize:26,fontWeight:700,color:calc.auszahlung>=0?T.success:T.danger,whiteSpace:"nowrap"}}>{fmtEuro(calc.auszahlung)}</div>
            </div>
          </div>
        </div>

        {/* Teilnehmerliste */}
        <div style={{order:1,background:T.surface,border:`1px solid ${T.border}`,borderRadius:12,overflow:"hidden",height:"calc(100vh - 220px)",display:"flex",flexDirection:"column"}}>
          <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"14px 16px",borderBottom:`1px solid ${T.border}`}}>
            <div style={{fontFamily:"Georgia,serif",fontSize:14,color:T.accent}}>{calc.kunden} Teilnehmer</div>
            <div style={{display:"flex",alignItems:"center",gap:14}}>
              <div style={{display:"flex",alignItems:"center",gap:7,color:T.muted}}>
                <span style={{fontSize:12}}>A</span>
                <input type="range" min={11} max={30} value={abrFont} onChange={e=>setAbrFont(Number(e.target.value))} title="Schriftgröße" style={{width:100,accentColor:T.accent,cursor:"pointer"}}/>
                <span style={{fontSize:18}}>A</span>
                <span style={{fontSize:11,minWidth:30,textAlign:"right"}}>{abrFont}px</span>
              </div>
              {/* Kopfzeile getrennt einstellbar */}
              <div style={{display:"flex",alignItems:"center",gap:7,color:T.muted}}>
                <span style={{fontSize:11}}>Kopf</span>
                <input type="range" min={9} max={20} value={kopfFont}
                  onChange={e=>{const v=Number(e.target.value);setKopfFont(v);localStorage.setItem("sd_abr_kopf_font",String(v));}}
                  title="Schriftgröße der Kopfzeile" style={{width:70,accentColor:T.accent,cursor:"pointer"}}/>
                <input type="range" min={28} max={90} step={2} value={kopfHoehe}
                  onChange={e=>{const v=Number(e.target.value);setKopfHoehe(v);localStorage.setItem("sd_abr_kopf_hoehe",String(v));}}
                  title="Höhe der Kopfzeile" style={{width:70,accentColor:T.accent,cursor:"pointer"}}/>
                <span style={{fontSize:11,minWidth:52,textAlign:"right"}}>{kopfFont}/{kopfHoehe}px</span>
              </div>
              <button style={btn(T,"primary",true)} onClick={()=>setAddRow(true)}>+ Hinzufügen</button>
            </div>
          </div>
          <div style={{overflowY:"auto",overflowX:"hidden",flex:1}}>
            <table style={{width:"100%",borderCollapse:"collapse",tableLayout:"fixed",fontSize:abrFont}}>
              <thead>
                <tr style={{background:T.bg}}>
                  {[["sel",""],["nr","Nr"],["name","Name"],["rasse","Rasse"],["gebuehr","Gebühr €"],["frei","Frei"],["zusatz","Zusatz"],["extra","Extra €"],["paket","Paketpreis €"],["summe","Summe €"],["bestelldatum","Bestelldatum"],["rechnung","Rechnung"],["bezahlt","Bezahlt"],["fertig","Fertig"],["verschickt","Erledigt"],["keinauftrag","Kein Auftrag"],["info","Info"],["del",""]].map(([k,h],hi,arr)=>{
                    // "keinauftrag" fehlte hier — deshalb stand die Kopfzeile links.
                    const centered=["rasse","gebuehr","frei","zusatz","extra","paket","summe","bestelldatum","rechnung","bezahlt","fertig","verschickt","keinauftrag","info"].includes(k);
                    const sortable=k==="bestelldatum"||k==="nr"; return <th key={k} onClick={sortable?()=>toggleSort(k):undefined} style={{padding:"6px 6px",height:kopfHoehe,textAlign:centered?"center":"left",fontSize:kopfFont,fontWeight:700,color:T.text,textTransform:"uppercase",letterSpacing:"0.04em",lineHeight:1.15,borderBottom:`2px solid ${T.border}`,borderRight:hi<arr.length-1&&k!=="sel"?`1px solid ${T.border}`:"none",whiteSpace:"normal",wordBreak:"break-word",position:"relative",width:evColW[k],userSelect:"none",background:T.bg,cursor:sortable?"pointer":"default",verticalAlign:"middle"}}>{h}{sortable&&sortField===k&&(sortDir===1?"↑":"↓")}{k!=="akt"&&k!=="sel"&&<ResizeHandle T={T} onMouseDown={e=>startEvResize(e,k)}/>}</th>;
                  })}
                </tr>
              </thead>
              <tbody>
                {(()=>{
                  const rows=ev.teilnehmer||[];
                  const gk=t=>(String(t.name||"").trim().toLowerCase())||("__id_"+t.id);
                  const pdNr=t=>{const n=parseInt(String(t.nr).replace(/\D/g,""),10);return isNaN(n)?null:n;};
                  const pdDate=t=>{const p=String(t.bestelldatum||"").split(".");return (p.length<3||!+p[2])?null:new Date(+p[2],(+p[1]||1)-1,+p[0]||1).getTime();};
                  // Zeilen mit gleichem Namen gruppieren (mehrere Hunde = mehrere Zeilen)
                  const groups=new Map();
                  rows.forEach(t=>{const k=gk(t);if(!groups.has(k))groups.set(k,[]);groups.get(k).push(t);});
                  // innerhalb der Gruppe nach Nr (leere ans Ende), damit Hund 1 zuerst steht
                  const within=(a,b)=>{const an=pdNr(a),bn=pdNr(b);if(an==null&&bn==null)return 0;if(an==null)return 1;if(bn==null)return -1;return an-bn;};
                  const glist=[...groups.values()].map(g=>[...g].sort(within));
                  const keyNr=g=>{const v=g.map(pdNr).filter(x=>x!=null);return v.length?Math.min(...v):null;};
                  const keyDate=g=>{const v=g.map(pdDate).filter(x=>x!=null);return v.length?Math.min(...v):null;};
                  glist.sort((ga,gb)=>{
                    // Abgeschlossene Kunden (Bilder verschickt) immer ans Ende — in jedem Sortiermodus
                    const aDone=ga.every(x=>x.bilderVerschickt), bDone=gb.every(x=>x.bilderVerschickt);
                    if(aDone&&!bDone)return 1;
                    if(!aDone&&bDone)return -1;
                    if(sortField==="nr"){const a=keyNr(ga),b=keyNr(gb);if(a==null&&b==null)return 0;if(a==null)return 1;if(b==null)return -1;return sortDir===1?a-b:b-a;}
                    if(sortField==="bestelldatum"){const a=keyDate(ga),b=keyDate(gb);if(a==null&&b==null)return 0;if(a==null)return 1;if(b==null)return -1;return sortDir===1?a-b:b-a;}
                    return 0;
                  });
                  return glist.flat();
                })().map((t,idx,arr)=>{
                  const extra=(t.bilderZusatz||0)*(ev.preise.preisZusatzbild||0);
                  const summe=(t.gebuehr||0)+extra+(Number(t.paket)||0);
                  const hasInfo=t.info&&t.info.trim().length>0;
                  const isSel=!!t._selected;
                  const abgeschlossenBg=t.bilderVerschickt?(T===DARK?"#1a2a1a":"#e8f5e9"):"transparent";
                  const rowBg=isSel?T.accentDim:abgeschlossenBg;
                  return(
                    <tr key={t.id}
                      onMouseEnter={e=>{if(!isSel)e.currentTarget.style.background=T.tileHover;}}
                      onMouseLeave={e=>{e.currentTarget.style.background=rowBg;}}
                      onDoubleClick={()=>setEditTeil({...t})}
                      style={{height:50,transition:"background 0.1s",background:rowBg,outline:isSel?`1px solid ${T.accent}66`:"none",outlineOffset:-1}}>
                      <td style={{padding:"8px 6px",borderBottom:`1px solid ${T.border}44`,borderRight:`1px solid ${T.border}99`,textAlign:"center"}}>
                        <div onClick={()=>updateField(t.id,"_selected",!t._selected)}
                            style={{width:16,height:16,borderRadius:3,border:"2px solid #888",background:isSel?"#c8a96e":"#fff",display:"inline-flex",alignItems:"center",justifyContent:"center",cursor:"pointer",flexShrink:0}}>
                            {isSel&&<svg width="10" height="10" viewBox="0 0 10 10"><polyline points="1.5,5 4,7.5 8.5,2" stroke="#1a1814" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"/></svg>}
                          </div>
                      </td>
                      <td style={{padding:"8px 8px",color:T.muted,borderBottom:`1px solid ${T.border}44`,borderRight:`1px solid ${T.border}99`,whiteSpace:"nowrap"}}>{t.nr}</td>
                      <td style={{padding:"8px 8px",fontWeight:600,color:T.text,borderBottom:`1px solid ${T.border}44`,borderRight:`1px solid ${T.border}99`,whiteSpace:"nowrap",cursor:"pointer"}}
                        onClick={()=>setMailFor(t)} title="Klicken für Mail">
                        <div style={{display:"flex",alignItems:"center",gap:5}}>
                          {/* Bei weiteren Hunden desselben Halters steht der Name
                              nur in der ersten Zeile. Aeltere Eintraege haben das
                              Kennzeichen nicht, dort greift der Vergleich mit der
                              Zeile darueber. */}
                          {(()=>{
                            const vorher=arr[idx-1];
                            const zusatz=t.weitererHund
                              ||(idx>0&&vorher&&t.name&&vorher.name===t.name&&Number(t.gebuehr)===0);
                            return zusatz
                              ?<span style={{color:T.border,fontSize:11,fontStyle:"italic"}}>↑ s.o.</span>
                              :<span>{t.name}</span>;
                          })()}
                          {(t.mailLog||[]).length>0&&(
                            <span style={{fontSize:10,color:T.accent}} title={(t.mailLog||[]).map(m=>(m.typ==="bildauswahl"?"📂":"🖼")+" "+new Date(m.datum).toLocaleDateString("de-DE")).join(", ")}>
                              {"·".repeat(Math.min((t.mailLog||[]).length,3))}
                            </span>
                          )}
                        </div>
                      </td>
                      <td style={{padding:"8px 8px",color:T.text,borderBottom:`1px solid ${T.border}44`,borderRight:`1px solid ${T.border}99`,textAlign:"center"}}>{t.hund||""}</td>
                      {/* Spezialpreise: Gebuehr frei aenderbar, auch mit Komma. */}
                      <td style={{padding:"4px 6px",borderBottom:`1px solid ${T.border}44`,borderRight:`1px solid ${T.border}99`,textAlign:"center"}}>
                        <PreisFeld T={T} mittig value={t.gebuehr??""} onChange={v=>updateField(t.id,"gebuehr",v===""?0:v)}/>
                      </td>
                      <td style={{padding:"8px 8px",borderBottom:`1px solid ${T.border}44`,borderRight:`1px solid ${T.border}99`,textAlign:"center"}}>
                        <input type="number" value={t.bilderFrei} onChange={e=>updateField(t.id,"bilderFrei",Number(e.target.value))} style={{...numStyleNeutral,textAlign:"center"}}/>
                      </td>
                      <td style={{padding:"8px 8px",borderBottom:`1px solid ${T.border}44`,borderRight:`1px solid ${T.border}99`,textAlign:"center"}}>
                        <input type="number" min={0} value={t.bilderZusatz} onChange={e=>updateField(t.id,"bilderZusatz",Number(e.target.value))} onFocus={e=>e.target.select()} style={{...numStyleNeutral,textAlign:"center",border:`1px solid ${T.border}`,borderRadius:4,padding:"2px 4px",background:T.bg}}/>
                      </td>
                      <td style={{padding:"8px 8px",color:T.muted,borderBottom:`1px solid ${T.border}44`,borderRight:`1px solid ${T.border}99`,textAlign:"center"}}>{fmtEuro(extra)}</td>
                      <td style={{padding:"4px 6px",borderBottom:`1px solid ${T.border}44`,borderRight:`1px solid ${T.border}99`,textAlign:"center"}}>
                        <PreisFeld T={T} mittig value={t.paket??""} onChange={v=>updateField(t.id,"paket",v)}/>
                      </td>
                      <td style={{padding:"8px 8px",fontWeight:600,color:T.accent,borderBottom:`1px solid ${T.border}44`,borderRight:`1px solid ${T.border}99`,textAlign:"center"}}>{fmtEuro(summe)}</td>
                      <td style={{padding:"8px 8px",textAlign:"center",fontSize:11,color:T.muted,borderBottom:`1px solid ${T.border}44`,borderRight:`1px solid ${T.border}99`}}>
                        <input type="text" value={t.bestelldatum||""} onChange={e=>{
                          // Nur Zahlen durchlassen, Punkte automatisch einfügen
                          const raw=e.target.value.replace(/\D/g,"").slice(0,8);
                          let fmt=raw;
                          if(raw.length>4)fmt=raw.slice(0,2)+"."+raw.slice(2,4)+"."+raw.slice(4);
                          else if(raw.length>2)fmt=raw.slice(0,2)+"."+raw.slice(2);
                          updateField(t.id,"bestelldatum",fmt);
                        }} placeholder="TT.MM.JJJJ" maxLength={10}
                          style={{background:"transparent",border:"none",color:T.text,fontSize:abrFont,fontFamily:"inherit",outline:"none",boxSizing:"border-box",width:"100%",textAlign:"center"}}/>
                      </td>
                      <td style={{padding:"8px 8px",textAlign:"center",borderBottom:`1px solid ${T.border}44`,borderRight:`1px solid ${T.border}99`,cursor:"pointer"}} onClick={()=>toggleCheck(t.id,"rechnung")}>{cb(t.rechnung)}</td>
                      <td style={{padding:"8px 8px",textAlign:"center",borderBottom:`1px solid ${T.border}44`,borderRight:`1px solid ${T.border}99`,cursor:"pointer"}} onClick={()=>toggleCheck(t.id,"bezahlt")}>{cb(t.bezahlt)}</td>
                      <td style={{padding:"8px 8px",textAlign:"center",borderBottom:`1px solid ${T.border}44`,borderRight:`1px solid ${T.border}99`,cursor:"pointer"}} onClick={()=>toggleCheck(t.id,"bilderFertig")}>{cb(t.bilderFertig)}</td>
                      <td title={t.bilderVerschicktDatum?"Verschickt am "+new Date(t.bilderVerschicktDatum).toLocaleDateString("de-DE"):""}
                        style={{padding:"8px 8px",textAlign:"center",borderBottom:`1px solid ${T.border}44`,borderRight:`1px solid ${T.border}99`,cursor:"pointer"}} onClick={()=>toggleCheck(t.id,"bilderVerschickt")}>
                        {cb(t.bilderVerschickt)}
                        {t.bilderVerschickt&&t.bilderVerschicktDatum&&(
                          <div style={{fontSize:9,color:T.muted,lineHeight:1.2,marginTop:1}}>
                            {new Date(t.bilderVerschicktDatum).toLocaleDateString("de-DE",{day:"2-digit",month:"2-digit"})}
                          </div>
                        )}
                      </td>
                      <td style={{padding:"8px 8px",textAlign:"center",borderBottom:`1px solid ${T.border}44`,borderRight:`1px solid ${T.border}99`,cursor:"pointer"}} onClick={()=>toggleCheck(t.id,"keinAuftrag")} title="Kein Auftrag – aus Überfällig-Liste entfernen">{cb(t.keinAuftrag,"#e53")}</td>
                      <td style={{padding:"8px 8px",textAlign:"center",borderBottom:`1px solid ${T.border}44`,borderRight:`1px solid ${T.border}99`,cursor:"pointer"}} onClick={()=>setInfoFor(t)} title={hasInfo?t.info:"Info hinzufügen"}>
                        <span style={{fontSize:16,color:hasInfo?T.warning:T.muted}}>{hasInfo?"📝":"✎"}</span>
                      </td>
                      <td style={{padding:"8px 6px",textAlign:"center",borderBottom:`1px solid ${T.border}44`,borderRight:`1px solid ${T.border}99`,whiteSpace:"nowrap"}}>
                        {(()=>{
                          const wa=(()=>{try{return JSON.parse(localStorage.getItem("sd_wa_settings")||"null")||{};}catch{return {};}})();
                          const phone=t.phone||(()=>{try{const custs=JSON.parse(localStorage.getItem("sd_customers")||"[]");return custs.find(c=>c.name===t.name)?.phone||"";}catch{return "";}})();
                          return wa.aktiv&&phone?(
                            <button style={{...btn(T,"ghost",true),color:"#25d366",padding:"2px 6px"}} title="WhatsApp senden"
                              onClick={async()=>{
                                const serverUrl=(localStorage.getItem("sd_server_url")||"").trim().replace(/\/+$/,"");
                                const text=`Hallo ${t.name||""}, wir möchten Sie an Ihren Termin bei Markus Heber Photography erinnern. Bei Fragen stehen wir gerne zur Verfügung.`;
                                try{
                                  const r=await fetch(`${serverUrl}/api/wa-send`,{method:"POST",headers:{"Content-Type":"application/json"},
                                    body:JSON.stringify({token:wa.token,phone_number_id:wa.phone_number_id,to:phone,text})});
                                  const d=await r.json();
                                  if(d.ok)alert("✅ WhatsApp gesendet!");
                                  else alert("❌ "+JSON.stringify(d.error));
                                }catch(e){alert("❌ "+e.message);}
                              }}>💬</button>
                          ):null;
                        })()}
                        {t._buchungId&&!t.storniert&&(
                          <button onClick={()=>{
                            const bk=JSON.parse(localStorage.getItem("sd_buchungen")||"[]").find(b=>b.id===t._buchungId);
                            if(!bk){alert("Buchung nicht gefunden.");return;}
                            if(!confirm(`Buchung von ${t.name} stornieren?`))return;
                            // Status setzen
                            const alle=JSON.parse(localStorage.getItem("sd_buchungen")||"[]");
                            localStorage.setItem("sd_buchungen",JSON.stringify(alle.map(b=>b.id===t._buchungId?{...b,status:"storniert"}:b)));
                            // Slot freigeben
                            try{const cfg=JSON.parse(localStorage.getItem("sd_buchung_config")||"{}");
                            const updated={...cfg,shootingTypes:(cfg.shootingTypes||[]).map(s=>{
                              if(s.name!==bk.shootingType)return s;
                              return {...s,slots:(s.slots||[]).map(sl=>{
                                if(sl.datum!==bk.datum)return sl;
                                return {...sl,booked:(sl.booked||[]).filter(z=>z!==bk.uhrzeit)};
                              })};
                            })};
                            localStorage.setItem("sd_buchung_config",JSON.stringify(updated));}catch{}
                            // Teilnehmer als storniert markieren
                            updateTeilnehmer(ev.teilnehmer.map(x=>x.id===t.id?{...x,storniert:true}:x));
                            // E-Mails via Server
                            const smtp=JSON.parse(localStorage.getItem("sd_smtp_buchung")||localStorage.getItem("sd_smtp_settings")||"{}");
                            const cfg2=JSON.parse(localStorage.getItem("sd_buchung_config")||"{}");
                            const studio=cfg2.studioName||"";
                            const srvUrl=(localStorage.getItem("sd_server_url")||"").replace(/\/+$/,"");
                            const kundeEmail=t.email||bk.formData?.sys_email||"";
                            const datStr=bk.datum?(()=>{try{return new Date(bk.datum).toLocaleDateString("de-DE");}catch{return bk.datum;}})():"";
                            const studioEmail=smtp.from_email||smtp.user||"";
                            if(kundeEmail)fetch(`${srvUrl}/api/newsletter`,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({smtp,recipients:[{name:t.name,email:kundeEmail}],subject:`Stornierungsbestätigung – ${bk.shootingType}`,text:`Hallo ${t.name},

dein Termin am ${datStr} um ${bk.uhrzeit||""} Uhr wurde storniert.

Herzliche Grüße
${studio}`,html:buildScattoDeskMailHtml(`Hallo ${t.name},

dein Termin am **${datStr}** um **${bk.uhrzeit||""} Uhr** wurde storniert.

Herzliche Grüße
${studio}`,_getSig().logo,_getSig().text),logo:_getSig().logo})});
                            if(studioEmail)fetch(`${srvUrl}/api/newsletter`,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({smtp,recipients:[{name:studio,email:studioEmail}],subject:`⚠️ Stornierung: ${t.name} – ${bk.shootingType} ${datStr}`,text:`Stornierung:
Kunde: ${t.name}
Veranstaltung: ${bk.shootingType}
Datum: ${datStr}
Uhrzeit: ${bk.uhrzeit||""}
Slot freigegeben.`,html:buildScattoDeskMailHtml(`**Stornierung**

Kunde: ${t.name}
Veranstaltung: ${bk.shootingType}
Datum: ${datStr} ${bk.uhrzeit||""}
Slot freigegeben.`,_getSig().logo,_getSig().text),logo:_getSig().logo})});
                            alert("✅ Storniert, E-Mails versendet, Slot freigegeben.");
                          }}
                            style={{background:"transparent",border:"none",color:"#e53",cursor:"pointer",fontSize:11,padding:"2px 6px",borderRadius:4,lineHeight:1,marginRight:2}}
                            title="Buchung stornieren">🚫</button>
                        )}
                        {t.storniert&&<span style={{fontSize:10,color:"#e53",fontWeight:600,marginRight:4}}>storniert</span>}
                        <button onClick={()=>deleteTeilnehmer(t.id)}
                          style={{background:"transparent",border:"none",color:T.muted,cursor:"pointer",fontSize:14,padding:"2px 6px",borderRadius:4,lineHeight:1}}
                          title="Teilnehmer löschen"
                          onMouseEnter={e=>e.currentTarget.style.color="#e53"}
                          onMouseLeave={e=>e.currentTarget.style.color=T.muted}>
                          ✕
                        </button>
                      </td>

                    </tr>
                  );
                })}
                {addRow&&(
                  <tr style={{background:T.accentDim}}>
                    <td style={{padding:"6px 6px"}}><input value={newT.nr} onChange={e=>setNewT(x=>({...x,nr:e.target.value}))} placeholder="Nr" style={{background:"transparent",border:"none",color:T.text,fontSize:12,fontFamily:"inherit",width:30,outline:"none"}}/></td>
                    <td style={{padding:"6px 6px",position:"relative"}}>
                      <input value={newT.name}
                        onChange={e=>{
                          const v=e.target.value;
                          setNewT(x=>({...x,name:v}));
                          if(v.length>=2){
                            const sugg=allKunden.filter(k=>(k.name||"").toLowerCase().includes(v.toLowerCase())).slice(0,6);
                            setNameAutoSugg(sugg);
                          } else setNameAutoSugg([]);
                        }}
                        onBlur={()=>setTimeout(()=>setNameAutoSugg([]),200)}
                        placeholder="Name *"
                        style={{background:"transparent",border:"none",color:T.text,fontSize:12,fontFamily:"inherit",width:110,outline:"none"}}/>
                      {nameAutoSugg.length>0&&(
                        <div style={{position:"absolute",top:"100%",left:0,background:T.surface,border:`1px solid ${T.border}`,borderRadius:8,zIndex:200,minWidth:220,boxShadow:"0 6px 20px rgba(0,0,0,0.4)",maxHeight:200,overflowY:"auto"}}>
                          {nameAutoSugg.map(k=>(
                            <div key={k.id} onClick={()=>{
                              // Rasse aus erstem Tier
                              const rasse=k.tiere?.[0]?.rasse||k.rasse||"";
                              const tel=k.telefon||"";
                              const email=k.email||"";
                              setNewT(x=>({...x,name:k.name||"",hund:rasse,telefon:tel,email:email}));
                              setNameAutoSugg([]);
                            }}
                              style={{padding:"8px 12px",cursor:"pointer",fontSize:12,borderBottom:`1px solid ${T.border}22`}}
                              onMouseEnter={e=>e.currentTarget.style.background=T.accentDim}
                              onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
                              <div style={{fontWeight:600,color:T.text}}>{k.name}</div>
                              <div style={{fontSize:11,color:T.muted}}>{[k.telefon,k.email,k.tiere?.[0]?.rasse].filter(Boolean).join(" · ")}</div>
                            </div>
                          ))}
                        </div>
                      )}
                    </td>
                    <td style={{padding:"6px 6px"}}><input value={newT.hund||""} onChange={e=>setNewT(x=>({...x,hund:e.target.value}))} placeholder="Rasse" style={{background:"transparent",border:"none",color:T.text,fontSize:12,fontFamily:"inherit",width:70,outline:"none"}}/></td>
                    <td style={{padding:"6px 6px",textAlign:"right"}}><input type="number" value={newT.gebuehr} onChange={e=>setNewT(x=>({...x,gebuehr:Number(e.target.value)}))} style={{...numStyle,background:"transparent"}}/> <span style={{fontSize:abrFont,color:T.muted}}>€</span></td>
                    <td style={{padding:"6px 6px",textAlign:"right"}}><input type="number" value={newT.bilderFrei} onChange={e=>setNewT(x=>({...x,bilderFrei:Number(e.target.value)}))} style={{...numStyleNeutral,background:"transparent"}}/></td>
                    <td style={{padding:"6px 6px",textAlign:"right"}}><input type="number" value={newT.bilderZusatz} onChange={e=>setNewT(x=>({...x,bilderZusatz:Number(e.target.value)}))} style={{...numStyleNeutral,background:"transparent"}}/></td>
                    <td colSpan={7}/>
                    <td style={{padding:"6px 6px"}}>
                      <div style={{display:"flex",gap:4}}>
                        <button style={btn(T,"success",true)} onClick={addTeilnehmer}>✓</button>
                        <button style={btn(T,"ghost",true)} onClick={()=>setAddRow(false)}>✕</button>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Info Modal */}
      {infoFor&&(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.7)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:100,padding:20}}>
          <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:16,padding:24,width:"100%",maxWidth:420}}>
            <div style={{fontFamily:"Georgia,serif",fontSize:16,color:T.accent,marginBottom:4}}>Info — {infoFor.name}</div>
            <div style={{fontSize:12,color:T.muted,marginBottom:14}}>{infoFor.hund} · Nr. {infoFor.nr}</div>
            <textarea
              value={infoFor.info||""}
              onChange={e=>setInfoFor(x=>({...x,info:e.target.value}))}
              placeholder="Infos, Wünsche, Besonderheiten..."
              style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:"10px 12px",color:T.text,fontSize:13,fontFamily:"inherit",outline:"none",boxSizing:"border-box",width:"100%",resize:"vertical",minHeight:100}}
            />
            <div style={{display:"flex",justifyContent:"flex-end",gap:10,marginTop:14}}>
              <button style={btn(T,"ghost")} onClick={()=>setInfoFor(null)}>Abbrechen</button>
              <button style={btn(T,"primary")} onClick={()=>{updateField(infoFor.id,"info",infoFor.info||"");setInfoFor(null);}}>Speichern</button>
            </div>
          </div>
        </div>
      )}

      {/* Teilnehmer bearbeiten Modal */}
      {editTeil&&(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.7)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:200,padding:20}}>
          <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:16,padding:24,width:"100%",maxWidth:480}}>
            <div style={{fontFamily:"Georgia,serif",fontSize:16,color:T.accent,marginBottom:16}}>✏️ Teilnehmer bearbeiten</div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:12}}>
              {[["nr","Nr."],["name","Name"],["hund","Tier / Rasse"],["email","E-Mail"],["telefon","Telefon"]].map(([k,l])=>(
                <div key={k} style={{gridColumn:k==="name"||k==="email"?"span 2":"span 1"}}>
                  <label style={{fontSize:11,color:T.muted,fontWeight:600,display:"block",marginBottom:3}}>{l}</label>
                  <input value={editTeil[k]||""} onChange={e=>setEditTeil(x=>({...x,[k]:e.target.value}))}
                    style={{width:"100%",background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:"8px 10px",color:T.text,fontSize:13,fontFamily:"inherit",outline:"none",boxSizing:"border-box"}}/>
                </div>
              ))}
            </div>
            <div style={{marginBottom:16}}>
              <label style={{fontSize:11,color:T.muted,fontWeight:600,display:"block",marginBottom:3}}>Info / Notiz</label>
              <textarea value={editTeil.info||""} onChange={e=>setEditTeil(x=>({...x,info:e.target.value}))} rows={3}
                style={{width:"100%",background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:"8px 10px",color:T.text,fontSize:13,fontFamily:"inherit",outline:"none",resize:"vertical",boxSizing:"border-box"}}/>
            </div>
            <div style={{display:"flex",justifyContent:"flex-end",gap:10}}>
              <button style={btn(T,"ghost")} onClick={()=>setEditTeil(null)}>Abbrechen</button>
              <button style={btn(T,"primary")} onClick={()=>{
                const updated={...editTeil};
                setEv(prev=>{
                  const neu={...prev,teilnehmer:prev.teilnehmer.map(t=>t.id===updated.id?updated:t)};
                  onUpdate(neu);
                  return neu;
                });
                setEditTeil(null);
              }}>Speichern</button>
            </div>
          </div>
        </div>
      )}

      {/* Mail-Modal für Teilnehmer */}
      {mailFor&&(()=>{
        const cfg=(()=>{try{return JSON.parse(localStorage.getItem("sd_buchung_config")||"{}");}catch{return {};}})();
        const zugangLink=mailFor.zugangLink||(cfg.zugangsLinkBase?`${cfg.zugangsLinkBase}/${mailFor.id}`:"");
        return(
          <TeilnehmerMailModal
            teilnehmer={mailFor}
            ev={ev}
            zugangLink={zugangLink}
            onMailGesendet={(typ)=>{
              const jetzt=new Date().toISOString();
              const neuerLog=[...(mailFor.mailLog||[]),{typ,datum:jetzt}];
              updateField(mailFor.id,"mailLog",neuerLog);
              setMailFor(prev=>prev?{...prev,mailLog:neuerLog}:prev);
              // Beide Mailarten festhalten, jeweils mit Datum. Ein bereits
              // gesetzter Haken behaelt sein urspruengliches Datum.
              const heute=jetzt.slice(0,10);
              if(typ==="fertige_bilder"&&!mailFor.bilderVerschickt){
                updateField(mailFor.id,"bilderVerschickt",true);
                updateField(mailFor.id,"bilderVerschicktDatum",heute);
                setMailFor(p=>p?{...p,bilderVerschickt:true,bilderVerschicktDatum:heute}:p);
              }
              if(typ==="bildauswahl"&&!mailFor.auswahlVerschickt){
                updateField(mailFor.id,"auswahlVerschickt",true);
                updateField(mailFor.id,"auswahlVerschicktDatum",heute);
                setMailFor(p=>p?{...p,auswahlVerschickt:true,auswahlVerschicktDatum:heute}:p);
              }
            }}
            onClose={()=>setMailFor(null)}
            T={T}
          />
        );
      })()}

      {editModal&&<EventModal event={ev} onSave={saveEv} onClose={()=>setEditModal(false)} T={T}/>}
      {sevProg&&(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.78)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:100,padding:20}}>
          <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:16,padding:28,width:"100%",maxWidth:440}}>
            <div style={{fontFamily:"Georgia,serif",fontSize:18,color:T.accent,marginBottom:14}}>sevDesk Übertragung</div>
            {!sevProg.done?(
              <div>
                <div style={{fontSize:13,color:T.muted,marginBottom:10}}>⏳ Übertrage Teilnehmer... {sevProg.ok.length+sevProg.skip.length+sevProg.err.length} / {sevProg.total}</div>
                <div style={{height:6,background:T.border,borderRadius:3,overflow:"hidden"}}>
                  <div style={{height:"100%",width:`${Math.round(((sevProg.ok.length+sevProg.skip.length+sevProg.err.length)/sevProg.total)*100)}%`,background:T.accent,borderRadius:3,transition:"width 0.3s"}}/>
                </div>
              </div>
            ):(
              <div>
                <div style={{background:T.success+"22",border:`1px solid ${T.success}44`,borderRadius:8,padding:"12px 16px",marginBottom:14,fontSize:13}}>
                  <div style={{fontWeight:600,color:T.success,marginBottom:6}}>✅ Fertig!</div>
                  <div style={{color:T.muted,fontSize:12,lineHeight:1.7}}>
                    Neu angelegt: <strong style={{color:T.text}}>{sevProg.ok.length}</strong><br/>
                    Bereits vorhanden: {sevProg.skip.length}
                    {sevProg.err.length>0&&<><br/><span style={{color:T.danger}}>Fehler: {sevProg.err.length}</span></>}
                  </div>
                </div>
                {sevProg.err.length>0&&(
                  <div style={{fontSize:11,color:T.danger,background:T.danger+"11",borderRadius:6,padding:8,marginBottom:12,maxHeight:100,overflowY:"auto"}}>
                    {sevProg.err.map((e,i)=><div key={i}>· {e}</div>)}
                  </div>
                )}
                <button style={{...btn(T,"primary"),width:"100%",justifyContent:"center"}} onClick={()=>setSevProg(null)}>Schließen</button>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}


// Der RichEditor liefert Bloecke als <div>, oft mit Attributen, etwa
// <div style="text-align:center">. Frueher wurde nur das nackte <div>
// entfernt, jedes </div> aber durch <br> ersetzt. Bei einem <div> mit
// Attributen blieb dadurch ein nie geschlossenes Element uebrig, das den
// Rest der Seite in sich aufgenommen und das Layout zerlegt hat.
function _lpText(roh){
  return String(roh||"")
    .replace(/<div[^>]*>/gi,"")
    .replace(/<\/div>/gi,"<br>")
    .replace(/<\/?(html|head|body|script|style)[^>]*>/gi,"")
    .replace(/\r\n|\r|\n/g,"<br>")
    .replace(/(<br\s*\/?>\s*)+/gi,"<br>")
    .replace(/^(<br>\s*)+|(<br>\s*)+$/gi,"")
    .trim();
}

function generateLandingPageFromEvent(evData, opts){
  if(!evData)return;
  const fmt=(dt,y)=>dt?dt.toLocaleDateString("de-DE",{day:"2-digit",month:"long",...(y?{year:"numeric"}:{})}):""
  const adresse=[evData.adresse?.strasse,[evData.adresse?.plz,evData.adresse?.ort].filter(Boolean).join(" ")].filter(Boolean).join(", ");
  const cfg=JSON.parse(localStorage.getItem("sd_buchung_config")||"{}");
  const hpCfg=JSON.parse(localStorage.getItem("sd_hp_config")||"{}");
  const pColor=cfg.primaryColor||"#C9A96E";
  const studio=cfg.studioName||"";
  const logo=cfg.logo||"";
  const buchUrl=hpCfg.buchungsLink||"#";
  const heroBg=hpCfg.heroBg||"#1a1814";
  // Textfarbe nach Helligkeit des Hintergrunds
  const _hex=heroBg.replace("#","");
  const _lum=(parseInt(_hex.substr(0,2),16)*0.299+parseInt(_hex.substr(2,2),16)*0.587+parseInt(_hex.substr(4,2),16)*0.114);
  const heroText=_lum>140?"#1a1814":"#F0EBE3";
  const heroSub=_lum>140?"#6a6258":"#7A7570";
  // Echten Buchungsplan-Slug holen
  const _bCfg=(()=>{try{return JSON.parse(localStorage.getItem("sd_buchung_config")||"null");}catch{return null;}})();
  const _bST=_bCfg&&Array.isArray(_bCfg.shootingTypes)&&_bCfg.shootingTypes.find(s=>s.eventId===evData.id);
  const slug=(_bST&&(_bST.buchungsUrl||(_bST.name||"").toLowerCase().replace(/\s+/g,"-")))||((evData.fotoart||"").toLowerCase().replace(/ /g,"-"));
  // Datum: bevorzugt aus der Veranstaltung. Fehlt es dort, nehmen wir die
  // kuenftigen Zeitslots des Buchungsplans, so wie es das Homepage-Widget
  // auch macht. Sonst bliebe die Zeile "Wann" auf der Seite einfach leer.
  const _slotTage=(()=>{
    const heute=new Date(new Date().toDateString());
    return [...new Set((_bST?.slots||[]).map(x=>x.datum).filter(Boolean))]
      .filter(x=>{const t=new Date(x);return !isNaN(t)&&t>=heute;})
      .sort();
  })();
  const _von=evData.date||_slotTage[0]||"";
  const _bis=evData.dateBis||(_slotTage.length>1?_slotTage[_slotTage.length-1]:"");
  const d=_von?new Date(_von):null;
  const dBis=(_bis&&_bis!==_von)?new Date(_bis):null;
  const datumStr=d?(dBis?fmt(d,false)+" – "+fmt(dBis,true):d.toLocaleDateString("de-DE",{weekday:"long",day:"2-digit",month:"long",year:"numeric"})):"";
  // Beschreibung: jede Zeile separat (HTML-Umbrüche UND echte Zeilenumbrüche)
  // Kopfbereich hat Vorrang. Ist er leer, greift wie bisher die Beschreibung,
  // damit bestehende Landingpages unveraendert bleiben.
  const _kopf=evData.kopfbereich||_bST?.kopfbereich||"";
  const infoHTML=_lpText(_kopf||evData.info||_bST?.beschreibung?.de||"");
  // Event-Info für "Das Event" Block auf der Landingpage
  const _eventInfo=evData.event_info||_bST?.event_info||"";
  const eventInfoHTML=_lpText(_eventInfo);

  const _sloganHTML=_lpText(_bST&&_bST.hp_slogan);
  const _scarcityHTML=_lpText((opts&&opts.scarcityText)||(_bST&&_bST.scarcityText));
  const _ogUrl="https://buchen.m-h-photo.de/"+slug;
  const _ogDesc=(infoHTML||"").replace(/<br\s*\/?>/gi," ").replace(/<[^>]+>/g,"").replace(/\s+/g," ").trim().slice(0,160);
  const html="<!DOCTYPE html><html lang='de'><head><meta charset='UTF-8'><meta name='viewport' content='width=device-width,initial-scale=1'>"
    +"<title>"+evData.name+"<\/title>"
    +"<meta property='og:title' content='"+evData.name+"'/>"
    +"<meta property='og:description' content='"+(_ogDesc||datumStr||"")+"'/>"
    +"<meta property='og:type' content='website'/>"
    +"<meta property='og:url' content='"+_ogUrl+"'/>"
    +(logo?"<meta property='og:image' content='"+logo.slice(0,500)+"'/>":" ")
    +"<meta name='description' content='"+(_ogDesc||datumStr||"")+"'/>"
    +"<link rel='stylesheet' href='https://unpkg.com/leaflet@1.9.4/dist/leaflet.css'\/>"
    +"<style>*{box-sizing:border-box;margin:0;padding:0}body{font-family:Georgia,serif;background:#f5f3ef;color:#1a1814}"
    +".hero{background:"+heroBg+";padding:56px 24px;text-align:center;color:"+heroSub+"}"
    +".hero-txt{font-size:15px;color:"+heroSub+";max-width:520px;margin:0 auto 38px;font-family:sans-serif;line-height:1.7}"
    +".hero-txt *{color:inherit}"
    +".hero-slogan{font-style:italic;opacity:.75;font-size:15px;color:"+heroSub+";margin:6px auto 16px;max-width:520px;font-family:sans-serif}"
    +".hero-slogan *{color:inherit}"
    +".cta-txt{font-size:13px;color:"+heroSub+";margin-bottom:24px;font-family:sans-serif}"
    +".cta-txt *{color:inherit}"
    +".tag{display:inline-block;background:"+pColor+"33;color:"+pColor+";font-size:11px;font-weight:700;letter-spacing:.15em;text-transform:uppercase;padding:5px 14px;border-radius:20px;margin-bottom:16px;font-family:sans-serif}"
    +".hero h1{font-size:clamp(28px,5vw,48px);color:"+heroText+";letter-spacing:.03em;line-height:1.2;margin-bottom:12px}"
    +".hero p{font-size:15px;color:"+heroSub+";max-width:520px;margin:0 auto 26px;font-family:sans-serif;line-height:1.7}"
    +".btn{display:inline-block;background:"+pColor+";color:#1a1814;padding:14px 32px;border-radius:8px;text-decoration:none;font-size:14px;font-weight:700;font-family:sans-serif}"
    +".wrap{max-width:1100px;margin:0 auto;padding:40px 20px}"
    +".main{display:grid;grid-template-columns:230px 1fr;gap:24px;align-items:center}"
    /* Schritte links vertikal */
    +".steps{display:flex;flex-direction:column;gap:12px}"
    +".steps-tag{font-size:10px;font-weight:700;letter-spacing:.15em;text-transform:uppercase;color:"+pColor+";font-family:sans-serif;margin-bottom:2px}"
    +".steps-h{font-size:19px;color:#1a1814;letter-spacing:.03em;margin-bottom:8px;line-height:1.3}"
    +".sc{background:#fff;border-radius:10px;padding:16px;box-shadow:0 1px 6px rgba(0,0,0,.06);border-left:3px solid "+pColor+"}"
    +".sc-i{font-size:20px;margin-bottom:6px}"
    +".sc-t{font-size:13px;font-weight:700;color:#1a1814;margin-bottom:4px}"
    +".sc-s{font-size:11.5px;color:#8A8075;font-family:sans-serif;line-height:1.55}"
    /* Info-Karte rechts groß */
    +".card{background:#fff;border-radius:14px;box-shadow:0 2px 16px rgba(0,0,0,.08);overflow:hidden;display:grid;grid-template-columns:1fr 1fr;min-height:480px;max-width:860px;margin:0 auto;width:100%}"
    +".card-l{padding:36px;display:flex;flex-direction:column;justify-content:center}"
    +".sec{font-size:10px;font-weight:700;letter-spacing:.12em;text-transform:uppercase;color:"+pColor+";margin-bottom:22px;font-family:sans-serif}"
    +".row{display:flex;gap:14px;margin-bottom:22px;align-items:flex-start}"
    +".ico{width:36px;height:36px;border-radius:50%;background:#f5f3ef;display:flex;align-items:center;justify-content:center;flex-shrink:0;font-size:16px}"
    +".lbl{font-size:10px;font-weight:700;letter-spacing:.1em;text-transform:uppercase;color:#8A8075;margin-bottom:4px;font-family:sans-serif}"
    +".val{font-size:14px;color:#1a1814;line-height:1.6}.sub{font-size:12px;color:#8A8075;font-family:sans-serif;line-height:1.7}"
    +"#map{height:100%;min-height:480px}"
    +".cta{background:"+heroBg+";text-align:center;padding:56px 24px}"
    +".cta h2{font-size:clamp(20px,4vw,34px);color:"+heroText+";margin-bottom:10px}"
    +".cta p{font-size:13px;color:"+heroSub+";margin-bottom:24px;font-family:sans-serif}"
    +".foot{background:#111;padding:16px;text-align:center;font-size:11px;color:#555;font-family:sans-serif}"
    +"@media(max-width:860px){.main{grid-template-columns:1fr}.steps{flex-direction:row;flex-wrap:wrap}.steps>div.sc{flex:1;min-width:150px}.card{grid-template-columns:1fr}#map{min-height:295px}}"
    +"<\/style><\/head><body>"
    +"<div class='hero'>"
    +"<div class='tag'>"+evData.fotoart+"<\/div>"
    +(logo?"<img src='"+logo+"' style='max-height:110px;max-width:340px;margin:6px auto 14px;display:block' alt='"+studio+"'>":"")
    +((!logo||evData.name!==studio)?"<h1>"+evData.name+"<\/h1>":"")
    +(_sloganHTML?"<div class='hero-slogan'>"+_sloganHTML+"<\/div>":"")
    +(infoHTML?"<div class='hero-txt'>"+infoHTML+"<\/div>":"")
    +"<a href='"+buchUrl+"/buchen/"+slug+"' class='btn'>Jetzt Termin buchen &rarr;<\/a><\/div>"
    +"<div class='wrap'><div class='main'>"
    /* Linke Spalte: Schritte vertikal */
    +"<div class='steps'>"
    +"<div><div class='steps-tag'>So geht's<\/div><div class='steps-h'>In wenigen Schritten zum Fotoshooting<\/div><\/div>"
    +"<div class='sc'><div class='sc-i'>📅<\/div><div class='sc-t'>1. Wunschtermin auswählen<\/div><div class='sc-s'>Wähle deinen Termin und sichere dir deinen festen Slot.<\/div><\/div>"
    +"<div class='sc'><div class='sc-i'>📝<\/div><div class='sc-t'>2. Shootingvereinbarung ausfüllen<\/div><div class='sc-s'>Du erhältst die Vereinbarung direkt nach der Buchung zum digitalen Unterzeichnen.<\/div><\/div>"
    +"<div class='sc'><div class='sc-i'>💳<\/div><div class='sc-t'>3. Shootinggebühr bezahlen<\/div><div class='sc-s'>Zahlbar per Überweisung oder PayPal vor dem Shooting.<\/div><\/div>"
    +"<div class='sc'><div class='sc-i'>🖼️<\/div><div class='sc-t'>4. Vom Shooting zum Lieblingsbild<\/div><div class='sc-s'>Individuelle und persönliche Onlinegalerie nach dem Shooting.<\/div><\/div>"
    +"<\/div>"
    /* Rechte Spalte: Info + große Karte */
    +"<div class='card'><div class='card-l'><div class='sec'>Alle Infos auf einen Blick<\/div>"
    +(datumStr?"<div class='row'><div class='ico'>📅<\/div><div><div class='lbl'>Wann<\/div><div class='val'>"+datumStr+"<\/div><\/div><\/div>":"")
    +(evData.location?"<div class='row'><div class='ico'>📍<\/div><div><div class='lbl'>Wo<\/div><div class='val'>"+evData.location+"<\/div>"+(adresse?"<div class='sub'>"+adresse+"<\/div>":"")+"<\/div><\/div>":"")
    +(eventInfoHTML?"<div class='row'><div class='ico'>⚡<\/div><div><div class='lbl'>Das Event<\/div><div class='sub'>"+eventInfoHTML+"<\/div><\/div><\/div>":"")
    +"<\/div><div id='map'><\/div><\/div>"
    +"<\/div><\/div>"
    +"<div class='cta'><h2>Jetzt Termin sichern<\/h2><div class='cta-txt'>"+_scarcityHTML+"<\/div><a href='"+buchUrl+"/buchen/"+slug+"' class='btn'>Termin buchen &rarr;<\/a><\/div>"
    +"<div class='foot'>"+studio+" &copy; "+new Date().getFullYear()+"<\/div>"
    +"<script src='https://unpkg.com/leaflet@1.9.4/dist/leaflet.js'><\/script>"
    +"<script>try{var m=L.map('map',{scrollWheelZoom:true}).setView([51.16,10.45],6);"
    +"L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',{attribution:'&copy; OpenStreetMap'}).addTo(m);"
    +(evData.locationLat&&evData.locationLng
      ? `var la=${evData.locationLat},lo=${evData.locationLng};m.setView([la,lo],14);L.marker([la,lo]).addTo(m).bindPopup(${JSON.stringify(evData.location||"")}).openPopup();`
      : `var q=${JSON.stringify(adresse||evData.location||"")};if(q){fetch('https://nominatim.openstreetmap.org/search?format=json&limit=1&q='+encodeURIComponent(q)).then(function(r){return r.json()}).then(function(res){if(res&&res[0]){var la=parseFloat(res[0].lat),lo=parseFloat(res[0].lon);m.setView([la,lo],14);L.marker([la,lo]).addTo(m).bindPopup(${JSON.stringify(evData.location||adresse||"")}).openPopup();}}).catch(function(){});}`
    )
    +"}catch(e){}<\/script>"
    +"<\/body><\/html>";

  // Auf Server hochladen für /landing/[slug]
  try{
    const slug2=evData.slug||evData.buchungsUrl||(()=>{
      const cfg2=JSON.parse(localStorage.getItem("sd_buchung_config")||"{}");
      const st2=(cfg2.shootingTypes||[]).find(s=>s.eventId===evData.id);
      return st2?.buchungsUrl||"";
    })();
    const serverUrl=(localStorage.getItem("sd_server_url")||"").trim().replace(/\/+$/,"");
    if(serverUrl&&slug2){
      const showOkToast=()=>{
        const publicUrl=`${serverUrl}/landing/${slug2}`;
        try{if(navigator.clipboard)navigator.clipboard.writeText(publicUrl).catch(()=>{});}catch{}
        const toast=document.createElement("div");
        toast.textContent="✓ Landingpage aktualisiert";
        Object.assign(toast.style,{position:"fixed",bottom:"24px",left:"50%",transform:"translateX(-50%)",background:"#1a1814",color:"#C9A96E",padding:"12px 20px",borderRadius:"10px",fontSize:"14px",fontWeight:"600",zIndex:"9999",boxShadow:"0 4px 20px rgba(0,0,0,0.4)",maxWidth:"90vw",textAlign:"center"});
        document.body.appendChild(toast);
        setTimeout(()=>toast.remove(),3000);
      };
      const doUpload=(retry)=>fetch(`${serverUrl}/api/landing-upload`,{
        method:"POST",
        headers:{"Content-Type":"application/json"},
        body:JSON.stringify({slug:slug2,html})
      }).then(async r=>{
        const txt=await r.text().catch(()=>"");
        let d=null; try{d=txt?JSON.parse(txt):null;}catch(e){d=null;}
        if(r.ok&&(!d||d.ok!==false)){console.log("Landingpage hochgeladen:",slug2);showOkToast();}
        else throw new Error((d&&d.error)||("Status "+r.status));
      }).catch(e=>{
        if(retry>0){return new Promise(res=>setTimeout(res,700)).then(()=>doUpload(retry-1));}
        console.warn("Upload fehlgeschlagen:",e);
        alert("Landingpage konnte nicht hochgeladen werden.\n\n"+(e&&e.message||e)+"\n\nBitte in ein paar Sekunden nochmal versuchen.");
      });
      doUpload(2);
    }else{
      console.warn("Kein Slug oder Server-URL — kein Upload");
    }
  }catch(e){console.warn("Upload-Fehler:",e);}

  if(opts&&opts.noPreview)return;
  const w=window.open("","_blank");
  if(!w){alert("Popup-Blocker aktiv — bitte in der Adressleiste oben erlauben und nochmal klicken.");return;}
  w.document.open();
  w.document.write(html);
  w.document.close();
}

function EventsPage({events,setEvents,T,onNewShootingplan,shootingplanAbrData,onAbrDataConsumed,onDeleteEvent,onCreateOrdner}){
  const [evArchivOpen,setEvArchivOpen]=useState(false);
  const [modal,setModal]=useState(null);
  const [detail,setDetail]=useState(null);
  const [neuerShootingplan,setNeuerShootingplan]=useState(null);
  const {dir,toggle,sortEvents}=useEventSort();

  // Wenn Abrechnung aus Shootingplan kommt, direkt Event öffnen + Daten laden
  useEffect(()=>{
    if(shootingplanAbrData){
      if(shootingplanAbrData.evId&&shootingplanAbrData.rows?.length>0){
        // Teilnehmer aus Shootingplan ins Event übertragen
        const ev=events.find(e=>e.id===shootingplanAbrData.evId);
        if(ev){
          const preise=ev.preise||{shootingGebuehr:30,bilderFrei:3};
          const neueTeilnehmer=shootingplanAbrData.rows.map(r=>({
            id:uid(),
            nr:r.nr||"",
            name:r.name||"",
            hund:r.hund||"",
            rasse:r.rasse||"",
            anrede:r.anrede||"",
            email:r.email||"",
            telefon:r.telefon||"",
            strasse:r.strasse||"",
            plz:r.plz||"",
            ort:r.ort||"",
            gebuehr:istZusatzTier(r)?0:preise.shootingGebuehr||0,
            bilderFrei:istZusatzTier(r)?0:preise.bilderFrei||0,
            bilderZusatz:istZusatzTier(r)?1:0,
            weitererHund:istZusatzTier(r),
            rechnung:false,bezahlt:false,
            bilderFertig:false,bilderVerschickt:false,
            info:"",notiz:"",
          }));
          // Nur hinzufügen wenn noch keine Teilnehmer oder explizit gewünscht
          if(ev.teilnehmer.length===0||confirm(`${ev.teilnehmer.length} bestehende Teilnehmer vorhanden.
OK = Hinzufügen · Abbrechen = Ersetzen`)){
            setEvents(p=>p.map(e=>e.id===ev.id?{...e,teilnehmer:[...e.teilnehmer,...neueTeilnehmer]}:e));
          } else {
            setEvents(p=>p.map(e=>e.id===ev.id?{...e,teilnehmer:neueTeilnehmer}:e));
          }
        }
        setDetail(shootingplanAbrData.evId);
      } else if(shootingplanAbrData.evId){
        setDetail(shootingplanAbrData.evId);
      } else if(shootingplanAbrData.rows?.length>0){
        // Kein passendes Event gefunden — zeige Auswahl
        setModal("select_for_abr");
        setPendingAbrRows(shootingplanAbrData.rows);
      }
      onAbrDataConsumed&&onAbrDataConsumed();
    }
  },[shootingplanAbrData]);

  const [pendingAbrRows,setPendingAbrRows]=useState(null);

  // CustomEvent listener für "Event öffnen aus Termine-Seite"
  useEffect(()=>{
    const handler=e=>setDetail(e.detail?.id);
    document.addEventListener("openEvent",handler);
    return()=>document.removeEventListener("openEvent",handler);
  },[]);

  if(detail){
    const ev=events.find(e=>e.id===detail);
    if(ev)return <EventDetail event={ev} onUpdate={updated=>setEvents(p=>p.map(e=>e.id===updated.id?updated:e))} onBack={()=>setDetail(null)} T={T} onOpenPlan={e2=>onNewShootingplan&&onNewShootingplan({eventId:e2.id})}/>;
  }

  function save(ev){
    const isNew=!events.find(x=>x.id===ev.id);
    setEvents(p=>p.find(x=>x.id===ev.id)?p.map(x=>x.id===ev.id?ev:x):[...p,ev]);
    setModal(null);
    if(isNew){
      onCreateOrdner&&onCreateOrdner(ev);
      // Automatisch Shootingplan erstellen
      const sp={
        eventId:ev.id,
        event_name:ev.name,
        event_type:ev.fotoart,
        event_date:ev.date,
        event_start:ev.date,
        event_end:ev.date,
        rows:[],
      };
      setNeuerShootingplan({ev,sp});
    }
  }
  function del(id){if(confirm("Veranstaltung wirklich löschen? Veranstaltungsplan, Abrechnung und Buchungsplan werden mitgelöscht."))(onDeleteEvent?onDeleteEvent(id):setEvents(p=>p.filter(x=>x.id!==id)));}
  const evHeute=new Date();
  const isEvArchiv=ev=>{
    return !!(ev.abgesagt||ev.status==="abgesagt"||ev.abgeschlossen);
  };
  const aktivEvents=events.filter(ev=>!isEvArchiv(ev));
  const archivEvents=events.filter(ev=>isEvArchiv(ev));

  return(
    <div>
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:24}}>
        <div style={{fontSize:13,color:T.muted,marginTop:2}}>{aktivEvents.length} Events · {archivEvents.length} archiviert</div>
        <div style={{display:"flex",alignItems:"center",gap:8}}>
          <SortBtn dir={dir} toggle={toggle} T={T}/>
          <button style={btn(T,"primary")} onClick={()=>setModal("new")}>+ Neue Veranstaltung</button>
        </div>
      </div>

      {evArchivOpen&&(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.55)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:300}}>
          <div style={{background:T.surface,borderRadius:14,width:"80vw",maxHeight:"80vh",overflow:"hidden",display:"flex",flexDirection:"column",border:`1px solid ${T.border}`}}>
            <div style={{padding:"16px 20px",borderBottom:`1px solid ${T.border}`,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              <div style={{fontFamily:"Georgia,serif",fontSize:18,color:T.accent}}>Archiv – Vergangene & Abgesagte Veranstaltungen</div>
              <button onClick={()=>setEvArchivOpen(false)} style={{background:"none",border:"none",fontSize:20,cursor:"pointer",color:T.muted}}>×</button>
            </div>
            <div style={{overflowY:"auto",padding:20,display:"flex",flexDirection:"column",gap:8}}>
              {archivEvents.length===0?<p style={{color:T.muted}}>Keine archivierten Veranstaltungen.</p>:sortEvents(archivEvents).map(ev=>{
                const calc=calcEvent(ev);
                return(<div key={ev.id} onClick={()=>{setEvArchivOpen(false);setDetail(ev.id);}} style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:"12px 16px",cursor:"pointer",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                  <div>
                    <div style={{fontSize:13,fontWeight:600,color:T.text}}>{ev.name}</div>
                    <div style={{fontSize:11,color:T.muted}}>{fmtDateRange(ev)} · {ev.fotoart||""} · {(ev.teilnehmer||[]).filter(t=>!/^online_.+_\d+$/.test(String(t&&t.id||""))).length} Teilnehmer</div>
                  </div>
                  <div style={{display:"flex",alignItems:"center",gap:10}}>
                    <div style={{fontSize:12,fontWeight:600,color:ev.abgesagt?T.muted:T.accent}}>
                      {ev.abgesagt?"abgesagt":calc.auszahlung.toFixed(2)+" €"}
                    </div>
                    <button
                      title={ev.abgesagt?"Absage zurücknehmen":"Als abgesagt markieren — zählt dann nicht zu den Einnahmen"}
                      onClick={e=>{e.stopPropagation();
                        if(!ev.abgesagt&&!window.confirm(`"${ev.name}" als abgesagt markieren?\n\nSie zählt dann nicht mehr zu den Einnahmen.`))return;
                        setEvents(p=>p.map(x=>x.id===ev.id?{...x,abgesagt:!x.abgesagt}:x));
                      }}
                      style={{padding:"4px 10px",borderRadius:6,cursor:"pointer",fontFamily:"inherit",fontSize:11,fontWeight:600,
                              background:"transparent",
                              border:`1px solid ${ev.abgesagt?"#C0563E66":T.border}`,
                              color:ev.abgesagt?"#C0563E":T.muted}}>
                      {ev.abgesagt?"✕ Abgesagt":"Absagen"}
                    </button>
                  </div>
                </div>);
              })}
            </div>
          </div>
        </div>
      )}

      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(320px,1fr))",gap:16,alignItems:"stretch"}}>
        {sortEvents(aktivEvents).map(ev=>{
          const calc=calcEvent(ev);
          const abg=!!ev.abgeschlossen;
          return(
            <div key={ev.id} onClick={()=>setDetail(ev.id)} style={{background:T.surface,border:`2px solid ${abg?"#4caf5066":T.border}`,borderRadius:12,padding:20,cursor:"pointer",transition:"all 0.15s",position:"relative",display:"flex",flexDirection:"column"}}
              onMouseEnter={e=>{e.currentTarget.style.borderColor=abg?"#4caf5099":T.accent+"66";e.currentTarget.style.transform="translateY(-1px)";}}
              onMouseLeave={e=>{e.currentTarget.style.borderColor=abg?"#4caf5066":T.border;e.currentTarget.style.transform="";}}>
              {abg&&<div style={{position:"absolute",top:10,right:10,background:"#4caf50",color:"#fff",fontSize:10,fontWeight:700,borderRadius:6,padding:"2px 8px",letterSpacing:"0.06em"}}>✓ ABGESCHLOSSEN</div>}
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:12}}>
                <div>
                  <div style={{fontFamily:"Georgia,serif",fontSize:16,fontWeight:700,color:abg?T.muted:T.text}}>{ev.name}</div>
                  <div style={{fontSize:12,color:T.muted,marginTop:2}}>{fmtDateRange(ev)} · {ev.location}</div>
                  <div style={{fontSize:11,color:T.muted}}>{ev.fotoart}</div>
                </div>
                <Badge label={`${ev.teilnehmer.length} 🐾`} color={abg?"#4caf50":T.accent}/>
              </div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:8,marginBottom:14}}>
                {[
                  {l:"Einnahme",v:fmtEuro(calc.gesamtEinnahme)},
                  {l:"Ausgabe",v:fmtEuro(calc.gesamtAusgabe)},
                  {l:"Auszahlung",v:fmtEuro(calc.auszahlung),c:calc.auszahlung>=0?T.success:T.danger},
                ].map(x=>(
                  <div key={x.l} style={{background:T.bg,borderRadius:8,padding:"8px 10px",textAlign:"center"}}>
                    <div style={{fontSize:10,color:T.muted,textTransform:"uppercase",letterSpacing:"0.07em"}}>{x.l}</div>
                    <div style={{fontSize:13,fontWeight:600,color:x.c||T.text,marginTop:2}}>{x.v}</div>
                  </div>
                ))}
              </div>
              <div style={{display:"flex",gap:8,marginTop:"auto"}}>
                <button style={{...btn(T,"primary",true),flex:1,justifyContent:"center"}} onClick={()=>setDetail(ev.id)}>Öffnen</button>
                <button style={{...btn(T,abg?"ghost":"ghost",true),fontSize:11,color:abg?"#4caf50":T.muted,borderColor:abg?"#4caf5066":T.border}} onClick={e=>{e.stopPropagation();setEvents(p=>p.map(x=>x.id===ev.id?{...x,abgeschlossen:!x.abgeschlossen}:x));}}>{abg?"✓ Abgeschlossen":"Abschließen"}</button>
                <button style={{...btn(T,"ghost",true),fontSize:11,color:ev.abgesagt?"#C0563E":T.muted,borderColor:ev.abgesagt?"#C0563E66":T.border}}
                  title={ev.abgesagt?"Absage zurücknehmen":"Veranstaltung als abgesagt markieren"}
                  onClick={e=>{e.stopPropagation();
                    if(!ev.abgesagt&&!window.confirm(`"${ev.name}" als abgesagt markieren?\n\nSie wandert ins Archiv und zählt nicht mehr zu den Einnahmen.`))return;
                    setEvents(p=>p.map(x=>x.id===ev.id?{...x,abgesagt:!x.abgesagt}:x));
                  }}>{ev.abgesagt?"✕ Abgesagt":"Absagen"}</button>
                <button style={btn(T,"ghost",true)} onClick={e=>{e.stopPropagation();setModal(ev);}}><Ic n="edit" s={13}/></button>
                <button style={btn(T,"danger",true)} onClick={e=>{e.stopPropagation();del(ev.id);}}>✕</button>
              </div>
            </div>
          );
        })}
        {events.length===0&&<div style={{gridColumn:"1/-1",textAlign:"center",padding:60,color:T.muted}}>Noch keine Events. Erstelle dein erstes Event!</div>}
        <div onClick={()=>setEvArchivOpen(true)} style={{background:T.surface,border:`2px dashed ${T.border}`,borderRadius:12,padding:20,cursor:"pointer",transition:"all 0.15s",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",gap:8}}
          onMouseEnter={e=>{e.currentTarget.style.borderColor=T.accent+"99";e.currentTarget.style.transform="translateY(-1px)";}}
          onMouseLeave={e=>{e.currentTarget.style.borderColor=T.border;e.currentTarget.style.transform="";}}>
          <div style={{fontSize:28}}>🗄️</div>
          <div style={{fontFamily:"Georgia,serif",fontSize:14,fontWeight:700,color:T.muted}}>Archiv</div>
          <div style={{fontSize:12,color:T.muted}}>{archivEvents.length+" Veranstaltung"+(archivEvents.length!==1?"en":"")}</div>
        </div>
      </div>

      {modal&&<EventModal event={modal==="new"?null:modal} onSave={save} onClose={()=>setModal(null)} T={T}/>}
      {neuerShootingplan&&(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.75)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:200,padding:20}}>
          <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:16,padding:28,maxWidth:440,width:"100%"}}>
            <div style={{fontSize:24,marginBottom:12,textAlign:"center"}}>🎯</div>
            <div style={{fontFamily:"Georgia,serif",fontSize:18,color:T.accent,marginBottom:8,textAlign:"center"}}>Veranstaltungsplan erstellt</div>
            <p style={{fontSize:13,color:T.muted,marginBottom:16,textAlign:"center",lineHeight:1.6}}>
              Für <strong style={{color:T.text}}>{neuerShootingplan.ev.name}</strong> wurde automatisch ein leerer Veranstaltungsplan angelegt.
            </p>
            <div style={{background:T.bg,borderRadius:8,padding:"10px 14px",fontSize:12,color:T.muted,marginBottom:20}}>
              📅 {fmtDate(neuerShootingplan.ev.date)} · {neuerShootingplan.ev.fotoart} · {neuerShootingplan.ev.location||"—"}
            </div>
            <div style={{display:"flex",flexDirection:"column",gap:10}}>
              <div style={{display:"flex",gap:10}}>
                <button style={{...btn(T,"ghost"),flex:1,justifyContent:"center"}} onClick={()=>{
                  onNewShootingplan&&onNewShootingplan(neuerShootingplan.sp);
                  setNeuerShootingplan(null);
                }}>
                  <svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"><circle cx="8" cy="8" r="6"/><circle cx="8" cy="8" r="2.5"/><line x1="8" y1="1.5" x2="8" y2="4"/><line x1="8" y1="12" x2="8" y2="14.5"/><line x1="1.5" y1="8" x2="4" y2="8"/><line x1="12" y1="8" x2="14.5" y2="8"/></svg>
                  Veranstaltungsplan
                </button>
                <button style={{...btn(T,"primary"),flex:1,justifyContent:"center"}} onClick={()=>{
                  generateLandingPageFromEvent(neuerShootingplan.ev);
                  setNeuerShootingplan(null);
                }}>
                  <svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"><circle cx="8" cy="8" r="6"/><line x1="2" y1="8" x2="14" y2="8"/><path d="M8 2c-2 2-2.5 4-2.5 6s.5 4 2.5 6"/><path d="M8 2c2 2 2.5 4 2.5 6s-.5 4-2.5 6"/></svg>
                  Landingpage
                </button>
              </div>
              <button style={{...btn(T,"ghost"),justifyContent:"center",fontSize:11}} onClick={()=>setNeuerShootingplan(null)}>Später</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ── Dashboard ─────────────────────────────────────────────────────────────────
function InteressentenKachel({T,cardStyle,maskName,btn,setPage,oeffneBuchungsplan}){
  const sv=(localStorage.getItem("sd_server_url")||"").replace(/\/+$/,"");
  const [dashInt,setDashInt]=useState([]);
  const [showAlleInt,setShowAlleInt]=useState(false);
  useEffect(()=>{
    if(!sv)return;
    fetch(sv+"/api/interessenten").then(r=>r.ok?r.json():null).then(d=>{if(Array.isArray(d)&&d.length>0)setDashInt(d);}).catch(()=>{});
  },[]);
  const grouped={};
  dashInt.forEach(int=>{const k=int.shootingType||"Unbekannt";if(!grouped[k])grouped[k]=[];grouped[k].push(int);});
  const shootings=Object.entries(grouped);
  // immer anzeigen
  return(<>
    <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr 1fr",gap:16,marginTop:16}}>
      <div style={{...cardStyle,height:170,overflow:"hidden",position:"relative",padding:16}}>
        <div style={{fontFamily:"Georgia,serif",fontSize:15,color:T.accent,marginBottom:12}}>
          Interessenten<span style={{marginLeft:8,fontSize:12,background:"#f59e0b",color:"#fff",borderRadius:10,padding:"1px 7px"}}>{dashInt.length}</span>
        </div>
        <div style={{display:"flex",flexDirection:"column",gap:8}}>
          {shootings.slice(0,2).map(([shooting,ints],i)=>(
            <div key={i} onClick={()=>{localStorage.setItem("sd_bp_nav","interessenten");localStorage.setItem("sd_bp_shooting",shooting);setPage&&setPage("buchung");}} style={{padding:"8px 10px",background:T.bg,borderRadius:8,border:`1px solid ${T.border}`,cursor:"pointer"}}>
              <div style={{fontSize:13,fontWeight:600,color:T.accent}}>{shooting}</div>
              <div style={{fontSize:11,color:T.muted}}>{maskName(ints.map(x=>x.name).join(", "))} · {ints.length} Interessent{ints.length!==1?"en":""}</div>
            </div>
          ))}
        </div>
        {shootings.length>2&&<button onClick={()=>setShowAlleInt(s=>!s)} style={{position:"absolute",bottom:0,left:0,right:0,fontSize:11,color:T.accent,background:T.surface,border:"none",borderTop:`1px solid ${T.border}33`,cursor:"pointer",padding:"6px 0",textAlign:"center"}}>{"▼ Alle "+dashInt.length+" anzeigen"}</button>}
      </div>
    </div>
    {showAlleInt&&<><div style={{position:"fixed",inset:0,zIndex:200}} onClick={()=>setShowAlleInt(false)}/>
    <div style={{position:"fixed",top:"50%",left:"50%",transform:"translate(-50%,-50%)",width:520,background:T.surface,borderRadius:12,border:`1px solid ${T.border}`,padding:20,zIndex:201,boxShadow:"0 8px 32px rgba(0,0,0,0.18)",maxHeight:"70vh",overflowY:"auto"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
        <div style={{fontFamily:"Georgia,serif",fontSize:15,color:T.accent}}>Interessenten nach Shooting</div>
        <button style={btn(T,"ghost",true)} onClick={()=>setShowAlleInt(false)}>▲ Weniger</button>
      </div>
      {shootings.map(([shooting,ints],i)=>(
        <div key={i} style={{marginBottom:12}}>
          <div style={{fontSize:13,fontWeight:700,color:T.accent,marginBottom:6}}>{shooting} <span style={{fontSize:11,color:T.muted,fontWeight:400}}>({ints.length})</span></div>
          {ints.map((int,j)=>(
            <div key={j} style={{padding:"6px 10px",background:T.bg,borderRadius:7,border:`1px solid ${T.border}`,marginBottom:4}}>
              <div style={{fontSize:13,fontWeight:600,color:T.text}}>{maskName(int.name)}</div>
              <div style={{fontSize:11,color:T.muted}}>{int.terminwahl?(isNaN(Date.parse(int.terminwahl))?int.terminwahl:new Date(int.terminwahl).toLocaleDateString("de-DE")):"Kein Wunschtermin"}</div>
            </div>
          ))}
        </div>
      ))}
    </div></>}
  </>);
}

function Dashboard({customers,setCustomers,bookings,setBookings,events,setPage,setEvents,T,onNewBooking,onNewCustomer,onOpenEventBookings,oeffneBuchungsplan,onOpenShootingplan}){
  const now=new Date();
  const [sortDir,setSortDir]=useState("asc");
  const [showAllTermine,setShowAllTermine]=useState(false);
  const [showAllEvents,setShowAllEvents]=useState(false);
  const [showAllAuftrV,setShowAllAuftrV]=useState(false);
  const [showAllAuftrE,setShowAllAuftrE]=useState(false);
  const [showAllBestellungen,setShowAllBestellungen]=useState(false);
  const [showEvRev,setShowEvRev]=useState(false);
  // Sortierung der Tabelle "Einnahmen je Veranstaltung", frei waehlbar.
  const [evRevSort,setEvRevSort]=useState(()=>{
    try{return JSON.parse(localStorage.getItem("sd_evrev_sort")||"null")||{key:"datum",dir:"asc"};}
    catch(e){return {key:"datum",dir:"asc"};}
  });
  function evRevSortieren(key){
    setEvRevSort(s=>{
      const neu=s.key===key?{key,dir:s.dir==="asc"?"desc":"asc"}:{key,dir:key==="datum"?"asc":"asc"};
      localStorage.setItem("sd_evrev_sort",JSON.stringify(neu));
      return neu;
    });
  }
  const [todos,setTodos]=useState(()=>{try{return JSON.parse(localStorage.getItem("sd_todos")||"[]");}catch{return [];}});
  const openEvent=(evId)=>{setPage("events");setTimeout(()=>document.dispatchEvent(new CustomEvent("openEvent",{detail:{id:evId}})),300);};
  const [todoInput,setTodoInput]=useState("");
  const [todoModal,setTodoModal]=useState(false);
  const [todoPopups,setTodoPopups]=useState([]);
  const [dashKundeModal,setDashKundeModal]=useState(null);
  const [dashBookingModal,setDashBookingModal]=useState(null);
  const [hideErtrag,setHideErtrag]=useState(()=>localStorage.getItem("sd_hide_ertrag")==="1");
  const [showErtragSplit,setShowErtragSplit]=useState(false);
  const ertragClickTimer=useRef(null); // trennt Einfach- von Doppelklick
  const maskName=(name)=>hideErtrag?"••••••":name;
  function saveTodos(t){setTodos(t);localStorage.setItem("sd_todos",JSON.stringify(t));}
  useEffect(()=>{
    const today=new Date();today.setHours(0,0,0,0);
    const fällig=todos.filter(t=>{
      if(t.done||!t.datum)return false;
      const d=new Date(t.datum);d.setHours(0,0,0,0);
      const erinnerDiff=(t.erinnerungTage||0);
      const triggerDate=new Date(d);triggerDate.setDate(triggerDate.getDate()-erinnerDiff);
      return triggerDate<=today&&d>=today;
    });
    setTodoPopups(fällig);
  },[todos]);
  const [todoFarbe,setTodoFarbe]=useState("gelb");
  const [todoDatum,setTodoDatum]=useState("");
  const [todoErinnerung,setTodoErinnerung]=useState(0);
  function addTodo(){
    if(!todoInput.trim())return;
    saveTodos([...todos,{id:uid(),text:todoInput.trim(),done:false,farbe:todoFarbe,datum:todoDatum||null,erinnerungTage:parseInt(todoErinnerung)||0}]);
    setTodoInput("");setTodoDatum("");setTodoErinnerung(0);setTodoFarbe("gelb");
  }
  function toggleTodo(id){saveTodos(todos.map(t=>t.id===id?{...t,done:!t.done}:t));}
  function updateTodoText(id,text){saveTodos(todos.map(t=>t.id===id?{...t,text}:t));}
  const [todoEditId,setTodoEditId]=useState(null);
  function delTodo(id){saveTodos(todos.filter(t=>t.id!==id));}

  const upcomingBookings=bookings.filter(b=>new Date(b.date)>now&&b.status!=="storniert").map(b=>({
    _type:"booking",id:b.id,date:b.date,
    label:customers.find(c=>c.id===b.customerId)?.name||"?",
    sub:terminHunde(b,customers.find(c=>c.id===b.customerId)).join(" & "),
    status:STATUS[b.status]?.label,statusColor:STATUS[b.status]?.color,
    icon:<Ic n="invoice" s={15}/>,
  }));
  const upcomingEvents=events.filter(ev=>ev.date&&new Date(ev.date)>now&&!ev.abgesagt&&!ev.abgeschlossen).map(ev=>({
    _type:"event",id:ev.id,date:ev.date,label:ev.name,
    sub:(ev.fotoart||"")+(ev.location?" · "+ev.location:""),
    status:`${teilnehmerAnzahl(ev)} Teiln.`,statusColor:"#C9A96E",
    icon:<Ic n="calendar" s={15}/>,
  }));
  const upcoming=[...upcomingBookings,...upcomingEvents].sort((a,b)=>sortDir==="asc"?new Date(a.date)-new Date(b.date):new Date(b.date)-new Date(a.date));
  const revenue=bookings.filter(b=>b.status==="abgeschlossen").reduce((s,b)=>s+terminBetrag(b),0);
  // Nur abgeschlossene Veranstaltungen zaehlen zum Ertrag. Geplante enthalten
  // meist nur Vorkosten und wuerden die Kennzahl ins Minus ziehen.
  const evRevenue=events.filter(ev=>!ev.abgesagt&&ev.abgeschlossen).reduce((s,ev)=>s+calcEvent(ev).auszahlung,0);
  const unsigned=bookings.filter(b=>b.status==="gebucht"&&!b.signed&&!b.vertragVorhanden&&!customers.find(x=>x.id===b.customerId)?.rahmenvertrag).length;

  const allBuchungen=(()=>{try{return JSON.parse(localStorage.getItem("sd_buchungen")||"[]");}catch{return [];}})();
  const buchungCfg=(()=>{try{return JSON.parse(localStorage.getItem("sd_buchung_config")||"{}");}catch{return {};}})();

  const offeneAuftraegeV=(()=>{
    const list=[];
    events.forEach(ev=>{
      (ev.teilnehmer||[]).forEach(t=>{
        const bilder=t.bilderAnzahl||t.bilder||(parseInt(t.bilderFrei||0)+parseInt(t.bilderZusatz||0))||0;
        if(!t.name||!t.bestelldatum||t.bilderFertig)return;
        list.push({name:t.name,event:ev.name,eventId:ev.id,datum:ev.date,bilder,bestelldatum:t.bestelldatum});
      });
    });
    const grouped={};
    list.forEach(item=>{
      const key=item.name+"||"+item.event;
      if(!grouped[key])grouped[key]={...item};
      else grouped[key].bilder=(grouped[key].bilder||0)+(item.bilder||0);
    });
    const merged=Object.values(grouped);
    const pd=s=>{const p=String(s||"").split(".");return p.length<3?0:new Date(+p[2],(+p[1]||1)-1,+p[0]||1).getTime();};
    return merged.sort((a,b)=>pd(a.bestelldatum)-pd(b.bestelldatum));
  })();

  // Jeder Fototermin kann einen eigenen Bildauftrag haben. Deshalb wird die
  // Liste flach aufgebaut: der Termin selbst und zusaetzlich jeder weitere
  // Fototermin mit eigener Bilderzahl und eigenem Bestelldatum.
  const offeneAuftraegeE=bookings.flatMap(b=>{
    const raus=[];
    const serie=Array.isArray(b.serie)?b.serie:[];
    const mehrere=serie.length>1;
    // "bilderFertig" haengt am einzelnen Fototermin, "bilderAbgeschlossen" am
    // ganzen Auftrag. Offen ist ein Fototermin also, solange seine Bilder nicht
    // fertig sind — sonst stuende ein Kunde noch hier, obwohl nur ein spaeteres
    // Shooting der Serie aussteht.
    if(b.bilderAnzahl>0&&b.bilderBestelldatum&&!b.bilderFertig&&!b.bilderAbgeschlossen)
      raus.push({...b,_orig:b,_terminNr:mehrere?1:0});
    serie.forEach((z,i)=>{
      if(i===0||!z)return;
      if(!(z.bilderAnzahl>0&&z.bilderBestelldatum))return;
      if(z.bilderFertig||b.bilderAbgeschlossen)return;
      raus.push({...b,_orig:b,_terminNr:i+1,
        bilderAnzahl:z.bilderAnzahl,bilderBestelldatum:z.bilderBestelldatum,
        bilderLinkVerschickt:z.bilderLinkVerschickt??b.bilderLinkVerschickt,
        bilderBezahlt:z.bilderBezahlt??b.bilderBezahlt});
    });
    return raus;
  }).sort((a,b)=>new Date(a.bilderBestelldatum)-new Date(b.bilderBestelldatum));

  const ueberfaellig=(()=>{
    const heute=new Date();const list=[];const seen=new Set();
    events.forEach(ev=>{
      if(ev.abgeschlossen||ev.storniert||ev.abgesagt)return;
      (ev.teilnehmer||[]).forEach(t=>{
        if(t.bestelldatum||!t.name||t.keinAuftrag)return;
        const shootDatum=ev.date?new Date(ev.date):null;
        if(!shootDatum)return;
        const diffTage=Math.floor((heute-shootDatum)/(1000*60*60*24));
        if(diffTage<14)return;
        const key=t.name+"_"+ev.id;
        if(seen.has(key))return;
        seen.add(key);
        list.push({name:t.name,event:ev.name,eventId:ev.id,teilnehmerId:t.id||t.name,diffTage,
          stufe:diffTage>=56?2:1,erinnerung1:t.erinnerung1||null,erinnerung2:t.erinnerung2||null});
      });
    });
    return list.sort((a,b)=>b.diffTage-a.diffTage);
  })();

  const markErinnerung=(eventId,teilnehmerId,stufe)=>{
    const today=new Date().toLocaleDateString("de-DE");
    if(setEvents){
      setEvents(prev=>prev.map(ev=>{
        if(ev.id!==eventId)return ev;
        return {...ev,teilnehmer:(ev.teilnehmer||[]).map(t=>{
          if((t.id||t.name)!==teilnehmerId)return t;
          return stufe===1?{...t,erinnerung1:today}:{...t,erinnerung2:today};
        })};
      }));
    }
    // Name aus Events holen
    const ev2=events.find(e=>e.id===eventId);
    const t2=ev2?.teilnehmer?.find(t=>(t.id||t.name)===teilnehmerId);
    const name2=t2?.name||teilnehmerId;
    alert("Erinnerung Stufe "+stufe+" für "+name2+" vermerkt.");
  };

  const fmtEvDate=s=>{if(!s)return "";try{return new Date(s).toLocaleDateString("de-DE",{day:"2-digit",month:"2-digit",year:"numeric"});}catch{return s;}};
  const cardStyle={background:T.surface,border:`1px solid ${T.border}`,borderRadius:12,padding:20};

  return(
    <div>
      {/* Stats */}
      <div style={{display:"grid",gridTemplateColumns:"repeat(5,1fr)",gap:12,marginBottom:24}}>
        {[
          {label:"Kunden",value:customers.length,icon:<Ic n="users" s={20}/>,onClick:()=>setPage("customers")},
          {label:"Einzelbuchungen",value:bookings.length,icon:<Ic n="calendar" s={20}/>,onClick:()=>setPage("bookings")},
          {label:"Abrechnung",value:events.length,icon:<Ic n="invoice" s={20}/>,onClick:()=>setPage("events")},
          {label:"Gesamtertrag",value:hideErtrag?"••••••":fmtEuro(revenue+evRevenue),icon:<Ic n="euro" s={20}/>,
            onClick:()=>{
              // Kurz warten: kommt ein zweiter Klick, war es ein Doppelklick.
              if(ertragClickTimer.current)return;
              ertragClickTimer.current=setTimeout(()=>{ertragClickTimer.current=null;setShowErtragSplit(true);},260);
            },
            onDblClick:()=>{
              if(ertragClickTimer.current){clearTimeout(ertragClickTimer.current);ertragClickTimer.current=null;}
              const n=!hideErtrag;setHideErtrag(n);localStorage.setItem("sd_hide_ertrag",n?"1":"0");
            }},
          {label:"Newsletter-Abonnenten",value:(()=>{
            const k=customers.filter(c=>c.newsletter&&c.email).length;
            const a=(()=>{try{return JSON.parse(localStorage.getItem("sd_nl_abonnenten")||"[]");}catch{return [];}})().filter(a=>a.aktiv).length;
            return k+a;
          })(),icon:<Ic n="mail" s={20}/>,onClick:()=>{
            // Merker, damit die Kundenseite gleich im richtigen Reiter aufgeht
            try{sessionStorage.setItem("sd_kunden_view","abonnenten");}catch(e){}
            setPage("customers");
          }},
        ].map(s=>(
          <div key={s.label} onClick={s.onClick||undefined} onDoubleClick={s.onDblClick||undefined}
            style={{background:T.tile,border:`1px solid ${s.label==="Gesamtertrag"?T.accent+"44":T.tileBorder}`,borderRadius:12,padding:"18px 16px",textAlign:"center",cursor:s.onClick?"pointer":"default",transition:"border-color 0.15s"}}>
            <div style={{fontSize:22,marginBottom:4}}>{s.icon}</div>
            <div style={{fontFamily:"Georgia,serif",fontSize:s.value.toString().length>8?18:26,color:T.accent}}>{s.value}</div>
            <div style={{fontSize:11,color:T.muted,marginTop:2,textTransform:"uppercase",letterSpacing:"0.07em"}}>{s.label}</div>
          </div>
        ))}
      </div>

      {/* Schnellzugriff */}
      <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:12,marginBottom:24}}>
        <TileGroup title="Kunden" cols={2} T={T}>
          <Tile T={T} icon={<Ic n="plus"/>} label="Neuer Kunde" onClick={onNewCustomer}/>
          <Tile T={T} icon={<Ic n="users"/>} label="Alle Kunden" onClick={()=>setPage("customers")}/>
        </TileGroup>
        <TileGroup title="Buchungen" cols={3} T={T}>
          <Tile T={T} icon={<Ic n="calendar"/>} label="Neuer Termin" onClick={onNewBooking}/>
          <Tile T={T} icon={<Ic n="invoice"/>} label="Übersicht" onClick={()=>setPage("bookings")}/>
          <Tile T={T} icon={<Ic n="calendar"/>} label="Kalender" onClick={()=>setPage("calendar")}/>
        </TileGroup>
        <TileGroup title="Events & Statistik" cols={3} T={T}>
          <Tile T={T} icon={<Ic n="invoice"/>} label="Abrechnung" onClick={()=>setPage("events")}/>
          <Tile T={T} icon={<Ic n="chart"/>} label="Statistik" onClick={()=>setPage("statistik")}/>
          <Tile T={T} icon={<Ic n="euro"/>} label="Einnahmen" sub="je Veranstaltung" onClick={()=>setShowEvRev(true)}/>
        </TileGroup>
        {showErtragSplit&&(()=>{
          // Geplante Veranstaltungen enthalten oft nur Vorkosten (Standgebuehr,
          // Hotel). Sie werden getrennt ausgewiesen und zaehlen nicht zum Ertrag.
          // Nach Datum sortiert, aelteste zuerst. Eintraege ohne Datum ans Ende.
          const nachDatum=(a,b)=>{
            if(!a.sort&&!b.sort)return String(a.name||"").localeCompare(String(b.name||""),"de");
            if(!a.sort)return 1;
            if(!b.sort)return -1;
            return String(a.sort).localeCompare(String(b.sort));
          };
          const evAlle=[...events].filter(ev=>!ev.abgesagt)
            .map(ev=>({name:ev.name,datum:ev.date?fmtDateRange(ev):"",sort:String(ev.date||"").slice(0,10),
                       betrag:calcEvent(ev).auszahlung,fertig:!!ev.abgeschlossen}));
          const evFertig=evAlle.filter(x=>x.fertig).sort(nachDatum);
          const evGeplant=evAlle.filter(x=>!x.fertig).sort(nachDatum);
          const btListe=bookings.filter(b=>b.status==="abgeschlossen")
            .map(b=>({name:customers.find(c=>c.id===b.customerId)?.name||"—",
                      datum:b.date?fmtDate(b.date):"",sort:String(b.date||"").slice(0,10),
                      betrag:terminBetrag(b)}))
            .sort(nachDatum);
          const summe=l=>l.reduce((x,y)=>x+y.betrag,0);
          const evSum=summe(evFertig),geplantSum=summe(evGeplant),btSum=summe(btListe);
          const geld=v=>hideErtrag?"••••":fmtEuro(v);
          // Gedeckte Farben, damit die drei Bereiche auf einen Blick
          // auseinandergehen, ohne dass die Aufstellung bunt wirkt.
          const TON={
            fertig: {bg:"#EAF1EA", rand:"#B9CDBA", schrift:"#2F5D3A", kopf:"#E0EBE1"},
            geplant:{bg:"#F6EBE8", rand:"#DCC3BC", schrift:"#8A4A38", kopf:"#EFE0DB"},
            einzel: {bg:"#F2EAF1", rand:"#D3BFD1", schrift:"#6E3F68", kopf:"#EADEE9"},
          };
          const Zeile=ton=>z=>(
            <div key={z.name+z.datum} style={{display:"flex",justifyContent:"space-between",gap:12,
                 padding:"8px 10px",background:ton.bg,borderLeft:`3px solid ${ton.rand}`,
                 borderBottom:`1px solid ${ton.rand}55`}}>
              <div style={{minWidth:0}}>
                <div style={{fontSize:13,color:ton.schrift,fontWeight:600,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{z.name}</div>
                <div style={{fontSize:11,color:ton.schrift,opacity:0.7}}>{z.datum||"kein Datum"}</div>
              </div>
              <div style={{fontFamily:"Georgia,serif",fontSize:14,fontWeight:700,whiteSpace:"nowrap",
                   color:z.betrag<0?"#A6462F":ton.schrift}}>{geld(z.betrag)}</div>
            </div>
          );
          const Block=({titel,anzahl,ton,children})=>(
            <div style={{marginBottom:18,borderRadius:10,overflow:"hidden",border:`1px solid ${ton.rand}`}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"baseline",
                   background:ton.kopf,padding:"9px 12px"}}>
                <div style={{fontFamily:"Georgia,serif",fontSize:15,color:ton.schrift}}>{titel}</div>
                <div style={{fontSize:11,color:ton.schrift,opacity:0.75}}>{anzahl}</div>
              </div>
              {children}
            </div>
          );
          const Fuss=({label,wert,ton})=>(
            <div style={{display:"flex",justifyContent:"space-between",background:ton.kopf,padding:"9px 12px",
                 borderTop:`1px solid ${ton.rand}`}}>
              <div style={{fontSize:13,fontWeight:700,color:ton.schrift}}>{label}</div>
              <div style={{fontFamily:"Georgia,serif",fontSize:16,fontWeight:700,
                   color:wert<0?"#A6462F":ton.schrift}}>{geld(wert)}</div>
            </div>
          );
          return(
            <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.7)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:200,padding:20}} onClick={()=>setShowErtragSplit(false)}>
              <div onClick={e=>e.stopPropagation()} style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:16,padding:28,width:"100%",maxWidth:1000,maxHeight:"90vh",display:"flex",flexDirection:"column"}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:4}}>
                  <div style={{fontFamily:"Georgia,serif",fontSize:18,color:T.accent}}>Gesamtertrag – Aufstellung</div>
                  <button style={btn(T,"ghost",true)} onClick={()=>setShowErtragSplit(false)}>✕</button>
                </div>
                <div style={{fontSize:11,color:T.muted,marginBottom:18}}>Doppelklick auf die Kachel blendet die Beträge aus.</div>

                <div style={{display:"flex",gap:28,flexWrap:"wrap",overflowY:"auto",flex:1,minHeight:0}}>
                  <div style={{flex:1,minWidth:280}}>
                    <Block titel="Veranstaltungen" anzahl={evFertig.length} ton={TON.fertig}>
                      {evFertig.length===0?<div style={{color:T.muted,fontSize:12,padding:"10px 12px"}}>Nichts abgeschlossen.</div>:evFertig.map(Zeile(TON.fertig))}
                      <Fuss label="Summe" wert={evSum} ton={TON.fertig}/>
                    </Block>
                    {evGeplant.length>0&&(
                      <Block titel="Geplant (zählt nicht)" anzahl={evGeplant.length} ton={TON.geplant}>
                        {evGeplant.map(Zeile(TON.geplant))}
                        <Fuss label="Bisherige Vorkosten" wert={geplantSum} ton={TON.geplant}/>
                      </Block>
                    )}
                  </div>
                  <div style={{flex:1,minWidth:280}}>
                    <Block titel="Einzeltermine" anzahl={btListe.length} ton={TON.einzel}>
                      {btListe.length===0?<div style={{color:T.muted,fontSize:12,padding:"10px 12px"}}>Nichts vorhanden.</div>:btListe.map(Zeile(TON.einzel))}
                      <Fuss label="Summe" wert={btSum} ton={TON.einzel}/>
                    </Block>
                  </div>
                </div>

                <div style={{display:"flex",justifyContent:"space-between",alignItems:"baseline",borderTop:`2px solid ${T.accent}55`,marginTop:16,paddingTop:12}}>
                  <div style={{fontSize:14,fontWeight:700,color:T.text}}>Gesamtertrag</div>
                  <div style={{fontFamily:"Georgia,serif",fontSize:20,fontWeight:700,color:T.accent}}>{geld(evSum+btSum)}</div>
                </div>
              </div>
            </div>
          );
        })()}

        {showEvRev&&(
          <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.7)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:200,padding:20}} onClick={()=>setShowEvRev(false)}>
            <div onClick={e=>e.stopPropagation()} style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:16,padding:28,width:"100%",maxWidth:1300,maxHeight:"90vh",overflowY:"auto"}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
                <div style={{fontFamily:"Georgia,serif",fontSize:18,color:T.accent}}>Einnahmen je Veranstaltung</div>
                <button style={btn(T,"ghost",true)} onClick={()=>setShowEvRev(false)}>✕</button>
              </div>
              {events.filter(ev=>!ev.abgesagt).length===0?<p style={{color:T.muted}}>Noch keine Veranstaltungen.</p>:(()=>{
                // Abgesagte Veranstaltungen haben nie stattgefunden und
                // gehoeren deshalb nicht in die Einnahmen.
                // Veranstaltungen ohne Datum ans Ende, sonst neueste zuerst.
                // Ohne diese Absicherung liefert der Vergleich NaN und die
                // Liste bleibt teilweise unsortiert.
                const zeit=ev=>{const t=ev.date?new Date(ev.date).getTime():NaN;return isNaN(t)?null:t;};
                const wert=(ev,key)=>{
                  if(key==="name")return String(ev.name||"").toLowerCase();
                  if(key==="datum")return zeit(ev);
                  if(key==="art")return String(ev.shootingart||ev.fotoart||"").toLowerCase();
                  if(key==="teilnehmer")return teilnehmerAnzahl(ev);
                  if(key==="einnahmen")return calcEvent(ev).auszahlung;
                  if(key==="status")return ev.abgeschlossen?1e12:(zeit(ev)??null);
                  return null;
                };
                const richtung=evRevSort.dir==="asc"?1:-1;
                const sorted=[...events].filter(ev=>!ev.abgesagt).sort((a,b)=>{
                  const va=wert(a,evRevSort.key),vb=wert(b,evRevSort.key);
                  const leerA=va===null||va===undefined||va==="";
                  const leerB=vb===null||vb===undefined||vb==="";
                  if(leerA&&leerB)return String(a.name||"").localeCompare(String(b.name||""),"de");
                  if(leerA)return 1;   // ohne Wert immer ans Ende
                  if(leerB)return -1;
                  if(typeof va==="number"&&typeof vb==="number")return (va-vb)*richtung;
                  return String(va).localeCompare(String(vb),"de")*richtung;
                });
                const gesamt=sorted.reduce((s,ev)=>s+calcEvent(ev).auszahlung,0);
                return(<div style={{overflowX:"auto"}}>
                  <table style={{width:"100%",borderCollapse:"collapse",fontSize:13}}>
                    <thead><tr style={{borderBottom:`2px solid ${T.border}`}}>
                      {[["Veranstaltung","left","name"],["Datum","left","datum"],["Shootingart","left","art"],["Teilnehmer","center","teilnehmer"],["Einnahmen","right","einnahmen"],["Status","center","status"]].map(([h,align,key])=>(
                        <th key={h} onClick={()=>evRevSortieren(key)} title="Zum Sortieren klicken"
                          style={{textAlign:align,padding:"6px 10px",fontSize:11,
                                  color:evRevSort.key===key?T.accent:T.muted,fontWeight:700,
                                  textTransform:"uppercase",letterSpacing:"0.07em",whiteSpace:"nowrap",
                                  cursor:"pointer",userSelect:"none"}}>
                          {h}{evRevSort.key===key?(evRevSort.dir==="asc"?" ↑":" ↓"):" ↕"}
                        </th>
                      ))}
                    </tr></thead>
                    <tbody>{sorted.map((ev,i)=>{
                      const calc=calcEvent(ev);const d=daysUntil(ev.date);
                      const vergangen=!!ev.abgeschlossen||daysUntil(ev.dateBis||ev.date)<0;
                      const status=ev.abgeschlossen?"✓ Abgeschlossen"
                        :!ev.date||isNaN(d)?"kein Datum"
                        :d<0?`vor ${Math.abs(d)} Tagen`
                        :d===0?"Heute":d===1?"Morgen":`in ${d} Tagen`;
                      return(<tr key={ev.id} style={{borderBottom:`1px solid ${T.border}22`,cursor:"pointer"}}
                        onClick={()=>{setShowEvRev(false);setPage("events");}}
                        onMouseEnter={e=>e.currentTarget.style.background=T.accentDim}
                        onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
                        <td style={{padding:"10px",fontWeight:600,color:T.text}}>{ev.name}</td>
                        <td style={{padding:"10px",color:T.muted,whiteSpace:"nowrap"}}>{ev.date?fmtDateRange(ev):""}</td>
                        <td style={{padding:"10px",color:T.muted}}>{ev.shootingart||ev.fotoart||""}</td>
                        <td style={{padding:"10px",textAlign:"center",fontWeight:600}}>{teilnehmerAnzahl(ev)}</td>
                        
                        <td style={{padding:"10px 10px",textAlign:"right",fontFamily:"Georgia,serif",fontSize:16,fontWeight:700,color:calc.auszahlung>0?T.accent:T.muted}}>{fmtEuro(calc.auszahlung)}</td>
                        <td style={{padding:"10px",whiteSpace:"nowrap",fontSize:11,color:vergangen?T.muted:T.accent,fontWeight:600,textAlign:"center"}}>{status}</td>
                      </tr>);
                    })}</tbody>
                    <tfoot>
                      <tr><td colSpan={6} style={{padding:"12px 0 0 0"}}></td></tr>
                      <tr style={{borderTop:`2px solid ${T.border}`}}>
                      <td colSpan={3} style={{padding:"12px 10px 10px",fontSize:13,color:T.text,fontWeight:700}}>Gesamt</td>
                      <td style={{padding:"10px",textAlign:"center",fontWeight:700}}>{sorted.reduce((s,ev)=>s+teilnehmerAnzahl(ev),0)}</td>
                      <td style={{padding:"10px",textAlign:"right",fontFamily:"Georgia,serif",fontSize:18,fontWeight:700,color:T.accent}}>{fmtEuro(gesamt)}</td>
                      <td></td>
                    </tr></tfoot>
                  </table>
                </div>);
              })()}
            </div>
          </div>
        )}
        <TileGroup title="Schnell" cols={2} T={T}>
          <Tile T={T} icon={<Ic n="edit"/>} label="Verträge" sub={unsigned>0?`${unsigned} offen`:""} accent={unsigned>0} onClick={()=>setPage("bookings")}/>
          <Tile T={T} icon={<Ic n="inbox"/>} label="E-Mails" onClick={()=>setPage("bookings")}/>
        </TileGroup>
      </div>

      {/* Zeile 1 */}
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr 1fr",gap:16,marginBottom:16,alignItems:"start"}}>
        {/* Nächste Termine */}
        <div style={{...cardStyle,height:260,overflow:"hidden",position:"relative"}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
            <div style={{fontFamily:"Georgia,serif",fontSize:15,color:T.accent}}>Nächste Termine</div>
            <button style={btn(T,"ghost",true)} onClick={()=>setSortDir(d=>d==="asc"?"desc":"asc")}>{sortDir==="asc"?"↑ Datum":"↓ Datum"}</button>
          </div>
          {upcoming.length===0?<p style={{color:T.muted,fontSize:13}}>Keine Termine geplant.</p>:upcoming.slice(0,3).map(item=>{
            const d=daysUntil(item.date);
            return(<div key={item.id} style={{display:"flex",alignItems:"center",gap:12,padding:"10px 0",borderBottom:`1px solid ${T.border}22`,cursor:"pointer"}} onClick={()=>{if(item._type==="event"&&onOpenShootingplan){const ev=events.find(e=>e.id===item.id);if(ev){onOpenShootingplan({eventId:ev.id,eventName:ev.name});return;}}setPage(item._type==="event"?"events":"bookings");}}>
              <div style={{width:28,height:28,borderRadius:"50%",background:T.accentDim,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>{item.icon}</div>
              <div style={{flex:1,minWidth:0}}>
                <div style={{fontSize:14,fontWeight:600,color:T.text,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{item._type==="booking"?maskName(item.label):item.label}</div>
                <div style={{fontSize:13,color:T.muted}}>{fmtEvDate(item.date)}{!hideErtrag&&item.sub?" · "+item.sub:""}</div>
              </div>
              <div style={{textAlign:"right",flexShrink:0}}>
                <Badge label={hideErtrag?"••":item.status} color={item.statusColor}/>
                <div style={{fontSize:13,color:T.muted,marginTop:2}}>{d===0?"Heute":d===1?"Morgen":`in ${d} Tagen`}</div>
              </div>
            </div>);
          })}
          {upcoming.length>3&&<button onClick={()=>setShowAllTermine(s=>!s)} style={{position:"absolute",bottom:0,left:0,right:0,fontSize:13,color:T.accent,background:T.surface,border:"none",borderTop:`1px solid ${T.border}33`,cursor:"pointer",padding:"6px 0",textAlign:"center"}}>{"▼ Alle "+upcoming.length+" anzeigen"}</button>}
        </div>
        {showAllTermine&&<div style={{position:"fixed",inset:0,zIndex:200,background:"rgba(0,0,0,0.55)"}} onClick={()=>setShowAllTermine(false)}/>}
        {showAllTermine&&<div style={{position:"fixed",top:"50%",left:"50%",transform:"translate(-50%,-50%)",width:480,background:T.surface,borderRadius:12,border:`1px solid ${T.border}`,padding:20,zIndex:201,boxShadow:"0 8px 32px rgba(0,0,0,0.18)",maxHeight:"70vh",overflowY:"auto"}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
            <div style={{fontFamily:"Georgia,serif",fontSize:15,color:T.accent}}>Nächste Termine</div>
            <button style={btn(T,"ghost",true)} onClick={()=>setShowAllTermine(false)}>▲ Weniger</button>
          </div>
          {upcoming.map(item=>{const d=daysUntil(item.date);return(<div key={item.id} style={{display:"flex",alignItems:"center",gap:12,padding:"4px 0",borderBottom:`1px solid ${T.border}22`,cursor:"pointer"}} onClick={()=>{if(item._type==="event"&&onOpenShootingplan){const ev=events.find(e=>e.id===item.id);if(ev){setShowAllTermine(false);onOpenShootingplan({eventId:ev.id,eventName:ev.name});return;}}setPage(item._type==="event"?"events":"bookings");setShowAllTermine(false);}}>
            <div style={{width:28,height:28,borderRadius:"50%",background:T.accentDim,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>{item.icon}</div>
            <div style={{flex:1,minWidth:0}}>
              <div style={{fontSize:14,fontWeight:600,color:T.text,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{item._type==="booking"?maskName(item.label):item.label}</div>
              <div style={{fontSize:13,color:T.muted}}>{fmtEvDate(item.date)}{!hideErtrag&&item.sub?" · "+item.sub:""}</div>
            </div>
            <div style={{textAlign:"right",flexShrink:0}}><Badge label={hideErtrag?"••":item.status} color={item.statusColor}/><div style={{fontSize:13,color:T.muted,marginTop:2}}>{d===0?"Heute":d===1?"Morgen":`in ${d} Tagen`}</div></div>
          </div>);})}
        </div>}

        {/* Veranstaltungen */}
        {(()=>{
          const heute=new Date();heute.setHours(0,0,0,0);
          const aktiveEvs=[...events].filter(ev=>!ev.abgeschlossen&&ev.date&&new Date(ev.date)>=heute&&!((buchungCfg.shootingTypes||[]).find(s=>s.eventId===ev.id)?.interessenliste)).sort((a,b)=>sortDir==="asc"?new Date(a.date)-new Date(b.date):new Date(b.date)-new Date(a.date));
          const renderEv=(ev,clk)=>{
            const plaene=(()=>{try{return JSON.parse(localStorage.getItem("sd_shootingplaene")||"{}");}catch{return {};}})();
            const planRows=Array.isArray(plaene[ev.id])?plaene[ev.id]:[];
            const echteRows=planRows.filter(r=>!r.blocked&&((r.name||"").trim()||(r.email||"").trim()||(r.telefon||"").trim()));
            const gesamt=teilnehmerAnzahl(ev);
            const abg=echteRows.filter(r=>r.bilderFertig||r.bezahlt).length;
            // Tagesgenau vergleichen: sonst gilt eine Veranstaltung schon
            // am Vormittag ihres eigenen Tages als vergangen. Bei mehrtaegigen
            // zaehlt der letzte Tag.
            const d=daysUntil(ev.date);
            const dEnde=daysUntil(ev.dateBis||ev.date);
            const vergangen=!!ev.abgeschlossen||dEnde<0;
            return(<div key={ev.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"10px 0",borderBottom:`1px solid ${T.border}22`,cursor:"pointer"}} onClick={clk||(() =>setPage("events"))}>
              <div style={{minWidth:0,flex:1}}>
                <div style={{fontSize:14,fontWeight:600,color:vergangen?T.muted:T.text,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{ev.name}</div>
                <div style={{fontSize:13,color:T.muted}}>{fmtDateRange(ev)}{vergangen?" · fertig":d===0?" · Heute":d===1?" · Morgen":` · in ${d} Tagen`}</div>
              </div>
              <div style={{flexShrink:0,marginLeft:8,textAlign:"right"}}>
                {gesamt>0?<div style={{fontSize:14,fontWeight:600,color:T.accent}}>{hideErtrag?"••":gesamt+" Teilnehmer"}</div>:<span style={{fontSize:13,color:T.muted}}>{hideErtrag?"••":"keine Buchungen"}</span>}
              </div>
            </div>);
          };
          return(<>
            <div style={{...cardStyle,height:260,overflow:"hidden",position:"relative"}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
                <div style={{fontFamily:"Georgia,serif",fontSize:15,color:T.accent}}>Veranstaltungen</div>
                <button style={btn(T,"ghost",true)} onClick={()=>setSortDir(d=>d==="asc"?"desc":"asc")}>{sortDir==="asc"?"↑ Datum":"↓ Datum"}</button>
              </div>
              {aktiveEvs.length===0?<p style={{color:T.muted,fontSize:13}}>Keine Veranstaltungen.</p>:aktiveEvs.slice(0,3).map(ev=>renderEv(ev,()=>{if(onOpenShootingplan){onOpenShootingplan({eventId:ev.id,eventName:ev.name});}else{setPage("events");}}))}
              {aktiveEvs.length>3&&<button onClick={()=>setShowAllEvents(s=>!s)} style={{position:"absolute",bottom:0,left:0,right:0,fontSize:13,color:T.accent,background:T.surface,border:"none",borderTop:`1px solid ${T.border}33`,cursor:"pointer",padding:"6px 0",textAlign:"center"}}>{"▼ Alle "+aktiveEvs.length+" anzeigen"}</button>}
            </div>
            {showAllEvents&&<div style={{position:"fixed",inset:0,zIndex:200,background:"rgba(0,0,0,0.55)"}} onClick={()=>setShowAllEvents(false)}/>}
            {showAllEvents&&<div style={{position:"fixed",top:"50%",left:"50%",transform:"translate(-50%,-50%)",width:480,background:T.surface,borderRadius:12,border:`1px solid ${T.border}`,padding:20,zIndex:201,boxShadow:"0 8px 32px rgba(0,0,0,0.18)",maxHeight:"70vh",overflowY:"auto"}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
                <div style={{fontFamily:"Georgia,serif",fontSize:15,color:T.accent}}>Veranstaltungen</div>
                <button style={btn(T,"ghost",true)} onClick={()=>setShowAllEvents(false)}>▲ Weniger</button>
              </div>
              {aktiveEvs.map(ev=>renderEv(ev,()=>{if(onOpenShootingplan){setShowAllEvents(false);onOpenShootingplan({eventId:ev.id,eventName:ev.name});}else{setPage("events");setShowAllEvents(false);}}))}
            </div>}
          </>);
        })()}

        {/* Offene Bildaufträge Veranstaltung */}
        <div style={{...cardStyle,height:260,overflow:"hidden",position:"relative"}}>
          <div style={{fontFamily:"Georgia,serif",fontSize:15,color:T.accent,marginBottom:14}}>Offene Bildaufträge Veranstaltung</div>
          {offeneAuftraegeV.length===0?<p style={{color:T.muted,fontSize:13}}>Keine offenen Aufträge.</p>
            :offeneAuftraegeV.slice(0,3).map((a,i)=>(
              <div key={i} style={{display:"flex",alignItems:"center",gap:8,padding:"4px 0",borderBottom:`1px solid ${T.border}22`}}>
                <div style={{flex:1,fontSize:14,fontWeight:600,color:T.accent,minWidth:0,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",cursor:"pointer",textDecoration:"underline"}} onClick={()=>openEvent(a.eventId)}>{maskName(a.name)}</div>
                <div style={{flex:2,fontSize:13,color:T.muted,minWidth:0,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{a.event}</div>
                <div style={{fontSize:14,fontWeight:600,color:T.accent,flexShrink:0}}>{a.bilder} Bilder</div>
              </div>
            ))}
          {offeneAuftraegeV.length>3&&<button onClick={()=>setShowAllAuftrV(true)} style={{position:"absolute",bottom:0,left:0,right:0,fontSize:13,color:T.accent,background:T.surface,border:"none",borderTop:`1px solid ${T.border}33`,cursor:"pointer",padding:"6px 0",textAlign:"center"}}>{"▼ Alle "+offeneAuftraegeV.length+" anzeigen"}</button>}
        </div>
        {showAllAuftrV&&<><div style={{position:"fixed",inset:0,zIndex:200,background:"rgba(0,0,0,0.55)"}} onClick={()=>setShowAllAuftrV(false)}/>
        <div style={{position:"fixed",top:"50%",left:"50%",transform:"translate(-50%,-50%)",width:520,background:T.surface,borderRadius:12,border:`1px solid ${T.border}`,padding:20,zIndex:201,boxShadow:"0 8px 32px rgba(0,0,0,0.18)",maxHeight:"70vh",overflowY:"auto"}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
            <div style={{fontFamily:"Georgia,serif",fontSize:15,color:T.accent}}>Offene Bildaufträge Veranstaltung</div>
            <button style={btn(T,"ghost",true)} onClick={()=>setShowAllAuftrV(false)}>▲ Weniger</button>
          </div>
          {offeneAuftraegeV.map((a,i)=>(
            <div key={i} style={{display:"flex",alignItems:"center",gap:8,padding:"4px 0",borderBottom:`1px solid ${T.border}22`}}>
              <div style={{flex:1,fontSize:14,fontWeight:600,color:T.accent,minWidth:0,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",cursor:"pointer",textDecoration:"underline"}} onClick={()=>openEvent(a.eventId)}>{maskName(a.name)}</div>
              <div style={{flex:2,fontSize:13,color:T.muted,minWidth:0,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{a.event}</div>
              <div style={{fontSize:14,fontWeight:600,color:T.accent,flexShrink:0}}>{a.bilder} Bilder</div>
            </div>
          ))}
        </div></>}

        {/* Überfällige Bestellungen */}
        <div style={{...cardStyle,height:260,position:"relative",display:"flex",flexDirection:"column"}}>
          <div style={{fontFamily:"Georgia,serif",fontSize:15,color:T.accent,marginBottom:14}}>Überfällige Bestellungen</div>
          <div style={{flex:1,overflow:"hidden"}}>
          {ueberfaellig.length===0?<p style={{color:T.muted,fontSize:13}}>Keine überfälligen Bestellungen.</p>
            :ueberfaellig.slice(0,2).map((u,i)=>(
              <div key={i} style={{padding:"10px 0",borderBottom:`1px solid ${T.border}22`}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:4}}>
                  <div>
                    <div style={{fontSize:14,fontWeight:600,color:T.accent,cursor:"pointer",textDecoration:"underline"}} onClick={()=>openEvent(u.eventId)}>{maskName(u.name)}</div>
                    <div style={{fontSize:13,color:T.muted}}>{u.event}</div>
                  </div>
                  <span style={{fontSize:12,color:T.muted}}>{u.diffTage} Tage</span>
                </div>
                <div style={{display:"flex",gap:6}}>
                  <button onClick={()=>markErinnerung(u.eventId,u.teilnehmerId,1)} style={{fontSize:13,padding:"3px 10px",borderRadius:6,border:`1px solid ${T.border}`,background:u.erinnerung1?"#d4edda":"transparent",color:u.erinnerung1?"#155724":T.muted,cursor:"pointer"}}>{u.erinnerung1?"Stufe 1: "+u.erinnerung1:"Stufe 1 senden"}</button>
                  <button onClick={()=>markErinnerung(u.eventId,u.teilnehmerId,2)} style={{fontSize:13,padding:"3px 10px",borderRadius:6,border:`1px solid ${T.border}`,background:u.erinnerung2?"#d4edda":"transparent",color:u.erinnerung2?"#155724":T.muted,cursor:"pointer"}}>{u.erinnerung2?"Stufe 2: "+u.erinnerung2:"Stufe 2 senden"}</button>
                </div>
              </div>
            ))}
          </div>
          {ueberfaellig.length>2&&<button onClick={()=>setShowAllBestellungen(true)} style={{flexShrink:0,fontSize:13,color:T.accent,background:"none",border:"none",borderTop:`1px solid ${T.border}33`,cursor:"pointer",padding:"6px 0",textAlign:"center",width:"100%"}}>{"▼ Alle "+ueberfaellig.length+" anzeigen"}</button>}
        </div>
        {showAllBestellungen&&<div style={{position:"fixed",inset:0,zIndex:200,background:"rgba(0,0,0,0.55)"}} onClick={()=>setShowAllBestellungen(false)}/>}
        {showAllBestellungen&&<div style={{position:"fixed",top:"50%",left:"50%",transform:"translate(-50%,-50%)",width:520,background:T.surface,borderRadius:12,border:`1px solid ${T.border}`,padding:20,zIndex:201,boxShadow:"0 8px 32px rgba(0,0,0,0.18)",maxHeight:"70vh",overflowY:"auto"}}>
          <div style={{display:"flex",justifyContent:"space-between",marginBottom:16}}>
            <div style={{fontFamily:"Georgia,serif",fontSize:15,color:T.accent}}>Überfällige Bestellungen</div>
            <button onClick={()=>setShowAllBestellungen(false)} style={{background:"none",border:"none",cursor:"pointer",fontSize:18,color:T.muted}}>×</button>
          </div>
          {ueberfaellig.map((u,i)=>(
            <div key={i} style={{padding:"10px 0",borderBottom:`1px solid ${T.border}22`}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:4}}>
                <div>
                  <div style={{fontSize:14,fontWeight:600,color:T.accent,cursor:"pointer",textDecoration:"underline"}} onClick={()=>{openEvent(u.eventId);setShowAllBestellungen(false);}}>{maskName(u.name)}</div>
                  <div style={{fontSize:13,color:T.muted}}>{u.event}</div>
                </div>
                <span style={{fontSize:12,color:T.muted}}>{u.diffTage} Tage</span>
              </div>
              <div style={{display:"flex",gap:6}}>
                <button onClick={()=>markErinnerung(u.eventId,u.teilnehmerId,1)} style={{fontSize:13,padding:"3px 10px",borderRadius:6,border:`1px solid ${T.border}`,background:u.erinnerung1?"#d4edda":"transparent",color:u.erinnerung1?"#155724":T.muted,cursor:"pointer"}}>{u.erinnerung1?"Stufe 1: "+u.erinnerung1:"Stufe 1 senden"}</button>
                <button onClick={()=>markErinnerung(u.eventId,u.teilnehmerId,2)} style={{fontSize:13,padding:"3px 10px",borderRadius:6,border:`1px solid ${T.border}`,background:u.erinnerung2?"#d4edda":"transparent",color:u.erinnerung2?"#155724":T.muted,cursor:"pointer"}}>{u.erinnerung2?"Stufe 2: "+u.erinnerung2:"Stufe 2 senden"}</button>
              </div>
            </div>
          ))}
        </div>}
      </div>

      {/* Zeile 2: To-Do + Galerien + Einzeltermin + Info */}
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr 1fr",gap:16,alignItems:"start"}}>
        {/* To-Do */}
        <div style={{...cardStyle,height:210,overflow:"hidden",cursor:"pointer",position:"relative"}} onClick={()=>setTodoModal(true)}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
            <div style={{fontFamily:"Georgia,serif",fontSize:15,color:T.accent}}>To-Do-Liste</div>
            <span style={{fontSize:13,color:T.muted}}>{todos.filter(t=>!t.done).length} offen</span>
          </div>
          {todos.length===0&&<p style={{color:T.muted,fontSize:13}}>Keine Aufgaben. Klicken zum Hinzufügen.</p>}
          <div style={{display:"flex",flexDirection:"column",gap:6}}>
            {todos.slice(0,3).map(todo=>(
              <div key={todo.id} style={{display:"flex",alignItems:"center",gap:8,padding:"5px 8px",background:todo.done?T.border+"22":todo.farbe==="rot"?"#fef2f2":todo.farbe==="grün"?"#f0fdf4":"#fffbeb",borderRadius:7,opacity:todo.done?0.5:1,border:`1px solid ${todo.done?T.border:todo.farbe==="rot"?"#fca5a5":todo.farbe==="grün"?"#86efac":"#fcd34d"}`}}>
                <input type="checkbox" checked={todo.done} onClick={e=>e.stopPropagation()} onChange={()=>toggleTodo(todo.id)} style={{accentColor:T.accent,width:14,height:14,cursor:"pointer"}}/>
                <span style={{flex:1,fontSize:13,color:todo.done?T.muted:T.text,textDecoration:todo.done?"line-through":"none"}}>{maskName(todo.text)}{todo.datum&&<span style={{display:"block",fontSize:10,color:T.muted}}>📅 {new Date(todo.datum).toLocaleDateString("de-DE")}</span>}</span>
              </div>
            ))}
          </div>
          {todos.length>3&&<button onClick={e=>{e.stopPropagation();setTodoModal(true);}} style={{position:"absolute",bottom:0,left:0,right:0,fontSize:13,color:T.accent,background:T.surface,border:"none",borderTop:`1px solid ${T.border}33`,cursor:"pointer",padding:"6px 0",textAlign:"center"}}>{"▼ Alle "+todos.length+" anzeigen"}</button>}
        </div>
        {todoModal&&(
          <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.55)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:300}} onClick={()=>setTodoModal(false)}>
            <div style={{background:T.surface,borderRadius:14,width:720,maxHeight:"80vh",overflow:"hidden",display:"flex",flexDirection:"column",border:`1px solid ${T.border}`}} onClick={e=>e.stopPropagation()}>
              <div style={{padding:"16px 20px",borderBottom:`1px solid ${T.border}`,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                <div style={{fontFamily:"Georgia,serif",fontSize:18,color:T.accent}}>To-Do-Liste</div>
                <button onClick={()=>setTodoModal(false)} style={{background:"none",border:"none",fontSize:20,cursor:"pointer",color:T.muted}}>×</button>
              </div>
              <div style={{padding:"14px 20px",borderBottom:`1px solid ${T.border}`}}>
                <div style={{display:"flex",gap:8,marginBottom:8}}>
                  <textarea value={todoInput} onChange={e=>setTodoInput(e.target.value)} onKeyDown={e=>{if(e.key==="Enter"&&e.ctrlKey)addTodo();}} placeholder="Neue Aufgabe... (Strg+Enter zum Speichern)" autoFocus rows={3} style={{flex:1,background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:"8px 12px",color:T.text,fontSize:13,outline:"none",fontFamily:"inherit",resize:"vertical",lineHeight:1.5}}/>
                  <button onClick={addTodo} style={{...btn(T,"primary"),padding:"8px 16px",fontSize:13}}>+</button>
                </div>
                <div style={{display:"flex",gap:8,alignItems:"center",flexWrap:"wrap"}}>
                  <div style={{display:"flex",gap:4}}>
                    {[["rot","#dc2626"],["gelb","#d97706"],["grün","#16a34a"]].map(([f,c])=>(
                      <button key={f} onClick={()=>setTodoFarbe(f)} style={{width:22,height:22,borderRadius:"50%",background:c,border:todoFarbe===f?"2px solid #1a1814":"2px solid transparent",cursor:"pointer",padding:0}}/>
                    ))}
                  </div>
                  <input type="date" value={todoDatum} onChange={e=>setTodoDatum(e.target.value)} style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:6,padding:"4px 8px",color:T.text,fontSize:12,fontFamily:"inherit",outline:"none"}}/>
                  <div style={{display:"flex",alignItems:"center",gap:4,fontSize:12,color:T.muted}}>
                    <span>Erinnerung</span>
                    <input type="number" min={0} max={365} value={todoErinnerung} onChange={e=>setTodoErinnerung(e.target.value)} style={{width:48,background:T.bg,border:`1px solid ${T.border}`,borderRadius:6,padding:"4px 6px",color:T.text,fontSize:12,fontFamily:"inherit",outline:"none",textAlign:"center"}}/>
                    <span>Tage vorher</span>
                  </div>
                </div>
              </div>
              <div style={{overflowY:"auto",padding:"12px 20px",display:"flex",flexDirection:"column",gap:8}}>
                {todos.length===0&&<p style={{color:T.muted,fontSize:13,textAlign:"center",padding:"20px 0"}}>Keine Aufgaben.</p>}
                {todos.map(todo=>(
                  <div key={todo.id} style={{display:"flex",alignItems:"center",gap:10,padding:"9px 12px",background:todo.done?T.border+"22":todo.farbe==="rot"?"#fef2f2":todo.farbe==="grün"?"#f0fdf4":"#fffbeb",borderRadius:8,border:`1px solid ${todo.done?T.border:todo.farbe==="rot"?"#fca5a5":todo.farbe==="grün"?"#86efac":"#fcd34d"}`,opacity:todo.done?0.6:1}}>
                    <input type="checkbox" checked={todo.done} onChange={()=>toggleTodo(todo.id)} style={{accentColor:T.accent,width:15,height:15,cursor:"pointer"}}/>
                    {todoEditId===todo.id
                      ? <textarea autoFocus value={todo.text} onChange={e=>updateTodoText(todo.id,e.target.value)} onBlur={()=>setTodoEditId(null)} onKeyDown={e=>{if(e.key==="Escape")setTodoEditId(null);}} style={{flex:1,background:T.bg,border:`1px solid ${T.accent}`,borderRadius:6,padding:"4px 8px",color:T.text,fontSize:13,fontFamily:"inherit",resize:"vertical",outline:"none",minHeight:40}}/>
                      : <span onDoubleClick={()=>setTodoEditId(todo.id)} style={{flex:1,fontSize:13,color:todo.done?T.muted:T.text,textDecoration:todo.done?"line-through":"none",cursor:"text",whiteSpace:"pre-wrap"}}>{todo.text}</span>}
                    <button onClick={()=>delTodo(todo.id)} style={{background:"none",border:"none",color:T.muted,cursor:"pointer",fontSize:14,padding:"0 2px"}}
                      onMouseEnter={e=>e.currentTarget.style.color="#e53"} onMouseLeave={e=>e.currentTarget.style.color=T.muted}>✕</button>
                  </div>
                ))}
              </div>
              {todos.filter(t=>t.done).length>0&&(
                <div style={{padding:"10px 20px",borderTop:`1px solid ${T.border}`}}>
                  <button onClick={()=>saveTodos(todos.filter(t=>!t.done))} style={{fontSize:13,color:T.muted,background:"none",border:"none",cursor:"pointer",padding:0}}>Erledigte löschen</button>
                </div>
              )}
            </div>
          </div>
        )}
        {/* Todo Popups */}
        {todoPopups.filter(t=>t.farbe==="rot").length>0&&(
          <div style={{position:"fixed",top:"50%",left:"50%",transform:"translate(-50%,-50%)",zIndex:9999,background:"#dc2626",color:"#fff",borderRadius:14,padding:28,maxWidth:480,width:"90%",boxShadow:"0 8px 40px rgba(0,0,0,0.4)"}}>
            <div style={{fontFamily:"Georgia,serif",fontSize:18,marginBottom:12}}>🔴 Erinnerung!</div>
            {todoPopups.filter(t=>t.farbe==="rot").map(t=>(
              <div key={t.id} style={{marginBottom:10,padding:"8px 12px",background:"rgba(0,0,0,0.15)",borderRadius:8}}>
                <div style={{fontWeight:600,fontSize:14}}>{t.text}</div>
                {t.datum&&<div style={{fontSize:12,opacity:0.85,marginTop:3}}>📅 {new Date(t.datum).toLocaleDateString("de-DE")}</div>}
              </div>
            ))}
            <button onClick={()=>setTodoPopups(p=>p.filter(t=>t.farbe!=="rot"))} style={{marginTop:12,padding:"8px 20px",background:"rgba(0,0,0,0.2)",border:"none",borderRadius:8,color:"#fff",cursor:"pointer",fontFamily:"inherit",fontSize:14}}>OK</button>
          </div>
        )}
        {todoPopups.filter(t=>t.farbe==="rot").length>0&&<div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.5)",zIndex:9998}}/>}
        {/* Galerie Kachel */}
        <GalerieKachel T={T} btn={btn} cardStyle={cardStyle} setPage={setPage}/>
        {/* Einzeltermin */}
        <div style={{...cardStyle,height:210,overflow:"hidden",position:"relative"}}>
          <div style={{fontFamily:"Georgia,serif",fontSize:15,color:T.accent,marginBottom:14}}>Offene Bildaufträge Einzeltermin</div>
          {offeneAuftraegeE.length===0?<p style={{color:T.muted,fontSize:13}}>Keine offenen Aufträge.</p>
            :offeneAuftraegeE.slice(0,2).map((b,i)=>(
              <div key={i} style={{padding:"4px 0",borderBottom:`1px solid ${T.border}22`}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                  <div style={{fontSize:14,fontWeight:600,color:T.accent,cursor:"pointer",textDecoration:"underline"}} onClick={()=>setDashBookingModal(b._orig||b)}>{maskName(customers.find(c=>c.id===b.customerId)?.name||"?")+(b._terminNr?" · "+b._terminNr+". Termin":"")}</div>
                  <span style={{fontSize:14,fontWeight:600,color:T.accent}}>{b.bilderAnzahl} Bilder</span>
                </div>
                <div style={{fontSize:13,color:T.muted,display:"flex",gap:12,marginTop:3}}>
                  <span>Best. {b.bilderBestelldatum?new Date(b.bilderBestelldatum).toLocaleDateString("de-DE"):""}</span>
                  <span style={{color:b.bilderLinkVerschickt?"#4caf50":T.muted}}>{b.bilderLinkVerschickt?"✓":"○"} Link</span>
                  <span style={{color:b.bilderBezahlt?"#4caf50":T.muted}}>{b.bilderBezahlt?"✓":"○"} Bezahlt</span>
                </div>
              </div>
            ))}
          {offeneAuftraegeE.length>2&&<button onClick={()=>setShowAllAuftrE(true)} style={{position:"absolute",bottom:0,left:0,right:0,fontSize:13,color:T.accent,background:T.surface,border:"none",borderTop:`1px solid ${T.border}33`,cursor:"pointer",padding:"6px 0",textAlign:"center"}}>{"▼ Alle "+offeneAuftraegeE.length+" anzeigen"}</button>}
        </div>
        {showAllAuftrE&&<><div style={{position:"fixed",inset:0,zIndex:200,background:"rgba(0,0,0,0.55)"}} onClick={()=>setShowAllAuftrE(false)}/>
        <div style={{position:"fixed",top:"50%",left:"50%",transform:"translate(-50%,-50%)",width:520,background:T.surface,borderRadius:12,border:`1px solid ${T.border}`,padding:20,zIndex:201,boxShadow:"0 8px 32px rgba(0,0,0,0.18)",maxHeight:"70vh",overflowY:"auto"}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
            <div style={{fontFamily:"Georgia,serif",fontSize:15,color:T.accent}}>Offene Bildaufträge Einzeltermin</div>
            <button style={btn(T,"ghost",true)} onClick={()=>setShowAllAuftrE(false)}>▲ Weniger</button>
          </div>
          {offeneAuftraegeE.map((b,i)=>(
            <div key={i} style={{padding:"4px 0",borderBottom:`1px solid ${T.border}22`}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                <div style={{fontSize:14,fontWeight:600,color:T.accent,cursor:"pointer",textDecoration:"underline"}} onClick={()=>setDashBookingModal(b._orig||b)}>{maskName(customers.find(c=>c.id===b.customerId)?.name||"?")+(b._terminNr?" · "+b._terminNr+". Termin":"")}</div>
                <span style={{fontSize:14,fontWeight:600,color:T.accent}}>{b.bilderAnzahl} Bilder</span>
              </div>
              <div style={{fontSize:13,color:T.muted,display:"flex",gap:12,marginTop:3}}>
                <span>Best. {b.bilderBestelldatum?new Date(b.bilderBestelldatum).toLocaleDateString("de-DE"):""}</span>
                <span style={{color:b.bilderLinkVerschickt?"#4caf50":T.muted}}>{b.bilderLinkVerschickt?"✓":"○"} Link</span>
                <span style={{color:b.bilderBezahlt?"#4caf50":T.muted}}>{b.bilderBezahlt?"✓":"○"} Bezahlt</span>
              </div>
            </div>
          ))}
        </div></>}
        {/* Info Kachel */}
        {(()=>{
          const [infoKachelFor,setInfoKachelFor]=useState(null);
          const [infoSelEv,setInfoSelEv]=useState(null); // gewählte Veranstaltung im Overlay
          const [infoOffen,setInfoOffen]=useState(false);
          // Infos nach Veranstaltung gruppieren
          const infoProEv=[];
          events.forEach(ev=>{
            const eintraege=(ev.teilnehmer||[]).filter(t=>t.info&&t.info.trim()).map(t=>({name:t.name,event:ev.name,datum:ev.date,info:t.info}));
            if(eintraege.length>0)infoProEv.push({evName:ev.name,datum:ev.date,eintraege});
          });
          const gesamtAnzahl=infoProEv.reduce((s,g)=>s+g.eintraege.length,0);
          return(<>
            <div style={{...cardStyle,height:210,overflow:"hidden",position:"relative",cursor:"pointer"}} onClick={()=>setInfoOffen(true)}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
                <div style={{fontFamily:"Georgia,serif",fontSize:15,color:T.accent}}>
                  Info{gesamtAnzahl>0&&<span style={{marginLeft:8,fontSize:13,background:T.accent,color:"#fff",borderRadius:10,padding:"1px 7px"}}>{gesamtAnzahl}</span>}
                </div>
              </div>
              {infoProEv.length===0&&<p style={{color:T.muted,fontSize:13}}>Keine Infos hinterlegt.</p>}
              <div style={{display:"flex",flexDirection:"column",gap:8}}>
                {infoProEv.slice(0,4).map((g,i)=>(
                  <div key={i} style={{padding:"8px 10px",background:T.bg,borderRadius:8,border:`1px solid ${T.border}`}}>
                    <div style={{fontSize:14,fontWeight:600,color:T.accent}}>{g.evName}</div>
                    <div style={{fontSize:13,color:T.muted}}>{g.datum?new Date(g.datum).toLocaleDateString("de-DE"):""} · {g.eintraege.length} Info{g.eintraege.length!==1?"s":""}</div>
                  </div>
                ))}
              </div>
              {infoProEv.length>0&&<div style={{position:"absolute",bottom:0,left:0,right:0,fontSize:13,color:T.accent,background:T.surface,borderTop:`1px solid ${T.border}33`,padding:"6px 0",textAlign:"center"}}>▼ Öffnen</div>}
            </div>

            {/* Overlay Ebene 1: Veranstaltungen */}
            {infoOffen&&!infoSelEv&&<div style={{position:"fixed",inset:0,zIndex:200,background:"rgba(0,0,0,0.55)"}} onClick={()=>setInfoOffen(false)}/>}
            {infoOffen&&!infoSelEv&&<div style={{position:"fixed",top:"50%",left:"50%",transform:"translate(-50%,-50%)",width:480,background:T.surface,borderRadius:12,border:`1px solid ${T.border}`,padding:20,zIndex:201,boxShadow:"0 8px 32px rgba(0,0,0,0.18)",maxHeight:"70vh",overflowY:"auto"}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
                <div style={{fontFamily:"Georgia,serif",fontSize:15,color:T.accent}}>Info nach Veranstaltung</div>
                <button style={btn(T,"ghost",true)} onClick={()=>setInfoOffen(false)}>✕</button>
              </div>
              <div style={{display:"flex",flexDirection:"column",gap:8}}>
                {infoProEv.map((g,i)=>(
                  <div key={i} style={{padding:"10px 12px",background:T.bg,borderRadius:8,border:`1px solid ${T.border}`,cursor:"pointer"}}
                    onClick={e=>{e.stopPropagation();setInfoSelEv(g);}}
                    onMouseEnter={el=>el.currentTarget.style.borderColor=T.accent+"66"}
                    onMouseLeave={el=>el.currentTarget.style.borderColor=T.border}>
                    <div style={{fontSize:13,fontWeight:600,color:T.accent}}>{g.evName}</div>
                    <div style={{fontSize:11,color:T.muted}}>{g.datum?new Date(g.datum).toLocaleDateString("de-DE"):""} · {g.eintraege.length} Info{g.eintraege.length!==1?"s":""}</div>
                  </div>
                ))}
              </div>
            </div>}

            {/* Overlay Ebene 2: Kunden der gewählten Veranstaltung */}
            {infoSelEv&&<div style={{position:"fixed",inset:0,zIndex:202,background:"rgba(0,0,0,0.55)"}} onClick={()=>setInfoSelEv(null)}/>}
            {infoSelEv&&<div style={{position:"fixed",top:"50%",left:"50%",transform:"translate(-50%,-50%)",width:480,background:T.surface,borderRadius:12,border:`1px solid ${T.border}`,padding:20,zIndex:203,boxShadow:"0 8px 32px rgba(0,0,0,0.18)",maxHeight:"70vh",overflowY:"auto"}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:4}}>
                <div style={{fontFamily:"Georgia,serif",fontSize:15,color:T.accent}}>{infoSelEv.evName}</div>
                <button style={btn(T,"ghost",true)} onClick={()=>setInfoSelEv(null)}>← Zurück</button>
              </div>
              <div style={{fontSize:11,color:T.muted,marginBottom:14}}>{infoSelEv.datum?new Date(infoSelEv.datum).toLocaleDateString("de-DE"):""}</div>
              <div style={{display:"flex",flexDirection:"column",gap:8}}>
                {infoSelEv.eintraege.map((e,i)=>(
                  <div key={i} style={{padding:"8px 10px",background:T.bg,borderRadius:8,border:`1px solid ${T.border}`,cursor:"pointer"}}
                    onClick={ev=>{ev.stopPropagation();setInfoKachelFor(e);}}
                    onMouseEnter={el=>el.currentTarget.style.borderColor=T.accent+"66"}
                    onMouseLeave={el=>el.currentTarget.style.borderColor=T.border}>
                    <div style={{fontSize:13,fontWeight:600,color:T.accent}}>{maskName(e.name)}</div>
                    <div style={{fontSize:11,color:T.muted,whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{e.info}</div>
                  </div>
                ))}
              </div>
            </div>}

            {/* Detail-Modal: Info eines Kunden */}
            {infoKachelFor&&(
              <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.55)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:400}} onClick={()=>setInfoKachelFor(null)}>
                <div style={{background:T.surface,borderRadius:14,width:440,padding:24,border:`1px solid ${T.border}`}} onClick={e=>e.stopPropagation()}>
                  <div style={{fontFamily:"Georgia,serif",fontSize:17,color:T.accent,marginBottom:4}}>{maskName(infoKachelFor.name)}</div>
                  <div style={{fontSize:12,color:T.muted,marginBottom:14}}>{infoKachelFor.event}{infoKachelFor.datum?" · "+new Date(infoKachelFor.datum).toLocaleDateString("de-DE"):""}</div>
                  <div style={{fontSize:13,color:T.text,lineHeight:1.7,whiteSpace:"pre-wrap",background:T.bg,borderRadius:8,padding:12}}>{infoKachelFor.info}</div>
                  <div style={{display:"flex",justifyContent:"flex-end",marginTop:14}}>
                    <button onClick={()=>setInfoKachelFor(null)} style={{...btn(T,"ghost"),fontSize:12}}>Schließen</button>
                  </div>
                </div>
              </div>
            )}
          </>);
        })()}
      </div>

      {/* Zeile 3: Interessenten */}
      <InteressentenKachel T={T} cardStyle={cardStyle} maskName={maskName} btn={btn} setPage={setPage} oeffneBuchungsplan={oeffneBuchungsplan}/>

      {dashKundeModal&&<CustomerModal customer={dashKundeModal} onSave={c=>setDashKundeModal(null)} onClose={()=>setDashKundeModal(null)} T={T}/>}
      {dashBookingModal&&<BookingModal booking={dashBookingModal} customers={customers} setCustomers={setCustomers} onSave={b=>{setBookings(p=>p.map(x=>x.id===b.id?b:x));setDashBookingModal(null);}} onClose={()=>setDashBookingModal(null)} T={T}/>}
    </div>
  );
}

function CalendarPage({bookings,customers,setCustomers,setBookings,events=[],setEvents,onOpenShootingplan,onOpenAbrechnung,onOpenBuchung,onDeleteEvent,onCreateOrdner,T}){
  const gcalColor=(()=>{try{return JSON.parse(localStorage.getItem("sd_google_cal")||"null")?.event_color||"#1a73e8";}catch{return "#1a73e8";}})();
  const today=new Date();
  const [view,setView]=useState(new Date(today.getFullYear(),today.getMonth(),1));
  const [sel,setSel]=useState(null);
  const [eventModal,setEventModal]=useState(false);
  const [editEvent,setEditEvent]=useState(null);
  const [kalTerminWahl,setKalTerminWahl]=useState(false);
  const [kalBookingModal,setKalBookingModal]=useState(false);
  const [kalInteresseModal,setKalInteresseModal]=useState(false);
  const [workflow,setWorkflow]=useState(null);

  function saveEvent(ev){
    const isNew=!(events&&events.find(x=>x.id===ev.id));
    setEvents&&setEvents(p=>p.find(x=>x.id===ev.id)?p.map(x=>x.id===ev.id?ev:x):[...p,ev]);
    setEventModal(false);setEditEvent(null);
    if(isNew){setWorkflow(ev);onCreateOrdner&&onCreateOrdner(ev);}
  }

  const y=view.getFullYear(),m=view.getMonth();
  const MON=["Januar","Februar","März","April","Mai","Juni","Juli","August","September","Oktober","November","Dezember"];
  const DOW=["Mo","Di","Mi","Do","Fr","Sa","So"];

  // Alle Tage des Monats + Auffüller
  const firstDay=(new Date(y,m,1).getDay()+6)%7;
  const daysInMonth=new Date(y,m+1,0).getDate();
  const days=[];
  for(let i=0;i<firstDay;i++)days.push(new Date(y,m,1-(firstDay-i)));
  for(let i=1;i<=daysInMonth;i++)days.push(new Date(y,m,i));
  while(days.length%7!==0){const l=days[days.length-1];days.push(new Date(l.getFullYear(),l.getMonth(),l.getDate()+1));}
  const weeks=[];
  for(let i=0;i<days.length;i+=7)weeks.push(days.slice(i,i+7));

  function getKW(d){
    const tmp=new Date(Date.UTC(d.getFullYear(),d.getMonth(),d.getDate()));
    const day=tmp.getUTCDay()||7;
    tmp.setUTCDate(tmp.getUTCDate()+4-day);
    const y1=new Date(Date.UTC(tmp.getUTCFullYear(),0,1));
    return Math.ceil((((tmp-y1)/86400000)+1)/7);
  }

  function dayKey(d){
    const y=d.getFullYear(),m=String(d.getMonth()+1).padStart(2,'0'),day=String(d.getDate()).padStart(2,'0');
    return `${y}-${m}-${day}`;
  }

  // Events und Buchungen pro Tag
  function getEventsForDay(d){
    const k=dayKey(d);
    const res=[];
    // Veranstaltungen (mehrtägig möglich)
    events.forEach(ev=>{
      if(!ev.date)return;
      const start=ev.date;
      const end=ev.dateBis||ev.date;
      if(k>=start&&k<=end)res.push({type:'event',ev,color:'#1a6fa8'});
      // Anreise-Streifen
      if(ev.anreise&&k===ev.anreise&&k<start)res.push({type:'anreise',ev});
      // Abreise-Streifen
      if(ev.abreise&&k===ev.abreise&&k>end)res.push({type:'abreise',ev});
    });
    // Google-Termine
    try{const gEvts=JSON.parse(localStorage.getItem('sd_google_events')||'[]');
    gEvts.forEach(ge=>{
      const gs=ge.date||'';const ge2=ge.dateBis||ge.date||'';
      if(gs&&k>=gs&&k<=ge2)res.push({type:'google',ge});
    });}catch{}
    // Einzelbuchungen
    bookings.forEach(b=>{
      if(!b.date)return;
      if(b.date&&b.date.slice(0,10)===k){
        const cust=customers.find(c=>c.id===b.customerId);
        res.push({type:'booking',b,cust,color:'#c0392b'});
      }
    });
    // Geplante Folgetermine aus einer Shooting-Serie
    bookings.forEach(b=>{
      (Array.isArray(b.serie)?b.serie:[]).forEach((z,i)=>{
        if(i===0)return; // der erste Fototermin ist der Termin selbst
        if(!z.datum||z.datum.slice(0,10)!==k)return;
        const cust=customers.find(c=>c.id===b.customerId);
        res.push({type:'serie',b,z,cust,color:'#8e6fb5'});
      });
    });
    return res;
  }

  // Mausrad = Monat wechseln — non-passive damit preventDefault funktioniert
  const wheelRef=useRef(null);
  useEffect(()=>{
    const el=wheelRef.current;
    if(!el)return;
    const handler=(e)=>{
      e.preventDefault();
      setView(v=>new Date(v.getFullYear(),v.getMonth()+(e.deltaY>0?1:-1),1));
    };
    el.addEventListener('wheel',handler,{passive:false});
    return()=>el.removeEventListener('wheel',handler);
  },[]);

  const isToday=(d)=>dayKey(d)===dayKey(today);
  const isCurMonth=(d)=>d.getMonth()===m;

  // Farben
  const BG='#f0ede8',CELL='#faf8f5',CELL_OTHER='#ede9e3',BORDER='#d4cfc8',
    TEXT='#2c2a26',MUTED='#9a9490',TODAY_BG='#d4edda',TODAY_BORDER='#3a7a3a';

  return(
    <div style={{height:'calc(100vh - 170px)',margin:'-32px -32px 0 0',display:'flex',flexDirection:'column',background:BG,color:TEXT,fontFamily:"'Open Sans',Verdana,sans-serif",overflow:'hidden'}}
      ref={wheelRef}>

      {/* Header */}
      <div style={{display:'flex',alignItems:'center',padding:'10px 16px',borderBottom:`1px solid ${BORDER}`,flexShrink:0,gap:12}}>
        <button onClick={()=>setView(v=>new Date(v.getFullYear(),v.getMonth()-1,1))}
          style={{background:'none',border:'none',color:TEXT,fontSize:18,cursor:'pointer',padding:'2px 8px'}}>‹</button>
        <div style={{fontSize:22,fontWeight:700,minWidth:180}}>{MON[m]} {y}</div>
        <button onClick={()=>setView(v=>new Date(v.getFullYear(),v.getMonth()+1,1))}
          style={{background:'none',border:'none',color:TEXT,fontSize:18,cursor:'pointer',padding:'2px 8px'}}>›</button>
        <button onClick={()=>setView(new Date(today.getFullYear(),today.getMonth(),1))}
          style={{background:'none',border:`1px solid ${BORDER}`,color:MUTED,fontSize:12,cursor:'pointer',padding:'4px 10px',borderRadius:6}}>Heute</button>
        <span style={{fontSize:12,color:MUTED,display:'flex',alignItems:'center',gap:5,marginLeft:8}}><span style={{width:10,height:10,borderRadius:2,background:'#1a6fa8',display:'inline-block'}}/> Veranstaltung</span>
        <span style={{fontSize:12,color:MUTED,display:'flex',alignItems:'center',gap:5}}><span style={{width:10,height:10,borderRadius:2,background:'#27ae60',display:'inline-block'}}/> Termin</span>
        <span style={{fontSize:12,color:MUTED,display:'flex',alignItems:'center',gap:5}}><span style={{width:10,height:10,borderRadius:2,border:'1px dashed #8e6fb5',display:'inline-block'}}/> Fototermin geplant</span>
        <span style={{fontSize:12,color:MUTED,display:'flex',alignItems:'center',gap:5}}><span style={{width:24,height:6,borderRadius:3,background:'#C9A96E',display:'inline-block'}}/> Anreise</span>
        <span style={{fontSize:12,color:MUTED,display:'flex',alignItems:'center',gap:5}}><span style={{width:24,height:6,borderRadius:3,background:'#e67e22',display:'inline-block'}}/> Abreise</span>
        <span style={{fontSize:12,color:MUTED,display:'flex',alignItems:'center',gap:5}}><span style={{width:10,height:10,borderRadius:2,background:'#1a73e8',display:'inline-block'}}/> Google</span>
        <button onClick={()=>{
          const sv=(localStorage.getItem("sd_server_url")||location.origin).replace(/\/+$/,"");
          const gcfg=(()=>{try{return JSON.parse(localStorage.getItem("sd_google_cal")||"null")||{};}catch{return {};}})();
          if(!gcfg.client_id){alert("Google Kalender nicht konfiguriert.");return;}
          localStorage.removeItem("sd_google_events");
          fetch(sv+"/api/google-import?calendarId="+(gcfg.calendar_id||"primary"))
          .then(r=>r.json()).then(d=>{
            if(d.ok){localStorage.setItem("sd_google_events",JSON.stringify(d.events));alert("✅ "+d.events.length+" Termine importiert.");}
            else alert("Fehler: "+d.error);
          }).catch(e=>alert("Fehler: "+e.message));
        }} style={{background:'none',border:`1px solid ${BORDER}`,color:MUTED,fontSize:12,cursor:'pointer',padding:'4px 10px',borderRadius:6}}>📥 Google</button>
        <button onClick={()=>setKalTerminWahl(true)}
          style={{background:T.accent,border:'none',color:'#fff',fontSize:15,fontWeight:700,cursor:'pointer',padding:'10px 22px',borderRadius:10}}>+ Termin</button>
      </div>

      {/* Wochentage Header */}
      <div style={{display:'grid',gridTemplateColumns:'36px repeat(7,1fr)',borderBottom:`1px solid ${BORDER}`,flexShrink:0}}>
        <div/>
        {DOW.map(d=>(
          <div key={d} style={{padding:'8px 0',textAlign:'center',fontSize:12,fontWeight:600,color:MUTED,borderLeft:`1px solid ${BORDER}`}}>{d}</div>
        ))}
      </div>

      {/* Kalender-Grid */}
      <div style={{flex:1,overflow:'hidden',display:'flex',flexDirection:'column'}}>
        {weeks.map((week,wi)=>{
          // Mehrtägige Events für diese Woche als Spanning-Balken
          const weekStart=dayKey(week[0]),weekEnd=dayKey(week[6]);
          const spanningEvents=events.filter(ev=>{
            if(!ev.date)return false;
            const end=ev.dateBis||ev.date;
            return ev.date<=weekEnd && end>=weekStart;
          }).map(ev=>{
            const end=ev.dateBis||ev.date;
            const clampedStart=ev.date<weekStart?weekStart:ev.date;
            const clampedEnd=end>weekEnd?weekEnd:end;
            const startDi=week.findIndex(d=>dayKey(d)===clampedStart);
            const endDi=week.findIndex(d=>dayKey(d)===clampedEnd);
            return{ev,startDi:startDi<0?0:startDi,endDi:endDi<0?6:endDi,
              isRealStart:ev.date>=weekStart,isRealEnd:end<=weekEnd};
          });

          // Buchungen pro Tag für diese Woche
          const bookingsPerDay=week.map(day=>{
            const k=dayKey(day);
            return bookings.filter(b=>b.date&&b.date.slice(0,10)===k).map(b=>{
              const cust=customers.find(c=>c.id===b.customerId);
              return{b,cust};
            });
          });
          // Geplante Folgetermine aus Shooting-Serien
          const seriePerDay=week.map(day=>{
            const k=dayKey(day);
            const out=[];
            bookings.forEach(b=>{
              (Array.isArray(b.serie)?b.serie:[]).forEach((z,i)=>{
                if(i===0)return; // der erste Fototermin ist der Termin selbst
                if(z.datum&&z.datum.slice(0,10)===k){
                  out.push({b,z,cust:customers.find(c=>c.id===b.customerId)});
                }
              });
            });
            return out;
          });

          return(
            <div key={wi} style={{display:'grid',gridTemplateColumns:'36px repeat(7,1fr)',flex:1,borderBottom:`1px solid ${BORDER}`,minHeight:0}}>
              {/* KW — vertikal, groß, zentriert */}
              <div style={{display:'flex',alignItems:'center',justifyContent:'center',borderRight:`1px solid ${BORDER}`,background:'#e8e4de',overflow:'hidden'}}>
                <div style={{fontSize:20,color:'#7a7570',transform:'rotate(-90deg)',whiteSpace:'nowrap',letterSpacing:1,fontFamily:"'Segoe UI Light','Segoe UI',sans-serif",fontWeight:300}}>
                  {getKW(week[0])}
                </div>
              </div>
              {/* Tages-Zellen */}
              {week.map((day,di)=>{
                const cur=isCurMonth(day);
                const tod=isToday(day);
                const dayBookings=bookingsPerDay[di];
                const headerBg=tod?TODAY_BORDER:cur?'#ddd9d3':'#ccc8c2';
                const headerColor=tod?'#fff':cur?TEXT:MUTED;
                // Events die diesen Tag berühren
                const daySpanning=spanningEvents.filter(se=>di>=se.startDi&&di<=se.endDi);
                return(
                  <div key={di} onClick={()=>setSel(sel&&dayKey(sel)===dayKey(day)?null:day)} onDoubleClick={()=>{setSel(day);if(dayBookings.length===0&&seriePerDay[di].length===0&&spanningEvents.filter(se=>di>=se.startDi&&di<=se.endDi).length===0)setKalTerminWahl(true);}}
                    style={{borderLeft:`1px solid ${BORDER}`,borderRight:di===6?`1px solid ${BORDER}`:'none',background:tod?TODAY_BG:cur?CELL:CELL_OTHER,
                      cursor:'pointer',display:'flex',flexDirection:'column',overflow:'hidden',
                      minHeight:100,maxHeight:180,
                      outline:sel&&dayKey(sel)===dayKey(day)?`2px solid ${TODAY_BORDER}`:'none',
                      outlineOffset:'-2px'}}>
                    {/* Datums-Kopfzeile */}
                    <div style={{background:headerBg,padding:'2px 5px',flexShrink:0,
                      borderBottom:`1px solid ${BORDER}`,display:'flex',alignItems:'center'}}>
                      <span style={{fontSize:12,fontWeight:tod?700:500,color:headerColor}}>
                        {day.getDate()}
                      </span>
                    </div>
                    <div style={{padding:'2px 0',display:'flex',flexDirection:'column',flex:1,gap:2}}>
                      {/* Anreise/Abreise-Streifen */}
                      {(()=>{const k=dayKey(day);return events.filter(ev=>ev.anreise&&ev.anreise===k).map((ev,i)=>(<div key={'an'+i} style={{fontSize:11,padding:'2px 6px',borderRadius:4,background:'#4a8db5',color:'#fff',opacity:0.75,margin:'1px 4px',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>🚗 Anreise: {ev.name}</div>));})()}
                      {(()=>{const k=dayKey(day);return events.filter(ev=>ev.abreise&&ev.abreise===k).map((ev,i)=>(<div key={'ab'+i} style={{fontSize:11,padding:'2px 6px',borderRadius:4,background:'#4a8db5',color:'#fff',opacity:0.75,margin:'1px 4px',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>🏠 Abreise: {ev.name}</div>));})()}
                      {/* Veranstaltungen */}
                      <div style={{display:'flex',flexDirection:'column',gap:1,paddingLeft:4,paddingRight:4}}>
                        {spanningEvents.filter(se=>di>=se.startDi&&di<=se.endDi).map((se,si)=>(
                          <div key={si} onClick={e=>{e.stopPropagation();setEditEvent(se.ev);setEventModal(true);}}
                            style={{fontSize:13,padding:'6px 8px',borderRadius:5,background:'#4a8db5',color:'#fff',
                              whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis',lineHeight:'1.6',
                              cursor:'pointer',fontWeight:600}}>
                            {(()=>{
                              try{
                                const pl=JSON.parse(localStorage.getItem("sd_shootingplaene")||"{}")[se.ev.id]||[];
                                const uhrzeiten=pl.map(r=>r.uhrzeit).filter(Boolean).sort();
                                if(uhrzeiten.length>0){
                                  const von=uhrzeiten[0];
                                  const bis=uhrzeiten[uhrzeiten.length-1];
                                  return `${von}–${bis} ${se.ev.name}`;
                                }
                              }catch{}
                              return se.ev.name;
                            })()}
                          </div>
                        ))}
                      </div>
                      {/* Google-Termine (nach ScattoDesk-Events) */}
                      {(()=>{try{const k=dayKey(day);const gEvts=JSON.parse(localStorage.getItem('sd_google_events')||'[]');const sdNames=new Set(events.map(e=>(e.name||'').trim().toLowerCase()));return gEvts.filter(ge=>ge.date&&k>=ge.date&&k<=(ge.dateBis||ge.date)&&!sdNames.has((ge.name||'').trim().toLowerCase())).map((ge,i)=>(<div key={'g'+i} onClick={e=>e.stopPropagation()} title={ge.name} style={{fontSize:11,padding:'2px 5px',borderRadius:4,background:gcalColor,color:'#fff',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis',margin:'1px 4px',opacity:0.85}}>🗓 {ge.name}</div>));}catch{return null;}})()}
                      {/* Einzelbuchungen */}
                      <div style={{flex:1,overflow:'hidden',display:'flex',flexDirection:'column',gap:1,paddingLeft:4,paddingRight:4}}>
                        {dayBookings.slice(0,3).map((item,ii)=>{
                          const name=item.cust?.name||item.b.name||'Termin';
                          return(
                            <div key={ii} onClick={e=>{e.stopPropagation();setKalBookingModal(item.b);}}
                              style={{fontSize:13,padding:'6px 8px',borderRadius:5,background:'#27ae60',color:'#fff',
                                whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis',lineHeight:'1.6',cursor:'pointer'}}>
                              {item.b.uhrzeit?`${item.b.uhrzeit} `:''}
                              {name}
                            </div>
                          );
                        })}
                        {dayBookings.length>3&&<div style={{fontSize:11,color:MUTED,padding:'2px 4px'}}>+{dayBookings.length-3} weitere</div>}
                        {seriePerDay[di].map((it,ii)=>(
                          <div key={'se'+ii} onClick={e=>{e.stopPropagation();setKalBookingModal(it.b);}}
                            title={`Geplant: ${it.cust?.name||''}${it.z.label?' \u00b7 '+it.z.label:''}`}
                            style={{fontSize:12,padding:'5px 8px',borderRadius:5,
                              background:it.z.erledigt?'#27ae60':'transparent',
                              border:it.z.erledigt?'1px solid #27ae60':'1px dashed #8e6fb5',
                              color:it.z.erledigt?'#fff':'#6b4f96',
                              whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis',lineHeight:'1.5',cursor:'pointer'}}>
                            {it.z.erledigt?'\u2713 ':'\u25CB '}{it.cust?.name||'Fototermin'}{(()=>{const g=Array.isArray(it.z.hunde)?it.z.hunde:(it.z.hund?[it.z.hund]:[]);return g.length?' \u00b7 '+g.join(', '):'';})()}{it.z.label?' \u00b7 '+it.z.label:''}{(it.z.location||it.b?.location)?' \u00b7 '+(it.z.location||it.b.location):''}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>

      {/* Modals */}
      {kalTerminWahl&&(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.78)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:100,padding:20}}>
          <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:16,padding:28,width:"100%",maxWidth:420}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:6}}>
              <div style={{fontFamily:"Georgia,serif",fontSize:20,color:T.accent}}>Was möchtest du anlegen?</div>
              <button style={btn(T,"ghost",true)} onClick={()=>setKalTerminWahl(false)}>✕</button>
            </div>
            <p style={{fontSize:13,color:T.muted,marginBottom:20}}>Einzeltermin, Veranstaltung oder unverbindliche Interessentenliste.</p>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:10}}>
              <div onClick={()=>{setKalTerminWahl(false);setKalBookingModal(true);}}
                style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:12,padding:16,cursor:"pointer",textAlign:"center",transition:"all 0.15s"}}
                onMouseEnter={e=>e.currentTarget.style.borderColor=T.accent}
                onMouseLeave={e=>e.currentTarget.style.borderColor=T.border}>
                <div style={{display:"flex",justifyContent:"center",marginBottom:10,color:T.accent}}><Ic n="calendar" s={24}/></div>
                <div style={{fontSize:13,fontWeight:700,color:T.text,marginBottom:4}}>Einzeltermin</div>
                <div style={{fontSize:11,color:T.muted,lineHeight:1.5}}>Shooting mit einem Kunden</div>
              </div>
              <div onClick={()=>{setKalTerminWahl(false);setEditEvent(null);setEventModal(true);}}
                style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:12,padding:16,cursor:"pointer",textAlign:"center",transition:"all 0.15s"}}
                onMouseEnter={e=>e.currentTarget.style.borderColor=T.accent}
                onMouseLeave={e=>e.currentTarget.style.borderColor=T.border}>
                <div style={{display:"flex",justifyContent:"center",marginBottom:10,color:T.accent}}><Ic n="invoice" s={24}/></div>
                <div style={{fontSize:13,fontWeight:700,color:T.text,marginBottom:4}}>Veranstaltung</div>
                <div style={{fontSize:11,color:T.muted,lineHeight:1.5}}>Event mit mehreren Teilnehmern</div>
              </div>
              <div onClick={()=>{setKalTerminWahl(false);setKalInteresseModal(true);}}
                style={{background:T.bg,border:"1px solid #f59e0b44",borderRadius:12,padding:16,cursor:"pointer",textAlign:"center",transition:"all 0.15s"}}
                onMouseEnter={e=>e.currentTarget.style.borderColor="#f59e0b"}
                onMouseLeave={e=>e.currentTarget.style.borderColor="#f59e0b44"}>
                <div style={{display:"flex",justifyContent:"center",marginBottom:10,color:"#f59e0b"}}><Ic n="list" s={24}/></div>
                <div style={{fontSize:13,fontWeight:700,color:T.text,marginBottom:4}}>Interessenten</div>
                <div style={{fontSize:11,color:T.muted,lineHeight:1.5}}>Ohne festes Datum</div>
              </div>
            </div>
          </div>
        </div>
      )}
      {kalBookingModal&&<BookingModal booking={kalBookingModal===true?null:kalBookingModal} customers={customers} setCustomers={setCustomers} onSave={b=>{setBookings&&setBookings(p=>kalBookingModal===true?[...p,b]:p.map(x=>x.id===b.id?b:x));setKalBookingModal(false);}} onClose={()=>setKalBookingModal(false)} T={T}/>}
      {kalInteresseModal&&<EventModal event={null} onSave={ev=>{setEvents&&setEvents(p=>[...p,ev]);setKalInteresseModal(false);}} onClose={()=>setKalInteresseModal(false)} T={T} datumOptional={true}/>}
      {eventModal&&(
        <EventModal
          event={editEvent}
          onSave={saveEvent}
          onDelete={(id)=>{onDeleteEvent&&onDeleteEvent(id);setEventModal(false);setEditEvent(null);}}
          onClose={()=>{setEventModal(false);setEditEvent(null);}}
          T={T}
          initialDate={!editEvent&&sel?`${sel.getFullYear()}-${String(sel.getMonth()+1).padStart(2,"0")}-${String(sel.getDate()).padStart(2,"0")}`:undefined}/>
      )}
      {workflow&&(
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.7)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:300}}>
          <div style={{background:BG,border:`1px solid ${BORDER}`,borderRadius:16,padding:28,width:'100%',maxWidth:400}}>
            <div style={{textAlign:'center',marginBottom:6}}>
              <div style={{display:'flex',justifyContent:'center',marginBottom:10,color:'#27ae60'}}>
                <svg width="32" height="32" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"><circle cx="8" cy="8" r="6.5"/><polyline points="5,8 7,10 11,6"/></svg>
              </div>
              <div style={{fontFamily:'Georgia,serif',fontSize:18,color:T.accent}}>Veranstaltung angelegt</div>
            </div>
            <p style={{fontSize:13,color:MUTED,marginBottom:6,textAlign:'center'}}><strong style={{color:TEXT}}>{workflow.name}</strong></p>
            <div style={{background:CELL_OTHER,borderRadius:8,padding:'10px 14px',fontSize:12,color:MUTED,marginBottom:20,textAlign:'center'}}>
              {fmtDate(workflow.date)} · {workflow.fotoart}{workflow.location?` · ${workflow.location}`:''}
            </div>
            <div style={{display:'flex',flexDirection:'column',gap:8}}>
              <button style={{...btn(T,'ghost'),justifyContent:'flex-start',padding:'12px 16px',color:TEXT}} onClick={()=>{onOpenBuchung&&onOpenBuchung(workflow);setWorkflow(null);}}>
                <span style={{color:T.accent,display:'flex'}}><Ic n="globe" s={15}/></span>
                <span style={{flex:1,textAlign:'left',marginLeft:8}}>1. Buchungsplan öffnen</span>
                <span style={{color:MUTED}}>→</span>
              </button>
              <button style={{...btn(T,'ghost'),justifyContent:'flex-start',padding:'12px 16px',color:TEXT}} onClick={()=>{onOpenShootingplan&&onOpenShootingplan({eventId:workflow.id,event_name:workflow.name,event_type:workflow.fotoart,event_date:workflow.date,event_start:workflow.date,event_end:workflow.date,rows:[]});setWorkflow(null);}}>
                <span style={{color:T.accent,display:'flex'}}><Ic n="renum" s={15}/></span>
                <span style={{flex:1,textAlign:'left',marginLeft:8}}>2. Veranstaltungsplan öffnen</span>
                <span style={{color:MUTED}}>→</span>
              </button>
              <button style={{...btn(T,'ghost'),justifyContent:'flex-start',padding:'12px 16px',color:TEXT}} onClick={()=>{onOpenAbrechnung&&onOpenAbrechnung(workflow.id);setWorkflow(null);}}>
                <span style={{color:T.accent,display:'flex'}}><Ic n="invoice" s={15}/></span>
                <span style={{flex:1,textAlign:'left',marginLeft:8}}>3. Abrechnung öffnen</span>
                <span style={{color:MUTED}}>→</span>
              </button>
            </div>
            <button style={{...btn(T,'ghost'),width:'100%',justifyContent:'center',marginTop:14,fontSize:11,color:MUTED}} onClick={()=>setWorkflow(null)}>Später</button>
          </div>
        </div>
      )}
    </div>
  );
}

// ── Customers Page ─────────────────────────────────────────────────────────────

// ── sevDesk Sync Modal ────────────────────────────────────────────────────────
function SevDeskSyncModal({customers,onImport,onClose,T}){
  const [step,setStep]=useState("idle"); // idle | testing | preview | importing | done
  const [result,setResult]=useState(null);
  const [preview,setPreview]=useState([]);
  const [error,setError]=useState("");
  const [progress,setProgress]=useState(0);
  const IS=IS2=>({background:IS2.bg,border:`1px solid ${IS2.border}`,borderRadius:8,padding:"9px 12px",color:IS2.text,fontSize:13,fontFamily:"inherit",outline:"none",boxSizing:"border-box",width:"100%"});

  const token=(JSON.parse(localStorage.getItem("sd_api_settings")||"{}").sevdesk_token||"").trim();
  const serverUrl=(localStorage.getItem("sd_server_url")||"").trim().replace(/\/+$/,"");
  // sevDesk über Hetzner-Server-Proxy (umgeht CORS)
  async function sevFetch(endpoint, params={}, method="GET", body=null){
    if(!serverUrl) throw new Error("Bitte zuerst die Server-URL in den Einstellungen eintragen.");
    const r=await fetch(`${serverUrl}/api/sevdesk`,{
      method:"POST",
      headers:{"Content-Type":"application/json"},
      body:JSON.stringify({token,endpoint,params,method,body})
    });
    const d=await r.json();
    console.log("sevDesk response:",endpoint,d);
    if(d.error)throw new Error(d.error);
    if(d.status&&Number(d.status)>=400)throw new Error(`sevDesk Fehler ${d.status}: ${d.message||JSON.stringify(d)}`);
    return d;
  }

  async function testConnection(){
    if(!token){setError("Kein sevDesk Token hinterlegt. Bitte zuerst unter Einstellungen → sevDesk eintragen.");return;}
    if(!serverUrl){setError("Keine Server-URL eingetragen. Bitte zuerst unter Einstellungen → Server-URL die Adresse deines Servers eintragen.");return;}
    setStep("testing");setError("");
    try{
      const d=await sevFetch("/Contact",{limit:"5",depth:"1"});
      if(d.status&&Number(d.status)>=400){throw new Error(`sevDesk lehnt den Zugriff ab: ${d.message||("HTTP "+d.status)} (Status ${d.status}). Bitte den API-Token unter Einstellungen neu kopieren.`);}
      if(d.error){throw new Error(d.error?.message||"API Fehler");}
      const contacts=d.objects||[];
      // sevDesk liefert "total" nur mit countAll=true — hole es separat falls fehlt
      let total=Number(d.total||0);
      if(!total&&contacts.length>0)total=contacts.length;
      setResult({total,raw:JSON.stringify(d).slice(0,300),sample:contacts.map(c=>({
        name:[c.surename,c.familyname].filter(Boolean).join(" ")||c.name||"(ohne Name)",
        id:c.id,
      }))});
      setStep("preview_ready");
    }catch(e){
      setError("Verbindung fehlgeschlagen: "+e.message+"\n\nHinweis: Stelle sicher dass dein sevDesk Token gültig ist und du Buchhaltung Pro hast.");
      setStep("idle");
    }
  }

  async function loadAll(){
    setStep("importing");setError("");
    try{
      let offset=0,all=[],total=0;
      // Gesamtzahl mit countAll holen (für Fortschrittsanzeige)
      try{
        const td=await sevFetch("/Contact",{limit:"1",depth:"1",countAll:"true"});
        total=Number(td.total||0);
      }catch{}
      while(true){
        const d=await sevFetch("/Contact",{limit:"100",offset:String(offset),depth:"1"});
        if(d.status&&Number(d.status)>=400)throw new Error(`sevDesk lehnt den Zugriff ab: ${d.message||d.status}. Token prüfen.`);
        if(d.error)throw new Error(d.error?.message||"API Fehler");
        const contacts=d.objects||[];
        if(contacts.length===0)break;
        if(!total)total=contacts.length;
        // Für jeden Kontakt Kommunikationswege laden
        for(const c of contacts){
          const cid=c.id;
          const name=[c.surename,c.familyname].filter(Boolean).join(" ")||c.name||"";
          if(!name)continue;
          // Kommunikation laden
          let email="",phone="",street="",zip="",city="";
          try{
            const cd=await sevFetch("/CommunicationWay",{"contact[id]":cid,"contact[objectName]":"Contact"});
            (cd.objects||[]).forEach(w=>{
              if(w.type==="EMAIL")email=w.value||"";
              if(w.type==="PHONE")phone=w.value||"";
            });
            // Adresse
            const ad=await sevFetch("/ContactAddress",{"contact[id]":cid,"contact[objectName]":"Contact"});
            const addr=(ad.objects||[])[0];
            if(addr){street=addr.street||"";zip=addr.zip||"";city=addr.city||"";}
          }catch{}
          const anredeMap={"m":"Herr","w":"Frau","male":"Herr","female":"Frau","Herr":"Herr","Frau":"Frau"};
          const anrede=anredeMap[c.gender]||"";
          all.push({id:uid(),name,email,phone,strasse:street,plz:zip,ort:city,sevdeskId:cid,kundennr:c.customerNumber||"",anrede});
          setProgress(total?Math.min(100,Math.round((all.length/total)*100)):Math.min(99,all.length));
        }
        offset+=100;
        if(contacts.length<100)break;
      }
      setPreview(all);
      setStep("preview");
    }catch(e){
      setError("Fehler beim Laden: "+e.message);
      setStep("idle");
    }
  }

  async function startUpload(){
    setStep("uploading");setError("");setProgress(0);
    try{
      // 1. Bestehende sevDesk-Kontakte laden (E-Mails sammeln)
      const sevEmails=new Set();
      let offset=0;
      while(true){
        const d=await sevFetch("/Contact",{limit:"100",offset:String(offset),depth:"1"});
        if(d.error||d.status===401)throw new Error(d.error?.message||d.message||"API Fehler");
        const contacts=d.objects||[];
        if(contacts.length===0)break;
        for(const c of contacts){
          try{
            const cd=await sevFetch("/CommunicationWay",{"contact[id]":c.id,"contact[objectName]":"Contact"});
            (cd.objects||[]).forEach(w=>{if(w.type==="EMAIL"&&w.value)sevEmails.add(w.value.toLowerCase());});
          }catch{}
        }
        offset+=100;
        if(contacts.length<100)break;
      }
      // 2. ScattoDesk-Kunden die fehlen hochladen
      const toUpload=customers.filter(c=>c.name&&(!c.email||!sevEmails.has(c.email.toLowerCase())));
      let uploaded=0,errors=0;
      const genderMap={"Herr":"m","Frau":"w"};
      for(let i=0;i<toUpload.length;i++){
        const c=toUpload[i];
        try{
          const parts=c.name.trim().split(" ");
          const surename=parts.slice(0,-1).join(" ")||parts[0];
          const familyname=parts.length>1?parts[parts.length-1]:"";
          const body2={surename,familyname,category:{id:3,objectName:"Category"}};
          if(c.anrede&&genderMap[c.anrede])body2.gender=genderMap[c.anrede];
          const rd=await sevFetch("/Contact",{},"POST",body2);
          const newId=rd.objects?.id;
          if(newId){
            // E-Mail + Telefon als CommunicationWay
            if(c.email)await sevFetch("/CommunicationWay",{},"POST",{contact:{id:newId,objectName:"Contact"},type:"EMAIL",value:c.email,key:{id:1,objectName:"CommunicationWayKey"}});
            if(c.phone)await sevFetch("/CommunicationWay",{},"POST",{contact:{id:newId,objectName:"Contact"},type:"PHONE",value:c.phone,key:{id:4,objectName:"CommunicationWayKey"}});
            if(c.telefon)await sevFetch("/CommunicationWay",{},"POST",{contact:{id:newId,objectName:"Contact"},type:"PHONE",value:c.telefon,key:{id:2,objectName:"CommunicationWayKey"}});
            // Adresse
            const _str=c.strasse||c.street||"";const _plz=c.plz||c.zip||"";const _ort=c.ort||c.city||"";
            if(_str||_ort)await sevFetch("/ContactAddress",{},"POST",{contact:{id:newId,objectName:"Contact"},street:_str,zip:_plz,city:_ort,country:{id:1,objectName:"StaticCountry"},category:{id:3,objectName:"Category"}});
            uploaded++;
          }else errors++;
        }catch{errors++;}
        setProgress(Math.round(((i+1)/toUpload.length)*100));
      }
      setResult({uploaded,skipped:customers.length-toUpload.length,errors});
      setStep("upload_done");
    }catch(e){
      setError("Upload fehlgeschlagen: "+e.message);
      setStep("idle");
    }
  }

  const existingEmails=new Set(customers.map(c=>c.email?.toLowerCase()).filter(Boolean));
  const neu=preview.filter(c=>!existingEmails.has(c.email?.toLowerCase()));
  const duplikate=preview.filter(c=>c.email&&existingEmails.has(c.email?.toLowerCase()));

  return(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.78)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:100,padding:20}}>
      <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:16,padding:28,width:"100%",maxWidth:560,maxHeight:"85vh",display:"flex",flexDirection:"column"}}>
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:6}}>
          <div style={{fontFamily:"Georgia,serif",fontSize:20,color:T.accent}}>sevDesk Sync</div>
          <button style={btn(T,"ghost",true)} onClick={onClose}>✕</button>
        </div>
        <p style={{fontSize:13,color:T.muted,marginBottom:20,lineHeight:1.6}}>Kontakte aus sevDesk in ScattoDesk importieren. Bestehende Kontakte (gleiche E-Mail) werden nicht doppelt angelegt.</p>

        {error&&<div style={{background:T.danger+"22",border:`1px solid ${T.danger}44`,borderRadius:8,padding:"10px 14px",fontSize:12,color:T.danger,marginBottom:14,whiteSpace:"pre-wrap"}}>{error}</div>}

        {/* Token Status */}
        <div style={{background:T.bg,borderRadius:8,padding:"10px 14px",fontSize:12,marginBottom:16,display:"flex",alignItems:"center",gap:8}}>
          <span style={{color:token?T.success:T.danger}}>{token?"✓":"✗"}</span>
          <span style={{color:T.muted}}>{token?"sevDesk Token hinterlegt":"Kein Token — bitte unter Shootingplan → API-Einstellungen eintragen"}</span>
        </div>

        {/* Steps */}
        {step==="idle"&&(
          <div style={{display:"flex",flexDirection:"column",gap:10}}>
            <button style={{...btn(T,"primary"),justifyContent:"center"}} onClick={testConnection} disabled={!token}>
              ⬇ Von sevDesk laden (Download)
            </button>
            <button style={{...btn(T,"ghost"),justifyContent:"center"}} onClick={startUpload} disabled={!token}>
              ⬆ Nach sevDesk hochladen (Upload)
            </button>
          </div>
        )}

        {step==="uploading"&&(
          <div style={{textAlign:"center",padding:24}}>
            <div style={{color:T.muted,marginBottom:12}}>⏳ Lade Kontakte nach sevDesk hoch... {progress}%</div>
            <div style={{height:6,background:T.border,borderRadius:3,overflow:"hidden"}}>
              <div style={{height:"100%",width:`${progress}%`,background:T.accent,borderRadius:3,transition:"width 0.3s"}}/>
            </div>
          </div>
        )}

        {step==="upload_done"&&result&&(
          <div>
            <div style={{background:T.success+"22",border:`1px solid ${T.success}44`,borderRadius:8,padding:"12px 16px",marginBottom:16}}>
              <div style={{fontSize:13,fontWeight:600,color:T.success,marginBottom:6}}>✅ Upload abgeschlossen!</div>
              <div style={{fontSize:12,color:T.muted}}>
                Hochgeladen: <strong style={{color:T.text}}>{result.uploaded}</strong> neue Kontakte<br/>
                Übersprungen: {result.skipped} (bereits in sevDesk)
                {result.errors>0&&<><br/><span style={{color:T.danger}}>Fehler: {result.errors}</span></>}
              </div>
            </div>
            <button style={{...btn(T,"primary"),width:"100%",justifyContent:"center"}} onClick={onClose}>Fertig</button>
          </div>
        )}

        {step==="testing"&&(
          <div style={{textAlign:"center",padding:24,color:T.muted}}>⏳ Verbindung wird getestet...</div>
        )}

        {step==="preview_ready"&&result&&(
          <div>
            <div style={{background:T.success+"22",border:`1px solid ${T.success}44`,borderRadius:8,padding:"12px 16px",marginBottom:16}}>
              <div style={{fontSize:13,fontWeight:600,color:T.success,marginBottom:6}}>✅ Verbindung erfolgreich!</div>
              <div style={{fontSize:12,color:T.muted}}>Gefunden: <strong style={{color:T.text}}>{result.total} Kontakte</strong> in sevDesk</div>
              <div style={{marginTop:8,fontSize:12,color:T.muted}}>
                Vorschau (erste 5):
                {result.sample.map(s=><div key={s.id} style={{color:T.text,marginTop:2}}>· {s.name}</div>)}
              </div>
              {result.total===0&&result.raw&&(
                <div style={{marginTop:10,fontSize:10,fontFamily:"monospace",color:T.muted,background:T.bg,borderRadius:6,padding:8,wordBreak:"break-all"}}>
                  Debug — API-Antwort: {result.raw}
                </div>
              )}
            </div>
            <div style={{display:"flex",gap:10}}>
              <button style={btn(T,"ghost")} onClick={onClose}>Abbrechen</button>
              <button style={{...btn(T,"primary"),flex:1,justifyContent:"center"}} onClick={loadAll}>
                Alle {result.total} Kontakte laden →
              </button>
            </div>
          </div>
        )}

        {step==="importing"&&(
          <div style={{textAlign:"center",padding:24}}>
            <div style={{color:T.muted,marginBottom:12}}>⏳ Lade Kontakte aus sevDesk... {progress}%</div>
            <div style={{height:6,background:T.border,borderRadius:3,overflow:"hidden"}}>
              <div style={{height:"100%",width:`${progress}%`,background:T.accent,borderRadius:3,transition:"width 0.3s"}}/>
            </div>
          </div>
        )}

        {step==="preview"&&(
          <div style={{display:"flex",flexDirection:"column",flex:1,minHeight:0}}>
            <div style={{display:"flex",gap:16,marginBottom:14,fontSize:12}}>
              <div style={{background:T.success+"22",color:T.success,padding:"6px 12px",borderRadius:6,fontWeight:600}}>
                + {neu.length} neu
              </div>
              <div style={{background:T.border,color:T.muted,padding:"6px 12px",borderRadius:6}}>
                {duplikate.length} bereits vorhanden
              </div>
            </div>
            <div style={{flex:1,overflowY:"auto",border:`1px solid ${T.border}`,borderRadius:8,marginBottom:16}}>
              {preview.map(c=>{
                const isDup=c.email&&existingEmails.has(c.email?.toLowerCase());
                return(
                  <div key={c.sevdeskId} style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"9px 14px",borderBottom:`1px solid ${T.border}22`,opacity:isDup?0.45:1}}>
                    <div>
                      <div style={{fontSize:13,fontWeight:600,color:T.text}}>{c.name}</div>
                      <div style={{fontSize:11,color:T.muted}}>{[c.email,c.phone].filter(Boolean).join(" · ")}</div>
                    </div>
                    {isDup&&<span style={{fontSize:10,color:T.muted,background:T.border,padding:"2px 7px",borderRadius:20}}>vorhanden</span>}
                  </div>
                );
              })}
            </div>
            <div style={{display:"flex",gap:10,justifyContent:"flex-end"}}>
              <button style={btn(T,"ghost")} onClick={onClose}>Abbrechen</button>
              <button style={btn(T,"primary")} onClick={()=>{onImport(neu);}}>
                {neu.length} Kontakte importieren
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

function BuchungslinkModal({kunde, events, T, onClose, inline=false, onSent}){
  const aktiveEvents=events.filter(ev=>ev.date&&!ev.abgesagt&&!ev.abgeschlossen).sort((a,b)=>new Date(a.date)-new Date(b.date));
  const [selEvId,setSelEvId]=useState(aktiveEvents[0]?.id||"");
  const [sending,setSending]=useState(false);
  const [sent,setSent]=useState(false);
  const [linkTyp,setLinkTyp]=useState("schenkend"); // schenkend | beschenkt
  const smtp=(()=>{try{const s=JSON.parse(localStorage.getItem("sd_smtp_info")||localStorage.getItem("sd_smtp_settings")||"{}");return {...s,from_email:"info@m-h-photo.de"};}catch{return {};}})();
  const serverUrl=(localStorage.getItem("sd_server_url")||"").trim().replace(/\/+$/,"");
  const cfg=(()=>{try{return JSON.parse(localStorage.getItem("sd_buchung_config")||"null")||{};}catch{return {};}})();

  const ev=events.find(e=>e.id===selEvId);
  const slug=ev?(ev.slug||ev.name?.toLowerCase().replace(/[äöüß]/g,c=>({ä:"ae",ö:"oe",ü:"ue",ß:"ss"}[c]||c)).replace(/[^a-z0-9]+/g,"-").replace(/^-|-$/g,"")):"";
  const buchungsUrl=slug?`https://buchen.m-h-photo.de/buchen/${slug}?geschenk=${linkTyp==="beschenkt"?"2":"1"}`:"";

  const vorlagen=(()=>{try{return JSON.parse(localStorage.getItem("sd_email_vorlagen")||"{}");}catch{return {};}})();
  const tmpl=(linkTyp==="beschenkt"
    ?vorlagen.geschenk_einloesen||{betreff:"Du wurdest zu einem Fotoshooting eingeladen! 🎁",text:"Hallo {{name}},\n\ndu hast ein Fotoshooting geschenkt bekommen!\n\nHier suchst du dir deinen Wunschtermin aus und unterschreibst die Shootingvereinbarung:\n\n{{link}}\n\nBezahlen musst du nichts, das ist bereits erledigt.\n\nWir freuen uns auf dich!\n\nHerzliche Grüße\n{{studio}}"}
    :vorlagen.geschenk_buchungslink||{betreff:"Dein Gutschein für ein Fotoshooting 🎁",text:"Hallo {{name}},\n\nschön, dass du ein Fotoshooting verschenken möchtest!\n\nÜber diesen Link trägst du die beschenkte Person ein und schließt die Bezahlung ab:\n\n{{link}}\n\nEinen Termin kannst du dabei schon aussuchen, musst du aber nicht.\n\nHerzliche Grüße\n{{studio}}"});
  const studio=cfg.studioName||smtp.from||"Markus Heber Photography";
  const name=kunde.name||kunde.vorname||"";
  const rep=(s)=>s.replace(/{{name}}/g,name).replace(/{{vorname}}/g,vornameAus(name))
    .replace(/{{(shooting|event|veranstaltung)}}/g,ev?.name||"").replace(/{{location}}/g,[ev?.adresse?.strasse,ev?.adresse?.plz,ev?.adresse?.ort].filter(Boolean).join(", ")||ev?.location||"").replace(/{{studio}}/g,studio)
    .replace(/{{link}}/g,buchungsUrl).replace(/{{buchungslink}}/g,buchungsUrl);

  const betreff=rep(tmpl.betreff||"");
  const text=rep(tmpl.text||"")+(buchungsUrl?`\n\n🎁 Geschenk-Buchung: keine Vereinbarung beim Buchen erforderlich.`:"");

  async function send(){
    if(!kunde.email){alert("Kein E-Mail bei diesem Kunden.");return;}
    if(!buchungsUrl){alert("Bitte Veranstaltung auswählen.");return;}
    setSending(true);
    try{
      await fetch(`${serverUrl}/api/newsletter`,{
        method:"POST",headers:{"Content-Type":"application/json"},
        body:JSON.stringify({smtp,recipients:[{name,email:kunde.email}],subject:betreff,text,
          html:buildScattoDeskMailHtml(text,_getSig().logo,_getSig().text),logo:_getSig().logo})
      });
      if(onSent)onSent();
      if(!inline)setSent(true);
      alert("✅ Buchungslink wurde erfolgreich gesendet!");
    }catch(e){alert("Fehler: "+e.message);}
    setSending(false);
  }

  const IS2={background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:"8px 12px",color:T.text,fontSize:13,fontFamily:"inherit",outline:"none",width:"100%"};

  const inner=(
    <div style={{minHeight:inline?"420px":"auto"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
          <div style={{fontFamily:"Georgia,serif",fontSize:16,color:T.accent}}>🎁 Buchungslink senden</div>
          {!inline&&onClose&&<button onClick={onClose} style={{background:"none",border:"none",fontSize:18,cursor:"pointer",color:T.muted}}>✕</button>}
        </div>
        {sent?(
          <div style={{textAlign:"center",padding:"24px 0"}}>
            <div style={{fontSize:36,marginBottom:8}}>✅</div>
            <div style={{fontSize:14,color:T.text,marginBottom:4}}>Mail gesendet an {kunde.email}</div>
            <button style={btn(T,"ghost")} onClick={onClose}>Schließen</button>
          </div>
        ):(
          <>
            <div style={{fontSize:12,color:T.muted,marginBottom:16}}>{name} · {kunde.email||"keine E-Mail"}</div>
            <div style={{marginBottom:14}}>
              <label style={{fontSize:12,color:T.muted,fontWeight:600,display:"block",marginBottom:5}}>Veranstaltung</label>
              <select value={selEvId} onChange={e=>setSelEvId(e.target.value)} style={IS2}>
                {aktiveEvents.length===0&&<option value="">Keine aktiven Veranstaltungen</option>}
                {aktiveEvents.map(e=><option key={e.id} value={e.id}>{e.name} · {e.date}</option>)}
              </select>
            </div>
            <div style={{marginBottom:14}}>
              <label style={{fontSize:12,color:T.muted,fontWeight:600,display:"block",marginBottom:5}}>Für wen ist der Link?</label>
              <div style={{display:"flex",flexDirection:"column",gap:6}}>
                {[["schenkend","🎁 Schenkende Person","Bezahlt das Shooting. Termin freiwillig, keine Vereinbarung."],
                  ["beschenkt","✍️ Beschenkte Person","Sucht den Termin und unterschreibt die Vereinbarung. Keine Bezahlung."]].map(([id,titel,txt])=>(
                  <div key={id} onClick={()=>setLinkTyp(id)}
                    style={{border:`1px solid ${linkTyp===id?T.accent:T.border}`,background:linkTyp===id?T.accentDim:T.bg,
                      borderRadius:8,padding:"9px 12px",cursor:"pointer",display:"flex",alignItems:"flex-start",gap:9}}>
                    <input type="radio" checked={linkTyp===id} onChange={()=>setLinkTyp(id)} style={{accentColor:T.accent,marginTop:3,flexShrink:0}}/>
                    <div>
                      <div style={{fontSize:13,fontWeight:700,color:linkTyp===id?T.accent:T.text}}>{titel}</div>
                      <div style={{fontSize:11,color:T.muted,marginTop:2}}>{txt}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            {buchungsUrl&&(
              <div style={{marginBottom:14,padding:"8px 12px",background:T.bg,borderRadius:8,fontSize:11,color:T.muted,wordBreak:"break-all"}}>
                🔗 {buchungsUrl}
              </div>
            )}
            <div style={{marginBottom:16,background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:12,fontSize:12,color:T.text,maxHeight:300,overflowY:"auto"}}>
              <div style={{fontSize:11,color:T.muted,marginBottom:6,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.06em"}}>Vorschau</div>
              <div style={{fontWeight:700,marginBottom:10,color:T.accent,fontSize:13}}>{betreff}</div>
              <div style={{fontSize:12,lineHeight:1.7}} dangerouslySetInnerHTML={{__html:(()=>{
                let h=text.replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;");
                h=h.replace(/\*\*(.+?)\*\*/g,"<strong>$1</strong>");
                h=h.replace(/\[([^\]]+)\]\(([^)]+)\)/g,(m,l,u)=>`<a href="${u}" style="color:#A8843E">${l}</a>`);
                h=h.split("\n").map(l=>l.trim()===""?"<br/>":l+"<br/>").join("");
                return h;
              })()}}/>
            </div>
            <button style={{...btn(T,"primary"),width:"100%",justifyContent:"center"}}
              onClick={send} disabled={sending||!buchungsUrl||!kunde.email}>
              {sending?"⏳ Wird gesendet…":"📧 Buchungslink senden"}
            </button>
          </>
        )}
    </div>
  );
  if(inline)return inner;
  return(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.55)",zIndex:9999,display:"flex",alignItems:"center",justifyContent:"center",padding:16}} onClick={onClose}>
      <div style={{background:T.surface,borderRadius:14,padding:24,maxWidth:480,width:"100%",boxShadow:"0 8px 40px rgba(0,0,0,0.3)"}} onClick={e=>e.stopPropagation()}>
        {inner}
      </div>
    </div>
  );
}

// ── QR-Codes fuer die Newsletter-Anmeldung ───────────────────────────────
// Zwei Varianten, wie beim Veranstaltungs-QR: einer oeffnet die Anmeldeseite
// direkt, der andere fuehrt auf die Zwischenseite /link, die die Adresse zum
// Kopieren anzeigt. Letzteres ist fuer Instagram und aehnliches gedacht.
function NewsletterQRKarte({T,titel,beschr,url,dateiname}){
  const canvasRef=useRef(null);
  const [fehler,setFehler]=useState("");

  function baueCanvas(groesse,fertig){
    if(!url)return;
    const qr=`https://api.qrserver.com/v1/create-qr-code/?size=${groesse}x${groesse}&margin=20&ecc=H&data=${encodeURIComponent(url)}`;
    const img=new Image();
    img.crossOrigin="anonymous";
    img.onload=()=>{
      const c=document.createElement("canvas");
      c.width=groesse;c.height=groesse;
      const ctx=c.getContext("2d");
      ctx.fillStyle="#ffffff";ctx.fillRect(0,0,groesse,groesse);
      ctx.drawImage(img,0,0,groesse,groesse);
      const wort="Newsletter";
      const fs=groesse*0.042,pad=groesse*0.022;
      const bw=wort.length*fs*0.58+pad*2, bh=fs+pad*2;
      const bx=groesse/2-bw/2, by=groesse/2-bh/2;
      ctx.fillStyle="#ffffff";
      if(ctx.roundRect){ctx.beginPath();ctx.roundRect(bx-4,by-4,bw+8,bh+8,6);ctx.fill();}
      else ctx.fillRect(bx-4,by-4,bw+8,bh+8);
      ctx.fillStyle="#1a1a1a";
      ctx.font=`${Math.round(fs)}px Arial,sans-serif`;
      ctx.textAlign="center";
      ctx.fillText(wort,groesse/2,by+pad+fs*0.85);
      fertig(c);
    };
    img.onerror=()=>setFehler("QR-Code konnte nicht geladen werden.");
    img.src=qr;
  }

  useEffect(()=>{
    if(!url||!canvasRef.current)return;
    setFehler("");
    baueCanvas(360,c=>{
      const el=canvasRef.current;
      if(!el)return;
      const ctx=el.getContext("2d");
      ctx.clearRect(0,0,360,360);
      ctx.drawImage(c,0,0,360,360);
    });
  },[url]);

  function herunterladen(){
    baueCanvas(900,c=>{
      const a=document.createElement("a");
      a.href=c.toDataURL("image/png");
      a.download=dateiname;
      a.click();
    });
  }
  function drucken(){
    baueCanvas(900,c=>{
      const bild=c.toDataURL("image/png");
      const w=window.open("","_blank");
      if(!w)return;
      w.document.write('<html><head><title>Newsletter QR-Code</title></head>'
        +'<body style="font-family:Arial,sans-serif;text-align:center;padding:40px">'
        +'<h1 style="font-size:26px;margin-bottom:6px">Newsletter</h1>'
        +'<p style="font-size:15px;color:#555;margin-top:0">'+beschr+'</p>'
        +'<img src="'+bild+'" style="width:360px;height:360px">'
        +'<p style="font-size:12px;color:#999;margin-top:18px;word-break:break-all">'+url+'</p>'
        +'</body></html>');
      w.document.close();
      setTimeout(()=>{try{w.print();}catch(e){}},600);
    });
  }

  return(
    <div style={{flex:1,minWidth:230,textAlign:"center",background:T.bg,border:`1px solid ${T.border}`,borderRadius:12,padding:14}}>
      <div style={{fontFamily:"Georgia,serif",fontSize:15,color:T.accent,marginBottom:2}}>{titel}</div>
      <div style={{fontSize:11,color:T.muted,marginBottom:10}}>{beschr}</div>
      <div style={{background:"#fff",borderRadius:10,padding:8,display:"inline-block"}}>
        <canvas ref={canvasRef} width={360} height={360} style={{width:170,height:170,display:"block"}}/>
      </div>
      {fehler&&<div style={{fontSize:11,color:"#e55",marginTop:6}}>{fehler}</div>}
      <div style={{fontSize:10,color:T.muted,wordBreak:"break-all",margin:"8px 0 10px"}}>{url}</div>
      <div style={{display:"flex",gap:6,justifyContent:"center",flexWrap:"wrap"}}>
        <button style={{...btn(T,"ghost",true),fontSize:11}} onClick={()=>{navigator.clipboard&&navigator.clipboard.writeText(url);alert("Link kopiert:\n"+url);}}>Link kopieren</button>
        <button style={{...btn(T,"ghost",true),fontSize:11}} onClick={herunterladen}>Herunterladen</button>
        <button style={{...btn(T,"primary",true),fontSize:11}} onClick={drucken}>Drucken</button>
      </div>
    </div>
  );
}

function NewsletterQR({T,url}){
  if(!url)return null;
  const basis=url.replace(/\/newsletter$/,"");
  const linkUrl=basis+"/link?zeigen=1&url="+encodeURIComponent(url)+"&name="+encodeURIComponent("Newsletter");
  return(
    <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:12,padding:20,marginBottom:16}}>
      <div style={{fontFamily:"Georgia,serif",fontSize:15,color:T.accent,marginBottom:4}}>QR-Codes zur Anmeldung</div>
      <div style={{fontSize:12,color:T.muted,marginBottom:14}}>
        Fuer Flyer, Aushang oder den Studiotisch.
      </div>
      <div style={{display:"flex",gap:12,flexWrap:"wrap"}}>
        <NewsletterQRKarte T={T} titel="QR Code" beschr="Scannen → Anmeldeseite öffnet sich"
          url={url} dateiname="Newsletter-QR.png"/>
        <NewsletterQRKarte T={T} titel="Link" beschr="Scannen → Adresse zum Kopieren (Insta)"
          url={linkUrl} dateiname="Newsletter-Link-QR.png"/>
      </div>
    </div>
  );
}

function CustomersPage({customers,bookings,setCustomers,setBookings,T,events=[]}){
  const [custFont,setCustFont]=useState(()=>{const v=parseInt(localStorage.getItem("sd_cust_fontsize")||"",10);return(Number.isFinite(v)&&v>=16)?v:16;});
  useEffect(()=>{localStorage.setItem("sd_cust_fontsize",String(custFont));},[custFont]);
  const [search,setSearch]=useState("");
  const [modal,setModal]=useState(null);
  const [terminModal,setTerminModal]=useState(null); // Einzeltermin aus der Kundenkarte
  const [showSevDesk,setShowSevDesk]=useState(false);
  const [vertragLoading,setVertragLoading]=useState(false);
  const [vertragKunde,setVertragKunde]=useState(null);
  const [view,setView]=useState("kunden");
  const [buchungslinkKunde,setBuchungslinkKunde]=useState(null);
  const [firmenKontakte,setFirmenKontakte]=useState(()=>{try{return JSON.parse(localStorage.getItem("sd_firmenkontakte")||"[]");}catch{return [];}});
  const [firmenEditK,setFirmenEditK]=useState(null);
  const [firmenForm,setFirmenForm]=useState({});
  const leerFK=()=>({id:uid(),name:"",firma:"",strasse:"",plz:"",ort:"",handy:"",telefon:"",email:"",homepage:"",oeffnungszeiten:"",sonstiges:""});
  const saveFirmen=(neu)=>{setFirmenKontakte(neu);localStorage.setItem("sd_firmenkontakte",JSON.stringify(neu));};
  const ffk=(k,v)=>setFirmenForm(f=>({...f,[k]:v}));
  const [fkTaH,setFkTaH]=useState(()=>{try{return JSON.parse(localStorage.getItem("sd_fk_tah")||"{}");}catch{return {};}});
  const saveFkTaH=(k,h)=>{const n={...fkTaH,[k]:h};setFkTaH(n);localStorage.setItem("sd_fk_tah",JSON.stringify(n));};
  const [abonnenten,setAbonnenten]=useState(()=>{try{return JSON.parse(localStorage.getItem("sd_nl_abonnenten")||"[]");}catch{return [];}});
  useEffect(()=>{
    // Kam der Aufruf ueber die Dashboard-Kachel, direkt die Abonnenten zeigen
    try{
      if(sessionStorage.getItem("sd_kunden_view")==="abonnenten"){
        sessionStorage.removeItem("sd_kunden_view");
        setView("abonnenten");
      }
    }catch(e){}
  },[]);
  const [aboName,setAboName]=useState("");
  const [aboEmail,setAboEmail]=useState("");
  const srvNL=(localStorage.getItem("sd_server_url")||"").trim().replace(/\/+$/,"");
  // Zeitpunkt des letzten Abrufs. Der Server braucht ihn, um zu erkennen,
  // welche Anmeldungen die App noch gar nicht kennen kann.
  const nlStand=useRef("");
  function saveAbos(list){
    setAbonnenten(list);
    localStorage.setItem("sd_nl_abonnenten",JSON.stringify(list));
    if(srvNL)fetch(srvNL+"/api/nl-abonnenten",{method:"POST",headers:{"Content-Type":"application/json"},
      body:JSON.stringify({liste:list,stand:nlStand.current})}).catch(()=>{});
  }
  useEffect(()=>{
    if(!srvNL)return;
    // Ortszeit, nicht UTC. Der Server schreibt seine Zeitstempel ebenfalls
    // in Ortszeit, sonst laegen die Werte zwei Stunden auseinander.
    nlStand.current=new Date(Date.now()-new Date().getTimezoneOffset()*60000).toISOString().slice(0,19);
    fetch(srvNL+"/api/nl-abonnenten").then(r=>r.json()).then(d=>{
      if(!Array.isArray(d))return;
      setAbonnenten(d);
      localStorage.setItem("sd_nl_abonnenten",JSON.stringify(d));
    }).catch(()=>{});
  },[srvNL]);
  function addAbo(){
    if(!aboEmail.trim())return;
    if(abonnenten.some(a=>a.email.toLowerCase()===aboEmail.trim().toLowerCase())){alert("E-Mail bereits vorhanden.");return;}
    saveAbos([...abonnenten,{id:uid(),name:aboName.trim(),email:aboEmail.trim(),aktiv:true,datum:new Date().toISOString().slice(0,10)}]);
    setAboName("");setAboEmail("");
  }
  function toggleAbo(id){saveAbos(abonnenten.map(a=>a.id===id?{...a,aktiv:!a.aktiv}:a));}
  function delAbo(id){if(confirm("Abonnent löschen?"))saveAbos(abonnenten.filter(a=>a.id!==id));}
  const kundenNL=customers.filter(c=>c.newsletter&&c.email);
  // Wer schon Kunde ist, wird nur einmal gezaehlt und erscheint unten
  // entsprechend gekennzeichnet.
  const kundenMails=new Set(kundenNL.map(c=>(c.email||"").toLowerCase()));
  const aktiveAbos=abonnenten.filter(a=>a.aktiv&&!kundenMails.has((a.email||"").toLowerCase()));
  const offeneAbos=abonnenten.filter(a=>!a.aktiv&&(a.quelle==="webformular"||a.quelle==="buchung"));

  async function erstelleVertrag(kunde){
    setVertragLoading(true);
    try{
      const resp=await fetch((localStorage.getItem("sd_server_url")||"http://167.233.88.11")+"/api/vertrag",{
        method:"POST",
        headers:{"Content-Type":"application/json"},
        body:JSON.stringify({
          kunde,
          studio:JSON.parse(localStorage.getItem("sd_api_settings")||"{}"),
          logo:(JSON.parse(localStorage.getItem("sd_api_settings")||"{}").studio_logo)||
               (JSON.parse(localStorage.getItem("sd_buchung_config")||"{}").logo)||null,
        }),
      });
      if(resp.ok){
        const blob=await resp.blob();
        const url=URL.createObjectURL(blob);
        const fname=`Vertrag_${(kunde.name||"Kunde").replace(/\s+/g,"_")}.pdf`;
        const a=document.createElement("a");
        a.href=url; a.download=fname; a.click();
        setTimeout(()=>URL.revokeObjectURL(url),10000);
      }else{
        alert("Server-Fehler beim Erstellen des Vertrags.");
      }
    }catch(e){
      alert("Vertrag-Server nicht erreichbar.\nBitte starten: python vertrag_server.py");
    }
    setVertragLoading(false);
  }
    const [custColW,startCustResize]=useColW("sd_cols_kunden",{kdnr:80,anrede:80,kunde:180,strasse:160,plz:70,ort:120,telefon:130,email:180,hundename:120,rasse:140,alter:65,geschlecht:80,akt:130});
  const [checked,setChecked]=useState(new Set());
  const [sortDir,setSortDir]=useState("desc"); // desc = neueste zuerst, asc = älteste zuerst
  const [sortBy,setSortBy]=useState("kdnr");
  const filtered=[...customers].sort((a,b)=>{
    if(sortBy==="kdnr"){
      function pk(nr){if(!nr)return[0,0];const m=(nr+"").match(/^(\d{4})-?(\d+)$/);if(m)return[+m[1],+m[2]];const n=+(nr+"").replace(/\D/g,"")||0;return[Math.floor(n/1000),n%1000];}
      const[ya,la]=pk(a.kundennr),[yb,lb]=pk(b.kundennr);
      if(!ya&&!la)return 1;if(!yb&&!lb)return -1;
      if(ya!==yb)return sortDir==="asc"?ya-yb:yb-ya;
      return sortDir==="asc"?la-lb:lb-la;
    }
    const da=new Date(a.created||"1970").getTime();
    const db=new Date(b.created||"1970").getTime();
    return sortDir==="asc"?da-db:db-da;
  }).filter(c=>[c.name,c.email,c.dog||""].join(" ").toLowerCase().includes(search.toLowerCase()));
  function save(c){setCustomers(p=>p.find(x=>x.id===c.id)?p.map(x=>x.id===c.id?c:x):[...p,c]);setModal(null);}

  function exportSevDeskCSV(){
    const toExp=checked.size>0?customers.filter(c=>checked.has(c.id)):filtered;
    if(toExp.length===0){alert("Keine Kunden zum Exportieren.");return;}
    // sevDesk CSV Header (exakt wie Import-Format)
    const header=["Kunden-Nr.","Anrede","Titel","Nachname","Vorname","Organisation","Namenszusatz","Position ","Kategorie","IBAN","BIC","UmSt.-ID","Strasse","PLZ","Ort","Land","Adresse-Kategorie","Telefon","Telefon-Kategorie","Mobil","Fax","E-Mail","E-Mail-Kategorie","Webseite","Webseite-Kategorie","Beschreibung","Geburtstag","Tags","Debitoren-Nr.","Kreditoren-Nr.","Leitweg-ID / Leitwegsnummer","Steuernummer","Skonto Tage","Skonto Prozent","Zahlungsziel Tage","Kundenrabatt","Ist Kundenrabatt prozentual"];
    function esc(v){const s=String(v||"");return s.includes(";")||s.includes('"')||s.includes('\\n')?`"${s.replace(/"/g,'""')}"`:s;}
    const rows=toExp.map(c=>{
      // Name aufteilen: letztes Wort = Nachname, Rest = Vorname
      const nameParts=(c.name||"").trim().split(" ");
      const nachname=nameParts.length>1?nameParts[nameParts.length-1]:"";
      const vorname=nameParts.length>1?nameParts.slice(0,-1).join(" "):nameParts[0]||"";
      const anrede=c.anrede||"";
      const kdnr=c.kundennr||"";
      return [
        kdnr,       // Kunden-Nr.
        anrede,     // Anrede
        "",         // Titel
        nachname,   // Nachname
        vorname,    // Vorname
        "",         // Organisation
        "",         // Namenszusatz
        "",         // Position
        "Kunde",    // Kategorie
        "",         // IBAN
        "",         // BIC
        "",         // UmSt.-ID
        c.strasse||c.street||"",  // Strasse
        c.plz||c.zip||"",          // PLZ
        c.ort||c.city||"",         // Ort
        (c.ort||c.city)?"Deutschland":"",  // Land
        (c.strasse||c.street)?"Arbeit":"",  // Adresse-Kategorie
        c.telefon||"",  // Telefon
        c.telefon?"Arbeit":"",  // Telefon-Kategorie
        c.phone||"",   // Mobil
        "",         // Fax
        c.email||"",    // E-Mail
        c.email?"Arbeit":"",    // E-Mail-Kategorie
        "",         // Webseite
        "",         // Webseite-Kategorie
        c.notes||"",    // Beschreibung
        "",         // Geburtstag
        "",         // Tags
        "",         // Debitoren-Nr.
        "",         // Kreditoren-Nr.
        "",         // Leitweg-ID
        "",         // Steuernummer
        "",         // Skonto Tage
        "",         // Skonto Prozent
        "",         // Zahlungsziel Tage
        "",         // Kundenrabatt
        "",         // Ist Kundenrabatt prozentual
      ].map(esc).join(";");
    });
    const csv="\uFEFF"+[header.map(esc).join(";"),...rows].join("\n");
    const blob=new Blob([csv],{type:"text/csv;charset=utf-8"});
    const a=document.createElement("a");
    a.href=URL.createObjectURL(blob);
    const date=new Date().toISOString().slice(0,10).replace(/-/g,"");
    a.download=`scattodesk_kontakte_${date}.csv`;
    a.click();
    alert(`✅ ${toExp.length} Kunden exportiert.`);
  }
  function del(id){if(confirm("Kunden löschen?"))setCustomers(p=>p.filter(x=>x.id!==id));}
  return(
    <div>
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:16}}>
        <div>
        <div style={{display:"flex",alignItems:"center",gap:14}}>
          <div style={{fontSize:13,color:T.muted,marginTop:2}}>{customers.length} Kunden · {kundenNL.length+aktiveAbos.length} Newsletter-Abonnenten</div>
          <div style={{display:"flex",alignItems:"center",gap:7,color:T.muted}}>
            <span style={{fontSize:11}}>A</span>
            <input type="range" min={10} max={22} value={custFont} onChange={e=>setCustFont(Number(e.target.value))} style={{width:80,accentColor:T.accent,cursor:"pointer"}}/>
            <span style={{fontSize:16}}>A</span>
            <span style={{fontSize:11,minWidth:28}}>{custFont}px</span>
          </div>
        </div>
        </div>
        <div style={{display:"flex",gap:8}}>
          <button style={btn(T,"ghost")} onClick={()=>{window._sevdeskSelected=checked.size>0?customers.filter(c=>checked.has(c.id)):null;setShowSevDesk(true);}}>
            <svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"><circle cx="8" cy="8" r="6"/><path d="M5 8h6M8 5v6"/></svg>
            {checked.size>0?`${checked.size} → `:""}{rechnungsProgrammName()} Sync
          </button>
          <button style={btn(T,"ghost")} onClick={exportSevDeskCSV} title={checked.size>0?`${checked.size} markierte exportieren`:"Alle exportieren"}>
            📥 {checked.size>0?`${checked.size} als CSV`:"Als CSV"} für sevDesk
          </button>
          <button style={btn(T,"primary")} onClick={()=>setModal("new")}>+ Neuer Kunde</button>
        </div>
      </div>

      {/* Tabs */}
      <div style={{display:"flex",gap:6,marginBottom:20,borderBottom:`1px solid ${T.border}`,paddingBottom:12}}>
        <button style={btn(T,view==="kunden"?"active":"ghost",true)} onClick={()=>setView("kunden")}>👥 Kunden ({customers.length})</button>
        <button style={btn(T,view==="firmen"?"active":"ghost",true)} onClick={()=>setView("firmen")}>🏢 Firmen ({firmenKontakte.length})</button>
        <button style={btn(T,view==="abonnenten"?"active":"ghost",true)} onClick={()=>setView("abonnenten")}>📧 Newsletter-Abonnenten ({kundenNL.length+aktiveAbos.length})</button>
        <button style={btn(T,view==="nlqr"?"active":"ghost",true)} onClick={()=>setView("nlqr")}>⬛ QR-Codes</button>
      </div>

      {/* Abonnenten-View */}
      {view==="firmen"&&(
        <div style={{padding:"4px 0"}}>
          {firmenEditK!==null?(()=>{
            const isNew=firmenEditK==="new";
            const IS2={background:T.bg,border:`1px solid ${T.border}`,borderRadius:7,padding:"8px 10px",color:T.text,fontSize:13,fontFamily:"inherit",width:"100%",boxSizing:"border-box"};
            const LB={fontSize:11,fontWeight:700,color:T.muted,textTransform:"uppercase",letterSpacing:".06em",marginBottom:4,display:"block"};
            return(
              <div style={{maxWidth:720}}>
                <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:20}}>
                  <button style={btn(T,"ghost",true)} onClick={()=>setFirmenEditK(null)}>← Zurück</button>
                  <div style={{fontFamily:"Georgia,serif",fontSize:17,color:T.accent}}>{isNew?"Neuer Kontakt":"Kontakt bearbeiten"}</div>
                </div>
                <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:12,padding:24,display:"flex",flexDirection:"column",gap:14}}>
                  <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
                    <div><span style={LB}>Name</span><input value={firmenForm.name||""} onChange={e=>ffk("name",e.target.value)} placeholder="Sina Wittmann" style={IS2}/></div>
                    <div><span style={LB}>Firma</span><input value={firmenForm.firma||""} onChange={e=>ffk("firma",e.target.value)} placeholder="Naturfutterladen Tierlieb" style={IS2}/></div>
                  </div>
                  <div><span style={LB}>Straße</span><input value={firmenForm.strasse||""} onChange={e=>ffk("strasse",e.target.value)} placeholder="Musterstraße 1" style={IS2}/></div>
                  <div style={{display:"grid",gridTemplateColumns:"120px 1fr",gap:12}}>
                    <div><span style={LB}>PLZ</span><input value={firmenForm.plz||""} onChange={e=>{
                      const plz=e.target.value.replace(/[^0-9]/g,"");ffk("plz",plz);
                      if(plz.length===5){fetch(`https://api.zippopotam.us/de/${plz}`).then(r=>r.ok?r.json():null).then(d=>{if(d?.places?.[0])ffk("ort",d.places[0]["place name"]);}).catch(()=>{});}
                    }} placeholder="90429" style={IS2} maxLength={5}/></div>
                    <div><span style={LB}>Ort</span><input value={firmenForm.ort||""} onChange={e=>ffk("ort",e.target.value)} placeholder="Nürnberg" style={IS2}/></div>
                  </div>
                  <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:12}}>
                    <div><span style={LB}>Handy</span><input value={firmenForm.handy||""} onChange={e=>ffk("handy",e.target.value)} placeholder="+49 151 12345678" style={IS2}/></div>
                    <div><span style={LB}>Telefon</span><input value={firmenForm.telefon||""} onChange={e=>ffk("telefon",e.target.value)} placeholder="+49 911 123456" style={IS2}/></div>
                    <div><span style={LB}>E-Mail</span>
                      {/* Doppelklick oeffnet das Standard-Mailprogramm. Das Feld
                          bleibt normal beschreibbar. */}
                      <input value={firmenForm.email||""} onChange={e=>ffk("email",e.target.value)}
                        onDoubleClick={()=>{const a=(firmenForm.email||"").trim();if(a)window.location.href="mailto:"+a;}}
                        title="Doppelklick öffnet eine neue Mail"
                        placeholder="info@firma.de" style={IS2}/></div>
                  </div>
                  <div><span style={LB}>Homepage</span><input value={firmenForm.homepage||""} onChange={e=>ffk("homepage",e.target.value)} placeholder="www.firma.de" style={IS2}/></div>
                  <div>
                    <span style={LB}>Öffnungszeiten</span>
                    <textarea value={firmenForm.oeffnungszeiten||""} onChange={e=>ffk("oeffnungszeiten",e.target.value)}
                      placeholder="Mo-Fr 9-18 Uhr, Sa 10-14 Uhr"
                      onMouseUp={e=>saveFkTaH("oeffnungszeiten",e.target.offsetHeight)}
                      style={{...IS2,resize:"vertical",minHeight:60,lineHeight:1.5,height:fkTaH.oeffnungszeiten||60}}/>
                  </div>
                  <div>
                    <span style={LB}>Sonstiges</span>
                    <textarea value={firmenForm.sonstiges||""} onChange={e=>ffk("sonstiges",e.target.value)}
                      placeholder="Notizen, Besonderheiten..."
                      onMouseUp={e=>saveFkTaH("sonstiges",e.target.offsetHeight)}
                      style={{...IS2,resize:"vertical",minHeight:60,lineHeight:1.5,height:fkTaH.sonstiges||60}}/>
                  </div>
                  <div style={{display:"flex",gap:8,marginTop:4}}>
                    <button onClick={()=>{
                      if(!firmenForm.name&&!firmenForm.firma){alert("Bitte Name oder Firma angeben.");return;}
                      if(isNew){saveFirmen([...firmenKontakte,firmenForm]);}else{saveFirmen(firmenKontakte.map(k=>k.id===firmenForm.id?firmenForm:k));}
                      setFirmenEditK(null);
                    }} style={{background:T.accent,color:"#fff",border:"none",borderRadius:8,padding:"10px 20px",fontSize:13,fontWeight:600,cursor:"pointer"}}>Speichern</button>
                    {!isNew&&<button onClick={()=>{if(!confirm("Kontakt löschen?"))return;saveFirmen(firmenKontakte.filter(k=>k.id!==firmenForm.id));setFirmenEditK(null);}}
                      style={{background:"none",border:"1px solid #e53",borderRadius:8,padding:"10px 16px",fontSize:13,color:"#e53",cursor:"pointer"}}>Löschen</button>}
                  </div>
                </div>
              </div>
            );
          })():(
            <div>
              <div style={{display:"flex",justifyContent:"flex-end",marginBottom:16}}>
                <button onClick={()=>{setFirmenForm(leerFK());setFirmenEditK("new");}} style={{background:T.accent,color:"#fff",border:"none",borderRadius:8,padding:"8px 16px",fontSize:13,fontWeight:600,cursor:"pointer"}}>+ Neuer Kontakt</button>
              </div>
              {firmenKontakte.length===0&&<div style={{color:T.muted,fontSize:13,padding:"30px 0",textAlign:"center"}}>Noch keine Firmenkontakte angelegt.</div>}
              <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(160px,1fr))",gap:12}}>
                {[...firmenKontakte].sort((a,b)=>{
                  // Nach dem, was auch gross auf der Karte steht
                  const an=(a.firma||a.name||"").toLowerCase();
                  const bn=(b.firma||b.name||"").toLowerCase();
                  return an.localeCompare(bn,"de");
                }).map(k=>(
                  <div key={k.id} onClick={()=>{setFirmenForm({...k});setFirmenEditK(k.id);}}
                    style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:12,padding:"16px 14px",cursor:"pointer",textAlign:"center",transition:"border-color 0.15s,box-shadow 0.15s"}}
                    onMouseEnter={el=>{el.currentTarget.style.borderColor=T.accent;el.currentTarget.style.boxShadow=`0 2px 10px ${T.accent}22`;}}
                    onMouseLeave={el=>{el.currentTarget.style.borderColor=T.border;el.currentTarget.style.boxShadow="none";}}>
                    <div style={{width:40,height:40,borderRadius:"50%",background:T.accentDim,display:"flex",alignItems:"center",justifyContent:"center",margin:"0 auto 10px",fontSize:18,color:T.accent}}>
                      {(k.firma||k.name||"?")[0].toUpperCase()}
                    </div>
                    <div style={{fontSize:13,fontWeight:700,color:T.text,lineHeight:1.3,marginBottom:3}}>{k.firma||k.name||"–"}</div>
                    <div style={{fontSize:11,color:T.muted,lineHeight:1.3}}>{k.firma?(k.name||""):""}</div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      )}
      {view==="nlqr"&&(
        <div>
          <NewsletterQR T={T} url={srvNL?srvNL+"/newsletter":""}/>
          {!srvNL&&<div style={{fontSize:13,color:T.muted}}>Keine Server-Adresse hinterlegt, deshalb lässt sich kein QR-Code erzeugen.</div>}
        </div>
      )}

      {view==="abonnenten"&&(
        <div>
          <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:12,padding:20,marginBottom:16}}>
            <div style={{fontFamily:"Georgia,serif",fontSize:15,color:T.accent,marginBottom:12}}>Neuen Abonnenten hinzufügen</div>
            <div style={{display:"flex",gap:10,flexWrap:"wrap"}}>
              <input value={aboName} onChange={e=>setAboName(e.target.value)} placeholder="Name (optional)"
                style={{flex:1,minWidth:160,background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:"9px 12px",color:T.text,fontSize:13,fontFamily:"inherit",outline:"none"}}/>
              <input value={aboEmail} onChange={e=>setAboEmail(e.target.value)} placeholder="E-Mail *" type="email"
                onKeyDown={e=>e.key==="Enter"&&addAbo()}
                style={{flex:2,minWidth:200,background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:"9px 12px",color:T.text,fontSize:13,fontFamily:"inherit",outline:"none"}}/>
              <button style={btn(T,"primary")} onClick={addAbo}>+ Hinzufügen</button>
            </div>
          </div>
          {kundenNL.length>0&&(
            <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:12,padding:20,marginBottom:16}}>
              <div style={{fontSize:12,fontWeight:700,color:T.muted,textTransform:"uppercase",letterSpacing:"0.08em",marginBottom:12}}>Kunden mit Newsletter-Haken ({kundenNL.length})</div>
              <div style={{display:"flex",flexDirection:"column",gap:6}}>
                {kundenNL.map(c=>(
                  <div key={c.id} style={{display:"flex",alignItems:"center",gap:12,padding:"8px 12px",background:T.bg,borderRadius:8,border:`1px solid ${T.border}`}}>
                    <div style={{width:32,height:32,borderRadius:"50%",background:T.accentDim,display:"flex",alignItems:"center",justifyContent:"center",fontSize:12,fontWeight:700,color:T.accent,flexShrink:0}}>
                      {(c.name||"?").split(" ").map(x=>x[0]).join("").toUpperCase().slice(0,2)}
                    </div>
                    <div style={{flex:1}}>
                      <div style={{fontSize:13,fontWeight:600,color:T.text}}>{c.name}</div>
                      <div style={{fontSize:11,color:T.muted}}>{c.email}</div>
                    </div>
                    <span style={{fontSize:11,background:"#6dbf6a22",color:"#3a7a38",padding:"2px 8px",borderRadius:20}}>Kunde ✓</span>
                  </div>
                ))}
              </div>
            </div>
          )}
          <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:12,padding:20}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12,flexWrap:"wrap",gap:8}}>
              <div style={{fontSize:12,fontWeight:700,color:T.muted,textTransform:"uppercase",letterSpacing:"0.08em"}}>Externe Abonnenten ({abonnenten.length})</div>
              {srvNL&&(
                <button style={{...btn(T,"ghost",true),fontSize:11}}
                  onClick={()=>{navigator.clipboard&&navigator.clipboard.writeText(srvNL+"/newsletter");alert("Anmeldelink kopiert:\n"+srvNL+"/newsletter");}}>
                  Anmeldelink kopieren
                </button>
              )}
            </div>
            {offeneAbos.length>0&&(
              <div style={{fontSize:11,color:"#b45309",background:"#fef9ee",border:"1px solid #f59e0b44",borderRadius:8,padding:"8px 12px",marginBottom:10}}>
                {offeneAbos.length} Anmeldung{offeneAbos.length!==1?"en":""} wartet noch auf die Bestätigung per E-Mail und bekommt bis dahin keinen Newsletter.
              </div>
            )}
            {abonnenten.length===0&&<div style={{fontSize:13,color:T.muted}}>Noch keine externen Abonnenten.</div>}
            <div style={{display:"flex",flexDirection:"column",gap:6}}>
              {abonnenten.map(a=>(
                <div key={a.id} style={{display:"flex",alignItems:"center",gap:12,padding:"8px 12px",background:T.bg,borderRadius:8,border:`1px solid ${T.border}`,opacity:a.aktiv?1:0.5}}>
                  <div style={{flex:1}}>
                    <div style={{fontSize:13,fontWeight:600,color:T.text}}>{a.name||"—"}</div>
                    <div style={{fontSize:11,color:T.muted}}>
                      {a.email} · seit {a.datum||"?"}
                      {a.quelle==="webformular"&&" · über das Webformular"}
                      {a.quelle==="abmeldung"&&" · hat sich selbst abgemeldet"}
                      {kundenMails.has((a.email||"").toLowerCase())&&" · steht auch in der Kundenliste"}
                    </div>
                  </div>
                  {a.quelle==="webformular"&&!a.aktiv
                    ?<span style={{fontSize:11,background:"#f59e0b22",color:"#b45309",padding:"2px 8px",borderRadius:20}}>Wartet auf Bestätigung</span>
                    :<span style={{fontSize:11,background:a.aktiv?"#6dbf6a22":T.border,color:a.aktiv?"#3a7a38":T.muted,padding:"2px 8px",borderRadius:20,cursor:"pointer"}}
                      onClick={()=>toggleAbo(a.id)}>{a.aktiv?"Aktiv":"Abgemeldet"}</span>}
                  <button style={btn(T,"danger",true)} onClick={()=>delAbo(a.id)}>✕</button>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {view==="kunden"&&(
      <div style={{display:"flex",flexDirection:"column",height:"calc(100vh - 260px)"}}>
      {showSevDesk&&<SevDeskSyncModal customers={window._sevdeskSelected||customers} onImport={imported=>{
        setCustomers(p=>{
          const existing=new Set(p.map(c=>c.email?.toLowerCase()).filter(Boolean));
          const neu=imported.filter(c=>!existing.has(c.email?.toLowerCase()));
          return[...p,...neu];
        });
        setShowSevDesk(false);
      }} onClose={()=>setShowSevDesk(false)} T={T}/>}
      <div style={{display:"flex",alignItems:"center",gap:10,background:T.surface,border:`1px solid ${T.border}`,borderRadius:10,padding:"8px 14px",marginBottom:12,flexShrink:0}}>
        <span style={{color:T.muted,display:"flex"}}><Ic n="search" s={14}/></span>
        <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Name, E-Mail oder Tier..." style={{border:"none",background:"transparent",padding:0,flex:1,fontSize:13,color:T.text,fontFamily:"inherit",outline:"none"}}/>
      </div>
      <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:12,overflow:"hidden",flex:1,display:"flex",flexDirection:"column"}}>
        <div style={{overflowX:"auto",overflowY:"auto",flex:1}}>
          <table key={custFont} style={{width:Object.values(custColW).reduce((a,b)=>a+b,0)+36,minWidth:"100%",borderCollapse:"collapse",tableLayout:"fixed",fontSize:custFont}}>
            <thead><tr style={{background:T.bg}}>
              <th style={{padding:"8px 10px",width:36,fontSize:11,fontWeight:600,borderBottom:`1px solid ${T.border}`,position:"relative",userSelect:"none",background:T.bg}}><input type="checkbox" style={{accentColor:T.accent}} onChange={e=>{if(e.target.checked)setChecked(new Set(filtered.map(c=>c.id)));else setChecked(new Set());}}/></th>
              {[["kdnr","Kd-Nr"],["anrede","Anrede"],["kunde","Kunde"],["strasse","Straße"],["plz","PLZ"],["ort","Ort"],["telefon","Telefon"],["email","E-Mail"],["hundename","Hundename"],["rasse","Rasse"],["alter","Alter"],["geschlecht","Geschl."],["akt",""]].map(([k,h])=><th key={k} style={{textAlign:"center",padding:"8px 10px",fontSize:11,fontWeight:600,color:T.muted,textTransform:"uppercase",letterSpacing:"0.07em",borderBottom:`1px solid ${T.border}`,whiteSpace:"nowrap",width:custColW[k],position:"relative",userSelect:"none",background:T.bg}}>{h}{k!=="akt"&&<ResizeHandle T={T} onMouseDown={e=>startCustResize(e,k)}/>}</th>)}
            </tr></thead>
            <tbody>
            {filtered.map(c=>{
              return <tr key={c.id} onMouseEnter={e=>e.currentTarget.style.background=T.tileHover} onMouseLeave={e=>e.currentTarget.style.background="transparent"} onDoubleClick={()=>setModal(c)} style={{transition:"background 0.1s",cursor:"pointer",background:checked.has(c.id)?T.accentDim:"transparent"}}>
                <td style={{padding:"12px 8px",textAlign:"center",borderBottom:`1px solid ${T.border}22`}}><input type="checkbox" checked={checked.has(c.id)} onChange={e=>{setChecked(prev=>{const n=new Set(prev);e.target.checked?n.add(c.id):n.delete(c.id);return n;});}} onClick={e=>e.stopPropagation()} style={{accentColor:T.accent}}/></td>
                <td style={{padding:"12px 16px",fontSize:custFont,fontFamily:"monospace",color:T.accent,borderBottom:`1px solid ${T.border}22`,whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{c.kundennr||"—"}</td>
                <td style={{padding:"12px 16px",borderBottom:`1px solid ${T.border}22`}}>
                  <select value={c.anrede||""} onChange={e=>setCustomers(p=>p.map(x=>x.id===c.id?{...x,anrede:e.target.value}:x))}
                    style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:6,padding:"4px 6px",color:c.anrede?T.text:T.muted,fontSize:custFont,fontFamily:"inherit",outline:"none",cursor:"pointer"}}>
                    <option value="">—</option>
                    <option value="Frau">Frau</option>
                    <option value="Herr">Herr</option>
                    <option value="Divers">Divers</option>
                  </select>
                </td>
                <td style={{padding:"12px 16px",borderBottom:`1px solid ${T.border}22`,textAlign:"center",fontSize:custFont,fontWeight:600,color:T.text}}>{c.name}</td>
                <td style={{padding:"12px 16px",fontSize:custFont,color:T.muted,borderBottom:`1px solid ${T.border}22`,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",textAlign:"center"}}>{c.strasse||"—"}</td>
                <td style={{padding:"12px 16px",fontSize:custFont,color:T.muted,borderBottom:`1px solid ${T.border}22`,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",textAlign:"center"}}>{c.plz||"—"}</td>
                <td style={{padding:"12px 16px",fontSize:custFont,color:T.muted,borderBottom:`1px solid ${T.border}22`,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",textAlign:"center"}}>{c.ort||"—"}</td>
                <td style={{padding:"12px 16px",fontSize:custFont,color:T.muted,borderBottom:`1px solid ${T.border}22`,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",textAlign:"center"}}>{c.phone||"—"}</td>
                <td style={{padding:"12px 16px",fontSize:custFont,borderBottom:`1px solid ${T.border}22`,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",textAlign:"center"}}>
                  {c.email?<a href={`mailto:${c.email}`} onClick={e=>e.stopPropagation()}
                    style={{color:T.info,textDecoration:"none",cursor:"pointer",transition:"all 0.15s"}} title={`E-Mail an ${c.email} schreiben`}
                    onMouseEnter={e=>{e.currentTarget.style.textDecoration="underline";e.currentTarget.style.opacity="0.75";}}
                    onMouseLeave={e=>{e.currentTarget.style.textDecoration="none";e.currentTarget.style.opacity="1";}}>{c.email}</a>:"—"}
                </td>
                <td style={{padding:"12px 16px",fontSize:custFont,color:T.muted,borderBottom:`1px solid ${T.border}22`,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",textAlign:"center"}}>{c.tiere?.[0]?.name||c.dog||"—"}</td>
                <td style={{padding:"12px 16px",fontSize:custFont,color:T.muted,borderBottom:`1px solid ${T.border}22`,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",textAlign:"center"}}>{c.tiere?.[0]?.rasse||c.breed||"—"}</td>
                <td style={{padding:"12px 16px",fontSize:custFont,color:T.muted,borderBottom:`1px solid ${T.border}22`,whiteSpace:"nowrap",textAlign:"center"}}>{(()=>{
                  const a=c.tiere?.[0];
                  if(!a)return "—";
                  const jahre=parseInt(a.alter||"0",10);
                  const monate=parseInt(a.alterMonate||"0",10);
                  if(!jahre&&!monate)return "—";
                  if(!jahre&&monate)return `${monate} Mon.`;
                  if(jahre&&!monate)return `${jahre} J.`;
                  return `${jahre} J. ${monate} Mon.`;
                })()}</td>
                <td style={{padding:"12px 16px",fontSize:custFont,color:T.muted,borderBottom:`1px solid ${T.border}22`,whiteSpace:"nowrap",textAlign:"center"}}>{c.tiere?.[0]?.geschlecht||"—"}</td>
                
                <td style={{padding:"12px 16px",borderBottom:`1px solid ${T.border}22`}}>
                  <div style={{display:"flex",gap:6}}>
                    <button style={{...btn(T,"ghost",true),fontSize:10}} onClick={e=>{e.stopPropagation();setVertragKunde(c);}}><Ic n="edit" s={11}/> Vertrag</button>
                    <button style={btn(T,"danger",true)} onClick={e=>{e.stopPropagation();del(c.id);}}>Löschen</button>
                  </div>
                </td>
              </tr>;
            })}
            </tbody>
          </table>
        </div>
      </div>
      {modal&&<CustomerModal customer={modal==="new"?null:modal} onSave={save} onClose={()=>setModal(null)} T={T} events={events}
        onNeuerTermin={k=>{setModal(null);setTerminModal(k);}}/>}
      {terminModal&&<BookingModal booking={{customerId:terminModal.id}} customers={customers} setCustomers={setCustomers}
        onSave={b=>{
          setBookings&&setBookings(p=>[...p,{...b,id:b.id||uid()}]);
          setTerminModal(null);
        }}
        onClose={()=>setTerminModal(null)} T={T}/>}
      {vertragKunde&&<VertragModal kunde={vertragKunde} onClose={()=>setVertragKunde(null)} T={T}/>}
      {buchungslinkKunde&&<BuchungslinkModal kunde={buchungslinkKunde} events={events} T={T} onClose={()=>setBuchungslinkKunde(null)}/>}

      {/* Vertrag laden Indikator */}
      {vertragLoading&&(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.5)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:200}}>
          <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:14,padding:28,textAlign:"center"}}>
            <div style={{fontFamily:"Georgia,serif",fontSize:16,color:T.accent,marginBottom:8}}>Vertrag wird erstellt…</div>
            <div style={{fontSize:12,color:T.muted}}>Bitte warte kurz.</div>
          </div>
        </div>
      )}
      </div>)} {/* Ende view==="kunden" */}

    </div>
  );

}

// ── Bookings Page ─────────────────────────────────────────────────────────────
function BookingsPage({bookings,customers,setCustomers,setBookings,events=[],setEvents,onOpenEvent,onOpenShootingplan,onOpenBuchung,onCreateOrdner,T}){
  const [bookFont,setBookFont]=useState(()=>{const v=parseInt(localStorage.getItem("sd_book_fontsize")||"",10);return(Number.isFinite(v)&&v>=12)?v:14;});
  useEffect(()=>{localStorage.setItem("sd_book_fontsize",String(bookFont));},[bookFont]);
  // Welche Termine zeigen ihre weiteren Hunde. Ein Klick auf die Zeile
  // klappt sie auf und wieder zu.
  const [offeneTiere,setOffeneTiere]=useState(()=>new Set());
  const tiereUmschalten=id=>setOffeneTiere(p=>{const n=new Set(p);n.has(id)?n.delete(id):n.add(id);return n;});
  const [bookColW,startBookResize]=useColW("sd_cols_bookings",{kdnr:55,anrede:65,kunde:140,strasse:110,plz:50,ort:80,telefon:95,email:140,hundename:85,rasse:100,alter:45,geschlecht:60,datum:85,location:110,status:75,vertrag:60,del:36});
  const [terminWahl,setTerminWahl]=useState(false);
  const [eventModal,setEventModal]=useState(false);
  const [bpInteresseModal,setBpInteresseModal]=useState(false);
  const [workflow,setWorkflow]=useState(null);
  const [filter,setFilter]=useState("alle");
  const [modal,setModal]=useState(null);
  const [agFor,setAgFor]=useState(null);
  const [emailFor,setEmailFor]=useState(null);
  const [kundeModal,setKundeModal]=useState(null);
  const [vertragKunde,setVertragKunde]=useState(null);
  function saveNewEvent(ev){
    const isNew=!events.find(x=>x.id===ev.id);
    setEvents&&setEvents(p=>p.find(x=>x.id===ev.id)?p.map(x=>x.id===ev.id?ev:x):[...p,ev]);
    setEventModal(false);
    setWorkflow(ev);
    if(isNew)onCreateOrdner&&onCreateOrdner(ev);
  }
  const heute=new Date();
  const isArchivBooking=b=>b.status==="abgesagt";
  const isAbgeschlossen=b=>b.status==="abgeschlossen"||b.bilderAbgeschlossen===true;
  const [archivOpen,setArchivOpen]=useState(false);
  const archivBookings=bookings.filter(b=>isArchivBooking(b)).sort((a,b)=>new Date(b.date)-new Date(a.date));
  const aktivBookings=bookings.filter(b=>!isArchivBooking(b));
  const filtered=(filter==="alle"?[...aktivBookings,...archivBookings]:[...aktivBookings,...archivBookings].filter(b=>b.status===filter)).sort((a,b)=>new Date(b.date)-new Date(a.date));
  function save(b){setBookings(p=>p.find(x=>x.id===b.id)?p.map(x=>x.id===b.id?b:x):[...p,b]);setModal(null);}
  function del(id){if(confirm("Termin löschen?"))setBookings(p=>p.filter(x=>x.id!==id));}
  // Mit der Unterschrift wird aus einer Anfrage automatisch eine Buchung.
  function sign(id,data){setBookings(p=>p.map(b=>b.id===id?{...b,signed:true,sigData:data,status:(b.status==="anfrage"||!b.status)?"gebucht":b.status}:b));}
  return(
    <div>
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:20}}>
        <div>
          <div style={{fontFamily:"Georgia,serif",fontSize:26,fontWeight:700,color:T.text}}>Einzeltermine</div>
          <div style={{display:"flex",alignItems:"center",gap:14}}>
            <div style={{fontSize:13,color:T.muted,marginTop:2}}>{aktivBookings.length} aktive Termine · <span style={{cursor:"pointer",textDecoration:"underline",color:T.accent}} onClick={()=>setArchivOpen(true)}>{archivBookings.length} archiviert</span></div>
            <div style={{display:"flex",alignItems:"center",gap:7,color:T.muted}}>
              <span style={{fontSize:11}}>A</span>
              <input type="range" min={10} max={22} value={bookFont} onChange={e=>setBookFont(Number(e.target.value))} style={{width:80,accentColor:T.accent,cursor:"pointer"}}/>
              <span style={{fontSize:16}}>A</span>
              <span style={{fontSize:11,minWidth:28}}>{bookFont}px</span>
            </div>
          </div>
        </div>
        <div style={{display:"flex",gap:8}}>
          <button style={btn(T,"primary")} onClick={()=>setTerminWahl(true)}>+ Neuer Termin</button>
        </div>
      </div>
      {archivOpen&&(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.55)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:300}}>
          <div style={{background:T.surface,borderRadius:14,width:"80vw",maxHeight:"80vh",overflow:"hidden",display:"flex",flexDirection:"column",border:`1px solid ${T.border}`}}>
            <div style={{padding:"16px 20px",borderBottom:`1px solid ${T.border}`,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              <div style={{fontFamily:"Georgia,serif",fontSize:18,color:T.accent}}>Archiv – Vergangene Termine</div>
              <button onClick={()=>setArchivOpen(false)} style={{background:"none",border:"none",fontSize:20,cursor:"pointer",color:T.muted}}>×</button>
            </div>
            <div style={{overflowY:"auto",padding:20,display:"flex",flexDirection:"column",gap:8}}>
              {archivBookings.length===0?<p style={{color:T.muted}}>Keine archivierten Termine.</p>:archivBookings.map(b=>{
                const c=customers.find(x=>x.id===b.customerId);
                return(<div key={b.id} style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:"12px 16px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                  <div>
                    <div style={{fontSize:13,fontWeight:600,color:T.text}}>{c?.name||"?"}</div>
                    <div style={{fontSize:11,color:T.muted}}>{fmtDateTime(b.date)} · {b.location||"—"} · {terminBetrag(b).toFixed(2)} €</div>
                  </div>
                  <span style={{fontSize:11,padding:"3px 8px",borderRadius:20,background:STATUS[b.status]?.color+"22",color:STATUS[b.status]?.color}}>{STATUS[b.status]?.label}</span>
                </div>);
              })}
            </div>
          </div>
        </div>
      )}
      {/* Tab: Einzeltermine */}
      <div style={{display:"flex",gap:6,marginBottom:16,borderBottom:`1px solid ${T.border}`,paddingBottom:12}}>
        <button style={btn(T,"active",true)}><Ic n="invoice" s={13}/> Einzeltermine ({bookings.length})</button>
      </div>
      {filter!=="events"&&<div style={{display:"flex",gap:8,marginBottom:16,flexWrap:"wrap"}}>
        {["alle",...Object.keys(STATUS)].map(s=><button key={s} style={btn(T,filter===s?"active":"ghost",true)} onClick={()=>setFilter(s)}>{s==="alle"?"Alle":STATUS[s]?.label}</button>)}
      </div>}
      {filter==="events"?(
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(300px,1fr))",gap:14}}>
          {events.filter(ev=>{const d=new Date(ev.date);const now=new Date();return d>=now||Math.ceil((d-now)/86400000)>-30;}).map(ev=>{
            const d=Math.ceil((new Date(ev.date)-new Date())/86400000);
            return(
              <div key={ev.id} style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:12,padding:18,cursor:"pointer",transition:"border-color 0.15s"}}
                onMouseEnter={e=>e.currentTarget.style.borderColor=T.accent+"66"}
                onMouseLeave={e=>e.currentTarget.style.borderColor=T.border}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:10}}>
                  <div>
                    <div style={{fontFamily:"Georgia,serif",fontSize:15,fontWeight:700,color:T.text}}>{ev.name}</div>
                    <div style={{fontSize:12,color:T.muted}}>{fmtDateRange(ev)}{ev.location?` · ${ev.location}`:""}</div>
                    <div style={{fontSize:11,color:T.accent,marginTop:2}}>{ev.fotoart}</div>
                  </div>
                  <div style={{textAlign:"right"}}>
                    <div style={{fontSize:22,fontWeight:700,color:d<0?T.muted:d<=7?T.warning:T.success}}>{d<0?"—":d}</div>
                    <div style={{fontSize:10,color:T.muted}}>{d<0?"vergangen":d===0?"heute":d===1?"morgen":"Tage"}</div>
                  </div>
                </div>
                <div style={{display:"flex",gap:6,fontSize:11,color:T.muted,marginBottom:12,flexWrap:"wrap"}}>
                  {ev.kontakt?.ansprechpartner&&<span>👤 {ev.kontakt.ansprechpartner}</span>}
                  {ev.kontakt?.telefon&&<span>📞 {ev.kontakt.telefon}</span>}
                  <span>🐾 {teilnehmerAnzahl(ev)} Teiln.</span>
                </div>
                <button style={{...btn(T,"primary",true),width:"100%",justifyContent:"center"}}
                  onClick={()=>onOpenEvent&&onOpenEvent(ev.id)}>
                  Abrechnung öffnen →
                </button>
              </div>
            );
          })}
          {events.length===0&&<div style={{gridColumn:"1/-1",textAlign:"center",padding:60,color:T.muted}}>Noch keine Events.</div>}
        </div>
      ):(
      <>
      <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:12,overflow:"hidden"}}>
        <div style={{overflowX:"auto"}}>
          <table key={bookFont} style={{width:Object.values(bookColW).reduce((a,b)=>a+b,0),borderCollapse:"collapse",tableLayout:"fixed",fontSize:bookFont}}>
            <thead><tr style={{background:T.bg}}>{[["kdnr","KD-NR"],["anrede","Anrede"],["kunde","Kunde"],["strasse","Straße"],["plz","PLZ"],["ort","Ort"],["telefon","Telefon"],["email","E-Mail"],["hundename","Hundename"],["rasse","Rasse"],["alter","Alter"],["geschlecht","Geschl."],["datum","Datum"],["location","Location"],["status","Status"],["vertrag","Vertrag"],["del",""]].map(([k,h],hi,arr)=><th key={k} style={{textAlign:"center",padding:"8px 10px",fontSize:11,fontWeight:600,color:T.muted,textTransform:"uppercase",letterSpacing:"0.08em",borderBottom:`1px solid ${T.border}`,whiteSpace:"nowrap",width:bookColW[k],position:"relative",userSelect:"none"}}>{h}<ResizeHandle T={T} onMouseDown={e=>startBookResize(e,k)}/></th>)}</tr></thead>
            <tbody>
              {filtered.map(b=>{
                const c=customers.find(x=>x.id===b.customerId);
                // Sind beim Termin Hunde angehakt, steht der erste davon in der
                // Zeile, nicht der erste aus der Kundenkartei. Die uebrigen
                // stehen wie bisher hinter dem Pfeil.
                const alleTiere=c?.tiere||[];
                const gewNamen=terminHunde(b,c);
                const tiere=(()=>{
                  const treffer=alleTiere.filter(t=>gewNamen.includes(t.name||t.rasse));
                  const rest=alleTiere.filter(t=>!gewNamen.includes(t.name||t.rasse));
                  return treffer.length?[...treffer,...rest]:alleTiere;
                })();
                const tier0=tiere[0]||{};
                const weitTiere=tiere.slice(1);
                const td=(val)=><td style={{textAlign:"center",padding:"7px 10px",fontSize:bookFont,color:T.text,borderBottom:`1px solid ${T.border}22`,whiteSpace:"nowrap"}}>{val||"—"}</td>;
                const colCount=17;
                return(<>
                <tr key={b.id} onDoubleClick={()=>setModal(b)} onMouseEnter={e=>e.currentTarget.style.background=T.tileHover} onMouseLeave={e=>e.currentTarget.style.background=(isArchivBooking(b)||isAbgeschlossen(b))?"#d4edda":"transparent"} style={{transition:"background 0.1s",cursor:"pointer",background:(isArchivBooking(b)||isAbgeschlossen(b))?"#d4edda":"transparent"}}>
                  {td(c?.kundennr)}
                  {td(c?.anrede)}
                  <td style={{textAlign:"center",padding:"7px 10px",borderBottom:`1px solid ${T.border}22`,whiteSpace:"nowrap",cursor:"pointer"}} onDoubleClick={e=>{e.stopPropagation();setEmailFor({booking:b,type:"buchung"});}}>
                    <span style={{fontSize:bookFont,fontWeight:600,color:T.text}}>{c?.name||"Unbekannt"}</span>
                    {(b.mailLog||[]).length>0&&(()=>{
                      const letztePerTyp={};
                      (b.mailLog||[]).forEach(m=>{letztePerTyp[m.typ]=m.datum;});
                      return(<div style={{display:"flex",gap:4,flexWrap:"wrap",marginTop:2}}>
                        {Object.entries(letztePerTyp).map(([t,datum])=>(
                          <span key={t} style={{fontSize:10,background:"#6dbf6a22",border:"1px solid #6dbf6a44",borderRadius:4,padding:"1px 5px",color:"#3a7a38",fontWeight:600}}>
                            {t==="bildauswahl"?"📂 Bildauswahl":"🖼 Fertige Bilder"} · {new Date(datum).toLocaleDateString("de-DE")}
                          </span>
                        ))}
                      </div>);
                    })()}
                  </td>
                  {td(c?.strasse)}
                  {td(c?.plz)}
                  {td(c?.ort)}
                  {td(c?.telefon||c?.phone)}
                  <td style={{textAlign:"center",padding:"7px 10px",fontSize:bookFont,borderBottom:`1px solid ${T.border}22`,whiteSpace:"nowrap"}}><a href={"mailto:"+(c?.email||"")} style={{color:T.info,textDecoration:"none"}}>{c?.email||"—"}</a></td>
                  <td style={{textAlign:"center",padding:"7px 10px",fontSize:bookFont,color:T.text,borderBottom:`1px solid ${T.border}22`,whiteSpace:"nowrap"}}>
                    {/* Pfeil sitzt vor dem Namen und hat immer denselben Platz,
                        damit die Spalte nicht springt. */}
                    <span style={{display:"inline-block",width:14,textAlign:"center",verticalAlign:"middle"}}>
                      {weitTiere.length>0&&(
                        <button type="button"
                          title={offeneTiere.has(b.id)?"Weitere Tiere ausblenden":weitTiere.length+" weitere anzeigen"}
                          onClick={e=>{e.stopPropagation();tiereUmschalten(b.id);}}
                          onDoubleClick={e=>e.stopPropagation()}
                          style={{background:"none",border:"none",padding:0,margin:0,cursor:"pointer",
                            color:T.accent,fontSize:9,lineHeight:1,fontFamily:"inherit",display:"inline-block",
                            transform:offeneTiere.has(b.id)?"rotate(90deg)":"none",
                            transition:"transform 0.15s"}}>▶</button>
                      )}
                    </span>
                    {tier0.name||c?.dog||"—"}
                  </td>
                  {td(tier0.rasse||c?.breed)}
                  {td(tier0.alter?(tier0.alter+" J"):(tier0.alterMonate?(tier0.alterMonate+" Mon."):""))}
                  {td(tier0.geschlecht)}
                  <td style={{textAlign:"center",padding:"7px 10px",fontSize:bookFont,color:T.muted,borderBottom:`1px solid ${T.border}22`,whiteSpace:"nowrap"}}>{fmtDate(b.date)}{b.uhrzeit?`, ${b.uhrzeit}`:""}</td>
                  <td style={{textAlign:"center",padding:"7px 10px",fontSize:bookFont,color:T.muted,borderBottom:`1px solid ${T.border}22`,whiteSpace:"nowrap"}}>{b.location||"—"}</td>
                  <td style={{textAlign:"center",padding:"7px 10px",borderBottom:`1px solid ${T.border}22`}}
                      onDoubleClick={e=>e.stopPropagation()}>
                    {isAbgeschlossen(b)
                      ? <Badge label={STATUS[b.status]?.label} color={STATUS[b.status]?.color}/>
                      : <select
                          value={b.status||"anfrage"}
                          onClick={e=>e.stopPropagation()}
                          onChange={e=>{const v=e.target.value;setBookings(p=>p.map(x=>x.id===b.id?{...x,status:v}:x));}}
                          title="Status ändern"
                          style={{
                            fontSize:11,padding:"3px 6px",borderRadius:20,cursor:"pointer",
                            border:`1px solid ${STATUS[b.status]?.color||T.border}55`,
                            background:(STATUS[b.status]?.color||T.border)+"22",
                            color:STATUS[b.status]?.color||T.text,
                            fontFamily:"inherit",outline:"none",appearance:"none",textAlign:"center"
                          }}>
                          {/* "abgeschlossen" fehlt bewusst: Fertig wird nur beim Abschliessen gesetzt */}
                          <option value="anfrage">Anfrage</option>
                          <option value="gebucht">Gebucht</option>
                          <option value="storniert">Storniert</option>
                        </select>}
                  </td>
                  <td style={{textAlign:"center",padding:"12px 16px",borderBottom:`1px solid ${T.border}22`}}>
                    {b.signed
                      ? <span style={{fontSize:bookFont,color:T.success}}>✅ Signiert</span>
                      : b.vertragVorhanden
                        ? <span style={{fontSize:bookFont,color:T.success,cursor:"pointer"}}
                                title="Klicken, um die Markierung zurückzunehmen"
                                onClick={e=>{e.stopPropagation();
                                  if(!window.confirm("Markierung „Vertrag liegt vor\" zurücknehmen?"))return;
                                  setBookings(p=>p.map(x=>x.id===b.id?{...x,vertragVorhanden:false,vertragDatum:""}:x));
                                }}>✅ Liegt vor{b.vertragDatum?" ("+new Date(b.vertragDatum).toLocaleDateString("de-DE")+")":""} ✕</span>
                        : c?.rahmenvertrag
                          ? <span style={{fontSize:bookFont,color:"#5b8fc9",cursor:"pointer",textDecoration:"underline"}}
                                  title="Vertrag öffnen"
                                  onClick={e=>{e.stopPropagation();if(c)setVertragKunde(c);}}>📋 Vertrag ({c.rahmenvertragDatum?new Date(c.rahmenvertragDatum).toLocaleDateString("de-DE"):"-"})</span>
                          : <span style={{fontSize:bookFont,color:T.warning}}>⏳ Ausstehend</span>
                    }
                  </td>
                  <td style={{textAlign:"center",padding:"12px 16px",borderBottom:`1px solid ${T.border}22`}}>
                    <div style={{display:"flex",gap:4,justifyContent:"flex-end"}}>
                      {!b.signed&&!b.vertragVorhanden&&!c?.rahmenvertrag&&<button style={btn(T,"ghost",true)} title="Vertrag liegt vor markieren" onClick={()=>setBookings(p=>p.map(x=>x.id===b.id?{...x,vertragVorhanden:true,vertragDatum:new Date().toISOString(),status:(x.status==="anfrage"||!x.status)?"gebucht":x.status}:x))}>📋</button>}
                      <button style={btn(T,"ghost",true)} onClick={()=>setEmailFor({booking:b,type:"buchung"})}>📧</button>
                      {b.galerie&&<a href={b.galerie} target="_blank" rel="noreferrer" style={btn(T,"ghost",true)}>🖼️</a>}
                      <button style={btn(T,"danger",true)} onClick={()=>del(b.id)}>✕</button>
                    </div>
                  </td>
                </tr>
                {offeneTiere.has(b.id)&&weitTiere.map((t,ti)=>(
                  <tr key={b.id+"-tier-"+ti} style={{background:T.bg+"88"}}>
                    <td colSpan={8} style={{padding:"4px 10px",borderBottom:`1px solid ${T.border}22`}}/>
                    <td style={{textAlign:"center",padding:"4px 10px",fontSize:bookFont,color:T.muted,borderBottom:`1px solid ${T.border}22`}}>{t.name||"—"}</td>
                    <td style={{textAlign:"center",padding:"4px 10px",fontSize:bookFont,color:T.muted,borderBottom:`1px solid ${T.border}22`}}>{t.rasse||"—"}</td>
                    <td style={{textAlign:"center",padding:"4px 10px",fontSize:bookFont,color:T.muted,borderBottom:`1px solid ${T.border}22`}}>{t.alter?(t.alter+" J"):(t.alterMonate?(t.alterMonate+" Mon."):"—")}</td>
                    <td style={{textAlign:"center",padding:"4px 10px",fontSize:bookFont,color:T.muted,borderBottom:`1px solid ${T.border}22`}}>{t.geschlecht||"—"}</td>
                    <td colSpan={6} style={{padding:"4px 10px",borderBottom:`1px solid ${T.border}22`}}/>
                  </tr>
                ))}
                </>);
              })}
            </tbody>
          </table>
        </div>
      </div>
      </>
      )}
      {terminWahl&&(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.78)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:100,padding:20}}>
          <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:16,padding:28,width:"100%",maxWidth:420}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:6}}>
              <div style={{fontFamily:"Georgia,serif",fontSize:20,color:T.accent}}>Was möchtest du anlegen?</div>
              <button style={btn(T,"ghost",true)} onClick={()=>setTerminWahl(false)}>✕</button>
            </div>
            <p style={{fontSize:13,color:T.muted,marginBottom:20}}>Einzeltermin mit einem Kunden oder eine Veranstaltung mit mehreren Teilnehmern.</p>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
              <div onClick={()=>{setTerminWahl(false);setModal("new");}}
                style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:12,padding:20,cursor:"pointer",textAlign:"center",transition:"all 0.15s"}}
                onMouseEnter={e=>e.currentTarget.style.borderColor=T.accent}
                onMouseLeave={e=>e.currentTarget.style.borderColor=T.border}>
                <div style={{display:"flex",justifyContent:"center",marginBottom:10,color:T.accent}}><Ic n="calendar" s={26}/></div>
                <div style={{fontSize:14,fontWeight:700,color:T.text,marginBottom:4}}>Einzeltermin</div>
                <div style={{fontSize:11,color:T.muted,lineHeight:1.5}}>Shooting mit einem Kunden</div>
              </div>
              <div onClick={()=>{setTerminWahl(false);setEventModal(true);}}
                style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:12,padding:20,cursor:"pointer",textAlign:"center",transition:"all 0.15s"}}
                onMouseEnter={e=>e.currentTarget.style.borderColor=T.accent}
                onMouseLeave={e=>e.currentTarget.style.borderColor=T.border}>
                <div style={{display:"flex",justifyContent:"center",marginBottom:10,color:T.accent}}><Ic n="invoice" s={26}/></div>
                <div style={{fontSize:14,fontWeight:700,color:T.text,marginBottom:4}}>Veranstaltung</div>
                <div style={{fontSize:11,color:T.muted,lineHeight:1.5}}>Event mit mehreren Teilnehmern</div>
              </div>
            </div>
          </div>
        </div>
      )}
      {eventModal&&<EventModal event={null} onSave={saveNewEvent} onClose={()=>setEventModal(false)} T={T} initialDate={sel?(()=>{const d=sel;return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}-${String(d.getDate()).padStart(2,"0")}`;})():""}/>}
      {bpInteresseModal&&<EventModal event={null} onSave={saveNewEvent} onClose={()=>setBpInteresseModal(false)} T={T} datumOptional={true}/>}
      {workflow&&(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.78)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:100,padding:20}}>
          <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:16,padding:28,width:"100%",maxWidth:440}}>
            <div style={{textAlign:"center",marginBottom:6}}>
              <div style={{display:"flex",justifyContent:"center",marginBottom:10,color:T.success}}>
                <svg width="32" height="32" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"><circle cx="8" cy="8" r="6.5"/><polyline points="5,8 7,10 11,6"/></svg>
              </div>
              <div style={{fontFamily:"Georgia,serif",fontSize:18,color:T.accent}}>Veranstaltung angelegt</div>
            </div>
            <p style={{fontSize:13,color:T.muted,marginBottom:6,textAlign:"center"}}><strong style={{color:T.text}}>{workflow.name}</strong></p>
            <div style={{background:T.bg,borderRadius:8,padding:"10px 14px",fontSize:12,color:T.muted,marginBottom:20,textAlign:"center"}}>
              {fmtDate(workflow.date)} · {workflow.fotoart}{workflow.location?` · ${workflow.location}`:""}
            </div>
            <div style={{fontSize:12,color:T.muted,marginBottom:12,textAlign:"center"}}>Abrechnung wurde automatisch angelegt. Nächste Schritte:</div>
            <div style={{display:"flex",flexDirection:"column",gap:8}}>
              <button style={{...btn(T,"ghost"),justifyContent:"flex-start",padding:"12px 16px"}} onClick={()=>{
                onOpenBuchung&&onOpenBuchung(workflow);
                setWorkflow(null);
              }}>
                <span style={{color:T.accent,display:"flex"}}><Ic n="globe" s={15}/></span>
                <span style={{flex:1,textAlign:"left",marginLeft:8}}>1. Buchungsplan öffnen</span>
                <span style={{color:T.muted}}>→</span>
              </button>
              <button style={{...btn(T,"ghost"),justifyContent:"flex-start",padding:"12px 16px"}} onClick={()=>{
                onOpenShootingplan&&onOpenShootingplan({eventId:workflow.id,event_name:workflow.name,event_type:workflow.fotoart,event_date:workflow.date,event_start:workflow.date,event_end:workflow.date,rows:[]});
                setWorkflow(null);
              }}>
                <span style={{color:T.accent,display:"flex"}}><Ic n="renum" s={15}/></span>
                <span style={{flex:1,textAlign:"left",marginLeft:8}}>2. Veranstaltungsplan öffnen</span>
                <span style={{color:T.muted}}>→</span>
              </button>
              <button style={{...btn(T,"ghost"),justifyContent:"flex-start",padding:"12px 16px"}} onClick={()=>{
                onOpenEvent&&onOpenEvent(workflow.id);
                setWorkflow(null);
              }}>
                <span style={{color:T.accent,display:"flex"}}><Ic n="invoice" s={15}/></span>
                <span style={{flex:1,textAlign:"left",marginLeft:8}}>3. Abrechnung öffnen</span>
                <span style={{color:T.muted}}>→</span>
              </button>
            </div>
            <button style={{...btn(T,"ghost"),width:"100%",justifyContent:"center",marginTop:14,fontSize:11}} onClick={()=>setWorkflow(null)}>Später</button>
          </div>
        </div>
      )}
      {modal&&<BookingModal booking={modal==="new"?null:modal} customers={customers} setCustomers={setCustomers} onSave={save} onClose={()=>setModal(null)} T={T}/>
      }
      {kundeModal&&<CustomerModal customer={kundeModal} onSave={c=>{setKundeModal(null);}} onClose={()=>setKundeModal(null)} T={T}/>}
      {vertragKunde&&<VertragModal kunde={vertragKunde} onClose={()=>setVertragKunde(null)} T={T}/>}
      {agFor&&<AgreementModal booking={agFor} customer={customers.find(c=>c.id===agFor.customerId)||{}} onSign={(d)=>sign(agFor.id,d)} onClose={()=>setAgFor(null)} T={T}/>}
      {emailFor&&<BuchungsMailModal booking={emailFor.booking} customer={customers.find(c=>c.id===emailFor.booking.customerId)||{}} onClose={()=>{setEmailFor(null);try{setBookings(JSON.parse(localStorage.getItem("sd_bookings")||"[]"));}catch{}}} T={T}/>}
    </div>
  );
}




// ── BildnummernPage ─────────────────────────────────────────────────────────────────────
function BildnummernPage({T}){
  const MONATE=["Januar","Februar","März","April","Mai","Juni","Juli","August","September","Oktober","November","Dezember"];
  const heute=new Date();
  const [jahr,setJahr]=useState(heute.getFullYear());
  const [eintraege,setEintraege]=useState(()=>{try{return JSON.parse(localStorage.getItem("sd_bildnummern")||"[]");}catch{return [];}});
  const [editId,setEditId]=useState(null);
  const alleKundenBN=(()=>{try{return JSON.parse(localStorage.getItem("sd_customers")||"[]");}catch{return [];}})();
  const alleEventsBN=(()=>{try{return JSON.parse(localStorage.getItem("sd_events")||"[]");}catch{return [];}})();
  const [kundeDropdown,setKundeDropdown]=useState(false);
  const [veranstDropdown,setVeranstDropdown]=useState(false);
  const [tblSettings,setTblSettings]=useState(()=>{try{return JSON.parse(localStorage.getItem("sd_bn_tbl")||"{}");  }catch{return {};}});
  const saveTblSettings=(neu)=>{setTblSettings(neu);localStorage.setItem("sd_bn_tbl",JSON.stringify(neu));};
  const zeilenH=tblSettings.zeilenH||11;
  const schriftG=tblSettings.schriftG||13;
  const tabelleB=tblSettings.tabelleB||600;

  // Formular-State
  const vonFuerDatum=(datumStr,curId)=>{
    if(!datumStr) return "0001";
    const d=new Date(datumStr);
    const imMonat=eintraege.filter(e=>{
      if(curId&&e.id===curId) return false;
      const ed=new Date(e.datum||"");
      return ed.getMonth()===d.getMonth()&&ed.getFullYear()===d.getFullYear();
    }).sort((a,b)=>new Date(a.datum)-new Date(b.datum));
    if(imMonat.length===0) return "0001";
    return String((parseInt(imMonat[imMonat.length-1].bis)||0)+1).padStart(4,"0");
  };
  const leerForm=()=>{
    const datumStr=heute.toISOString().slice(0,10);
    const vonNr=vonFuerDatum(datumStr,null);
    return{datum:datumStr,kunde:"",veranstaltung:"",rasse:"",von:vonNr,bis:vonNr};
  };
  const [form,setForm]=useState(leerForm);
  const [monatFilter,setMonatFilter]=useState(-1);

  const save=(neu)=>{setEintraege(neu);localStorage.setItem("sd_bildnummern",JSON.stringify(neu));};
  const fmt4=(n)=>{const v=parseInt(n)||0;return String(v).padStart(4,"0");};
  const fv=(k,v)=>{
    if(k==="datum"){
      const vonNr=vonFuerDatum(v,editId);
      setForm(f=>({...f,datum:v,von:vonNr,bis:vonNr}));
    } else {
      setForm(f=>({...f,[k]:v}));
    }
  };

  const addOrUpdate=()=>{
    const _d=new Date(form.datum||"");
    const entry={
      id:editId||uid(),
      monat:MONATE[_d.getMonth()]||"",
      datum:form.datum,
      kunde:form.kunde,
      veranstaltung:form.veranstaltung,
      rasse:form.rasse,
      von:fmt4(form.von),
      bis:fmt4(form.bis),
    };
    if(editId){
      save(eintraege.map(e=>e.id===editId?entry:e));
      setEditId(null);
    } else {
      save([...eintraege,entry]);
    }
    // Von-Wert für nächsten Eintrag auto-weitersetzen
    const naechste=String((parseInt(form.bis)||0)+1).padStart(4,"0");setForm(f=>({...f,kunde:"",veranstaltung:"",rasse:"",von:naechste,bis:naechste}));setKundeDropdown(false);setVeranstDropdown(false);
  };

  const startEdit=(e)=>{
    setEditId(e.id);
    setForm({datum:e.datum,kunde:e.kunde,veranstaltung:e.veranstaltung||"",rasse:e.rasse||"",von:e.von,bis:e.bis});
  };

  const cancelEdit=()=>{setEditId(null);setForm(leerForm());};

  const del=(id)=>{if(confirm("Eintrag löschen?"))save(eintraege.filter(e=>e.id!==id));if(editId===id)cancelEdit();};

  const doPrint=()=>{
    const w=window.open("","_blank");
    const rows=gefiltert.map((e,i)=>`<tr><td>${i+1}</td><td>${e.monat}</td><td>${e.datum?new Date(e.datum).toLocaleDateString("de-DE"):""}</td><td>${e.kunde}</td><td style="text-align:center">${e.von}</td><td style="font-weight:700;text-align:center">${e.bis}</td></tr>`).join("");
    w.document.write(`<!DOCTYPE html><html><head><meta charset="UTF-8"><style>body{font-family:Helvetica,Arial,sans-serif;font-size:12px}table{border-collapse:collapse;width:100%}th,td{border:1px solid #ccc;padding:6px 10px}th{background:#f5f3ef;font-weight:600}h2{color:#b8952a}</style></head><body><h2>Bildnummern ${jahr}</h2><table><thead><tr><th>#</th><th>Monat</th><th>Datum</th><th>Kunde / Veranstaltung</th><th>Bild von</th><th>Bild bis</th></tr></thead><tbody>${rows}</tbody></table></body></html>`);
    w.document.close();
    setTimeout(()=>{w.focus();w.print();setTimeout(()=>w.close(),500);},400);
  };

  const gefiltert=[...eintraege].sort((a,b)=>new Date(a.datum||"")-new Date(b.datum||"")).filter(e=>{
    const d=new Date(e.datum||"");
    return d.getFullYear()===jahr&&(monatFilter===-1||d.getMonth()===monatFilter);
  });

  const [bnColW,startBnResize]=useColW("sd_cols_bildnummern",{nr:30,datum:70,kunde:100,veranstaltung:100,rasse:90,von:58,bis:58,del:30});
  const IS={padding:"8px 10px",border:`1px solid ${T.border}`,borderRadius:7,fontSize:14,background:T.bg,color:T.text,fontFamily:"inherit",width:"100%",boxSizing:"border-box"};
  const LBL={fontSize:11,fontWeight:700,color:T.muted,textTransform:"uppercase",letterSpacing:".06em",marginBottom:5,display:"block"};

  return(
    <div style={{padding:32}}>
      {/* Header */}
      <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:28,flexWrap:"wrap"}}>
        <div style={{fontFamily:"Georgia,serif",fontSize:22,fontWeight:700,color:T.accent}}>Bildnummern</div>
        <select value={jahr} onChange={e=>setJahr(Number(e.target.value))} style={{...IS,width:"auto",padding:"6px 10px"}}>
          {[2024,2025,2026,2027,2028].map(y=><option key={y}>{y}</option>)}
        </select>
        <select value={monatFilter} onChange={e=>setMonatFilter(Number(e.target.value))} style={{...IS,width:"auto",padding:"6px 10px"}}>
          <option value={-1}>Alle Monate</option>
          {MONATE.map((m,i)=><option key={i} value={i}>{m}</option>)}
        </select>

        <div style={{flex:1}}/>
        <button onClick={doPrint} style={{background:"none",border:`1px solid ${T.border}`,borderRadius:8,padding:"8px 16px",fontSize:13,cursor:"pointer",color:T.text}}>Drucken</button>
      </div>

      {/* 2-Spalten-Layout */}
      <div style={{display:"grid",gridTemplateColumns:`360px ${tabelleB}px`,gap:24,alignItems:"start"}}>

        {/* LINKS: Eingabeformular */}
        <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:12,padding:24}}>
          <div style={{fontFamily:"Georgia,serif",fontSize:15,fontWeight:700,color:T.accent,marginBottom:20}}>
            {editId ? "Eintrag bearbeiten" : "Neuer Eintrag"}
          </div>

          <div style={{display:"flex",flexDirection:"column",gap:16}}>
            <div>
              <span style={LBL}>Datum</span>
              <input type="date" value={form.datum} onChange={e=>fv("datum",e.target.value)} style={IS}/>
            </div>
            <div style={{position:"relative"}}>
              <span style={LBL}>Kunde</span>
              <input value={form.kunde}
                onChange={e=>{fv("kunde",e.target.value);setKundeDropdown(true);}}
                onFocus={()=>setKundeDropdown(true)}
                onBlur={()=>setTimeout(()=>setKundeDropdown(false),150)}
                placeholder="z.B. Muster, Maria"
                disabled={!!form.veranstaltung}
                style={{...IS,opacity:form.veranstaltung?0.4:1,cursor:form.veranstaltung?"not-allowed":"text"}}/>
              {kundeDropdown&&!form.veranstaltung&&(()=>{
                const hits=alleKundenBN.filter(k=>(k.name||"").toLowerCase().includes((form.kunde||"").toLowerCase())).slice(0,8);
                return hits.length>0&&<div style={{position:"absolute",top:"100%",left:0,right:0,background:T.surface,border:`1px solid ${T.border}`,borderRadius:8,zIndex:99,boxShadow:"0 4px 12px #0002",marginTop:2}}>
                  {hits.map(k=><div key={k.id} onMouseDown={()=>{fv("kunde",k.name);setKundeDropdown(false);}} style={{padding:"8px 12px",fontSize:13,cursor:"pointer",color:T.text,borderBottom:`1px solid ${T.border}22`}}
                    onMouseEnter={el=>el.currentTarget.style.background=T.tileHover}
                    onMouseLeave={el=>el.currentTarget.style.background="transparent"}>{k.name}</div>)}
                </div>;
              })()}
            </div>
            <div style={{position:"relative"}}>
              <span style={LBL}>Veranstaltung</span>
              <input value={form.veranstaltung}
                onChange={e=>{fv("veranstaltung",e.target.value);setVeranstDropdown(true);}}
                onFocus={()=>setVeranstDropdown(true)}
                onBlur={()=>setTimeout(()=>setVeranstDropdown(false),150)}
                placeholder="z.B. Dogworld 2026"
                disabled={!!form.kunde}
                style={{...IS,opacity:form.kunde?0.4:1,cursor:form.kunde?"not-allowed":"text"}}/>
              {veranstDropdown&&!form.kunde&&(()=>{
                const hits=alleEventsBN.filter(ev=>(ev.name||"").toLowerCase().includes((form.veranstaltung||"").toLowerCase())).slice(0,8);
                return hits.length>0&&<div style={{position:"absolute",top:"100%",left:0,right:0,background:T.surface,border:`1px solid ${T.border}`,borderRadius:8,zIndex:99,boxShadow:"0 4px 12px #0002",marginTop:2}}>
                  {hits.map(ev=><div key={ev.id} onMouseDown={()=>{fv("veranstaltung",ev.name);setVeranstDropdown(false);}} style={{padding:"8px 12px",fontSize:13,cursor:"pointer",color:T.text,borderBottom:`1px solid ${T.border}22`}}
                    onMouseEnter={el=>el.currentTarget.style.background=T.tileHover}
                    onMouseLeave={el=>el.currentTarget.style.background="transparent"}>{ev.name}</div>)}
                </div>;
              })()}
            </div>
            <div>
              <span style={LBL}>Rasse</span>
              <RasseInput T={T} value={form.rasse} onChange={v=>fv("rasse",v)} style={IS}/>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
              <div>
                <span style={LBL}>Bild von</span>
                <div style={{...IS,fontFamily:"monospace",fontWeight:700,textAlign:"center",
                  background:"#fdeceb",color:"#a83228",border:"1px solid #e8b4ae",
                  height:38,lineHeight:"20px",display:"flex",alignItems:"center",justifyContent:"center"}}>
                  {form.von}
                </div>
              </div>
              <div>
                <span style={LBL}>Bild bis</span>
                <style>{`.bn-bis::placeholder{color:#1e7a4577;opacity:1}`}</style>
                <input
                  className="bn-bis"
                  type="text"
                  inputMode="numeric"
                  value={form.bis===form.von?"":form.bis}
                  placeholder={form.von}
                  onChange={e=>{const v=e.target.value.replace(/[^0-9]/g,"");fv("bis",v||form.von);}}
                  onBlur={e=>{const v=e.target.value.replace(/[^0-9]/g,"")||form.von;fv("bis",v.padStart(4,"0"));}}
                  style={{...IS,fontFamily:"monospace",fontWeight:700,textAlign:"center",
                    background:"#eaf7ef",color:"#1e7a45",border:"1px solid #a9dcbf",height:38,lineHeight:"20px"}}
                  maxLength={4}
                />
              </div>
            </div>
            {/* Anzahl Bilder Anzeige */}
            {(parseInt(form.bis)||0)>=(parseInt(form.von)||0)&&(parseInt(form.von)||0)>0&&(
              <div style={{fontSize:12,color:T.muted,textAlign:"right",marginTop:-8}}>
                {(parseInt(form.bis)-parseInt(form.von)+1)} Bilder
              </div>
            )}
            <div style={{display:"flex",gap:8,marginTop:4}}>
              <button onClick={addOrUpdate} style={{flex:1,background:T.accent,color:"#fff",border:"none",borderRadius:8,padding:"10px 0",fontSize:14,fontWeight:600,cursor:"pointer"}}>
                {editId ? "Speichern" : "+ Hinzufügen"}
              </button>
              {editId&&<button onClick={cancelEdit} style={{background:"none",border:`1px solid ${T.border}`,borderRadius:8,padding:"10px 14px",fontSize:14,cursor:"pointer",color:T.text}}>Abbrechen</button>}
            </div>
          </div>
        </div>

        {/* RECHTS: Listenvorschau */}
        <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:12,overflow:"hidden",overflowX:"auto"}}>
          <div style={{borderBottom:`1px solid ${T.border}`}}>
            <div style={{width:tabelleB,padding:"12px 16px",textAlign:"center",boxSizing:"border-box"}}>
              <div style={{fontFamily:"Georgia,serif",fontSize:15,fontWeight:700,color:T.accent}}>
                {gefiltert.length} {gefiltert.length===1?"Eintrag":"Einträge"}
              </div>
              {gefiltert.length>0&&(
                <div style={{fontSize:12,color:T.muted,marginTop:2}}>
                  Nummern: {gefiltert[0]?.von} – {gefiltert[gefiltert.length-1]?.bis}
                </div>
              )}
            </div>
            <div style={{padding:"8px 16px",borderTop:`1px solid ${T.border}22`,background:T.bg,display:"flex",alignItems:"center",gap:16,flexWrap:"wrap"}}>
              <span style={{fontSize:11,color:T.muted,fontWeight:700,textTransform:"uppercase",letterSpacing:".06em"}}>Ansicht</span>
              <label style={{fontSize:12,color:T.muted,display:"flex",alignItems:"center",gap:6}}>
                Zeilenhöhe
                <input type="range" min={6} max={40} value={zeilenH}
                  onChange={e=>saveTblSettings({...tblSettings,zeilenH:Number(e.target.value)})}
                  style={{width:80,accentColor:T.accent}}/>
                <span style={{fontSize:11,width:20}}>{zeilenH}</span>
              </label>
              <label style={{fontSize:12,color:T.muted,display:"flex",alignItems:"center",gap:6}}>
                Schrift
                <input type="range" min={10} max={32} value={schriftG}
                  onChange={e=>saveTblSettings({...tblSettings,schriftG:Number(e.target.value)})}
                  style={{width:60,accentColor:T.accent}}/>
                <span style={{fontSize:11,width:20}}>{schriftG}</span>
              </label>
              <label style={{fontSize:12,color:T.muted,display:"flex",alignItems:"center",gap:6}}>
                Breite
                <input type="range" min={300} max={2800} step={10} value={tabelleB}
                  onChange={e=>saveTblSettings({...tblSettings,tabelleB:Number(e.target.value)})}
                  style={{width:100,accentColor:T.accent}}/>
                <span style={{fontSize:11,width:36}}>{tabelleB}px</span>
              </label>
            </div>
          </div>
          <table style={{tableLayout:"fixed",borderCollapse:"collapse",width:"100%"}}>
            <colgroup>
              <col style={{width:bnColW.nr}}/><col style={{width:bnColW.datum}}/><col style={{width:bnColW.kunde}}/><col style={{width:bnColW.veranstaltung}}/><col style={{width:bnColW.rasse}}/><col style={{width:bnColW.von}}/><col style={{width:bnColW.bis}}/><col style={{width:bnColW.del}}/>
            </colgroup>
            <thead>
              <tr style={{background:T.bg}}>
                {[["nr","#"],["datum","Datum"],["kunde","Kunde"],["veranstaltung","Veranstaltung"],["rasse","Rasse"],["von","Von"],["bis","Bis"],["del",""]].map(([k,h])=>{
                  const centered=["nr","von","bis","del"].includes(k);
                  return <th key={k} style={{padding:"9px 12px",textAlign:centered?"center":"left",fontSize:11,fontWeight:700,color:T.muted,textTransform:"uppercase",letterSpacing:".06em",borderBottom:`1px solid ${T.border}`,position:"relative",userSelect:"none",overflow:"hidden",whiteSpace:"nowrap"}}>
                    {h}{k!=="del"&&<ResizeHandle T={T} onMouseDown={e=>startBnResize(e,k)}/>}
                  </th>;
                })}
              </tr>
            </thead>
            <tbody>
              {gefiltert.length===0&&(
                <tr><td colSpan={8} style={{padding:40,textAlign:"center",color:T.muted,fontSize:13}}>Noch keine Einträge.</td></tr>
              )}
              {gefiltert.map((e,i)=>{
                const monatNr=new Date(e.datum||"").getMonth();
                const zeileBg=editId===e.id?T.accent+"18":monatNr%2===0?"#f0eeeb":"transparent";
                return <tr key={e.id}
                  style={{borderBottom:`1px solid ${T.border}22`,background:zeileBg}}
                  onMouseEnter={el=>{if(editId!==e.id)el.currentTarget.style.background=T.tileHover;}}
                  onMouseLeave={el=>{el.currentTarget.style.background=editId===e.id?T.accent+"18":zeileBg;}}>
                  <td style={{padding:`${zeilenH}px 8px`,fontSize:schriftG-1,color:T.muted,overflow:"hidden"}}>{i+1}</td>
                  <td style={{padding:`${zeilenH}px 8px`,fontSize:schriftG,color:T.text,overflow:"hidden",whiteSpace:"nowrap"}}>
                    {e.datum?new Date(e.datum).toLocaleDateString("de-DE",{day:"2-digit",month:"2-digit"}):e.monat}
                  </td>
                  <td style={{padding:`${zeilenH}px 8px`,fontSize:schriftG,color:T.text,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{e.kunde||<span style={{color:T.muted}}>–</span>}</td>
                  <td style={{padding:`${zeilenH}px 8px`,fontSize:schriftG,color:T.text,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{e.veranstaltung||<span style={{color:T.muted}}>–</span>}</td>
                  <td style={{padding:`${zeilenH}px 8px`,fontSize:schriftG,color:T.text,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{e.rasse||"–"}</td>
                  <td style={{padding:`${zeilenH}px 8px`,fontSize:schriftG,color:T.text,fontFamily:"monospace",textAlign:"center",overflow:"hidden"}}>{e.von}</td>
                  <td style={{padding:`${zeilenH}px 8px`,fontSize:schriftG,color:T.text,fontFamily:"monospace",textAlign:"center",overflow:"hidden"}}>{e.bis}</td>
                  <td style={{padding:`${zeilenH}px 4px`,textAlign:"center",whiteSpace:"nowrap"}}>
                    <button onClick={()=>startEdit(e)} title="Bearbeiten" style={{background:"none",border:"none",color:editId===e.id?T.accent:T.muted,cursor:"pointer",fontSize:15,padding:"0 3px",lineHeight:1}}
                      onMouseEnter={el=>el.currentTarget.style.color=T.accent}
                      onMouseLeave={el=>el.currentTarget.style.color=editId===e.id?T.accent:T.muted}>✎</button>
                    <button onClick={ev=>{ev.stopPropagation();del(e.id);}} title="Löschen" style={{background:"none",border:"none",color:T.muted,cursor:"pointer",fontSize:15,padding:"0 3px",lineHeight:1}}
                      onMouseEnter={el=>el.currentTarget.style.color="#e53"}
                      onMouseLeave={el=>el.currentTarget.style.color=T.muted}>✕</button>
                  </td>
                </tr>
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

// ── GutscheinePage ─────────────────────────────────────────────────────────────────────
function GutscheinePage({T}){
  const norm=g=>({
    id:g.id||uid(),
    nr:g.nr??g.code??"",
    kunde:g.kunde??g.kaeufer??"",
    strasse:g.strasse??g.adresse??"",
    plz:g.plz??"",
    ort:g.ort??"",
    handy:g.handy??g.phone??"",
    email:g.email??"",
    gekauft:g.gekauft??g.erstellt??"",
    infos:g.infos??[g.anlass,g.wert?fmtEuro(g.wert):"",g.empfaenger?("Für "+g.empfaenger):""].filter(Boolean).join(" · "),
    eingeloest:!!g.eingeloest,
  });
  const [gutscheine,setGutscheine]=useState(()=>{
    try{const raw=JSON.parse(localStorage.getItem("sd_gutscheine")||"[]");return Array.isArray(raw)?raw.map(norm):[];}catch{return [];}
  });
  useEffect(()=>{localStorage.setItem("sd_gutscheine",JSON.stringify(gutscheine));},[gutscheine]);
  const [q,setQ]=useState("");
  const [showKundePicker,setShowKundePicker]=useState(false);
  const [kq,setKq]=useState("");
  const [infoFor,setInfoFor]=useState(null);
  const [showNeuerModal,setShowNeuerModal]=useState(false);
  const [neuerForm,setNeuerForm]=useState({kunde:"",strasse:"",plz:"",ort:"",handy:"",email:"",infos:""});
  const [showVorlageModal,setShowVorlageModal]=useState(false);
  const [vorlageForm,setVorlageForm]=useState({nr:"",fuer:"",von:"",betrag:""});
  const [alleKunden]=useState(()=>{try{return JSON.parse(localStorage.getItem("sd_customers")||"[]");}catch{return [];}});
  function addFromKunde(c,extraInfos=""){
    setGutscheine(p=>{
      const nr=nextNr(p);
      const heute=new Date().toLocaleDateString("de-DE",{day:"2-digit",month:"2-digit",year:"numeric"});
      return [...p,{id:uid(),nr,kunde:c.name||"",strasse:c.strasse||"",plz:c.plz||"",ort:c.ort||"",handy:c.phone||c.telefon||"",email:c.email||"",gekauft:heute,infos:extraInfos||"",eingeloest:false}];
    });
    setShowKundePicker(false);setKq("");
  }

  const COLS=[
    {key:"nr",label:"Gutschein-Nr",w:120},
    {key:"kunde",label:"Kunde",w:170},
    {key:"strasse",label:"Straße",w:160,center:true},
    {key:"plz",label:"PLZ",w:80,center:true},
    {key:"ort",label:"Ort",w:130,center:true},
    {key:"handy",label:"Handy",w:140,type:"tel",center:true},
    {key:"email",label:"E-Mail",w:200,type:"email",center:true},
    {key:"gekauft",label:"Gekauft am",w:130,ph:"TT.MM.JJJJ",center:true},
    {key:"infos",label:"Infos",w:90,center:true,info:true},
  ];
  const colDefaults={eingeloest:96};COLS.forEach(c=>colDefaults[c.key]=c.w);
  const [colW,startResize]=useColW("sd_gutscheine_colw2",colDefaults);
  function nextNr(liste){
    const jahr=new Date().getFullYear().toString().slice(-2);
    const jahrNrs=liste.filter(g=>(g.nr||"").endsWith("/"+jahr)).map(g=>parseInt((g.nr||"").split("/")[0])||0);
    const next=(jahrNrs.length>0?Math.max(...jahrNrs):0)+1;
    return String(next).padStart(2,"0")+"/"+jahr;
  }
  function addRow(data={}){
    setGutscheine(p=>{
      const nr=data.nr||nextNr(p);
      const heute=new Date().toLocaleDateString("de-DE",{day:"2-digit",month:"2-digit",year:"numeric"});
      return [...p,{id:uid(),nr,kunde:data.kunde||"",strasse:data.strasse||"",plz:data.plz||"",ort:data.ort||"",handy:data.handy||"",email:data.email||"",gekauft:heute,infos:data.infos||"",eingeloest:false}];
    });
  }
  function upd(id,key,val){setGutscheine(p=>p.map(g=>g.id===id?{...g,[key]:val}:g));}
  function del(id){if(confirm("Diesen Gutschein wirklich löschen?"))setGutscheine(p=>p.filter(g=>g.id!==id));}

  const ql=q.trim().toLowerCase();
  const rows=ql?gutscheine.filter(g=>[g.nr,g.kunde,g.strasse,g.plz,g.ort,g.handy,g.email,g.infos].join(" ").toLowerCase().includes(ql)):gutscheine;
  const ACT_W=70;
  const totalW=COLS.reduce((s,c)=>s+(colW[c.key]||c.w),0)+(colW.eingeloest||96)+ACT_W;
  const cellInp={background:"transparent",border:"none",color:T.text,fontSize:13,fontFamily:"inherit",outline:"none",boxSizing:"border-box",width:"100%",padding:0};
  const thStyle={padding:"12px 16px",fontSize:12.5,fontWeight:700,color:T.text,textTransform:"uppercase",letterSpacing:"0.07em",borderBottom:`2px solid ${T.border}`,background:T.bg};
  const infoG=infoFor?gutscheine.find(x=>x.id===infoFor):null;

  return(
    <div>
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:24,gap:12,flexWrap:"wrap"}}>
        <div>
          <div style={{fontFamily:"Georgia,serif",fontSize:26,fontWeight:700,color:T.text}}>Gutscheine</div>
          <div style={{fontSize:13,color:T.muted,marginTop:2}}>{gutscheine.length} {gutscheine.length===1?"Eintrag":"Einträge"} · {gutscheine.filter(g=>g.eingeloest).length} eingelöst</div>
        </div>
        <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
          <button style={btn(T,"ghost")} onClick={()=>{setVorlageForm({nr:nextNr(gutscheine),fuer:"",von:"",betrag:""});setShowVorlageModal(true);}}>📄 Vorlage Gutschein</button>
          <button style={btn(T,"ghost")} onClick={()=>setShowKundePicker(v=>!v)}>+ Aus Kunde</button>
          <button style={btn(T,"primary")} onClick={()=>{setGutscheine(p=>{const nr=nextNr(p);setNeuerForm({kunde:"",strasse:"",plz:"",ort:"",handy:"",email:"",infos:"",nr});return p;});setShowNeuerModal(true);}}>+ Neuer Gutschein</button>
        </div>
      </div>

      {showNeuerModal&&(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.55)",zIndex:9999,display:"flex",alignItems:"center",justifyContent:"center",padding:16}} onClick={()=>setShowNeuerModal(false)}>
          <div style={{background:T.surface,borderRadius:14,padding:24,maxWidth:520,width:"100%",maxHeight:"92vh",overflowY:"auto",boxShadow:"0 8px 40px rgba(0,0,0,0.3)"}} onClick={e=>e.stopPropagation()}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:18}}>
              <div style={{fontFamily:"Georgia,serif",fontSize:16,color:T.accent}}>+ Neuer Gutschein</div>
              <button onClick={()=>setShowNeuerModal(false)} style={{background:"none",border:"none",fontSize:18,cursor:"pointer",color:T.muted}}>✕</button>
            </div>
            {/* Nr */}
            <div style={{marginBottom:12}}>
              <label style={{fontSize:12,color:T.muted,fontWeight:600,display:"block",marginBottom:4}}>Gutschein-Nr</label>
              <input value={neuerForm.nr||""} onChange={e=>setNeuerForm(p=>({...p,nr:e.target.value}))} style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:"8px 12px",color:T.text,fontSize:13,fontFamily:"inherit",outline:"none",width:"100%",boxSizing:"border-box"}}/>
            </div>
            {/* Kundensuche */}
            <div style={{marginBottom:12}}>
              <label style={{fontSize:12,color:T.muted,fontWeight:600,display:"block",marginBottom:4}}>Aus Bestandskunden wählen (optional)</label>
              <input value={kq} onChange={e=>setKq(e.target.value)} placeholder="Kunde suchen..." style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:"8px 12px",color:T.text,fontSize:13,fontFamily:"inherit",outline:"none",width:"100%",boxSizing:"border-box",marginBottom:6}}/>
              {kq.trim()&&<div style={{maxHeight:160,overflowY:"auto",display:"flex",flexDirection:"column",gap:4,marginBottom:8}}>
                {alleKunden.filter(c=>[c.name,c.email,c.ort].join(" ").toLowerCase().includes(kq.toLowerCase())).slice(0,20).map(c=>(
                  <button key={c.id} onClick={()=>{setNeuerForm(p=>({...p,kunde:c.name||"",strasse:c.strasse||"",plz:c.plz||"",ort:c.ort||"",handy:c.phone||c.telefon||"",email:c.email||""}));setKq("");}}
                    style={{display:"flex",justifyContent:"space-between",padding:"7px 10px",background:T.bg,border:`1px solid ${T.accent}`,borderRadius:7,cursor:"pointer",fontFamily:"inherit",textAlign:"left",color:T.text}}>
                    <span style={{fontSize:13,fontWeight:600}}>{c.name}</span>
                    <span style={{fontSize:11,color:T.muted}}>{[c.ort,c.email].filter(Boolean).join(" · ")}</span>
                  </button>
                ))}
              </div>}
            </div>
            {/* Felder */}
            {[{k:"kunde",l:"Kunde *"},{k:"email",l:"E-Mail"},{k:"handy",l:"Handy"},{k:"strasse",l:"Straße"},{k:"plz",l:"PLZ"},{k:"ort",l:"Ort"}].map(({k,l})=>(
              <div key={k} style={{marginBottom:10}}>
                <label style={{fontSize:12,color:T.muted,fontWeight:600,display:"block",marginBottom:3}}>{l}</label>
                <input value={neuerForm[k]||""} onChange={e=>setNeuerForm(p=>({...p,[k]:e.target.value}))} style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:"7px 12px",color:T.text,fontSize:13,fontFamily:"inherit",outline:"none",width:"100%",boxSizing:"border-box"}}/>
              </div>
            ))}
            {/* Infos */}
            <div style={{marginBottom:16}}>
              <label style={{fontSize:12,color:T.muted,fontWeight:600,display:"block",marginBottom:3}}>Infos / Notizen</label>
              <textarea value={neuerForm.infos||""} onChange={e=>setNeuerForm(p=>({...p,infos:e.target.value}))} rows={3}
                style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:"7px 12px",color:T.text,fontSize:13,fontFamily:"inherit",outline:"none",width:"100%",boxSizing:"border-box",resize:"vertical"}}/>
            </div>
            <div style={{display:"flex",gap:8,marginTop:8}}>
              <button style={{...btn(T,"primary"),flex:1,justifyContent:"center"}} onClick={()=>{
                if(!neuerForm.kunde?.trim()){alert("Bitte Kunden eingeben.");return;}
                addRow({...neuerForm});
                setShowNeuerModal(false);
                setNeuerForm({kunde:"",strasse:"",plz:"",ort:"",handy:"",email:"",infos:""});
                setKq("");
              }}>Gutschein erstellen</button>
              <button style={{...btn(T,"ghost"),flex:1,justifyContent:"center"}} onClick={()=>{
                if(!neuerForm.kunde?.trim()){alert("Bitte Kunden eingeben.");return;}
                const nr=neuerForm.nr||nextNr(gutscheine);
                addRow({...neuerForm,nr});
                setShowNeuerModal(false);
                setNeuerForm({kunde:"",strasse:"",plz:"",ort:"",handy:"",email:"",infos:""});
                setKq("");
                setVorlageForm({nr,fuer:neuerForm.kunde||"",von:"",betrag:neuerForm.infos||""});
                setShowVorlageModal(true);
              }}>+ Vorlage drucken</button>
            </div>
          </div>
        </div>
      )}
      {showVorlageModal&&(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.55)",zIndex:9999,display:"flex",alignItems:"center",justifyContent:"center",padding:16}} onClick={()=>setShowVorlageModal(false)}>
          <div style={{background:T.surface,borderRadius:14,padding:24,maxWidth:420,width:"100%",boxShadow:"0 8px 40px rgba(0,0,0,0.3)"}} onClick={e=>e.stopPropagation()}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:18}}>
              <div style={{fontFamily:"Georgia,serif",fontSize:16,color:T.accent}}>📄 Vorlage Gutschein</div>
              <button onClick={()=>setShowVorlageModal(false)} style={{background:"none",border:"none",fontSize:18,cursor:"pointer",color:T.muted}}>✕</button>
            </div>
            <div style={{fontSize:12,color:T.muted,marginBottom:14}}>Felder optional vorausfüllen:</div>
            {[
              {k:"nr",l:"Gutschein-Nr",ph:"06/26"},
              {k:"fuer",l:"Für",ph:"Name des Beschenkten"},
              {k:"von",l:"Von",ph:"Name des Schenkers"},
              {k:"betrag",l:"Betrag/Paket",ph:"1 Termin Underglass"},
            ].map(({k,l,ph})=>(
              <div key={k} style={{marginBottom:10}}>
                <label style={{fontSize:12,color:T.muted,fontWeight:600,display:"block",marginBottom:3}}>{l}</label>
                <input value={vorlageForm[k]||""} onChange={e=>setVorlageForm(p=>({...p,[k]:e.target.value}))}
                  placeholder={ph} style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:"7px 12px",color:T.text,fontSize:13,fontFamily:"inherit",outline:"none",width:"100%",boxSizing:"border-box"}}/>
              </div>
            ))}
            <button style={{...btn(T,"primary"),width:"100%",justifyContent:"center",marginTop:8}} onClick={()=>{
              const cfg=(()=>{try{return JSON.parse(localStorage.getItem("sd_buchung_config")||"{}");}catch{return {};}})();
              const sh=(()=>{try{return JSON.parse(localStorage.getItem("sd_studio_header")||"{}");}catch{return {};}})();
              const logo=sh.logoDark||sh.logo||cfg.logo||"";
              const vf=vorlageForm;
              const html=`<!DOCTYPE html><html><head><meta charset="utf-8"><style>
                *{margin:0;padding:0;box-sizing:border-box;}
                body{background:#e8e8e8;font-family:Arial,sans-serif;display:flex;justify-content:center;align-items:flex-start;padding:30px;min-height:100vh;}
                .wrap{position:relative;display:inline-block;}
                .cut{position:absolute;background:#999;}
                .cut-tl-h{top:-12px;left:0;width:8px;height:0.5px;}.cut-tl-v{top:0;left:-12px;width:0.5px;height:8px;}
                .cut-tr-h{top:-12px;right:0;width:8px;height:0.5px;}.cut-tr-v{top:0;right:-12px;width:0.5px;height:8px;}
                .cut-bl-h{bottom:-12px;left:0;width:8px;height:0.5px;}.cut-bl-v{bottom:0;left:-12px;width:0.5px;height:8px;}
                .cut-br-h{bottom:-12px;right:0;width:8px;height:0.5px;}.cut-br-v{bottom:0;right:-12px;width:0.5px;height:8px;}
                .page{background:#fff;width:210mm;height:190mm;box-shadow:0 2px 20px rgba(0,0,0,0.3);overflow:hidden;position:relative;display:flex;flex-direction:column;}
                .outer{transform:rotate(180deg);background:#585858;height:94.85mm;display:flex;flex-direction:column;justify-content:center;padding-bottom:8mm;}
                .outer-logo{background:#585858;display:flex;justify-content:center;align-items:center;flex:1;}
                .outer-logo img{max-height:110px;max-width:280px;}
                .gold-line{height:2px;background:linear-gradient(90deg,transparent,#C9A96E,transparent);margin:0 40px;}
                .outer-title{text-align:center;padding:18px 0 20px;font-size:28px;letter-spacing:0.4em;color:#fff;font-weight:300;background:#585858;}
                .outer-top{text-align:center;padding:6px 0 6px;font-size:11px;color:#fff;letter-spacing:0.15em;background:#585858;}
                .fold{height:3px;background:linear-gradient(90deg,transparent,#C9A96E,transparent);border-top:1px dashed #aaa;}
                .inner{height:95mm;display:flex;flex-direction:column;}
                .inner-bar{display:flex;padding:18px 30px;gap:20px;background:#fff;border-bottom:2px solid #C9A96E;}
                .inner-logo{flex:0 0 200px;display:flex;align-items:center;}
                .inner-logo img{max-height:75px;max-width:180px;}
                .inner-logo-txt{font-size:16px;font-family:Georgia,serif;color:#333;}
                .inner-address{flex:1;text-align:right;font-size:10.5px;line-height:1.9;color:#333;}
                .inner-address strong{font-size:12px;}
                .fields{padding:22px 30px 28px;}
                .field-row{display:flex;align-items:baseline;padding:10px 0;border-bottom:1px solid #ddd;gap:16px;}
                .field-label{font-weight:700;font-size:12px;min-width:100px;color:#000;}
                .field-value{flex:1;font-size:13px;color:#333;min-height:18px;}
                .field-nr{display:flex;align-items:baseline;gap:8px;min-width:130px;}
                .field-nr .field-label{min-width:auto;}
                @media print{body{background:#fff;padding:0;} .page{box-shadow:none;}}
              </style></head><body>
              <div class="wrap">
                <div class="cut cut-tl-h"></div><div class="cut cut-tl-v"></div>
                <div class="cut cut-tr-h"></div><div class="cut cut-tr-v"></div>
                <div class="cut cut-bl-h"></div><div class="cut cut-bl-v"></div>
                <div class="cut cut-br-h"></div><div class="cut cut-br-v"></div>
              <div class="page">
                <div class="outer">
                  <div class="outer-logo">${logo?`<img src="${logo}" alt="Logo"/>`:`<div style="color:#fff;font-size:22px;font-family:Georgia,serif;">Markus Heber Photography</div>`}</div>
                  <div class="gold-line"></div>
                  <div class="outer-title">G U T S C H E I N</div>
                  <div class="outer-top">www.m-h-photo.de</div>
                </div>
                <div class="fold"></div>
                <div class="inner"><div class="inner-bar">
                  <div class="inner-logo">${logo?`<img src="${logo}" alt="Logo"/>`:`<div class="inner-logo-txt">Markus Heber Photography</div>`}</div>
                  <div class="inner-address"><strong>Markus Heber Photography</strong><br>Moltkestraße 22<br>90429 Nürnberg<br>info@m-h-photo.de<br>www.m-h-photo.de<br>01718199782</div>
                </div>
                <div class="fields">
                  <div class="field-row"><div class="field-label">Für:</div><div class="field-value">${vf.fuer||""}</div></div>
                  <div class="field-row"><div class="field-label">Von:</div><div class="field-value">${vf.von||""}</div></div>
                  <div class="field-row">
                    <div class="field-label">Betrag/Paket:</div>
                    <div class="field-value">${vf.betrag||""}</div>
                    <div class="field-nr"><div class="field-label">Nr.:</div><div class="field-value">${vf.nr||""}</div></div>
                  </div>
                </div></div>
              </div></div>
              <script>window.onload=()=>window.print();</script>
              </body></html>`;
              const w=window.open("","_blank");w.document.write(html);w.document.close();
              setShowVorlageModal(false);
            }}>PDF erstellen & drucken</button>
          </div>
        </div>
      )}
      {showKundePicker&&(
        <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:12,padding:16,marginBottom:16}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10}}>
            <div style={{fontSize:13,fontWeight:600,color:T.accent}}>Bestehenden Kunden übernehmen</div>
            <button style={btn(T,"ghost",true)} onClick={()=>setShowKundePicker(false)}>✕</button>
          </div>
          <input value={kq} onChange={e=>setKq(e.target.value)} placeholder="Kunde suchen..." style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:"9px 12px",color:T.text,fontSize:13,fontFamily:"inherit",outline:"none",boxSizing:"border-box",width:"100%",marginBottom:10}}/>
          <div style={{maxHeight:240,overflowY:"auto",display:"flex",flexDirection:"column",gap:4}}>
            {alleKunden.filter(c=>!kq.trim()||[c.name,c.email,c.ort].join(" ").toLowerCase().includes(kq.toLowerCase())).slice(0,80).map(c=>(
              <button key={c.id} onClick={()=>addFromKunde(c)} style={{display:"flex",justifyContent:"space-between",alignItems:"center",gap:10,padding:"9px 12px",background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,cursor:"pointer",fontFamily:"inherit",textAlign:"left",color:T.text}}>
                <span style={{fontSize:13,fontWeight:600}}>{c.name||"(ohne Name)"}</span>
                <span style={{fontSize:11,color:T.muted}}>{[c.ort,c.email].filter(Boolean).join(" · ")}</span>
              </button>
            ))}
            {alleKunden.length===0&&<div style={{fontSize:12,color:T.muted,padding:8}}>Noch keine Kunden vorhanden. Lege zuerst unter „Kunden" welche an.</div>}
          </div>
        </div>
      )}

      <div style={{display:"flex",alignItems:"center",gap:10,background:T.surface,border:`1px solid ${T.border}`,borderRadius:10,padding:"8px 14px",marginBottom:20}}>
        <span style={{color:T.muted,display:"flex"}}><Ic n="search" s={14}/></span>
        <input value={q} onChange={e=>setQ(e.target.value)} placeholder="Kunde, E-Mail oder Ort..." style={{border:"none",background:"transparent",padding:0,flex:1,fontSize:13,color:T.text,fontFamily:"inherit",outline:"none"}}/>
      </div>

      <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:12,overflow:"hidden"}}>
        <div style={{fontSize:11,color:T.muted,padding:"8px 16px",borderBottom:`1px solid ${T.border}`}}>Direkt in die Felder tippen. Spaltenbreite am rechten Rand der Überschrift ziehen. Bei Infos auf das Feld klicken.</div>
        <div style={{overflowX:"auto"}}>
          <table style={{borderCollapse:"collapse",tableLayout:"fixed",width:totalW,minWidth:"100%"}}>
            <colgroup>
              {COLS.map(c=><col key={c.key} style={{width:(colW[c.key]||c.w)}}/>)}
              <col style={{width:(colW.eingeloest||96)}}/>
              <col style={{width:ACT_W}}/>
            </colgroup>
            <thead>
              <tr>
                {COLS.map(c=>(
                  <th key={c.key} style={{...thStyle,textAlign:c.center?"center":"left",borderRight:`1px solid ${T.border}44`,position:"relative",userSelect:"none",overflow:"hidden",whiteSpace:"nowrap"}}>
                    {c.label}
                    <ResizeHandle T={T} onMouseDown={e=>startResize(e,c.key)}/>
                  </th>
                ))}
                <th style={{...thStyle,textAlign:"center",letterSpacing:"0.04em",borderRight:`1px solid ${T.border}44`,position:"relative",userSelect:"none",overflow:"hidden",whiteSpace:"nowrap"}}>
                  Eingelöst
                  <ResizeHandle T={T} onMouseDown={e=>startResize(e,"eingeloest")}/>
                </th>
                <th style={{...thStyle}}></th>
              </tr>
            </thead>
            <tbody>
              {rows.map(g=>(
                <tr key={g.id}
                  onMouseEnter={e=>e.currentTarget.style.background=T.tileHover}
                  onMouseLeave={e=>e.currentTarget.style.background="transparent"}
                  style={{transition:"background 0.1s",opacity:g.eingeloest?0.6:1}}>
                  {COLS.map(c=>(
                    <td key={c.key} style={{padding:"10px 16px",borderBottom:`1px solid ${T.border}22`,borderRight:`1px solid ${T.border}22`,overflow:"hidden",textAlign:c.center?"center":"left"}}>
                      {c.info?(
                        <button onClick={()=>setInfoFor(g.id)} title={g.infos?g.infos:"Infos hinzufügen"}
                          style={{background:"transparent",border:"none",cursor:"pointer",width:"100%",display:"flex",justifyContent:"center",alignItems:"center",padding:"4px 0"}}>
                          {g.infos&&g.infos.trim()
                            ? <span style={{width:11,height:11,borderRadius:"50%",background:T.info,display:"inline-block"}}/>
                            : <span style={{fontSize:16,color:T.muted,lineHeight:1}}>+</span>}
                        </button>
                      ):(
                        <input type={c.type||"text"} placeholder={c.ph||""} value={g[c.key]||""} onChange={e=>upd(g.id,c.key,e.target.value)} style={{...cellInp,textAlign:c.center?"center":"left"}}/>
                      )}
                    </td>
                  ))}
                  <td style={{padding:"10px 16px",borderBottom:`1px solid ${T.border}22`,borderRight:`1px solid ${T.border}22`,textAlign:"center"}}>
                    <input type="checkbox" checked={!!g.eingeloest} onChange={e=>upd(g.id,"eingeloest",e.target.checked)} style={{accentColor:T.accent,width:16,height:16,cursor:"pointer"}}/>
                  </td>
                  <td style={{padding:"10px 12px",borderBottom:`1px solid ${T.border}22`,textAlign:"center"}}>
                    <button style={btn(T,"danger",true)} onClick={()=>del(g.id)} title="Löschen"><Ic n="trash" s={13}/></button>
                  </td>
                </tr>
              ))}
              {gutscheine.length===0&&(
                <tr><td colSpan={COLS.length+2} style={{padding:36,textAlign:"center",color:T.muted}}>Noch keine Gutscheine. Klicke auf „+ Neuer Gutschein" oder „+ Aus Kunde".</td></tr>
              )}
              {gutscheine.length>0&&rows.length===0&&(
                <tr><td colSpan={COLS.length+2} style={{padding:20,textAlign:"center",color:T.muted}}>Keine Treffer.</td></tr>
              )}
            </tbody>
          </table>
        </div>
        <div style={{padding:"10px 16px",borderTop:`1px solid ${T.border}`}}>
          <button style={btn(T,"ghost",true)} onClick={addRow}>+ Zeile hinzufügen</button>
        </div>
      </div>

      {infoG&&(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.6)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:200,padding:20}} onClick={()=>setInfoFor(null)}>
          <div onClick={e=>e.stopPropagation()} style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:14,padding:24,width:"100%",maxWidth:480}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
              <div style={{fontFamily:"Georgia,serif",fontSize:18,color:T.accent}}>Infos{infoG.kunde?" – "+infoG.kunde:infoG.nr?" – Nr "+infoG.nr:""}</div>
              <button style={btn(T,"ghost",true)} onClick={()=>setInfoFor(null)}>✕</button>
            </div>
            <textarea value={infoG.infos||""} onChange={e=>upd(infoG.id,"infos",e.target.value)} autoFocus
              placeholder="Notizen zu diesem Gutschein..."
              style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:"12px 14px",color:T.text,fontSize:14,fontFamily:"inherit",outline:"none",boxSizing:"border-box",width:"100%",minHeight:180,resize:"vertical",lineHeight:1.6}}/>
            <div style={{display:"flex",justifyContent:"flex-end",marginTop:14}}>
              <button style={btn(T,"primary")} onClick={()=>setInfoFor(null)}>Fertig</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ── StudioHeaderKarte ─────────────────────────────────────────────────────────
function GalerieKachel({T, btn, cardStyle, setPage}){
  const [galKacheln,setGalKacheln]=useState([]);
  const [galAusgeblendet,setGalAusgeblendet]=useState(()=>{try{return JSON.parse(localStorage.getItem("sd_gal_ausgeblendet")||"[]");}catch{return [];}});
  const [galPopup,setGalPopup]=useState(null);
  const [showAlleGal,setShowAlleGal]=useState(false);
  useEffect(()=>{
    const su=(localStorage.getItem("sd_server_url")||location.origin).replace(/\/+$/,"");
    fetch(su+"/api/galerie/alle").then(r=>r.json()).then(d=>{
      if(Array.isArray(d))setGalKacheln(d);
    }).catch(()=>{});
  },[]);
  // Neueste zuerst. Ohne Datum ans Ende.
  const _galZeit=g=>{
    const kand=[g.erstellt,(g.downloads_log||[]).slice(-1)[0]?.datum];
    for(const k of kand){const t=k?new Date(k).getTime():NaN;if(!isNaN(t))return t;}
    return 0;
  };
  const sichtbar=galKacheln.filter(g=>!galAusgeblendet.includes(g.token))
    .slice().sort((a,b)=>_galZeit(b)-_galZeit(a));
  if(sichtbar.length===0)return(<div style={{...cardStyle,height:210}}><div style={{fontFamily:"Georgia,serif",fontSize:15,color:T.accent,marginBottom:8}}>Galerien</div><p style={{color:T.muted,fontSize:13}}>Keine aktiven Galerien.</p></div>);
  return(<>
    <div style={{...cardStyle,height:210,overflow:"hidden",position:"relative"}}>
      <div style={{fontFamily:"Georgia,serif",fontSize:15,color:T.accent,marginBottom:12}}>Galerien</div>
      <div style={{display:"flex",flexDirection:"column",gap:8}}>
        {sichtbar.slice(0,2).map(g=>{
          const dlLog=g.downloads_log||[];
          const hatDl=dlLog.length>0;
          const letzterDl=hatDl?dlLog[dlLog.length-1]:null;
          const gesamtDl=dlLog.reduce((s,d)=>s+(d.anzahl||0),0);
          const fbAnzahl=g.feedback?Object.values(g.feedback).filter(v=>v).length:0;
          // Wie viele Bilder der Kunde tatsaechlich haben will
          const fbJa=g.feedback?Object.values(g.feedback).filter(v=>v==="ja").length:0;
          const fbAbg=g.status==="abgeschlossen";
          return(
            <div key={g.token} style={{padding:"8px 10px",background:T.bg,borderRadius:8,border:`1px solid ${hatDl?"#22c55e":T.border}`,cursor:"pointer"}}
              onClick={()=>{if(setPage){setPage("galerien");setTimeout(()=>document.dispatchEvent(new CustomEvent("openGalerie",{detail:{token:g.token}})),300);}}}>
              <div style={{fontWeight:700,fontSize:15,color:T.text,marginBottom:4,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{(g.titel||"").replace(/<[^>]*>/g,"")}</div>
              {fbAnzahl>0&&(<div style={{display:"flex",alignItems:"center",gap:4,fontSize:11,color:T.muted,marginBottom:2}}>
                <span style={{minWidth:58}}>Feedback</span><span>·</span>
                <span style={{color:T.text}}>{g.erstellt?new Date(g.erstellt).toLocaleDateString("de-DE"):"-"}</span><span>·</span>
                <span style={{color:T.text}}>{g.bilder?g.bilder.length:0} Galerie</span><span>·</span>
                <span style={{color:T.text}}>{fbAnzahl} bewertet</span>
                {fbJa>0&&<><span>·</span><span style={{color:"#16a34a",fontWeight:700}}>{fbJa} ausgewählt</span></>}
                {fbAbg&&<span style={{color:"#22c55e",fontWeight:700,marginLeft:"auto"}}>✓</span>}
              </div>)}
              {hatDl&&letzterDl&&(<div style={{display:"flex",alignItems:"center",gap:4,fontSize:11,color:T.muted}}>
                <span style={{minWidth:58}}>Download</span><span>·</span>
                <span style={{color:T.text}}>{letzterDl.datum?new Date(letzterDl.datum).toLocaleDateString("de-DE"):letzterDl.datum}</span><span>·</span>
                <span style={{color:T.text}}>{gesamtDl} Dateien</span>
                <span style={{color:"#22c55e",fontWeight:700,marginLeft:"auto"}}>✓</span>
              </div>)}
              {fbAnzahl===0&&!hatDl&&(<div style={{fontSize:11,color:T.muted}}>{g.status==="abgeschlossen"?"Abgeschlossen":g.status==="download"?"Download":"Feedbackgalerie"} · {g.bilder?g.bilder.length:0} Dateien</div>)}
            </div>
          );
        })}
      </div>
      {sichtbar.length>2&&<button onClick={()=>setShowAlleGal(true)} style={{position:"absolute",bottom:0,left:0,right:0,fontSize:13,color:T.accent,background:T.surface,border:"none",borderTop:`1px solid ${T.border}33`,cursor:"pointer",padding:"6px 0",textAlign:"center"}}>{"▼ Alle "+sichtbar.length+" anzeigen"}</button>}
    </div>
    {showAlleGal&&(
      <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.55)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:300}} onClick={()=>setShowAlleGal(false)}>
        <div style={{background:T.surface,borderRadius:14,width:520,maxHeight:"75vh",overflowY:"auto",padding:20,border:`1px solid ${T.border}`}} onClick={e=>e.stopPropagation()}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
            <div style={{fontFamily:"Georgia,serif",fontSize:15,color:T.accent}}>Galerien</div>
            <button style={btn(T,"ghost",true)} onClick={()=>setShowAlleGal(false)}>▲ Weniger</button>
          </div>
          <div style={{display:"flex",flexDirection:"column",gap:8}}>
            {sichtbar.map(g=>(
              <div key={g.token} style={{padding:"8px 10px",background:T.bg,borderRadius:8,border:`1px solid ${T.border}`,cursor:"pointer"}}
                onClick={()=>{setShowAlleGal(false);if(setPage){setPage("galerien");setTimeout(()=>document.dispatchEvent(new CustomEvent("openGalerie",{detail:{token:g.token}})),300);}}}>
                <div style={{fontWeight:700,fontSize:15,color:T.text,marginBottom:4,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{(g.titel||"").replace(/<[^>]*>/g,"")}</div>
                <div style={{fontSize:11,color:T.muted}}>
                  {g.status==="abgeschlossen"?"Abgeschlossen":g.status==="download"?"Download":"Feedbackgalerie"}
                  {g.erstellt?" · "+new Date(g.erstellt).toLocaleDateString("de-DE"):""}
                  {" · "+(g.bilder?g.bilder.length:0)+" Dateien"}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    )}
    {galPopup&&(
      <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.55)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:300}} onClick={()=>setGalPopup(null)}>
        <div style={{background:T.surface,borderRadius:14,width:400,padding:24,border:`1px solid ${T.border}`}} onClick={e=>e.stopPropagation()}>
          <div style={{fontFamily:"Georgia,serif",fontSize:17,color:T.accent,marginBottom:8}} dangerouslySetInnerHTML={{__html:galPopup.titel||""}}/>
          <div style={{fontSize:13,color:T.text,marginBottom:20}}>Der Kunde hat die Bilder heruntergeladen. Soll diese Galerie aus dem Dashboard entfernt werden?</div>
          <div style={{display:"flex",gap:10,justifyContent:"flex-end"}}>
            <button onClick={()=>setGalPopup(null)} style={{...btn(T,"ghost"),fontSize:12}}>Behalten</button>
            <button onClick={()=>{const neu=[...galAusgeblendet,galPopup.token];setGalAusgeblendet(neu);localStorage.setItem("sd_gal_ausgeblendet",JSON.stringify(neu));setGalPopup(null);}} style={{...btn(T,"primary"),fontSize:12}}>Entfernen</button>
          </div>
        </div>
      </div>
    )}
  </>);
}

function StudioHeaderKarte({T, btn, IS}){
  const [sh,setSh]=useState(()=>{try{return JSON.parse(localStorage.getItem("sd_studio_header")||"null")||{};}catch{return {};}});
  function saveSh(k,v){const u={...sh,[k]:v};setSh(u);localStorage.setItem("sd_studio_header",JSON.stringify(u));}
  const FONTS=["Georgia, serif","Inter, sans-serif","Arial, sans-serif","'Courier New', monospace","'Trebuchet MS', sans-serif","Palatino, serif","Garamond, serif"];
  const nameStyle={fontFamily:sh.nameFont||"Georgia, serif",fontSize:sh.nameSize||26,fontWeight:sh.nameBold?"700":"400",fontStyle:sh.nameItalic?"italic":"normal",color:sh.nameColor||T.text};
  return(
    <div>
      <div style={{marginBottom:16}}>
        <label style={{fontSize:12,color:T.muted,fontWeight:600,display:"block",marginBottom:6}}>Anzeigename (statt "Übersicht")</label>
        <input value={sh.name||""} onChange={e=>saveSh("name",e.target.value)}
          placeholder="z.B. Markus Heber Photography"
          style={{...IS,width:"100%"}}/>
        {sh.name&&<div style={{...nameStyle,marginTop:8,padding:"6px 0"}}>{sh.name}</div>}
      </div>
      <div style={{marginBottom:16,display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
        <div>
          <label style={{fontSize:12,color:T.muted,fontWeight:600,display:"block",marginBottom:6}}>Schriftart</label>
          <select value={sh.nameFont||"Georgia, serif"} onChange={e=>saveSh("nameFont",e.target.value)}
            style={{...IS,width:"100%"}}>
            {FONTS.map(f=><option key={f} value={f} style={{fontFamily:f}}>{f.split(",")[0]}</option>)}
          </select>
        </div>
        <div>
          <label style={{fontSize:12,color:T.muted,fontWeight:600,display:"block",marginBottom:6}}>Größe</label>
          <div style={{display:"flex",gap:8,alignItems:"center"}}>
            <input type="range" min={14} max={48} step={1} value={sh.nameSize||26} onChange={e=>saveSh("nameSize",+e.target.value)} style={{flex:1,accentColor:T.accent}}/>
            <span style={{fontSize:12,color:T.text,minWidth:28}}>{sh.nameSize||26}px</span>
          </div>
        </div>
        <div style={{display:"flex",gap:8,alignItems:"center"}}>
          <label style={{fontSize:12,color:T.muted,fontWeight:600}}>Farbe</label>
          <input type="color" value={sh.nameColor||T.text} onChange={e=>saveSh("nameColor",e.target.value)}
            style={{width:36,height:28,border:"none",borderRadius:6,cursor:"pointer",padding:2,background:"none"}}/>
        </div>
        <div style={{display:"flex",gap:12,alignItems:"center"}}>
          <label style={{display:"flex",alignItems:"center",gap:6,fontSize:12,color:T.muted,cursor:"pointer"}}>
            <input type="checkbox" checked={!!sh.nameBold} onChange={e=>saveSh("nameBold",e.target.checked)} style={{accentColor:T.accent}}/> Fett
          </label>
          <label style={{display:"flex",alignItems:"center",gap:6,fontSize:12,color:T.muted,cursor:"pointer"}}>
            <input type="checkbox" checked={!!sh.nameItalic} onChange={e=>saveSh("nameItalic",e.target.checked)} style={{accentColor:T.accent}}/> Kursiv
          </label>
        </div>
      </div>
      <div style={{marginBottom:16}}>
        <label style={{fontSize:12,color:T.muted,fontWeight:600,display:"block",marginBottom:10}}>Logos</label>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
          <div style={{background:"#1a1814",borderRadius:8,padding:12}}>
            <div style={{fontSize:11,color:"#aaa",marginBottom:6}}>Hell (für dunklen Hintergrund)</div>
          <label style={{fontSize:12,color:T.muted,fontWeight:600,display:"block",marginBottom:4}}>Logo hell</label>
          {sh["logo"]&&<img src={sh["logo"]} alt="Logo hell" style={{maxHeight:80,maxWidth:200,display:"block",marginBottom:6,borderRadius:4}}/>}
          <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
            <label style={{...btn(T,"ghost",true),cursor:"pointer",fontSize:11}}>
              📁 Hochladen
              <input type="file" accept="image/*" style={{display:"none"}} onChange={e=>{
                const f=e.target.files[0];if(!f)return;
                const r=new FileReader();
                r.onload=ev=>{
                  const img=new Image();
                  img.onload=()=>{
                    const canvas=document.createElement("canvas");
                    const MAX=800;let w=img.width,h=img.height;
                    if(w>MAX||h>MAX){const ratio=Math.min(MAX/w,MAX/h);w=Math.round(w*ratio);h=Math.round(h*ratio);}
                    canvas.width=w;canvas.height=h;
                    canvas.getContext("2d").drawImage(img,0,0,w,h);
                    const compressed=canvas.toDataURL("image/png",0.9);
                    saveSh("logo",compressed);
                    try{
                      const cfg=JSON.parse(localStorage.getItem("sd_buchung_config")||"{}");
                      const updated={...cfg,logo:compressed};
                      localStorage.setItem("sd_buchung_config",JSON.stringify(updated));
                      const serverUrl=(localStorage.getItem("sd_server_url")||"").trim().replace(/\/+$/,"");
                      if(serverUrl)fetch(`${serverUrl}/api/buchung-config`,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(updated)}).catch(()=>{});
                    }catch{}
                  };
                  img.src=ev.target.result;
                };
                r.readAsDataURL(f);
              }}/>
            </label>
            {sh["logo"]&&<button style={{...btn(T,"ghost",true),fontSize:11,color:"#e53"}} onClick={()=>saveSh("logo","")}>✕</button>}
            {sh["logo"]&&<button style={{...btn(T,"ghost",true),fontSize:10}} onClick={async()=>{
              try{
                const cfg=JSON.parse(localStorage.getItem("sd_buchung_config")||"{}");
                const updated={...cfg,logo:sh["logo"]};
                localStorage.setItem("sd_buchung_config",JSON.stringify(updated));
                const serverUrl=(localStorage.getItem("sd_server_url")||"").trim().replace(/\/+$/,"");
                if(!serverUrl){alert("Keine Server-URL.");return;}
                const r=await fetch(`${serverUrl}/api/buchung-config`,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(updated)});
                const d=await r.json();
                alert(d.ok?"✅ Gespeichert!":"❌ Fehler");
              }catch(e){alert("Fehler: "+e.message);}
            }}>☁️ Server</button>}
          </div>
          </div>
          <div style={{background:"#f5f3ef",border:`1px solid ${T.border}`,borderRadius:8,padding:12}}>
            <div style={{fontSize:11,color:T.muted,marginBottom:6}}>Dunkel (für hellen Hintergrund)</div>
          <label style={{fontSize:12,color:T.muted,fontWeight:600,display:"block",marginBottom:4}}>Logo dunkel</label>
          {sh["logoDark"]&&<img src={sh["logoDark"]} alt="Logo dunkel" style={{maxHeight:80,maxWidth:200,display:"block",marginBottom:6,borderRadius:4}}/>}
          <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
            <label style={{...btn(T,"ghost",true),cursor:"pointer",fontSize:11}}>
              📁 Hochladen
              <input type="file" accept="image/*" style={{display:"none"}} onChange={e=>{
                const f=e.target.files[0];if(!f)return;
                const r=new FileReader();
                r.onload=ev=>{
                  const img=new Image();
                  img.onload=()=>{
                    const canvas=document.createElement("canvas");
                    const MAX=800;let w=img.width,h=img.height;
                    if(w>MAX||h>MAX){const ratio=Math.min(MAX/w,MAX/h);w=Math.round(w*ratio);h=Math.round(h*ratio);}
                    canvas.width=w;canvas.height=h;
                    canvas.getContext("2d").drawImage(img,0,0,w,h);
                    const compressed=canvas.toDataURL("image/png",0.9);
                    saveSh("logoDark",compressed);
                    try{
                      const cfg=JSON.parse(localStorage.getItem("sd_buchung_config")||"{}");
                      const updated={...cfg,logoDark:compressed};
                      localStorage.setItem("sd_buchung_config",JSON.stringify(updated));
                      const serverUrl=(localStorage.getItem("sd_server_url")||"").trim().replace(/\/+$/,"");
                      if(serverUrl)fetch(`${serverUrl}/api/buchung-config`,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(updated)}).catch(()=>{});
                    }catch{}
                  };
                  img.src=ev.target.result;
                };
                r.readAsDataURL(f);
              }}/>
            </label>
            {sh["logoDark"]&&<button style={{...btn(T,"ghost",true),fontSize:11,color:"#e53"}} onClick={()=>saveSh("logoDark","")}>✕</button>}
            {sh["logoDark"]&&<button style={{...btn(T,"ghost",true),fontSize:10}} onClick={async()=>{
              try{
                const cfg=JSON.parse(localStorage.getItem("sd_buchung_config")||"{}");
                const updated={...cfg,logoDark:sh["logoDark"]};
                localStorage.setItem("sd_buchung_config",JSON.stringify(updated));
                const serverUrl=(localStorage.getItem("sd_server_url")||"").trim().replace(/\/+$/,"");
                if(!serverUrl){alert("Keine Server-URL.");return;}
                const r=await fetch(`${serverUrl}/api/buchung-config`,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(updated)});
                const d=await r.json();
                alert(d.ok?"✅ Gespeichert!":"❌ Fehler");
              }catch(e){alert("Fehler: "+e.message);}
            }}>☁️ Server</button>}
          </div>
          </div>
        </div>
      </div>
      <div style={{marginBottom:12}}>
        <label style={{fontSize:12,color:T.muted,fontWeight:600,display:"block",marginBottom:6}}>Logo-Höhe</label>
        <div style={{display:"flex",gap:8,alignItems:"center"}}>
          <input type="range" min={24} max={300} step={2} value={sh.logoH||150} onChange={e=>saveSh("logoH",+e.target.value)} style={{flex:1,accentColor:T.accent}}/>
          <span style={{fontSize:12,color:T.text,minWidth:32}}>{sh.logoH||150}px</span>
        </div>
      </div>
      {(sh.logo||sh.logoDark)&&<button style={{...btn(T,"primary",true),width:"100%",justifyContent:"center"}} onClick={async()=>{
        try{
          const cfg=JSON.parse(localStorage.getItem("sd_buchung_config")||"{}");
          const updated={...cfg,...(sh.logo?{logo:sh.logo}:{}),...(sh.logoDark?{logoDark:sh.logoDark}:{})};
          localStorage.setItem("sd_buchung_config",JSON.stringify(updated));
          const serverUrl=(localStorage.getItem("sd_server_url")||"").trim().replace(/\/+$/,"");
          if(!serverUrl){alert("Keine Server-URL.");return;}
          const r=await fetch(`${serverUrl}/api/buchung-config`,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(updated)});
          const d=await r.json();
          alert(d.ok?"✅ Logos zum Server hochgeladen!":"❌ Fehler");
        }catch(e){alert("Fehler: "+e.message);}
      }}>☁️ Beide Logos zum Server hochladen</button>}
    </div>
  );
}

// ── EinstellungenPage ─────────────────────────────────────────────────────────────────────
function SpeicherKarte({T,s,up,btn,IS,subFolders,neuOrdner,setNeuOrdner,addFolder,removeFolder}){
  return(
    <EinstellungenCard T={T} title="Speicherpfad & Ordnerstruktur" icon="folder">
      <label style={{fontSize:12,color:T.muted,fontWeight:600,display:"block",marginBottom:5}}>Basis-Speicherpfad</label>
      <input value={s.basePath||""} onChange={e=>up("basePath",e.target.value)} placeholder={"E:\\Fotografie\\Shootings"} style={{...IS,fontFamily:"monospace",fontSize:12}}/>
      <div style={{fontSize:11,color:T.muted,marginTop:6,marginBottom:18}}>
        Wird verwendet sobald der Server läuft — PDFs und Dateien werden dann automatisch dort abgelegt.
      </div>
      <label style={{fontSize:12,color:T.muted,fontWeight:600,display:"block",marginBottom:8}}>Unterordner pro Veranstaltung</label>
      <div style={{display:"flex",flexDirection:"column",gap:6,marginBottom:12}}>
        {subFolders.map(f=>(
          <div key={f} style={{display:"flex",alignItems:"center",gap:8,background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:"8px 12px"}}>
            <span style={{color:T.accent,display:"flex"}}><Ic n="folder" s={13}/></span>
            <span style={{flex:1,fontSize:13,color:T.text}}>{f}</span>
            <button style={btn(T,"danger",true)} onClick={()=>removeFolder(f)} title="Entfernen"><Ic n="trash" s={12}/></button>
          </div>
        ))}
        {subFolders.length===0&&<div style={{fontSize:12,color:T.muted,padding:8}}>Keine Unterordner definiert.</div>}
      </div>
      <div style={{display:"flex",gap:8}}>
        <input value={neuOrdner} onChange={e=>setNeuOrdner(e.target.value)}
          onKeyDown={e=>{if(e.key==="Enter")addFolder();}}
          placeholder="Neuer Ordnername..." style={{...IS,flex:1}}/>
        <button style={btn(T,"primary",true)} onClick={addFolder}>+ Hinzufügen</button>
      </div>
      <div style={{marginTop:18,background:T.bg,borderRadius:8,padding:14,fontFamily:"monospace",fontSize:11.5,color:T.muted,lineHeight:1.9}}>
        <div style={{fontSize:10,fontWeight:700,textTransform:"uppercase",letterSpacing:"0.08em",marginBottom:6,fontFamily:"Inter,sans-serif"}}>Vorschau der Struktur:</div>
        <div>{s.basePath||"E:\\Fotografie\\Shootings"}</div>
        <div style={{paddingLeft:16}}>└─ {new Date().getFullYear()}</div>
        <div style={{paddingLeft:32}}>└─ Tierlieb Festival</div>
        {subFolders.map((f,i)=>(
          <div key={f} style={{paddingLeft:48,color:T.accent}}>{i===subFolders.length-1?"└─":"├─"} {f}</div>
        ))}
      </div>
    </EinstellungenCard>
  );
}

function TelegramKarte({T,s,up,btn,IS}){
  return(
    <EinstellungenCard T={T} title="Telegram Benachrichtigungen" icon="inbox">
      <div style={{fontSize:12,color:T.muted,marginBottom:12,lineHeight:1.7,background:T.bg,borderRadius:8,padding:"10px 14px"}}>
        <strong style={{color:T.text}}>Einrichtung (einmalig):</strong><br/>
        1. Telegram öffnen → <code style={{background:T.surface,padding:"1px 5px",borderRadius:3}}>@BotFather</code> suchen<br/>
        2. <code style={{background:T.surface,padding:"1px 5px",borderRadius:3}}>/newbot</code> senden → Name vergeben → Token kopieren<br/>
        3. Deinen neuen Bot suchen → <code style={{background:T.surface,padding:"1px 5px",borderRadius:3}}>/start</code> schreiben<br/>
        4. <code style={{background:T.surface,padding:"1px 5px",borderRadius:3}}>@userinfobot</code> anschreiben → deine Chat-ID erhalten
      </div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit, minmax(150px, 1fr))",gap:12,marginBottom:12}}>
        <div>
          <label style={{fontSize:11,color:T.muted,fontWeight:600,display:"block",marginBottom:4}}>Bot Token</label>
          <input value={s.telegram_token||""} onChange={e=>up("telegram_token",e.target.value.trim())} placeholder="7123456789:AAH..." type="password" style={IS}/>
        </div>
        <div>
          <label style={{fontSize:11,color:T.muted,fontWeight:600,display:"block",marginBottom:4}}>Chat-ID</label>
          <input value={s.telegram_chat_id||""} onChange={e=>up("telegram_chat_id",e.target.value.trim())} placeholder="123456789" style={IS}/>
        </div>
      </div>
      <button style={btn(T,"primary",true)} onClick={async()=>{
        const tok=(s.telegram_token||"").trim();const cid=(s.telegram_chat_id||"").trim();
        if(!tok||!cid){alert("Bitte zuerst Token und Chat-ID eingeben.");return;}
        try{
          const r=await fetch(`https://api.telegram.org/bot${tok}/sendMessage`,{
            method:"POST",headers:{"Content-Type":"application/json"},
            body:JSON.stringify({chat_id:cid,text:"✅ ScattoDesk Benachrichtigungen sind aktiv!"}),
          });
          const d=await r.json();
          if(d.ok)alert("✅ Testnachricht gesendet — schau in Telegram!");
          else alert("❌ Fehler: "+d.description);
        }catch(e){alert("❌ Verbindungsfehler: "+e.message);}
      }}>Testnachricht senden</button>
    </EinstellungenCard>
  );
}

function BankdatenKarte({T,IS,Card}){
  const [bk,setBk]=useState(()=>{try{const c=JSON.parse(localStorage.getItem("sd_buchung_config")||"null");return c?.bankdaten||{};}catch{return {};}});
  function saveBk(k,v){
    setBk(p=>{
      const n={...p,[k]:v};
      try{
        const c=JSON.parse(localStorage.getItem("sd_buchung_config")||"{}");
        localStorage.setItem("sd_buchung_config",JSON.stringify({...c,bankdaten:n}));
      }catch{}
      return n;
    });
  }
  return(<>
    <Card title="Bankverbindung" icon="🏦">
      {[
        {k:"kontoinhaber",label:"Kontoinhaber",ph:"Markus Heber"},
        {k:"iban",label:"IBAN",ph:"DE00 1234 5678 9012 3456 78"},
        {k:"bic",label:"BIC",ph:"COBADEFFXXX"},
        {k:"bank",label:"Kreditinstitut",ph:"Commerzbank"},
        {k:"paypal",label:"PayPal.me-Link",ph:"https://paypal.me/deinname"},
      ].map(({k,label,ph})=>(
        <div key={k} style={{marginBottom:14}}>
          <label style={{fontSize:12,color:T.muted,fontWeight:600,display:"block",marginBottom:5}}>{label}</label>
          <input value={bk[k]||""} onChange={e=>saveBk(k,e.target.value)} placeholder={ph} style={IS}/>
        </div>
      ))}
      <div style={{marginTop:8,padding:"10px 14px",background:T.bg,borderRadius:8,fontSize:12,color:T.muted}}>
        💡 Diese Daten werden für Bezahllinks und QR-Codes verwendet.
      </div>
    </Card>
  </>);
}

function EinstellungenCard({T,title,icon,children}){
  return(
    <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:12,padding:24,marginBottom:0}}>
      <div style={{display:"flex",alignItems:"center",gap:8,fontFamily:"Georgia,serif",fontSize:16,color:T.accent,marginBottom:16}}>
        <Ic n={icon} s={16}/>{title}
      </div>
      {children}
    </div>
  );
}

// ── Akquise-Liste ─────────────────────────────────────────────────────────────
// Wen habe ich wann angeschrieben, wie ist der Stand. Sagt jemand zu, wandert
// der Eintrag per Knopf in die Firmenkontakte.
const AKQ_KEY="sd_akquise";
const AKQ_SPALTEN_KEY="sd_akquise_spalten";

const AKQ_STATUS=[
  {id:"offen",     label:"noch nichts",   farbe:"#8A8075"},
  {id:"kontakt",   label:"angeschrieben", farbe:"#5b8fc9"},
  {id:"nachfass",  label:"nachgefasst",   farbe:"#A8843E"},
  {id:"bedarf",    label:"melden sich bei Bedarf", farbe:"#7A9BB5"},
  {id:"zusage",    label:"Zusage",        farbe:"#2F8B4E"},
  {id:"absage",    label:"Absage",        farbe:"#C0563E"},
];

function AkquiseListe({T,btn,IS}){
  const [zeilen,setZeilen]=useState(()=>{
    try{return JSON.parse(localStorage.getItem(AKQ_KEY)||"[]");}catch(e){return [];}
  });
  const [spalten,setSpalten]=useState(()=>{
    try{
      const v=JSON.parse(localStorage.getItem(AKQ_SPALTEN_KEY)||"null");
      return Array.isArray(v)?v:[{id:"c1",titel:"Branche"},{id:"c2",titel:"Notiz"}];
    }catch(e){return [{id:"c1",titel:"Branche"},{id:"c2",titel:"Notiz"}];}
  });
  const [offen,setOffen]=useState(null);      // id der geöffneten Zeile
  const [meldung,setMeldung]=useState("");
  const [filter,setFilter]=useState("");

  const sichern=n=>{setZeilen(n);localStorage.setItem(AKQ_KEY,JSON.stringify(n));};
  const sichernSp=n=>{setSpalten(n);localStorage.setItem(AKQ_SPALTEN_KEY,JSON.stringify(n));};
  const eintrag=zeilen.find(z=>z.id===offen)||null;
  const aendern=(feld,wert)=>sichern(zeilen.map(z=>z.id===offen?{...z,[feld]:wert}:z));
  const aendernExtra=(sid,wert)=>sichern(zeilen.map(z=>z.id===offen
    ?{...z,extra:{...(z.extra||{}),[sid]:wert}}:z));

  const neu=()=>{
    const id="a"+Date.now();
    sichern([{id,firma:"",name:"",email:"",telefon:"",strasse:"",plz:"",ort:"",
              homepage:"",notizen:"",status:"offen",kontakt1:"",extra:{}},...zeilen]);
    setOffen(id);
  };

  const spalteNeu=()=>{
    const titel=window.prompt("Wie soll die Spalte heißen?","Neue Spalte");
    if(!titel||!titel.trim())return;
    sichernSp([...spalten,{id:"c"+Date.now(),titel:titel.trim()}]);
  };
  const spalteUm=s=>{
    const titel=window.prompt("Spalte umbenennen:",s.titel);
    if(!titel||!titel.trim())return;
    sichernSp(spalten.map(x=>x.id===s.id?{...x,titel:titel.trim()}:x));
  };
  const spalteWeg=s=>{
    if(!window.confirm("Spalte „"+s.titel+"“ entfernen? Die eingetragenen Werte gehen verloren."))return;
    sichernSp(spalten.filter(x=>x.id!==s.id));
  };

  // Übernahme in die Firmenkontakte. Gleiche Ablage und gleiche Felder wie
  // unter Kontakte, damit der Eintrag dort ohne Nacharbeit auftaucht.
  function alsFirmenkontakt(z){
    if(!(z.firma||"").trim()&&!(z.name||"").trim()){
      setMeldung("Ohne Firma oder Name kann ich nichts übernehmen.");
      return;
    }
    let alle=[];
    try{alle=JSON.parse(localStorage.getItem("sd_firmenkontakte")||"[]");}catch(e){}
    if(!Array.isArray(alle))alle=[];
    const gleich=alle.find(k=>
      ((k.firma||"").trim().toLowerCase()&&(k.firma||"").trim().toLowerCase()===(z.firma||"").trim().toLowerCase())
      ||((k.email||"").trim().toLowerCase()&&(k.email||"").trim().toLowerCase()===(z.email||"").trim().toLowerCase()));
    if(gleich&&!window.confirm(
      "„"+(gleich.firma||gleich.name)+"“ steht schon in den Firmenkontakten.\n\nTrotzdem ein zweites Mal anlegen?"))return;

    const zusatz=spalten
      .map(s=>(z.extra||{})[s.id]?s.titel+": "+(z.extra||{})[s.id]:"")
      .filter(Boolean).join("\n");
    alle.push({
      id:"fk"+Date.now(),
      name:z.name||"", firma:z.firma||"",
      strasse:z.strasse||"", plz:z.plz||"", ort:z.ort||"",
      handy:"", telefon:z.telefon||"", email:z.email||"",
      homepage:z.homepage||"", oeffnungszeiten:"",
      sonstiges:[z.notizen||"",zusatz,z.kontakt1?"Erstkontakt: "+z.kontakt1:""]
        .filter(Boolean).join("\n\n"),
    });
    localStorage.setItem("sd_firmenkontakte",JSON.stringify(alle));
    sichern(zeilen.map(x=>x.id===z.id?{...x,uebernommen:new Date().toISOString().slice(0,10),status:"zusage"}:x));
    setMeldung("„"+(z.firma||z.name)+"“ steht jetzt unter Kontakte → Firmen.");
    setTimeout(()=>setMeldung(""),5000);
  }

  const FELD={...IS,width:"100%"};
  const LBL={fontSize:12,color:T.muted,fontWeight:600,display:"block",marginBottom:5};
  const stat=id=>AKQ_STATUS.find(s=>s.id===id)||AKQ_STATUS[0];

  // Oeffnet das Standard-Mailprogramm mit vorbereiteter Nachricht. Welches
  // Konto Outlook dabei als Absender nimmt, bestimmt Outlook selbst - ueber
  // einen mailto-Aufruf laesst sich der Absender nicht vorgeben.
  function mailOeffnen(z){
    if(!(z.email||"").trim())return;
    let betreff="",text="";
    try{
      const v=(JSON.parse(localStorage.getItem(MT_KEY)||"null")||MT_START)[0]||{};
      const teile=(z.name||"").trim().split(/\s+/).filter(Boolean);
      const werte={
        firma:z.firma||"", anrede:"Guten Tag",
        nachname:teile.length?teile[teile.length-1]:"",
        vorname:teile.length>1?teile[0]:"",
        ort:z.ort||"", branche:"",
        studio:(()=>{try{return JSON.parse(localStorage.getItem("sd_buchung_config")||"{}").studioName||"Markus Heber Photography";}catch(e){return "Markus Heber Photography";}})(),
        datum:new Date().toLocaleDateString("de-DE"),
      };
      const fuellen=r=>String(r||"").replace(/\{\{(\w+)\}\}/g,(m,k)=>(k in werte?werte[k]:""));
      betreff=fuellen(v.betreff); text=fuellen(v.text);
    }catch(e){}
    const url="mailto:"+encodeURIComponent(z.email.trim())
      +"?subject="+encodeURIComponent(betreff)
      +"&body="+encodeURIComponent(text);
    if(url.length>1900){
      window.location.href="mailto:"+encodeURIComponent(z.email.trim());
      return;
    }
    window.location.href=url;
  }

  const sichtbar=zeilen.filter(z=>{
    if(!filter.trim())return true;
    const f=filter.toLowerCase();
    return ((z.firma||"")+" "+(z.name||"")+" "+(z.ort||"")+" "+(z.email||"")).toLowerCase().includes(f);
  });

  // ── Einzelner Eintrag ──────────────────────────────────────────────────────
  if(eintrag){
    return(
      <div>
        <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:16,flexWrap:"wrap"}}>
          <button style={btn(T,"ghost",true)} onClick={()=>setOffen(null)}>← Zur Liste</button>
          <div style={{fontSize:15,fontWeight:700,color:T.text,flex:1,minWidth:120}}>
            {eintrag.firma||eintrag.name||"Neuer Eintrag"}
          </div>
          <span style={{fontSize:11,padding:"3px 10px",borderRadius:12,
                        background:stat(eintrag.status).farbe+"22",color:stat(eintrag.status).farbe,fontWeight:600}}>
            {stat(eintrag.status).label}
          </span>
        </div>

        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"0 28px"}}>
          <div>
            <label style={LBL}>Unternehmen</label>
            <input style={{...FELD,marginBottom:12}} value={eintrag.firma||""} onChange={e=>aendern("firma",e.target.value)}/>
            <label style={LBL}>Ansprechpartner</label>
            <input style={{...FELD,marginBottom:12}} value={eintrag.name||""} onChange={e=>aendern("name",e.target.value)}/>
            <label style={LBL}>E-Mail</label>
            <div style={{display:"flex",gap:8,marginBottom:12}}>
              <input style={FELD} value={eintrag.email||""} onChange={e=>aendern("email",e.target.value)}
                onDoubleClick={()=>mailOeffnen(eintrag)}
                title="Doppelklick öffnet dein Mailprogramm"/>
              {eintrag.email&&(
                <button style={{...btn(T,"ghost",true),whiteSpace:"nowrap"}} onClick={()=>mailOeffnen(eintrag)}>
                  ✉️ Mail
                </button>
              )}
            </div>
            <label style={LBL}>Telefon</label>
            <input style={{...FELD,marginBottom:12}} value={eintrag.telefon||""} onChange={e=>aendern("telefon",e.target.value)}/>
            <label style={LBL}>Webseite</label>
            <input style={{...FELD,marginBottom:12}} value={eintrag.homepage||""} onChange={e=>aendern("homepage",e.target.value)}/>
          </div>
          <div>
            <label style={LBL}>Straße</label>
            <input style={{...FELD,marginBottom:12}} value={eintrag.strasse||""} onChange={e=>aendern("strasse",e.target.value)}/>
            <div style={{display:"grid",gridTemplateColumns:"110px 1fr",gap:10,marginBottom:12}}>
              <div>
                <label style={LBL}>PLZ</label>
                <input style={FELD} maxLength={5} placeholder="90429" value={eintrag.plz||""}
                  onChange={e=>{
                    const plz=e.target.value.replace(/[^0-9]/g,"");
                    aendern("plz",plz);
                    // Ort automatisch dazu. Nur setzen, wenn das Feld leer ist
                    // oder zur vorherigen PLZ gehoerte, damit ein von Hand
                    // eingetragener Ortsteil nicht ueberschrieben wird.
                    if(plz.length===5){
                      fetch(`https://api.zippopotam.us/de/${plz}`)
                        .then(r=>r.ok?r.json():null)
                        .then(d=>{
                          const o=d&&d.places&&d.places[0]&&d.places[0]["place name"];
                          if(o)sichern(zeilen.map(z=>z.id===eintrag.id?{...z,plz,ort:z.ort?z.ort:o,ortVorschlag:o}:z));
                        }).catch(()=>{});
                    }
                  }}/>
              </div>
              <div>
                <label style={LBL}>Ort</label>
                <input style={FELD} placeholder="Nürnberg" value={eintrag.ort||""} onChange={e=>aendern("ort",e.target.value)}/>
                {eintrag.ortVorschlag&&eintrag.ort&&eintrag.ort!==eintrag.ortVorschlag&&(
                  <div style={{fontSize:11,color:T.muted,marginTop:3}}>
                    Zur PLZ gehört{" "}
                    <span onClick={()=>aendern("ort",eintrag.ortVorschlag)}
                      style={{color:T.accent,cursor:"pointer",textDecoration:"underline"}}>{eintrag.ortVorschlag}</span>
                  </div>
                )}
              </div>
            </div>
            <label style={LBL}>Erstkontakt am</label>
            <input type="date" style={{...FELD,marginBottom:12}} value={eintrag.kontakt1||""} onChange={e=>aendern("kontakt1",e.target.value)}/>
            <label style={LBL}>Stand</label>
            <select style={{...FELD,marginBottom:12}} value={eintrag.status||"offen"} onChange={e=>aendern("status",e.target.value)}>
              {AKQ_STATUS.map(s=><option key={s.id} value={s.id}>{s.label}</option>)}
            </select>
          </div>
        </div>

        {spalten.length>0&&(
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"0 28px",marginTop:4}}>
            {spalten.map(sp=>(
              <div key={sp.id}>
                <label style={LBL}>{sp.titel}</label>
                <input style={{...FELD,marginBottom:12}} value={(eintrag.extra||{})[sp.id]||""}
                  onChange={e=>aendernExtra(sp.id,e.target.value)}/>
              </div>
            ))}
          </div>
        )}

        <label style={LBL}>Notizen</label>
        <textarea style={{...FELD,minHeight:110,resize:"vertical",lineHeight:1.6,fontFamily:"inherit"}}
          value={eintrag.notizen||""} onChange={e=>aendern("notizen",e.target.value)}/>

        {eintrag.uebernommen&&(
          <div style={{fontSize:12,color:T.success,marginTop:12}}>
            ✓ Am {new Date(eintrag.uebernommen).toLocaleDateString("de-DE")} in die Firmenkontakte übernommen
          </div>
        )}
        {meldung&&(
          <div style={{fontSize:12,color:T.success,marginTop:12,lineHeight:1.6}}>{meldung}</div>
        )}

        <div style={{display:"flex",gap:8,marginTop:18,flexWrap:"wrap"}}>
          <button style={btn(T,"primary",true)} onClick={()=>alsFirmenkontakt(eintrag)}>
            🏢 In Firmenkontakte übernehmen
          </button>
          <button style={btn(T,"ghost",true)}
            onClick={()=>{
              // Empfängerfelder der Mustertexte füllen, damit man direkt
              // schreiben kann, ohne alles erneut einzutippen.
              // Namen trennen, sonst stünde in der Anrede "Sehr geehrte Frau
              // Julia Ziegeltrum" statt nur des Nachnamens.
              const teile=(eintrag.name||"").trim().split(/\s+/).filter(Boolean);
              const e={firma:eintrag.firma||"",
                       vorname:teile.length>1?teile[0]:"",
                       nachname:teile.length?teile[teile.length-1]:"",
                       ort:eintrag.ort||"",email:eintrag.email||"",
                       branche:(eintrag.extra||{})[(spalten.find(s=>/branche/i.test(s.titel))||{}).id]||""};
              localStorage.setItem("sd_mustertexte_empfaenger",JSON.stringify(e));
              setMeldung("Übernommen. Oben unter „Mustertexte“ ist der Empfänger jetzt gefüllt.");
              setTimeout(()=>setMeldung(""),5000);
            }}>
            📝 Als Empfänger für Mustertexte
          </button>
          <button style={{...btn(T,"ghost",true),color:"#e55",borderColor:"#e5533"}}
            onClick={()=>{
              if(!window.confirm("Eintrag löschen?"))return;
              sichern(zeilen.filter(z=>z.id!==eintrag.id));setOffen(null);
            }}>Löschen</button>
        </div>
      </div>
    );
  }

  // ── Liste ──────────────────────────────────────────────────────────────────
  const TH={textAlign:"left",padding:"8px 10px",fontSize:11,fontWeight:700,color:T.muted,
            textTransform:"uppercase",letterSpacing:".05em",borderBottom:`1px solid ${T.border}`,whiteSpace:"nowrap"};
  const TD={padding:"9px 10px",fontSize:13,borderBottom:`1px solid ${T.border}44`,borderRight:`1px solid ${T.border}99`,verticalAlign:"top"};

  return(
    <div>
      <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:14,flexWrap:"wrap"}}>
        <button style={btn(T,"primary",true)} onClick={neu}>+ Unternehmen</button>
        <button style={btn(T,"ghost",true)} onClick={spalteNeu}>+ Spalte</button>
        <input style={{...IS,flex:1,minWidth:160}} placeholder="Suchen…" value={filter} onChange={e=>setFilter(e.target.value)}/>
        <span style={{fontSize:12,color:T.muted}}>{sichtbar.length} von {zeilen.length}</span>
      </div>
      {meldung&&<div style={{fontSize:12,color:T.success,marginBottom:12}}>{meldung}</div>}

      {zeilen.length===0?(
        <div style={{border:`1px dashed ${T.border}`,borderRadius:12,padding:"28px 20px",
                     textAlign:"center",color:T.muted,fontSize:13,lineHeight:1.7}}>
          Noch keine Unternehmen erfasst.<br/>
          Leg mit „+ Unternehmen“ den ersten Eintrag an.
        </div>
      ):(
        <div style={{overflowX:"auto",border:`1px solid ${T.border}`,borderRadius:12}}>
          <table style={{width:"100%",borderCollapse:"collapse",background:T.surface}}>
            <thead>
              <tr>
                <th style={TH}>Unternehmen</th>
                <th style={TH}>Ansprechpartner</th>
                <th style={TH}>Erstkontakt</th>
                <th style={TH}>Stand</th>
                {spalten.map(sp=>(
                  <th key={sp.id} style={TH}>
                    <span style={{cursor:"pointer"}} onClick={()=>spalteUm(sp)} title="Umbenennen">{sp.titel}</span>
                    <span onClick={()=>spalteWeg(sp)} title="Spalte entfernen"
                      style={{cursor:"pointer",color:"#e55",marginLeft:6,fontWeight:400}}>✕</span>
                  </th>
                ))}
                <th style={TH}></th>
              </tr>
            </thead>
            <tbody>
              {sichtbar.map(z=>(
                <tr key={z.id}>
                  <td style={{...TD,cursor:"pointer"}} onClick={()=>setOffen(z.id)}>
                    <span style={{fontWeight:700,color:T.accent,textDecoration:"underline"}}>
                      {z.firma||"(ohne Namen)"}
                    </span>
                    {z.ort&&<div style={{fontSize:11,color:T.muted}}>{z.ort}</div>}
                  </td>
                  <td style={TD}>
                    {z.name||"—"}
                    {z.email&&(
                      <div title="Doppelklick öffnet dein Mailprogramm"
                        onDoubleClick={()=>mailOeffnen(z)}
                        style={{fontSize:11,color:T.accent,cursor:"pointer",textDecoration:"underline"}}>
                        {z.email}
                      </div>
                    )}
                  </td>
                  <td style={TD}>{z.kontakt1?new Date(z.kontakt1).toLocaleDateString("de-DE"):"—"}</td>
                  <td style={TD}>
                    <span style={{fontSize:11,padding:"3px 9px",borderRadius:12,whiteSpace:"nowrap",
                                  background:stat(z.status).farbe+"22",color:stat(z.status).farbe,fontWeight:600}}>
                      {stat(z.status).label}
                    </span>
                  </td>
                  {spalten.map(sp=>(
                    <td key={sp.id} style={{...TD,color:T.muted}}>{(z.extra||{})[sp.id]||"—"}</td>
                  ))}
                  <td style={{...TD,textAlign:"right",whiteSpace:"nowrap"}}>
                    {z.uebernommen
                      ? <span title={"Übernommen am "+new Date(z.uebernommen).toLocaleDateString("de-DE")}
                          style={{fontSize:11,color:T.success}}>✓ Kontakt</span>
                      : <button style={{...btn(T,"ghost",true),fontSize:11}} onClick={()=>alsFirmenkontakt(z)}>🏢 Übernehmen</button>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      <div style={{fontSize:11,color:T.muted,marginTop:10,lineHeight:1.6}}>
        Auf den Firmennamen klicken öffnet den Eintrag. Spaltenüberschriften lassen sich
        anklicken zum Umbenennen, das ✕ daneben entfernt die Spalte.
      </div>
    </div>
  );
}

// ── Mustertexte (Akquise) ─────────────────────────────────────────────────────
// Textbausteine für die Kaltansprache von Firmenkunden. Die fertigen Texte
// gehen nicht über ScattoDesk raus, sondern werden kopiert und in Outlook
// eingefügt. Ablage im Browser unter sd_mustertexte.
const MT_KEY="sd_mustertexte";
const MT_EMPF_KEY="sd_mustertexte_empfaenger";

const MT_PLATZ=[
  ["firma","Firmenname"],
  ["anrede","Sehr geehrte Frau / Sehr geehrter Herr"],
  ["nachname","Nachname"],
  ["vorname","Vorname"],
  ["ort","Ort"],
  ["branche","Branche"],
  ["studio","Mein Studioname"],
  ["datum","Heutiges Datum"],
];

const MT_START=[
  {id:"mt1",titel:"Erstansprache Hundeladen",
   betreff:"Hundefotografie bei {{firma}} in {{ort}}?",
   text:"{{anrede}} {{nachname}},\n\nich bin Markus Heber und fotografiere Hunde. Mein Schwerpunkt sind Aufnahmen durch eine Glasplatte von unten, die Hunde wirken darauf sehr lebendig und die Bilder fallen auf.\n\nIch veranstalte Shootingtage direkt bei Partnern vor Ort. Für Sie bedeutet das: ein Tag mit zusätzlicher Frequenz im Laden, ohne Aufwand und ohne Kosten. Ich bringe die komplette Technik mit und brauche nur eine Ecke von etwa drei mal drei Metern.\n\nHätten Sie Interesse, das einmal in Ruhe zu besprechen? Ein kurzer Anruf genügt.\n\nHerzliche Grüße\nMarkus Heber"},
  {id:"mt2",titel:"Nachfassen nach 2 Wochen",
   betreff:"Kurz nachgefragt: Shootingtag bei {{firma}}",
   text:"{{anrede}} {{nachname}},\n\nvor zwei Wochen hatte ich Ihnen geschrieben, ob ein Hundeshooting-Tag bei {{firma}} für Sie interessant wäre. Vermutlich ist meine Mail im Tagesgeschäft untergegangen, das kenne ich gut.\n\nFalls das Thema grundsätzlich passt, melde ich mich gerne telefonisch. Und falls nicht, sagen Sie mir kurz Bescheid, dann lasse ich Sie in Ruhe.\n\nHerzliche Grüße\nMarkus Heber"},
  {id:"mt3",titel:"Nach Messekontakt",
   betreff:"Schön, Sie kennengelernt zu haben",
   text:"{{anrede}} {{nachname}},\n\nes hat mich gefreut, Sie auf der Messe zu treffen. Wie besprochen hier noch einmal in Kurzform, worum es geht.\n\nIch komme mit meinem Aufbau zu Ihnen, wir legen einen Termin fest, und Ihre Kunden können sich vor Ort spontan fotografieren lassen. Die Bilder bekommen sie digital, die Abwicklung übernehme komplett ich.\n\nSagen Sie mir einfach, welcher Zeitraum Ihnen passen würde.\n\nHerzliche Grüße\nMarkus Heber"},
];

function MtLadeVorlagen(){
  try{
    const v=JSON.parse(localStorage.getItem(MT_KEY)||"null");
    if(Array.isArray(v)&&v.length)return v;
  }catch(e){}
  return MT_START;
}

function MustertexteBlock({T,btn,IS}){
  const [bereich,setBereich]=useState(()=>localStorage.getItem("sd_mustertexte_bereich")||"texte");
  const bereichSetzen=w=>{setBereich(w);localStorage.setItem("sd_mustertexte_bereich",w);};
  const [liste,setListe]=useState(MtLadeVorlagen);
  const [offen,setOffen]=useState(null);        // id der geöffneten Kachel
  const [tab,setTab]=useState("fertig");        // "fertig" | "vorlage"
  const [kopiert,setKopiert]=useState("");
  const [empf,setEmpf]=useState(()=>{
    try{return JSON.parse(localStorage.getItem(MT_EMPF_KEY)||"null")||{};}catch(e){return {};}
  });

  const sichern=neu=>{setListe(neu);localStorage.setItem(MT_KEY,JSON.stringify(neu));};
  const empfSetzen=(k,v)=>{
    const neu={...empf,[k]:v};
    setEmpf(neu);
    localStorage.setItem(MT_EMPF_KEY,JSON.stringify(neu));
  };

  const aktuell=liste.find(x=>x.id===offen)||null;

  // Platzhalter ersetzen. Was nicht ausgefüllt ist, bleibt sichtbar stehen,
  // damit man den Text nicht mit einer Lücke verschickt.
  const fuellen=roh=>{
    const anrede=empf.geschlecht==="w"?"Sehr geehrte Frau"
                :empf.geschlecht==="m"?"Sehr geehrter Herr"
                :"Guten Tag";
    const werte={
      firma:empf.firma||"",anrede,
      nachname:empf.nachname||"",vorname:empf.vorname||"",
      ort:empf.ort||"",branche:empf.branche||"",
      studio:(()=>{try{return JSON.parse(localStorage.getItem("sd_buchung_config")||"{}").studioName||"Markus Heber Photography";}catch(e){return "Markus Heber Photography";}})(),
      datum:new Date().toLocaleDateString("de-DE"),
    };
    return String(roh||"").replace(/\{\{(\w+)\}\}/g,(m,k)=>{
      if(!(k in werte))return m;
      return werte[k]||("«"+k+"»");
    });
  };

  // Deine Mailsignatur aus den E-Mail-Einstellungen. Als reiner Text, denn
  // der fertige Text wird in Outlook eingefuegt und dort formatierst du selbst.
  const sigLogo=(()=>{
    try{
      const g=JSON.parse(localStorage.getItem("sd_email_sig")||"null")||{};
      return (typeof g.logo==="string"&&g.logo.startsWith("data:image"))?g.logo:"";
    }catch(e){return "";}
  })();
  const signatur=(()=>{
    try{
      const g=JSON.parse(localStorage.getItem("sd_email_sig")||"null")||{};
      return String(g.text||"")
        // Eingerueckte Zeilen gerade ziehen. In der HTML-Signatur richtet
        // das Leerzeichen nichts aus, im reinen Text schiebt es die Zeile
        // sichtbar nach rechts.
        .split("\n").map(z=>z.replace(/^[ \t\u00a0]+/,"").replace(/[ \t]+$/,"")).join("\n")
        // Geschriebene Links auflösen. Ist die Beschriftung nur die Adresse
        // ohne Vorspann, reicht die Adresse - sonst stünde dort zweimal
        // dasselbe hintereinander.
        .replace(/\[([^\]]+)\]\((https?:\/\/[^)\s]+)\)/g,(m,txt,url)=>{
          const nackt=url.replace(/^https?:\/\//,"").replace(/\/+$/,"");
          const t=String(txt).trim();
          return (t===nackt||t===url||nackt.endsWith(t)||t.endsWith(nackt))?nackt:(t+": "+url);
        })
        .replace(/\*\*(.+?)\*\*/g,"$1")
        .trim();
    }catch(e){return "";}
  })();
  const [mitSig,setMitSig]=useState(()=>localStorage.getItem("sd_mustertexte_sig")!=="0");
  const sigAn=w=>{setMitSig(w);localStorage.setItem("sd_mustertexte_sig",w?"1":"0");};
  const anhaengen=t=>(mitSig&&signatur)?(t.replace(/\s+$/,"")+"\n\n"+signatur):t;

  const fertigBetreff=aktuell?fuellen(aktuell.betreff):"";
  const rumpf=aktuell?fuellen(aktuell.text):"";
  const fertigText=aktuell?anhaengen(rumpf):"";
  const luecken=(fertigBetreff+fertigText).match(/«\w+»/g)||[];

  function kopiere(was,inhalt){
    const fertig=ok=>{setKopiert(ok?was:"fehler_"+was);setTimeout(()=>setKopiert(""),2500);};
    try{
      if(navigator.clipboard&&window.isSecureContext){
        navigator.clipboard.writeText(inhalt).then(()=>fertig(true),()=>fertig(false));
        return;
      }
    }catch(e){}
    try{
      const feld=document.getElementById("mt-kopierfeld");
      if(feld){feld.value=inhalt;feld.select();const ok=document.execCommand("copy");fertig(ok);return;}
    }catch(e){}
    fertig(false);
  }

  // Fuer das Logo reicht reiner Text nicht. Deshalb wird zusaetzlich eine
  // HTML-Fassung in die Zwischenablage gelegt. Outlook nimmt beim Einfuegen
  // die HTML-Fassung und behaelt damit das Bild.
  function alsHtml(){
    const esc=t=>String(t||"").replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;");
    let h='<div style="font-family:Calibri,Arial,sans-serif;font-size:11pt;line-height:1.5">'
          +esc(rumpf).replace(/\n/g,"<br>");
    if(mitSig&&(signatur||sigLogo)){
      h+='<br><br>';
      if(sigLogo)h+='<img src="'+sigLogo+'" alt="" style="max-height:70px;max-width:220px;display:block;margin-bottom:6px">';
      if(signatur)h+=esc(signatur).replace(/\n/g,"<br>");
    }
    return h+'</div>';
  }

  async function kopiereMitLogo(){
    const fertig=ok=>{setKopiert(ok?"html":"fehler_html");setTimeout(()=>setKopiert(""),2500);};
    try{
      if(navigator.clipboard&&window.ClipboardItem&&window.isSecureContext){
        await navigator.clipboard.write([new window.ClipboardItem({
          "text/html":new Blob([alsHtml()],{type:"text/html"}),
          "text/plain":new Blob([fertigText],{type:"text/plain"}),
        })]);
        fertig(true);return;
      }
    }catch(e){}
    // Rueckfallebene: sichtbaren HTML-Bereich markieren und kopieren
    try{
      const feld=document.getElementById("mt-htmlfeld");
      if(feld){
        feld.innerHTML=alsHtml();
        const r=document.createRange();r.selectNodeContents(feld);
        const sel=window.getSelection();sel.removeAllRanges();sel.addRange(r);
        const ok=document.execCommand("copy");
        sel.removeAllRanges();
        fertig(ok);return;
      }
    }catch(e){}
    fertig(false);
  }

  function inOutlook(){
    // mailto verträgt keine langen Texte zuverlässig. Ab etwa 1800 Zeichen
    // schneiden manche Programme ab, deshalb vorher warnen.
    const adr=(empf.email||"").trim();
    const url="mailto:"+encodeURIComponent(adr)
      +"?subject="+encodeURIComponent(fertigBetreff)
      +"&body="+encodeURIComponent(fertigText);
    if(url.length>1900&&!window.confirm(
      "Der Text ist lang. Manche Mailprogramme schneiden ihn beim Öffnen ab.\n\n"+
      "Sicherer: „Text kopieren“ und in Outlook einfügen.\n\nTrotzdem öffnen?"))return;
    window.location.href=url;
  }

  const neueVorlage=()=>{
    const id="mt"+Date.now();
    sichern([...liste,{id,titel:"Neue Vorlage",betreff:"",text:""}]);
    setOffen(id);setTab("vorlage");
  };
  const duplizieren=v=>{
    const id="mt"+Date.now();
    sichern([...liste,{...v,id,titel:v.titel+" (Kopie)"}]);
    setOffen(id);setTab("vorlage");
  };
  const loeschen=v=>{
    if(!window.confirm("Vorlage „"+v.titel+"“ löschen?"))return;
    sichern(liste.filter(x=>x.id!==v.id));
    setOffen(null);
  };
  const aendern=(feld,wert)=>sichern(liste.map(x=>x.id===offen?{...x,[feld]:wert}:x));

  const einfuegen=platz=>{
    const feld=document.getElementById("mt-text");
    if(!feld){aendern("text",(aktuell.text||"")+"{{"+platz+"}}");return;}
    const a=feld.selectionStart||0,b=feld.selectionEnd||0;
    const t=aktuell.text||"";
    aendern("text",t.slice(0,a)+"{{"+platz+"}}"+t.slice(b));
    setTimeout(()=>{feld.focus();feld.selectionStart=feld.selectionEnd=a+platz.length+4;},0);
  };

  // Ziehst du das Textfeld groesser, soll es das bleiben. Ein Textfeld
  // meldet die Groessenaenderung nicht von selbst, deshalb ein Beobachter.
  const [txtHoehe,setTxtHoehe]=useState(()=>{
    const h=parseInt(localStorage.getItem("sd_mustertexte_hoehe")||"",10);
    return (h>=120&&h<=1600)?h:320;
  });
  useEffect(()=>{
    if(tab!=="vorlage")return;
    const el=document.getElementById("mt-text");
    if(!el||typeof ResizeObserver==="undefined")return;
    const beo=new ResizeObserver(()=>{
      const h=el.offsetHeight;
      if(!h||h<120||h>1600)return;
      setTxtHoehe(alt=>{
        if(Math.abs(h-alt)<4)return alt;   // nichts tun, sonst Rueckkopplung
        localStorage.setItem("sd_mustertexte_hoehe",String(h));
        return h;
      });
    });
    beo.observe(el);
    return()=>beo.disconnect();
  },[tab,offen]);

  const FELD={...IS,width:"100%"};
  const LBL={fontSize:12,color:T.muted,fontWeight:600,display:"block",marginBottom:5};

  // Reiterleiste über beiden Ansichten
  const Reiter=(
    <div style={{display:"flex",gap:8,marginBottom:18,borderBottom:`1px solid ${T.border}`,paddingBottom:12}}>
      {[["texte","📝 Textbausteine"],["akquise","🏢 Akquise-Liste"]].map(([k,l])=>(
        <button key={k} onClick={()=>bereichSetzen(k)}
          style={{padding:"7px 16px",borderRadius:20,cursor:"pointer",fontFamily:"inherit",fontSize:13,
                  fontWeight:bereich===k?700:400,
                  border:`2px solid ${bereich===k?T.accent:T.border}`,
                  background:bereich===k?T.accent+"14":"transparent",
                  color:bereich===k?T.accent:T.muted}}>{l}</button>
      ))}
    </div>
  );

  if(bereich==="akquise"){
    return(<div>{Reiter}<AkquiseListe T={T} btn={btn} IS={IS}/></div>);
  }

  // ── Kachelübersicht ────────────────────────────────────────────────────────
  if(!aktuell){
    return(
      <div>
        <textarea id="mt-kopierfeld" readOnly style={{position:"absolute",left:-9999,top:0,width:1,height:1,opacity:0}}/>
        {Reiter}
        <div style={{fontSize:12,color:T.muted,lineHeight:1.7,marginBottom:18}}>
          Textbausteine für die Ansprache neuer Firmenkunden. Du wählst eine Vorlage,
          trägst die Firma ein und kopierst den fertigen Text nach Outlook.
          Verschickt wird hier nichts.
        </div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(230px,1fr))",gap:12}}>
          {liste.map(v=>(
            <div key={v.id} onClick={()=>{setOffen(v.id);setTab("fertig");}}
              style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:12,
                      padding:16,cursor:"pointer",transition:"border-color .15s"}}
              onMouseEnter={e=>e.currentTarget.style.borderColor=T.accent}
              onMouseLeave={e=>e.currentTarget.style.borderColor=T.border}>
              <div style={{fontSize:14,fontWeight:700,color:T.text,marginBottom:6,lineHeight:1.3}}>{v.titel}</div>
              <div style={{fontSize:11,color:T.accent,marginBottom:8,lineHeight:1.4}}>{v.betreff||"— kein Betreff —"}</div>
              <div style={{fontSize:11,color:T.muted,lineHeight:1.5,
                           display:"-webkit-box",WebkitLineClamp:3,WebkitBoxOrient:"vertical",overflow:"hidden"}}>
                {(v.text||"").replace(/\{\{\w+\}\}/g,"…")}
              </div>
            </div>
          ))}
          <div onClick={neueVorlage}
            style={{border:`1px dashed ${T.border}`,borderRadius:12,padding:16,cursor:"pointer",
                    display:"flex",alignItems:"center",justifyContent:"center",
                    color:T.muted,fontSize:13,minHeight:110}}>
            + Neue Vorlage
          </div>
        </div>
      </div>
    );
  }

  // ── Einzelne Vorlage ───────────────────────────────────────────────────────
  return(
    <div>
      <textarea id="mt-kopierfeld" readOnly style={{position:"absolute",left:-9999,top:0,width:1,height:1,opacity:0}}/>
      <div id="mt-htmlfeld" style={{position:"absolute",left:-9999,top:0,width:600,opacity:0}} aria-hidden="true"/>
      <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:16,flexWrap:"wrap"}}>
        <button style={btn(T,"ghost",true)} onClick={()=>setOffen(null)}>← Alle Vorlagen</button>
        <div style={{fontSize:15,fontWeight:700,color:T.text,flex:1,minWidth:120}}>{aktuell.titel}</div>
        <button style={btn(T,tab==="fertig"?"primary":"ghost",true)} onClick={()=>setTab("fertig")}>Text erzeugen</button>
        <button style={btn(T,tab==="vorlage"?"primary":"ghost",true)} onClick={()=>setTab("vorlage")}>Vorlage bearbeiten</button>
      </div>

      {tab==="fertig"?(
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:20,alignItems:"start"}}>
          <div style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:12,padding:16}}>
            <div style={{fontSize:11,fontWeight:700,color:T.muted,textTransform:"uppercase",letterSpacing:".06em",marginBottom:12}}>Empfänger</div>
            <label style={LBL}>Firma</label>
            <input style={FELD} value={empf.firma||""} onChange={e=>empfSetzen("firma",e.target.value)} placeholder="Pfötchen Hundebedarf"/>
            <label style={{...LBL,marginTop:10}}>Anrede</label>
            <select style={FELD} value={empf.geschlecht||""} onChange={e=>empfSetzen("geschlecht",e.target.value)}>
              <option value="">Guten Tag (neutral)</option>
              <option value="w">Sehr geehrte Frau</option>
              <option value="m">Sehr geehrter Herr</option>
            </select>
            <label style={{...LBL,marginTop:10}}>Nachname</label>
            <input style={FELD} value={empf.nachname||""} onChange={e=>empfSetzen("nachname",e.target.value)} placeholder="Ziegeltrum"/>
            <label style={{...LBL,marginTop:10}}>Vorname</label>
            <input style={FELD} value={empf.vorname||""} onChange={e=>empfSetzen("vorname",e.target.value)} placeholder="Julia"/>
            <label style={{...LBL,marginTop:10}}>Ort</label>
            <input style={FELD} value={empf.ort||""} onChange={e=>empfSetzen("ort",e.target.value)} placeholder="München"/>
            <label style={{...LBL,marginTop:10}}>Branche</label>
            <input style={FELD} value={empf.branche||""} onChange={e=>empfSetzen("branche",e.target.value)} placeholder="Hundebedarf"/>
            <label style={{...LBL,marginTop:10}}>E-Mail (nur für Outlook)</label>
            <input style={FELD} value={empf.email||""} onChange={e=>empfSetzen("email",e.target.value)} placeholder="info@firma.de"/>
            <label style={{display:"flex",alignItems:"center",gap:8,marginTop:14,cursor:"pointer",fontSize:12,color:T.text}}>
              <input type="checkbox" checked={mitSig} onChange={e=>sigAn(e.target.checked)} style={{width:16,height:16}}/>
              <span>Signatur anhängen</span>
            </label>
            {mitSig&&!signatur&&(
              <div style={{fontSize:11,color:T.warning,marginTop:6,lineHeight:1.5}}>
                Unter Einstellungen → E-Mail &amp; Vorlagen ist noch keine Signatur hinterlegt.
              </div>
            )}
            <button style={{...btn(T,"ghost",true),marginTop:12,width:"100%"}}
              onClick={()=>{setEmpf({});localStorage.setItem(MT_EMPF_KEY,"{}");}}>Felder leeren</button>
          </div>

          <div>
            <label style={LBL}>Betreff</label>
            <div style={{display:"flex",gap:8,marginBottom:14}}>
              <input readOnly value={fertigBetreff} onFocus={e=>e.target.select()}
                style={{...FELD,background:T.bg}}/>
              <button style={btn(T,"ghost",true)} onClick={()=>kopiere("betreff",fertigBetreff)}>
                {kopiert==="betreff"?"✓":kopiert==="fehler_betreff"?"✕":"Kopieren"}
              </button>
            </div>
            <label style={LBL}>Text</label>
            <textarea readOnly value={fertigText} onFocus={e=>e.target.select()}
              style={{...FELD,minHeight:300,resize:"vertical",lineHeight:1.7,background:T.bg,
                      fontFamily:"inherit",fontSize:13}}/>
            {luecken.length>0&&(
              <div style={{fontSize:12,color:T.warning,marginTop:8,lineHeight:1.6}}>
                Noch nicht ausgefüllt: {[...new Set(luecken)].join(", ")}. Die Stellen sind im Text
                mit spitzen Klammern markiert, damit sie nicht versehentlich mit rausgehen.
              </div>
            )}
            <div style={{display:"flex",gap:8,marginTop:12,flexWrap:"wrap"}}>
              <button style={btn(T,"primary",true)} onClick={()=>kopiere("text",fertigText)}>
                {kopiert==="text"?"✓ Kopiert":kopiert==="fehler_text"?"Bitte von Hand markieren":"Text kopieren"}
              </button>
              <button style={btn(T,"ghost",true)}
                onClick={()=>kopiere("beides",fertigBetreff+"\n\n"+fertigText)}>
                {kopiert==="beides"?"✓ Kopiert":"Betreff + Text kopieren"}
              </button>
              {(sigLogo&&mitSig)&&(
                <button style={btn(T,"ghost",true)} onClick={kopiereMitLogo}>
                  {kopiert==="html"?"✓ Mit Logo kopiert":kopiert==="fehler_html"?"Hat nicht geklappt":"Mit Logo kopieren"}
                </button>
              )}
              <button style={btn(T,"ghost",true)} onClick={inOutlook}>In Outlook öffnen</button>
            </div>
            {kopiert.startsWith("fehler_")&&(
              <div style={{fontSize:12,color:T.danger,marginTop:8,lineHeight:1.6}}>
                Der Browser hat das Kopieren nicht zugelassen. Klick ins Textfeld, dann Strg+A und Strg+C.
              </div>
            )}
          </div>
        </div>
      ):(
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:20,alignItems:"start"}}>
          <div>
          <label style={LBL}>Bezeichnung der Vorlage</label>
          <input style={{...FELD,marginBottom:14}} value={aktuell.titel} onChange={e=>aendern("titel",e.target.value)}/>
          <label style={LBL}>Betreff</label>
          <input style={{...FELD,marginBottom:14}} value={aktuell.betreff} onChange={e=>aendern("betreff",e.target.value)}/>
          <label style={LBL}>Text</label>
          <div style={{display:"flex",gap:6,flexWrap:"wrap",marginBottom:8}}>
            {MT_PLATZ.map(([k,l])=>(
              <button key={k} title={l} onMouseDown={e=>e.preventDefault()} onClick={()=>einfuegen(k)}
                style={{...btn(T,"ghost",true),fontSize:11}}>{"{{"+k+"}}"}</button>
            ))}
          </div>
          <textarea id="mt-text" style={{...FELD,boxSizing:"border-box",height:txtHoehe,minHeight:120,resize:"vertical",lineHeight:1.7,fontFamily:"inherit",fontSize:13}}
            value={aktuell.text} onChange={e=>aendern("text",e.target.value)}/>
          <div style={{fontSize:11,color:T.muted,marginTop:6,lineHeight:1.6}}>
            Die Platzhalter werden erst unter „Text erzeugen“ ersetzt. Änderungen werden sofort gespeichert.
          </div>
          <div style={{display:"flex",gap:8,marginTop:14}}>
            <button style={btn(T,"ghost",true)} onClick={()=>duplizieren(aktuell)}>Duplizieren</button>
            <button style={{...btn(T,"ghost",true),color:"#e55",borderColor:"#e5533"}} onClick={()=>loeschen(aktuell)}>Löschen</button>
          </div>
          </div>

          {/* Vorschau: zeigt beim Tippen mit, wie die Mail beim Empfänger ankommt */}
          <div style={{position:"sticky",top:12}}>
            <div style={{fontSize:11,fontWeight:700,color:T.muted,textTransform:"uppercase",letterSpacing:".06em",marginBottom:8}}>Vorschau</div>
            <div style={{background:"#fff",border:`1px solid ${T.border}`,borderRadius:12,overflow:"hidden"}}>
              <div style={{background:T.bg,padding:"10px 14px",borderBottom:`1px solid ${T.border}`}}>
                <div style={{fontSize:10,color:T.muted,marginBottom:2}}>Betreff</div>
                <div style={{fontSize:13,fontWeight:600,color:"#1a1814",lineHeight:1.4}}>
                  {fertigBetreff||<span style={{color:T.muted,fontWeight:400}}>— kein Betreff —</span>}
                </div>
              </div>
              <div style={{padding:"14px 16px",fontSize:13,lineHeight:1.7,color:"#1a1814",
                           whiteSpace:"pre-wrap",maxHeight:txtHoehe+120,overflowY:"auto",
                           fontFamily:"Georgia,serif"}}>
                {fertigText||<span style={{color:T.muted}}>— noch kein Text —</span>}
              </div>
            </div>
            <div style={{fontSize:11,color:T.muted,marginTop:8,lineHeight:1.6}}>
              Mit den Empfängerdaten aus „Text erzeugen“. Fehlende Angaben stehen als «feld» drin.
            </div>
            {luecken.length>0&&(
              <div style={{fontSize:11,color:T.warning,marginTop:6,lineHeight:1.6}}>
                Offen: {[...new Set(luecken)].join(", ")}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

function EinstellungenPage({T, dark, setDark, setPage}){
  // Anzeigegroesse: geraetebezogen, deshalb nur im localStorage und nicht
  // im Server-Sync. Angewendet wird sie zentral in der App (siehe sd_ui_scale).
  const [uiScale,setUiScaleRaw]=useState(()=>Number(localStorage.getItem("sd_ui_scale"))||100);
  function setUiScale(v){
    setUiScaleRaw(v);
    localStorage.setItem("sd_ui_scale",String(v));
    window.dispatchEvent(new CustomEvent("sd-ui-scale",{detail:v}));
  }
  const [serverUrl,setServerUrl]=useState(()=>localStorage.getItem("sd_server_url")||"http://167.233.88.11");
  const smtpKey="sd_smtp_settings";
  const [smtp,setSmtp]=useState(()=>{try{return JSON.parse(localStorage.getItem(smtpKey)||"{}")}catch{return {};}});
  function saveSmtp(k,v){const u={...smtp,[k]:v};setSmtp(u);localStorage.setItem(smtpKey,JSON.stringify(u));}
  const [s,setS]=useState(()=>{
    try{return JSON.parse(localStorage.getItem("sd_api_settings")||"{}");}catch{return {};}
  });
  useEffect(()=>{localStorage.setItem("sd_api_settings",JSON.stringify(s));},[s]);
  const up=(k,v)=>setS(p=>({...p,[k]:v}));
  const IS={background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:"9px 12px",color:T.text,fontSize:13,fontFamily:"inherit",outline:"none",boxSizing:"border-box",width:"100%"};
  const subFolders=Array.isArray(s.subFolders)?s.subFolders:["Shootingvereinbarungen","Rechnungen","Bilder"];
  const [neuOrdner,setNeuOrdner]=useState("");

  function addFolder(){
    const n=neuOrdner.trim();
    if(!n)return;
    if(subFolders.includes(n)){alert("Ordner existiert bereits.");return;}
    up("subFolders",[...subFolders,n]);
    setNeuOrdner("");
  }
  function removeFolder(name){
    up("subFolders",subFolders.filter(f=>f!==name));
  }

  const [pdf,setPdf]=useState(()=>{try{return JSON.parse(localStorage.getItem("sd_pdf_settings")||"{}");}catch{return {};}});
  function savePdf(k,v){const u={...pdf,[k]:v};setPdf(u);localStorage.setItem("sd_pdf_settings",JSON.stringify(u));}

  const [sh,setSh]=useState(()=>{try{return JSON.parse(localStorage.getItem("sd_studio_header")||"null")||{};}catch{return {};}});
  function saveSh(k,v){const u={...sh,[k]:v};setSh(u);localStorage.setItem("sd_studio_header",JSON.stringify(u));}
  // Karten per Maus anordnen (Reihenfolge wird gespeichert)
  const [cardOrder,setCardOrder]=useState(()=>{
    try{const o=JSON.parse(localStorage.getItem("sd_einst_order")||"null");
      if(Array.isArray(o)&&o.length>=5)return o.includes("backup")?o.includes("buchungspdf")?o:[...o.filter(x=>x!=="backup"),"buchungspdf","backup"]:[...o,"buchungspdf","backup"];}catch{}
    return ["sevdesk","telegram","speicher","server","smtp","buchungspdf","backup"];
  });
  useEffect(()=>{localStorage.setItem("sd_einst_order",JSON.stringify(cardOrder));},[cardOrder]);
  function moveCard(id,dir){
    setCardOrder(prev=>{
      const a=[...prev];const i=a.indexOf(id);const j=i+dir;
      if(i<0||j<0||j>=a.length)return prev;
      [a[i],a[j]]=[a[j],a[i]];return a;
    });
  }
  const moveCtrl={position:"absolute",top:8,right:10,display:"flex",gap:4,zIndex:3};
  const moveBtn={cursor:"pointer",border:`1px solid ${T.border}`,background:T.bg,color:T.accent,borderRadius:6,width:26,height:24,fontSize:13,lineHeight:1,padding:0,fontFamily:"inherit"};

  const Card=(props)=><EinstellungenCard T={T} {...props}/>;

  const [vereinbarungText,setVereinbarungText]=useState(()=>localStorage.getItem("sd_vereinbarung_text")||DEFAULT_VEREINBARUNG);
  function saveVereinbarung(v){setVereinbarungText(v);try{localStorage.setItem("sd_vereinbarung_text",v);}catch{}}

  const cardEls={
    mustertexte:(<MustertexteBlock T={T} btn={btn} IS={IS}/>),
    sevdesk:(<>
      {/* sevDesk */}
      <Card title="sevDesk" icon="building">
        <label style={{fontSize:12,color:T.muted,fontWeight:600,display:"block",marginBottom:5}}>API Token (Buchhaltung Pro)</label>
        <input value={s.sevdesk_token||""} onChange={e=>up("sevdesk_token",e.target.value.trim())} type="password" style={IS}/>
        <div style={{fontSize:11,color:T.muted,marginTop:6}}>sevDesk → Mein Konto → Benutzer → API-Token</div>
      </Card>
      </>),
    telegram:(<><TelegramKarte T={T} s={s} up={up} btn={btn} IS={IS}/></>),
    whatsapp:(()=>{
      const twKey="sd_twilio_settings";
      const DEFAULT_TW_TEXT="Hallo {vorname},\n\nErinnerung an Ihren Termin morgen!\n📅 {datum}\n🕐 {uhrzeit}\n📍 {ort}\n🎯 {event}\n\nBis bald!\nMarkus Heber Photography";
      const DEFAULT_SMS_TEXT="Hallo {vorname}, Erinnerung: Termin morgen {datum} um {uhrzeit} Uhr, {ort}. Markus Heber Photography";
      const [tw,setTw]=useState(()=>{try{return JSON.parse(localStorage.getItem(twKey)||"null")||{sid:"",token:"",from:"whatsapp:+14155238886",sms_from:"",aktiv:false,sms_aktiv:false,erinnerung_h:24,test_to:"+491718199782",text:DEFAULT_TW_TEXT,sms_text:DEFAULT_SMS_TEXT,cron_aktiv:false,cron_zeit:"09:00"};}catch{return {sid:"",token:"",from:"whatsapp:+14155238886",sms_from:"",aktiv:false,sms_aktiv:false,erinnerung_h:24,test_to:"+491718199782",text:DEFAULT_TW_TEXT,sms_text:DEFAULT_SMS_TEXT,cron_aktiv:false,cron_zeit:"09:00"};}});
      const waRef=useRef(null);
      const smsRef=useRef(null);
      // Textarea-Höhe wiederherstellen
      useEffect(()=>{
        const wh=localStorage.getItem("sd_twilio_wa_h");
        const sh=localStorage.getItem("sd_twilio_sms_h");
        if(waRef.current&&wh)waRef.current.style.height=wh;
        if(smsRef.current&&sh)smsRef.current.style.height=sh;
      },[]);
      function onWaResize(){if(waRef.current)localStorage.setItem("sd_twilio_wa_h",waRef.current.style.height);}
      function onSmsResize(){if(smsRef.current)localStorage.setItem("sd_twilio_sms_h",smsRef.current.style.height);}
      function insertPlaceholder(ref,ph){
        const el=ref.current;
        if(!el)return;
        const start=el.selectionStart,end=el.selectionEnd;
        const val=el.value;
        const newVal=val.slice(0,start)+ph+val.slice(end);
        el.value=newVal;
        el.selectionStart=el.selectionEnd=start+ph.length;
        el.focus();
        // Kein saveTw hier - verhindert Re-render und Textarea-Reset
      }
      const PLACEHOLDERS=["{vorname}","{name}","{datum}","{uhrzeit}","{ort}","{event}"];
      function previewText(tpl){
        return(tpl||"")
          .replace("{vorname}","Anna")
          .replace("{name}","Anna Müller")
          .replace("{datum}","Samstag, 04. Juli 2026")
          .replace("{uhrzeit}","11:00")
          .replace("{ort}","Studio Nürnberg")
          .replace("{event}","Pfötchen Underglass");
      }
      function saveTw(u){setTw(u);localStorage.setItem(twKey,JSON.stringify(u));}
      const srvUrl=(localStorage.getItem("sd_server_url")||"").trim().replace(/\/+$/,"");
      function syncData(){
        try{
          const b=JSON.parse(localStorage.getItem("sd_bookings")||"[]");
          const c=JSON.parse(localStorage.getItem("sd_customers")||"[]");
          // WICHTIG: key und data muessen einzeln gesendet werden.
          // Frueher ging hier {bookings,customers} ohne key raus - der Server
          // hat das dann als sd_bookings abgelegt und die Einzeltermine zerstoert.
          fetch(`${srvUrl}/api/sync-data`,{method:"POST",headers:{"Content-Type":"application/json"},
            body:JSON.stringify({key:"sd_bookings",data:b})}).catch(()=>{});
          fetch(`${srvUrl}/api/sync-data`,{method:"POST",headers:{"Content-Type":"application/json"},
            body:JSON.stringify({key:"sd_customers",data:c})}).catch(()=>{});
        }catch{}
      }
      function toggle(){saveTw({...tw,aktiv:!tw.aktiv});}
      return(
        <Card title="WhatsApp Erinnerungen (Twilio)" icon="chat">
          <div style={{display:"flex",flexDirection:"column",gap:14}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"10px 14px",background:T.bg,borderRadius:8,border:`1px solid ${T.border}`}}>
              <div>
                <div style={{fontSize:13,fontWeight:700,color:T.text}}>💬 Automatische Erinnerungen</div>
                <div style={{fontSize:11,color:T.muted,marginTop:2}}>WA-Erinnerung automatisch X Stunden vor Termin</div>
              </div>
              <div onClick={toggle} style={{width:44,height:24,borderRadius:12,background:tw.aktiv?"#4caf50":T.border,position:"relative",cursor:"pointer",transition:"background 0.2s",flexShrink:0}}>
                <div style={{position:"absolute",top:3,left:tw.aktiv?21:3,width:18,height:18,borderRadius:"50%",background:"#fff",transition:"left 0.2s",boxShadow:"0 1px 3px rgba(0,0,0,0.3)"}}/>
              </div>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
              <div>
                <label style={{fontSize:12,color:T.muted,fontWeight:600,display:"block",marginBottom:4}}>Account SID</label>
                <input value={tw.sid} onChange={e=>saveTw({...tw,sid:e.target.value.trim()})} type="password"
                  placeholder="ACxxxxxxxxxxxxxxx" style={{...IS,fontFamily:"monospace",fontSize:11}}/>
              </div>
              <div>
                <label style={{fontSize:12,color:T.muted,fontWeight:600,display:"block",marginBottom:4}}>Auth Token</label>
                <input value={tw.token} onChange={e=>saveTw({...tw,token:e.target.value.trim()})} type="password"
                  placeholder="xxxxxxxxxxxxxxxx" style={{...IS,fontFamily:"monospace",fontSize:11}}/>
              </div>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"2fr 1fr",gap:10}}>
              <div>
                <label style={{fontSize:12,color:T.muted,fontWeight:600,display:"block",marginBottom:4}}>Absender-Nummer</label>
                <input value={tw.from} onChange={e=>saveTw({...tw,from:e.target.value.trim()})}
                  placeholder="whatsapp:+14155238886" style={{...IS,fontFamily:"monospace",fontSize:11}}/>
                <div style={{fontSize:10,color:T.muted,marginTop:3}}>Twilio Sandbox: whatsapp:+14155238886</div>
              </div>
              <div>
                <label style={{fontSize:12,color:T.muted,fontWeight:600,display:"block",marginBottom:4}}>Stunden vorher</label>
                <input type="number" min={1} max={72} value={tw.erinnerung_h} onChange={e=>saveTw({...tw,erinnerung_h:Number(e.target.value)})}
                  style={{...IS}}/>
              </div>
            </div>
            <div>
              <label style={{fontSize:12,color:T.muted,fontWeight:600,display:"block",marginBottom:4}}>Meine Test-Nummer</label>
              <input value={tw.test_to} onChange={e=>saveTw({...tw,test_to:e.target.value.trim()})}
                placeholder="+491718199782" style={{...IS,fontFamily:"monospace",fontSize:11}}/>
              <div style={{fontSize:10,color:T.muted,marginTop:3}}>An diese Nummer wird die Test-Nachricht gesendet</div>
            </div>
            <div style={{fontSize:11,color:T.muted}}>Twilio Console → Account Dashboard → Account SID & Auth Token</div>
            <div>
              <label style={{fontSize:12,color:T.muted,fontWeight:600,display:"block",marginBottom:4}}>Nachrichtentext</label>
              <textarea ref={waRef} defaultValue={tw.text||DEFAULT_TW_TEXT}
                onBlur={e=>saveTw({...tw,text:e.target.value})}
                onMouseUp={onWaResize}
                style={{...IS,minHeight:100,resize:"vertical",fontFamily:"inherit",lineHeight:1.5,fontSize:12}}/>
              <div style={{display:"flex",flexWrap:"wrap",gap:4,marginTop:4}}>
                {PLACEHOLDERS.map(ph=>(
                  <span key={ph} onClick={()=>insertPlaceholder(waRef,ph)}
                    style={{fontSize:10,padding:"2px 7px",borderRadius:4,background:T.bg,border:`1px solid ${T.border}`,
                      color:T.accent,cursor:"pointer",fontFamily:"monospace"}}>
                    {ph}
                  </span>
                ))}
              </div>
            </div>
            {/* SMS */}
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"10px 14px",background:T.bg,borderRadius:8,border:`1px solid ${T.border}`}}>
              <div>
                <div style={{fontSize:13,fontWeight:700,color:T.text}}>📱 SMS-Erinnerungen</div>
                <div style={{fontSize:11,color:T.muted,marginTop:2}}>Für Kunden ohne WhatsApp (selbe Twilio-Zugangsdaten)</div>
              </div>
              <div onClick={()=>saveTw({...tw,sms_aktiv:!tw.sms_aktiv})}
                style={{width:44,height:24,borderRadius:12,background:tw.sms_aktiv?"#4caf50":T.border,position:"relative",cursor:"pointer",transition:"background 0.2s",flexShrink:0}}>
                <div style={{position:"absolute",top:3,left:tw.sms_aktiv?21:3,width:18,height:18,borderRadius:"50%",background:"#fff",transition:"left 0.2s",boxShadow:"0 1px 3px rgba(0,0,0,0.3)"}}/>
              </div>
            </div>
            {tw.sms_aktiv&&(<>
              <div>
                <label style={{fontSize:12,color:T.muted,fontWeight:600,display:"block",marginBottom:4}}>SMS Absender-Nummer</label>
                <input value={tw.sms_from||""} onChange={e=>saveTw({...tw,sms_from:e.target.value.trim()})}
                  placeholder="+14155238886" style={{...IS,fontFamily:"monospace",fontSize:11}}/>
                <div style={{fontSize:10,color:T.muted,marginTop:3}}>Twilio SMS-Nummer (ohne whatsapp: Prefix)</div>
              </div>
              <div>
                <label style={{fontSize:12,color:T.muted,fontWeight:600,display:"block",marginBottom:4}}>SMS-Text</label>
                <textarea ref={smsRef} defaultValue={tw.sms_text||DEFAULT_SMS_TEXT}
                  onBlur={e=>saveTw({...tw,sms_text:e.target.value})}
                  onMouseUp={onSmsResize}
                  style={{...IS,minHeight:70,resize:"vertical",fontFamily:"inherit",lineHeight:1.5,fontSize:12}}/>
                <div style={{display:"flex",flexWrap:"wrap",gap:4,marginTop:4}}>
                  {PLACEHOLDERS.map(ph=>(
                    <span key={ph} onClick={()=>insertPlaceholder(smsRef,ph)}
                      style={{fontSize:10,padding:"2px 7px",borderRadius:4,background:T.bg,border:`1px solid ${T.border}`,
                        color:T.accent,cursor:"pointer",fontFamily:"monospace"}}>
                      {ph}
                    </span>
                  ))}
                </div>
              </div>
              <button style={{...btn(T,"ghost",true),alignSelf:"flex-start"}} onClick={async()=>{
                if(!tw.sid||!tw.token){alert("Bitte Zugangsdaten eintragen.");return;}
                try{
                  const r=await fetch(`${srvUrl}/api/wa-send`,{method:"POST",headers:{"Content-Type":"application/json"},
                    body:JSON.stringify({sid:tw.sid,token:tw.token,from:tw.sms_from||"",to:tw.test_to||"",text:"✅ ScattoDesk SMS-Test erfolgreich!",sms:true})});
                  const d=await r.json();
                  if(d.ok)alert("✅ SMS-Test gesendet!");
                  else alert("❌ "+JSON.stringify(d.error));
                }catch(e){alert("❌ "+e.message);}
              }}>📱 SMS-Test senden</button>
            </>)}
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:16}}>
            <div style={{background:T.bg,borderRadius:10,border:`1px solid ${T.border}`,padding:14}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10}}>
                <div>
                  <div style={{fontSize:13,fontWeight:700,color:T.text}}>⏰ Erinnerung 1 — Vorabend</div>
                  <div style={{fontSize:11,color:T.muted,marginTop:2}}>Ausführliche Erinnerung X Stunden vor dem Termin</div>
                </div>
                <div onClick={()=>saveTw({...tw,cron_aktiv:!tw.cron_aktiv})} style={{width:44,height:24,borderRadius:12,background:tw.cron_aktiv?"#4caf50":T.border,position:"relative",cursor:"pointer",transition:"background 0.2s",flexShrink:0}}>
                  <div style={{position:"absolute",top:3,left:tw.cron_aktiv?21:3,width:18,height:18,borderRadius:"50%",background:"#fff",transition:"left 0.2s",boxShadow:"0 1px 3px rgba(0,0,0,0.3)"}}/>
                </div>
              </div>
              {tw.cron_aktiv&&(<>
                <div>
                  <label style={{fontSize:11,color:T.muted,fontWeight:600,display:"block",marginBottom:3}}>Text</label>
                  <textarea ref={waRef} defaultValue={tw.text||DEFAULT_TW_TEXT} onBlur={e=>saveTw({...tw,text:e.target.value})} onMouseUp={onWaResize} style={{...IS,minHeight:80,resize:"vertical",fontFamily:"inherit",lineHeight:1.5,fontSize:12}}/>
                  <div style={{display:"flex",flexWrap:"wrap",gap:4,marginTop:4}}>{PLACEHOLDERS.map(ph=>(<span key={ph} onClick={()=>insertPlaceholder(waRef,ph)} style={{fontSize:10,padding:"2px 7px",borderRadius:4,background:T.surface,border:`1px solid ${T.border}`,color:T.accent,cursor:"pointer",fontFamily:"monospace"}}>{ph}</span>))}</div>
                </div>
                <div style={{marginTop:8}}>
                  <label style={{fontSize:11,color:T.muted,fontWeight:600,display:"block",marginBottom:3}}>Stunden vorher</label>
                  <input type="number" min={1} max={72} value={tw.erinnerung_h||24} onChange={e=>saveTw({...tw,erinnerung_h:Number(e.target.value)})} style={{...IS,marginBottom:8}}/>
                  <button style={{...btn(T,"primary",true),width:"100%",fontSize:12}} onClick={async()=>{
                    if(!tw.sid||!tw.token){alert("Bitte Zugangsdaten eintragen.");return;}
                    try{syncData();const r=await fetch(`${srvUrl}/api/wa-cron`,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({sid:tw.sid,token:tw.token,from:tw.from,erinnerung_h:tw.erinnerung_h||24,aktiv:true,erinnerung2_aktiv:tw.cron2_aktiv||false,erinnerung2_h:tw.erinnerung2_h||3})});const d=await r.json();if(d.ok)alert("✅ Gespeichert!"); else alert("❌ "+JSON.stringify(d.error));}catch(e){alert("❌ "+e.message);}
                  }}>💾 Speichern</button>
                </div>
              </>)}
            </div>
            <div style={{background:T.bg,borderRadius:10,border:`1px solid ${T.border}`,padding:14}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10}}>
                <div>
                  <div style={{fontSize:13,fontWeight:700,color:T.text}}>⚡ Erinnerung 2 — Gleicher Tag</div>
                  <div style={{fontSize:11,color:T.muted,marginTop:2}}>Kurze Info X Stunden vor dem Termin</div>
                </div>
                <div onClick={()=>saveTw({...tw,cron2_aktiv:!tw.cron2_aktiv})} style={{width:44,height:24,borderRadius:12,background:tw.cron2_aktiv?"#4caf50":T.border,position:"relative",cursor:"pointer",transition:"background 0.2s",flexShrink:0}}>
                  <div style={{position:"absolute",top:3,left:tw.cron2_aktiv?21:3,width:18,height:18,borderRadius:"50%",background:"#fff",transition:"left 0.2s",boxShadow:"0 1px 3px rgba(0,0,0,0.3)"}}/>
                </div>
              </div>
              {tw.cron2_aktiv&&(<>
                <div>
                  <label style={{fontSize:11,color:T.muted,fontWeight:600,display:"block",marginBottom:3}}>Text</label>
                  <textarea value={tw.text2||"Hallo {vorname}, kurze Erinnerung: Ihr Termin heute um {uhrzeit} Uhr. Wir freuen uns auf Sie! 📷 Markus Heber Photography"} onChange={e=>saveTw({...tw,text2:e.target.value})} style={{...IS,minHeight:80,resize:"vertical",fontFamily:"inherit",lineHeight:1.5,fontSize:12}}/>
                  <div style={{display:"flex",flexWrap:"wrap",gap:4,marginTop:4}}>{PLACEHOLDERS.map(ph=>(<span key={ph} onClick={()=>saveTw({...tw,text2:(tw.text2||"")+ph})} style={{fontSize:10,padding:"2px 7px",borderRadius:4,background:T.surface,border:`1px solid ${T.border}`,color:T.accent,cursor:"pointer",fontFamily:"monospace"}}>{ph}</span>))}</div>
                </div>
                <div style={{marginTop:8}}>
                  <label style={{fontSize:11,color:T.muted,fontWeight:600,display:"block",marginBottom:3}}>Stunden vorher</label>
                  <input type="number" min={1} max={12} value={tw.erinnerung2_h||3} onChange={e=>saveTw({...tw,erinnerung2_h:Number(e.target.value)})} style={{...IS,marginBottom:8}}/>
                  <button style={{...btn(T,"primary",true),width:"100%",fontSize:12}} onClick={async()=>{
                    if(!tw.sid||!tw.token){alert("Bitte Zugangsdaten eintragen.");return;}
                    try{syncData();const r=await fetch(`${srvUrl}/api/wa-cron`,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({sid:tw.sid,token:tw.token,from:tw.from,erinnerung_h:tw.erinnerung_h||24,aktiv:tw.cron_aktiv||false,erinnerung2_aktiv:true,erinnerung2_h:tw.erinnerung2_h||3})});const d=await r.json();if(d.ok)alert("✅ Gespeichert!"); else alert("❌ "+JSON.stringify(d.error));}catch(e){alert("❌ "+e.message);}
                  }}>💾 Speichern</button>
                </div>
              </>)}
            </div>
            </div>
            <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
              <button style={{...btn(T,"ghost",true),flex:1}} onClick={()=>{
                alert("Vorschau:\n\n"+previewText(waRef.current?.value||tw.text||DEFAULT_TW_TEXT));
              }}>👁 Vorschau</button>
              <button style={{...btn(T,"primary",true),flex:1}} onClick={async()=>{
                if(!tw.sid||!tw.token){alert("Bitte Account SID und Auth Token eintragen.");return;}
                const testText=previewText(waRef.current?.value||tw.text||DEFAULT_TW_TEXT);
                try{
                  const r=await fetch(`${srvUrl}/api/wa-send`,{method:"POST",headers:{"Content-Type":"application/json"},
                    body:JSON.stringify({sid:tw.sid,token:tw.token,from:tw.from,to:`whatsapp:${tw.test_to||"+491718199782"}`,text:"Termin-Erinnerung",content_sid:"HXa0423d9e0510b42775f497e04363dbae",content_variables:JSON.stringify({"1":"Test","2":"ScattoDesk Test","3":"Nürnberg","4":"Heute","5":"12:00"})})});
                  const d=await r.json();
                  if(d.ok)alert("✅ Test-Nachricht gesendet!");
                  else alert("❌ Fehler: "+JSON.stringify(d.error));
                }catch(e){alert("❌ "+e.message);}
              }}>📱 Test senden</button>
              <button style={{...btn(T,"ghost",true),flex:1}} onClick={async()=>{
                if(!tw.sid||!tw.token){alert("Bitte Zugangsdaten eintragen.");return;}
                const bookings_raw=localStorage.getItem("sd_bookings");
                if(!bookings_raw){alert("Keine Buchungen gefunden.");return;}
                const bookings=JSON.parse(bookings_raw);
                const now=new Date();
                const target=new Date(now.getTime()+tw.erinnerung_h*3600000);
                const targetKey=target.toISOString().slice(0,10);
                const due=bookings.filter(b=>b.date&&b.date.slice(0,10)===targetKey&&b.status!=="storniert");
                if(due.length===0){alert(`Keine Termine in ${tw.erinnerung_h}h gefunden.`);return;}
                let sent=0;
                for(const b of due){
                  const customers_raw=localStorage.getItem("sd_customers");
                  const customers=customers_raw?JSON.parse(customers_raw):[];
                  const c=customers.find(x=>x.id===b.customerId);
                  const tel=(c?.telefon||b.telefon||"").replace(/\s/g,"").replace(/^0/,"+49");
                  if(!tel){continue;}
                  const d=new Date(b.date);
                  const datumStr=d.toLocaleDateString("de-DE",{weekday:"long",day:"2-digit",month:"long",year:"numeric"});
                  const evName=b.shootingType||b.eventName||"";
                  const vorname=vornameAus(c?.name);
                  function fillTpl(tpl){return(tpl||"").replace("{vorname}",vorname).replace("{name}",c?.name||"").replace("{datum}",datumStr).replace("{uhrzeit}",b.uhrzeit||"").replace("{ort}",b.location||"").replace("{event}",evName);}
                  const text=fillTpl(tw.text);
                  try{
                    const r=await fetch(`${srvUrl}/api/wa-send`,{method:"POST",headers:{"Content-Type":"application/json"},
                      body:JSON.stringify({sid:tw.sid,token:tw.token,from:tw.from,to:`whatsapp:${tel}`,text:"Termin-Erinnerung",content_sid:"HXa0423d9e0510b42775f497e04363dbae",content_variables:JSON.stringify({"1":vorname,"2":evName,"3":b.location||"","4":datumStr,"5":b.uhrzeit||""})})});
                    const res=await r.json();
                    if(res.ok)sent++;
                    else if(tw.sms_aktiv&&tw.sms_from){
                      // WA fehlgeschlagen → SMS fallback
                      const rs=await fetch(`${srvUrl}/api/wa-send`,{method:"POST",headers:{"Content-Type":"application/json"},
                        body:JSON.stringify({sid:tw.sid,token:tw.token,from:tw.sms_from,to:tel,text:fillTpl(tw.sms_text),sms:true})});
                      const ress=await rs.json();
                      if(ress.ok)sent++;
                    }
                  }catch{}
                }
                alert(`✅ ${sent} Erinnerung(en) gesendet.`);
              }}>📤 Erinnerungen jetzt senden</button>
            </div>
          </div>
        </Card>
      );
    })(),
    vertrag:<VertragEinstellungen T={T}/>,
    speicher:(<><SpeicherKarte T={T} s={s} up={up} btn={btn} IS={IS} subFolders={subFolders} neuOrdner={neuOrdner} setNeuOrdner={setNeuOrdner} addFolder={addFolder} removeFolder={removeFolder}/></>),
    buchungspdf:(<>
      {(()=>{
        const [pdfPrev,setPdfPrev]=useState(()=>localStorage.getItem("sd_pdf_prev")==="1");
        const tAlign=pdf.logoAlign||"left";
        const fAlign=pdf.footerAlign||"center";
        const lh=Math.min(pdf.logoH||60,80), lw=Math.min(pdf.logoW||200,300);
        const mL=tAlign==="center"?"auto":tAlign==="right"?"auto":"0";
        const mR=tAlign==="center"?"auto":tAlign==="right"?"0":"auto";
        const fsz=9, leading=pdf.leading||14;
        const hasLogo=pdf.logoUrl&&pdf.logoUrl.startsWith("data:");
        const kontaktPrev=[pdf.strasse,pdf.tel?`Tel: ${pdf.tel}`:"",pdf.email,pdf.web].filter(Boolean);
        const previewHtml=`
          <div style="font-family:Helvetica,Arial,sans-serif;color:#1a1814;padding:0;width:100%">
            ${hasLogo?`<img src="${pdf.logoUrl}" style="max-height:${Math.round(lh*0.38)}px;max-width:${Math.round(lw*0.38)}px;display:block;margin-left:${mL};margin-right:${mR}" alt="Logo"/><div style="height:4px"></div>`:""}
            ${!hasLogo&&pdf.name?`<div style="color:#A8843E;font-weight:bold;font-size:12px">${pdf.name}</div>`:""}
            ${kontaktPrev.map(l=>`<div style="color:#8A8075;font-size:7px;line-height:1.3">${l}</div>`).join("")}
            <div style="height:8px"></div>
            <div style="font-size:14px;font-weight:bold;color:#1a1814">Buchungsbestätigung</div>
            <div style="border-bottom:0.5px solid #A8843E;margin:2px 0 5px"></div>
            <div style="font-size:8px;font-weight:bold;color:#A8843E;margin-bottom:2px">Shooting &amp; Termin</div>
            <div style="font-size:8px"><b>Shooting:</b> Pfötchen Underglass</div>
            <div style="font-size:8px"><b>Termin:</b> Samstag, 04. Juli 2026 · 11:15 Uhr</div>
            <div style="height:6px"></div>
            <div style="font-size:8px;font-weight:bold;color:#A8843E;margin-bottom:2px">Kontaktdaten</div>
            <div style="display:grid;grid-template-columns:1fr 1fr;gap:1px 4px">
              <div style="font-size:8px"><b>Vorname:</b> Markus</div>
              <div style="font-size:8px"><b>Nachname:</b> Heber</div>
              <div style="font-size:8px"><b>E-Mail:</b> info@m-h-photo.de</div>
              <div style="font-size:8px"><b>Telefon:</b> 0171 8199782</div>
              <div style="font-size:8px;grid-column:1/-1"><b>Straße:</b> Moltkestr. 2, 90429 Nürnberg</div>
            </div>
            <div style="height:6px"></div>
            <div style="font-size:8px;font-weight:bold;color:#A8843E;margin-bottom:2px">Tierdaten</div>
            <div style="display:grid;grid-template-columns:1fr 1fr;gap:1px 4px">
              <div style="font-size:8px"><b>Rasse:</b> Rauhaardackel</div>
              <div style="font-size:8px"><b>Tiername:</b> Frieda</div>
            </div>
            <div style="height:6px"></div>
            <div style="font-size:8px"><b>Vereinbarung akzeptiert:</b> Ja</div>
            <div style="font-size:7px;color:#8A8075;font-style:italic">Vereinbarung online akzeptiert.</div>
            ${pdf.footer?`
            <div style="position:absolute;bottom:0;left:0;right:0;padding:3px 8% 3px">
            ${pdf.footer.split("\n").map(l=>`<div style="font-size:6px;color:#8A8075;text-align:${fAlign}">${l}</div>`).join("")}
            </div>`:""}
          </div>`;
        return(
        <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:12,padding:20,display:"flex",flexDirection:"column",gap:16}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <div style={{fontFamily:"Georgia,serif",fontSize:15,color:T.accent}}>📄 Buchungs-PDF Layout</div>
            <button style={btn(T,pdfPrev?"primary":"ghost",true)} onClick={()=>{const n=!pdfPrev;setPdfPrev(n);localStorage.setItem("sd_pdf_prev",n?"1":"0");}}>{pdfPrev?"👁 Vorschau aus":"👁 Vorschau"}</button>
          </div>
          <div style={{display:"grid",gridTemplateColumns:pdfPrev?"1fr 1fr":"1fr",gap:20,alignItems:"start"}}>
            {/* Linke Spalte: Einstellungen */}
            <div style={{display:"flex",flexDirection:"column",gap:14}}>
              {/* Logo */}
              <div>
                <label style={{fontSize:12,color:T.muted,fontWeight:600,display:"block",marginBottom:5}}>Logo</label>
                <div style={{display:"flex",gap:8,alignItems:"center"}}>
                  {pdf.logoUrl&&<img src={pdf.logoUrl} alt="Logo" style={{maxHeight:40,maxWidth:120,borderRadius:4,border:`1px solid ${T.border}`,display:"block",marginLeft:mL,marginRight:mR}}/>}
                  <label style={{...btn(T,"ghost",true),cursor:"pointer",whiteSpace:"nowrap"}}>
                    {pdf.logoUrl?"Logo ändern":"📁 Hochladen"}
                    <input type="file" accept="image/*" style={{display:"none"}} onChange={e=>{
                      const f=e.target.files[0];if(!f)return;
                      const r=new FileReader();r.onload=ev=>savePdf("logoUrl",ev.target.result);r.readAsDataURL(f);
                    }}/>
                  </label>
                  {pdf.logoUrl&&<button style={{...btn(T,"ghost",true),color:"#e55",fontSize:11}} onClick={()=>savePdf("logoUrl","")}>✕</button>}
                </div>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginTop:8}}>
                  <div>
                    <label style={{fontSize:11,color:T.muted,display:"block",marginBottom:3}}>Höhe max: <b>{pdf.logoH||60}px</b></label>
                    <input type="range" min={20} max={200} step={5} value={pdf.logoH||60} onChange={e=>savePdf("logoH",+e.target.value)} style={{width:"100%",accentColor:T.accent}}/>
                  </div>
                  <div>
                    <label style={{fontSize:11,color:T.muted,display:"block",marginBottom:3}}>Breite max: <b>{pdf.logoW||200}px</b></label>
                    <input type="range" min={50} max={400} step={10} value={pdf.logoW||200} onChange={e=>savePdf("logoW",+e.target.value)} style={{width:"100%",accentColor:T.accent}}/>
                  </div>
                </div>
                <div style={{marginTop:8}}>
                  <label style={{fontSize:11,color:T.muted,display:"block",marginBottom:4}}>Ausrichtung</label>
                  <div style={{display:"flex",gap:6}}>
                    {[["left","Links"],["center","Mittig"],["right","Rechts"]].map(([v,l])=>(
                      <button key={v} style={btn(T,tAlign===v?"active":"ghost",true)} onClick={()=>savePdf("logoAlign",v)}>{l}</button>
                    ))}
                  </div>
                </div>
              </div>
              {/* Zeilenabstand */}
              <div style={{borderTop:`1px solid ${T.border}`,paddingTop:12}}>
                <label style={{fontSize:12,color:T.muted,fontWeight:600,display:"block",marginBottom:5}}>Zeilenabstand (Felder)</label>
                <div style={{display:"flex",gap:8,alignItems:"center"}}>
                  <input type="range" min={10} max={22} step={1} value={pdf.leading||14} onChange={e=>savePdf("leading",+e.target.value)} style={{flex:1,accentColor:T.accent}}/>
                  <span style={{fontSize:12,color:T.text,minWidth:24}}>{pdf.leading||14}</span>
                </div>
                <div style={{fontSize:11,color:T.muted,marginTop:3}}>Klein = kompakter, Groß = luftiger</div>
              </div>
              {/* Kontakt */}
              <div style={{borderTop:`1px solid ${T.border}`,paddingTop:12}}>
                <label style={{fontSize:12,color:T.muted,fontWeight:600,display:"block",marginBottom:8}}>Absender / Kontakt</label>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
                  {[["name","Studio-Name",true],["strasse","Straße"],["plz","PLZ"],["ort","Ort"],["tel","Telefon"],["email","E-Mail"],["web","Website",true]].map(([k,lbl,full])=>(
                    <div key={k} style={full?{gridColumn:"1/-1"}:{}}>
                      <label style={{fontSize:11,color:T.muted,display:"block",marginBottom:3}}>{lbl}</label>
                      <input value={pdf[k]||""} onChange={e=>savePdf(k,e.target.value)} placeholder={lbl} style={{...IS,width:"100%"}}/>
                    </div>
                  ))}
                </div>
              </div>
              {/* Fußtext */}
              <div style={{borderTop:`1px solid ${T.border}`,paddingTop:12}}>
                <label style={{fontSize:12,color:T.muted,fontWeight:600,display:"block",marginBottom:5}}>Fußtext</label>
                <textarea value={pdf.footer||""} onChange={e=>savePdf("footer",e.target.value)}
                  placeholder={"Markus Heber Photography · Moltkestraße 2 · 90429 Nürnberg\nSt.-Nr.: … · www.m-h-photo.de"}
                  style={{...IS,minHeight:60,resize:"vertical",lineHeight:1.6}}/>
                <div style={{marginTop:6,display:"flex",gap:6}}>
                  {[["left","Links"],["center","Mittig"],["right","Rechts"]].map(([v,l])=>(
                    <button key={v} style={btn(T,fAlign===v?"active":"ghost",true)} onClick={()=>savePdf("footerAlign",v)}>{l}</button>
                  ))}
                </div>
              </div>
              {/* Speichern */}
              <div style={{borderTop:`1px solid ${T.border}`,paddingTop:12}}>
                <button style={btn(T,"primary")} onClick={async()=>{
                  const serverUrl=(localStorage.getItem("sd_server_url")||"").replace(/\/$/,"");
                  try{
                    const r=await fetch(`${serverUrl}/api/pdf-settings`,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(pdf)});
                    const txt=await r.text();let d=null;try{d=JSON.parse(txt);}catch{}
                    if(r.ok&&(!d||d.ok!==false))alert("✅ PDF-Einstellungen auf Server gespeichert.");
                    else alert("❌ Fehler: "+((d&&d.error)||("Status "+r.status)));
                  }catch(e){alert("❌ "+e.message);}
                }}>💾 Auf Server speichern</button>
                <div style={{fontSize:11,color:T.muted,marginTop:6}}>Überträgt Logo, Kontakt und Fußtext auf den Server.</div>
              </div>
            </div>
            {/* Rechte Spalte: PDF-Vorschau */}
            {pdfPrev&&(
              <div style={{position:"sticky",top:16}}>
                <label style={{fontSize:11,color:T.muted,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.07em",display:"block",marginBottom:8}}>Vorschau</label>
                <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:10,padding:20,display:"flex",flexDirection:"column",gap:12,alignItems:"center",textAlign:"center"}}>
                  <div style={{fontSize:48}}>📄</div>
                  <div style={{fontSize:13,color:T.text,fontWeight:600}}>Echte PDF-Vorschau</div>
                  <div style={{fontSize:11,color:T.muted}}>Öffnet ein Beispiel-PDF mit deinen aktuellen Einstellungen in einem neuen Tab — genau wie es der Kunde bekommt.</div>
                  <button style={{...btn(T,"primary"),marginTop:4}} onClick={async()=>{
                    const serverUrl=(localStorage.getItem("sd_server_url")||"").replace(/\/$/,"");
                    const w=window.open("","_blank");
                    try{
                      const res=await fetch(`${serverUrl}/api/pdf-preview`);
                      if(!res.ok){if(w)w.close();alert("Vorschau fehlgeschlagen (HTTP "+res.status+")");return;}
                      const blob=await res.blob();
                      const url=URL.createObjectURL(blob);
                      if(w){w.location.href=url;}else{window.open(url,"_blank");}
                      setTimeout(()=>URL.revokeObjectURL(url),60000);
                    }catch(e){if(w)w.close();alert("Vorschau fehlgeschlagen: "+(e&&e.message?e.message:e));}
                  }}>📄 PDF-Vorschau öffnen</button>
                  <div style={{fontSize:10,color:T.muted}}>Zuerst „Auf Server speichern" klicken, damit die aktuellen Einstellungen im PDF erscheinen.</div>
                </div>
              </div>
            )}
          </div>
        </div>
        );
      })()}
    </>),
    server:(<>
      {/* Server URL */}
      <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:12,padding:20,marginBottom:0}}>
        <div style={{fontFamily:"Georgia,serif",fontSize:15,color:T.accent,marginBottom:12}}>🌐 Server-URL</div>
        <input value={serverUrl} onChange={e=>{setServerUrl(e.target.value);localStorage.setItem("sd_server_url",e.target.value);}}
          placeholder="http://167.233.88.11"
          style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:"9px 12px",color:T.text,fontSize:13,fontFamily:"inherit",outline:"none",boxSizing:"border-box",width:"100%",marginBottom:10}}/>
        <div style={{display:"flex",gap:8,alignItems:"center"}}>
          <button style={btn(T,"ghost",true)} onClick={async()=>{
            try{const r=await fetch(serverUrl);const t=await r.text();alert(t.includes("ScattoDesk")?"✅ Verbunden!":"⚠️ "+t);}
            catch(e){alert("❌ Nicht erreichbar: "+e.message);}
          }}>Verbindung testen</button>
          <span style={{fontSize:11,color:T.muted}}>{serverUrl||"Keine URL gesetzt"}</span>
        </div>
      </div>
      </>),
    smtp:(<>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:16,marginBottom:16}}>
      {[
        {key:"sd_smtp_settings",    title:"📧 SMTP – Newsletter",           ph:{host:"smtp.ionos.de",user:"newsletter@m-h-photo.de",from:"Markus Heber Photography",from_email:"newsletter@m-h-photo.de"}},
        {key:"sd_smtp_buchung",     title:"📨 SMTP – Buchungsbestätigungen", ph:{host:"smtp.ionos.de",user:"anmeldung@m-h-photo.de",from:"Markus Heber Photography",from_email:"anmeldung@m-h-photo.de"}},
        {key:"sd_smtp_info",        title:"✉️ SMTP – Info-Mail (Bilder)",    ph:{host:"smtp.ionos.de",user:"info@m-h-photo.de",from:"Markus Heber Photography",from_email:"info@m-h-photo.de"}},
      ].map(({key,title,ph})=>{
        const [sv,setSv]=useState(()=>{try{return JSON.parse(localStorage.getItem(key)||"{}");}catch{return {};}});
        const save=(k,v)=>{const u={...sv,[k]:v};setSv(u);localStorage.setItem(key,JSON.stringify(u));};
        return(
        <div key={key} style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:12,padding:20,marginBottom:16}}>
          <div style={{fontFamily:"Georgia,serif",fontSize:15,color:T.accent,marginBottom:16}}>{title}</div>
          <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit, minmax(150px, 1fr))",gap:12}}>
            {[
              {k:"host",label:"SMTP-Server",placeholder:ph.host},
              {k:"port",label:"Port",placeholder:"587"},
              {k:"user",label:"Benutzername",placeholder:ph.user},
              {k:"pass",label:"Passwort",placeholder:"••••••••",type:"password"},
              {k:"from",label:"Absender-Name",placeholder:ph.from},
              {k:"from_email",label:"Absender-E-Mail",placeholder:ph.from_email},
            ].map(({k,label,placeholder,type})=>(
              <div key={k}>
                <label style={{fontSize:11,color:T.muted,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.07em",display:"block",marginBottom:4}}>{label}</label>
                <input type={type||"text"} value={sv[k]||""} onChange={e=>save(k,e.target.value)}
                  placeholder={placeholder}
                  style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:"9px 12px",color:T.text,fontSize:13,fontFamily:"inherit",outline:"none",boxSizing:"border-box",width:"100%"}}/>
              </div>
            ))}
          </div>
          <div style={{marginTop:14,display:"flex",alignItems:"center",gap:12}}>
            <button style={btn(T,"ghost")} onClick={async()=>{
              if(!sv.host||!sv.user||!sv.pass){alert("Bitte erst SMTP-Einstellungen ausfüllen.");return;}
              const to=sv.from_email||sv.user;
              if(!confirm(`Test-E-Mail an ${to} senden?`))return;
              try{
                const serverUrl=(localStorage.getItem("sd_server_url")||"").replace(/\/$/,"");
                const r=await fetch(`${serverUrl}/api/newsletter`,{method:"POST",headers:{"Content-Type":"application/json"},
                  body:JSON.stringify({smtp:sv,recipients:[{name:"Test",email:to}],subject:"ScattoDesk SMTP Test",text:"Wenn du diese E-Mail siehst, funktioniert deine SMTP-Konfiguration korrekt.",html:"<p>Wenn du diese E-Mail siehst, funktioniert deine SMTP-Konfiguration korrekt. ✅</p>"})});
                const d=await r.json();
                if(d.ok||d.sent>0)alert("✅ Test-E-Mail erfolgreich gesendet an "+to);
                else alert("❌ Fehler: "+(d.error||d.message||JSON.stringify(d)));
              }catch(e){alert("❌ Fehler: "+e.message);}
            }}>📧 Test-E-Mail senden</button>
            <span style={{fontSize:11,color:T.muted}}>sendet an deine Absender-E-Mail</span>
          </div>
          {key==="sd_smtp_buchung"&&(
            <div style={{marginTop:10,paddingTop:14,borderTop:`1px solid ${T.border}`,display:"flex",alignItems:"center",gap:12,flexWrap:"wrap"}}>
              <button style={btn(T,"primary")} onClick={async()=>{
                if(!sv.host||!sv.user||!sv.pass){alert("Bitte erst die SMTP-Daten (z. B. anmeldung@m-h-photo.de) ausfüllen.");return;}
                let tmpl={betreff:"Buchungsbestätigung – {{shooting}}",text:"Hallo {{name}},\n\nvielen Dank für deine Buchung!\n\n📅 {{datum}}\n🕐 {{uhrzeit}}\n📍 {{location}}\n📷 {{shooting}}\n💰 {{preis}} €\n\nBei Fragen stehe ich gerne zur Verfügung.\n\nHerzliche Grüße\n{{studio}}"};
                try{const v=JSON.parse(localStorage.getItem("sd_email_vorlagen")||"{}");if(v.buchungsbestaetigung)tmpl={betreff:v.buchungsbestaetigung.betreff||tmpl.betreff,text:v.buchungsbestaetigung.text||tmpl.text};}catch(e){}
                let sig={text:"",logo:""},fmt={size:14,font:"Georgia,serif",color:"#1a1814",lineHeight:1.7};
                try{sig=JSON.parse(localStorage.getItem("sd_email_sig")||"null")||sig;}catch(e){}
                try{fmt=JSON.parse(localStorage.getItem("sd_email_fmt")||"null")||fmt;}catch(e){}
                try{
                  const serverUrl=(localStorage.getItem("sd_server_url")||"").replace(/\/$/,"");
                  const r=await fetch(`${serverUrl}/api/buchung-mail-settings`,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({smtp:sv,betreff:tmpl.betreff,text:tmpl.text,sig,fmt,vorlagen:(()=>{try{const vl=JSON.parse(localStorage.getItem("sd_email_vorlagen")||"null");return vl?{interesse_bestaetigung:vl.interesse_bestaetigung||{}}:{};}catch{return {};}})()} )});
                  const txt=await r.text();let d=null;try{d=txt?JSON.parse(txt):null;}catch(e){d=null;}
                  if(r.ok&&(!d||d.ok!==false))alert("✅ Auf Server gespeichert.\n\nKunden bekommen ab jetzt nach einer Buchung automatisch eine Bestätigung von "+(sv.from_email||sv.user)+".");
                  else alert("❌ Fehler: "+((d&&d.error)||("Status "+r.status)));
                }catch(e){alert("❌ Fehler: "+e.message);}
              }}>💾 Bestätigungs-Versand auf Server speichern</button>
              <span style={{fontSize:11,color:T.muted}}>hinterlegt diese Zugangsdaten + Vorlage für die automatische Kundenbestätigung</span>
            </div>
          )}
        </div>
        );
      })}
      </div>
      {(()=>{
        const VORLAGEN_KEY="sd_email_vorlagen";
        const DEF={
          buchungsbestaetigung:{label:"Buchungsbestätigung",betreff:"Buchungsbestätigung – {{shooting}}",
            text:"Hallo {{name}},\n\nvielen Dank für deine Buchung!\n\n📅 {{datum}}\n🕐 {{uhrzeit}}\n📍 {{location}}\n📷 {{shooting}}\n💰 {{preis}} €\n\nBei Fragen stehe ich gerne zur Verfügung.\n\nHerzliche Grüße\n{{studio}}"},
          info_mail:{label:"Info-Mail",betreff:"Wichtige Infos zu deinem Shooting – {{shooting}}",
            text:"Hallo {{name}},\n\nhier sind wichtige Informationen zu deinem Shooting am {{datum}} um {{uhrzeit}} Uhr:\n\n[Deine Infos hier]\n\nBei Fragen stehe ich gerne zur Verfügung.\n\nHerzliche Grüße\n{{studio}}"},
          erinnerung:{label:"Erinnerung",betreff:"Erinnerung: Dein Shooting bei {{studio}}",
            text:"Hallo {{name}},\n\nnur zur Erinnerung: Dein Shooting findet statt am:\n\n📅 {{datum}}\n🕐 {{uhrzeit}}\n📍 {{ort}}\n\nWir freuen uns auf dich!\n\nHerzliche Grüße\n{{studio}}"},
          dankemail:{label:"Danke",betreff:"Danke für dein Shooting! ⭐",
            text:"Hallo {{name}},\n\nvielen Dank für dein Shooting bei uns!\n\nWir hoffen, du hattest eine tolle Zeit. Deine Bilder sind in Bearbeitung.\n\nWir würden uns sehr über deine Bewertung freuen:\n{{bewertung_link}}\n\nBis bald!\n{{studio}}"},
          feedback:{label:"Feedback",betreff:"Wie war dein Shooting bei {{studio}}?",
            text:"Hallo {{name}},\n\nwir hoffen, du hast dein Shooting bei {{event}} genossen!\n\nDein Feedback ist uns sehr wichtig – es dauert nur 2 Minuten:\n{{feedback_link}}\n\nVielen Dank für deine Zeit!\n\nHerzliche Grüße\n{{studio}}"},
          vereinbarung:{label:"Vereinbarung",betreff:"Deine Shooting-Vereinbarung – {{shooting}}",
            text:"Hallo {{name}},\n\nfür dein Shooting am {{datum}} um {{uhrzeit}} Uhr fehlt noch die unterschriebene Shootingvereinbarung.\n\nÜber diesen Link kannst du sie in Ruhe durchlesen und direkt am Handy unterschreiben:\n\n{{vereinbarung_link}}\n\nBei Fragen melde dich einfach kurz.\n\nHerzliche Grüße\n{{studio}}"},
          vertragsmail:{label:"📄 Vertragsmail",betreff:"Dein Fotografievertrag – {{datum}}",
            text:"Hallo {{vorname}},\n\nhier ist dein Fotografievertrag für das Shooting am {{datum}} um {{uhrzeit}} Uhr.\n\nÜber diesen Link kannst du ihn in Ruhe durchlesen und direkt am Handy unterschreiben:\n\n{{link}}\n\nTreffpunkt: {{ort}}\n{{maps}}\n\nWenn etwas nicht stimmt, melde dich einfach kurz.\n\nHerzliche Grüße\n{{studio}}"},
          geschenk_buchungslink:{label:"Geschenk-Link · Schenkende(r)",betreff:"Dein Gutschein für ein Fotoshooting 🎁",
            text:"Hallo {{name}},\n\nschön, dass du ein Fotoshooting verschenken möchtest!\n\nÜber diesen Link trägst du die beschenkte Person ein und schließt die Bezahlung ab:\n\n{{link}}\n\nEinen Termin kannst du dabei schon aussuchen, musst du aber nicht. Die beschenkte Person kann das auch später selbst tun.\n\nHerzliche Grüße\n{{studio}}"},
          geschenk_einloesen:{label:"Geschenk-Link · Beschenkte(r)",betreff:"Du wurdest zu einem Fotoshooting eingeladen! 🎁",
            text:"Hallo {{name}},\n\ndu hast ein Fotoshooting geschenkt bekommen!\n\nHier suchst du dir deinen Wunschtermin aus und unterschreibst die Shootingvereinbarung:\n\n{{link}}\n\nBezahlen musst du nichts, das ist bereits erledigt.\n\nWir freuen uns auf dich!\n\nHerzliche Grüße\n{{studio}}"},
          slotreservierung:{label:"Slot-Reservierung",betreff:"Dein Termin bei {{studio}}",
            text:"Hallo {{name}},\n\nIch habe für Sie folgenden Termin reserviert:\n\n📅 {{datum}}\n🕐 {{uhrzeit}}\n📷 {{shooting}}\n\n✍️ Bitte füllen Sie jetzt Ihr Buchungsformular aus:\n{{link}}\n\nHerzliche Grüße\n{{studio}}"},
          newsletter:{label:"Newsletter",betreff:"Neuigkeiten von {{studio}}",
            text:"Hallo {{name}},\n\n[Dein Newsletter-Text hier]\n\nHerzliche Grüße\n{{studio}}"},
          erinnerung_bestellung:{label:"Erinnerung: Bildauswahl abschließen",betreff:"Erinnerung: Buchung abschließen – {{event}}",
            text:"Hallo {{name}},\n\nnur eine kurze Erinnerung: Deine Buchung für {{event}} am {{datum}} ist noch nicht abgeschlossen.\n\nBitte schließe deine Bestellung bald ab.\n\nHerzliche Grüße\n{{studio}}"},
          erinnerung_einzel:{label:"Erinnerung Einzel: Bildauswahl",betreff:"Erinnerung: Deine Bildauswahl vom {{datum}}",
            text:"Hallo {{vorname}},\n\nnur eine kurze Erinnerung: Die Auswahl deiner Bilder vom Shooting am {{datum}} ist noch offen.\n\nHier ist dein persönlicher Zugangslink:\n{{link}}\n\nMelde dich gern, wenn du Fragen hast.\n\nHerzliche Grüße\n{{studio}}"},
          bildauswahl:{label:"📂 Bildauswahl",betreff:"Dein Zugangslink zur Bildauswahl – {{event}}",
            text:"Hallo {{vorname}},\n\nhier ist dein persönlicher Zugangslink zur Bildauswahl:\n{{link}}\n\nHerzliche Grüße\n{{studio}}"},
          fertige_bilder:{label:"🖼 Fertige Bilder",betreff:"Deine fertigen Bilder – {{event}}",
            text:"Hallo {{vorname}},\n\ndeine Bilder vom Fototermin \"{{event}}\" am {{datum}} sind fertig!\n\nHier ist dein persönlicher Zugangslink:\n{{link}}\n\nHerzliche Grüße\n{{studio}}"},
          erinnerung1:{label:"Erinnerung Stufe 1",betreff:"Erinnerung: Deine Bilder warten – {{event}}",
            text:"Hallo {{vorname}},\n\nnur eine kurze Erinnerung – deine Bilder vom Fototermin \"{{event}}\" warten noch auf deine Auswahl.\n\nHier ist dein persönlicher Zugangslink:\n{{link}}\n\nHerzliche Grüße\n{{studio}}"},
          interesse_bestaetigung:{label:"Interesse Bestätigung",betreff:"Dein Interesse wurde vorgemerkt – {{shooting}}",
            text:"Hallo {{vorname}},\n\nvielen Dank für dein Interesse an: {{shooting}}\n\nWunschtermin: {{terminwahl}}\n\nWir melden uns sobald die Buchung startet!\n\nHerzliche Grüße\n{{studio}}"},
          erinnerung2:{label:"Erinnerung Stufe 2",betreff:"Letzte Erinnerung: Deine Bilder warten – {{event}}",
            text:"Hallo {{vorname}},\n\ndies ist eine letzte Erinnerung – die Galerie für {{event}} schließt bald.\n\nHier ist dein persönlicher Zugangslink:\n{{link}}\n\nHerzliche Grüße\n{{studio}}"},
          gutschein:{label:"Gutschein",betreff:"Dein Gutschein von {{studio}}",
            text:"Hallo {{name}},\n\ndu hast einen Gutschein erhalten!\n\n🎁 Gutscheincode: {{code}}\nWert: {{wert}} €\n\nGültig bis: {{gueltig_bis}}\n\nHerzliche Grüße\n{{studio}}"},
          absage:{label:"Absage",betreff:"Absage deines Shootings – {{shooting}}",
            text:"Hallo {{name}},\n\nleider müssen wir dein Shooting am {{datum}} um {{uhrzeit}} Uhr absagen.\n\nWir melden uns baldmöglichst für einen neuen Termin.\n\nHerzliche Grüße\n{{studio}}"},
          bezahlung_anfordern:{label:"Bezahlung anfordern",betreff:"Zahlungsanforderung – {{shooting}}",
            text:"Hallo {{name}},\n\nfür dein Shooting am {{datum}} um {{uhrzeit}} Uhr ist noch ein offener Betrag von {{betrag}} € offen.\n\nDu kannst bequem per PayPal oder Überweisung bezahlen:\n\n💳 PayPal:\n{{paypal_link}}\n\n🏦 Überweisung:\nEmpfänger: {{kontoinhaber}}\nIBAN: {{iban}}\nBIC: {{bic}}\nBetrag: {{betrag}} €\nVerwendungszweck: {{verwendungszweck}}\n\nVielen Dank!\n\nHerzliche Grüße\n{{studio}}"},
        };
        const [vl,setVl]=useState(()=>{try{const x=JSON.parse(localStorage.getItem(VORLAGEN_KEY)||"null");if(x){delete x.zugangslink;}return x?{...DEF,...x}:DEF;}catch{return DEF;}});
        const [akt,setAkt]=useState("buchungsbestaetigung");
        const [prev,setPrev]=useState(()=>localStorage.getItem("sd_email_prev")==="1");
        const [fmt,setFmt]=useState(()=>{try{return JSON.parse(localStorage.getItem("sd_email_fmt")||"null")||{size:14,bold:false,italic:false,color:"#1a1814",font:"Georgia,serif",lineHeight:1.7};}catch{return {size:14,bold:false,italic:false,color:"#1a1814",font:"Georgia,serif",lineHeight:1.7};}});
        useEffect(()=>{localStorage.setItem("sd_email_fmt",JSON.stringify(fmt));},[fmt]);
        const [sig,setSig]=useState(()=>{try{return JSON.parse(localStorage.getItem("sd_email_sig")||"null")||{text:"",logo:""};}catch{return {text:"",logo:""};} });
        const [linkDlg,setLinkDlg]=useState(false);
        const [linkLabel,setLinkLabel]=useState("");
        const [linkUrl,setLinkUrl]=useState("");
        const [imgDlg,setImgDlg]=useState(false);
        const [imgUrl,setImgUrl]=useState("");
        const [imgAlt,setImgAlt]=useState("");
        // Erinnerungsmail-Einstellungen (Buchung abschließen)
        const [erBest,setErBest]=useState(()=>{try{return JSON.parse(localStorage.getItem("sd_erinnerung_bestellung")||"null")||{aktiv:false,tage:7,betreff:"Erinnerung: Buchung abschließen – {{event}}",text:"Hallo {{name}},\n\nnur eine kurze Erinnerung: Deine Buchung für {{event}} am {{datum}} ist noch nicht abgeschlossen.\n\nBitte schließe deine Bestellung bald ab.\n\nHerzliche Grüße\n{{studio}}"};}catch{return {aktiv:false,tage:7,betreff:"",text:""};}});
        function saveErBest(u){setErBest(u);localStorage.setItem("sd_erinnerung_bestellung",JSON.stringify(u));}
        // Erinnerungsmail-Einstellungen
        const [erinnerung,setErinnerung]=useState(()=>{try{return JSON.parse(localStorage.getItem("sd_erinnerung")||"null")||{aktiv:false,zeiten:[{tage:3,stunden:0},{tage:1,stunden:0}],email:"anmeldung@m-h-photo.de"};}catch{return {aktiv:false,zeiten:[{tage:3,stunden:0},{tage:1,stunden:0}],email:"anmeldung@m-h-photo.de"};}});
        const [danke,setDanke]=useState(()=>{try{return JSON.parse(localStorage.getItem("sd_dankemail")||"null")||{aktiv:false,zeiten:[{tage:1,stunden:0}],email:"info@m-h-photo.de",bewertungLink:"https://g.page/r/XXXXX/review"};}catch{return {aktiv:false,zeiten:[{tage:1,stunden:0}],email:"info@m-h-photo.de",bewertungLink:""};}});
        const [feedback,setFeedback]=useState(()=>{try{return JSON.parse(localStorage.getItem("sd_feedbackmail")||"null")||{aktiv:false,zeiten:[{tage:7,stunden:0}],triggerMode:"abgeschlossen",email:"info@m-h-photo.de",feedbackLink:""};}catch{return {aktiv:false,zeiten:[{tage:7,stunden:0}],triggerMode:"abgeschlossen",email:"info@m-h-photo.de",feedbackLink:""};} });
        const [bildauswahl,setBildauswahl]=useState(()=>{try{return JSON.parse(localStorage.getItem("sd_erinnerung_bildauswahl")||"null")||{aktiv:false,zeiten:[{tage:7,stunden:0}],triggerMode:"galerielink",email:"info@m-h-photo.de"};}catch{return {aktiv:false,zeiten:[{tage:7,stunden:0}],triggerMode:"galerielink",email:"info@m-h-photo.de"};}});
        const [amStatus,setAmStatus]=useState("");
        // Merkt sich, dass eine der drei Auto-Mail-Vorlagen geaendert wurde,
        // aber noch nicht auf dem Server liegt.
        const [amOffen,setAmOffen]=useState(false);
        const AM_VORLAGEN=["erinnerung","dankemail","feedback","erinnerung_einzel"];
        // Auto-Mail-Einstellungen zum Server schieben. Ohne das kann der
        // Cronjob nichts verschicken, weil er nur auto_mail_settings.json kennt.
        function pushAutoMail(next){
          const g=k=>{try{return JSON.parse(localStorage.getItem(k)||"{}");}catch{return {};}};
          const srv=(localStorage.getItem("sd_server_url")||"").trim().replace(/\/+$/,"");
          if(!srv){setAmStatus("Keine Server-URL hinterlegt");return Promise.resolve(false);}
          const smtp=(()=>{try{return JSON.parse(localStorage.getItem("sd_smtp_buchung")||localStorage.getItem("sd_smtp_settings")||"{}");}catch{return {};}})();
          const vor=g("sd_email_vorlagen"), bcfg=g("sd_buchung_config"), sg=g("sd_email_sig");
          const er=(next&&next.erinnerung)||erinnerung;
          const da=(next&&next.danke)||danke;
          const fb=(next&&next.feedback)||feedback;
          const ba=(next&&next.bildauswahl)||bildauswahl;
          const body={
            smtp,
            studioName:bcfg.studioName||"",
            signatur:{text:sg.text||""},
            maxAlterTage:30,
            erinnerung:{...er,betreff:(vor.erinnerung||{}).betreff||"",text:(vor.erinnerung||{}).text||""},
            danke:{...da,betreff:(vor.dankemail||{}).betreff||"",text:(vor.dankemail||{}).text||""},
            feedback:{...fb,betreff:(vor.feedback||{}).betreff||"",text:(vor.feedback||{}).text||""},
            bildauswahl:{...ba,betreff:(vor.erinnerung_einzel||{}).betreff||"",text:(vor.erinnerung_einzel||{}).text||""},
          };
          setAmStatus("\u00dcbertrage \u2026");
          return fetch(srv+"/api/auto-mail-settings",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(body)})
            .then(r=>r.json())
            .then(d=>{const ok=!!(d&&d.ok);setAmStatus(ok?"\u2713 Auf dem Server gespeichert":"Fehler beim Speichern");if(ok)setAmOffen(false);return ok;})
            .catch(()=>{setAmStatus("Server nicht erreichbar");return false;});
        }
        function saveFb(u){setFeedback(u);localStorage.setItem("sd_feedbackmail",JSON.stringify(u));pushAutoMail({feedback:u});}
        function saveEr(u){setErinnerung(u);localStorage.setItem("sd_erinnerung",JSON.stringify(u));pushAutoMail({erinnerung:u});}
        function saveDa(u){setDanke(u);localStorage.setItem("sd_dankemail",JSON.stringify(u));pushAutoMail({danke:u});}
        function saveBa(u){setBildauswahl(u);localStorage.setItem("sd_erinnerung_bildauswahl",JSON.stringify(u));pushAutoMail({bildauswahl:u});}
        function saveSig(k,v){const u={...sig,[k]:v};setSig(u);localStorage.setItem("sd_email_sig",JSON.stringify(u));}
        function sv(k,field,val){const u={...vl,[k]:{...vl[k],[field]:val}};setVl(u);localStorage.setItem(VORLAGEN_KEY,JSON.stringify(u));if(AM_VORLAGEN.includes(k))setAmOffen(true);if(k==="erinnerung_bestellung"){const er=(()=>{try{return JSON.parse(localStorage.getItem("sd_erinnerung_bestellung")||"{}");}catch{return {};}})();localStorage.setItem("sd_erinnerung_bestellung",JSON.stringify({...er,[field]:val}));}}
        const v=vl[akt]||{};
        const bsp={name:"Max Mustermann",vorname:"Max",datum:"Samstag, 05. Juli 2026",uhrzeit:"10:00",shooting:"Underglass",event:"Pfötchen Underglass",preis:"99",ort:"Pfötchen Hundebedarf, München",location:"Musterstraße 1, 80331 München",studio_name:"Markus Heber Photography",link:"https://buchen.m-h-photo.de/...",studio:"Markus Heber Photography",bewertung_link:danke.bewertungLink||"https://g.page/r/...",feedback_link:feedback.feedbackLink||"https://forms.gle/..."};
        const FONTS=[
          // Web-sicher (funktioniert überall)
          {val:"Georgia,serif",label:"Georgia"},
          {val:"Arial,sans-serif",label:"Arial"},
          {val:"Helvetica,sans-serif",label:"Helvetica"},
          {val:"Verdana,sans-serif",label:"Verdana"},
          {val:"Trebuchet MS,sans-serif",label:"Trebuchet MS"},
          {val:"Courier New,monospace",label:"Courier New"},
          // Google Fonts (Avenir-ähnlich & modern, Gmail/Apple Mail ✓, Outlook ✗)
          {val:"'Nunito',sans-serif",label:"Nunito ✦ (Avenir-ähnlich)",gf:"Nunito:300,400,600"},
          {val:"'Raleway',sans-serif",label:"Raleway ✦ (schlank & elegant)",gf:"Raleway:300,400,600"},
          {val:"'Lato',sans-serif",label:"Lato ✦ (modern, neutral)",gf:"Lato:300,400,700"},
          {val:"'Poppins',sans-serif",label:"Poppins ✦ (rund & freundlich)",gf:"Poppins:300,400,600"},
          {val:"'Playfair Display',serif",label:"Playfair Display ✦ (elegant)",gf:"Playfair+Display:400,600"},
          {val:"'Montserrat',sans-serif",label:"Montserrat ✦ (geometrisch)",gf:"Montserrat:300,400,600"},
          {val:"'Open Sans',sans-serif",label:"Open Sans ✦ (gut lesbar)",gf:"Open+Sans:300,400,600"},
          {val:"'Cormorant Garamond',serif",label:"Cormorant Garamond ✦ (fein)",gf:"Cormorant+Garamond:300,400,600"},
        ];
        const activeGF=FONTS.find(f=>f.val===fmt.font)?.gf;
        const gfLink=activeGF?`https://fonts.googleapis.com/css2?family=${activeGF}&display=swap`:null;
        const IS={background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:"9px 12px",color:T.text,fontSize:13,fontFamily:"inherit",outline:"none",boxSizing:"border-box",width:"100%"};
        const tbBtn=(active,title,content,onClick)=>(
          <button title={title} onClick={onClick} style={{background:active?T.accent+"33":"transparent",border:`1px solid ${active?T.accent:T.border}`,borderRadius:5,padding:"3px 9px",cursor:"pointer",color:active?T.accent:T.text,fontSize:12,fontFamily:"inherit",lineHeight:1.5,whiteSpace:"nowrap"}}>{content}</button>
        );
        function insertAtCursor(snippet){
          const ta=document.getElementById("sd-vorlage-ta");
          if(!ta)return;
          const a=ta.selectionStart,b=ta.selectionEnd;
          const newText=v.text.slice(0,a)+snippet+v.text.slice(b);
          sv(akt,"text",newText);
          setTimeout(()=>{ta.focus();ta.setSelectionRange(a+snippet.length,a+snippet.length);},10);
        }
        function wrapSelection(before,after){
          const ta=document.getElementById("sd-vorlage-ta");
          if(!ta)return;
          const a=ta.selectionStart,b=ta.selectionEnd;
          const sel=v.text.slice(a,b)||"Text";
          const wrapped=before+sel+after;
          const newText=v.text.slice(0,a)+wrapped+v.text.slice(b);
          sv(akt,"text",newText);
          setTimeout(()=>{ta.focus();ta.setSelectionRange(a+before.length,a+before.length+sel.length);},10);
        }
        function buildPreviewHtml(){
          const esc=s=>String(s||"").replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;");
          let t=(v.text||"").replace(/\{\{(\w+)\}\}/g,(_,k)=>bsp[k]||`{{${k}}}`);
          // Markdown-ähnliche Bildeinbettung ![alt](url)
          t=t.replace(/!\[([^\]]*)\]\(([^)]+)\)/g,(m,alt,url)=>`<img src="${url}" alt="${esc(alt)}" style="max-width:100%;border-radius:6px;margin:8px 0;display:block"/>`);
          // Links [label](url)
          t=t.replace(/\[([^\]]+)\]\(([^)]+)\)/g,(m,l,u)=>`<a href="${u}" style="color:#A8843E;font-weight:600">${esc(l)}</a>`);
          // Schriftgröße [14px]text[/size]
          t=t.replace(/\[(\d+)px?\](.*?)\[\/size\]/gs,(m,px,inner)=>`<span style="font-size:${px}px">${inner}</span>`);
          // Fett **text**
          t=t.replace(/\*\*(.+?)\*\*/gs,(m,inner)=>`<strong>${inner}</strong>`);
          // Kursiv _text_
          t=t.replace(/(?<![a-zA-Z])_(.+?)_(?![a-zA-Z])/gs,(m,inner)=>`<em>${inner}</em>`);
          // Zeilenumbrüche: jede Zeile wird zu <br>, doppelte Leerzeile = kleiner Absatzabstand
          const parts=t.split(/\n/).map(line=>{
            if(line.trim()==="")return `<br style="line-height:0.8"/>`;
            return line+"<br/>";
          }).join("");
          const logoHtml=sig.logo?`<img src="${sig.logo}" style="max-height:70px;max-width:200px;display:block;margin-bottom:8px" alt="Logo"/>`:"";
          const sigHtml=sig.text?`<div style="font-size:12px;color:#8A8075;white-space:pre-wrap;">${esc(sig.text)}</div>`:"";
          const foot=logoHtml||sigHtml?`${logoHtml}${sigHtml}`:"";
          return `<div style="font-size:${fmt.size}px;font-family:${fmt.font};color:${fmt.color};line-height:${v.lineHeight||fmt.lineHeight||1.7};">${parts}${foot}</div>`;
        }
        const ZeitBlock=({label,state,onSave,showBewertung,richtung="vor",extraFelder=[],felder="beide",voll=false})=>(
          <div style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:14,marginBottom:12,
                       ...(voll?{flex:1,display:"flex",flexDirection:"column"}:{})}}>
            <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:10}}>
              <label style={{fontSize:12,fontWeight:600,color:T.text}}>{label}</label>
              <input type="checkbox" checked={state.aktiv} onChange={e=>onSave({...state,aktiv:e.target.checked})} style={{accentColor:T.accent,width:16,height:16}}/>
              <span style={{fontSize:11,color:T.muted}}>{state.aktiv?"aktiv":"inaktiv"}</span>
            </div>
            <div style={{display:"flex",gap:8,marginBottom:8,alignItems:"center"}}>
              <label style={{fontSize:11,color:T.muted,minWidth:60}}>Absender</label>
              <input value={state.email||""} onChange={e=>onSave({...state,email:e.target.value})} style={{...IS,fontSize:12}} placeholder="anmeldung@m-h-photo.de"/>
            </div>
            {showBewertung&&(
              <div style={{display:"flex",gap:8,marginBottom:8,alignItems:"center"}}>
                <label style={{fontSize:11,color:T.muted,minWidth:60}}>Bewertungslink</label>
                <input value={state.bewertungLink||""} onChange={e=>onSave({...state,bewertungLink:e.target.value})} style={{...IS,fontSize:12}} placeholder="https://g.page/r/..."/>
              </div>
            )}
            {extraFelder.map(f=>(
              <div key={f.key} style={{display:"flex",gap:8,marginBottom:8,alignItems:"center"}}>
                <label style={{fontSize:11,color:T.muted,minWidth:60}}>{f.label}</label>
                <input value={state[f.key]||""} onChange={e=>onSave({...state,[f.key]:e.target.value})} style={{...IS,fontSize:12}} placeholder={f.placeholder||""}/>
              </div>
            ))}
            <div style={{fontSize:11,color:T.muted,marginBottom:6}}>Zeitpunkte:</div>
            {(state.zeiten||[]).map((z,i)=>(
              <div key={i} style={{display:"flex",gap:8,alignItems:"center",marginBottom:6}}>
                {felder!=="stunden"&&(<>
                  <input type="number" min={0} max={30} value={z.tage||0} onChange={e=>{const zn=[...state.zeiten];zn[i]={...zn[i],tage:Number(e.target.value),stunden:felder==="tage"?0:(zn[i].stunden||0)};onSave({...state,zeiten:zn});}}
                    style={{...IS,width:60,fontSize:12}} placeholder="3"/>
                  <span style={{fontSize:12,color:T.muted}}>Tage</span>
                </>)}
                {felder!=="tage"&&(<>
                  <input type="number" min={0} max={72} value={z.stunden||0} onChange={e=>{const zn=[...state.zeiten];zn[i]={...zn[i],stunden:Number(e.target.value),tage:felder==="stunden"?0:(zn[i].tage||0)};onSave({...state,zeiten:zn});}}
                    style={{...IS,width:60,fontSize:12}} placeholder="0"/>
                  <span style={{fontSize:12,color:T.muted}}>Std.</span>
                </>)}
                <span style={{fontSize:12,color:T.muted}}>{richtung} dem Shooting</span>
                <button onClick={()=>{const zn=state.zeiten.filter((_,j)=>j!==i);onSave({...state,zeiten:zn});}} style={{...btn(T,"ghost"),padding:"3px 8px",fontSize:11,color:"#e55"}}>✕</button>
              </div>
            ))}
            <button onClick={()=>onSave({...state,zeiten:[...state.zeiten,felder==="stunden"?{tage:0,stunden:2}:{tage:1,stunden:0}]})} style={{...btn(T,"ghost"),fontSize:11,marginTop:4}}>+ Zeitpunkt hinzufügen</button>
          </div>
        );
        return(
        <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:12,padding:20,marginTop:0}}>
          <div style={{fontFamily:"Georgia,serif",fontSize:15,color:T.accent,marginBottom:16}}>✉️ E-Mail Vorlagen & Automatisierung</div>
          <div style={{marginBottom:20,display:"flex",flexWrap:"wrap",gap:10,alignItems:"flex-start"}}>
            {[
              {keys:["buchungsbestaetigung","erinnerung","info_mail","dankemail","feedback"],bg:"#e6f1fb",border:"#b5d4f4",col:"#0c447c",aktBg:"#185fa5"},
              {keys:["vereinbarung","vertragsmail","geschenk_buchungslink","geschenk_einloesen","slotreservierung","bildauswahl","erinnerung_bestellung","erinnerung_einzel","erinnerung1","erinnerung2","fertige_bilder"],bg:"#e1f5ee",border:"#5dcaa5",col:"#085041",aktBg:"#0f6e56"},
              {keys:["interesse_bestaetigung","bezahlung_anfordern"],bg:"#faece7",border:"#f0997b",col:"#712b13",aktBg:"#993c1d"},
              {keys:["newsletter","gutschein","absage"],bg:"#eeedfe",border:"#afa9ec",col:"#3c3489",aktBg:"#534ab7"},
            ].map(({keys,bg,border,col,aktBg},gi)=>(
              // Trennstrich steckt in der Gruppe: so rutscht er beim Umbruch mit
              // und bleibt nicht allein am Zeilenende stehen.
              // Feste zwei Reihen je Farbgruppe. Das Raster richtet die Knoepfe
              // sauber in Spalten aus, statt sie nach geschaetzter Breite
              // umbrechen zu lassen.
              <div key={gi} style={{display:"flex",alignItems:"stretch"}}>
                {gi>0&&<div style={{width:1,background:T.border,margin:"0 10px 0 4px"}}/>}
                <div style={{display:"grid",gap:4,alignContent:"start",
                     gridTemplateColumns:`repeat(${Math.ceil(keys.filter(k=>vl[k]).length/2)}, max-content)`}}>
                {keys.filter(k=>vl[k]).map(k=>(
                  <button key={k} onClick={()=>setAkt(k)} style={{
                    fontSize:12,padding:"6px 12px",borderRadius:6,border:`0.5px solid ${border}`,cursor:"pointer",fontFamily:"inherit",fontWeight:akt===k?600:400,
                    background:akt===k?aktBg:bg,color:akt===k?"#fff":col,transition:"all 0.1s"
                  }}>{vl[k].label}</button>
                ))}
                </div>
              </div>
            ))}
          </div>
          <div style={{display:"grid",gridTemplateColumns:prev?"minmax(0,1fr) minmax(0,1fr)":"1fr",gap:32}}>
            {/* Linke Spalte: Editor */}
            <div>
              <div style={{marginBottom:10}}>
                <label style={{fontSize:11,color:T.muted,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.07em",display:"block",marginBottom:4}}>Betreff</label>
                <input value={v.betreff||""} onChange={e=>sv(akt,"betreff",e.target.value)} style={IS}/>
              </div>
              {/* Toolbar */}
              <div style={{display:"flex",gap:5,alignItems:"center",flexWrap:"wrap",marginBottom:8,padding:"8px 10px",background:T.bg,borderRadius:8,border:`1px solid ${T.border}`}}>
                <select value={fmt.font} onChange={e=>setFmt(f=>({...f,font:e.target.value}))} style={{...IS,width:"auto",padding:"3px 6px",fontSize:11}}>
                  {FONTS.map(f=>(<option key={f.val} value={f.val}>{f.label}</option>))}
                </select>
                <select onChange={e=>{if(e.target.value){wrapSelection(`[${e.target.value}]`,"[/size]");e.target.value="";}}} style={{...IS,width:70,padding:"3px 6px",fontSize:11}} title="Größe auf markierten Text">
                  <option value="">px</option>
                  {[10,11,12,13,14,15,16,18,20,22,24].map(s=>(<option key={s} value={s}>{s}px</option>))}
                </select>
                {tbBtn(false,"Fett (Text markieren, dann klicken)","B",()=>wrapSelection("**","**"))}
                {tbBtn(false,"Kursiv (Text markieren, dann klicken)","I",()=>wrapSelection("_","_"))}
                <input type="color" value={fmt.color} onChange={e=>setFmt(f=>({...f,color:e.target.value}))} title="Textfarbe" style={{width:28,height:26,border:"none",borderRadius:4,cursor:"pointer",background:"none"}}/>
                <div style={{display:"flex",alignItems:"center",gap:4}}>
                  <span style={{fontSize:10,color:T.muted,whiteSpace:"nowrap"}}>Zeilenabstand</span>
                  <input type="range" min="1.0" max="4.0" step="0.1" value={v.lineHeight||1.7}
                    onChange={e=>sv(akt,"lineHeight",Number(e.target.value))}
                    style={{width:80,accentColor:T.accent}}/>
                  <span style={{fontSize:10,color:T.muted,minWidth:22}}>{(v.lineHeight||1.7).toFixed(1)}</span>
                </div>
                <div style={{width:1,height:20,background:T.border}}/>
                {tbBtn(false,"Link einfügen","🔗",()=>{setLinkLabel("");setLinkUrl("");setLinkDlg(true);})}
                {tbBtn(false,"Bild einfügen","🖼",()=>{setImgUrl("");setImgAlt("");setImgDlg(true);})}
                {tbBtn(false,"Aufzählungsliste","• —",()=>insertAtCursor("\n• Punkt 1\n• Punkt 2\n• Punkt 3\n"))}
                <select onChange={e=>{if(e.target.value){insertAtCursor(e.target.value);e.target.value="";}}}
                  style={{...IS,width:"auto",padding:"3px 8px",fontSize:11,color:T.muted}}>
                  <option value="">{"{{}} Platzhalter"}</option>
                  {[["name","Vollständiger Name"],["vorname","Vorname"],["datum","Datum"],["uhrzeit","Uhrzeit"],["shooting","Shootingart"],["event","Veranstaltungsname"],["preis","Preis"],["ort","Ort"],["location","Location/Adresse"],["studio","Studioname"],["link","Buchungslink"],["bewertung_link","Bewertungslink"],["feedback_link","Feedback-Link"]].map(([k,l])=>(
                    <option key={k} value={`{{${k}}}`}>{`{{${k}}} – ${l}`}</option>
                  ))}
                </select>              </div>
              {/* Link-Dialog */}
              {linkDlg&&(
                <div style={{background:T.bg,border:`1px solid ${T.accent}`,borderRadius:8,padding:12,marginBottom:8}}>
                  <div style={{fontSize:12,fontWeight:600,color:T.accent,marginBottom:8}}>🔗 Link einfügen</div>
                  <input value={linkLabel} onChange={e=>setLinkLabel(e.target.value)} placeholder="Linktext (z.B. Jetzt bewerten)" style={{...IS,marginBottom:6,fontSize:12}}/>
                  <input value={linkUrl} onChange={e=>setLinkUrl(e.target.value)} placeholder="URL (z.B. https://g.page/r/...)" style={{...IS,marginBottom:8,fontSize:12}}/>
                  <div style={{display:"flex",gap:8}}>
                    <button style={btn(T,"primary")} onClick={()=>{if(linkUrl){insertAtCursor(`[${linkLabel||linkUrl}](${linkUrl})`);}setLinkDlg(false);}}>Einfügen</button>
                    <button style={btn(T,"ghost")} onClick={()=>setLinkDlg(false)}>Abbrechen</button>
                  </div>
                </div>
              )}
              {/* Bild-Dialog */}
              {imgDlg&&(
                <div style={{background:T.bg,border:`1px solid ${T.accent}`,borderRadius:8,padding:12,marginBottom:8}}>
                  <div style={{fontSize:12,fontWeight:600,color:T.accent,marginBottom:8}}>🖼 Bild einfügen</div>
                  <input value={imgUrl} onChange={e=>setImgUrl(e.target.value)} placeholder="Bild-URL (https://...)" style={{...IS,marginBottom:6,fontSize:12}}/>
                  <input value={imgAlt} onChange={e=>setImgAlt(e.target.value)} placeholder="Beschreibung (optional)" style={{...IS,marginBottom:8,fontSize:12}}/>
                  <label style={{...btn(T,"ghost"),cursor:"pointer",display:"inline-block",marginBottom:8,fontSize:11}}>
                    📁 Bild hochladen
                    <input type="file" accept="image/*" style={{display:"none"}} onChange={e=>{
                      const file=e.target.files?.[0];if(!file)return;
                      const reader=new FileReader();
                      reader.onload=ev=>{setImgUrl(ev.target.result);};
                      reader.readAsDataURL(file);
                    }}/>
                  </label>
                  <div style={{display:"flex",gap:8}}>
                    <button style={btn(T,"primary")} onClick={()=>{if(imgUrl){insertAtCursor(`![${imgAlt||"Bild"}](${imgUrl})`);}setImgDlg(false);}}>Einfügen</button>
                    <button style={btn(T,"ghost")} onClick={()=>setImgDlg(false)}>Abbrechen</button>
                  </div>
                </div>
              )}
              <textarea id="sd-vorlage-ta" value={v.text||""} onChange={e=>sv(akt,"text",e.target.value)} rows={14}
                data-ta-key={`email_vorlage_${akt}`} style={{...IS,fontFamily:fmt.font,fontSize:fmt.size,color:fmt.color,resize:"vertical",lineHeight:v.lineHeight||1.7}}/>
              <div style={{fontSize:11,color:T.muted,marginTop:4}}>{"Platzhalter: {{name}} {{vorname}} {{datum}} {{uhrzeit}} {{shooting}} {{event}} {{preis}} {{ort}} {{location}} {{studio}} {{link}} {{bewertung_link}} {{feedback_link}}"}</div>
              {akt==="vertragsmail"&&(
                <div style={{fontSize:11,color:T.muted,marginTop:6,lineHeight:1.6,background:T.bg,border:`1px solid ${T.border}`,borderRadius:6,padding:"8px 10px"}}>
                  In der Vertragsmail werden gefüllt: {"{{name}} {{vorname}} {{datum}} {{uhrzeit}} {{ort}} {{location}} {{maps}} {{preis}} {{tier}} {{rasse}} {{studio}} {{link}}"} — die Werte stammen aus dem Vertragsfenster. {"{{maps}}"} wird zum Kartenlink des Shootingorts, sofern einer hinterlegt ist. Andere Platzhalter bleiben leer und verschwinden.
                </div>
              )}
              <div style={{fontSize:11,color:T.muted,marginTop:2}}>{"Links: [Linktext](URL) · Bilder: ![Alt](URL)"}</div>
              {/* Signatur */}
              <div style={{marginTop:14,padding:12,background:T.bg,borderRadius:8,border:`1px solid ${T.border}`}}>
                <div style={{fontSize:11,color:T.muted,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.07em",marginBottom:8}}>Signatur & Logo</div>
                <div style={{display:"grid",gridTemplateColumns:"1fr auto",gap:10,alignItems:"start"}}>
                  <textarea value={sig.text||""} onChange={e=>saveSig("text",e.target.value)} rows={3} placeholder={"Markus Heber Photography\nTel: 0911 123456\nwww.m-h-photo.de"}
                    style={{...IS,resize:"vertical",lineHeight:1.5,fontSize:12}}/>
                  <div style={{display:"flex",flexDirection:"column",gap:5,alignItems:"center"}}>
                    {sig.logo&&<img src={sig.logo} style={{maxHeight:50,maxWidth:120,borderRadius:4,border:`1px solid ${T.border}`}} alt="Logo"/>}
                    <label style={{...btn(T,"ghost"),cursor:"pointer",fontSize:11,padding:"4px 8px",textAlign:"center",whiteSpace:"nowrap"}}>
                      {sig.logo?"Logo ändern":"📷 Logo"}
                      <input type="file" accept="image/*" style={{display:"none"}} onChange={e=>{
                        const file=e.target.files?.[0];if(!file)return;
                        const reader=new FileReader();reader.onload=ev=>saveSig("logo",ev.target.result);reader.readAsDataURL(file);
                      }}/>
                    </label>
                    {sig.logo&&<button style={{...btn(T,"ghost"),fontSize:10,padding:"2px 6px",color:"#e55"}} onClick={()=>saveSig("logo","")}>✕</button>}
                  </div>
                </div>
              </div>
              <div style={{display:"flex",gap:8,marginTop:10}}>
                <button style={btn(T,prev?"primary":"ghost")} onClick={()=>{const n=!prev;setPrev(n);localStorage.setItem("sd_email_prev",n?"1":"0");}}>{prev?"👁 Vorschau aus":"👁 Vorschau"}</button>
                <button style={btn(T,"ghost")} onClick={()=>{if(confirm("Vorlage zurücksetzen?"))sv(akt,"text",DEF[akt]?.text||"");}}>↺ Standard</button>
              </div>
            </div>
            {/* Rechte Spalte: Vorschau */}
            {prev&&(
            <div>
              <label style={{fontSize:11,color:T.muted,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.07em",display:"block",marginBottom:6}}>Vorschau</label>
              <div style={{background:"#fff",border:`1px solid ${T.border}`,borderRadius:8,padding:20,minHeight:200,position:"sticky",top:16}}>
                {gfLink&&<link rel="stylesheet" href={gfLink}/>}
                <div style={{fontSize:11,color:"#8A8075",marginBottom:8,fontFamily:"sans-serif"}}>Betreff: <strong>{(v.betreff||"").replace(/\{\{(\w+)\}\}/g,(_,k)=>bsp[k]||`{{${k}}}`)}</strong></div>
                <div dangerouslySetInnerHTML={{__html:buildPreviewHtml()}}/>
              </div>
            </div>
            )}
          </div>
          {/* Automatisierungs-Einstellungen */}
          <div style={{fontSize:12,fontWeight:600,color:T.accent,margin:"16px 0 10px",fontFamily:"Georgia,serif"}}>⏰ Automatische Mails</div>
          {/* Zwei Reihen, drei Spalten: oben die drei Zeitplaene, darunter die
              Ausloeser und die Einzeltermin-Erinnerung. Alle Zellen gleich breit,
              die Reihen jeweils gleich hoch. */}
          <div style={{display:"grid",gridTemplateColumns:"repeat(3, minmax(0,1fr))",gap:16,alignItems:"stretch"}}>
            <ZeitBlock label="Erinnerungsmail (vor dem Shooting)" state={erinnerung} onSave={saveEr} showBewertung={false} richtung="vor" felder="tage" voll/>
            <ZeitBlock label="Danke-Mail (nach dem Shooting)" state={danke} onSave={saveDa} showBewertung={true} richtung="nach" felder="stunden" voll/>
              <ZeitBlock label="Feedback-Mail" state={feedback} onSave={saveFb} showBewertung={false} richtung="nach" felder="tage" extraFelder={[{key:"feedbackLink",label:"Feedback-Link",placeholder:"https://forms.gle/..."}]} voll/>
            <ZeitBlock label="Erinnerung Bildauswahl (Einzeltermine)" state={bildauswahl} onSave={saveBa} showBewertung={false} richtung="nach" felder="tage" voll/>
              <div style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:14}}>
                <div style={{fontSize:12,fontWeight:600,color:T.text,marginBottom:10}}>Versand-Auslöser</div>
                {["galerielink","shooting"].map(m=>(
                  <label key={m} style={{display:"flex",alignItems:"center",gap:8,fontSize:13,color:T.text,marginBottom:8,cursor:"pointer"}}>
                    <input type="radio" name="ba_trigger" checked={(bildauswahl.triggerMode||"galerielink")===m}
                      onChange={()=>saveBa({...bildauswahl,triggerMode:m})}
                      style={{accentColor:T.accent}}/>
                    {m==="galerielink"?"X Tage nach Galerielink verschickt (empfohlen)":"X Tage nach Shooting-Datum"}
                  </label>
                ))}
                <div style={{fontSize:11,color:T.muted,marginTop:4}}>
                  Geht nur raus, solange kein Bestelldatum eingetragen und die Auswahl nicht abgeschlossen ist.
                  Verwendet die Vorlage „Erinnerung Einzel: Bildauswahl".
                </div>
              </div>
              <div style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:14}}>
                <div style={{fontSize:12,fontWeight:600,color:T.text,marginBottom:10}}>Versand-Auslöser</div>
                {["abgeschlossen","datum"].map(m=>(
                  <label key={m} style={{display:"flex",alignItems:"center",gap:8,fontSize:13,color:T.text,marginBottom:8,cursor:"pointer"}}>
                    <input type="radio" name="fb_trigger" checked={(feedback.triggerMode||"abgeschlossen")===m}
                      onChange={()=>saveFb({...feedback,triggerMode:m})}
                      style={{accentColor:T.accent}}/>
                    {m==="abgeschlossen"?"Nach Abschluss in der Abrechnung (empfohlen)":"X Tage nach Shooting-Datum"}
                  </label>
                ))}
                <div style={{fontSize:11,color:T.muted,marginTop:4}}>
                  {(feedback.triggerMode||"abgeschlossen")==="abgeschlossen"
                    ?"Mail wird gesendet wenn 'Abgeschlossen' gesetzt wurde + X Tage vergangen sind."
                    :"Mail wird X Tage nach dem Shooting-Datum gesendet."}
                </div>
                <label style={{display:"flex",alignItems:"center",gap:8,fontSize:13,color:T.text,marginTop:12,cursor:"pointer"}}>
                  <input type="checkbox" checked={feedback.einzeltermine!==false}
                    onChange={e=>saveFb({...feedback,einzeltermine:e.target.checked})}
                    style={{accentColor:T.accent}}/>
                  Auch an Einzeltermine senden
                </label>
                <div style={{fontSize:11,color:T.muted,marginTop:4}}>
                  Erinnerung und Danke gehen nur an Veranstaltungsteilnehmer.
                </div>
              </div>
          </div>
          {amOffen&&(
            <div style={{position:"fixed",top:16,left:"50%",transform:"translateX(-50%)",zIndex:9999,
              background:"#f59e0b",color:"#1a1814",padding:"10px 16px",borderRadius:8,
              boxShadow:"0 4px 16px rgba(0,0,0,0.25)",display:"flex",alignItems:"center",gap:12,
              fontSize:12,fontWeight:600,maxWidth:"90vw"}}>
              <span>Vorlage geändert — der Server kennt den neuen Text noch nicht.</span>
              <button onClick={()=>pushAutoMail()} style={{background:"#1a1814",color:"#fff",border:"none",
                borderRadius:6,padding:"6px 12px",fontSize:12,fontWeight:600,cursor:"pointer",fontFamily:"inherit"}}>Jetzt übertragen</button>
              <button onClick={()=>setAmOffen(false)} style={{background:"none",border:"none",cursor:"pointer",
                fontSize:14,color:"#1a1814",fontWeight:700,padding:"2px 4px"}}>✕</button>
            </div>
          )}
          <div style={{display:"flex",gap:10,alignItems:"center",marginTop:10,flexWrap:"wrap"}}>
            <button style={btn(T,"primary")} onClick={()=>pushAutoMail()}>Einstellungen zum Server übertragen</button>
            <button style={btn(T,"ghost")} onClick={async()=>{
              const srv=(localStorage.getItem("sd_server_url")||"").trim().replace(/\/+$/,"");
              if(!srv){alert("Keine Server-URL hinterlegt.");return;}
              const ok=await pushAutoMail();
              if(!ok){alert("Einstellungen konnten nicht übertragen werden.");return;}
              setAmStatus("Probelauf läuft …");
              try{
                const r=await fetch(srv+"/api/auto-mail-check?dry=1",{method:"POST",headers:{"Content-Type":"application/json"},body:"{}"});
                const d=await r.json();
                setAmStatus("");
                const liste=(d.probelauf||[]);
                alert("Probelauf (es wurde nichts verschickt)\n\nF\u00e4llig: "+liste.length+"\n\n"+(liste.slice(0,25).join("\n")||"\u2014"));
              }catch(e){setAmStatus("");alert("Probelauf fehlgeschlagen: "+e);}
            }}>Probelauf</button>
            <span style={{fontSize:11,color:T.muted}}>{amStatus}</span>
          </div>
          <div style={{fontSize:11,color:T.muted,marginTop:8,lineHeight:1.6}}>
            Der Server prüft täglich per Cronjob und verschickt die Mails zum eingestellten Zeitpunkt.
            Erinnerung, Danke und Feedback gehen an Veranstaltungsteilnehmer, Feedback zusätzlich an Einzeltermine.
            Geänderte Einstellungen und Vorlagen wirken erst, wenn sie übertragen wurden.
          </div>
        </div>
        );
      })()}
    </>),
    google_cal:(()=>{
      const [gcfg,setGcfg]=useState(()=>{try{return JSON.parse(localStorage.getItem("sd_google_cal")||"null")||{client_id:"",client_secret:"",calendar_id:"primary",event_color:"#1a73e8"};}catch{return {client_id:"",client_secret:"",calendar_id:"primary",event_color:"#1a73e8"};}});
      const [gStatus,setGStatus]=useState(null);
      const sv=localStorage.getItem("sd_server_url")||"";
      function saveGcfg(v){setGcfg(v);localStorage.setItem("sd_google_cal",JSON.stringify(v));}
      function checkStatus(){
        if(!sv){setGStatus("no_server");return;}
        fetch(sv+"/api/google-status").then(r=>r.json()).then(d=>setGStatus(d.connected?"connected":"not_connected")).catch(()=>setGStatus("error"));
      }
      function saveConfig(){
        if(!sv){alert("Keine Server-URL konfiguriert.");return;}
        fetch(sv+"/api/google-config",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({client_id:gcfg.client_id,client_secret:gcfg.client_secret})})
        .then(r=>r.json()).then(d=>{if(d.ok)alert("✅ Konfiguration gespeichert!");else alert("Fehler: "+d.error);}).catch(e=>alert("Fehler: "+e.message));
      }
      function connectGoogle(){
        if(!gcfg.client_id){alert("Bitte zuerst Client-ID eintragen und speichern.");return;}
        const authUrl="https://accounts.google.com/o/oauth2/v2/auth?"+
          "client_id="+encodeURIComponent(gcfg.client_id)+
          "&redirect_uri="+encodeURIComponent("https://buchen.m-h-photo.de/api/google-callback")+
          "&response_type=code&scope="+encodeURIComponent("https://www.googleapis.com/auth/calendar")+
          "&access_type=offline&prompt=consent";
        window.open(authUrl,"_blank");
      }
      function syncEvents(){
        if(!sv){alert("Keine Server-URL konfiguriert.");return;}
        const evts=JSON.parse(localStorage.getItem("sd_events")||"[]");
        const heute=new Date();heute.setHours(0,0,0,0);
        const kommend=evts.filter(e=>e.date&&new Date(e.date)>=heute&&!e.abgeschlossen);
        if(!kommend.length){alert("Keine zukünftigen Veranstaltungen gefunden.");return;}
        // Anreise/Abreise als Start/Ende verwenden wenn vorhanden
        const buchCfg=JSON.parse(localStorage.getItem("sd_buchung_config")||"null");
        const mapped=kommend.map(e=>{
          const st=(buchCfg?.shootingTypes||[]).find(s=>s.eventId===e.id);
          return {...e,
            exportStart:e.anreise||e.date,
            exportEnd:e.abreise||e.dateBis||e.date,
            hp_von:st?.hp_von||"",
            hp_bis:st?.hp_bis||""
          };
        });
        fetch(sv+"/api/google-sync",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({events:mapped,calendarId:gcfg.calendar_id||"primary"})})
        .then(r=>r.json()).then(d=>{
          if(d.ok){const ok=d.results.filter(r=>r.ok).length;const fail=d.results.filter(r=>!r.ok).length;
          alert("✅ "+ok+" Events exportiert"+(fail?" · "+fail+" Fehler":"")+".");}
          else alert("Fehler: "+d.error);
        }).catch(e=>alert("Fehler: "+e.message));
      }
      function importFromGoogle(){
        if(!sv){alert("Keine Server-URL konfiguriert.");return;}
        localStorage.removeItem("sd_google_events");
        fetch(sv+"/api/google-import?calendarId="+(gcfg.calendar_id||"primary"))
        .then(r=>r.json()).then(d=>{
          if(d.ok){
            localStorage.setItem("sd_google_events",JSON.stringify(d.events));
            alert("✅ "+d.events.length+" Termine aus Google Kalender importiert.");
          }else alert("Fehler: "+d.error);
        }).catch(e=>alert("Fehler: "+e.message));
      }
      useEffect(()=>{checkStatus();},[]);
      return(<>
        <div style={{background:T.surface,borderRadius:12,border:`1px solid ${T.border}`,padding:20,marginBottom:16}}>
          <div style={{fontSize:14,fontWeight:700,color:T.accent,marginBottom:12}}>📅 Google Kalender</div>
          <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:16,padding:"10px 14px",borderRadius:8,background:gStatus==="connected"?"#4caf5022":T.bg,border:`1px solid ${gStatus==="connected"?"#4caf50":T.border}`}}>
            <span style={{fontSize:18}}>{gStatus==="connected"?"✅":"🔴"}</span>
            <span style={{fontSize:13,color:T.text}}>{gStatus==="connected"?"Verbunden mit Google Kalender":gStatus==="not_connected"?"Nicht verbunden":gStatus==="no_server"?"Server-URL fehlt":"Status unbekannt"}</span>
            <button style={{...btn(T,"ghost",true),marginLeft:"auto",fontSize:11}} onClick={checkStatus}>Aktualisieren</button>
          </div>
          <div style={{display:"flex",flexDirection:"column",gap:10}}>
            <div>
              <label style={{fontSize:12,color:T.muted,fontWeight:600,display:"block",marginBottom:5}}>Client-ID</label>
              <input value={gcfg.client_id||""} onChange={e=>saveGcfg({...gcfg,client_id:e.target.value.trim()})} placeholder="...apps.googleusercontent.com" style={IS}/>
            </div>
            <div>
              <label style={{fontSize:12,color:T.muted,fontWeight:600,display:"block",marginBottom:5}}>Client Secret</label>
              <input value={gcfg.client_secret||""} onChange={e=>saveGcfg({...gcfg,client_secret:e.target.value.trim()})} type="password" style={IS}/>
            </div>
            <div>
              <label style={{fontSize:12,color:T.muted,fontWeight:600,display:"block",marginBottom:5}}>Kalender-ID (primary = Hauptkalender)</label>
              <input value={gcfg.calendar_id||"primary"} onChange={e=>saveGcfg({...gcfg,calendar_id:e.target.value.trim()})} placeholder="primary" style={IS}/>
            </div>
            <button style={btn(T,"primary")} onClick={saveConfig}>💾 Konfiguration speichern</button>
            <div style={{marginTop:8}}>
              <label style={{fontSize:12,color:T.muted,fontWeight:600,display:"block",marginBottom:5}}>Farbe Google-Termine im Kalender</label>
              <div style={{display:"flex",gap:8,alignItems:"center"}}>
                <input type="color" value={gcfg.event_color||"#1a73e8"} onChange={e=>saveGcfg({...gcfg,event_color:e.target.value})} style={{width:40,height:32,cursor:"pointer"}}/>
                <input value={gcfg.event_color||"#1a73e8"} onChange={e=>saveGcfg({...gcfg,event_color:e.target.value})} style={{...IS,flex:1,fontFamily:"monospace",fontSize:12}}/>
              </div>
            </div>
            {gStatus!=="connected"
              ?<button style={btn(T,"ghost")} onClick={connectGoogle}>🔗 Mit Google verbinden</button>
              :<div style={{display:"flex",flexDirection:"column",gap:8}}>
                <button style={btn(T,"primary")} onClick={syncEvents}>📤 Veranstaltungen → Google exportieren</button>
                <button style={btn(T,"ghost")} onClick={importFromGoogle}>📥 Termine von Google importieren</button>
              </div>
            }
          </div>
        </div>
      </>);
    })(),
    rassen:(<>
      {(()=>{
        const RKEY="sd_rassen_profil";
        const [rp,setRp]=useState(()=>{try{return JSON.parse(localStorage.getItem(RKEY)||"{}")||{};}catch{return {};}});
        function saveRp(v){setRp(v);localStorage.setItem(RKEY,JSON.stringify(v));}
        const rassen=rp.rassen||[];
        const [neu,setNeu]=useState("");
        const [suche,setSuche]=useState("");
        const gefiltert=rassen.filter(r=>r.toLowerCase().includes(suche.toLowerCase()));
        function addRasse(){
          const r=neu.trim();
          if(!r||rassen.includes(r))return;
          saveRp({...rp,rassen:[...rassen,r].sort()});
          setNeu("");
        }
        function delRasse(r){saveRp({...rp,rassen:rassen.filter(x=>x!==r)});}
        function importTxt(e){
          const file=e.target.files[0];if(!file)return;
          const reader=new FileReader();
          reader.onload=ev=>{
            const lines=ev.target.result.split(/\r?\n/).map(l=>l.trim()).filter(Boolean);
            const merged=[...new Set([...rassen,...lines])].sort();
            saveRp({...rp,rassen:merged});
            alert(`${lines.length} Rassen importiert (${merged.length} gesamt)`);
          };
          reader.readAsText(file);
        }
        return(
          <div>
            <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:12,padding:20,marginBottom:16}}>
              <div style={{fontFamily:"Georgia,serif",fontSize:15,color:T.accent,marginBottom:12}}>🐕 Rassen verwalten</div>
              <div style={{display:"flex",gap:8,marginBottom:12}}>
                <input value={neu} onChange={e=>setNeu(e.target.value)} onKeyDown={e=>e.key==="Enter"&&addRasse()}
                  placeholder="Neue Rasse hinzufügen..."
                  style={{flex:1,background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:"8px 12px",color:T.text,fontSize:13,outline:"none"}}/>
                <button style={btn(T,"primary",true)} onClick={addRasse}>+ Hinzufügen</button>
              </div>
              <div style={{display:"flex",gap:8,marginBottom:12,alignItems:"center"}}>
                <input value={suche} onChange={e=>setSuche(e.target.value)} placeholder="Suchen..."
                  style={{flex:1,background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:"7px 12px",color:T.text,fontSize:12,outline:"none"}}/>
                <label style={{...btn(T,"ghost",true),cursor:"pointer",whiteSpace:"nowrap"}}>
                  📂 TXT importieren
                  <input type="file" accept=".txt,.csv" style={{display:"none"}} onChange={importTxt}/>
                </label>
                <button style={btn(T,"ghost",true)} onClick={()=>{
                  const txt=rassen.join("\n");
                  const a=document.createElement("a");a.href=URL.createObjectURL(new Blob([txt],{type:"text/plain"}));
                  a.download="rassen.txt";a.click();
                }}>💾 Exportieren</button>
              </div>
              <div style={{fontSize:12,color:T.muted,marginBottom:8}}>{gefiltert.length} von {rassen.length} Rassen</div>
              <div style={{maxHeight:400,overflowY:"auto",display:"flex",flexWrap:"wrap",gap:6}}>
                {gefiltert.map(r=>(
                  <div key={r} style={{display:"flex",alignItems:"center",gap:4,background:T.bg,border:`1px solid ${T.border}`,borderRadius:20,padding:"4px 10px"}}>
                    <span style={{fontSize:12,color:T.text}}>{r}</span>
                    <button onClick={()=>delRasse(r)} style={{background:"none",border:"none",color:T.muted,cursor:"pointer",fontSize:13,padding:"0 0 0 4px",lineHeight:1}}
                      onMouseEnter={e=>e.currentTarget.style.color="#e53"}
                      onMouseLeave={e=>e.currentTarget.style.color=T.muted}>×</button>
                  </div>
                ))}
              </div>
            </div>
          </div>
        );
      })()}
    </>),
    backup:(<>
      {(()=>{
        // Alle sd_* Keys aus localStorage sichern
        const KEYS=Object.keys(localStorage).filter(k=>k.startsWith("sd_"));
        const serverUrl=(localStorage.getItem("sd_server_url")||"").replace(/\/+$/,"");
        const [syncStatus,setSyncStatus]=useState("");
        function doBackup(){
          const data={};
          KEYS.forEach(k=>{const v=localStorage.getItem(k);if(v)data[k]=v;});
          const json=JSON.stringify(data,null,2);
          const date=new Date().toISOString().slice(0,10);
          const a=document.createElement("a");
          a.href=URL.createObjectURL(new Blob([json],{type:"application/json"}));
          a.download=`scattodesk_backup_${date}.json`;
          a.click();
          alert("✅ Backup gespeichert!");
        }
        async function syncToServer(){
          if(!serverUrl){alert("Bitte zuerst Server-URL in den Einstellungen eintragen.");return;}
          const data={};
          Object.keys(localStorage).filter(k=>k.startsWith("sd_")).forEach(k=>{const v=localStorage.getItem(k);if(v)data[k]=v;});
          setSyncStatus("⏳ Wird gespeichert...");
          try{
            const r=await fetch(`${serverUrl}/api/localstorage-backup`,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({data})});
            const d=await r.json();
            if(d.ok)setSyncStatus("✅ Auf Server gesichert: "+new Date().toLocaleString("de-DE"));
            else setSyncStatus("❌ Fehler: "+d.error);
          }catch(e){setSyncStatus("❌ "+e.message);}
        }
        async function syncFromServer(){
          if(!serverUrl){alert("Bitte zuerst Server-URL eintragen.");return;}
          if(!confirm("Einstellungen vom Server laden? Aktuelle lokale Einstellungen werden überschrieben."))return;
          setSyncStatus("⏳ Wird geladen...");
          try{
            const r=await fetch(`${serverUrl}/api/localstorage-backup`);
            const d=await r.json();
            if(d.ok&&d.data){
              Object.entries(d.data).forEach(([k,v])=>localStorage.setItem(k,v));
              setSyncStatus("✅ Vom Server geladen!");
              setTimeout(()=>window.location.reload(),1000);
            }else setSyncStatus("❌ "+(d.error||"Keine Daten auf Server"));
          }catch(e){setSyncStatus("❌ "+e.message);}
        }
        const dateiRef=useRef(null);
        const [einfuegen,setEinfuegen]=useState(false);
        const [rohText,setRohText]=useState("");
        function uebernehmen(text,quelle,schonBestaetigt){
          try{
            let data=JSON.parse(text);
            // Backups vom Server liegen in einer Huelle {datum, daten:{...}}.
            if(data&&data.daten&&typeof data.daten==="object")data=data.daten;
            if(!schonBestaetigt&&!confirm(`Backup ${quelle} wiederherstellen? Aktuelle Daten werden überschrieben.`))return;
            Object.entries(data).forEach(([k,v])=>localStorage.setItem(k,typeof v==="string"?v:JSON.stringify(v)));
            const srvUrl=(localStorage.getItem("sd_server_url")||"").replace(/\/+$/,"");
            if(srvUrl){
              fetch(`${srvUrl}/api/gen-landings`,{method:"POST",headers:{"Content-Type":"application/json"},body:"{}"}).catch(()=>{});
            }
            alert("✅ Backup wiederhergestellt! Seite wird neu geladen.");
            window.location.reload();
          }catch(err){alert("❌ Ungültige Backup-Datei: "+(err&&err.message||err));}
        }
        function doRestore(e){
          const file=e.target.files[0];if(!file)return;
          const reader=new FileReader();
          reader.onerror=()=>alert("❌ Datei konnte nicht gelesen werden.");
          reader.onload=ev=>{
            try{
              const data=JSON.parse(ev.target.result);
              if(!confirm(`Backup vom ${file.name} wiederherstellen? Aktuelle Daten werden überschrieben.`))return;
              Object.entries(data).forEach(([k,v])=>localStorage.setItem(k,v));
              const srvUrl=(localStorage.getItem("sd_server_url")||"").replace(/\/+$/,"");
              if(srvUrl){
                fetch(`${srvUrl}/api/gen-landings`,{method:"POST",headers:{"Content-Type":"application/json"},body:"{}"})
                  .then(()=>console.log("Landingpages neu generiert"))
                  .catch(()=>console.log("gen-landings nicht verfügbar"));
              }
              alert("✅ Backup wiederhergestellt! Seite wird neu geladen.");
              window.location.reload();
            }catch{alert("❌ Ungültige Backup-Datei.");}
          };
          reader.readAsText(file);
        }
        return(
          <div>
            <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:12,padding:24,marginBottom:16}}>
              <div style={{fontFamily:"Georgia,serif",fontSize:15,color:T.accent,marginBottom:8}}>☁️ Server-Sync (Einstellungen)</div>
              <div style={{fontSize:13,color:T.muted,marginBottom:16}}>Speichert alle lokalen Einstellungen (Layout, Vorlagen, Logo, Schriften usw.) auf dem Server — so sind sie auf jedem Rechner verfügbar.</div>
              <div style={{display:"flex",gap:10,flexWrap:"wrap",marginBottom:12}}>
                <button style={{...btn(T,"primary")}} onClick={syncToServer}>☁️ Einstellungen auf Server sichern</button>
                <button style={{...btn(T,"ghost")}} onClick={syncFromServer}>⬇️ Einstellungen vom Server laden</button>
              </div>
              {syncStatus&&<div style={{fontSize:12,color:syncStatus.startsWith("✅")?"#4caf50":"#e53",marginTop:4}}>{syncStatus}</div>}
            </div>
            <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:12,padding:24,marginBottom:16}}>
              <div style={{fontFamily:"Georgia,serif",fontSize:15,color:T.accent,marginBottom:8}}>💾 Lokales Backup</div>
              <div style={{fontSize:13,color:T.muted,marginBottom:20}}>Sichere alle ScattoDesk-Daten als JSON-Datei auf deinem PC.</div>
              <button style={{...btn(T,"primary"),marginBottom:24}} onClick={doBackup}>💾 Backup erstellen & herunterladen</button>
              <div style={{borderTop:`1px solid ${T.border}`,paddingTop:20}}>
                <div style={{fontFamily:"Georgia,serif",fontSize:15,color:T.accent,marginBottom:8}}>📂 Wiederherstellen</div>
                <div style={{fontSize:13,color:T.muted,marginBottom:12}}>Lade eine Backup-Datei hoch um alle Daten wiederherzustellen.</div>
                {/* Android ignoriert einen .click() auf ein Feld mit display:none.
                    Deshalb liegt das Dateifeld hier unsichtbar, aber vorhanden
                    ueber dem Knopf: der Fingertipp trifft direkt das Feld.
                    Kein accept-Filter, sonst blendet Android Drive-Dateien aus. */}
                <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
                  <label style={{...btn(T,"ghost",true),position:"relative",overflow:"hidden",cursor:"pointer",display:"inline-flex"}}>
                    📂 Backup-Datei auswählen
                    <input ref={dateiRef} type="file" onChange={doRestore}
                      style={{position:"absolute",inset:0,width:"100%",height:"100%",
                              opacity:0,cursor:"pointer",fontSize:"100px"}}/>
                  </label>
                  <button type="button" style={{...btn(T,"ghost",true)}}
                    onClick={()=>setEinfuegen(v=>!v)}>
                    📋 Backup-Text einfügen
                  </button>
                </div>

                {/* Vorfuehrgeraete: Musterdaten stecken fest in der App, damit
                    auf dem Tablet weder Dateiwaehler noch Server noetig sind. */}
                <div style={{marginTop:20,paddingTop:18,borderTop:`1px solid ${T.border}`}}>
                  <div style={{fontFamily:"Georgia,serif",fontSize:15,color:T.accent,marginBottom:8}}>🧪 Musterdaten</div>
                  <div style={{fontSize:13,color:T.muted,marginBottom:12,lineHeight:1.5}}>
                    30 erfundene Kunden, 3 Veranstaltungen, 2 Einzeltermine — zum Vorführen.
                    Überschreibt alle Daten auf diesem Gerät. Nicht auf dem Arbeitsrechner benutzen.
                  </div>
                  <button type="button" style={{...btn(T,"ghost",true)}}
                    onClick={()=>{
                      if(!window.confirm("Musterdaten laden?\n\nAlle Daten auf DIESEM Gerät werden überschrieben. Nur für Vorführgeräte gedacht."))return;
                      uebernehmen(MUSTERDATEN_JSON,"Musterdaten",true);
                    }}>
                    🧪 Musterdaten laden
                  </button>
                </div>

                {einfuegen&&(
                  <div style={{marginTop:12}}>
                    <div style={{fontSize:12,color:T.muted,marginBottom:6,lineHeight:1.5}}>
                      Backup-Datei auf dem Tablet öffnen, gesamten Inhalt kopieren und hier einfügen.
                    </div>
                    <textarea value={rohText} onChange={e=>setRohText(e.target.value)}
                      placeholder='{"sd_customers": ...'
                      style={{width:"100%",minHeight:120,background:T.bg,color:T.text,
                              border:`1px solid ${T.border}`,borderRadius:8,padding:10,
                              fontSize:12,fontFamily:"monospace",resize:"vertical"}}/>
                    <button type="button" style={{...btn(T,"primary",true),marginTop:8}}
                      disabled={!rohText.trim()}
                      onClick={()=>uebernehmen(rohText,"aus dem Textfeld")}>
                      Wiederherstellen
                    </button>
                  </div>
                )}

              </div>
            </div>
            <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:12,padding:20}}>
              <div style={{fontFamily:"Georgia,serif",fontSize:15,color:T.accent,marginBottom:12}}>🗑️ Daten löschen</div>
              <div style={{fontSize:13,color:T.muted,marginBottom:12}}>Einzelne Datenbereiche zurücksetzen.</div>
              <div style={{display:"flex",flexWrap:"wrap",gap:8}}>
                {[["Kunden","sd_customers"],["Buchungen","sd_buchungen"],["Events","sd_events"],["Shootingpläne","sd_shootingplaene"]].map(([label,key])=>(
                  <button key={key} style={{...btn(T,"ghost",true),fontSize:12,color:"#e53"}} onClick={()=>{
                    if(confirm(`Alle ${label} wirklich löschen?`)){localStorage.removeItem(key);alert(`${label} gelöscht.`);window.location.reload();}
                  }}>🗑️ {label} löschen</button>
                ))}
              </div>
            </div>
          </div>
        );
      })()}
    </>),

    kontakte_REMOVED:(<>
      {(()=>{
        const leerK=()=>({id:uid()});
        const [kontakte,setKontakte]=useState([]);
        const [editK,setEditK]=useState(null);
        const [form,setFormK]=useState(leerK());
        const saveK=(neu)=>{};
        const [taH,setTaH]=useState({});
        const saveTaH=(k,h)=>{};
        const fk=(k,v)=>{};
        const IS2={};
        const LB={};
        if(editK!==null){
          const isNew=editK==="new";
          return(
            <div style={{maxWidth:720}}>
              <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:20}}>
                <button style={btn(T,"ghost",true)} onClick={()=>setEditK(null)}>← Zurück</button>
                <div style={{fontFamily:"Georgia,serif",fontSize:17,color:T.accent}}>{isNew?"Neuer Kontakt":"Kontakt bearbeiten"}</div>
              </div>
              <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:12,padding:24,display:"flex",flexDirection:"column",gap:14}}>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
                  <div><span style={LB}>Name</span><input value={form.name} onChange={e=>fk("name",e.target.value)} placeholder="Sina Wittmann" style={IS2}/></div>
                  <div><span style={LB}>Firma</span><input value={form.firma} onChange={e=>fk("firma",e.target.value)} placeholder="Naturfutterladen Tierlieb" style={IS2}/></div>
                </div>
                <div><span style={LB}>Straße</span><input value={form.strasse} onChange={e=>fk("strasse",e.target.value)} placeholder="Musterstraße 1" style={IS2}/></div>
                <div style={{display:"grid",gridTemplateColumns:"120px 1fr",gap:12}}>
                  <div><span style={LB}>PLZ</span><input value={form.plz} onChange={e=>{
                    const plz=e.target.value.replace(/[^0-9]/g,"");fk("plz",plz);
                    if(plz.length===5){fetch(`https://api.zippopotam.us/de/${plz}`).then(r=>r.ok?r.json():null).then(d=>{if(d?.places?.[0])fk("ort",d.places[0]["place name"]);}).catch(()=>{});}
                  }} placeholder="90429" style={IS2} maxLength={5}/></div>
                  <div><span style={LB}>Ort</span><input value={form.ort} onChange={e=>fk("ort",e.target.value)} placeholder="Nürnberg" style={IS2}/></div>
                </div>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:12}}>
                  <div><span style={LB}>Handy</span><input value={form.handy} onChange={e=>fk("handy",e.target.value)} placeholder="+49 151 12345678" style={IS2}/></div>
                  <div><span style={LB}>Telefon</span><input value={form.telefon||""} onChange={e=>fk("telefon",e.target.value)} placeholder="+49 911 123456" style={IS2}/></div>
                  <div><span style={LB}>E-Mail</span><input value={form.email} onChange={e=>fk("email",e.target.value)} placeholder="info@firma.de" style={IS2}/></div>
                </div>
                <div><span style={LB}>Homepage</span><input value={form.homepage} onChange={e=>fk("homepage",e.target.value)} placeholder="www.firma.de" style={IS2}/></div>
                <div>
                  <span style={LB}>Öffnungszeiten</span>
                  <textarea value={form.oeffnungszeiten||""} onChange={e=>fk("oeffnungszeiten",e.target.value)}
                    placeholder="Mo-Fr 9-18 Uhr, Sa 10-14 Uhr"
                    onMouseUp={e=>saveTaH("oeffnungszeiten",e.target.offsetHeight)}
                    style={{...IS2,resize:"vertical",minHeight:60,lineHeight:1.5,height:taH.oeffnungszeiten||60}}/>
                </div>
                <div>
                  <span style={LB}>Sonstiges</span>
                  <textarea value={form.sonstiges||""} onChange={e=>fk("sonstiges",e.target.value)}
                    placeholder="Notizen, Besonderheiten..."
                    onMouseUp={e=>saveTaH("sonstiges",e.target.offsetHeight)}
                    style={{...IS2,resize:"vertical",minHeight:60,lineHeight:1.5,height:taH.sonstiges||60}}/>
                </div>
                <div style={{display:"flex",gap:8,marginTop:4}}>
                  <button onClick={()=>{
                    if(!form.name&&!form.firma){alert("Bitte Name oder Firma angeben.");return;}
                    if(isNew){saveK([...kontakte,form]);}else{saveK(kontakte.map(k=>k.id===form.id?form:k));}
                    setEditK(null);
                  }} style={{background:T.accent,color:"#fff",border:"none",borderRadius:8,padding:"10px 20px",fontSize:13,fontWeight:600,cursor:"pointer"}}>Speichern</button>
                  {!isNew&&<button onClick={()=>{if(!confirm("Kontakt löschen?"))return;saveK(kontakte.filter(k=>k.id!==form.id));setEditK(null);}}
                    style={{background:"none",border:"1px solid #e53",borderRadius:8,padding:"10px 16px",fontSize:13,color:"#e53",cursor:"pointer"}}>Löschen</button>}
                </div>
              </div>
            </div>
          );
        }
        return(
          <div style={{maxWidth:700}}>
            <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:20}}>
              <div style={{fontFamily:"Georgia,serif",fontSize:17,color:T.accent}}>👤 Firmenkontakte</div>
              <button onClick={()=>{setFormK(leerK());setEditK("new");}} style={{background:T.accent,color:"#fff",border:"none",borderRadius:8,padding:"8px 16px",fontSize:13,fontWeight:600,cursor:"pointer"}}>+ Neuer Kontakt</button>
            </div>
            {kontakte.length===0&&<div style={{color:T.muted,fontSize:13,padding:"30px 0",textAlign:"center"}}>Noch keine Kontakte angelegt.</div>}
            <div style={{display:"flex",flexDirection:"column",gap:8}}>
              {kontakte.map(k=>(
                <div key={k.id} onClick={()=>{setFormK({...k});setEditK(k.id);}}
                  style={{display:"flex",alignItems:"center",gap:12,padding:"14px 16px",background:T.surface,borderRadius:10,border:`1px solid ${T.border}`,cursor:"pointer"}}
                  onMouseEnter={el=>el.currentTarget.style.borderColor=T.accent}
                  onMouseLeave={el=>el.currentTarget.style.borderColor=T.border}>
                  <div style={{flex:1}}>
                    <div style={{fontSize:14,fontWeight:600,color:T.text}}>{[k.name,k.firma].filter(Boolean).join(" · ")}</div>
                    <div style={{fontSize:12,color:T.muted,marginTop:3}}>{[k.handy,k.telefon,k.email,[k.plz,k.ort].filter(Boolean).join(" ")].filter(Boolean).join(" · ")}</div>
                  </div>
                  <span style={{fontSize:18,color:T.muted}}>›</span>
                </div>
              ))}
            </div>
          </div>
        );
      })()}
    </>),

    ansicht:(<>
      <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:12,padding:28,maxWidth:520}}>
        <div style={{fontFamily:"Georgia,serif",fontSize:17,color:T.accent,marginBottom:8}}>🔍 Anzeigegröße</div>
        <div style={{fontSize:13,color:T.muted,marginBottom:22,lineHeight:1.5}}>
          Verkleinert oder vergrößert die gesamte Oberfläche. Die Einstellung gilt nur
          für dieses Gerät — auf dem Tablet klein, am Arbeitsrechner normal.
        </div>
        <div style={{display:"flex",alignItems:"center",gap:14}}>
          <span style={{fontSize:12,color:T.muted}}>klein</span>
          <input type="range" min="60" max="130" step="5" value={uiScale}
            onChange={e=>setUiScale(Number(e.target.value))}
            style={{flex:1,accentColor:T.accent}}/>
          <span style={{fontSize:12,color:T.muted}}>groß</span>
          <div style={{minWidth:56,textAlign:"right",fontFamily:"Georgia,serif",fontSize:16,color:T.accent,fontWeight:700}}>{uiScale}%</div>
        </div>
        <div style={{display:"flex",gap:8,flexWrap:"wrap",marginTop:18}}>
          {[75,85,100].map(v=>(
            <button key={v} style={{...btn(T,uiScale===v?"primary":"ghost",true)}}
              onClick={()=>setUiScale(v)}>
              {v===100?"Normal (100%)":v===85?"Tablet (85%)":"Sehr klein (75%)"}
            </button>
          ))}
        </div>
      </div>
    </>),

    darkmodus:(<>
      <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:12,padding:28,maxWidth:400}}>
        <div style={{fontFamily:"Georgia,serif",fontSize:17,color:T.accent,marginBottom:8}}>🌙 Darkmodus</div>
        <div style={{fontSize:13,color:T.muted,marginBottom:24}}>Wechsle zwischen hellem und dunklem Design.</div>
        <div style={{display:"flex",alignItems:"center",gap:16}}>
          <div onClick={()=>setDark(d=>{const n=!d;try{localStorage.setItem("sd_dark_mode",String(n));}catch{}return n;})}
            style={{display:"flex",alignItems:"center",gap:12,cursor:"pointer",padding:"14px 20px",borderRadius:10,border:`2px solid ${T.accent}`,background:T.accentDim,userSelect:"none"}}>
            <span style={{fontSize:22}}>{dark?"☀️":"🌙"}</span>
            <div>
              <div style={{fontSize:14,fontWeight:600,color:T.text}}>{dark?"Hell-Modus aktivieren":"Dunkel-Modus aktivieren"}</div>
              <div style={{fontSize:12,color:T.muted,marginTop:2}}>Aktuell: {dark?"Dunkel":"Hell"}</div>
            </div>
          </div>
        </div>
      </div>
    </>),

    studio_header:(<>
        <Card title="Studio-Header" icon="🏷️">
          <div style={{marginBottom:16}}>
            <label style={{fontSize:12,color:T.muted,fontWeight:600,display:"block",marginBottom:6}}>Anzeigename (statt "Übersicht")</label>
            <input value={sh.name||""} onChange={e=>saveSh("name",e.target.value)}
              placeholder="z.B. Markus Heber Photography"
              style={{...IS,width:"100%"}}/>
            <div style={{fontSize:11,color:T.muted,marginTop:4}}>Wird im Dashboard-Header oben angezeigt.</div>
          </div>
          <div style={{marginBottom:16}}>
            <label style={{fontSize:12,color:T.muted,fontWeight:600,display:"block",marginBottom:6}}>Logo</label>
            {sh.logo&&<img src={sh.logo} alt="Logo" style={{maxHeight:160,maxWidth:320,display:"block",marginBottom:8,borderRadius:6}}/>}
            <div style={{display:"flex",gap:8}}>
              <label style={{...btn(T,"ghost",true),cursor:"pointer",fontSize:12}}>
                Logo hochladen
                <input type="file" accept="image/*" style={{display:"none"}} onChange={e=>{
                  const f=e.target.files[0];if(!f)return;
                  const r=new FileReader();r.onload=ev=>saveSh("logo",ev.target.result);r.readAsDataURL(f);
                }}/>
              </label>
              {sh.logo&&<button style={{...btn(T,"ghost",true),fontSize:12,color:"#e53"}} onClick={()=>saveSh("logo","")}>Entfernen</button>}
            </div>
          </div>
          <div>
            <label style={{fontSize:12,color:T.muted,fontWeight:600,display:"block",marginBottom:6}}>Logo-Höhe</label>
            <div style={{display:"flex",gap:8,alignItems:"center"}}>
              <input type="range" min={24} max={200} step={2} value={sh.logoH||40} onChange={e=>saveSh("logoH",+e.target.value)} style={{flex:1,accentColor:T.accent}}/>
              <span style={{fontSize:12,color:T.text,minWidth:32}}>{sh.logoH||40}px</span>
            </div>
          </div>
        </Card>
      </>),

    bankdaten:(<BankdatenKarte T={T} IS={IS} Card={Card}/>),
  };

  const [activeCard,setActiveCard]=useState(()=>localStorage.getItem("sd_einst_card")||null);
  function openCard(id){setActiveCard(id);localStorage.setItem("sd_einst_card",id||"");}

  // Nach Verwendungshäufigkeit gruppiert. Was täglich gebraucht wird, steht
  // oben; was man einmal einrichtet und dann vergisst, unten.
  const GRUPPEN=[
    {id:"oft",   titel:"Täglich im Einsatz", farbe:"#A8843E",
     karten:[
      {id:"homepage",    icon:"🌐", title:"Homepage Export",       sub:"Widget & Exportdaten für deine Website"},
      {id:"smtp",        icon:"✉️", title:"E-Mail & Vorlagen",     sub:"SMTP, Vorlagen, Automatisierung"},
      {id:"mustertexte", icon:"📝", title:"Mustertexte",           sub:"Akquise-Mails für Firmenkunden"},
      {id:"vertrag",     icon:"✍️", title:"Vereinbarung / Vertrag", sub:"Vertragstext bearbeiten"},
     ]},
    {id:"regel", titel:"Ab und zu", farbe:"#5b8fc9",
     karten:[
      {id:"buchungspdf", icon:"📄", title:"Buchungs-PDF",   sub:"Logo, Kopf, Fußtext, Kontakt"},
      {id:"studio_header", icon:"🏷️", title:"Studio-Header", sub:"Name & Logo für die Übersicht"},
      {id:"bankdaten",   icon:"🏦", title:"Bankverbindung", sub:"IBAN, BIC & PayPal für Bezahllinks"},
      {id:"backup",      icon:"💾", title:"Datensicherung", sub:"Backup & Wiederherstellen"},
      {id:"darkmodus",   icon:"🌙", title:"Darkmodus",      sub:"Hell / Dunkel umschalten"},
      {id:"ansicht",     icon:"🔍", title:"Anzeigegröße",   sub:"Alles kleiner oder größer — nur dieses Gerät"},
     ]},
    {id:"selten", titel:"Einmal einrichten", farbe:"#8A8075",
     karten:[
      {id:"server",     icon:"🔗", title:"Server-URL",        sub:"Verbindung & Test"},
      {id:"speicher",   icon:"📁", title:"Speicherpfad",      sub:"Ordnerstruktur"},
      {id:"sevdesk",    icon:"🏢", title:"sevDesk",           sub:"API Token & Buchhaltung"},
      {id:"google_cal", icon:"📅", title:"Google Kalender",   sub:"Events mit Google synchronisieren"},
      {id:"whatsapp",   icon:"💬", title:"WhatsApp Business", sub:"WA-Nachrichten an Kunden"},
     ]},
  ];
  const CARDS=GRUPPEN.flatMap(g=>g.karten);

  if(activeCard){
    const card=CARDS.find(c=>c.id===activeCard);
    return(
      <div>
        <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:24}}>
          <button style={btn(T,"ghost")} onClick={()=>openCard(null)}>← Zurück</button>
          <div>
            <div style={{fontFamily:"Georgia,serif",fontSize:22,fontWeight:700,color:T.text}}>{card?.icon} {card?.title}</div>
            <div style={{fontSize:12,color:T.muted}}>{card?.sub}</div>
          </div>
        </div>
      <div style={{minWidth:0,overflow:"hidden"}}>
        {activeCard==="studio_header"?(
          <Card title="Studio-Header" icon="🏷️">
            <StudioHeaderKarte T={T} btn={btn} IS={IS}/>
          </Card>
        ):cardEls[activeCard]}
      </div>
      </div>
    );
  }

  return(
    <div>
      <div style={{marginBottom:24}}>
        <div style={{fontFamily:"Georgia,serif",fontSize:26,fontWeight:700,color:T.text}}>Einstellungen</div>
        <div style={{fontSize:13,color:T.muted,marginTop:2}}>Wähle einen Bereich zum Bearbeiten.</div>
      </div>
      {GRUPPEN.map(g=>(
        <div key={g.id} style={{marginBottom:28}}>
          <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:12}}>
            <span style={{width:10,height:10,borderRadius:"50%",background:g.farbe,flexShrink:0}}/>
            <span style={{fontSize:12,fontWeight:700,color:T.muted,textTransform:"uppercase",letterSpacing:".07em"}}>{g.titel}</span>
            <span style={{flex:1,height:1,background:T.border}}/>
            <span style={{fontSize:11,color:T.muted}}>{g.karten.length}</span>
          </div>
          <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(240px,1fr))",gap:16}}>
            {g.karten.map(c=>(
              <div key={c.id} onClick={()=>c.id==="homepage"?setPage&&setPage("homepage"):openCard(c.id)}
                style={{background:T.surface,border:`1px solid ${T.border}`,borderLeft:`4px solid ${g.farbe}`,
                        borderRadius:14,padding:"20px 22px",cursor:"pointer",
                        transition:"border-color 0.15s,box-shadow 0.15s"}}
                onMouseEnter={e=>{e.currentTarget.style.borderColor=g.farbe;e.currentTarget.style.borderLeftColor=g.farbe;e.currentTarget.style.boxShadow=`0 4px 16px ${g.farbe}33`;}}
                onMouseLeave={e=>{e.currentTarget.style.borderColor=T.border;e.currentTarget.style.borderLeftColor=g.farbe;e.currentTarget.style.boxShadow="none";}}>
                <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:8}}>
                  <span style={{fontSize:26,lineHeight:1}}>{c.icon}</span>
                  <span style={{fontFamily:"Georgia,serif",fontSize:16,fontWeight:700,color:T.text,lineHeight:1.25}}>{c.title}</span>
                </div>
                <div style={{fontSize:12,color:T.muted,marginBottom:14,lineHeight:1.5,minHeight:32}}>{c.sub}</div>
                <button style={{...btn(T,"ghost",true),width:"100%",justifyContent:"center",borderColor:g.farbe+"66",color:g.farbe}}
                  onClick={e=>{e.stopPropagation();c.id==="homepage"?setPage&&setPage("homepage"):openCard(c.id);}}>Öffnen</button>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

// ── NewsletterPage ─────────────────────────────────────────────────────────────────────
function fillTemplate(tmpl, data){
  return (tmpl||"").replace(/\{\{(\w+)\}\}/g,(_,k)=>{
    if(k==="vorname") return vornameAus(data.name);
    return data[k]!==undefined?String(data[k]):`{{${k}}}`;
  });
}

function buildNewsletterHtml(text){
  const esc=s=>String(s).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;");
  const parts=String(text||"").split(/\n\n+/).map(block=>{
    const imgOnly=block.trim().match(/^!\[([^\]]*)\]\(([^)]+)\)$/);
    if(imgOnly)return `<img src="${imgOnly[2]}" alt="${esc(imgOnly[1])}" style="max-width:100%;border-radius:8px;margin:10px 0;display:block">`;
    let h=esc(block);
    h=h.replace(/!\[([^\]]*)\]\(([^)]+)\)/g,(m,a,u)=>`<img src="${u}" alt="${a}" style="max-width:100%;border-radius:8px;margin:8px 0;display:block">`);
    h=h.replace(/\[([^\]]+)\]\(([^)]+)\)/g,(m,l,u)=>`<a href="${u}" style="color:#A8843E">${l}</a>`);
    h=h.replace(/\n/g,"<br>");
    return `<p style="margin:0 0 12px;line-height:1.7">${h}</p>`;
  });
  let logo="";
  try{
    if(localStorage.getItem("sd_nl_logo_on")==="1"){
      const l=localStorage.getItem("sd_nl_logo")||"";
      if(l)logo=`<div style="margin-top:24px;padding-top:16px;border-top:1px solid #e0ddd8"><img src="${l}" alt="Logo" style="max-height:90px;max-width:300px"></div>`;
    }
  }catch(e){}
  let bgStyle="";
  try{
    const bg=localStorage.getItem("sd_nl_bg")||"";
    const bgOp=parseFloat(localStorage.getItem("sd_nl_bg_opacity")||"0.15");
    if(bg){bgStyle=`background-image:url(${bg});background-size:cover;background-position:center;position:relative;`;}
  }catch(e){}
  const bgOverlay=localStorage.getItem("sd_nl_bg")?(()=>{
    const op=parseFloat(localStorage.getItem("sd_nl_bg_opacity")||"0.15");
    return `<div style="position:absolute;inset:0;background:rgba(255,255,255,${1-op});border-radius:8px;z-index:0;"></div>`;
  })():"";
  const wrap=bgStyle?`<div style="position:relative;${bgStyle}border-radius:8px;overflow:hidden"><div style="position:relative;z-index:1;padding:24px;font-family:Arial,Helvetica,sans-serif;font-size:15px;color:#1a1814;max-width:600px;margin:0 auto">${bgOverlay}${parts.join("")}${logo}</div></div>`
    :`<div style="font-family:Arial,Helvetica,sans-serif;font-size:15px;color:#1a1814;max-width:600px;margin:0 auto;padding:8px">${parts.join("")}${logo}</div>`;
  return wrap;
}
function NewsletterPage({events,customers,T}){
  const jetzt=new Date();
  const aktQ=Math.floor(jetzt.getMonth()/3)+1;
  const [quartal,setQuartal]=useState(aktQ);
  const [jahr,setJahr]=useState(jetzt.getFullYear());
  const [text,setText]=useState(()=>{try{const v=JSON.parse(localStorage.getItem("sd_email_vorlagen")||"{}");return v.newsletter?.text||"";}catch{return "";}});
  const [showSend,setShowSend]=useState(false);
  const [zeigeQR,setZeigeQR]=useState(false); // QR-Codes zur Anmeldung
  const [sending,setSending]=useState(false);
  const [sendResult,setSendResult]=useState(null);
  const [showLinkForm,setShowLinkForm]=useState(false);
  const [linkLabel,setLinkLabel]=useState("");
  const [linkUrl,setLinkUrl]=useState("");
  const [generating,setGenerating]=useState(false);
  const [showImgForm,setShowImgForm]=useState(false);
  const [imgUrl,setImgUrl]=useState("");
  const [nlLogo,setNlLogo]=useState(()=>localStorage.getItem("sd_nl_logo")||(JSON.parse(localStorage.getItem("sd_buchung_config")||"{}").logo)||"");
  const [nlBg,setNlBg]=useState(()=>localStorage.getItem("sd_nl_bg")||"");
  const [nlBgOp,setNlBgOp]=useState(()=>parseFloat(localStorage.getItem("sd_nl_bg_opacity")||"0.15"));
  const [nlSig,setNlSig]=useState(()=>localStorage.getItem("sd_nl_sig")||"");
  const [logoOn,setLogoOn]=useState(()=>localStorage.getItem("sd_nl_logo_on")==="1");
  const [showPreview,setShowPreview]=useState(()=>localStorage.getItem("sd_nl_prev")==="1");
  const [fmt,setFmt]=useState(()=>{try{return JSON.parse(localStorage.getItem("sd_email_fmt")||"null")||{size:14,color:"#1a1814",font:"Georgia,serif"};}catch{return {size:14,color:"#1a1814",font:"Georgia,serif"};}});
  useEffect(()=>{localStorage.setItem("sd_nl_logo_on",logoOn?"1":"0");},[logoOn]);
  useEffect(()=>{if(nlLogo)localStorage.setItem("sd_nl_logo",nlLogo);else localStorage.removeItem("sd_nl_logo");},[nlLogo]);
  function insertAtCursor(snippet){
    const ta=document.getElementById("nl-textarea");
    const a=ta?ta.selectionStart:text.length;const b=ta?ta.selectionEnd:text.length;
    setText(text.slice(0,a)+snippet+text.slice(b));
  }
  function wrapSelection(before,after){
    const ta=document.getElementById("nl-textarea");
    if(!ta)return;
    const a=ta.selectionStart,b=ta.selectionEnd;
    const sel=text.slice(a,b)||"Text";
    const wrapped=before+sel+after;
    setText(text.slice(0,a)+wrapped+text.slice(b));
    setTimeout(()=>{ta.focus();ta.setSelectionRange(a+before.length,a+before.length+sel.length);},10);
  }
  const FONTS=[
    {val:"Georgia,serif",label:"Georgia"},
    {val:"Arial,sans-serif",label:"Arial"},
    {val:"Helvetica,sans-serif",label:"Helvetica"},
    {val:"Verdana,sans-serif",label:"Verdana"},
    {val:"'Nunito',sans-serif",label:"Nunito ✦",gf:"Nunito:300,400,600"},
    {val:"'Raleway',sans-serif",label:"Raleway ✦",gf:"Raleway:300,400,600"},
    {val:"'Lato',sans-serif",label:"Lato ✦",gf:"Lato:300,400,700"},
    {val:"'Poppins',sans-serif",label:"Poppins ✦",gf:"Poppins:300,400,600"},
    {val:"'Montserrat',sans-serif",label:"Montserrat ✦",gf:"Montserrat:300,400,600"},
    {val:"'Open Sans',sans-serif",label:"Open Sans ✦",gf:"Open+Sans:300,400,600"},
  ];
  const activeGF=FONTS.find(f=>f.val===fmt.font)?.gf;
  const gfLink=activeGF?`https://fonts.googleapis.com/css2?family=${activeGF}&display=swap`:null;
  const tbBtn=(title,content,onClick)=>(
    <button title={title} onClick={onClick} style={{background:"transparent",border:`1px solid ${T.border}`,borderRadius:5,padding:"3px 9px",cursor:"pointer",color:T.text,fontSize:12,fontFamily:"inherit",lineHeight:1.5}}>{content}</button>
  );
  function buildNlPreviewHtml(){
    let t=text;
    t=t.replace(/!\[([^\]]*)\]\(([^)]+)\)/g,(m,alt,url)=>`<img src="${url}" alt="${alt}" style="max-width:100%;border-radius:6px;margin:8px 0;display:block"/>`);
    t=t.replace(/\[([^\]]+)\]\(([^)]+)\)/g,(m,l,u)=>`<a href="${u}" style="color:#A8843E;font-weight:600">${l}</a>`);
    t=t.replace(/\[(\d+)px?\](.*?)\[\/size\]/gs,(m,px,inner)=>`<span style="font-size:${px}px">${inner}</span>`);
    t=t.replace(/\*\*(.+?)\*\*/gs,(m,inner)=>`<strong>${inner}</strong>`);
    t=t.replace(/(?<![a-zA-Z])_(.+?)_(?![a-zA-Z])/gs,(m,inner)=>`<em>${inner}</em>`);
    const parts=t.split(/\n/).map(line=>{
      if(line.trim()==="")return `<br style="line-height:0.8"/>`;
      return line+"<br/>";
    }).join("");
    const logoHtml=nlLogo?`<img src="${nlLogo}" style="max-height:70px;max-width:200px;display:block;margin-bottom:8px" alt="Logo"/>`:"";
    const sigHtml=nlSig?`<div style="font-size:12px;color:#8A8075;white-space:pre-wrap;">${nlSig}</div>`:"";
    const foot=logoHtml||sigHtml?`${logoHtml}${sigHtml}`:"";
    if(nlBg){
      const op=nlBgOp;
      return `<div style="position:relative;background-image:url(${nlBg});background-size:cover;background-position:center;border-radius:8px;overflow:hidden"><div style="position:absolute;inset:0;background:rgba(255,255,255,${1-op});z-index:0;border-radius:8px;"></div><div style="position:relative;z-index:1;padding:16px;font-size:${fmt.size}px;font-family:${fmt.font};color:${fmt.color};">${parts}${foot}</div></div>`;
    }
    return `<div style="font-size:${fmt.size}px;font-family:${fmt.font};color:${fmt.color};">${parts}${foot}</div>`;
  }
  const IS={background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:"9px 12px",color:T.text,fontSize:13,fontFamily:"inherit",outline:"none"};

  const cfg=JSON.parse(localStorage.getItem("sd_buchung_config")||"{}");
  const studio=cfg.studioName||"Mein Fotostudio";

  // Events im gewählten Quartal
  const qStart=new Date(jahr,(quartal-1)*3,1);
  const qEnd=new Date(jahr,quartal*3,0,23,59);
  const qEvents=events.filter(ev=>{
    if(!ev.date)return false;
    const d=new Date(ev.date);
    return d>=qStart&&d<=qEnd;
  }).sort((a,b)=>new Date(a.date)-new Date(b.date));
  const naechste=events.filter(ev=>ev.date&&new Date(ev.date)>qEnd).sort((a,b)=>new Date(a.date)-new Date(b.date)).slice(0,3);

  function generateTemplate(){
    const fmtD=d=>new Date(d).toLocaleDateString("de-DE",{day:"2-digit",month:"long",year:"numeric"});
    const fmtRange=ev=>ev.dateBis&&ev.dateBis!==ev.date?`${fmtD(ev.date)} – ${fmtD(ev.dateBis)}`:fmtD(ev.date);
    const lines=[];
    lines.push(`Liebe Tierfreunde,`);
    lines.push(``);
    lines.push(`das ${quartal}. Quartal ${jahr} steht vor der Tür — und wir haben wieder einiges für euch und eure Vierbeiner geplant!`);
    lines.push(``);
    if(qEvents.length>0){
      lines.push(`\ud83d\udcc5 UNSERE TERMINE IM ${quartal}. QUARTAL`);
      lines.push(``);
      qEvents.forEach(ev=>{
        lines.push(`\u2728 ${ev.name}`);
        lines.push(`   ${fmtRange(ev)}${ev.location?" · "+ev.location:""}${ev.fotoart?" · "+ev.fotoart:""}`);
        if(ev.info)lines.push(`   ${ev.info.split("\n")[0]}`);
        lines.push(``);
      });
    }else{
      lines.push(`In diesem Quartal planen wir gerade neue Termine — haltet die Augen offen!`);
      lines.push(``);
    }
    if(naechste.length>0){
      lines.push(`\ud83d\udd2d AUSBLICK`);
      lines.push(``);
      naechste.forEach(ev=>{
        lines.push(`· ${ev.name} — ${fmtRange(ev)}`);
      });
      lines.push(``);
    }
    lines.push(`Die Plätze sind begrenzt — sichert euch frühzeitig euren Wunschtermin!`);
    lines.push(``);
    lines.push(`Wir freuen uns auf euch und eure Lieblinge!`);
    lines.push(``);
    lines.push(`Herzliche Grüße`);
    lines.push(`${studio}`);
    setText(lines.join("\n"));
  }

  async function verfeinernKI(){
    if(!text.trim()){alert("Bitte zuerst einen Entwurf generieren.");return;}
    setGenerating(true);
    try{
      const srv=(()=>{
        let u=(localStorage.getItem("sd_server_url")||"").trim().replace(/\/+$/,"");
        if(!u||(location.protocol==="https:"&&u.startsWith("http://")))u=location.origin;
        return u;
      })();
      const resp=await fetch(srv+"/api/ki-verfeinern",{
        method:"POST",
        headers:{"Content-Type":"application/json"},
        body:JSON.stringify({
          text,
          auftrag:"Überarbeite diesen Newsletter für ein Tierfotografie-Studio. Mach ihn warm, persönlich und einladend, aber nicht kitschig. Behalte alle Termine und Fakten exakt bei.",
        }),
      });
      const data=await resp.json();
      if(data&&data.ok&&data.text)setText(data.text);
      else alert("KI-Verfeinerung nicht möglich: "+((data&&data.fehler)||"Antwort leer")+"\nDer Entwurf bleibt erhalten.");
    }catch(e){
      alert("KI-Verfeinerung nicht verfügbar ("+e.message+").\nDer Entwurf bleibt erhalten — du kannst ihn manuell anpassen.");
    }
    setGenerating(false);
  }

  return(
    <>
    <div style={{width:"100%"}}>
      <div style={{marginBottom:24}}>
        <div style={{fontFamily:"Georgia,serif",fontSize:26,fontWeight:700,color:T.text}}>Newsletter</div>
        <div style={{fontSize:13,color:T.muted,marginTop:2}}>Quartals-Newsletter aus deinen Veranstaltungen generieren</div>
      </div>

      {/* Quartal wählen */}
      <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:12,padding:20,marginBottom:18}}>
        <div style={{display:"flex",gap:10,alignItems:"flex-end",flexWrap:"wrap"}}>
          <div>
            <label style={{fontSize:11,color:T.muted,fontWeight:600,display:"block",marginBottom:4}}>Quartal</label>
            <div style={{display:"flex",gap:6}}>
              {[1,2,3,4].map(q=>(
                <button key={q} onClick={()=>setQuartal(q)}
                  style={{...btn(T,quartal===q?"primary":"ghost",true),minWidth:48,justifyContent:"center"}}>Q{q}</button>
              ))}
            </div>
          </div>
          <div>
            <label style={{fontSize:11,color:T.muted,fontWeight:600,display:"block",marginBottom:4}}>Jahr</label>
            <input type="number" value={jahr} onChange={e=>setJahr(Number(e.target.value))} style={{...IS,width:90}}/>
          </div>
          <button style={btn(T,"primary")} onClick={generateTemplate}>Newsletter-Entwurf erstellen</button>
        </div>
        <div style={{fontSize:12,color:T.muted,marginTop:12}}>
          {qEvents.length} Veranstaltung{qEvents.length!==1?"en":""} in Q{quartal} {jahr}
          {qEvents.length>0&&": "+qEvents.map(e=>e.name).join(", ")}
        </div>
      </div>

      {/* Editor */}
      <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:12,padding:20}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
          <div style={{fontFamily:"Georgia,serif",fontSize:15,color:T.accent}}>Newsletter-Text</div>
          <div style={{display:"flex",gap:8}}>
            <button style={btn(T,zeigeQR?"primary":"ghost",true)} onClick={()=>setZeigeQR(v=>!v)}>⬛ QR-Codes</button>
            <button style={btn(T,"ghost",true)} onClick={verfeinernKI} disabled={generating||!text.trim()}>
              {generating?"\u23f3 Verfeinere...":"\u2728 Mit KI verfeinern"}
            </button>
            <button style={btn(T,"primary",true)} onClick={()=>{navigator.clipboard.writeText(text);alert("✅ In Zwischenablage kopiert!");}} disabled={!text.trim()}>
              📋 Kopieren
            </button>
            <button style={btn(T,"primary",true)} onClick={()=>setShowSend(true)} disabled={!text.trim()}>
              📧 Versenden
            </button>
          </div>
        </div>
        {zeigeQR&&(()=>{
          const srvQR=(localStorage.getItem("sd_server_url")||"").trim().replace(/\/+$/,"");
          return(
            <div style={{marginBottom:14}}>
              <NewsletterQR T={T} url={srvQR?srvQR+"/newsletter":""}/>
              {!srvQR&&<div style={{fontSize:13,color:T.muted}}>Keine Server-Adresse hinterlegt, deshalb lässt sich kein QR-Code erzeugen.</div>}
            </div>
          );
        })()}
        {showLinkForm&&(
          <div style={{display:"flex",gap:8,marginBottom:6,flexWrap:"wrap",background:T.bg,padding:"10px 12px",borderRadius:8,border:`1px solid ${T.border}`}}>
            <input value={linkLabel} onChange={e=>setLinkLabel(e.target.value)} placeholder="Linktext" style={{...IS,flex:1,minWidth:120,fontSize:12}}/>
            <input value={linkUrl} onChange={e=>setLinkUrl(e.target.value)} placeholder="https://..." style={{...IS,flex:2,minWidth:180,fontSize:12}}/>
            <button style={{...btn(T,"primary",true),fontSize:11}} onClick={()=>{
              const ta=document.getElementById("nl-textarea");
              const s=ta?ta.selectionStart:text.length,e2=ta?ta.selectionEnd:text.length;
              setText(text.slice(0,s)+`[${linkLabel||linkUrl}](${linkUrl})`+text.slice(e2));
              setLinkLabel(""); setLinkUrl(""); setShowLinkForm(false);
            }}>Einfügen</button>
            <button style={{...btn(T,"ghost",true),fontSize:11}} onClick={()=>setShowLinkForm(false)}>✕</button>
          </div>
        )}
        {showImgForm&&(
          <div style={{display:"flex",gap:8,marginBottom:6,alignItems:"flex-end",background:T.bg,padding:"10px 12px",borderRadius:8,border:`1px solid ${T.border}`,flexWrap:"wrap"}}>
            <div style={{flex:1,minWidth:200}}>
              <label style={{fontSize:10,color:T.muted,display:"block",marginBottom:3}}>Bild-URL oder Datei wählen</label>
              <input value={imgUrl} onChange={e=>setImgUrl(e.target.value)} placeholder="https://...bild.jpg"
                style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:6,padding:"6px 10px",color:T.text,fontSize:12,fontFamily:"inherit",outline:"none",boxSizing:"border-box",width:"100%"}}/>
            </div>
            <label style={{...btn(T,"ghost",true),fontSize:11,cursor:"pointer"}}>
              📁 Datei
              <input type="file" accept="image/*" style={{display:"none"}} onChange={e=>{const f=e.target.files[0];if(!f)return;const r=new FileReader();r.onload=ev=>{insertAtCursor(`\n\n![Bild](${ev.target.result})\n\n`);setShowImgForm(false);};r.readAsDataURL(f);}}/>
            </label>
            <button style={{...btn(T,"primary",true),fontSize:11}} onClick={()=>{if(!imgUrl.trim())return;insertAtCursor(`\n\n![Bild](${imgUrl.trim()})\n\n`);setImgUrl("");setShowImgForm(false);}}>Einfügen</button>
            <button style={{...btn(T,"ghost",true),fontSize:11}} onClick={()=>setShowImgForm(false)}>✕</button>
          </div>
        )}
        {/* Toolbar */}
        <div style={{display:"flex",gap:5,alignItems:"center",flexWrap:"wrap",marginBottom:8,padding:"8px 10px",background:T.bg,borderRadius:8,border:`1px solid ${T.border}`}}>
          <select value={fmt.font} onChange={e=>setFmt(f=>({...f,font:e.target.value}))} style={{...IS,width:"auto",padding:"3px 6px",fontSize:11}}>
            {FONTS.map(f=>(<option key={f.val} value={f.val}>{f.label}</option>))}
          </select>
          <select onChange={e=>{if(e.target.value){wrapSelection(`[${e.target.value}]`,"[/size]");e.target.value="";}}} style={{...IS,width:70,padding:"3px 6px",fontSize:11}} title="Größe auf Auswahl">
            <option value="">px</option>
            {[10,11,12,13,14,15,16,18,20,22,24].map(s=>(<option key={s} value={s}>{s}px</option>))}
          </select>
          <input type="color" value={fmt.color} onChange={e=>setFmt(f=>({...f,color:e.target.value}))} title="Textfarbe" style={{width:28,height:26,border:"none",borderRadius:4,cursor:"pointer",background:"none"}}/>
          <button onClick={()=>wrapSelection("**","**")} title="Fett" style={{background:"transparent",border:`1px solid ${T.border}`,borderRadius:5,padding:"3px 9px",cursor:"pointer",color:T.text,fontSize:12,fontFamily:"inherit",fontWeight:"bold"}}>B</button>
          <button onClick={()=>wrapSelection("_","_")} title="Kursiv" style={{background:"transparent",border:`1px solid ${T.border}`,borderRadius:5,padding:"3px 9px",cursor:"pointer",color:T.text,fontSize:12,fontFamily:"inherit",fontStyle:"italic"}}>I</button>
          <button onClick={()=>insertAtCursor("\n• ")} title="Aufzählungspunkt" style={{background:"transparent",border:`1px solid ${T.border}`,borderRadius:5,padding:"3px 9px",cursor:"pointer",color:T.text,fontSize:12,fontFamily:"inherit"}}>•</button>
          <div style={{width:1,height:20,background:T.border}}/>
          <button style={{...btn(T,"ghost",true),fontSize:11}} onClick={()=>setShowLinkForm(true)}>🔗 Link</button>
          <button style={{...btn(T,"ghost",true),fontSize:11}} onClick={()=>setShowImgForm(true)}>🖼 Bild</button>
          <div style={{width:1,height:20,background:T.border}}/>
          <button style={{...btn(T,showPreview?"primary":"ghost",true),fontSize:11}} onClick={()=>{const n=!showPreview;setShowPreview(n);localStorage.setItem("sd_nl_prev",n?"1":"0");}}>👁 Vorschau</button>
          <button style={{...btn(T,"ghost",true),fontSize:11}} onClick={()=>{navigator.clipboard.writeText(buildNlPreviewHtml());alert("✅ HTML kopiert!");}} disabled={!text.trim()}>⧉ HTML kopieren</button>
        </div>
        {/* Entwurf + Vorschau nebeneinander */}
        <div style={{display:"grid",gridTemplateColumns:showPreview?"minmax(0,1fr) minmax(0,1fr)":"1fr",gap:32,alignItems:"start"}}>
          {/* Linke Spalte: Editor + Signatur + Buttons */}
          <div>
            <textarea id="nl-textarea" value={text} onChange={e=>setText(e.target.value)}
              placeholder={'Klicke auf "Newsletter-Entwurf erstellen" — der Text wird aus deinen Veranstaltungen generiert.'}
              style={{...IS,width:"100%",minHeight:420,resize:"vertical",lineHeight:fmt.lineHeight||1.7,fontSize:fmt.size,fontFamily:fmt.font,color:fmt.color}}/>
            <div style={{fontSize:11,color:T.muted,marginTop:4}}>{"Platzhalter: {{name}} {{datum}} {{studio}} — Links: [Text](URL) — Bilder: ![Alt](URL)"}</div>
            {/* Signatur & Logo */}
            <div style={{marginTop:14,padding:12,background:T.bg,borderRadius:8,border:`1px solid ${T.border}`}}>
              <div style={{fontSize:11,color:T.muted,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.07em",marginBottom:8}}>Signatur & Logo</div>
              <div style={{display:"grid",gridTemplateColumns:"1fr auto",gap:10,alignItems:"start"}}>
                <textarea value={nlSig} onChange={e=>{setNlSig(e.target.value);localStorage.setItem("sd_nl_sig",e.target.value);}} rows={3}
                  placeholder={"Markus Heber Photography\nTel: 0171 8199782\nwww.m-h-photo.de"}
                  style={{...IS,resize:"vertical",lineHeight:1.5,fontSize:12}}/>
                <div style={{display:"flex",flexDirection:"column",gap:5,alignItems:"center"}}>
                  {nlLogo&&<img src={nlLogo} style={{maxHeight:50,maxWidth:120,borderRadius:4,border:`1px solid ${T.border}`}} alt="Logo"/>}
                  <label style={{...btn(T,"ghost",true),cursor:"pointer",fontSize:11,padding:"4px 8px",textAlign:"center",whiteSpace:"nowrap"}}>
                    {nlLogo?"Logo ändern":"📷 Logo"}
                    <input type="file" accept="image/*" style={{display:"none"}} onChange={e=>{const f=e.target.files[0];if(!f)return;const r=new FileReader();r.onload=ev=>setNlLogo(ev.target.result);r.readAsDataURL(f);}}/>
                  </label>
                  {nlLogo&&<button style={{...btn(T,"ghost",true),fontSize:10,padding:"2px 6px",color:"#e55"}} onClick={()=>setNlLogo("")}>✕</button>}
                </div>
                {/* Hintergrundbild */}
                <div style={{display:"flex",alignItems:"center",gap:8,marginTop:10,flexWrap:"wrap"}}>
                  <span style={{fontSize:11,color:T.muted,whiteSpace:"nowrap"}}>🖼 Hintergrundbild:</span>
                  {nlBg&&<img src={nlBg} style={{maxHeight:30,maxWidth:60,borderRadius:3,border:`1px solid ${T.border}`,objectFit:"cover"}} alt="BG"/>}
                  <label style={{...btn(T,"ghost",true),cursor:"pointer",fontSize:11,padding:"3px 7px"}}>
                    {nlBg?"Ändern":"Hochladen"}
                    <input type="file" accept="image/*" style={{display:"none"}} onChange={e=>{
                      const f=e.target.files[0];if(!f)return;
                      const r=new FileReader();
                      r.onload=ev=>{setNlBg(ev.target.result);localStorage.setItem("sd_nl_bg",ev.target.result);};
                      r.readAsDataURL(f);
                    }}/>
                  </label>
                  {nlBg&&<><span style={{fontSize:11,color:T.muted}}>Deckkraft:</span>
                  <input type="range" min="0.05" max="1" step="0.05" value={nlBgOp}
                    onChange={e=>{const v=parseFloat(e.target.value);setNlBgOp(v);localStorage.setItem("sd_nl_bg_opacity",String(v));}}
                    style={{width:80,accentColor:T.accent}}/>
                  <span style={{fontSize:11,color:T.muted,minWidth:30}}>{Math.round(nlBgOp*100)}%</span>
                  <button style={{...btn(T,"ghost",true),fontSize:10,padding:"2px 6px",color:"#e55"}} onClick={()=>{setNlBg("");localStorage.removeItem("sd_nl_bg");}}>✕</button></>}
                </div>
              </div>
            </div>
          </div>
          {/* Rechte Spalte: Vorschau */}
          {showPreview&&(
            <div style={{position:"sticky",top:16}}>
              <div style={{fontSize:11,color:T.muted,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.07em",marginBottom:6}}>Vorschau</div>
              <div style={{background:"#fff",borderRadius:8,border:`1px solid ${T.border}`,padding:20,overflowY:"auto",maxHeight:700}}>
                {gfLink&&<link rel="stylesheet" href={gfLink}/>}
                <div dangerouslySetInnerHTML={{__html:buildNlPreviewHtml()}}/>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
    {showSend&&<NewsletterSendModal text={text} customers={customers} onClose={()=>setShowSend(false)} T={T}/>}
    </>
  );
}

function NewsletterSendModal({text,customers,onClose,T}){
  const serverUrl=(localStorage.getItem("sd_server_url")||"http://167.233.88.11").replace(/\/+$/,"");
  const allCusts=JSON.parse(localStorage.getItem("sd_customers")||"[]");
  const alleAbos=(()=>{try{return JSON.parse(localStorage.getItem("sd_nl_abonnenten")||"[]");}catch{return [];}})();
  const extAbos=alleAbos.filter(a=>a.aktiv);
  // Wer sich abgemeldet hat, bekommt nichts mehr. Das gilt auch fuer Kunden
  // mit gesetztem Newsletter-Haken, sonst liefe der Abmeldelink ins Leere.
  const gesperrt=new Set(alleAbos.filter(a=>!a.aktiv).map(a=>(a.email||"").toLowerCase()));
  const nlCusts=allCusts.filter(c=>c.newsletter&&c.email&&!gesperrt.has(c.email.toLowerCase()));
  const alleEmails=new Set();
  const alleEmpfaenger=[];
  [...nlCusts.map(c=>({id:c.id,name:c.name,email:c.email,typ:"kunde"})),
   ...extAbos.map(a=>({id:a.id,name:a.name||"",email:a.email,typ:"abo"}))
  ].forEach(e=>{if(!alleEmails.has(e.email.toLowerCase())){alleEmails.add(e.email.toLowerCase());alleEmpfaenger.push(e);}});
  const [sel,setSel]=useState(()=>{const s={};alleEmpfaenger.forEach(e=>s[e.id]=true);return s;});
  const [subj,setSubj]=useState(()=>{try{const v=JSON.parse(localStorage.getItem("sd_email_vorlagen")||"{}");return v.newsletter?.betreff||"Newsletter";}catch{return "Newsletter";}});
  const [sending,setSending]=useState(false);
  const [result,setResult]=useState(null);
  const smtp=JSON.parse(localStorage.getItem("sd_smtp_settings")||"{}");
  const selected=alleEmpfaenger.filter(e=>sel[e.id]);

  async function send(){
    if(!smtp.host||!smtp.user||!smtp.pass){alert("Bitte erst SMTP-Einstellungen unter Einstellungen ausfüllen.");return;}
    if(selected.length===0){alert("Keine Empfänger ausgewählt.");return;}
    setSending(true);
    try{
      const recipients=selected.map(e=>({name:e.name,email:e.email,abmeldeLink:`${serverUrl}/abmelden?email=${encodeURIComponent(e.email)}`}));
      const textMitAbmelden=text+"\n\n---\nUm den Newsletter abzubestellen: {{abmeldeLink}}";
      const resp=await fetch(`${serverUrl}/api/newsletter`,{
        method:"POST",headers:{"Content-Type":"application/json"},
        body:JSON.stringify({smtp,recipients,subject:subj,text:textMitAbmelden,html:buildNewsletterHtml(text)}),
      });
      const d=await resp.json();
      setResult(d.ok?`✅ Erfolgreich an ${selected.length} Empfänger verschickt.`:`❌ Fehler: ${d.error}`);
    }catch(e){setResult(`❌ Server nicht erreichbar.`);}
    setSending(false);
  }

  return(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.78)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:100,padding:20}}>
      <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:16,padding:28,width:"100%",maxWidth:520,maxHeight:"88vh",overflowY:"auto"}}>
        <div style={{fontFamily:"Georgia,serif",fontSize:18,color:T.accent,marginBottom:16}}>📧 Newsletter versenden</div>
        <div style={{marginBottom:12}}>
          <label style={{fontSize:11,color:T.muted,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.07em",display:"block",marginBottom:4}}>Betreff</label>
          <input value={subj} onChange={e=>setSubj(e.target.value)} style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:"8px 12px",color:T.text,fontSize:13,fontFamily:"inherit",outline:"none",boxSizing:"border-box",width:"100%"}}/>
        </div>
        <div style={{fontFamily:"Georgia,serif",fontSize:13,color:T.accent,marginBottom:8}}>Empfänger ({selected.length} von {alleEmpfaenger.length})</div>
        {alleEmpfaenger.length===0?(
          <div style={{color:T.muted,fontSize:12,marginBottom:12}}>Keine Empfänger. Kunden unter "Kunden" als Newsletter-Empfänger markieren oder unter Kunden → Abonnenten hinzufügen.</div>
        ):(
          <div style={{display:"flex",flexDirection:"column",gap:4,marginBottom:16,maxHeight:280,overflowY:"auto"}}>
            <label style={{display:"flex",alignItems:"center",gap:8,cursor:"pointer",padding:"9px 0",borderBottom:`1px solid ${T.border}`}}>
              <input type="checkbox" checked={selected.length===alleEmpfaenger.length} onChange={e=>{const s={};alleEmpfaenger.forEach(c=>{s[c.id]=e.target.checked;});setSel(s);}} style={{accentColor:T.accent}}/>
              <span style={{fontSize:12,fontWeight:600,color:T.muted}}>Alle auswählen</span>
            </label>
            {alleEmpfaenger.map(e=>(
              <label key={e.id} style={{display:"flex",alignItems:"center",gap:8,cursor:"pointer",padding:"5px 0"}}>
                <input type="checkbox" checked={!!sel[e.id]} onChange={ev=>setSel(p=>({...p,[e.id]:ev.target.checked}))} style={{accentColor:T.accent}}/>
                <span style={{fontSize:13,color:T.text}}>{e.name||"—"}</span>
                <span style={{fontSize:11,color:T.muted,marginLeft:"auto"}}>{e.email}</span>
                <span style={{fontSize:10,background:e.typ==="kunde"?T.accentDim:T.border,color:e.typ==="kunde"?T.accent:T.muted,padding:"1px 6px",borderRadius:10}}>{e.typ==="kunde"?"Kunde":"Abo"}</span>
              </label>
            ))}
          </div>
        )}
        <div style={{fontSize:11,color:T.muted,marginBottom:12}}>📌 Jede Mail enthält automatisch einen Abmelde-Link.</div>
        {result&&<div style={{padding:"10px 14px",borderRadius:8,fontSize:13,marginBottom:12}}>{result}</div>}
        <div style={{display:"flex",justifyContent:"flex-end",gap:10}}>
          <button style={btn(T,"ghost")} onClick={onClose}>Schließen</button>
          <button style={btn(T,"primary")} onClick={send} disabled={sending||selected.length===0}>{sending?"⏳ Wird gesendet...":"📧 Jetzt senden"}</button>
        </div>
      </div>
    </div>
  );
}
// ── SocialPage ─────────────────────────────────────────────────────────────────────
const SOCIAL_KANAELE=[
  {id:"instagram",label:"Instagram",farbe:"#C13584"},
  {id:"facebook", label:"Facebook", farbe:"#1877F2"},
  {id:"tiktok",   label:"TikTok",   farbe:"#00C2CB"},
  {id:"blog",     label:"Blog",     farbe:"#8B7355"},
];

function socialUid(){return "sp_"+Date.now().toString(36)+Math.random().toString(36).slice(2,7);}

function socialSrv(){
  let u=(localStorage.getItem("sd_server_url")||"").trim().replace(/\/+$/,"");
  if(!u||(location.protocol==="https:"&&u.startsWith("http://")))u=location.origin;
  return u;
}

function socialDatumPlus(basis,tage){
  if(!basis)return "";
  const d=new Date(basis);
  if(isNaN(d))return "";
  d.setDate(d.getDate()+tage);
  return d.toISOString().slice(0,10);
}

function socialDatumKurz(iso){
  if(!iso)return "";
  const d=new Date(iso);
  if(isNaN(d))return iso;
  return d.toLocaleDateString("de-DE",{day:"2-digit",month:"2-digit",year:"numeric"});
}

// Skaliert ein Bild auf max. 1400px lange Kante und gibt Base64 ohne Praefix zurueck.
// Kamerabilder sind sonst zu gross fuer die API.
function socialBildVerkleinern(file){
  return new Promise((resolve,reject)=>{
    const leser=new FileReader();
    leser.onerror=()=>reject(new Error("Datei nicht lesbar"));
    leser.onload=()=>{
      const img=new Image();
      img.onerror=()=>reject(new Error("Kein gültiges Bild"));
      img.onload=()=>{
        const max=1400;
        let{width:w,height:h}=img;
        if(w>max||h>max){
          const f=max/Math.max(w,h);
          w=Math.round(w*f);h=Math.round(h*f);
        }
        const c=document.createElement("canvas");
        c.width=w;c.height=h;
        c.getContext("2d").drawImage(img,0,0,w,h);
        const dataUrl=c.toDataURL("image/jpeg",0.82);
        resolve({b64:dataUrl.split(",")[1],typ:"image/jpeg",vorschau:dataUrl});
      };
      img.src=leser.result;
    };
    leser.readAsDataURL(file);
  });
}

// Erzeugt drei Standard-Posts (Ankündigung, Erinnerung, Rückblick) für eine Veranstaltung
function socialVorlage(ev){
  const name=ev.name||"Veranstaltung";
  const datum=ev.date?new Date(ev.date).toLocaleDateString("de-DE",{day:"numeric",month:"long"}):"";
  return [
    {
      id:socialUid(),
      eventId:ev.id,
      datum:socialDatumPlus(ev.date,-21),
      kanal:"instagram",
      titel:"Ankündigung",
      bildhinweis:"Stärkstes Motiv, einzeln. Kein Carousel.",
      text:[
        "Am "+datum+" ist es wieder soweit: "+name+".",
        "",
        "[Kurz beschreiben, was besonders daran ist. Ein bis zwei Absätze, konkret statt allgemein.]",
        "",
        "Einzeltermin, [X] Minuten. [Preis] inklusive einem fertig bearbeiteten Bild, weitere Bilder einzeln dazu buchbar. Alle Preise stehen im Buchungsformular.",
        "",
        "[Anzahl] von [Gesamt] Plätzen sind schon weg.",
        "",
        "Termin sichern: [LINK]",
      ].join("\n"),
      hashtags:"#hundefotografie #hundefotografienürnberg #nürnberg #franken #hundeliebe #hundeportrait #mittelfranken",
      erledigt:false,
    },
    {
      id:socialUid(),
      eventId:ev.id,
      datum:socialDatumPlus(ev.date,-7),
      kanal:"instagram",
      titel:"Erinnerung",
      bildhinweis:"Nicht das Schönste, sondern etwas mit Charakter.",
      text:[
        "Noch [Zahl] Plätze für "+name+" am "+datum+".",
        "",
        "[Hier die häufigste Sorge aufgreifen und wegnehmen. Das ist der wichtigste Absatz.]",
        "",
        "[Dauer], [Preis] inklusive einem bearbeiteten Bild.",
        "",
        "[LINK]",
      ].join("\n"),
      hashtags:"#hundefotografie #hundefotografienürnberg #nürnberg #franken #hundeliebe",
      erledigt:false,
    },
    {
      id:socialUid(),
      eventId:ev.id,
      datum:socialDatumPlus(ev.date,1),
      kanal:"instagram",
      titel:"Rückblick",
      bildhinweis:"Das beste Ergebnis vom Tag.",
      text:[
        "[Ein Bild vom Tag, zwei bis drei Sätze dazu. Was war los, welcher Hund hat überrascht.]",
        "",
        "Nächste Gelegenheit: [nächster Termin]. [LINK]",
      ].join("\n"),
      hashtags:"",
      erledigt:false,
    },
  ];
}

const SOCIAL_EMOJIS=[
  {gruppe:"Hund",zeichen:["🐾","🐕","🐶","🦮","🐩","🦴","🎾","🐈"]},
  {gruppe:"Gefühl",zeichen:["❤️","🥰","😊","😍","🤍","✨","🙌","😅"]},
  {gruppe:"Foto",zeichen:["📸","📷","🎬","🖼️","💡","🎥"]},
  {gruppe:"Termin",zeichen:["📅","⏰","📍","✅","👉","🔗","⚡"]},
  {gruppe:"Saison",zeichen:["🍂","❄️","🎄","🎁","🌸","☀️","🎃"]},
];

// Textfeld, das mit dem Inhalt waechst. Damit faengt es das Mausrad nicht ab.
function SocialTextfeld({wert,onChange,platzhalter,T,minHoehe=180,emojis=true}){
  const ref=useRef(null);
  const [emojiAuf,setEmojiAuf]=useState(false);

  function anpassen(el){
    if(!el)return;
    el.style.height="auto";
    el.style.height=Math.max(minHoehe,el.scrollHeight+2)+"px";
  }
  useEffect(()=>{anpassen(ref.current);},[wert,minHoehe]);

  function einfuegen(zeichen){
    const el=ref.current;
    const t=wert||"";
    if(!el){onChange(t+zeichen);return;}
    const a=el.selectionStart??t.length;
    const b=el.selectionEnd??t.length;
    const neu=t.slice(0,a)+zeichen+t.slice(b);
    onChange(neu);
    // Cursor hinter das eingefuegte Zeichen setzen
    setTimeout(()=>{
      if(!ref.current)return;
      ref.current.focus();
      const pos=a+zeichen.length;
      ref.current.setSelectionRange(pos,pos);
      anpassen(ref.current);
    },0);
  }

  return(
    <div>
      {emojis&&(
        <div style={{marginBottom:6}}>
          <button style={btn(T,"ghost",true)} onClick={()=>setEmojiAuf(v=>!v)}>
            {emojiAuf?"Smileys zu":"Smileys"}
          </button>
          {emojiAuf&&(
            <div style={{border:`1px solid ${T.border}`,borderRadius:10,padding:10,marginTop:6,background:T.bg}}>
              {SOCIAL_EMOJIS.map(g=>(
                <div key={g.gruppe} style={{display:"flex",alignItems:"center",gap:6,marginBottom:6,flexWrap:"wrap"}}>
                  <span style={{fontSize:11,color:T.muted,width:56,flexShrink:0}}>{g.gruppe}</span>
                  {g.zeichen.map(z=>(
                    <button key={z} onClick={()=>einfuegen(z)} title={z}
                      style={{background:"transparent",border:`1px solid ${T.border}`,borderRadius:7,
                        cursor:"pointer",fontSize:17,lineHeight:1,padding:"5px 7px"}}>{z}</button>
                  ))}
                </div>
              ))}
              <div style={{fontSize:11,color:T.muted,marginTop:4}}>
                Wird an der Cursorposition eingefügt. Zwei Emojis pro Post reichen meistens.
              </div>
            </div>
          )}
        </div>
      )}
      <textarea ref={ref} value={wert||""}
        onChange={e=>{onChange(e.target.value);anpassen(e.target);}}
        placeholder={platzhalter}
        style={{...inpStyle(T),width:"100%",resize:"vertical",lineHeight:1.6,fontSize:14,
          overflow:"hidden",minHeight:minHoehe}}/>
    </div>
  );
}

// Welche Hunde gehoeren zu diesem Termin? Sind welche angehakt, gelten nur
// die. Ohne Auswahl alle Hunde des Kunden.
function terminHunde(b,c){
  const alle=(Array.isArray(c&&c.tiere)&&c.tiere.length>0
    ?c.tiere.map(t=>t&&(t.name||t.rasse)).filter(Boolean)
    :((c&&c.dog)?[c.dog]:[]));
  const gew=[];
  if(b&&Array.isArray(b.hunde))gew.push(...b.hunde);
  if(b&&Array.isArray(b.serie))b.serie.forEach(z=>{
    if(z&&Array.isArray(z.hunde))gew.push(...z.hunde);
  });
  if(!gew.length)return alle;
  const treffer=alle.filter(n=>gew.includes(n));
  return treffer.length?treffer:alle;
}

// Beschriftung eines Einzeltermins fuer Auswahl und Anzeige
function socialHunde(c){
  if(!c)return "";
  const liste=Array.isArray(c.tiere)&&c.tiere.length>0
    ?c.tiere.map(t=>t&&t.name).filter(Boolean)
    :(c.dog?[c.dog]:[]);
  return liste.join(" & ");
}
function socialTerminLabel(b,customers){
  const c=(customers||[]).find(x=>x.id===b.customerId);
  const hunde=terminHunde(b,c).join(" & ");
  const wer=c?(hunde?c.name+" · "+hunde:c.name):"Kunde unbekannt";
  return wer+(b.date?" · "+socialDatumKurz(b.date):"");
}

function SocialPostKarte({post,onChange,onDelete,events,bookings,customers,T}){
  const [kopiert,setKopiert]=useState(false);
  const [stichworte,setStichworte]=useState("");
  const [bild,setBild]=useState(null);
  const [erzeugt,setErzeugt]=useState(false);
  const [kiFehler,setKiFehler]=useState("");
  const kanal=SOCIAL_KANAELE.find(k=>k.id===post.kanal)||SOCIAL_KANAELE[0];
  const ev=(events||[]).find(e=>e.id===post.eventId);
  const bk=(bookings||[]).find(b=>b.id===post.bookingId);
  const kunde=bk?(customers||[]).find(c=>c.id===bk.customerId):null;

  async function bildWaehlen(e){
    const f=e.target.files&&e.target.files[0];
    e.target.value="";
    if(!f)return;
    setKiFehler("");
    try{setBild(await socialBildVerkleinern(f));}
    catch(err){setKiFehler(err.message);}
  }

  async function erzeugen(){
    if(!stichworte.trim()&&!bild){setKiFehler("Ein paar Stichworte oder ein Bild brauche ich.");return;}
    if(post.text&&post.text.trim()&&!window.confirm("Der vorhandene Text wird ersetzt. Fortfahren?"))return;
    setErzeugt(true);setKiFehler("");

    // Alle Hunde des Kunden, nicht nur den ersten
    const tiere=(()=>{
      if(!kunde)return [];
      const liste=Array.isArray(kunde.tiere)&&kunde.tiere.length>0
        ?kunde.tiere
        :(kunde.dog?[{name:kunde.dog,rasse:kunde.breed||"",geschlecht:""}]:[]);
      return liste.filter(t=>t&&(t.name||t.rasse)).map(t=>({
        name:t.name||"",rasse:t.rasse||"",alter:t.alter||"",geschlecht:t.geschlecht||"",
      }));
    })();

    // Liegt der Termin in der Vergangenheit?
    const heute=new Date();heute.setHours(0,0,0,0);
    const bezug=bk&&bk.date?bk.date:(ev&&ev.date?ev.date:null);
    const bezugZeit=bezug?new Date(bezug):null;
    const vergangen=bezugZeit&&!isNaN(bezugZeit)?bezugZeit<heute:false;

    try{
      const r=await fetch(socialSrv()+"/api/social-text",{
        method:"POST",
        headers:{"Content-Type":"application/json"},
        body:JSON.stringify({
          stichworte,
          bild:bild?bild.b64:"",
          bildTyp:bild?bild.typ:"",
          kanal:post.kanal,
          titel:post.titel||"",
          veranstaltung:ev?ev.name:"",
          evDatum:ev&&ev.date?socialDatumKurz(ev.date):"",
          ort:ev&&ev.ort?ev.ort:(bk&&bk.location?bk.location:""),
          shootingArt:bk&&bk.shootingType?bk.shootingType:"",
          tiere,
          terminDatum:bk&&bk.date?socialDatumKurz(bk.date):"",
          vergangen,
        }),
      });
      const d=await r.json();
      if(d&&d.ok){
        onChange({...post,
          text:d.text||post.text,
          hashtags:d.hashtags||post.hashtags,
          bildhinweis:d.bildhinweis||post.bildhinweis});
      } else {
        setKiFehler((d&&d.fehler)||"Unbekannter Fehler");
      }
    }catch(err){
      setKiFehler("Server nicht erreichbar: "+err.message);
    }
    setErzeugt(false);
  }

  function kopieren(){
    const voll=[post.text||"",post.hashtags?"\n"+post.hashtags:""].join("");
    const fertig=()=>{setKopiert(true);setTimeout(()=>setKopiert(false),1800);};
    if(navigator.clipboard&&navigator.clipboard.writeText){
      navigator.clipboard.writeText(voll).then(fertig).catch(()=>{});
    } else {
      const ta=document.createElement("textarea");
      ta.value=voll;document.body.appendChild(ta);ta.select();
      try{document.execCommand("copy");fertig();}catch(e){}
      document.body.removeChild(ta);
    }
  }

  return(
    <div style={{border:`1px solid ${post.erledigt?T.success+"55":T.border}`,borderRadius:12,padding:16,marginBottom:14,background:post.erledigt?T.success+"0d":T.surface}}>
      <div style={{display:"flex",alignItems:"center",gap:10,flexWrap:"wrap",marginBottom:12}}>
        <input value={post.titel||""} onChange={e=>onChange({...post,titel:e.target.value})}
          placeholder="Titel" style={{...inpStyle(T),width:170,fontWeight:600}}/>
        <select value={post.kanal} onChange={e=>onChange({...post,kanal:e.target.value})}
          style={{...inpStyle(T),width:130}}>
          {SOCIAL_KANAELE.map(k=><option key={k.id} value={k.id}>{k.label}</option>)}
        </select>
        <input type="date" value={post.datum||""} onChange={e=>onChange({...post,datum:e.target.value})}
          style={{...inpStyle(T),width:150}}/>
        <span style={{width:10,height:10,borderRadius:5,background:kanal.farbe,flexShrink:0}}/>
        <div style={{flex:1}}/>
        <label style={{display:"flex",alignItems:"center",gap:6,fontSize:12,color:T.muted,cursor:"pointer"}}>
          <input type="checkbox" checked={!!post.erledigt} onChange={e=>onChange({...post,erledigt:e.target.checked})}/>
          gepostet
        </label>
        <button style={btn(T,kopiert?"success":"primary",true)} onClick={kopieren}>
          {kopiert?"kopiert":"Text kopieren"}
        </button>
        <button style={btn(T,"danger",true)} onClick={()=>{if(window.confirm("Diesen Post löschen?"))onDelete(post.id);}}>löschen</button>
      </div>

      <div style={{background:T.bg,border:`1px dashed ${T.border}`,borderRadius:10,padding:12,marginBottom:12}}>
        <div style={{display:"flex",gap:8,alignItems:"flex-start",flexWrap:"wrap"}}>
          <input value={stichworte} onChange={e=>setStichworte(e.target.value)}
            onKeyDown={e=>{if(e.key==="Enter"&&!erzeugt)erzeugen();}}
            placeholder="Stichworte: z.B. Border Collie, erste Mal auf Glas, war erst skeptisch"
            style={{...inpStyle(T),flex:1,minWidth:220,fontSize:13}}/>
          <label style={{...btn(T,"ghost",true),cursor:"pointer"}}>
            {bild?"Bild tauschen":"Bild wählen"}
            <input type="file" accept="image/*" onChange={bildWaehlen} style={{display:"none"}}/>
          </label>
          <button style={btn(T,"primary",true)} onClick={erzeugen} disabled={erzeugt}>
            {erzeugt?"schreibt…":"Text erzeugen"}
          </button>
        </div>
        {bild&&(
          <div style={{display:"flex",alignItems:"center",gap:10,marginTop:10}}>
            <img src={bild.vorschau} alt="" style={{height:52,borderRadius:6,objectFit:"cover"}}/>
            <button style={btn(T,"ghost",true)} onClick={()=>setBild(null)}>Bild entfernen</button>
          </div>
        )}
        {kiFehler&&<div style={{color:T.danger,fontSize:12,marginTop:8}}>{kiFehler}</div>}
      </div>

      <SocialTextfeld wert={post.text} onChange={v=>onChange({...post,text:v})}
        platzhalter="Post-Text" T={T}/>

      <input value={post.hashtags||""} onChange={e=>onChange({...post,hashtags:e.target.value})}
        placeholder="Hashtags" style={{...inpStyle(T),width:"100%",marginTop:8,fontSize:13}}/>

      <input value={post.bildhinweis||""} onChange={e=>onChange({...post,bildhinweis:e.target.value})}
        placeholder="Welches Bild dazu?" style={{...inpStyle(T),width:"100%",marginTop:8,fontSize:12,color:T.muted}}/>

      <div style={{display:"flex",alignItems:"center",gap:8,marginTop:8}}>
        <span style={{fontSize:12,color:T.muted,flexShrink:0}}>gehört zu</span>
        <select value={post.bookingId?"b:"+post.bookingId:(post.eventId?"e:"+post.eventId:"")}
          onChange={e=>{
            const v=e.target.value;
            if(v.startsWith("b:"))onChange({...post,bookingId:v.slice(2),eventId:null,terminKontext:true});
            else if(v.startsWith("e:"))onChange({...post,eventId:v.slice(2),bookingId:null,terminKontext:false});
            else onChange({...post,eventId:null,bookingId:null,terminKontext:false});
          }}
          style={{...inpStyle(T),fontSize:12,flex:1}}>
          <option value="">— nichts zugeordnet —</option>
          <optgroup label="Veranstaltungen">
            {[...(events||[])].sort((a,b)=>new Date(b.date||0)-new Date(a.date||0)).map(x=>(
              <option key={x.id} value={"e:"+x.id}>{x.name}{x.date?" · "+socialDatumKurz(x.date):""}</option>
            ))}
          </optgroup>
          <optgroup label="Einzeltermine">
            {[...(bookings||[])].filter(x=>x.status!=="storniert")
              .sort((a,b)=>new Date(b.date||0)-new Date(a.date||0)).slice(0,80).map(x=>(
              <option key={x.id} value={"b:"+x.id}>{socialTerminLabel(x,customers)}</option>
            ))}
          </optgroup>
        </select>
      </div>
    </div>
  );
}

// ── Bestellungen: Einkaufsliste fuer den Fotobetrieb ────────────────────────
// Visitenkarten, Flyer, Banner und was sonst regelmaessig nachbestellt wird.
// Liegt im localStorage unter sd_bestellungen und wandert mit ins Backup.
const BEST_SPALTEN=[
  {key:"artikel",     label:"Artikel",           w:180, typ:"text"},
  {key:"shop",        label:"Shop",              w:140, typ:"text"},
  {key:"beschreibung",label:"Artikelbeschreibung",w:260, typ:"mehrzeilig"},
  {key:"ve",          label:"VE",                w:90,  typ:"text"},
  {key:"preisAlt",    label:"Letzter Preis",     w:120, typ:"preis"},
  {key:"preisNeu",    label:"Aktueller Preis",   w:120, typ:"preis"},
  {key:"datum",       label:"Datum",             w:130, typ:"datum"},
  {key:"info",        label:"Info",              w:220, typ:"mehrzeilig"},
];

function BestellungenPage({T}){
  const [zeilen,setZeilen]=useState(()=>{
    try{return JSON.parse(localStorage.getItem("sd_bestellungen")||"[]");}catch(e){return [];}
  });
  const [zeilenHoehe,setZeilenHoehe]=useState(()=>Number(localStorage.getItem("sd_best_hoehe"))||44);
  const [schrift,setSchrift]=useState(()=>Number(localStorage.getItem("sd_best_font"))||13);
  const [sort,setSort]=useState(()=>{
    try{return JSON.parse(localStorage.getItem("sd_best_sort")||"null")||{key:"artikel",dir:"asc"};}
    catch(e){return {key:"artikel",dir:"asc"};}
  });
  const [suche,setSuche]=useState("");
  // Spaltenbreiten per Maus, gemerkt im localStorage (wie in den anderen Tabellen).
  const [colW,startResize]=useColW("sd_best_colw",
    Object.fromEntries(BEST_SPALTEN.map(c=>[c.key,c.w])));

  function speichern(neu){
    setZeilen(neu);
    localStorage.setItem("sd_bestellungen",JSON.stringify(neu));
  }
  function setz(id,feld,wert){
    speichern(zeilen.map(z=>z.id===id?{...z,[feld]:wert}:z));
  }
  function neueZeile(){
    speichern([...zeilen,{id:uid(),artikel:"",shop:"",beschreibung:"",ve:"",
      preisAlt:"",preisNeu:"",datum:"",info:""}]);
  }
  function loeschen(id){
    const z=zeilen.find(x=>x.id===id);
    if(z&&(z.artikel||z.shop)&&!window.confirm(`"${z.artikel||z.shop}" löschen?`))return;
    speichern(zeilen.filter(x=>x.id!==id));
  }
  // Uebernimmt den aktuellen Preis als letzten Preis — fuer eine Nachbestellung.
  function nachbestellen(id){
    speichern(zeilen.map(z=>z.id===id
      ?{...z,preisAlt:z.preisNeu,preisNeu:"",datum:new Date().toISOString().slice(0,10)}
      :z));
  }
  function sortieren(key){
    setSort(s=>{
      const neu=s.key===key?{key,dir:s.dir==="asc"?"desc":"asc"}:{key,dir:"asc"};
      localStorage.setItem("sd_best_sort",JSON.stringify(neu));
      return neu;
    });
  }

  const gefiltert=(()=>{
    const q=suche.trim().toLowerCase();
    const liste=q
      ?zeilen.filter(z=>BEST_SPALTEN.some(c=>String(z[c.key]||"").toLowerCase().includes(q)))
      :[...zeilen];
    const spalte=BEST_SPALTEN.find(c=>c.key===sort.key)||BEST_SPALTEN[0];
    const richtung=sort.dir==="asc"?1:-1;
    return liste.sort((a,b)=>{
      const va=a[spalte.key],vb=b[spalte.key];
      const leerA=va===""||va==null,leerB=vb===""||vb==null;
      if(leerA&&leerB)return 0;
      if(leerA)return 1;   // Leeres immer ans Ende
      if(leerB)return -1;
      if(spalte.typ==="preis")return (Number(va)-Number(vb))*richtung;
      if(spalte.typ==="datum")return String(va).localeCompare(String(vb))*richtung;
      return String(va).localeCompare(String(vb),"de",{sensitivity:"base"})*richtung;
    });
  })();

  const summe=gefiltert.reduce((s,z)=>s+(Number(z.preisNeu)||0),0);
  const IS={background:"transparent",border:"none",outline:"none",width:"100%",
    color:T.text,fontSize:schrift,fontFamily:"inherit",padding:"2px 4px"};

  return(
    <div>
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",gap:16,flexWrap:"wrap",marginBottom:18}}>
        <div>
          <div style={{fontFamily:"Georgia,serif",fontSize:26,fontWeight:700,color:T.text}}>Bestellungen</div>
          <div style={{fontSize:13,color:T.muted,marginTop:2}}>
            {zeilen.length} Artikel{suche?` · ${gefiltert.length} gefunden`:""} · Summe aktuelle Preise: {fmtEuro(summe)}
          </div>
        </div>
        <div style={{display:"flex",alignItems:"center",gap:14,flexWrap:"wrap"}}>
          <input value={suche} onChange={e=>setSuche(e.target.value)} placeholder="Suchen…"
            style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:8,padding:"8px 12px",
                    color:T.text,fontSize:13,fontFamily:"inherit",outline:"none",width:200}}/>
          <div style={{display:"flex",alignItems:"center",gap:8}}>
            <span style={{fontSize:11,color:T.muted}}>Zeilenhöhe</span>
            <input type="range" min="28" max="140" step="4" value={zeilenHoehe}
              onChange={e=>{const v=Number(e.target.value);setZeilenHoehe(v);localStorage.setItem("sd_best_hoehe",String(v));}}
              style={{width:110,accentColor:T.accent}}/>
            <span style={{fontSize:11,color:T.muted,minWidth:34}}>{zeilenHoehe}px</span>
          </div>
          <div style={{display:"flex",alignItems:"center",gap:8}}>
            <span style={{fontSize:11,color:T.muted}}>Schrift</span>
            <input type="range" min="11" max="18" step="1" value={schrift}
              onChange={e=>{const v=Number(e.target.value);setSchrift(v);localStorage.setItem("sd_best_font",String(v));}}
              style={{width:80,accentColor:T.accent}}/>
            <span style={{fontSize:11,color:T.muted,minWidth:34}}>{schrift}px</span>
          </div>
          <button style={btn(T,"primary")} onClick={neueZeile}>+ Artikel</button>
        </div>
      </div>

      <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:12,overflow:"auto"}}>
        <table style={{borderCollapse:"collapse",tableLayout:"fixed",
                       width:BEST_SPALTEN.reduce((sum,c)=>sum+(colW[c.key]||c.w),0)+96}}>
          <colgroup>
            {BEST_SPALTEN.map(c=><col key={c.key} style={{width:colW[c.key]}}/>)}
            <col style={{width:96}}/>
          </colgroup>
          <thead>
            <tr>
              {BEST_SPALTEN.map(c=>(
                <th key={c.key} onClick={()=>sortieren(c.key)} title="Zum Sortieren klicken · Rand ziehen ändert die Breite"
                  style={{padding:"10px 8px",
                          textAlign:["artikel","shop","beschreibung","ve"].includes(c.key)?"left":"center",
                          fontSize:10,fontWeight:700,color:sort.key===c.key?T.accent:T.muted,
                          textTransform:"uppercase",letterSpacing:"0.07em",cursor:"pointer",
                          borderBottom:`1px solid ${T.border}`,whiteSpace:"nowrap",userSelect:"none",
                          position:"relative"}}>
                  {c.label}{sort.key===c.key?(sort.dir==="asc"?" ↑":" ↓"):""}
                  <ResizeHandle T={T} onMouseDown={e=>startResize(e,c.key)}/>
                </th>
              ))}
              <th style={{width:96,borderBottom:`1px solid ${T.border}`}}/>
            </tr>
          </thead>
          <tbody>
            {gefiltert.length===0&&(
              <tr><td colSpan={BEST_SPALTEN.length+1} style={{padding:40,textAlign:"center",color:T.muted,fontSize:13}}>
                {zeilen.length===0?"Noch keine Artikel. Lege den ersten mit „+ Artikel“ an.":"Nichts gefunden."}
              </td></tr>
            )}
            {gefiltert.map((z,i)=>(
              <tr key={z.id} style={{minHeight:zeilenHoehe,background:i%2===0?T.surface:T.bg}}>
                {BEST_SPALTEN.map(c=>(
                  <td key={c.key} style={{padding:"0 6px",borderBottom:`1px solid ${T.border}33`,
                       textAlign:c.typ==="preis"?"right":"left",overflow:"hidden",
                       height:zeilenHoehe,verticalAlign:"top"}}>
                    {c.typ==="mehrzeilig"?(
                      // Umbricht statt abzuschneiden und waechst mit dem Text mit.
                      <textarea value={z[c.key]||""} onChange={e=>setz(z.id,c.key,e.target.value)}
                        placeholder={c.label} rows={1}
                        style={{...IS,resize:"none",lineHeight:1.35,padding:"6px 4px",
                                whiteSpace:"pre-wrap",wordBreak:"break-word",overflow:"hidden",
                                minHeight:zeilenHoehe-8,
                                height:Math.max(zeilenHoehe-8,
                                  Math.ceil((String(z[c.key]||"").length*schrift*0.55)/(colW[c.key]-14)||1)
                                  *(schrift*1.35)+10)}}/>
                    ):c.typ==="preis"?(
                      <PreisFeld T={T} value={z[c.key]??""} onChange={v=>setz(z.id,c.key,v)}/>
                    ):c.typ==="datum"?(
                      <input type="date" value={z[c.key]||""} onChange={e=>setz(z.id,c.key,e.target.value)} style={IS}/>
                    ):(
                      <input value={z[c.key]||""} onChange={e=>setz(z.id,c.key,e.target.value)}
                        placeholder={c.label} style={IS}/>
                    )}
                  </td>
                ))}
                <td style={{padding:"0 6px",borderBottom:`1px solid ${T.border}33`,whiteSpace:"nowrap",textAlign:"right"}}>
                  <button style={{...btn(T,"ghost",true),fontSize:11,marginRight:4}}
                    title="Aktuellen Preis als letzten Preis übernehmen und neu eintragen"
                    onClick={()=>nachbestellen(z.id)}>↻</button>
                  <button style={btn(T,"danger",true)} onClick={()=>loeschen(z.id)}>✕</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div style={{fontSize:11,color:T.muted,marginTop:10,lineHeight:1.6}}>
        Spaltenüberschrift anklicken sortiert, nochmal klicken dreht die Richtung um.
        Die Spaltenbreite lässt sich am rechten Rand der Überschrift mit der Maus ziehen.
        Das ↻ übernimmt den aktuellen Preis als letzten Preis und setzt das Datum auf heute —
        praktisch beim Nachbestellen.
      </div>
    </div>
  );
}

function SocialPage({events,bookings=[],customers=[],T}){
  const [posts,setPosts]=useState([]);
  const [geladen,setGeladen]=useState(false);
  const [ladeFehler,setLadeFehler]=useState("");
  const [offenId,setOffenId]=useState(null);
  const [dirty,setDirty]=useState(false);
  const [status,setStatus]=useState("");
  const {dir,toggle}=useEventSort();

  // Laden
  useEffect(()=>{
    let abbruch=false;
    fetch(socialSrv()+"/api/social-posts")
      .then(r=>r.json())
      .then(d=>{
        if(abbruch)return;
        setPosts(Array.isArray(d.posts)?d.posts:[]);
        setGeladen(true);
      })
      .catch(e=>{
        if(abbruch)return;
        setLadeFehler("Server nicht erreichbar. Nichts wird gespeichert, bis die Verbindung steht.");
        setGeladen(true);
      });
    return()=>{abbruch=true;};
  },[]);

  // Warnung beim Verlassen mit ungespeicherten Änderungen
  useEffect(()=>{
    if(!dirty)return;
    const h=e=>{e.preventDefault();e.returnValue="";};
    window.addEventListener("beforeunload",h);
    return()=>window.removeEventListener("beforeunload",h);
  },[dirty]);

  function speichern(neu){
    const liste=neu||posts;
    setStatus("speichert");
    return fetch(socialSrv()+"/api/social-posts",{
      method:"POST",
      headers:{"Content-Type":"application/json"},
      body:JSON.stringify({posts:liste}),
    })
      .then(r=>r.json())
      .then(d=>{
        if(d&&d.ok){setDirty(false);setStatus("gespeichert");setTimeout(()=>setStatus(""),2200);}
        else{setStatus("Fehler: "+((d&&d.fehler)||"unbekannt"));}
      })
      .catch(e=>{setStatus("Fehler: "+e.message);});
  }

  function aendern(p){
    setPosts(ps=>ps.map(x=>x.id===p.id?p:x));
    setDirty(true);
  }
  function loeschen(id){
    setPosts(ps=>ps.filter(x=>x.id!==id));
    setDirty(true);
  }
  function neuerPost(evId,terminKontext){
    setPosts(ps=>[...ps,{id:socialUid(),eventId:evId||null,bookingId:null,terminKontext:!!terminKontext,datum:"",kanal:"instagram",titel:"Neuer Post",text:"",hashtags:"",bildhinweis:"",erledigt:false}]);
    setDirty(true);
  }
  function vorlageEinfuegen(ev){
    setPosts(ps=>[...ps,...socialVorlage(ev)]);
    setDirty(true);
  }

  // Veranstaltungen: kommende zuerst, abgeschlossene raus
  const heute=new Date();heute.setHours(0,0,0,0);
  const zeit=e=>{const d=new Date(e&&e.date);return isNaN(d)?0:d.getTime();};
  const sortiere=arr=>[...arr].sort((a,b)=>dir==="asc"?zeit(a)-zeit(b):zeit(b)-zeit(a));
  const kommende=sortiere(events.filter(e=>e.date&&zeit(e)>=heute.getTime()));
  const vergangene=sortiere(events.filter(e=>e.date&&zeit(e)<heute.getTime()&&posts.some(p=>p.eventId===e.id)));
  const ohneDatum=events.filter(e=>!e.date&&posts.some(p=>p.eventId===e.id));

  const zaehle=evId=>posts.filter(p=>p.eventId===evId);
  const terminPosts=posts.filter(p=>p.bookingId||p.terminKontext);
  const freiePosts=posts.filter(p=>!p.bookingId&&!p.terminKontext&&(!p.eventId||!events.some(e=>e.id===p.eventId)));

  if(!geladen)return <div style={{color:T.muted,padding:20}}>Lade…</div>;

  // ── Detailansicht einer Veranstaltung ───────────────────────────────────────
  if(offenId!==null){
    const ev=(offenId==="_frei"||offenId==="_termine")?null:events.find(e=>e.id===offenId);
    const meine=offenId==="_frei"?freiePosts
      :offenId==="_termine"?terminPosts
      :posts.filter(p=>p.eventId===offenId);
    const sortiert=[...meine].sort((a,b)=>(a.datum||"9999").localeCompare(b.datum||"9999"));
    const kopf=offenId==="_frei"?"Ohne Zuordnung":offenId==="_termine"?"Einzeltermine":(ev?ev.name:"");

    return(
      <div style={{maxWidth:900,paddingBottom:60}}>
        <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:20,flexWrap:"wrap",position:"sticky",top:0,zIndex:5,background:T.bg,paddingBottom:10}}>
          <button style={btn(T,"ghost")} onClick={()=>setOffenId(null)}>← Übersicht</button>
          <div style={{flex:1,minWidth:200}}>
            <div style={{fontFamily:"Georgia,serif",fontSize:20,color:T.text}}>{kopf}</div>
            {ev&&ev.date&&<div style={{fontSize:12,color:T.muted,marginTop:2}}>{socialDatumKurz(ev.date)}</div>}
            {offenId==="_termine"&&<div style={{fontSize:12,color:T.muted,marginTop:2}}>Posts rund um einzelne Shootings</div>}
          </div>
          {status&&<span style={{fontSize:12,color:status.startsWith("Fehler")?T.danger:T.success}}>{status}</span>}
          {dirty&&<span style={{fontSize:12,color:T.danger}}>ungespeichert</span>}
          <button style={btn(T,"primary")} onClick={()=>speichern()}>Speichern</button>
        </div>

        <div>
        {ladeFehler&&<div style={{background:T.danger+"18",border:`1px solid ${T.danger}44`,color:T.danger,padding:12,borderRadius:8,marginBottom:16,fontSize:13}}>{ladeFehler}</div>}

        {sortiert.length===0&&(
          <div style={{color:T.muted,fontSize:13,marginBottom:16}}>
            Noch keine Posts.{ev?" Die Vorlage legt Ankündigung, Erinnerung und Rückblick mit passenden Daten an.":""}
          </div>
        )}

        {sortiert.map(p=>(
          <SocialPostKarte key={p.id} post={p} onChange={aendern} onDelete={loeschen}
            events={events} bookings={bookings} customers={customers} T={T}/>
        ))}

        <div style={{display:"flex",gap:10,marginTop:8,marginBottom:40}}>
          <button style={btn(T,"ghost")} onClick={()=>neuerPost(ev?ev.id:null,offenId==="_termine")}>+ Post</button>
          {ev&&<button style={btn(T,"ghost")} onClick={()=>vorlageEinfuegen(ev)}>Vorlage einfügen (3 Posts)</button>}
          {offenId==="_termine"&&<span style={{fontSize:12,color:T.muted,alignSelf:"center"}}>
            Unten in der Karte den Einzeltermin auswählen, dann kennt der Generator Hund und Datum.
          </span>}
        </div>
        </div>
      </div>
    );
  }

  // ── Übersicht ───────────────────────────────────────────────────────────────
  const Kachel=({ev,art})=>{
    const liste=art==="frei"?freiePosts:art==="termine"?terminPosts:zaehle(ev.id);
    const offen=liste.filter(p=>!p.erledigt).length;
    const naechster=[...liste].filter(p=>p.datum&&!p.erledigt).sort((a,b)=>a.datum.localeCompare(b.datum))[0];
    const titel=art==="frei"?"Ohne Zuordnung":art==="termine"?"Einzeltermine":ev.name;
    const ziel=art==="frei"?"_frei":art==="termine"?"_termine":ev.id;
    return(
      <div onClick={()=>setOffenId(ziel)}
        style={{border:`1px solid ${art==="termine"?T.accent+"55":T.border}`,borderRadius:12,padding:16,background:T.surface,cursor:"pointer",transition:"border-color 0.15s"}}>
        <div style={{fontFamily:"Georgia,serif",fontSize:16,fontWeight:700,color:T.text,marginBottom:4}}>
          {titel}
        </div>
        {!art&&ev.date&&<div style={{fontSize:12,color:T.muted}}>{socialDatumKurz(ev.date)}</div>}
        {art==="termine"&&<div style={{fontSize:12,color:T.muted}}>Posts zu einzelnen Shootings</div>}
        <div style={{marginTop:12,display:"flex",alignItems:"center",gap:8,flexWrap:"wrap"}}>
          {liste.length===0
            ? <span style={{fontSize:12,color:T.muted}}>keine Posts</span>
            : <>
                <Badge label={liste.length+(liste.length===1?" Post":" Posts")} color={T.accent}/>
                {offen>0&&<Badge label={offen+" offen"} color="#D4A84B"/>}
                {offen===0&&<Badge label="alle raus" color={T.success}/>}
              </>}
        </div>
        {naechster&&naechster.datum&&(
          <div style={{fontSize:12,color:T.muted,marginTop:10}}>
            nächster: {socialDatumKurz(naechster.datum)} · {naechster.titel||"ohne Titel"}
          </div>
        )}
      </div>
    );
  };

  return(
    <div style={{paddingBottom:60}}>
      {ladeFehler&&<div style={{background:T.danger+"18",border:`1px solid ${T.danger}44`,color:T.danger,padding:12,borderRadius:8,marginBottom:16,fontSize:13}}>{ladeFehler}</div>}

      <div style={{display:"flex",alignItems:"center",gap:14,marginBottom:20,flexWrap:"wrap"}}>
        <div style={{fontSize:13,color:T.muted,flex:1,minWidth:200}}>
          Post-Texte je Veranstaltung. Alles liegt auf dem Server, nicht im Browser.
        </div>
        <SortBtn dir={dir} toggle={toggle} T={T}/>
      </div>

      {kommende.length===0&&vergangene.length===0&&ohneDatum.length===0&&freiePosts.length===0&&(
        <div style={{color:T.muted}}>Keine kommenden Veranstaltungen.</div>
      )}

      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(250px,1fr))",gap:14}}>
        {kommende.map(ev=><Kachel key={ev.id} ev={ev}/>)}
        {ohneDatum.map(ev=><Kachel key={ev.id} ev={ev}/>)}
        <Kachel art="termine"/>
        <Kachel art="frei"/>
      </div>

      {vergangene.length>0&&(
        <>
          <div style={{fontSize:12,fontWeight:700,color:T.muted,textTransform:"uppercase",letterSpacing:"0.08em",margin:"32px 0 12px"}}>Vergangen</div>
          <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(250px,1fr))",gap:14,opacity:0.65}}>
            {vergangene.map(ev=><Kachel key={ev.id} ev={ev}/>)}
          </div>
        </>
      )}

      <div style={{height:40}}/>
    </div>
  );
}

// ── HomepagePage ─────────────────────────────────────────────────────────────────────
function HomepagePage({events,config,T}){
  const [tab,setTab]=useState("html");
  const [hpConfig,setHpConfig]=useState(()=>{
    try{return JSON.parse(localStorage.getItem("sd_hp_config")||"null")||{
      titel:"Kommende Veranstaltungen",
      untertitel:"Tier-Fotografie Events",
      farbe:"#C9A96E",
      logo:"",
      zeigeBeschreibung:true,
      zeigeOrt:true,
      zeigePreis:false,
      buchungsLink:"https://buchen.meinestudio.de",
    };}catch{return {titel:"Kommende Veranstaltungen",untertitel:"",farbe:"#C9A96E",logo:"",zeigeBeschreibung:true,zeigeOrt:true,zeigePreis:false,buchungsLink:""};}
  });
  useEffect(()=>{localStorage.setItem("sd_hp_config",JSON.stringify(hpConfig));},[hpConfig]);

  // Buchungsplan-Shootings mit hp_aktiv=true laden
  const buchCfg=(()=>{try{return JSON.parse(localStorage.getItem("sd_buchung_config")||"{}");}catch{return {};}})();
  const hpShootings=(buchCfg.shootingTypes||[]).filter(st=>st.hp_aktiv===true&&st.eventId);
  // Zusätzlich events aus Veranstaltungsplan die hp_aktiv haben
  const kommend=[
    ...hpShootings.map(st=>{
      const ev=events.find(e=>e.id===st.eventId)||{};
      // Frühestes zukünftiges Slot-Datum nehmen
      const heute=new Date();
      const slots=(st.slots||[]).filter(s=>s.datum&&new Date(s.datum)>=heute).sort((a,b)=>new Date(a.datum)-new Date(b.datum));
      const date=slots[0]?.datum||ev.date||"";
      const dateEnd=slots[slots.length-1]?.datum||date;
      const evAdresse=[ev.adresse?.strasse,ev.adresse?.plz,ev.adresse?.ort].filter(Boolean).join(", ");
      return {id:st.id,name:st.name||ev.name||"",date,dateEnd,location:st.location||ev.location||"",fotoart:ev.fotoart||"",info:st.hp_beschreibung||"",preise:ev.preise||{},buchungsUrl:st.buchungsUrl||st.name?.toLowerCase().replace(/\s+/g,"-")||"",hp_von:st.hp_von||"",hp_bis:st.hp_bis||"",hp_adresse:st.hp_adresse||evAdresse,hp_kategorie:st.hp_kategorie||""};
    }),
    ...events.filter(ev=>ev.hp_aktiv&&(!buchCfg.shootingTypes||!buchCfg.shootingTypes.find(st=>st.eventId===ev.id)))
  ].filter(ev=>ev.name).sort((a,b)=>new Date(a.date)-new Date(b.date));
  const IS=T=>({background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:"9px 12px",color:T.text,fontSize:13,fontFamily:"inherit",outline:"none",boxSizing:"border-box",width:"100%"});
  const sc=(k,v)=>setHpConfig(p=>({...p,[k]:v}));

  const [einbettung,setEinbettung]=useState("");
  const [kopiert,setKopiert]=useState("");   // "" | "ok" | "fehler"

  // Die Zwischenablage ist nur auf gesicherten Seiten erreichbar und kann
  // trotzdem abgelehnt werden. Deshalb wird das Ergebnis geprueft und es
  // gibt einen zweiten Weg ueber das Markieren im Textfeld.
  function kopiereEinbettung(){
    const fertig=ok=>{setKopiert(ok?"ok":"fehler");setTimeout(()=>setKopiert(""),2500);};
    try{
      if(navigator.clipboard&&window.isSecureContext){
        navigator.clipboard.writeText(einbettung).then(()=>fertig(true),()=>fertig(false));
        return;
      }
    }catch(e){}
    // Aelterer Weg: Text markieren und ueber den Browserbefehl kopieren
    try{
      const feld=document.getElementById("sd-einbettung");
      if(feld){feld.select();const ok=document.execCommand("copy");fertig(ok);return;}
    }catch(e){}
    fertig(false);
  }


  // Einbettungscode fuer die Homepage. Die Hoehe stellt sich selbst ein,
  // der Startwert dient nur fuer die ersten Sekundenbruchteile und fuer den
  // Fall, dass die Homepage kein Javascript zulaesst.
  function baueEinbettung(){
    const basis=(localStorage.getItem("sd_server_url")||"https://buchen.m-h-photo.de").trim().replace(/\/+$/,"");
    const spalten=hpConfig.zweiSpalten?2:1;
    const reihen=Math.max(1,Math.ceil(kommend.length/spalten));
    const start=reihen*195+(reihen-1)*16;
    return '<iframe id="mhp-veranstaltungen"\n'
      +'  src="'+basis+'/veranstaltungen.html?v='+Date.now()+'"\n'
      +'  width="100%" height="'+start+'" frameborder="0" scrolling="no"\n'
      +'  style="border:none;display:block;width:100%"></iframe>\n'
      +'<script>\n'
      +'window.addEventListener("message", function(e){\n'
      +'  if(e.origin !== "'+basis+'") return;\n'
      +'  var d = e.data;\n'
      +'  if(!d || d.typ !== "mhp-hoehe") return;\n'
      +'  var f = document.getElementById("mhp-veranstaltungen");\n'
      +'  if(f) f.style.height = (d.hoehe + 8) + "px";\n'
      +'});\n'
      +'<\/script>';
  }

  // ── HTML Export ──────────────────────────────────────────────────────────────
  function exportHTML(){
    const buchungsBase=(localStorage.getItem("sd_server_url")||"").trim().replace(/\/+$/,"");
    let cardId=0;
    const evCards=kommend.map(ev=>{
      const d=ev.date?new Date(ev.date):null;
      const dEnd=ev.dateEnd&&ev.dateEnd!==ev.date?new Date(ev.dateEnd):null;
      const fmtD=(dt)=>dt?dt.toLocaleDateString("de-DE",{day:"2-digit",month:"long",year:"numeric"}):"";
      const datum=dEnd?fmtD(d)+" - "+fmtD(dEnd):fmtD(d);
      const slug=ev.buchungsUrl||(ev.name||"").toLowerCase().replace(/\s+/g,"-");
      const buchungsHref=buchungsBase&&slug?buchungsBase+"/landing_"+slug+".html":"";
      const cid="ev"+cardId++;
      const uhrzeit=(ev.hp_von&&ev.hp_bis)?ev.hp_von+" - "+ev.hp_bis+" Uhr":(ev.hp_von?ev.hp_von+" Uhr":"");
      return`<div class="ev-card" id="card_${cid}">
  <div class="ev-inner">
    <div class="ev-left">
      ${ev.hp_kategorie?`<div class="ev-badge">${ev.hp_kategorie}</div>`:""}
      <div class="ev-name">${ev.name||""}</div>
      ${datum?`<div class="ev-meta"><span class="ev-icon">📅</span>${datum}</div>`:""}
      ${uhrzeit?`<div class="ev-meta"><span class="ev-icon">🕐</span>${uhrzeit}</div>`:""}
      ${ev.location?`<div class="ev-meta"><span class="ev-icon">📍</span>${ev.location}</div>`:""}
      ${ev.hp_adresse?`<div class="ev-adresse">${ev.hp_adresse}</div>`:""}
    </div>
    <div class="ev-mid">
      ${ev.info?`<div class="ev-text" id="txt_${cid}">${ev.info.replace(/\n/g,"<br>")}</div>
      <button class="ev-mehr" onclick="toggleMehr('${cid}')"><span id="icon_${cid}">▼</span> <span id="lbl_${cid}">Mehr anzeigen</span></button>`:""}
    </div>
    <div class="ev-right">
      ${buchungsHref?`<a class="ev-btn" href="${buchungsHref}" target="_blank" rel="noopener">Zum Termin</a>`:""}
    </div>
  </div>
</div>`;
    }).join("\n");

    const html=`<!DOCTYPE html>
<html lang="de">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Veranstaltungen</title>
  <style>
    *{box-sizing:border-box;margin:0;padding:0}
    body{font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif;color:#1a1814;background:transparent;padding:0}
    .ev-card{background:${hpConfig.cardBg||"#ffffff"};border-radius:12px;margin-bottom:16px;${hpConfig.cardShadow!==false?"box-shadow:0 2px 14px rgba(0,0,0,.09);":""}overflow:hidden;border:1px solid ${hpConfig.cardBorderColor||"#ede9e2"}}
    .ev-text,.ev-text *{text-align:${hpConfig.ausrichtungText||"center"} !important}
    .ev-text ul,.ev-text ol{margin:6px 0 6px 20px;padding-left:4px;list-style-position:inside}
    .ev-text ul,.ev-text ol{margin:6px 0;padding-left:0}
    .ev-text ul{list-style:disc outside}
    .ev-text ol{list-style:decimal outside}
    .ev-text li{margin-bottom:3px}
    .ev-grid{display:grid;grid-template-columns:1fr;gap:16px}
${hpConfig.zweiSpalten?`
    @media(min-width:900px){
      .ev-grid{grid-template-columns:1fr 1fr}
      .ev-grid .ev-card{margin-bottom:0}
      .ev-grid .ev-inner{flex-direction:column;gap:14px;padding:20px 22px}
      .ev-grid .ev-left{width:100%;min-width:0;padding-right:0}
      .ev-grid .ev-mid{width:100%;border-left:none;padding-left:0;padding-right:0;border-top:1px solid #f0ece4;padding-top:12px}
      .ev-grid .ev-right{padding-left:0;width:100%}
      .ev-grid .ev-btn{width:100%;text-align:center}
    }`:""}
    .ev-inner{display:flex;align-items:flex-start;gap:0;padding:22px 28px}
    .ev-left{width:320px;min-width:320px;flex-shrink:0;padding-right:28px;text-align:${hpConfig.ausrichtungInfo||"left"}}
    .ev-badge{background:#f0ece4;color:#8A6A2E;font-size:10px;font-weight:700;letter-spacing:.1em;padding:3px 8px;border-radius:4px;display:inline-block;margin-bottom:8px}
    .ev-name{font-family:Georgia,serif;font-size:18px;font-weight:700;color:#1a1814;margin-bottom:10px;text-transform:uppercase;letter-spacing:.04em;line-height:1.3}
    .ev-meta{font-size:13px;color:#555;margin-bottom:5px;line-height:1.4${(hpConfig.ausrichtungInfo||"left")==="left"?";padding-left:20px;text-indent:-20px":(hpConfig.ausrichtungInfo||"left")==="right"?";padding-right:20px":""}}
    .ev-icon{margin-right:5px}
    .ev-adresse{font-size:12px;color:#8A8075;display:block;margin:-2px 0 5px;line-height:1.4;${(hpConfig.ausrichtungInfo||"left")==="left"?"padding-left:24px":(hpConfig.ausrichtungInfo||"left")==="right"?"padding-right:24px":""}}
    .ev-mid{flex:1;padding-right:24px;padding-top:2px;border-left:1px solid #f0ece4;padding-left:24px}
    .ev-text{font-size:14px;color:#444;line-height:1.65;overflow:hidden;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:4;line-clamp:4}
    .ev-text.open{display:block;-webkit-line-clamp:unset;line-clamp:unset;overflow:visible}
    .ev-mehr{background:none;border:none;color:#8A6A2E;font-size:12px;cursor:pointer;padding:6px 0;display:flex;align-items:center;justify-content:flex-end;gap:5px;font-family:inherit;margin-top:4px;width:100%}
    .ev-mehr:hover{opacity:.75}
    .ev-right{flex-shrink:0;display:flex;align-items:center;padding-left:24px}
    .ev-btn{display:inline-block;background:${hpConfig.btnBg||"#1a1814"};color:${hpConfig.btnColor||"#ffffff"};padding:12px 22px;border-radius:8px;text-decoration:none;font-size:13px;font-weight:600;font-family:inherit;white-space:nowrap;border:${hpConfig.btnBorderWidth||0}px solid ${hpConfig.btnBorderColor||"#1a1814"};${hpConfig.btnShadow?"box-shadow:0 2px 8px rgba(0,0,0,0.2);":""}}
    .ev-btn:hover{opacity:.8}
    .empty{color:#8A8075;padding:40px;font-size:14px;text-align:center}
    @media(max-width:700px){
      .ev-card{margin-bottom:10px;border-radius:10px}
      .ev-inner{flex-direction:column;gap:10px;padding:14px 16px}
      .ev-left{width:100%;min-width:0;padding-right:0}
      .ev-badge{font-size:9px;padding:2px 6px;margin-bottom:6px}
      .ev-name{font-size:15px;margin-bottom:7px;line-height:1.25}
      .ev-meta{font-size:12px;margin-bottom:3px}
      .ev-icon{margin-right:4px}
      .ev-adresse{font-size:11px;${(hpConfig.ausrichtungInfo||"left")==="left"?"padding-left:20px":(hpConfig.ausrichtungInfo||"left")==="right"?"padding-right:20px":""}}
      .ev-mid{width:100%;border-left:none;padding-left:0;padding-right:0;border-top:1px solid #f0ece4;padding-top:9px}
      .ev-text{font-size:13px;line-height:1.5;display:none}
      .ev-text.open{display:block}
      .ev-mehr{justify-content:center}
      .ev-right{padding-left:0;width:100%}
      .ev-btn{width:100%;text-align:center;padding:11px 18px}
    }
  </style>
  <script>
    // Eigene Hoehe an die einbettende Seite melden, damit der Rahmen dort
    // mitwaechst. Ohne das braucht es eine feste Hoehe, die entweder
    // abschneidet oder eine Leerflaeche hinterlaesst.
    function meldeHoehe(){
      // Am Inhalt messen, nicht am Dokument. Sobald der Rahmen aussen groesser
      // wird, waechst auch die Dokumenthoehe mit - die Hoehe wuerde dann nur
      // noch steigen und beim Zuklappen nie wieder schrumpfen.
      var el=document.querySelector(".ev-grid")||document.querySelector(".empty")||document.body;
      var r=el.getBoundingClientRect();
      var h=Math.ceil(r.height+r.top+window.scrollY);
      if(h<40)h=Math.ceil(document.body.getBoundingClientRect().height);
      try{ parent.postMessage({typ:"mhp-hoehe",hoehe:h},"*"); }catch(e){}
    }
    window.addEventListener("load",function(){
      meldeHoehe();
      setTimeout(meldeHoehe,300);
      setTimeout(meldeHoehe,1200);
    });
    window.addEventListener("resize",meldeHoehe);
    if(typeof ResizeObserver!=="undefined"){
      try{ new ResizeObserver(meldeHoehe).observe(document.documentElement); }
      catch(e){ setInterval(meldeHoehe,1000); }
    }else{
      setInterval(meldeHoehe,1000);
    }

    function toggleMehr(id){
      var txt=document.getElementById('txt_'+id);
      var lbl=document.getElementById('lbl_'+id);
      var icon=document.getElementById('icon_'+id);
      var isOpen=txt.classList.contains('open');
      // Alle anderen schließen
      document.querySelectorAll('.ev-text.open').forEach(function(el){
        el.classList.remove('open');
        var eid=el.id.replace('txt_','');
        var elbl=document.getElementById('lbl_'+eid);
        var eicon=document.getElementById('icon_'+eid);
        if(elbl)elbl.textContent='Mehr anzeigen';
        if(eicon)eicon.textContent='▼';
      });
      setTimeout(meldeHoehe,60);
      // Gewähltes öffnen wenn es zu war
      if(!isOpen){
        txt.classList.add('open');
        lbl.textContent='Weniger anzeigen';
        icon.textContent='▲';
        // Nach dem Öffnen zur Karte scrollen
        setTimeout(meldeHoehe,60);
        setTimeout(function(){
          var card=document.getElementById('card_'+id)||txt.closest('.ev-card');
          if(card){card.scrollIntoView({behavior:'smooth',block:'nearest'});}
        },50);
      }
    }
  </script>
</head>
<body>
  ${kommend.length>0?`<div class="ev-grid">${evCards}</div>`:`<div class="empty">Aktuell keine kommenden Veranstaltungen geplant.</div>`}
</body>
</html>`;
  // Direkt auf Server speichern
    const serverUrl=(localStorage.getItem("sd_server_url")||"").trim().replace(/\/+$/,"");
    if(!serverUrl){alert("Keine Server-URL konfiguriert.");return;}
    fetch(serverUrl+"/api/landing-upload",{
      method:"POST",
      headers:{"Content-Type":"application/json"},
      body:JSON.stringify({slug:"veranstaltungen",html})
    }).then(r=>r.json()).then(d=>{
      if(d.ok){setEinbettung(baueEinbettung());setKopiert("");}
      else alert("Fehler beim Veröffentlichen: "+JSON.stringify(d));
    }).catch(e=>alert("Fehler beim Speichern: "+e.message));
  }

  // ── iCal Export ──────────────────────────────────────────────────────────────
  function exportICal(){
    const escape=s=>(s||"").replace(/,/g,"\\\\,").replace(/;/g,"\\\\;").replace(/\n/g,"\n");
    const stamp=new Date().toISOString().replace(/[-:]/g,"").split(".")[0]+"Z";
    const events_ical=kommend.map(ev=>{
      const d=ev.date?ev.date.replace(/-/g,""):"";
      const uid_val=`${ev.id||uid()}@scattodesk`;
      return[
        "BEGIN:VEVENT",
        `UID:${uid_val}`,
        `DTSTAMP:${stamp}`,
        `DTSTART;VALUE=DATE:${d}`,
        `DTEND;VALUE=DATE:${d}`,
        `SUMMARY:${escape(ev.name)}`,
        ev.location?`LOCATION:${escape(ev.location)}`:"",
        ev.fotoart?`DESCRIPTION:${escape(ev.fotoart+(ev.info?" - "+ev.info:""))}`:"",
        hpConfig.buchungsLink?`URL:${hpConfig.buchungsLink}`:"",
        "END:VEVENT"
      ].filter(Boolean).join("\\r\n");
    }).join("\\r\n");

    const ical=[
      "BEGIN:VCALENDAR",
      "VERSION:2.0",
      `PRODID:-//ScattoDesk//${config?.studioName||"Fotografie"}//DE`,
      `X-WR-CALNAME:${hpConfig.titel}`,
      "X-WR-TIMEZONE:Europe/Berlin",
      "CALSCALE:GREGORIAN",
      "METHOD:PUBLISH",
      events_ical,
      "END:VCALENDAR"
    ].join("\\r\n");

    const blob=new Blob([ical],{type:"text/calendar;charset=utf-8"});
    const a=document.createElement("a");
    a.href=URL.createObjectURL(blob);
    a.download="veranstaltungen.ics";
    a.click();
  }

  // ── Widget Code ──────────────────────────────────────────────────────────────
  const widgetCode=`<!-- ScattoDesk Veranstaltungs-Widget -->
<div id="scattodesk-events"></div>
<script>
  fetch('https://DEINE-SERVER-URL/api/events/public')
    .then(r=>r.json())
    .then(events=>{
      const el=document.getElementById('scattodesk-events');
      el.innerHTML=events.map(ev=>'<div style="border:1px solid #e0ddd8;border-radius:8px;padding:16px;margin-bottom:12px"><strong>'+ev.name+'</strong><br><span style="color:#888">'+ev.date+' · '+ev.fotoart+'</span></div>').join('');
    });
<\/script>
<!-- Ersetze DEINE-SERVER-URL mit deiner ScattoDesk Server-Adresse -->`;

  const TABS=[{id:"html",l:"\ud83d\udcc4 HTML-Seite"},{id:"ical",l:"\ud83d\udcc5 iCal"},{id:"widget",l:"\ud83d\udd27 Widget"}];

  return(
    <div style={{minHeight:"100vh",background:T.bg,color:T.text,fontFamily:"Inter,system-ui,sans-serif",fontSize:14,padding:32}}>
      <div style={{display:"flex",alignItems:"flex-start",justifyContent:"space-between",marginBottom:24}}>
        <div>
          <div style={{fontFamily:"Georgia,serif",fontSize:26,fontWeight:700,color:T.text}}>Homepage Export</div>
          <div style={{fontSize:13,color:T.muted,marginTop:2}}>{kommend.length} kommende Events · IONOS</div>
        </div>
      </div>

      <div style={{display:"grid",gridTemplateColumns:"280px 1fr",gap:24,alignItems:"start"}}>
        {/* Config Sidebar */}
        <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:12,padding:20,display:"flex",flexDirection:"column",gap:12}}>
          <div style={{fontFamily:"Georgia,serif",fontSize:14,color:T.accent,marginBottom:4}}>Einstellungen</div>
          {[["titel","Titel"],["untertitel","Untertitel"],["buchungsLink","Buchungs-URL"]].map(([k,l])=>(
            <div key={k}>
              <label style={{fontSize:11,color:T.muted,fontWeight:600,display:"block",marginBottom:4}}>{l}</label>
              <input value={hpConfig[k]||""} onChange={e=>sc(k,e.target.value)} style={{...IS(T),padding:"7px 10px",fontSize:12}}/>
            </div>
          ))}
          <div>
            <label style={{fontSize:11,color:T.muted,fontWeight:600,display:"block",marginBottom:4}}>Akzentfarbe</label>
            <input type="color" value={hpConfig.farbe||"#C9A96E"} onChange={e=>sc("farbe",e.target.value)} style={{width:"100%",height:36,borderRadius:6,border:`1px solid ${T.border}`,cursor:"pointer"}}/>
          </div>
          <div>
            <label style={{fontSize:11,color:T.muted,fontWeight:600,display:"block",marginBottom:4}}>Kopfbereich Landingpage</label>
            <div style={{display:"flex",gap:6,alignItems:"center"}}>
              <input type="color" value={hpConfig.heroBg||"#1a1814"} onChange={e=>sc("heroBg",e.target.value)} style={{flex:1,height:36,borderRadius:6,border:`1px solid ${T.border}`,cursor:"pointer"}}/>
              <button onClick={()=>sc("heroBg","#f5f3ef")} style={{...btn(T,"ghost",true),fontSize:11}}>Hell</button>
              <button onClick={()=>sc("heroBg","#1a1814")} style={{...btn(T,"ghost",true),fontSize:11}}>Dunkel</button>
            </div>
            <div style={{fontSize:10,color:T.muted,marginTop:3}}>Wirkt erst nach dem Neuerzeugen einer Landingpage.</div>
          </div>
          <div>
            <label style={{fontSize:11,color:T.muted,fontWeight:600,display:"block",marginBottom:4}}>Logo (optional)</label>
            <div style={{display:"flex",gap:6,alignItems:"center"}}>
              {hpConfig.logo&&<img src={hpConfig.logo} style={{height:28,maxWidth:80,objectFit:"contain",borderRadius:4}}/>}
              <label style={{...btn(T,"ghost",true),cursor:"pointer",fontSize:11}}>
                \ud83d\udcc1 Wählen
                <input type="file" accept="image/*" style={{display:"none"}} onChange={e=>{const f=e.target.files[0];if(!f)return;const r=new FileReader();r.onload=ev=>sc("logo",ev.target.result);r.readAsDataURL(f);}}/>
              </label>
              {hpConfig.logo&&<button style={btn(T,"danger",true)} onClick={()=>sc("logo","")}>✕</button>}
            </div>
          </div>
          <div style={{borderTop:`1px solid ${T.border}`,paddingTop:12,marginTop:4}}>
            <div style={{fontSize:11,color:T.accent,fontWeight:700,marginBottom:8}}>Kachel</div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginBottom:8}}>
              <div>
                <label style={{fontSize:11,color:T.muted,fontWeight:600,display:"block",marginBottom:4}}>Hintergrund</label>
                <div style={{display:"flex",gap:4}}>
                  <input type="color" value={hpConfig.cardBg||"#ffffff"} onChange={e=>sc("cardBg",e.target.value)} style={{width:36,height:28,borderRadius:4,border:`1px solid ${T.border}`,cursor:"pointer",flexShrink:0}}/>
                  <input value={hpConfig.cardBg||"#ffffff"} onChange={e=>sc("cardBg",e.target.value)} style={{...IS(T),padding:"4px 6px",fontSize:11,flex:1}}/>
                </div>
              </div>
              <div>
                <label style={{fontSize:11,color:T.muted,fontWeight:600,display:"block",marginBottom:4}}>Rahmenfarbe</label>
                <div style={{display:"flex",gap:4}}>
                  <input type="color" value={hpConfig.cardBorderColor||"#ede9e2"} onChange={e=>sc("cardBorderColor",e.target.value)} style={{width:36,height:28,borderRadius:4,border:`1px solid ${T.border}`,cursor:"pointer",flexShrink:0}}/>
                  <input value={hpConfig.cardBorderColor||"#ede9e2"} onChange={e=>sc("cardBorderColor",e.target.value)} style={{...IS(T),padding:"4px 6px",fontSize:11,flex:1}}/>
                </div>
              </div>
            </div>
            <label style={{display:"flex",alignItems:"center",gap:8,cursor:"pointer",fontSize:12,color:T.text,marginBottom:12}}>
              <input type="checkbox" checked={hpConfig.cardShadow!==false} onChange={e=>sc("cardShadow",e.target.checked)} style={{accentColor:T.accent}}/>
              Schatten
            </label>
          </div>
          <div style={{borderTop:`1px solid ${T.border}`,paddingTop:12,marginTop:4}}>
            <div style={{fontSize:11,color:T.accent,fontWeight:700,marginBottom:8}}>Button</div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginBottom:8}}>
              <div>
                <label style={{fontSize:11,color:T.muted,fontWeight:600,display:"block",marginBottom:4}}>Hintergrund</label>
                <div style={{display:"flex",gap:4}}>
                  <input type="color" value={hpConfig.btnBg||"#1a1814"} onChange={e=>sc("btnBg",e.target.value)} style={{width:36,height:28,borderRadius:4,border:`1px solid ${T.border}`,cursor:"pointer",flexShrink:0}}/>
                  <input value={hpConfig.btnBg||"#1a1814"} onChange={e=>sc("btnBg",e.target.value)} style={{...IS(T),padding:"4px 6px",fontSize:11,flex:1}}/>
                </div>
              </div>
              <div>
                <label style={{fontSize:11,color:T.muted,fontWeight:600,display:"block",marginBottom:4}}>Textfarbe</label>
                <div style={{display:"flex",gap:4}}>
                  <input type="color" value={hpConfig.btnColor||"#ffffff"} onChange={e=>sc("btnColor",e.target.value)} style={{width:36,height:28,borderRadius:4,border:`1px solid ${T.border}`,cursor:"pointer",flexShrink:0}}/>
                  <input value={hpConfig.btnColor||"#ffffff"} onChange={e=>sc("btnColor",e.target.value)} style={{...IS(T),padding:"4px 6px",fontSize:11,flex:1}}/>
                </div>
              </div>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginBottom:8}}>
              <div>
                <label style={{fontSize:11,color:T.muted,fontWeight:600,display:"block",marginBottom:4}}>Rahmenfarbe</label>
                <div style={{display:"flex",gap:4}}>
                  <input type="color" value={hpConfig.btnBorderColor||"#1a1814"} onChange={e=>sc("btnBorderColor",e.target.value)} style={{width:36,height:28,borderRadius:4,border:`1px solid ${T.border}`,cursor:"pointer",flexShrink:0}}/>
                  <input value={hpConfig.btnBorderColor||"#1a1814"} onChange={e=>sc("btnBorderColor",e.target.value)} style={{...IS(T),padding:"4px 6px",fontSize:11,flex:1}}/>
                </div>
              </div>
              <div>
                <label style={{fontSize:11,color:T.muted,fontWeight:600,display:"block",marginBottom:4}}>Rahmenstärke (px)</label>
                <input type="number" min="0" max="10" value={hpConfig.btnBorderWidth||0} onChange={e=>sc("btnBorderWidth",Number(e.target.value))} style={{...IS(T),padding:"4px 6px",fontSize:11}}/>
              </div>
            </div>
            <label style={{display:"flex",alignItems:"center",gap:8,cursor:"pointer",fontSize:12,color:T.text}}>
              <input type="checkbox" checked={hpConfig.btnShadow||false} onChange={e=>sc("btnShadow",e.target.checked)} style={{accentColor:T.accent}}/>
              Schatten
            </label>
          </div>
          <div style={{borderTop:`1px solid ${T.border}`,paddingTop:12,marginTop:4,display:"flex",flexDirection:"column",gap:8}}>
            <div style={{fontSize:11,fontWeight:700,color:T.muted,textTransform:"uppercase",letterSpacing:".06em"}}>Ausrichtung</div>
            {[["ausrichtungInfo","Name, Datum, Ort","left"],["ausrichtungText","Beschreibung","center"]].map(([k,l,vor])=>(
              <div key={k}>
                <label style={{fontSize:11,color:T.muted,display:"block",marginBottom:3}}>{l}</label>
                <select value={hpConfig[k]||vor} onChange={e=>sc(k,e.target.value)}
                  style={{...IS(T),padding:"5px 8px",fontSize:12}}>
                  <option value="left">Linksbündig</option>
                  <option value="center">Mittig</option>
                  <option value="right">Rechtsbündig</option>
                </select>
              </div>
            ))}
          </div>

          {[["zeigeBeschreibung","Beschreibung anzeigen"],["zeigeOrt","Ort anzeigen"],["zeigePreis","Preis anzeigen"],["zweiSpalten","2-spaltig (ab Tablet)"]].map(([k,l])=>(
            <label key={k} style={{display:"flex",alignItems:"center",gap:8,cursor:"pointer",fontSize:12,color:T.text}}>
              <input type="checkbox" checked={hpConfig[k]} onChange={e=>sc(k,e.target.checked)} style={{accentColor:T.accent}}/>
              {l}
            </label>
          ))}
        </div>

        {/* Main */}
        <div>
          <div style={{display:"flex",gap:6,marginBottom:20}}>
            {TABS.map(t=><button key={t.id} style={btn(T,tab===t.id?"active":"ghost")} onClick={()=>setTab(t.id)}>{t.l}</button>)}
          </div>

          {tab==="html"&&(
            <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:12,padding:24}}>
              <div style={{fontFamily:"Georgia,serif",fontSize:16,color:T.accent,marginBottom:8}}>HTML-Seite für IONOS</div>
              <p style={{fontSize:13,color:T.muted,lineHeight:1.7,marginBottom:20}}>
                Exportiert eine fertige HTML-Datei mit allen kommenden Events. Hochladen über:<br/>
                <strong style={{color:T.text}}>IONOS → Hosting → FTP & Datei-Manager → Datei hochladen</strong><br/>
                Danach ist die Seite unter <code style={{background:T.bg,padding:"1px 5px",borderRadius:3,fontSize:11}}>www.deineseite.de/veranstaltungen.html</code> erreichbar.
              </p>
              {/* Vorschau */}
              <div style={{background:T.bg,borderRadius:8,padding:16,marginBottom:20,maxHeight:200,overflowY:"auto"}}>
                <p style={{color:T.muted,fontSize:11,marginBottom:8}}>Gefunden: {kommend.length} · hp_aktiv-Shootings: {hpShootings.length} · shootingTypes gesamt: {(buchCfg.shootingTypes||[]).length}</p>
              {kommend.length===0?<p style={{color:T.muted,fontSize:12}}>Keine kommenden Events vorhanden.</p>:
                kommend.map(ev=>(
                  <div key={ev.id} style={{padding:"10px 0",borderBottom:`1px solid ${T.border}22`,display:"flex",justifyContent:"space-between"}}>
                    <div>
                      <div style={{fontSize:13,fontWeight:600,color:T.text}}>{ev.name}</div>
                      <div style={{fontSize:11,color:T.muted}}>{ev.date?new Date(ev.date).toLocaleDateString("de-DE",{day:"2-digit",month:"long",year:"numeric"}):""}{(ev.shootingart||ev.fotoart)?` · ${ev.shootingart||ev.fotoart}`:""}{ev.location?` · ${ev.location}`:""}</div>
                    </div>
                    <div style={{fontSize:11,color:hpConfig.farbe,fontWeight:600,flexShrink:0,marginLeft:12}}>
                      {Math.ceil((new Date(ev.date)-new Date())/86400000)}d
                    </div>
                  </div>
                ))}
              </div>
              {einbettung&&(
                <div style={{background:T.bg,border:`1px solid ${T.accent}`,borderRadius:10,padding:14,marginBottom:18}}>
                  <div style={{fontSize:13,fontWeight:600,color:T.success,marginBottom:4}}>
                    ✓ Veröffentlicht — {kommend.length} {kommend.length===1?"Veranstaltung":"Veranstaltungen"} sind jetzt online
                  </div>
                  <div style={{fontSize:12,color:T.muted,lineHeight:1.6,marginBottom:10}}>
                    Diesen Code bei IONOS in das HTML-Element einsetzen. Die Höhe stellt sich danach von selbst auf die Anzahl der Veranstaltungen ein, auch wenn jemand „Mehr anzeigen“ aufklappt.
                  </div>
                  <textarea id="sd-einbettung" readOnly value={einbettung} onFocus={e=>e.target.select()}
                    style={{width:"100%",minHeight:150,resize:"vertical",background:T.surface,
                            border:`1px solid ${T.border}`,borderRadius:8,padding:10,
                            color:T.text,fontSize:11,fontFamily:"ui-monospace,Menlo,Consolas,monospace",lineHeight:1.5}}/>
                  <div style={{display:"flex",gap:8,marginTop:8}}>
                    <button style={btn(T,"primary",true)} onClick={kopiereEinbettung}>
                      {kopiert==="ok"?"\u2713 Kopiert":kopiert==="fehler"?"Bitte von Hand markieren":"In die Zwischenablage"}
                    </button>
                    <button style={btn(T,"ghost",true)} onClick={()=>{setEinbettung("");setKopiert("");}}>Schließen</button>
                  </div>
                  {kopiert&&(
                    <div style={{fontSize:12,marginTop:8,lineHeight:1.6,
                                 color:kopiert==="ok"?T.success:T.danger}}>
                      {kopiert==="ok"
                        ?"Der Code liegt in der Zwischenablage. Bei IONOS mit Strg+V einfügen."
                        :"Der Browser hat das Kopieren nicht zugelassen. Klick ins Textfeld, dann Strg+A und Strg+C."}
                    </div>
                  )}
                </div>
              )}
              <div style={{display:"flex",gap:10,flexWrap:"wrap"}}>
                <button style={btn(T,"primary")} onClick={exportHTML}>☁️ Auf Server veröffentlichen</button>
                <button style={btn(T,"ghost")} onClick={()=>setEinbettung(baueEinbettung())}>Einbettungscode anzeigen</button>
                <button style={btn(T,"ghost")} onClick={()=>{const serverUrl=(localStorage.getItem("sd_server_url")||"").trim().replace(/\/+$/,"");if(!serverUrl){alert("Keine Server-URL konfiguriert.");return;}const cfg=JSON.parse(localStorage.getItem("sd_buchung_config")||"null");if(!cfg||!Array.isArray(cfg.shootingTypes)){alert("Keine Buchungsplan-Daten.");return;}const evts=JSON.parse(localStorage.getItem("sd_events")||"[]");const sts=cfg.shootingTypes.filter(st=>st.eventId&&st.hp_aktiv!==false);if(!sts.length){alert("Keine aktiven Veranstaltungen.");return;}let done=0;sts.forEach(st=>{const ev=evts.find(e=>e.id===st.eventId)||{};generateLandingPageFromEvent({...ev,id:ev.id,name:st.name||ev.name,fotoart:ev.fotoart,date:ev.date,dateBis:ev.dateBis,location:ev.location,adresse:ev.adresse,info:ev.info||st.beschreibung?.de||"",kopfbereich:st.kopfbereich||"",kopfbereich_en:st.kopfbereich_en||"",event_info:st.event_info||"",event_info_en:st.event_info_en||"",hp_beschreibung:st.hp_beschreibung||""},{noPreview:true,silent:true});done++;});setTimeout(()=>alert("\u2705 "+done+" Landingpages neu hochgeladen."),2000);}}>🔄 Alle Landingpages neu generieren</button>
              </div>
            </div>
          )}

          {tab==="ical"&&(
            <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:12,padding:24}}>
              <div style={{fontFamily:"Georgia,serif",fontSize:16,color:T.accent,marginBottom:8}}>iCal Export (.ics)</div>
              <p style={{fontSize:13,color:T.muted,lineHeight:1.7,marginBottom:16}}>
                Exportiert alle Events als Kalenderdatei. Verwendung auf IONOS:
              </p>
              <div style={{background:T.bg,borderRadius:8,padding:14,marginBottom:20,fontSize:12,color:T.text,lineHeight:1.8}}>
                <div style={{fontWeight:600,color:T.accent,marginBottom:6}}>Option A — Google Calendar einbetten:</div>
                <div style={{color:T.muted}}>1. .ics Datei in Google Calendar importieren (calendar.google.com → Weitere Kalender → Importieren)<br/>2. Kalender öffentlich stellen → Einbettungscode kopieren<br/>3. Code in IONOS Website Builder als HTML-Element einfügen</div>
                <div style={{fontWeight:600,color:T.accent,marginTop:10,marginBottom:6}}>Option B — IONOS Plugin:</div>
                <div style={{color:T.muted}}>1. .ics Datei auf deinen Webspace hochladen<br/>2. IONOS Website Builder → Elemente → Kalender → iCal URL eintragen</div>
              </div>
              <button style={btn(T,"primary")} onClick={exportICal}>⬇️ veranstaltungen.ics herunterladen</button>
            </div>
          )}

          {tab==="widget"&&(
            <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:12,padding:24}}>
              <div style={{fontFamily:"Georgia,serif",fontSize:16,color:T.accent,marginBottom:8}}>Widget-Code</div>
              <div style={{background:T.warning+"22",border:`1px solid ${T.warning}44`,borderRadius:8,padding:"10px 14px",fontSize:12,color:T.warning,marginBottom:16}}>
                ⚠️ Benötigt den ScattoDesk Backend-Server. Erst einrichten wenn der Server läuft.
              </div>
              <p style={{fontSize:13,color:T.muted,lineHeight:1.7,marginBottom:12}}>
                Diesen Code einmalig in deine IONOS-Seite einfügen (HTML-Element). Danach aktualisieren sich Events automatisch.
              </p>
              <div style={{background:T.bg,borderRadius:8,padding:14,fontFamily:"monospace",fontSize:11,color:T.text,lineHeight:1.7,whiteSpace:"pre-wrap",marginBottom:16,overflowX:"auto"}}>
                {widgetCode}
              </div>
              <button style={btn(T,"ghost")} onClick={()=>{navigator.clipboard.writeText(widgetCode);alert("✅ Code kopiert!");}}>
                \ud83d\udccb Code kopieren
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

function VereinbarungSendenModal({ziel, T, ev, eventName, eventDate, fotoart, selectedEventId, onClose}){
  const cfg=(()=>{try{return JSON.parse(localStorage.getItem("sd_buchung_config")||"{}");}catch{return {};}})();
  const vorl=(()=>{try{return JSON.parse(localStorage.getItem("sd_email_vorlagen")||"{}");}catch{return {};}})();
  const st=(cfg.shootingTypes||[]).find(x=>x.eventId===selectedEventId)||{};
  const sName=cfg.studioName||"Fotoshooting";
  const vereinb=(st.vereinbarung&&st.vereinbarung.de)||"";
  const datumLang=ev.date?new Date(ev.date).toLocaleDateString("de-DE",{weekday:"long",day:"2-digit",month:"long",year:"numeric"}):(eventDate||"");
  const v=vorl.vereinbarung||{};
  const stdBetreff="Deine Shooting-Vereinbarung – "+(ev.name||eventName||"");
  const stdText="Hallo {{name}},\n\nfür dein Shooting am {{datum}} um {{uhrzeit}} Uhr fehlt noch die unterschriebene Shootingvereinbarung.\n\nÜber diesen Link kannst du sie in Ruhe durchlesen und direkt am Handy unterschreiben:\n\n{{vereinbarung_link}}\n\nBei Fragen melde dich einfach kurz.\n\nHerzliche Grüße\n{{studio}}";
  const [betreff,setBetreff]=useState(v.betreff||stdBetreff);
  const [text,setText]=useState(v.text||stdText);
  const [state,setState]=useState("");
  const [msg,setMsg]=useState("");

  const senden=async()=>{
    if(!vereinb&&!window.confirm("Für diese Veranstaltung ist kein Vereinbarungstext hinterlegt. Trotzdem senden?"))return;
    let srv=(localStorage.getItem("sd_server_url")||"").trim().replace(/\/+$/,"");
    if(!srv||(window.location.protocol==="https:"&&srv.startsWith("http://")))srv=window.location.origin;
    let smtp={};try{smtp=JSON.parse(localStorage.getItem("sd_smtp_buchung")||localStorage.getItem("sd_smtp_settings")||"{}");}catch{}
    const esc=t=>String(t==null?"":t).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;");
    setState("senden");setMsg("");
    let ok=0,fail=0,letzter="";
    for(const r of ziel){
      const zeilen=[
        ["Shooting-Art",st.name||ev.fotoart||fotoart||""],
        ["Veranstaltung",ev.name||eventName||""],
        ["Datum",datumLang],
        ["Uhrzeit",r.uhrzeit||""],
        ["Name",r.name||""],
        ["Straße",r.strasse||""],
        ["PLZ",r.plz||""],
        ["Ort",r.ort||""],
        ["Telefon",r.telefon||""],
        ["E-Mail",r.email||""],
        ["Rasse",r.rasse||""],
        ["Tiername",r.hund||""],
        ["Geschlecht",r.geschlecht||""],
        ["Alter",r.alter||""],
      ].filter(([,w])=>String(w||"").trim());
      const tabelle=zeilen.map(([l,w])=>`<tr><td style="padding:5px 8px;color:#888;width:130px">${esc(l)}</td><td style="padding:5px 8px">${esc(w)}</td></tr>`).join("");
      const html=`<!DOCTYPE html><html><head><meta charset="utf-8"><title>Shooting-Vereinbarung</title>
        <style>
          body{font-family:Georgia,serif;color:#1a1814;max-width:650px;margin:0 auto;padding:8px;font-size:13px}
          h1{font-size:20px;color:#A8843E;margin-bottom:2px}
          .meta{font-size:11px;color:#888;margin-bottom:20px}
          h2{font-size:14px;color:#A8843E;border-bottom:1px solid #e0ddd8;padding-bottom:5px;margin:20px 0 10px}
          table{width:100%;border-collapse:collapse;margin-bottom:12px}
          td{padding:5px 8px;border-bottom:1px solid #f0ede8;font-size:12px;vertical-align:top}
          .vereinb{background:#f5f3ef;border-radius:6px;padding:14px;font-size:12px;line-height:1.7;color:#444;margin:10px 0 16px}
          .sig-box{margin-top:16px;padding-top:14px;border-top:1px solid #e0ddd8}
          .footer{margin-top:32px;font-size:10px;color:#aaa;text-align:center;border-top:1px solid #eee;padding-top:12px}
        </style></head><body>
        <h1>${esc(sName)}</h1>
        <div class="meta">Shooting-Vereinbarung</div>
        <h2>Buchungsdetails</h2>
        <table>${tabelle}</table>
        ${vereinb?`<h2>Vereinbarung</h2><div class="vereinb">${esc(vereinb).split("\n").join("<br/>")}</div>`:""}
        <div class="sig-box">
          <div style="font-size:11px;color:#888;margin-bottom:6px">Unterschrift des Auftraggebers:</div>
          <!--SIG_KUNDE-->
          <div style="font-size:11px;color:#888;margin-top:8px"><!--ORT_DATUM--></div>
        </div>
        <div class="footer">${esc(sName)}</div>
        </body></html>`;
      const ersetz=t=>String(t||"")
        .replace(/\{\{name\}\}/g,r.name||"")
        .replace(/\{\{vorname\}\}/g,(r.vorname||String(r.name||"").split(" ")[0]||""))
        .replace(/\{\{shooting\}\}/g,st.name||ev.fotoart||"")
        .replace(/\{\{event\}\}/g,ev.name||eventName||"")
        .replace(/\{\{datum\}\}/g,datumLang)
        .replace(/\{\{uhrzeit\}\}/g,r.uhrzeit||"")
        .replace(/\{\{ort\}\}/g,ev.location||"")
        .replace(/\{\{studio\}\}/g,sName)
        .replace(/\{\{vereinbarung_link\}\}/g,"{link}");
      let mailText=ersetz(text);
      if(mailText.indexOf("{link}")<0)mailText+="\n\n{link}";
      try{
        const res=await fetch(srv+"/api/vertrag-senden",{
          method:"POST",headers:{"Content-Type":"application/json"},
          body:JSON.stringify({
            name:r.name||"",email:r.email,
            dateiname:"Vereinbarung_"+String(r.name||"Teilnehmer").replace(/\s+/g,"_"),
            html,betreff:ersetz(betreff),text:mailText,
            studio:sName,
            basis:(cfg.buchungsUrlBasis||"").replace(/\/+$/,"")||undefined,
            smtp,
          }),
        });
        const d=await res.json();
        if(d.ok)ok++;else{fail++;letzter=d.fehler||d.error||"Unbekannt";}
      }catch(e){fail++;letzter=(e&&e.message)||String(e);}
    }
    if(fail>0){
      setState("fehler");
      setMsg(ok+" gesendet, "+fail+" fehlgeschlagen. Fehler: "+letzter);
      return;
    }
    // Alles raus: kurz Bescheid geben und das Fenster schliessen.
    onClose();
    window.alert("✅ Vereinbarung an "+ok+(ok===1?" Teilnehmer":" Teilnehmer")+" verschickt.");
  };

  const IS={background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:"8px 10px",fontSize:12,color:T.text,fontFamily:"inherit",outline:"none",boxSizing:"border-box"};
  return(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.5)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:1000,padding:20}} onClick={onClose}>
      <div style={{background:T.surface,borderRadius:14,padding:24,width:"100%",maxWidth:620,maxHeight:"90vh",overflowY:"auto"}} onClick={e=>e.stopPropagation()}>
        <div style={{fontFamily:"Georgia,serif",fontSize:16,color:T.accent,marginBottom:6}}>✍️ Vereinbarung senden</div>
        <div style={{fontSize:12,color:T.muted,marginBottom:16,lineHeight:1.5}}>
          Geht an {ziel.length} {ziel.length===1?"Teilnehmer":"Teilnehmer"}: {ziel.map(r=>r.name||r.email).join(", ")}
        </div>
        <div style={{marginBottom:12}}>
          <div style={{fontSize:10,color:T.muted,marginBottom:4,textTransform:"uppercase",letterSpacing:"0.05em"}}>Betreff</div>
          <input style={{...IS,width:"100%"}} value={betreff} onChange={e=>setBetreff(e.target.value)}/>
        </div>
        <div style={{marginBottom:8}}>
          <div style={{fontSize:10,color:T.muted,marginBottom:4,textTransform:"uppercase",letterSpacing:"0.05em"}}>Text</div>
          <textarea style={{...IS,width:"100%",minHeight:200,resize:"vertical",lineHeight:1.6}} value={text} onChange={e=>setText(e.target.value)}/>
        </div>
        <div style={{fontSize:10,color:T.muted,marginBottom:16,lineHeight:1.5}}>
          Platzhalter: {"{{name}}"}, {"{{vorname}}"}, {"{{datum}}"}, {"{{uhrzeit}}"}, {"{{ort}}"}, {"{{event}}"}, {"{{shooting}}"}, {"{{studio}}"}, {"{{vereinbarung_link}}"}.
          Änderungen hier gelten nur für diesen Versand. Dauerhaft ändern kannst du den Text unter Einstellungen → E-Mail-Vorlagen → Vereinbarung.
        </div>
        {msg&&<div style={{fontSize:12,marginBottom:14,color:state==="ok"?T.success:T.danger}}>{msg}</div>}
        <div style={{display:"flex",justifyContent:"flex-end",gap:8}}>
          <button onClick={onClose} style={{background:"none",border:`1px solid ${T.border}`,borderRadius:8,padding:"8px 14px",fontSize:12,cursor:"pointer",color:T.text,fontFamily:"inherit"}}>
            {state==="ok"?"Fertig":"Abbrechen"}
          </button>
          <button onClick={senden} disabled={state==="senden"}
            style={{background:T.accent,color:"#fff",border:"none",borderRadius:8,padding:"8px 18px",fontSize:12,fontWeight:600,fontFamily:"inherit",cursor:state==="senden"?"default":"pointer",opacity:state==="senden"?0.6:1}}>
            {state==="senden"?"Wird gesendet…":"Senden"}
          </button>
        </div>
      </div>
    </div>
  );
}

function InfoMailModal({rows, config, T, eventName, eventDate, onClose, variante="info"}){
  // Variante "absage": gleiche Mechanik (Einzeln/Sammel mit BCC), nur andere
  // Vorlage, Ueberschrift und Farbe.
  const istAbsage=variante==="absage";
  // Datum immer deutsch ausgeben, nicht im Rohformat 2026-09-06.
  const eventDateFmt=eventDate?(()=>{try{const d=new Date(eventDate);return isNaN(d)?eventDate:d.toLocaleDateString("de-DE",{day:"2-digit",month:"2-digit",year:"numeric"});}catch{return eventDate;}})():"";
  const AKZENT=istAbsage?"#C0563E":"#0f6e56";
  const selected=rows.filter(r=>r._selected&&r.email&&!r.blocked);
  const smtp=(()=>{try{const s=JSON.parse(localStorage.getItem("sd_smtp_info")||localStorage.getItem("sd_smtp_settings")||"{}");return{...s,from_email:"info@m-h-photo.de"};}catch{return{};}})();
  const vorlagen=(()=>{try{return JSON.parse(localStorage.getItem("sd_email_vorlagen")||"{}");}catch{return{};}})();
  const studio=config?.studioName||smtp.from||"";
  const defTmpl=(istAbsage
    ?(vorlagen.absage||{betreff:"Absage deines Shootings – "+eventName,
        text:"Hallo {{name}},\n\nleider müssen wir dein Shooting am "+eventDate+" absagen.\n\nWir melden uns baldmöglichst für einen neuen Termin.\n\nHerzliche Grüße\n"+studio})
    :(vorlagen.info_mail||{betreff:"Wichtige Infos zu deinem Shooting – "+eventName,
        text:"Hallo {{name}},\n\nhier sind wichtige Informationen zu deinem Shooting am "+eventDate+":\n\n[Deine Infos hier]\n\nHerzliche Grüße\n"+studio}));
  const [betreff,setBetreff]=useState(defTmpl.betreff||"");
  const [text,setText]=useState(defTmpl.text||"");
  const modusKey=istAbsage?"sd_absagemail_modus":"sd_infomail_modus";
  const [modus,setModus]=useState(()=>localStorage.getItem(modusKey)||"einzeln");
  const sammelAnrede="zusammen";
  const persoDrin=/\{\{(name|vorname)\}\}/.test(betreff+text);
  const [sending,setSending]=useState(false);
  const [done,setDone]=useState(false);
  const [kopieAnMich,setKopieAnMich]=useState(()=>localStorage.getItem("sd_mail_kopie")==="1");
  const [vorschau,setVorschau]=useState(false);
  const kopieAdresse=smtp.from_email||smtp.user||"";
  const serverUrl=(localStorage.getItem("sd_server_url")||"").trim().replace(/\/+$/,"");

  function buildText(r){
    const name=r.name||r.vorname||"Teilnehmer";
    const _evObjInfo=(()=>{try{const evts=JSON.parse(localStorage.getItem("sd_events")||"[]");return evts.find(e=>e.name===eventName)||null;}catch{return null;}})();
    const _loc=[_evObjInfo?.adresse?.strasse,_evObjInfo?.adresse?.plz,_evObjInfo?.adresse?.ort].filter(Boolean).join(", ")||_evObjInfo?.location||"";
    const _uhr=r.uhrzeit||"";
    return{
      betreff:betreff.replace(/{{name}}/g,name).replace(/{{vorname}}/g,vornameAus(name)).replace(/{{(shooting|event|veranstaltung)}}/g,eventName||"").replace(/{{datum}}/g,eventDateFmt||"").replace(/{{uhrzeit}}/g,_uhr).replace(/{{studio}}/g,studio).replace(/{{location}}/g,_loc),
      text:text.replace(/{{name}}/g,name).replace(/{{vorname}}/g,vornameAus(name)).replace(/{{(shooting|event|veranstaltung)}}/g,eventName||"").replace(/{{datum}}/g,eventDateFmt||"").replace(/{{uhrzeit}}/g,_uhr).replace(/{{studio}}/g,studio).replace(/{{location}}/g,_loc)
    };
  }

  async function send(){
    if(betragCheck())return;
    localStorage.setItem(modusKey,modus);
    setSending(true);
    let ok=0,fail=0;

    if(modus==="sammel"){
      // Eine einzige Mail. Der erste Empfaenger steht im An-Feld, alle
      // weiteren gehen als Blindkopie mit. Personalisierung ist hier nicht
      // moeglich, deshalb eine neutrale Anrede.
      const {betreff:b,text:t}=buildText({name:sammelAnrede});
      try{
        const r=await fetch(`${serverUrl}/api/newsletter`,{method:"POST",headers:{"Content-Type":"application/json"},
          body:JSON.stringify({smtp,
            recipients:[{name:"",email:selected[0].email},
                        ...(kopieAnMich&&kopieAdresse?[{name:"Kopie",email:kopieAdresse}]:[])],
            bcc:selected.slice(1).map(x=>x.email),
            subject:b,text:t,
            html:buildScattoDeskMailHtml(t,_getSig().logo,_getSig().text),logo:_getSig().logo})});
        const d=await r.json();
        if(d&&d.ok)ok=selected.length; else fail=selected.length;
      }catch{fail=selected.length;}
    }else{
      let kopieGesendet=false;
      for(const r of selected){
        const{betreff:b,text:t}=buildText(r);
        try{
          await fetch(`${serverUrl}/api/newsletter`,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({smtp,recipients:[{name:r.name||"",email:r.email}],subject:b,text:t,
            html:buildScattoDeskMailHtml(t,_getSig().logo,_getSig().text),logo:_getSig().logo})});
          ok++;
          // Eine einzige Kopie an mich, mit der ersten Mail als Beispiel.
          if(kopieAnMich&&kopieAdresse&&!kopieGesendet){
            kopieGesendet=true;
            try{
              await fetch(`${serverUrl}/api/newsletter`,{method:"POST",headers:{"Content-Type":"application/json"},
                body:JSON.stringify({smtp,recipients:[{name:"Kopie",email:kopieAdresse}],
                  subject:"[Kopie] "+b,text:t,
                  html:buildScattoDeskMailHtml(t,_getSig().logo,_getSig().text),logo:_getSig().logo})});
            }catch{}
          }
        }catch{fail++;}
      }
    }
    setSending(false);
    setDone(true);
    if(fail>0)alert(`⚠️ ${fail} Mails fehlgeschlagen.`);
  }
  function betragCheck(){if(selected.length===0){alert("Keine Empfänger ausgewählt.");return true;}return false;}

  const IS2={background:"#f5f3ef",border:"1px solid #e0ddd8",borderRadius:8,padding:"8px 12px",color:"#1a1814",fontSize:13,fontFamily:"inherit",outline:"none",width:"100%"};
  const lh=(istAbsage?vorlagen.absage?.lineHeight:vorlagen.info_mail?.lineHeight)||1.7;

  return(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.6)",zIndex:9999,display:"flex",alignItems:"center",justifyContent:"center",padding:16}} onClick={onClose}>
      <div style={{background:"#fff",borderRadius:14,padding:24,maxWidth:600,width:"100%",maxHeight:"92vh",overflowY:"auto",boxShadow:"0 8px 40px rgba(0,0,0,0.3)"}} onClick={e=>e.stopPropagation()}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
          <div style={{fontFamily:"Georgia,serif",fontSize:16,color:AKZENT}}>{istAbsage?"❌ Absage senden":"📧 Info-Mail senden"}</div>
          <button onClick={onClose} style={{background:"none",border:"none",fontSize:18,cursor:"pointer",color:"#8A8075"}}>✕</button>
        </div>
        {done?(
          <div style={{textAlign:"center",padding:"24px 0"}}>
            <div style={{fontSize:36,marginBottom:8}}>✅</div>
            <div style={{fontSize:14,marginBottom:16}}>Mails gesendet!</div>
            <button onClick={onClose} style={{padding:"8px 20px",borderRadius:8,border:"1px solid #e0ddd8",background:"transparent",cursor:"pointer",fontFamily:"inherit"}}>Schließen</button>
          </div>
        ):(
          <>
            <div style={{marginBottom:12,fontSize:12,color:AKZENT,fontWeight:600}}>{selected.length} Empfänger ausgewählt</div>

            {/* Einzeln: jeder bekommt seine eigene Mail, Platzhalter werden
                personalisiert. Sammelmail: eine Mail, alle weiteren als
                Blindkopie - keiner sieht die Adressen der anderen. */}
            <div style={{display:"flex",gap:8,marginBottom:12}}>
              {[["einzeln","Einzelmails","Jeder bekommt eine eigene Mail mit persönlicher Anrede"],
                ["sammel","Sammelmail (BCC)","Eine Mail an alle, Adressen bleiben verborgen"]].map(([k,l,tip])=>(
                <button key={k} title={tip} onClick={()=>setModus(k)}
                  style={{flex:1,padding:"9px 12px",borderRadius:9,cursor:"pointer",fontFamily:"inherit",
                          fontSize:13,fontWeight:modus===k?700:400,textAlign:"left",
                          border:`2px solid ${modus===k?AKZENT:"#e0ddd8"}`,
                          background:modus===k?AKZENT+"12":"transparent",
                          color:modus===k?AKZENT:"#8A8075"}}>
                  {l}
                  <div style={{fontSize:10,fontWeight:400,color:"#8A8075",marginTop:2,lineHeight:1.4}}>{tip}</div>
                </button>
              ))}
            </div>

            {modus==="sammel"&&(
              <div style={{marginBottom:12,padding:"9px 12px",background:"#f5f3ef",borderRadius:8,
                           fontSize:11,color:"#4A443C",lineHeight:1.6}}>
                {selected.length>0&&(<>
                  <b>An:</b> {selected[0].email}
                  {selected.length>1&&<> · <b>Blindkopie:</b> {selected.length-1} weitere</>}
                </>)}
                {persoDrin&&(
                  <div style={{color:"#b8860b",marginTop:4}}>
                    Im Text steht {"{{name}}"} oder {"{{vorname}}"}. In einer Sammelmail
                    gibt es keine persönliche Anrede, dort wird „{sammelAnrede}“ eingesetzt.
                  </div>
                )}
              </div>
            )}
            <div style={{marginBottom:12}}>
              <label style={{fontSize:12,color:"#8A8075",fontWeight:600,display:"block",marginBottom:4}}>Betreff</label>
              <input value={betreff} onChange={e=>setBetreff(e.target.value)} style={IS2}/>
            </div>
            <div style={{marginBottom:16}}>
              <label style={{fontSize:12,color:"#8A8075",fontWeight:600,display:"block",marginBottom:4}}>Text</label>
              <textarea value={text} onChange={e=>setText(e.target.value)} rows={10}
                data-ta-key="info_mail_text" style={{...IS2,resize:"vertical",lineHeight:lh,minHeight:200}}/>
            </div>
            <div style={{fontSize:11,color:"#8A8075",marginBottom:12,padding:"6px 10px",background:"#f5f3ef",borderRadius:6}}>
              {"Verfügbare Platzhalter: {{name}} {{vorname}} {{shooting}} (auch {{event}}) {{datum}} {{uhrzeit}} {{location}} {{studio}}"}
              <div style={{marginTop:4}}>{"Fett schreiben: **so** · Link: [Text](https://…)"}</div>
            </div>
            <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",gap:12,marginBottom:12,flexWrap:"wrap"}}>
              <label style={{display:"flex",alignItems:"center",gap:8,cursor:"pointer",fontSize:13,color:"#1a1814"}}>
                <input type="checkbox" checked={kopieAnMich} disabled={!kopieAdresse}
                  onChange={e=>{setKopieAnMich(e.target.checked);localStorage.setItem("sd_mail_kopie",e.target.checked?"1":"0");}}
                  style={{accentColor:AKZENT}}/>
                Kopie an mich{kopieAdresse?` (${kopieAdresse})`:" — keine Absenderadresse hinterlegt"}
              </label>
              <button onClick={()=>setVorschau(v=>!v)}
                style={{padding:"7px 12px",borderRadius:8,border:"1px solid #e0ddd8",background:"transparent",
                        cursor:"pointer",fontFamily:"inherit",fontSize:12,color:"#4A443C"}}>
                {vorschau?"Vorschau ausblenden":"👁 Vorschau"}
              </button>
            </div>

            {vorschau&&(()=>{
              // Zeigt die Mail so, wie sie beim ersten Empfaenger ankommt.
              // Platzhalter sind hier schon ersetzt, dadurch faellt sofort auf,
              // wenn etwas wie {{event}} stehen bleibt.
              const bsp=modus==="sammel"?{name:sammelAnrede}:(selected[0]||{name:"Beispiel"});
              const {betreff:pb,text:pt}=buildText(bsp);
              const offen=/{{\s*[a-zA-Z_]+\s*}}/g;
              const rest=[...new Set(((pb+"\n"+pt).match(offen)||[]))];
              return(
                <div style={{marginBottom:12,border:"1px solid #e0ddd8",borderRadius:10,overflow:"hidden"}}>
                  <div style={{padding:"8px 12px",background:"#f5f3ef",fontSize:12,color:"#4A443C"}}>
                    <div><b>An:</b> {selected[0]?.email||"—"}</div>
                    {modus==="sammel"&&selected.length>1&&(
                      <div style={{marginTop:2}}>
                        <b>Blindkopie ({selected.length-1}):</b>
                        <div style={{marginTop:3,maxHeight:110,overflowY:"auto",lineHeight:1.6,wordBreak:"break-all"}}>
                          {selected.slice(1).map(x=>(<div key={x.email}>{x.email}</div>))}
                        </div>
                      </div>
                    )}
                    {modus==="einzeln"&&selected.length>1&&(
                      <div style={{marginTop:2}}>
                        <b>Weitere Einzelmails ({selected.length-1}):</b>
                        <div style={{marginTop:3,maxHeight:110,overflowY:"auto",lineHeight:1.6,wordBreak:"break-all"}}>
                          {selected.slice(1).map(x=>(<div key={x.email}>{x.email}</div>))}
                        </div>
                      </div>
                    )}
                    <div style={{marginTop:4}}><b>Betreff:</b> {pb}</div>
                  </div>
                  {rest.length>0&&(
                    <div style={{padding:"7px 12px",background:"#fdeceb",color:"#C0563E",fontSize:12}}>
                      Nicht ersetzt: {rest.join(" ")}
                    </div>
                  )}
                  <iframe title="Mailvorschau" style={{width:"100%",height:320,border:"none",background:"#fff"}}
                    srcDoc={buildScattoDeskMailHtml(pt,_getSig().logo,_getSig().text)}/>
                </div>
              );
            })()}

            <button style={{width:"100%",padding:14,borderRadius:10,border:"none",background:AKZENT,color:"#fff",fontSize:15,fontWeight:700,cursor:"pointer",fontFamily:"inherit"}}
              onClick={send} disabled={sending||selected.length===0}>
              {sending?`⏳ Wird gesendet…`
                :modus==="sammel"
                  ?`${istAbsage?"❌":"📧"} Eine Sammelmail an ${selected.length} Empfänger senden`
                  :`${istAbsage?"❌":"📧"} ${selected.length} Einzelmail${selected.length!==1?"s":""} senden`}
            </button>
          </>
        )}
      </div>
    </div>
  );
}

function BezahlungMailModal({rows, config, T, eventName, eventDate, onClose, onSent}){
  const eventDateFmt=eventDate?(()=>{try{const d=new Date(eventDate);return isNaN(d)?eventDate:d.toLocaleDateString("de-DE",{day:"2-digit",month:"2-digit",year:"numeric"});}catch{return eventDate;}})():"";
  const selected=rows.filter(r=>r._selected&&r.email&&!r.blocked);
  const bankd=(()=>{try{return JSON.parse(localStorage.getItem("sd_buchung_config")||"null")?.bankdaten||{};}catch{return {};}})();
  const paypalLink=config?.zahlung?.paypal?.link||bankd.paypal||"";
  const iban=(config?.zahlung?.ueberweisung?.iban||bankd.iban||"").replace(/\s/g,"");
  const bic=config?.zahlung?.ueberweisung?.bic||bankd.bic||"";
  const inhaber=config?.zahlung?.ueberweisung?.inhaber||bankd.kontoinhaber||config?.studioName||"";
  const stPreis=(()=>{try{const cfg=JSON.parse(localStorage.getItem("sd_buchung_config")||"null");const st=(cfg?.shootingTypes||[]).find(s=>s.name===eventName||s.eventId);return st?.preis||0;}catch{return 0;}})();
  const [betrag,setBetrag]=useState(String(stPreis||""));
  const [sending,setSending]=useState(false);
  const [done,setDone]=useState(false);
  const [kopie,setKopie]=useState(false);
  const betragNum=parseFloat(betrag)||0;

  const vorlagen=(()=>{try{return JSON.parse(localStorage.getItem("sd_email_vorlagen")||"{}");}catch{return {};}})();
  const smtp=(()=>{try{const s=JSON.parse(localStorage.getItem("sd_smtp_info")||localStorage.getItem("sd_smtp_buchung")||localStorage.getItem("sd_smtp_settings")||"{}");return {...s,from_email:"info@m-h-photo.de"};}catch{return {};}})();
  const kopieEmail="info@m-h-photo.de";
  const studio=config?.studioName||smtp.from||"";

  function buildText(r){
    const name=r.name||((r.vorname||"")+" "+(r.nachname||"")).trim()||"Kunde";
    const vn=r.vorname||vornameAus(name);
    const vz=`${name} – ${eventName||"Shooting"} ${eventDateFmt||""}`.trim();
    const tmpl=vorlagen.bezahlung_anfordern||{
      betreff:"Zahlungsanforderung – "+eventName,
      text:"Hallo {{name}},\n\nfür dein Shooting am {{datum}} um {{uhrzeit}} Uhr ist noch ein offener Betrag von {{betrag}} € offen.\n\nDu kannst bequem bezahlen:\n\n💳 PayPal:\n{{paypal_link}}\n\n🏦 Überweisung:\nEmpfänger: {{kontoinhaber}}\nIBAN: {{iban}}\nBIC: {{bic}}\nBetrag: {{betrag}} €\nVerwendungszweck: {{verwendungszweck}}\n\nVielen Dank!\n\nHerzliche Grüße\n{{studio}}"
    };
    const _evObjBez=(()=>{try{const evts=JSON.parse(localStorage.getItem("sd_events")||"[]");return evts.find(e=>e.name===eventName)||null;}catch{return null;}})();
    const _evLoc=[_evObjBez?.adresse?.strasse,_evObjBez?.adresse?.plz,_evObjBez?.adresse?.ort].filter(Boolean).join(", ")||_evObjBez?.location||"";
    const rep=(s)=>s
      .replace(/{{name}}/g,name).replace(/{{vorname}}/g,vn)
      .replace(/{{datum}}/g,r.uhrzeit?eventDateFmt||"":eventDateFmt||"")
      .replace(/{{uhrzeit}}/g,r.uhrzeit||"")
      .replace(/{{(shooting|event|veranstaltung)}}/g,eventName||"")
      .replace(/{{betrag}}/g,betragNum.toFixed(2))
      .replace(/{{paypal_link}}/g,paypalLink&&betragNum>0?paypalLink.replace(/\s+/g,"").replace(/.*paypal\.me\/([^\/]+).*/,"https://www.paypal.com/paypalme/$1/")+betragNum.toFixed(2):"(kein PayPal konfiguriert)")
      .replace(/{{location}}/g,_evLoc)
              .replace(/{{kontoinhaber}}/g,inhaber).replace(/{{iban}}/g,iban).replace(/{{bic}}/g,bic)
      .replace(/{{verwendungszweck}}/g,vz).replace(/{{studio}}/g,studio);
    return {betreff:rep(tmpl.betreff||"Zahlungsanforderung"),text:rep(tmpl.text||"")};
  }

  // EPC QR für ersten Empfänger als Vorschau
  const epcData=iban&&betragNum>0?(()=>{
    const r0=selected[0]||{name:"Kunde"};
    const vz=`${r0.name||"Kunde"} – ${eventName||""} ${eventDateFmt||""}`.trim();
    return ["BCD","002","1","SCT",bic,inhaber,iban,`EUR${betragNum.toFixed(2)}`,"","",vz,""].join("\n");
  })():null;
  const qrUrl=epcData?`https://api.qrserver.com/v1/create-qr-code/?size=140x140&data=${encodeURIComponent(epcData)}`:null;

  // Vorschau für ersten Empfänger
  const prev=selected[0]?buildText(selected[0]):null;

  async function send(){
    if(betragNum<=0){alert("Bitte Betrag eingeben.");return;}
    setSending(true);
    const serverUrl=(localStorage.getItem("sd_server_url")||"").trim().replace(/\/+$/,"");
    let ok=0,fail=0;
    for(const r of selected){
      const {betreff,text}=buildText(r);
      try{
        await fetch(`${serverUrl}/api/newsletter`,{
          method:"POST",headers:{"Content-Type":"application/json"},
          body:JSON.stringify({smtp,recipients:[{name:r.name||r.vorname||"",email:r.email}],subject:betreff,text,
            html:buildScattoDeskMailHtml(text,_getSig().logo,_getSig().text),logo:_getSig().logo})
        });
        ok++;
      }catch{fail++;}
    }
    if(kopie){
      const studioName=config?.studioName||smtp.from||"Studio";
      const {betreff,text}=buildText(selected[0]||{name:"Kopie",email:kopieEmail,uhrzeit:"",vorname:""});
      try{
        await fetch(`${serverUrl}/api/newsletter`,{
          method:"POST",headers:{"Content-Type":"application/json"},
          body:JSON.stringify({smtp,recipients:[{name:studioName,email:kopieEmail}],subject:"[Kopie] "+betreff,text,
            html:buildScattoDeskMailHtml(text,_getSig().logo,_getSig().text),logo:_getSig().logo})
        });
      }catch{}
    }
    setSending(false);
    onSent(selected.map(r=>r.id),betragNum);
    setDone(true);
    if(fail>0)alert(`⚠️ ${fail} Mails fehlgeschlagen.`);
  }

  const IS2={background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:"8px 12px",color:T.text,fontSize:13,fontFamily:"inherit",outline:"none",width:"100%"};

  return(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.6)",zIndex:9999,display:"flex",alignItems:"center",justifyContent:"center",padding:16}} onClick={onClose}>
      <div style={{background:T.surface,borderRadius:14,padding:24,maxWidth:750,width:"100%",maxHeight:"96vh",overflowY:"auto",boxShadow:"0 8px 40px rgba(0,0,0,0.35)"}} onClick={e=>e.stopPropagation()}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
          <div style={{fontFamily:"Georgia,serif",fontSize:16,color:"#d97706"}}>💳 Bezahlung anfordern</div>
          <button onClick={onClose} style={{background:"none",border:"none",fontSize:18,cursor:"pointer",color:T.muted}}>✕</button>
        </div>
        {done?(
          <div style={{textAlign:"center",padding:"24px 0"}}>
            <div style={{fontSize:36,marginBottom:8}}>✅</div>
            <div style={{fontSize:14,color:T.text,marginBottom:4}}>{selected.length} Mail{selected.length!==1?"s":""} gesendet!</div>
            <button style={btn(T,"ghost")} onClick={onClose}>Schließen</button>
          </div>
        ):(
          <>
            <div style={{marginBottom:14}}>
              <div style={{fontSize:12,color:T.muted,fontWeight:600,marginBottom:6}}>Empfänger ({selected.length})</div>
              <div style={{display:"flex",flexWrap:"wrap",gap:6}}>
                {selected.map(r=>(
                  <span key={r.id} style={{fontSize:11,background:T.bg,border:`1px solid ${T.border}`,borderRadius:20,padding:"3px 10px",color:T.text}}>
                    {r.name||r.vorname||r.email} <span style={{color:T.muted}}>({r.email})</span>
                  </span>
                ))}
                {selected.length===0&&<span style={{fontSize:12,color:"#e53"}}>Keine Empfänger mit E-Mail ausgewählt.</span>}
              </div>
            </div>
            <div style={{marginBottom:16}}>
              <label style={{fontSize:12,color:T.muted,fontWeight:600,display:"block",marginBottom:5}}>Betrag (€)</label>
              <input value={betrag} onChange={e=>setBetrag(e.target.value)} type="number" min="0" step="0.01" placeholder="0.00" style={IS2}/>
            </div>
            {betragNum>0&&(iban||paypalLink)&&(
              <div style={{marginBottom:16,display:"flex",gap:12}}>
                {iban&&qrUrl&&(
                  <div style={{flex:1,padding:14,background:T.bg,borderRadius:10,display:"flex",flexDirection:"column",alignItems:"center",gap:8}}>
                    <img src={qrUrl} alt="GiroCode" style={{width:120,height:120,borderRadius:6}}/>
                    <div style={{textAlign:"center",width:"100%"}}>
                      <div style={{fontSize:12,fontWeight:700,color:T.text,marginBottom:4}}>🏦 Überweisung per QR</div>
                      <div style={{fontSize:11,color:T.muted,lineHeight:1.6,textAlign:"center"}}>
                        <div>{inhaber}</div>
                        <div style={{fontFamily:"monospace",fontSize:10}}>{iban}</div>
                        <div style={{fontWeight:700,color:"#d97706",marginTop:2}}>{betragNum.toFixed(2)} €</div>
                        <div style={{fontSize:10,color:T.muted,marginTop:4}}>Banking-App scannen →<br/>alle Felder vorausgefüllt</div>
                      </div>
                    </div>
                  </div>
                )}
                {paypalLink&&betragNum>0&&(()=>{
                  const ppBetrag=betragNum%1===0?String(Math.round(betragNum)):betragNum.toFixed(2);
                  const ppUrl=paypalLink.replace(/\s+/g,"").replace(/\/+$/,"")+"/"+ppBetrag;
                  const ppQr=`https://api.qrserver.com/v1/create-qr-code/?size=120x120&data=${encodeURIComponent(ppUrl)}`;
                  return(
                    <div style={{flex:1,padding:14,background:T.bg,borderRadius:10,display:"flex",flexDirection:"column",alignItems:"center",gap:8}}>
                      <img src={ppQr} alt="PayPal QR" style={{width:120,height:120,borderRadius:6}}/>
                      <div style={{textAlign:"center",width:"100%"}}>
                        <div style={{fontSize:12,fontWeight:700,color:T.text,marginBottom:4}}>💳 PayPal per QR</div>
                        <div style={{fontSize:11,color:T.muted,lineHeight:1.6,textAlign:"center"}}>
                          <div style={{fontWeight:700,color:"#d97706"}}>{betragNum.toFixed(2)} €</div>
                          <div style={{fontSize:10,color:T.muted,marginTop:4}}>PayPal-App oder Browser<br/>scannen → direkt bezahlen</div>
                        </div>
                      </div>
                    </div>
                  );
                })()}
              </div>
            )}
            {prev&&betragNum>0&&(
              <div style={{marginBottom:16}}>
                <div style={{fontSize:12,color:T.muted,fontWeight:600,marginBottom:6}}>Vorschau (erster Empfänger)</div>
                <div style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:12,fontSize:11,color:T.text,lineHeight:1.7,whiteSpace:"pre-wrap",minHeight:300,overflowY:"visible"}}>
                  <div style={{fontWeight:700,marginBottom:6,color:T.accent}}>{prev.betreff}</div>
                  {prev.text}
                </div>
              </div>
            )}
            {!iban&&<div style={{fontSize:11,color:"#d97706",marginBottom:10,padding:"7px 12px",background:"#fff7e6",border:"1px solid #fcd34d",borderRadius:6}}>⚠️ Keine IBAN → Einstellungen → Bankverbindung</div>}
            <label style={{display:"flex",alignItems:"center",gap:8,fontSize:12,color:T.muted,marginBottom:10,cursor:"pointer"}}>
              <input type="checkbox" checked={kopie} onChange={e=>setKopie(e.target.checked)} style={{accentColor:"#d97706",width:14,height:14}}/>
              Kopie an mich senden ({kopieEmail})
            </label>
            <button style={{...btn(T,"primary"),width:"100%",justifyContent:"center",background:"#d97706",borderColor:"#d97706"}}
              onClick={send} disabled={sending||selected.length===0||betragNum<=0}>
              {sending?`⏳ Wird gesendet…`:`📧 ${selected.length} Mail${selected.length!==1?"s":""} senden`}
            </button>
          </>
        )}
      </div>
    </div>
  );
}

// ── ShootingplanPage ─────────────────────────────────────────────────────────────────────
function ZeitslotModal({onApply,rowCount,T,onClose}){
  const [start,setStart]=useState("09:00");
  const [dauer,setDauer]=useState(15);
  const preview=[];
  for(let i=0;i<Math.min(rowCount,5);i++){
    const [h,m]=start.split(":").map(Number);
    const total=h*60+m+i*dauer;
    preview.push(`${String(Math.floor(total/60)).padStart(2,"0")}:${String(total%60).padStart(2,"0")}`);
  }
  return(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.75)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:100,padding:20}}>
      <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:16,padding:28,width:360}}>
        <div style={{fontFamily:"Georgia,serif",fontSize:18,color:T.accent,marginBottom:20}}>Zeitslots vergeben</div>
        <div style={{display:"flex",flexDirection:"column",gap:14}}>
          <div>
            <label style={{fontSize:12,color:T.muted,fontWeight:600,display:"block",marginBottom:5}}>Startzeit</label>
            <input type="time" value={start} onChange={e=>setStart(e.target.value)} style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:"9px 12px",color:T.text,fontSize:14,fontFamily:"inherit",outline:"none",boxSizing:"border-box",width:"100%"}}/>
          </div>
          <div>
            <label style={{fontSize:12,color:T.muted,fontWeight:600,display:"block",marginBottom:5}}>Slotdauer (Minuten)</label>
            <input type="number" value={dauer} onChange={e=>setDauer(Number(e.target.value))} min={5} max={120} step={5} style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:"9px 12px",color:T.text,fontSize:14,fontFamily:"inherit",outline:"none",boxSizing:"border-box",width:"100%"}}/>
          </div>
          {preview.length>0&&(
            <div style={{background:T.bg,borderRadius:8,padding:"10px 14px",fontSize:12,color:T.muted}}>
              <div style={{marginBottom:4,fontWeight:600,color:T.text}}>Vorschau (erste {preview.length} Slots):</div>
              {preview.map((t,i)=><div key={i}>Slot {i+1}: {t}</div>)}
              {rowCount>5&&<div style={{color:T.muted}}>... und {rowCount-5} weitere</div>}
            </div>
          )}
        </div>
        <div style={{display:"flex",justifyContent:"flex-end",gap:10,marginTop:20}}>
          <button style={btn(T,"ghost")} onClick={onClose}>Abbrechen</button>
          <button style={btn(T,"primary")} onClick={()=>{onApply(start,dauer);onClose();}}>Übernehmen</button>
        </div>
      </div>
    </div>
  );
}

// ── API Einstellungen Modal ────────────────────────────────────────────────────
function ApiModal({settings,onSave,onClose,T}){
  const [s,setS]=useState({...settings});
  const up=(k,v)=>setS(x=>({...x,[k]:v}));
  const IS={background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:"9px 12px",color:T.text,fontSize:13,fontFamily:"inherit",outline:"none",boxSizing:"border-box",width:"100%"};
  return(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.75)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:100,padding:20}}>
      <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:16,padding:28,width:"100%",maxWidth:480}}>
        <div style={{fontFamily:"Georgia,serif",fontSize:18,color:T.accent,marginBottom:20}}>API Einstellungen</div>
        <div style={{display:"flex",flexDirection:"column",gap:14}}>
          {[
            ["calendly_token","Calendly Personal Access Token","eyJ..."],
            ["jotform_key","Jotform API Key",""],
            ["sevdesk_token","sevDesk API Token (Buchhaltung Pro)",""],
          ].map(([k,label,ph])=>(
            <div key={k}>
              <label style={{fontSize:12,color:T.muted,fontWeight:600,display:"block",marginBottom:5}}>{label}</label>
              <input value={s[k]||""} onChange={e=>up(k,e.target.value)} placeholder={ph} type="password" style={IS}/>
            </div>
          ))}
        </div>
        <div style={{fontSize:11,color:T.muted,marginTop:12,padding:"8px 10px",background:T.bg,borderRadius:6,lineHeight:1.6}}>
          💡 Calendly: Einstellungen → Integrationen → API & Webhooks → Personal Access Token<br/>
          💡 Jotform: Konto → API → API-Key generieren<br/>
          💡 sevDesk: Mein Konto → API → Token (nur Buchhaltung Pro)
        </div>
        <div style={{display:"flex",justifyContent:"flex-end",gap:10,marginTop:20}}>
          <button style={btn(T,"ghost")} onClick={onClose}>Abbrechen</button>
          <button style={btn(T,"primary")} onClick={()=>{onSave(s);onClose();}}>Speichern</button>
        </div>
      </div>
    </div>
  );
}

// ── Calendly Import Modal ─────────────────────────────────────────────────────
function CalendlyModal({token,onImport,onClose,T}){
  const [step,setStep]=useState("loading");
  const [events,setEvents]=useState([]);
  const [error,setError]=useState("");
  const [loading,setLoading]=useState(false);
  const [selected,setSelected]=useState(null);

  useEffect(()=>{
    if(!token){setError("Kein Calendly Token hinterlegt. Bitte zuerst unter API Einstellungen eintragen.");setStep("error");return;}
    setLoading(true);
    fetch("https://api.calendly.com/users/me",{headers:{"Authorization":`Bearer ${token}`}})
      .then(r=>r.json())
      .then(data=>{
        const userUri=data?.resource?.uri;
        if(!userUri)throw new Error("User URI nicht gefunden");
        return fetch(`https://api.calendly.com/event_types?user=${encodeURIComponent(userUri)}&count=100`,{headers:{"Authorization":`Bearer ${token}`}})
          .then(r=>r.json())
          .then(d=>({userUri,events:d?.collection||[]}));
      })
      .then(({userUri,events})=>{setEvents(events.map(e=>({...e,_userUri:userUri})));setStep("select");setLoading(false);})
      .catch(e=>{setError("Fehler: "+e.message+"\n\nHinweis: Calendly API erfordert einen gültigen Personal Access Token. Prüfe ob der Token noch aktiv ist.");setStep("error");setLoading(false);});
  },[]);

  function loadInvitees(){
    if(!selected)return;
    setLoading(true);setStep("loading");
    const userUri=selected._userUri;
    fetch(`https://api.calendly.com/scheduled_events?user=${encodeURIComponent(userUri)}&count=100&min_start_time=${new Date().toISOString().slice(0,10)}T00:00:00Z`,{headers:{"Authorization":`Bearer ${token}`}})
      .then(r=>r.json())
      .then(async data=>{
        const matching=(data?.collection||[]).filter(e=>e.event_type===selected.uri);
        const rows=[];
        for(const ev of matching){
          const evId=ev.uri.split("/").pop();
          const r2=await fetch(`https://api.calendly.com/scheduled_events/${evId}/invitees?count=100`,{headers:{"Authorization":`Bearer ${token}`}});
          const d2=await r2.json();
          for(const inv of d2?.collection||[]){
            const row=emptyRow();
            row.name=inv.name||"";
            row.email=inv.email||"";
            const startTime=ev.start_time;
            if(startTime){
              const d=new Date(startTime);
              row.uhrzeit=`${String(d.getHours()).padStart(2,"0")}:${String(d.getMinutes()).padStart(2,"0")}`;
            }
            row.cal="●";
            // Zusatzfragen aus Jotform-ähnlichen answers
            const answers=inv.questions_and_answers||[];
            answers.forEach(qa=>{
              const q=(qa.question||"").toLowerCase();
              const a=qa.answer||"";
              if(q.includes("hund")||q.includes("tier")||q.includes("name")&&q.includes("hund"))row.hund=a;
              if(q.includes("rasse"))row.rasse=a;
              if(q.includes("alter"))row.alter=a;
              if(q.includes("telefon")||q.includes("phone"))row.telefon=a;
            });
            rows.push(row);
          }
        }
        setLoading(false);
        if(rows.length===0){setError(`Keine Buchungen für "${selected.name}" gefunden.`);setStep("error");}
        else{onImport(rows,selected.name);}
      })
      .catch(e=>{setError("Fehler beim Laden der Buchungen: "+e.message);setStep("error");setLoading(false);});
  }

  return(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.78)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:100,padding:20}}>
      <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:16,padding:28,width:"100%",maxWidth:520,maxHeight:"80vh",display:"flex",flexDirection:"column"}}>
        <div style={{fontFamily:"Georgia,serif",fontSize:18,color:T.accent,marginBottom:16}}>Calendly Import</div>
        {(step==="loading"||loading)&&<div style={{textAlign:"center",padding:40,color:T.muted}}>⏳ Lade Calendly Daten...</div>}
        {step==="error"&&!loading&&(
          <div>
            <div style={{background:T.danger+"22",border:`1px solid ${T.danger}44`,borderRadius:8,padding:14,fontSize:13,color:T.danger,whiteSpace:"pre-wrap",lineHeight:1.6}}>{error}</div>
            <div style={{display:"flex",justifyContent:"flex-end",marginTop:16}}><button style={btn(T,"ghost")} onClick={onClose}>Schließen</button></div>
          </div>
        )}
        {step==="select"&&!loading&&(
          <div style={{display:"flex",flexDirection:"column",flex:1,minHeight:0}}>
            <p style={{fontSize:13,color:T.muted,marginBottom:12}}>Wähle einen Eventtyp:</p>
            <div style={{flex:1,overflowY:"auto",border:`1px solid ${T.border}`,borderRadius:8,marginBottom:16}}>
              {events.map(e=>(
                <div key={e.uri} onClick={()=>setSelected(e)}
                  style={{padding:"12px 16px",cursor:"pointer",borderBottom:`1px solid ${T.border}22`,background:selected?.uri===e.uri?T.accentDim:"transparent",transition:"background 0.1s"}}
                  onMouseEnter={x=>x.currentTarget.style.background=selected?.uri===e.uri?T.accentDim:T.tileHover}
                  onMouseLeave={x=>x.currentTarget.style.background=selected?.uri===e.uri?T.accentDim:"transparent"}>
                  <div style={{fontSize:14,fontWeight:600,color:selected?.uri===e.uri?T.accent:T.text}}>{e.name}</div>
                  <div style={{fontSize:12,color:T.muted}}>{e.scheduling_url||""}</div>
                </div>
              ))}
            </div>
            <div style={{display:"flex",justifyContent:"flex-end",gap:10}}>
              <button style={btn(T,"ghost")} onClick={onClose}>Abbrechen</button>
              <button style={btn(T,"primary")} onClick={loadInvitees} disabled={!selected}>Buchungen laden →</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

// ── Jotform Import Modal ───────────────────────────────────────────────────────
function JotformModal({apiKey,fotoart,onImport,onClose,T}){
  const [step,setStep]=useState("loading");
  const [forms,setForms]=useState([]);
  const [selected,setSelected]=useState(null);
  const [error,setError]=useState("");
  const [loading,setLoading]=useState(false);
  const [preview,setPreview]=useState([]);

  useEffect(()=>{
    if(!apiKey){setError("Kein Jotform API-Key hinterlegt.");setStep("error");return;}
    fetch(`https://api.jotform.com/user/forms?apiKey=${apiKey}&limit=50`)
      .then(r=>r.json())
      .then(d=>{
        if(d.responseCode!==200)throw new Error("Ungültiger API-Key oder Fehler: "+d.message);
        setForms(d.content||[]);setStep("select");
      })
      .catch(e=>{setError("Fehler: "+e.message);setStep("error");});
  },[]);

  function loadSubmissions(){
    if(!selected)return;
    setLoading(true);
    fetch(`https://api.jotform.com/form/${selected.id}/submissions?apiKey=${apiKey}&limit=100`)
      .then(r=>r.json())
      .then(d=>{
        if(d.responseCode!==200)throw new Error(d.message);
        const subs=d.content||[];
        const rows=subs.filter(s=>s.status==="ACTIVE").map(s=>{
          const row=emptyRow();
          row.jot="●";
          const ans=s.answers||{};
          Object.values(ans).forEach(a=>{
            const q=(a.text||"").toLowerCase();
            const val=typeof a.answer==="object"?Object.values(a.answer).join(" "):(a.answer||"");
            if(q.includes("vorname")||q.includes("first"))row.name=(row.name?row.name+" ":"")+val;
            else if(q.includes("nachname")||q.includes("last")&&!q.includes("hund"))row.name=(row.name?row.name+" ":"")+val;
            else if(q.includes("name")&&!q.includes("hund"))row.name=val||row.name;
            if(q.includes("hund")&&q.includes("name"))row.hund=val;
            if(q.includes("rasse"))row.rasse=val;
            if(q.includes("alter")&&!q.includes("veranstaltung"))row.alter=val;
            if(q.includes("geschlecht"))row.geschlecht=val;
            if(q.includes("telefon")||q.includes("phone"))row.telefon=val;
            if(q.includes("e-mail")||q.includes("email"))row.email=val;
            if(q.includes("straße")||q.includes("adresse")||q.includes("street"))row.strasse=val;
            if(q.includes("plz")||q.includes("postleitzahl"))row.plz=val;
            if(q.includes("ort")||q.includes("city")&&!q.includes("veranstaltungsort"))row.ort=val;
          });
          return row;
        });
        setPreview(rows.slice(0,3));
        setLoading(false);
        if(rows.length===0){setError("Keine aktiven Einreichungen gefunden.");setStep("error");}
        else{onImport(rows,selected.title);}
      })
      .catch(e=>{setError("Fehler: "+e.message);setStep("error");setLoading(false);});
  }

  return(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.78)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:100,padding:20}}>
      <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:16,padding:28,width:"100%",maxWidth:520,maxHeight:"80vh",display:"flex",flexDirection:"column"}}>
        <div style={{fontFamily:"Georgia,serif",fontSize:18,color:T.accent,marginBottom:16}}>Jotform Import</div>
        {(step==="loading"||loading)&&<div style={{textAlign:"center",padding:40,color:T.muted}}>⏳ Lade Jotform Daten...</div>}
        {step==="error"&&!loading&&(
          <div>
            <div style={{background:T.danger+"22",border:`1px solid ${T.danger}44`,borderRadius:8,padding:14,fontSize:13,color:T.danger}}>{error}</div>
            <div style={{display:"flex",justifyContent:"flex-end",marginTop:16}}><button style={btn(T,"ghost")} onClick={onClose}>Schließen</button></div>
          </div>
        )}
        {step==="select"&&!loading&&(
          <div style={{display:"flex",flexDirection:"column",flex:1,minHeight:0}}>
            <p style={{fontSize:13,color:T.muted,marginBottom:12}}>Formular wählen (Fotoart: {fotoart}):</p>
            <div style={{flex:1,overflowY:"auto",border:`1px solid ${T.border}`,borderRadius:8,marginBottom:16}}>
              {forms.map(f=>(
                <div key={f.id} onClick={()=>setSelected(f)}
                  style={{padding:"12px 16px",cursor:"pointer",borderBottom:`1px solid ${T.border}22`,background:selected?.id===f.id?T.accentDim:"transparent"}}
                  onMouseEnter={x=>x.currentTarget.style.background=selected?.id===f.id?T.accentDim:T.tileHover}
                  onMouseLeave={x=>x.currentTarget.style.background=selected?.id===f.id?T.accentDim:"transparent"}>
                  <div style={{fontSize:13,fontWeight:600,color:selected?.id===f.id?T.accent:T.text}}>{f.title}</div>
                  <div style={{fontSize:11,color:T.muted}}>{f.count} Einreichungen · ID: {f.id}</div>
                </div>
              ))}
            </div>
            <div style={{display:"flex",justifyContent:"flex-end",gap:10}}>
              <button style={btn(T,"ghost")} onClick={onClose}>Abbrechen</button>
              <button style={btn(T,"primary")} onClick={loadSubmissions} disabled={!selected}>Daten laden →</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

// ── sevDesk Übertragung ───────────────────────────────────────────────────────
async function sevDeskUebertragen(rows, token, onProgress){
  const base="https://my.sevdesk.de/api/v1";
  const headers={"Content-Type":"application/json","Accept":"application/json"};
  const params=`token=${token}`;
  const results={ok:[],skip:[],err:[]};

  for(const row of rows){
    const name=row.name?.trim();
    if(!name){results.err.push("Leere Zeile übersprungen");continue;}
    // Getrennte Felder bevorzugen (in sevDesk: surename=Vorname, familyname=Nachname),
    // aber nur wenn sie zum sichtbaren Namen passen (sonst wurde der Name von Hand geändert → aufteilen).
    let surename, familyname;
    const _vn=(row.vorname||"").trim(), _nn=(row.nachname||"").trim();
    const _full=(_vn+" "+_nn).trim();
    if((_vn||_nn)&&_full===name){
      surename=_vn; familyname=_nn||_vn;
      if(!_nn)surename="";   // nur Vorname vorhanden → als Nachname behandeln (sevDesk braucht familyname)
    }else{
      const parts=name.split(" ");
      surename=parts.length>1?parts.slice(0,-1).join(" "):name;
      familyname=parts.length>1?parts[parts.length-1]:name;
    }
    try{
      // Dublettencheck
      const check=await fetch(`${base}/Contact?${params}&familyname=${encodeURIComponent(familyname)}&surename=${encodeURIComponent(surename)}&depth=0`,{headers});
      const checkData=await check.json();
      if((checkData.objects||[]).length>0){results.skip.push(name);continue;}
      // Anlegen
      const resp=await fetch(`${base}/Contact?${params}`,{method:"POST",headers,body:JSON.stringify({surename,familyname,category:{id:3,objectName:"Category"}})});
      const respData=await resp.json();
      const contactId=respData.objects?.id;
      if(!contactId){results.err.push(name);continue;}
      // Adresse
      if(row.strasse||row.plz||row.ort){
        await fetch(`${base}/ContactAddress?${params}`,{method:"POST",headers,body:JSON.stringify({contact:{id:contactId,objectName:"Contact"},street:row.strasse,zip:row.plz,city:row.ort,country:{id:1,objectName:"StaticCountry"},category:null})});
      }
      if(row.telefon)await fetch(`${base}/CommunicationWay?${params}`,{method:"POST",headers,body:JSON.stringify({contact:{id:contactId,objectName:"Contact"},type:"PHONE",value:row.telefon,key:{id:2,objectName:"CommunicationWayKey"}})});
      if(row.email)await fetch(`${base}/CommunicationWay?${params}`,{method:"POST",headers,body:JSON.stringify({contact:{id:contactId,objectName:"Contact"},type:"EMAIL",value:row.email,key:{id:2,objectName:"CommunicationWayKey"}})});
      results.ok.push(name);
      // Gleichzeitig als ScattoDesk-Kunde speichern
      try{
        const sd_customers=JSON.parse(localStorage.getItem("sd_customers")||"[]");
        const emailNorm=(row.email||"").trim().toLowerCase();
        const exists=sd_customers.some(c=>(c.email||"").toLowerCase()===emailNorm&&emailNorm);
        if(!exists){
          const tiername=row.rasse||""; // im Shootingplan: rasse=Tiername
          const tierrasse=row.hund||"";  // im Shootingplan: hund=Rasse
          const neuerKunde={
            id:uid(),name,email:row.email||"",phone:row.telefon||"",
            strasse:row.strasse||"",plz:row.plz||"",ort:row.ort||"",
            sevdeskId:contactId,anrede:"",notes:"",kundennr:"",
            tiere:tiername||tierrasse?[{name:tiername,rasse:tierrasse,alter:row.alter||"",geschlecht:row.geschlecht||""}]:[],
          };
          localStorage.setItem("sd_customers",JSON.stringify([...sd_customers,neuerKunde]));
        }
      }catch(e){console.warn("ScattoDesk-Kunde konnte nicht gespeichert werden:",e);}
    }catch(e){results.err.push(`${name}: ${e.message}`);}
    onProgress&&onProgress(results);
  }
  return results;
}

// ── Haupt Shootingplan Seite ──────────────────────────────────────────────────
// Leere Tabellenzeile für den Shootingplan (auch von Calendly-/Jotform-Import genutzt)
function emptyRow(){
  return {id:uid(),nr:"",uhrzeit:"",name:"",vorname:"",nachname:"",hund:"",rasse:"",geschlecht:"",alter:"",telefon:"",email:"",strasse:"",plz:"",ort:"",notiz:"",cal:"",jot:"",zahlVorab:false,zahlOffen:false};
}
// Buchungsdaten in Plan-/Abrechnungsfelder übersetzen.
// Feld-IDs sind frei vergeben (z.B. sf2c, sf3c) — daher Zuordnung über type/labelDe der Feld-Definition, NICHT über die ID.
function mapBookingFelder(booking, felder){
  const fd=(booking&&booking.formData)||{};
  const t0=(booking&&booking.tiere&&booking.tiere[0])||{};
  const out={name:fd.sys_name||"",vorname:fd.sys_vorname||"",nachname:fd.sys_nachname||"",
    telefon:"",email:"",strasse:"",plz:"",ort:"",hund:"",rasse:"",geschlecht:"",alter:"",alterMonate:"",anrede:""};
  const valOf=(f)=>{
    if(fd[f.id]!=null&&fd[f.id]!=="")return fd[f.id];
    if(t0[f.id]!=null&&t0[f.id]!=="")return t0[f.id];
    if(fd["tier_0_"+f.id]!=null&&fd["tier_0_"+f.id]!=="")return fd["tier_0_"+f.id];
    return "";
  };
  (Array.isArray(felder)?felder:[]).forEach(f=>{
    const lbl=(f.labelDe||f.label||"").trim().toLowerCase();
    const typ=(f.type||"").toLowerCase();
    const v=valOf(f);
    if(!v)return;
    if(typ==="email"||lbl.includes("mail")){if(!out.email)out.email=v;}
    else if(typ==="tel"||lbl.includes("telefon")||lbl.includes("handy")||lbl.includes("mobil")){if(!out.telefon)out.telefon=v;}
    else if(lbl.startsWith("stra")||lbl==="adresse"){if(!out.strasse)out.strasse=v;}
    else if(lbl.includes("plz")||lbl.includes("postleit")){if(!out.plz)out.plz=v;}
    else if(lbl==="ort"||lbl.includes("stadt")){if(!out.ort)out.ort=v;}
    else if(lbl.includes("rasse")){if(!out.hund)out.hund=v;}        // Rasse → "hund"-Spalte (bestehende Konvention)
    else if(lbl.includes("tiername")){if(!out.rasse)out.rasse=v;}   // Tiername → "rasse"-Spalte
    else if(lbl.includes("geschlecht")){if(!out.geschlecht)out.geschlecht=v;}
    else if(lbl.includes("monat")){if(!out.alterMonate)out.alterMonate=v;}
    else if(lbl.startsWith("alter")){if(!out.alter)out.alter=v;}
    else if(lbl.includes("anrede")){if(!out.anrede)out.anrede=v;}
  });
  return out;
}
function QRModal({eventName,onClose,T,bookingUrl}){
  const defUrl=(()=>{try{return bookingUrl||localStorage.getItem("sd_server_url")||"";}catch{return "";}})();
  const [url,setUrl]=useState(defUrl);
  const u=url.trim();
  const qrSrc=u?`https://api.qrserver.com/v1/create-qr-code/?size=320x320&margin=12&data=${encodeURIComponent(u)}`:"";
  const [copied,setCopied]=useState(false);
  function copyLink(){try{navigator.clipboard.writeText(u);setCopied(true);setTimeout(()=>setCopied(false),2000);}catch(e){}}
  function printQR(){
    if(!u)return;
    const w=window.open("","_blank");if(!w)return;
    w.document.write(`<html><head><title>Anmeldung ${eventName||""}</title></head><body style="font-family:Arial,sans-serif;text-align:center;padding:40px"><h1 style="font-size:26px;margin-bottom:6px">${eventName||"Anmeldung"}</h1><p style="font-size:16px;color:#555;margin-top:0">Code scannen und anmelden</p><img src="${qrSrc}" style="width:340px;height:340px"><p style="font-size:12px;color:#999;margin-top:18px;word-break:break-all">${u}</p></body></html>`);
    w.document.close();setTimeout(()=>{try{w.print();}catch(e){}},500);
  }
  return(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.7)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:200,padding:20}} onClick={onClose}>
      <div onClick={e=>e.stopPropagation()} style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:16,padding:28,width:"100%",maxWidth:600,textAlign:"center"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
          <div style={{fontFamily:"Georgia,serif",fontSize:18,color:T.accent}}>QR-Anmeldung</div>
          <button style={btn(T,"ghost",true)} onClick={onClose}>✕</button>
        </div>
        <div style={{fontSize:12,color:T.muted,marginBottom:8,textAlign:"left"}}>Buchungslink für „{eventName||"diese Veranstaltung"}" — scannen oder per Link teilen.</div>
        <input value={url} onChange={e=>setUrl(e.target.value)} placeholder="https://..."
          style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:"9px 12px",color:T.text,fontSize:12,fontFamily:"inherit",outline:"none",boxSizing:"border-box",width:"100%"}}/>
        {u&&(
          <button style={{...btn(T,copied?"primary":"ghost"),width:"100%",marginTop:8,justifyContent:"center"}} onClick={copyLink}>
            {copied?"✓ Link kopiert!":"📋 Link kopieren & teilen"}
          </button>
        )}
        {u?(<>
          <div style={{marginTop:16,display:"grid",gridTemplateColumns:"1fr 1fr",gap:24}}>
            <div style={{textAlign:"center"}}>
              <div style={{fontSize:10,color:T.muted,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.06em",marginBottom:8}}>QR-Code (mit Name)</div>
              <div style={{background:"#fff",padding:14,borderRadius:10,display:"inline-block"}}>
                <img src={qrSrc} alt="QR-Code" style={{width:160,height:160,display:"block"}}/>
              </div>
            </div>
            <div style={{textAlign:"center"}}>
              <div style={{fontSize:10,color:T.accent,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.06em",marginBottom:8}}>📱 Zugangslink per Handy</div>
              <div style={{background:"#fff",padding:14,borderRadius:10,display:"inline-block",border:`2px solid ${T.accent}`}}>
                <img src={`https://api.qrserver.com/v1/create-qr-code/?size=320x320&margin=10&data=${encodeURIComponent(u.replace(/\/buchen\//,"/link/"))}`} alt="Zugangslink" style={{width:160,height:160,display:"block"}}/>
              </div>
              <div style={{fontSize:9,color:T.muted,marginTop:6,wordBreak:"break-all",maxWidth:180,margin:"6px auto 0"}}>{u}</div>
            </div>
          </div>
        </>):(
          <div style={{marginTop:18,color:T.muted,fontSize:13}}>Bitte oben einen Link eingeben.</div>
        )}
        {u&&<div style={{fontSize:11,color:T.muted,marginTop:10,wordBreak:"break-all"}}>{u}</div>}
        <div style={{display:"flex",gap:8,justifyContent:"center",marginTop:16}}>
          <button style={btn(T,"ghost")} onClick={onClose}>Schließen</button>
          <button style={btn(T,"primary")} onClick={printQR} disabled={!u}>🖨️ Drucken</button>
        </div>
        <div style={{fontSize:10,color:T.muted,marginTop:12}}>Für die Anzeige des Codes wird eine Internetverbindung benötigt.</div>
      </div>
    </div>
  );
}
function AnwesenheitModal({rows,cols=[],events,selectedEventId,eventName,eventDate,fotoart,onClose,T}){
  const ev=events.find(e=>e.id===selectedEventId)||{name:eventName,date:eventDate,fotoart,adresse:{}};
  const saved=(()=>{try{return JSON.parse(localStorage.getItem("sd_anwesenheit_cfg2")||"{}");}catch{return {};}})();

  // Standardbreiten in cm
  const DEF_W={__nr:1,uhrzeit:1.5,name:4,hund:3.5,rasse:3,geschlecht:1.5,alter:1.2,alterMonate:1.2,
    telefon:3,email:4.5,strasse:3.5,plz:1.2,ort:2.5,notiz:3.5,zahlVorab:1.5,zahlOffen:1.5,__vereinb:1.5};
  // Vorauswahl wie bisher
  const DEF_SEL={__nr:true,name:true,hund:true,rasse:true,telefon:true,notiz:true,__vereinb:true};

  const spalten=[
    {key:"__nr",label:"Nr — bleibt leer (vor Ort ausfüllen)",plabel:"Nr",art:"leer"},
    ...cols.map(c=>({key:c.key,label:c.label,plabel:c.label,art:c.check?"haken":"text"})),
    {key:"__vereinb",label:"✓ Vereinb. — leeres Kästchen",plabel:"✓",art:"kasten"},
  ];

  const [sel,setSel]=useState(()=>({...DEF_SEL,...(saved.sel||{})}));
  const [colW,setColW]=useState(()=>({...DEF_W,...(saved.colW||{})}));
  const [extraZeilen,setExtraZeilen]=useState(saved.extraZeilen??5);
  const [zeilenhoehe,setZeilenhoehe]=useState(saved.zeilenhoehe??14);
  const [schriftPt,setSchriftPt]=useState(saved.schriftPt??8);

  function save(patch){
    const cfg={extraZeilen,zeilenhoehe,schriftPt,sel,colW,...patch};
    try{localStorage.setItem("sd_anwesenheit_cfg2",JSON.stringify(cfg));}catch{}
  }

  const IS={background:T.bg,border:`1px solid ${T.border}`,borderRadius:6,padding:"5px 8px",color:T.text,fontSize:12,fontFamily:"inherit",outline:"none",width:"100%"};

  function erstellen(){
    save({});

    const spaltenAktiv=spalten.filter(s=>sel[s.key]).map(s=>({...s,w:colW[s.key]||2.5}));
    if(spaltenAktiv.length===0){alert("Bitte mindestens eine Spalte auswählen.");return;}

    const ev=events.find(e=>e.id===selectedEventId)||{name:eventName,date:eventDate,fotoart,adresse:{}};
    const adresse=ev.adresse||{};
    const datum=(()=>{try{const d=new Date(ev.date);return d.toLocaleDateString("de-DE",{day:"2-digit",month:"2-digit",year:"numeric"});}catch{return ev.date||"";}})();
    const titel=[ev.name,datum,ev.fotoart,ev.location].filter(Boolean).join(" • ");
    const adrBlock=[adresse.strasse,`${adresse.plz||""} ${adresse.ort||""}`.trim(),ev.kontakt].filter(Boolean).join("<br/>");

    const totalW=spaltenAktiv.reduce((s,c)=>s+c.w,0);
    const thStyle=`padding:5px 6px;background:#F5F3EF;color:#A8843E;font-size:${schriftPt}pt;font-weight:700;border-bottom:1.5px solid #A8843E;border-right:1px solid #D8D4CE;text-align:center;`;
    const tdStyle=(i)=>`padding:4px 6px;font-size:${schriftPt}pt;border-bottom:1px solid #e0ddd8;border-right:1px solid #e8e5e0;background:${i%2?"#faf8f5":"#fff"};vertical-align:middle;text-align:center;`;

    const headerRow=`<tr>${spaltenAktiv.map(c=>`<th style="${thStyle}width:${(c.w/totalW*100).toFixed(1)}%">${c.plabel}</th>`).join("")}</tr>`;

    const dataRows=rows.map((r,i)=>`<tr>${spaltenAktiv.map(c=>{
      const val=c.art==="leer"?"":c.art==="kasten"?"□":c.art==="haken"?(r[c.key]?"☑":"☐"):String(r[c.key]||"");
      return `<td style="${tdStyle(i)}${c.art==="kasten"||c.art==="haken"?`font-size:${schriftPt+3}pt;`:""}">${val}</td>`;
    }).join("")}</tr>`).join("");

    const emptyRows=Array.from({length:extraZeilen},(_,i)=>`<tr>${spaltenAktiv.map(()=>`<td style="${tdStyle(rows.length+i)}">&nbsp;</td>`).join("")}</tr>`).join("");

    const rowH=zeilenhoehe;

    const html=`<!DOCTYPE html><html><head><meta charset="utf-8">
    <title>Anwesenheit – ${ev.name||""}</title>
    <style>
      @page{size:A4 landscape;margin:1cm}
      body{font-family:Helvetica,Arial,sans-serif;margin:0;padding:0}
      .header{display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:8px}
      .titel{font-size:12pt;font-weight:700;color:#A8843E}
      .adr{font-size:8pt;color:#8A8075;text-align:right}
      hr{border:none;border-top:1.5px solid #A8843E;margin:4px 0 10px}
      table{width:100%;border-collapse:collapse;table-layout:fixed}
      tr{height:${rowH}pt}
      @media print{button{display:none}}
    </style></head><body>
    <div class="header">
      <div class="titel">${titel}</div>
      <div class="adr">${adrBlock}</div>
    </div>
    <hr/>
    <table><thead>${headerRow}</thead><tbody>${dataRows}${emptyRows}</tbody></table>
    <script>window.onload=()=>{window.print();}<\/script>
    </body></html>`;

    const iframe=document.createElement("iframe");
    iframe.style.cssText="position:fixed;top:-9999px;left:-9999px;width:1px;height:1px;border:none;";
    document.body.appendChild(iframe);
    iframe.contentDocument.open();
    iframe.contentDocument.write(html.replace(/<script>window.onload.*?<\/script>/,""));
    iframe.contentDocument.close();
    iframe.onload=()=>{iframe.contentWindow.focus();iframe.contentWindow.print();setTimeout(()=>document.body.removeChild(iframe),2000);};
    onClose();
  }

  return(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.75)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:200,padding:20}} onClick={onClose}>
      <div onClick={e=>e.stopPropagation()} style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:16,padding:24,width:"100%",maxWidth:560,maxHeight:"90vh",overflowY:"auto"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
          <div style={{fontFamily:"Georgia,serif",fontSize:18,color:T.accent}}>Anwesenheitsliste PDF</div>
          <button style={btn(T,"ghost",true)} onClick={onClose}>✕</button>
        </div>

        {/* Spalten */}
        <div style={{marginBottom:16}}>
          <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:8}}>
            <label style={{fontSize:12,color:T.muted,fontWeight:600,flex:1}}>Spalten für den Ausdruck</label>
            <button style={{...btn(T,"ghost",true),fontSize:10}} onClick={()=>{const n={};spalten.forEach(s=>n[s.key]=true);setSel(n);save({sel:n});}}>Alle</button>
            <button style={{...btn(T,"ghost",true),fontSize:10}} onClick={()=>{const n={};spalten.forEach(s=>n[s.key]=false);setSel(n);save({sel:n});}}>Keine</button>
            <button style={{...btn(T,"ghost",true),fontSize:10}} onClick={()=>{setSel({...DEF_SEL});setColW({...DEF_W});save({sel:{...DEF_SEL},colW:{...DEF_W}});}}>Standard</button>
          </div>
          <div style={{display:"flex",flexDirection:"column",gap:6}}>
            {spalten.map(s=>(
              <div key={s.key} style={{display:"flex",alignItems:"center",gap:10,background:s.key.startsWith("__")?T.accentDim:T.bg,borderRadius:8,padding:"6px 10px"}}>
                <input type="checkbox" checked={!!sel[s.key]} onChange={e=>{const n={...sel,[s.key]:e.target.checked};setSel(n);save({sel:n});}} style={{accentColor:T.accent,width:15,height:15,flexShrink:0}}/>
                <span style={{fontSize:13,color:sel[s.key]?(s.key.startsWith("__")?T.accent:T.text):T.muted,flex:1}}>{s.label}</span>
                {sel[s.key]&&(
                  <div style={{display:"flex",alignItems:"center",gap:6,flexShrink:0}}>
                    <span style={{fontSize:11,color:T.muted}}>Breite (cm)</span>
                    <input type="number" value={colW[s.key]||2.5} min={0.5} max={10} step={0.5}
                      onChange={e=>{const v=Number(e.target.value);setColW(p=>{const n={...p,[s.key]:v};save({colW:n});return n;});}}
                      style={{...IS,width:60,textAlign:"center"}}/>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Einstellungen */}
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:12,marginBottom:20}}>
          <div>
            <label style={{fontSize:12,color:T.muted,fontWeight:600,display:"block",marginBottom:4}}>Leere Zusatzzeilen</label>
            <input type="number" value={extraZeilen} min={0} max={30} onChange={e=>{const v=Number(e.target.value);setExtraZeilen(v);save({extraZeilen:v});}} style={IS}/>
          </div>
          <div>
            <label style={{fontSize:12,color:T.muted,fontWeight:600,display:"block",marginBottom:4}}>Zeilenhöhe (pt)</label>
            <input type="number" value={zeilenhoehe} min={10} max={30} onChange={e=>{const v=Number(e.target.value);setZeilenhoehe(v);save({zeilenhoehe:v});}} style={IS}/>
          </div>
          <div>
            <label style={{fontSize:12,color:T.muted,fontWeight:600,display:"block",marginBottom:4}}>Schriftgröße (pt)</label>
            <input type="number" value={schriftPt} min={5} max={16} step={0.5} onChange={e=>{const v=Number(e.target.value);setSchriftPt(v);save({schriftPt:v});}} style={IS}/>
          </div>
        </div>

        <div style={{display:"flex",gap:8}}>
          <button style={btn(T,"ghost")} onClick={onClose}>Abbrechen</button>
          <button style={{...btn(T,"primary"),flex:1,justifyContent:"center"}} onClick={erstellen}>
            📄 PDF erstellen & drucken
          </button>
        </div>
      </div>
    </div>
  );
}

function ShootingplanPage({T: propT, events=[], setEvents, initData, onInitConsumed, customers=[], setCustomers, onOpenAbrechnung}){
  const [dark,setDark]=useState(true);
  const T=propT||(dark?DARK:LIGHT);
  const {dir:evSortDir,toggle:evSortToggle,sortEvents}=useEventSort();

  // Event-Daten
  const [eventName,setEventName]=useState("");
  const [fotoart,setFotoart]=useState("Underglass");
  const [eventDate,setEventDate]=useState("");
  // Bei Mehrtagesveranstaltungen bekommt jeder Tag einen eigenen Farbton,
  // damit sich die Zeilen im Plan auseinanderhalten lassen.
  const TAGESFARBEN=[
    {bg:"#EAF1F8",rand:"#B9CEE2",text:"#33587A"},  // gedecktes Blau
    {bg:"#FBF1E6",rand:"#E5CDAE",text:"#8A5F2B"},  // gedecktes Orange
    {bg:"#ECF3EC",rand:"#C2D8C4",text:"#3B6B44"},  // Salbei
    {bg:"#F3EDF5",rand:"#D3C4DA",text:"#63467A"},  // Flieder
  ];
  const [rows,setRows]=useState([]);
  // Kachel-Übersicht: pro Veranstaltung ein gespeicherter Plan (wie Abrechnung)
  const [selectedEventId,setSelectedEventId]=useState(null);
  const [spArchivOpen,setSpArchivOpen]=useState(false);

  // Tage der geoeffneten Veranstaltung. Leer, solange es nur ein Tag ist.
  const planTage=(()=>{
    const evv=events.find(e=>e.id===selectedEventId);
    const von=String(evv?.date||"").slice(0,10);
    const bis=String(evv?.dateBis||"").slice(0,10);
    if(!von||!bis||bis===von)return [];
    const raus=[];const d=new Date(von);const ende=new Date(bis);
    if(isNaN(d)||isNaN(ende))return [];
    while(d<=ende&&raus.length<8){raus.push(d.toISOString().slice(0,10));d.setDate(d.getDate()+1);}
    return raus.length>1?raus:[];
  })();
  const tagFarbe=row=>{
    if(!planTage.length)return null;
    const tag=String(row&&row.datum||"").slice(0,10);
    const i=planTage.indexOf(tag);
    return i<0?null:TAGESFARBEN[i%TAGESFARBEN.length];
  };
  const [spTab,setSpTab]=useState("plan"); // "plan" | "buchungen"
  const [showBezahlModal,setShowBezahlModal]=useState(false);
  const [showInfoMailModal,setShowInfoMailModal]=useState(false);
  const [showAbsageMailModal,setShowAbsageMailModal]=useState(false);
  const [vereinbModal,setVereinbModal]=useState(null); // ausgewaehlte Zeilen
  function ladePlaene(){try{return JSON.parse(localStorage.getItem("sd_shootingplaene")||"{}")||{};}catch{return {};}}
  function planOeffnen(ev){
    if(!ev)return;
    const serverUrl=(()=>{try{return(localStorage.getItem("sd_server_url")||"").trim().replace(/\/+$/,"");}catch{return "";}})();
    function _apply(all){
      // rows kann Array (alt) oder Objekt mit .rows (neu) sein
      const entry=all[ev.id];
      const r=entry?.rows??entry;
      setRows(Array.isArray(r)?r:[]);
      setEventName(ev.name||"");
      setFotoart(ev.fotoart||"Veranstaltung");
      setEventDate(ev.date||"");
      setSelectedEventId(ev.id);
    }
    if(serverUrl){
      fetch(serverUrl+"/api/shootingplaene").then(r=>r.json()).then(serverPlaene=>{
        // Mit localStorage mergen: Server hat Vorrang für neue Einträge
        const local=ladePlaene();
        const evLocal=local[ev.id];
        const evServer=serverPlaene[ev.id];
        // Zusammenführen: alle IDs sammeln, Server-Einträge überschreiben lokale
        const localRows=evLocal?.rows??evLocal??[];
        const serverRows=evServer?.rows??evServer??[];
        const byId=new Map();
        localRows.forEach(r=>r.id&&byId.set(r.id,r));
        serverRows.forEach(r=>r.id&&byId.set(r.id,r));
        // Zusatzzeilen weiterer Tiere haben keine Uhrzeit. Sie muessen direkt
        // hinter ihrer ersten Zeile bleiben, sonst rutschen sie nach oben.
        const alleZeilen=[...byId.values()];
        const uhrVon=new Map(alleZeilen.map(r=>[String(r.id||""),r.uhrzeit||""]));
        const sKey=r=>{
          const m=String(r.id||"").match(/^(online_.+)_(\d+)$/);
          if(m&&parseInt(m[2])>=2)return[uhrVon.get(m[1])||"",parseInt(m[2])];
          return[r.uhrzeit||"",1];
        };
        const merged=alleZeilen.sort((a,b)=>{
          const ka=sKey(a),kb=sKey(b);
          return ka[0].localeCompare(kb[0])||ka[1]-kb[1];
        });
        const mergedPlaene={...local,...serverPlaene};
        if(merged.length>0){
          mergedPlaene[ev.id]=merged; // Array-Format beibehalten
        }
        try{localStorage.setItem("sd_shootingplaene",JSON.stringify(mergedPlaene));}catch{}
        _apply(mergedPlaene);
      }).catch(()=>{_apply(ladePlaene());});
    } else {
      _apply(ladePlaene());
    }
  }
  // Plan pro Veranstaltung speichern
  useEffect(()=>{
    if(selectedEventId){
      const all=ladePlaene();
      all[selectedEventId]=rows;
      try{localStorage.setItem("sd_shootingplaene",JSON.stringify(all));}catch{}
      // Auch zum Server syncen
      try{const su=(localStorage.getItem("sd_server_url")||"").trim().replace(/\/+$/,"");if(su){fetch(su+"/api/shootingplaene",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(all)}).catch(()=>{});}}catch{}

      // Automatisch in Abrechnung (ev.teilnehmer) synchronisieren — ZUSAMMENFÜHREN, nicht überschreiben.
      // Vorhandene Teilnehmer behalten ihre Abrechnungsdaten (bezahlt, bestelldatum, rechnung, ...);
      // nur die Plan-Felder werden aktualisiert. Bei leerem Plan wird NICHTS überschrieben.
      if(setEvents&&events.length>0&&rows.length>0){
        const ev=events.find(e=>e.id===selectedEventId);
        if(ev){
          const alt=Array.isArray(ev.teilnehmer)?ev.teilnehmer:[];
          const byId=new Map(alt.map(t=>[t.id,t]));
          const nk=(n,h)=>((n||"").trim().toLowerCase()+"|"+((h||"").trim().toLowerCase()));
          const byName=new Map(alt.filter(t=>t.name).map(t=>[nk(t.name,t.hund),t]));
          const benutzt=new Set();
          const seenNames=new Set();
          const teiln=rows.filter(r=>!r.blocked).map(r=>{
            const nameKey=(r.name||"").trim().toLowerCase();
            const istWiederholung=(nameKey&&seenNames.has(nameKey))||istZusatzTier(r);
            if(nameKey)seenNames.add(nameKey);
            const vorhanden=(r.id&&byId.get(r.id))||byName.get(nk(r.name,r.hund));
            if(vorhanden){
              benutzt.add(vorhanden.id);
              // Weitere Hunde desselben Halters kosten keine Shootinggebuehr.
              // Zusatzbild nur setzen, wenn noch nichts eingetragen ist —
              // eine manuelle Anzahl bleibt erhalten.
              const zusatzKorrektur=istZusatzTier(r)
                ?{gebuehr:0,bilderFrei:0,bilderZusatz:Number(vorhanden.bilderZusatz)||1,weitererHund:true}
                :{weitererHund:false};
              // Abrechnungsdaten erhalten, nur Plan-Felder aktualisieren
              return {...vorhanden,...zusatzKorrektur,
                nr:r.nr||vorhanden.nr||"",
                name:r.name||vorhanden.name||"",
                vorname:r.vorname||vorhanden.vorname||"",
                nachname:r.nachname||vorhanden.nachname||"",
                hund:r.hund||vorhanden.hund||"",
                rasse:r.rasse||vorhanden.rasse||"",
                uhrzeit:r.uhrzeit||vorhanden.uhrzeit||"",
                telefon:r.telefon||vorhanden.telefon||"",
                email:r.email||vorhanden.email||"",
                strasse:r.strasse||vorhanden.strasse||"",
                plz:r.plz||vorhanden.plz||"",
                ort:r.ort||vorhanden.ort||"",
              };
            }
            // Neuer Teilnehmer aus dem Plan
            return {
              id:r.id||uid(),
              nr:r.nr||"",
              name:r.name||"",
              vorname:r.vorname||"",
              nachname:r.nachname||"",
              hund:r.hund||"",
              rasse:r.rasse||"",
              uhrzeit:r.uhrzeit||"",
              telefon:r.telefon||"",
              email:r.email||"",
              strasse:r.strasse||"",
              plz:r.plz||"",
              ort:r.ort||"",
              gebuehr:istWiederholung?0:Number(ev.preise?.shootingGebuehr)||0,
              bilderFrei:istWiederholung?0:Number(ev.preise?.bilderFrei)||0,
              bilderZusatz:istWiederholung?1:0,
              weitererHund:istZusatzTier(r),
              bestelldatum:"",
              rechnung:false,
              bezahlt:false,
              bilderFertig:false,
              bilderVerschickt:false,
              info:"",
              notiz:r.notiz||"",
            };
          });
          // In der Abrechnung manuell ergänzte Teilnehmer (nicht im Plan) nicht verlieren
          const extra=alt.filter(t=>!benutzt.has(t.id));
          setEvents(p=>p.map(x=>x.id===selectedEventId?{...x,teilnehmer:[...teiln,...extra]}:x));
        }
      }
    }
  },[rows,selectedEventId]);
  // Beim Öffnen aus einer Veranstaltung direkt deren Plan anzeigen
  useEffect(()=>{
    if(initData&&initData.eventId){
      const ev=events.find(e=>e.id===initData.eventId);
      if(ev)planOeffnen(ev);
      onInitConsumed&&onInitConsumed();
    }
  },[initData]);

  // Spalten der Teilnehmer-Tabelle (key muss zu emptyRow + Import-Mapping passen)
  const [sortNr,setSortNr]=useState(null); // null=original, "asc", "desc"
  const COLS=[
    {key:"nr",         label:"Nr",        w:36},
    {key:"uhrzeit",    label:"Uhrzeit",   w:64},
    {key:"name",       label:"Name",      w:150},
    {key:"hund",       label:"Rasse",     w:120, center:true},
    {key:"rasse",      label:"Tiername",  w:110, center:true},
    {key:"geschlecht", label:"Geschlecht",w:90,  center:true},
    {key:"alter",      label:"Alter (J)", w:52,  center:true},
    {key:"alterMonate",label:"Mon.",      w:44,  center:true},
    {key:"telefon",    label:"Telefon",   w:120, center:true},
    {key:"email",      label:"E-Mail",    w:180, center:true},
    {key:"strasse",    label:"Straße",    w:150, center:true},
    {key:"plz",        label:"PLZ",       w:64,  center:true},
    {key:"ort",        label:"Ort",       w:110, center:true},
    {key:"notiz",      label:"Notiz",     w:160, center:true},
    {key:"zahlVorab",  label:"Zahlung vorab", w:84, check:true},
    {key:"zahlOffen",  label:"Zahlung offen", w:84, check:true},
  ];

  // Spaltenbreiten (ziehbar, lokal gespeichert)
  const SP_COL_DEFAULTS=COLS.reduce((a,c)=>{a[c.key]=c.w;return a;},{});
  const [colW,startResize,setColW]=useColW("sd_sp_colw",SP_COL_DEFAULTS);
  const cwOf=c=>colW[c.key]||c.w;
  const AKTION_W=84;
  const KUNDE_W=44; // Spalte fuer "Als Kunde anlegen" (links neben Zahlung vorab)
  // Zusatzzeilen weiterer Tiere zeigen nur die Tier-Spalten
  const ZUSATZ_KEYS=["hund","rasse","geschlecht","alter","alterMonate"];
  function resetColW(e,c){e.preventDefault();e.stopPropagation();setColW(p=>({...p,[c.key]:c.w}));}

  // Zahlung vorab / offen schließen sich gegenseitig aus
  function toggleZahlung(id,key){
    const other=key==="zahlVorab"?"zahlOffen":"zahlVorab";
    setRows(p=>p.map(r=>r.id===id?{...r,[key]:!r[key],[other]:false}:r));
  }

  // API Settings
  const [apiSettings,setApiSettings]=useState(()=>{
    try{return JSON.parse(localStorage.getItem("sd_api_settings")||"null")||{};}catch{return {};}
  });
  useEffect(()=>{localStorage.setItem("sd_api_settings",JSON.stringify(apiSettings));},[apiSettings]);

  // Modals
  const [showZeitslot,setShowZeitslot]=useState(false);
  const [showApi,setShowApi]=useState(false);
  const [showCalendly,setShowCalendly]=useState(false);
  const [showJotform,setShowJotform]=useState(false);
  const [showQR,setShowQR]=useState(false);
  const [showSevDesk,setShowSevDesk]=useState(false);
  const [sevDeskProgress,setSevDeskProgress]=useState(null);

  // Tabelle Editing
  const [editCell,setEditCell]=useState(null); // {rowId, key}

  const fileRef=useRef(null);
  const exportRef=useRef(null);

  // ── Tabellen-Operationen ──────────────────────────────────────────────────
  function addRow(){
    const nr=rows.length+1;
    const newRow=emptyRow();
    newRow.nr=String(nr).padStart(2,"0");
    setRows(p=>[...p,newRow]);
  }
  function deleteSelected(){
    setRows(p=>p.filter(r=>!r._selected));
  }
  function toggleSelect(id){
    setRows(p=>p.map(r=>r.id===id?{...r,_selected:!r._selected}:r));
  }
  function renumber(){
    setRows(p=>p.map((r,i)=>({...r,nr:String(i+1).padStart(2,"0")})));
  }
  function updateCell(rowId,key,val){
    setRows(p=>p.map(r=>r.id===rowId?{...r,[key]:val}:r));
  }
  function applyZeitslots(start,dauer){
    const [h,m]=start.split(":").map(Number);
    setRows(p=>p.map((r,i)=>{
      const total=h*60+m+i*dauer;
      return{...r,uhrzeit:`${String(Math.floor(total/60)).padStart(2,"0")}:${String(total%60).padStart(2,"0")}`};
    }));
  }
  function clearAll(){
    if(!confirm("Alle Teilnehmer löschen?"))return;
    setRows([]);
  }

  // ── Import/Export ─────────────────────────────────────────────────────────
  function saveJSON(){
    const data={
      event_name:eventName,event_type:fotoart,
      event_date:eventDate,event_start:eventDate,event_end:eventDate,
      rows:rows.map(r=>COLS.map(c=>r[c.key]||"")),
    };
    const blob=new Blob([JSON.stringify(data,null,2)],{type:"application/json"});
    const a=document.createElement("a");
    a.href=URL.createObjectURL(blob);
    a.download=`${eventName||"Veranstaltungsplan"}_Veranstaltungsplan.json`;
    a.click();
  }

  function loadJSON(e){
    const file=e.target.files[0];if(!file)return;
    const reader=new FileReader();
    reader.onload=ev=>{
      try{
        const data=JSON.parse(ev.target.result);
        setEventName(data.event_name||"");
        setFotoart(data.event_type||"Underglass");
        setEventDate(data.event_start||data.event_date||"");
        const loadedRows=(data.rows||[]).map(row=>{
          const r=emptyRow();
          COLS.forEach((col,i)=>{r[col.key]=row[i]||"";});
          return r;
        });
        setRows(loadedRows);
      }catch(err){alert("Fehler beim Laden: "+err.message);}
    };
    reader.readAsText(file,"utf-8");
    e.target.value="";
  }

  function exportStatistikJSON(){
    const selected=rows.filter(r=>r._selected);
    const relevante=(selected.length>0?selected:rows).filter(r=>r.rasse||r.hund);
    if(!relevante.length){alert("Keine Eintr\u00e4ge mit Rasse vorhanden.");return;}
    try{
      const profs=JSON.parse(localStorage.getItem("sd_profiles")||"[]");
      if(!profs.length){alert("Kein Statistik-Profil vorhanden. Bitte zuerst in der Statistik ein Profil anlegen.");return;}
      const aktiv=profs[0];
      const shootingTyp=aktiv.shootingTypes?.find(st=>st.aktiv&&st.name==="Veranstaltung")
        ||aktiv.shootingTypes?.find(st=>st.aktiv)||{name:"Sonstiges"};
      const neueEintraege=relevante.map(r=>({
        id:uid(),datum:new Date().toISOString().slice(0,10),
        tierName:r.rasse||"",rasse:r.hund||r.rasse||"",
        geschlecht:r.geschlecht||"",alter:alterAusJahrenUndMonaten(r.alter,r.alterMonate),alterMonate:r.alterMonate||"",
        shootingTyp:shootingTyp.name,notizen:""
      }));
      aktiv.eintraege=[...(aktiv.eintraege||[]),...neueEintraege];
      localStorage.setItem("sd_profiles",JSON.stringify(profs));
      alert(neueEintraege.length+" Eintr\u00e4ge in Statistik \u00fcbernommen ("+shootingTyp.name+").");
    }catch(e){alert("Fehler: "+e.message);}
  }

  function exportAbrechnungJSON(){
    const data=rows.filter(r=>r.name||r.nr).map(r=>({
      shootingnr:r.nr,name:r.name,hund:r.rasse||r.hund,
    }));
    const blob=new Blob([JSON.stringify(data,null,2)],{type:"application/json"});
    const a=document.createElement("a");
    a.href=URL.createObjectURL(blob);
    a.download=`${eventName||"Event"}_Abrechnung.json`;
    a.click();
  }

  function exportPDF(){
    const printCols=COLS.filter(c=>c.key!=="notiz");
    const gesamtW=printCols.reduce((s,c)=>s+cwOf(c),0);
    const tableRows=rows.map((r,i)=>`<tr style="${i%2?"background:#f9f9f9":""}">
      ${printCols.map(c=>`<td style="padding:4px 6px;border-bottom:1px solid #e0e0e0;font-size:${c.check?13:10}px;text-align:${c.check?"center":"left"};overflow:hidden">${c.check?(r[c.key]?"☑":"☐"):(r[c.key]||"")}</td>`).join("")}
    </tr>`).join("");
    const html=`<!DOCTYPE html><html><head><meta charset="utf-8"><title>Shootingplan — ${eventName}</title>
    <style>body{font-family:Arial,sans-serif;padding:20px;color:#1a1a1a}h1{font-size:18px;margin-bottom:2px}h2{font-size:12px;color:#666;margin-bottom:16px;font-weight:400}table{width:100%;border-collapse:collapse;table-layout:fixed}th{background:#1a1a1a;color:#fff;padding:6px;font-size:10px;text-align:left;overflow:hidden}@media print{body{padding:8px}}</style>
    </head><body>
    <h1>Shootingplan — ${eventName}</h1>
    <h2>${eventDate} · ${fotoart} · ${rows.filter(r=>!/^online_.+_\d+$/.test(String(r.id||""))).length} Teilnehmer</h2>
    <table><colgroup>${printCols.map(c=>`<col style="width:${(cwOf(c)/gesamtW*100).toFixed(3)}%">`).join("")}</colgroup>
    <thead><tr>${printCols.map(c=>`<th style="text-align:${c.check?"center":"left"}">${c.label}</th>`).join("")}</tr></thead>
    <tbody>${tableRows}</tbody></table>
    <script>window.onload=()=>window.print();<\/script></body></html>`;
    const iframe=document.createElement("iframe");
    iframe.style.cssText="position:fixed;top:-9999px;left:-9999px;width:1px;height:1px;border:none;";
    document.body.appendChild(iframe);
    iframe.contentDocument.open();
    iframe.contentDocument.write(html.replace(/<script>window.onload.*?<\/script>/,""));
    iframe.contentDocument.close();
    iframe.onload=()=>{iframe.contentWindow.focus();iframe.contentWindow.print();setTimeout(()=>document.body.removeChild(iframe),2000);};
  }

  const [showAnwesenheit,setShowAnwesenheit]=useState(false);

  async function anwesenheitPDF(){
    setShowAnwesenheit(true);
  }

  function importFromCalendly(importedRows, evName){
    if(importedRows.length===0)return;
    const mode=rows.length>0&&confirm(`${rows.length} bestehende Einträge vorhanden.\nOK = Hinzufügen, Abbrechen = Ersetzen`);
    const base=mode?rows:[];
    setRows([...base,...importedRows]);
    if(!eventName&&evName)setEventName(evName);
    setShowCalendly(false);
    alert(`✅ ${importedRows.length} Buchungen aus Calendly importiert.`);
  }

  function importFromJotform(importedRows, formTitle){
    if(importedRows.length===0)return;
    const mode=rows.length>0&&confirm(`${rows.length} bestehende Einträge vorhanden.\nOK = Hinzufügen, Abbrechen = Ersetzen`);
    const base=mode?rows:[];
    setRows([...base,...importedRows]);
    setShowJotform(false);
    alert(`✅ ${importedRows.length} Einreichungen aus Jotform importiert.`);
  }

  async function startSevDesk(){
    const token=apiSettings.sevdesk_token;
    if(!token){alert("Bitte zuerst den sevDesk API Token unter API Einstellungen hinterlegen.");return;}
    const selected=rows.filter(r=>r._selected);
    const toSend=selected.length>0?selected:rows;
    if(toSend.length===0){alert("Keine Teilnehmer vorhanden.");return;}
    if(!confirm(`${toSend.length} Kontakte an sevDesk übertragen?`))return;
    setShowSevDesk(true);setSevDeskProgress({ok:[],skip:[],err:[],total:toSend.length});
    const results=await sevDeskUebertragen(toSend,token,r=>setSevDeskProgress({...r,total:toSend.length}));
    setSevDeskProgress({...results,total:toSend.length,done:true});
  }

  // ── Dashboard Kacheln (wie im Original) ───────────────────────────────────
  const TILES=[
    {group:"Veranstaltung",color:{bg:"#dce8f5",border:"#a8c4e0",text:"#2a5a8a"},tiles:[
      {icon:"save",label:"Speichern",action:saveJSON},
      {icon:"folder",label:"Laden",action:()=>fileRef.current.click()},
    ]},
    {group:"Teilnehmer",color:{bg:"#fde8e8",border:"#e0a8a8",text:"#8a2a2a"},tiles:[
      {icon:"plus",label:"Teilnehmer +",action:addRow},
      {icon:"minus",label:"Teilnehmer \u2212",action:deleteSelected},
      {icon:"renum",label:"Nummerieren",action:renumber},
      {icon:"trash",label:"Alle l\u00f6schen",action:clearAll},
      {icon:"block",label:"🚫 Blockieren",action:()=>{const nr=rows.length+1;const newRow={...emptyRow(),nr:String(nr).padStart(2,"0"),name:"— BLOCKIERT —",blocked:true};setRows(p=>[...p,newRow]);}},
    ]},
    {group:"Daten",color:{bg:"#e2f0e2",border:"#a8d0a8",text:"#2a6a2a"},tiles:[
      {icon:"pdf",label:"PDF Liste",action:anwesenheitPDF},
      {icon:"chart",label:"→ Statistik",action:exportStatistikJSON},
      {icon:"pdf",label:"📥 Vereinbarung",action:async()=>{
        const su=(localStorage.getItem("sd_server_url")||"").trim().replace(/\/+$/,"");
        if(!su){alert("Keine Server-URL.");return;}
        const ev=events.find(e=>e.id===selectedEventId);
        const evName=(ev?.name||eventName||"");
        try{
          const res=await fetch(su+"/api/vereinbarungen-zip?ev="+encodeURIComponent(evName));
          if(!res.ok){alert("Download fehlgeschlagen (HTTP "+res.status+")");return;}
          const blob=await res.blob();
          const url=URL.createObjectURL(blob);
          const safe=evName.replace(/[\\/:*?"<>|]+/g,"").trim().replace(/\s+/g,"_");
          const a=document.createElement("a");
          a.href=url;
          a.download="Vereinbarungen"+(safe?"_"+safe:"")+".zip";
          document.body.appendChild(a);a.click();a.remove();
          setTimeout(()=>URL.revokeObjectURL(url),2000);
        }catch(e){alert("Download fehlgeschlagen: "+(e&&e.message?e.message:e));}
      }},
      {icon:"mail",label:"📧 Info-Mail",action:()=>setShowInfoMailModal(true)},
      {icon:"pdf",label:"✍️ Vereinbarung senden",action:()=>{
        const ziel=rows.filter(r=>r._selected&&r.email&&!r.blocked);
        if(ziel.length===0){alert("Bitte zuerst Teilnehmer mit E-Mail auswählen (Checkbox).");return;}
        setVereinbModal(ziel);
      }},
    ]},
  ];

  const inCellStyle={background:"transparent",border:"none",color:T.text,fontSize:12,fontFamily:"inherit",outline:"none",boxSizing:"border-box",width:"100%",padding:0};
  const allKundenSP=(()=>{try{return JSON.parse(localStorage.getItem("sd_customers")||"[]");}catch{return [];}})();
  const [spNewCustData,setSpNewCustData]=useState(null); // Vorbefüllte Daten für neues Kunden-Modal
  const allRassenSP=(()=>{try{return JSON.parse(localStorage.getItem("sd_rassen_profil")||"{}").rassen||[];}catch{return [];}})();
  const [spNameSugg,setSpNameSugg]=useState([]);
  const [spSuggRowId,setSpSuggRowId]=useState(null);
  const [spRasseSugg,setSpRasseSugg]=useState([]);
  const [spRasseRowId,setSpRasseRowId]=useState(null);
  const [editSpRow,setEditSpRow]=useState(null);
  const [spPlzSugg,setSpPlzSugg]=useState([]);
  const [spPlzRowId,setSpPlzRowId]=useState(null);

  // ── Kachel-Übersicht: pro Veranstaltung eine Kachel ───────────────────────
  if(selectedEventId===null){
    const plaene=ladePlaene();
    return(
      <div style={{minHeight:"100vh",background:T.bg,color:T.text,fontFamily:"Inter,system-ui,sans-serif"}}>
        <div style={{padding:"20px 28px 0",display:"flex",alignItems:"flex-start",justifyContent:"space-between",gap:12}}>
          <div>
            <div style={{fontFamily:"Georgia,serif",fontSize:28,fontWeight:700,color:T.text,letterSpacing:"0.05em"}}>VERANSTALTUNGSPLAN</div>
            <div style={{fontSize:13,color:T.muted}}>Wähle eine Veranstaltung, um ihren Plan zu öffnen.</div>
          </div>
          <SortBtn dir={evSortDir} toggle={evSortToggle} T={T}/>
        </div>
        {(()=>{
          const spAktiv=sortEvents(events.filter(ev=>!ev.abgeschlossen&&!ev.abgesagt));
          const spArchiv=sortEvents(events.filter(ev=>ev.abgeschlossen||ev.abgesagt));
          const KachelEl=({ev,archiv})=>{
            // Zusatzzeilen weiterer Tiere sind keine eigenen Teilnehmer.
            const anz=Array.isArray(plaene[ev.id])
              ?plaene[ev.id].filter(r=>!/^online_.+_\d+$/.test(String(r&&r.id||""))).length
              :0;
            return(
              <div key={ev.id}
                onClick={()=>planOeffnen(ev)}
                style={{background:T.surface,border:`1px solid ${archiv?"#4caf5033":T.border}`,borderRadius:14,padding:18,cursor:"pointer",transition:"border-color 0.15s",display:"flex",flexDirection:"column"}}
                onMouseEnter={e=>e.currentTarget.style.borderColor=archiv?"#4caf5066":T.accent}
                onMouseLeave={e=>e.currentTarget.style.borderColor=archiv?"#4caf5033":T.border}>
                <div style={{fontFamily:"Georgia,serif",fontSize:17,fontWeight:700,color:archiv?T.muted:T.text,marginBottom:6}}>{ev.name||"Ohne Namen"}</div>
                <div style={{fontSize:12,color:T.muted,marginBottom:14}}>{ev.date?fmtDateRange(ev):""}{(ev.shootingart||ev.fotoart)?` · ${ev.shootingart||ev.fotoart}`:""}{ev.location?` · ${ev.location}`:""}</div>
                <div style={{fontSize:12,color:T.muted,marginTop:"auto",marginBottom:12}}>{anz} Teilnehmer</div>
                <button style={{...btn(T,archiv?"ghost":"primary",true),width:"100%",justifyContent:"center",color:archiv?"#4caf50":undefined,borderColor:archiv?"#4caf5066":undefined}} onClick={()=>planOeffnen(ev)}>{archiv?"Archiv öffnen":"Öffnen"}</button>
              </div>
            );
          };
          return(<>
            <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(240px,1fr))",gap:16,padding:"22px 28px",alignItems:"stretch"}}>
              {spAktiv.length===0&&<div style={{color:T.muted,fontSize:14}}>Keine aktiven Veranstaltungen.</div>}
              {spAktiv.map(ev=><KachelEl key={ev.id} ev={ev} archiv={false}/>)}
              {spArchiv.length>0&&(
                <div onClick={()=>setSpArchivOpen(true)} style={{background:T.surface,border:`2px dashed ${T.border}`,borderRadius:14,padding:18,cursor:"pointer",transition:"border-color 0.15s",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",gap:10,minHeight:"100%"}}
                  onMouseEnter={e=>e.currentTarget.style.borderColor=T.accent}
                  onMouseLeave={e=>e.currentTarget.style.borderColor=T.border}>
                  <div style={{fontSize:32}}>🗄️</div>
                  <div style={{fontFamily:"Georgia,serif",fontSize:17,fontWeight:700,color:T.muted}}>Archiv</div>
                  <div style={{fontSize:12,color:T.muted}}>{spArchiv.length} Veranstaltung{spArchiv.length!==1?"en":""}</div>
                </div>
              )}
            </div>
            {spArchivOpen&&(
              <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.55)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:300}}>
                <div style={{background:T.surface,borderRadius:14,width:"80vw",maxHeight:"80vh",overflow:"hidden",display:"flex",flexDirection:"column",border:`1px solid ${T.border}`}}>
                  <div style={{padding:"16px 20px",borderBottom:`1px solid ${T.border}`,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                    <div style={{fontFamily:"Georgia,serif",fontSize:18,color:T.accent}}>Archiv – Abgeschlossene Veranstaltungen</div>
                    <button onClick={()=>setSpArchivOpen(false)} style={{background:"none",border:"none",fontSize:20,cursor:"pointer",color:T.muted}}>×</button>
                  </div>
                  <div style={{overflowY:"auto",padding:20,display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(240px,1fr))",gap:14}}>
                    {spArchiv.map(ev=><KachelEl key={ev.id} ev={ev} archiv={true}/>)}
                  </div>
                </div>
              </div>
            )}
          </>);
        })()}
      </div>
    );
  }

  return(
    <div style={{minHeight:"100vh",background:T.bg,color:T.text,fontFamily:"Inter,system-ui,sans-serif",fontSize:14}}>
      <div style={{padding:"14px 28px 0",display:"flex",alignItems:"center",gap:12}}>
        <button style={btn(T,"ghost",true)} onClick={()=>setSelectedEventId(null)}>← Übersicht</button>
        <div style={{display:"flex",gap:4,background:T.surface,border:`1px solid ${T.border}`,borderRadius:8,padding:3}}>
          <button onClick={()=>setSpTab("plan")} style={{padding:"5px 14px",borderRadius:6,border:"none",background:spTab==="plan"?T.accent:"transparent",color:spTab==="plan"?"#fff":T.text,cursor:"pointer",fontSize:12,fontWeight:600,fontFamily:"inherit"}}>Veranstaltungsplan</button>
          <button onClick={()=>setSpTab("buchungen")} style={{padding:"5px 14px",borderRadius:6,border:"none",background:spTab==="buchungen"?T.accent:"transparent",color:spTab==="buchungen"?"#fff":T.text,cursor:"pointer",fontSize:12,fontWeight:600,fontFamily:"inherit"}}>📋 Buchungsliste</button>
        </div>
        <button
          disabled={!selectedEventId}
          title={selectedEventId?"Abrechnung dieser Veranstaltung oeffnen":"Erst eine Veranstaltung laden"}
          onClick={()=>{if(selectedEventId&&onOpenAbrechnung)onOpenAbrechnung(selectedEventId);}}
          style={{...btn(T,"ghost",true),opacity:selectedEventId?1:0.45,cursor:selectedEventId?"pointer":"not-allowed"}}>
          🧾 Abrechnung
        </button>
      </div>
      {/* Header */}
      <div style={{padding:"20px 28px 0",display:"flex",alignItems:"flex-end",gap:20,flexWrap:"wrap"}}>
        <div>
          <div style={{fontFamily:"Georgia,serif",fontSize:28,fontWeight:700,color:T.text,letterSpacing:"0.05em"}}>VERANSTALTUNGSPLAN</div>
          <div style={{fontSize:13,color:T.muted}}>ScattoDesk · Veranstaltungsplanung</div>
        </div>
        <div style={{display:"flex",gap:10,alignItems:"center",flexWrap:"wrap",marginLeft:"auto"}}>
          <input value={eventName} onChange={e=>setEventName(e.target.value)} placeholder="Veranstaltungsname" style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:8,padding:"7px 14px",color:T.text,fontSize:14,fontWeight:600,fontFamily:"inherit",outline:"none",minWidth:220}}/>
          <select value={fotoart} onChange={e=>setFotoart(e.target.value)} style={{background:T.surface,border:`1px solid ${T.accent}66`,borderRadius:8,padding:"7px 12px",color:T.accent,fontSize:13,fontWeight:600,fontFamily:"inherit",outline:"none"}}>
            {FOTOARTEN.map(f=><option key={f} value={f}>{f}</option>)}
          </select>
          <input type="date" value={eventDate} onChange={e=>setEventDate(e.target.value)} style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:8,padding:"7px 12px",color:T.text,fontSize:13,fontFamily:"inherit",outline:"none"}}/>
          {!propT&&<button style={btn(T,"ghost",true)} onClick={()=>setDark(d=>!d)}>{dark?"☀️":"🌙"}</button>}
        </div>
      </div>

      {/* Kacheln Dashboard */}
      <div style={{display:"flex",gap:8,padding:"12px 28px",flexWrap:"wrap",alignItems:"center"}}>
        {TILES.map((group,gi)=>(
          <Fragment key={group.group}>
            {gi>0&&<div style={{width:12}}/>}
            {group.tiles.map(tile=>(
              <button key={tile.label} onClick={tile.action}
                style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",gap:5,
                  width:72,height:72,background:group.color.bg,border:`1px solid ${group.color.border}`,
                  borderRadius:6,cursor:"pointer",fontSize:11,fontWeight:600,color:group.color.text,
                  fontFamily:"inherit",padding:0}}>
                <Ic n={tile.icon} s={18}/>
                <span style={{textAlign:"center",lineHeight:1.2,padding:"0 4px"}}>{tile.label}</span>
              </button>
            ))}
          </Fragment>
        ))}
        {(()=>{const wa=(()=>{try{return JSON.parse(localStorage.getItem("sd_twilio_settings")||"null")||{};}catch{return {};}})();if(!wa.aktiv)return null;return(<><div style={{width:12}}/><button onClick={async()=>{const srvUrl=(localStorage.getItem("sd_server_url")||"").replace(/\/+$/,"");const mitTel=rows.filter(r=>r._selected&&r.telefon&&!r.blocked);if(mitTel.length===0){alert("Bitte zuerst Teilnehmer auswählen (Checkbox).");return;}if(!confirm(`WA-Erinnerung an ${mitTel.length} Teilnehmer senden?`))return;let ok=0,fail=0,lastErr="";for(const r of mitTel){try{const res=await fetch(`${srvUrl}/api/wa-send`,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({sid:wa.sid,token:wa.token,from:wa.from,to:(()=>{let t=r.telefon.replace(/\s/g,"");if(t.startsWith("whatsapp:"))return t;if(t.startsWith("00"))t="+"+t.slice(2);else if(t.startsWith("0"))t="+49"+t.slice(1);else if(!t.startsWith("+"))t="+49"+t;return"whatsapp:"+t;})(),text:"Termin-Erinnerung",content_sid:"HXa0423d9e0510b42775f497e04363dbae",content_variables:JSON.stringify({"1":r.vorname||vornameAus(r.name)||"-","2":eventName||"-","3":(events.find(e=>e.id===selectedEventId)||{}).location||"-","4":eventDate||"-","5":r.uhrzeit||"-"})})});const d=await res.json();if(d.ok)ok++;else{fail++;console.error("WA Fehler:",d.error);lastErr=d.error||"Unbekannt";}}catch(e){fail++;lastErr=e.message;}}alert(`✅ ${ok} gesendet${fail>0?`, ${fail} fehlgeschlagen\nFehler: ${lastErr}`:""}`);}} style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",gap:5,width:72,height:72,background:"#e8f8ee",border:"1px solid #a8d0a8",borderRadius:6,cursor:"pointer",fontSize:11,fontWeight:600,color:"#25d366",fontFamily:"inherit",padding:0}}><span style={{fontSize:18}}>💬</span><span style={{textAlign:"center",lineHeight:1.2,padding:"0 4px"}}>WA Erinnerung</span></button></>) ;})()}
        <div style={{width:12}}/>
        <button onClick={()=>{if(rows.filter(r=>r._selected&&r.email).length===0){alert("Bitte zuerst Teilnehmer mit E-Mail auswählen.");return;}setShowBezahlModal(true);}}
          style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",gap:5,width:72,height:72,background:"#fff3e0",border:"1px solid #f59e0b",borderRadius:6,cursor:"pointer",fontSize:11,fontWeight:600,color:"#d97706",fontFamily:"inherit",padding:0}}>
          <span style={{fontSize:18}}>💳</span>
          <span style={{textAlign:"center",lineHeight:1.2,padding:"0 4px"}}>Bezahlung</span>
        </button>
        <div style={{width:24}}/>
        <button onClick={()=>{if(rows.filter(r=>r._selected&&r.email&&!r.blocked).length===0){alert("Bitte zuerst Teilnehmer mit E-Mail auswählen.");return;}setShowAbsageMailModal(true);}}
          title="Alle ausgewählten Teilnehmer über die Absage informieren"
          style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",gap:5,width:72,height:72,background:"#fdeceb",border:"1px solid #C0563E",borderRadius:6,cursor:"pointer",fontSize:11,fontWeight:600,color:"#C0563E",fontFamily:"inherit",padding:0}}>
          <span style={{fontSize:18}}>❌</span>
          <span style={{textAlign:"center",lineHeight:1.2,padding:"0 4px"}}>Absage</span>
        </button>
      </div>
      {showBezahlModal&&<BezahlungMailModal
        rows={rows} config={JSON.parse(localStorage.getItem("sd_buchung_config")||"null")||{}}
        T={T} eventName={eventName} eventDate={eventDate}
        onClose={()=>setShowBezahlModal(false)}
        onSent={(ids,betrag)=>{
          const ts=new Date().toLocaleString("de-DE",{day:"2-digit",month:"2-digit",year:"numeric",hour:"2-digit",minute:"2-digit"});
          setRows(p=>p.map(r=>ids.includes(r.id)?{...r,bezahlung_gesendet:ts,bezahlung_betrag:betrag}:r));
          setShowBezahlModal(false);
        }}
      />}

      {showInfoMailModal&&<InfoMailModal
        rows={rows} config={JSON.parse(localStorage.getItem("sd_buchung_config")||"null")||{}}
        T={T} eventName={eventName} eventDate={eventDate}
        onClose={()=>setShowInfoMailModal(false)}
      />}

      {showAbsageMailModal&&<InfoMailModal
        variante="absage"
        rows={rows} config={JSON.parse(localStorage.getItem("sd_buchung_config")||"null")||{}}
        T={T} eventName={eventName} eventDate={eventDate}
        onClose={()=>setShowAbsageMailModal(false)}
      />}

      {vereinbModal&&<VereinbarungSendenModal
        ziel={vereinbModal} T={T}
        ev={events.find(e=>e.id===selectedEventId)||{}}
        eventName={eventName} eventDate={eventDate} fotoart={fotoart}
        selectedEventId={selectedEventId}
        onClose={()=>setVereinbModal(null)}
      />}

      {/* Teilnehmer-Info */}
      <div style={{padding:"0 28px 8px",display:"flex",alignItems:"center",gap:16}}>
        <div style={{fontSize:13,color:T.muted}}>{(()=>{
          // Zusatzzeilen weiterer Tiere zaehlen nicht als eigene Teilnehmer.
          const istTier=r=>/^online_.+_\d+$/.test(String(r.id||""));
          const n=rows.filter(r=>!istTier(r)).length;
          const tiere=rows.length-n;
          return n+" Teilnehmer"+(tiere>0?" · "+tiere+" weitere Tiere":"");
        })()}{rows.filter(r=>r._selected).length>0?` · ${rows.filter(r=>r._selected).length} ausgewählt`:""}</div>
        {rows.filter(r=>r.cal==="●").length>0&&<span style={{fontSize:11,background:T.info+"22",color:T.info,padding:"2px 8px",borderRadius:20}}>📅 {rows.filter(r=>r.cal==="●").length} Calendly</span>}
        {rows.filter(r=>r.jot==="●").length>0&&<span style={{fontSize:11,background:T.warning+"22",color:T.warning,padding:"2px 8px",borderRadius:20}}>📋 {rows.filter(r=>r.jot==="●").length} Jotform</span>}

        {planTage.length>1&&(
          <div style={{display:"flex",alignItems:"center",gap:8,flexWrap:"wrap",marginLeft:"auto"}}>
            {planTage.map((t,i)=>{
              const ton=TAGESFARBEN[i%TAGESFARBEN.length];
              const anz=rows.filter(r=>String(r.datum||"").slice(0,10)===t).length;
              return(
                <span key={t} style={{fontSize:11,fontWeight:600,padding:"3px 10px",borderRadius:20,
                      background:ton.bg,border:`1px solid ${ton.rand}`,color:ton.text}}>
                  {t.slice(8,10)}.{t.slice(5,7)}. · {anz}
                </span>
              );
            })}
            {rows.some(r=>!planTage.includes(String(r.datum||"").slice(0,10)))&&(
              <span style={{fontSize:11,color:T.muted}}>ohne Tag: {rows.filter(r=>!planTage.includes(String(r.datum||"").slice(0,10))).length}</span>
            )}
          </div>
        )}
      </div>

      {/* Tabelle */}
      {spTab==="buchungen"&&(()=>{
        const allBuchungen=JSON.parse(localStorage.getItem("sd_buchungen")||"[]");
        const evBuchungen=allBuchungen.filter(b=>b.shootingType===(events.find(e=>e.id===selectedEventId)?.name||eventName));
        return(<div style={{padding:"0 28px 28px"}}>
          <div style={{fontSize:13,color:T.muted,marginBottom:12}}>{evBuchungen.length} Buchung{evBuchungen.length!==1?"en":""} für diese Veranstaltung</div>
          {evBuchungen.length===0?<div style={{color:T.muted,fontSize:13}}>Keine Buchungen vorhanden.</div>:
          <div style={{overflowX:"auto"}}><table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
            <thead><tr>{["Datum","Uhrzeit","Name","Tel","E-Mail","Hund","Rasse","Geschlecht","Tier-Alter"].map(h=>(
              <th key={h} style={{padding:"8px 10px",textAlign:"left",fontSize:10,fontWeight:700,color:T.muted,textTransform:"uppercase",borderBottom:`1px solid ${T.border}`}}>{h}</th>
            ))}</tr></thead>
            <tbody>{evBuchungen.map((b,i)=>{
              const fd=b.formData||{};
              const tier=(b.tiere||[])[0]||{};
              const name=fd.sys_name||(str=>str)((fd.sys_vorname||"")+" "+(fd.sys_nachname||"")).trim();
              const tel=fd.sys_tel||fd.sys_telefon||Object.values(fd).find(v=>typeof v==="string"&&v.match(/^[0-9+\s]{7,}/));
              const email=fd.sys_email||Object.values(fd).find(v=>typeof v==="string"&&v.includes("@"));
              const tierName=tier.name||tier.sf4c_mqfmeio5wne9_4||"";
              const rasse=tier.rasse||tier.sf5c_mqfmeio5wne9_5||"";
              const gesch=tier.geschlecht||tier.mqfmg8n78wfp||"";
              const alter=tier.alter||tier.mqfmfyupentw||"";
              return(<tr key={b.id||i} style={{background:i%2===0?T.surface:T.bg}}>
                <td style={{padding:"7px 10px",borderBottom:`1px solid ${T.border}22`}}>{b.datum?new Date(b.datum).toLocaleDateString("de-DE"):"-"}</td>
                <td style={{padding:"7px 10px",borderBottom:`1px solid ${T.border}22`}}>{b.uhrzeit||"-"}</td>
                <td style={{padding:"7px 10px",borderBottom:`1px solid ${T.border}22`,fontWeight:600}}>{name||"-"}</td>
                <td style={{padding:"7px 10px",borderBottom:`1px solid ${T.border}22`}}>{tel||"-"}</td>
                <td style={{padding:"7px 10px",borderBottom:`1px solid ${T.border}22`}}><a href={"mailto:"+email} style={{color:T.accent}}>{email||"-"}</a></td>
                <td style={{padding:"7px 10px",borderBottom:`1px solid ${T.border}22`}}>{tierName||"-"}</td>
                <td style={{padding:"7px 10px",borderBottom:`1px solid ${T.border}22`}}>{rasse||"-"}</td>
                <td style={{padding:"7px 10px",borderBottom:`1px solid ${T.border}22`}}>{gesch||"-"}</td>
                <td style={{padding:"7px 10px",borderBottom:`1px solid ${T.border}22`}}>{alter||"-"}</td>
              </tr>);
            })}</tbody>
          </table></div>}
        </div>);
      })()}
      {spTab==="plan"&&<div style={{padding:"0 28px 28px",overflowX:"auto"}}>
        <table style={{borderCollapse:"collapse",fontSize:12,whiteSpace:"nowrap",tableLayout:"fixed",width:32+AKTION_W+KUNDE_W+COLS.reduce((s,c)=>s+cwOf(c),0)}}>
          <colgroup>
            <col style={{width:32}}/>
            {COLS.map(c=>(<Fragment key={c.key}>
              {c.key==="zahlVorab"&&<col style={{width:KUNDE_W}}/>}
              <col style={{width:cwOf(c)}}/>
            </Fragment>))}
            <col style={{width:AKTION_W}}/>
          </colgroup>
          <thead>
            <tr style={{background:T.surface}}>
              <th style={{padding:"8px 8px",borderBottom:`1px solid ${T.border}`}}>
                <input type="checkbox" onChange={e=>setRows(p=>p.map(r=>({...r,_selected:e.target.checked})))} style={{accentColor:T.accent}}/>
              </th>
              {COLS.map(c=>(<Fragment key={c.key}>
                {c.key==="zahlVorab"&&<th style={{padding:"8px 8px",textAlign:"center",fontSize:10,fontWeight:700,color:T.muted,textTransform:"uppercase",letterSpacing:"0.07em",borderBottom:`1px solid ${T.border}`,whiteSpace:"normal",lineHeight:1.2}}>Kunde</th>}
                <th onClick={c.key==="nr"?()=>setSortNr(s=>s==="asc"?"desc":s==="desc"?null:"asc"):undefined} title={c.check?"Manuell setzen — vorab und offen schließen sich gegenseitig aus":undefined} style={{padding:"8px 8px",textAlign:c.center||c.check?"center":"left",fontSize:10,fontWeight:700,color:c.key==="nr"||c.check?T.accent:T.muted,textTransform:"uppercase",letterSpacing:"0.07em",borderBottom:`1px solid ${T.border}`,cursor:c.key==="nr"?"pointer":"default",userSelect:"none",position:"relative",overflow:"hidden",whiteSpace:c.check?"normal":"nowrap",lineHeight:1.2}}>
                  {c.label}{c.key==="nr"&&(sortNr==="asc"?" ↑":sortNr==="desc"?" ↓":" ⇅")}
                  <span onDoubleClick={e=>resetColW(e,c)} title="Ziehen = Breite ändern · Doppelklick = Standardbreite">
                    <ResizeHandle T={T} onMouseDown={e=>startResize(e,c.key)}/>
                  </span>
                </th>
              </Fragment>))}
              <th style={{padding:"8px 8px",borderBottom:`1px solid ${T.border}`}}/>
            </tr>
          </thead>
          <tbody>
            {(sortNr?[...rows].sort((a,b)=>{const na=parseInt(a.nr)||Infinity;const nb=parseInt(b.nr)||Infinity;return sortNr==="asc"?na-nb:nb-na;}):rows).map((row,idx)=>{
              const ton=tagFarbe(row);
              const grund=row.blocked?"#fee2e2":row.bezahlung_gesendet?"#d1fae5":row._geschenk?"#fef9e7"
                :row._selected?T.accentDim:ton?ton.bg:(idx%2===0?T.surface:T.bg);
              return(
              <tr key={row.id}
                style={{background:grund,transition:"background 0.1s",
                        boxShadow:ton&&!row.blocked&&!row._selected?`inset 3px 0 0 ${ton.rand}`:undefined}}
                onMouseEnter={e=>{if(!row._selected&&!row.blocked)e.currentTarget.style.background=T.tileHover;}}
                onMouseLeave={e=>{if(!row._selected&&!row.blocked)e.currentTarget.style.background=grund;}}
                onDoubleClick={()=>setEditSpRow({...row})}>
                <td style={{padding:"4px 8px",borderBottom:`1px solid ${T.border}22`}}>
                  <input type="checkbox" checked={!!row._selected} onChange={()=>toggleSelect(row.id)} style={{accentColor:T.accent}}/>
                </td>
                {COLS.map(c=>(<Fragment key={c.key}>
                  {c.key==="zahlVorab"&&(
                    <td onDoubleClick={e=>e.stopPropagation()} style={{padding:"2px 4px",borderBottom:`1px solid ${T.border}22`,textAlign:"center",whiteSpace:"nowrap"}}>
                      {istZusatzTier(row)?null:(()=>{
                        const nameMatch=row.name&&allKundenSP.some(k=>(k.name||"").toLowerCase().trim()===(row.name||"").toLowerCase().trim());
                        const emailMatch=row.email&&allKundenSP.some(k=>(k.email||"").toLowerCase().trim()===(row.email||"").toLowerCase().trim());
                        if(nameMatch||emailMatch)return null;
                        if(!row.name)return null;
                        // Nur bei erster Zeile dieser Person den Button zeigen
                        const ersteZeile=rows.findIndex(r=>r.name===row.name&&r.email===row.email)===rows.indexOf(row);
                        if(!ersteZeile)return null;
                        // Alle Tiere dieser Person sammeln
                        const alleTiere=rows.filter(r=>r.name===row.name&&r.email===row.email).map(r=>({id:uid(),name:r.rasse||"",rasse:r.hund||"",geschlecht:r.geschlecht||"",alter:r.alter||"",alterMonate:r.alterMonate||""}));
                        return(
                          <button style={{...btn(T,"ghost",true),fontSize:10,padding:"2px 6px",marginRight:3}} title="Als Kunde speichern"
                            onClick={()=>{
                              setSpNewCustData({
                                name:row.name||"",email:row.email||"",phone:row.telefon||"",
                                strasse:row.strasse||"",plz:row.plz||"",ort:row.ort||"",
                                anrede:"",notes:"",
                                tiere:alleTiere,
                              });
                            }}>👤+</button>
                        );
                      })()}
                    </td>
                  )}
                  <td onDoubleClick={c.check?(e=>e.stopPropagation()):undefined} style={{padding:"2px 6px",borderBottom:`1px solid ${T.border}22`,position:"relative",textAlign:c.center||c.check?"center":"left"}}>
                    {istZusatzTier(row)&&!ZUSATZ_KEYS.includes(c.key)?(
                      c.key==="name"?<span style={{color:T.border,fontSize:11,fontStyle:"italic"}}>↑ s.o.</span>:<span/>
                    ):c.check?(
                      <input type="checkbox" checked={!!row[c.key]} onChange={()=>toggleZahlung(row.id,c.key)}
                        title={c.key==="zahlVorab"?"Zahlung vorab":"Zahlung offen — zahlt vor Ort"}
                        style={{accentColor:c.key==="zahlVorab"?T.success:T.warning,width:15,height:15,cursor:"pointer"}}/>
                    ):c.key==="cal"||c.key==="jot"?(
                      <span style={{fontSize:14,color:row[c.key]==="●"?c.key==="cal"?T.info:T.warning:T.border+"44"}}>{row[c.key]==="●"?"●":"○"}</span>
                    ):c.key==="name"?(
                      <>
                        <input
                          value={row[c.key]||""}
                          onChange={e=>{
                            updateCell(row.id,c.key,e.target.value);
                            const v=e.target.value;
                            if(v.length>=2){
                              const vl=v.toLowerCase();
                            const sugg=allKundenSP.filter(k=>{
                              const n=(k.name||"").toLowerCase();
                              const parts=n.split(" ");
                              return parts.some(p=>p.startsWith(vl))||n.includes(vl);
                            }).slice(0,10);
                              setSpNameSugg(sugg);
                              setSpSuggRowId(row.id);
                            } else {setSpNameSugg([]);setSpSuggRowId(null);}
                          }}
                          onBlur={()=>setTimeout(()=>{setSpNameSugg([]);setSpSuggRowId(null);},200)}
                          style={{...inCellStyle,minWidth:0,textAlign:c.center?"center":"left"}}
                        />
                        {spSuggRowId===row.id&&spNameSugg.length>0&&(
                          <div style={{position:"absolute",top:"100%",left:0,background:T.surface,border:`1px solid ${T.border}`,borderRadius:10,zIndex:300,minWidth:320,boxShadow:"0 8px 32px rgba(0,0,0,0.6)",maxHeight:320,overflowY:"auto"}}>
                            {spNameSugg.map(k=>(
                              <div key={k.id} onClick={()=>{
                                const rasse=k.tiere?.[0]?.rasse||k.rasse||"";
                                const tiername=k.tiere?.[0]?.name||"";
                                const geschlecht=k.tiere?.[0]?.geschlecht||"";
                                const alter=k.tiere?.[0]?.alter||"";
                                setRows(p=>p.map(r=>r.id===row.id?{...r,
                                  name:k.name||"",
                                  hund:rasse,
                                  rasse:tiername,
                                  geschlecht:geschlecht,
                                  alter:alter,
                                  telefon:k.phone||k.telefon||"",
                                  email:k.email||"",
                                }:r));
                                setSpNameSugg([]);setSpSuggRowId(null);
                              }}
                                style={{padding:"8px 12px",cursor:"pointer",fontSize:12,borderBottom:`1px solid ${T.border}22`}}
                                onMouseEnter={e=>e.currentTarget.style.background=T.accentDim}
                                onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
                                <div style={{fontWeight:600,color:T.text}}>{k.name}</div>
                                <div style={{fontSize:11,color:T.muted}}>{[k.phone||k.telefon,k.email,k.tiere?.[0]?.rasse].filter(Boolean).join(" · ")}</div>
                              </div>
                            ))}
                          </div>
                        )}
                      </>
                    ):c.key==="hund"?(
                      <>
                        <input value={row[c.key]||""}
                          onChange={e=>{updateCell(row.id,c.key,e.target.value);const v=e.target.value;if(v.length>=2){setSpRasseSugg(allRassenSP.filter(r=>r.toLowerCase().includes(v.toLowerCase())).slice(0,8));setSpRasseRowId(row.id);}else{setSpRasseSugg([]);setSpRasseRowId(null);}}}
                          onBlur={()=>setTimeout(()=>{setSpRasseSugg([]);setSpRasseRowId(null);},200)}
                          style={{...inCellStyle,minWidth:0,textAlign:c.center?"center":"left"}}/>
                        {spRasseRowId===row.id&&spRasseSugg.length>0&&(
                          <div style={{position:"fixed",background:T.surface,border:`1px solid ${T.border}`,borderRadius:8,zIndex:9999,minWidth:220,boxShadow:"0 8px 32px rgba(0,0,0,0.6)",maxHeight:260,overflowY:"auto",marginTop:2}}
                            ref={el=>{if(el){const inp=el.previousSibling;if(inp){const r=inp.getBoundingClientRect();el.style.top=(r.bottom+2)+"px";el.style.left=r.left+"px";}}}}>
                            {spRasseSugg.map(r=>(
                              <div key={r} onClick={()=>{updateCell(row.id,"hund",r);setSpRasseSugg([]);setSpRasseRowId(null);}}
                                style={{padding:"9px 14px",cursor:"pointer",fontSize:13,color:T.text,borderBottom:`1px solid ${T.border}22`}}
                                onMouseEnter={e=>e.currentTarget.style.background=T.accentDim}
                                onMouseLeave={e=>e.currentTarget.style.background="transparent"}>{r}</div>
                            ))}
                          </div>
                        )}
                      </>
                    ):c.key==="name"&&row._geschenk&&!row.weitererHund?(
                      <span>{row.name} <span title={`Beschenkte: ${row.name}\nE-Mail: ${row.geschenk?.email||row.email||""}\nHandy: ${row.geschenk?.handy||row.telefon||""}`} style={{cursor:"help"}}>🎁</span></span>
                    ):c.key==="name"&&row.weitererHund?(
                      <span style={{color:T.border,fontSize:11,fontStyle:"italic"}}>↑ s.o.</span>
                    ):c.key==="email"&&row.weitererHund?(
                      <span/>
                    ):(c.key==="telefon"||c.key==="strasse"||c.key==="plz"||c.key==="ort")&&row.weitererHund?(
                      <span/>
                    ):c.key==="plz"?(
                      <input value={row[c.key]||""}
                        onChange={async e=>{
                          const v=e.target.value;updateCell(row.id,"plz",v);
                          if(v.length===5){
                            try{
                              const r=await fetch(`https://api.zippopotam.us/de/${v}`);
                              if(r.ok){const d=await r.json();const ort=d.places?.[0]?.["place name"]||"";if(ort)updateCell(row.id,"ort",ort);}
                            }catch{}
                          }
                        }}
                        style={{...inCellStyle,minWidth:0,textAlign:c.center?"center":"left"}}/>
                    ):c.key==="email"&&row[c.key]?(
                      <a href={`mailto:${row[c.key]}`}
                        title={`E-Mail an ${row[c.key]} schreiben`}
                        style={{color:T.info,textDecoration:"none",fontSize:12,fontFamily:"inherit",cursor:"pointer",display:"block",minWidth:0,textAlign:"center",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}
                        onMouseEnter={e=>{e.currentTarget.style.textDecoration="underline";e.currentTarget.style.opacity="0.8";}}
                        onMouseLeave={e=>{e.currentTarget.style.textDecoration="none";e.currentTarget.style.opacity="1";}}>
                        {row[c.key]}
                      </a>
                    ):(
                      <input
                        value={row[c.key]||""}
                        onChange={e=>updateCell(row.id,c.key,e.target.value)}
                        style={{...inCellStyle,minWidth:0,textAlign:c.center?"center":"left",color:c.key==="nr"?T.accent:T.text}}
                      />
                    )}
                  </td>
                </Fragment>))}
                <td style={{padding:"4px 6px",borderBottom:`1px solid ${T.border}22`,whiteSpace:"nowrap"}}>
                  <button style={btn(T,"danger",true)} onClick={()=>setRows(p=>p.filter(r=>r.id!==row.id))}>✕</button>
                </td>
              </tr>);
            })}
            {rows.length===0&&(
              <tr><td colSpan={COLS.length+3} style={{padding:40,textAlign:"center",color:T.muted}}>
                Noch keine Teilnehmer. Über "Teilnehmer +" manuell hinzufügen oder Calendly / Jotform importieren.
              </td></tr>
            )}
          </tbody>
        </table>
      </div>}

      {/* Hidden file inputs */}
      <input ref={fileRef} type="file" accept=".json" onChange={loadJSON} style={{display:"none"}}/>

      {/* Modals */}
      {showZeitslot&&<ZeitslotModal rowCount={rows.length} onApply={applyZeitslots} onClose={()=>setShowZeitslot(false)} T={T}/>}
      {showAnwesenheit&&<AnwesenheitModal rows={rows} cols={COLS} events={events} selectedEventId={selectedEventId} eventName={eventName} eventDate={eventDate} fotoart={fotoart} onClose={()=>setShowAnwesenheit(false)} T={T}/>}
      {showApi&&<ApiModal settings={apiSettings} onSave={s=>{setApiSettings(s);localStorage.setItem("sd_api_settings",JSON.stringify(s));}} onClose={()=>setShowApi(false)} T={T}/>}
      {showCalendly&&<CalendlyModal token={apiSettings.calendly_token} onImport={importFromCalendly} onClose={()=>setShowCalendly(false)} T={T}/>}
      {showJotform&&<JotformModal apiKey={apiSettings.jotform_key} fotoart={fotoart} onImport={importFromJotform} onClose={()=>setShowJotform(false)} T={T}/>}
      {showQR&&<QRModal eventName={eventName} onClose={()=>setShowQR(false)} T={T} bookingUrl={(()=>{
        try{
          const serverUrl=(localStorage.getItem("sd_server_url")||"").replace(/\/+$/,"");
          const cfg=JSON.parse(localStorage.getItem("sd_buchung_config")||"{}");
          const st=(cfg.shootingTypes||[]).find(s=>s.eventId===selectedEventId);
          const slug=st?.buchungsUrl||"";
          return slug?`${serverUrl}/buchen/${slug}`:"";
        }catch{return "";}
      })()}/>}

      {/* sevDesk Fortschritt */}
      {spNewCustData&&<CustomerModal T={T} customer={spNewCustData} onClose={()=>setSpNewCustData(null)} onSave={c=>{
        const alle=(()=>{try{return JSON.parse(localStorage.getItem("sd_customers")||"[]");}catch{return [];}})();
        localStorage.setItem("sd_customers",JSON.stringify([c,...alle]));
        if(setCustomers)setCustomers(p=>[c,...p]);
        setSpNewCustData(null);
        alert(`✅ Kunde "${c.name}" gespeichert (Kd-Nr: ${c.kundennr||""}).`);
      }}/>}

      {showSevDesk&&(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.78)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:100,padding:20}}>
          <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:16,padding:28,width:"100%",maxWidth:460}}>
            <div style={{fontFamily:"Georgia,serif",fontSize:18,color:T.accent,marginBottom:16}}>sevDesk Übertragung</div>
            {sevDeskProgress&&(
              <div>
                <div style={{background:T.bg,borderRadius:8,padding:14,fontSize:12,maxHeight:200,overflowY:"auto",marginBottom:14}}>
                  {sevDeskProgress.ok?.length>0&&<div style={{color:T.success,marginBottom:6}}>✅ Angelegt ({sevDeskProgress.ok.length}):{"\n"+sevDeskProgress.ok.map(n=>`  • ${n}`).join("\n")}</div>}
                  {sevDeskProgress.skip?.length>0&&<div style={{color:T.warning,marginBottom:6}}>⚠️ Übersprungen ({sevDeskProgress.skip.length}):{"\n"+sevDeskProgress.skip.map(n=>`  • ${n}`).join("\n")}</div>}
                  {sevDeskProgress.err?.length>0&&<div style={{color:T.danger}}>❌ Fehler ({sevDeskProgress.err.length}):{"\n"+sevDeskProgress.err.map(n=>`  • ${n}`).join("\n")}</div>}
                  {!sevDeskProgress.done&&<div style={{color:T.muted,marginTop:6}}>⏳ Übertrage... ({(sevDeskProgress.ok?.length||0)+(sevDeskProgress.skip?.length||0)+(sevDeskProgress.err?.length||0)}/{sevDeskProgress.total})</div>}
                </div>
                {sevDeskProgress.done&&<div style={{display:"flex",justifyContent:"flex-end"}}><button style={btn(T,"primary")} onClick={()=>{setShowSevDesk(false);setSevDeskProgress(null);}}>Fertig</button></div>}
              </div>
            )}
          </div>
        </div>
      )}

      {/* Zeile bearbeiten Modal */}
      {editSpRow&&(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.7)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:300,padding:20}}>
          <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:16,padding:24,width:"100%",maxWidth:620,maxHeight:"90vh",overflowY:"auto"}}>
            <div style={{fontFamily:"Georgia,serif",fontSize:16,color:T.accent,marginBottom:16}}>Eintrag bearbeiten</div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:16}}>
              {[
                ["nr","Nr.","span 1"],["uhrzeit","Uhrzeit","span 1"],
                ...(!editSpRow.weitererHund?[["name","Name","span 2"]]:[]),
                ["hund","Rasse","span 1"],["rasse","Tiername","span 1"],
                ["geschlecht","Geschlecht","span 1"],["alter","Alter (J)","span 1"],
                ["alterMonate","Monate","span 1"],
                ...(!editSpRow.weitererHund?[
                  ["telefon","Telefon","span 1"],
                  ["email","E-Mail","span 2"],
                  ["strasse","Straße","span 2"],
                  ["plz","PLZ","span 1"],["ort","Ort","span 1"],
                ]:[]),
              ].map(([k,l,span])=>(
                <div key={k} style={{gridColumn:span}}>
                  <label style={{fontSize:11,color:T.muted,fontWeight:600,display:"block",marginBottom:3}}>{l}</label>
                  <input value={editSpRow[k]||""} onChange={e=>setEditSpRow(x=>({...x,[k]:e.target.value}))}
                    style={{width:"100%",background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:"8px 10px",color:T.text,fontSize:13,fontFamily:"inherit",outline:"none",boxSizing:"border-box"}}/>
                </div>
              ))}
            </div>
            <div style={{marginBottom:16}}>
              <label style={{fontSize:11,color:T.muted,fontWeight:600,display:"block",marginBottom:3}}>Notiz</label>
              <textarea value={editSpRow.notiz||""} onChange={e=>setEditSpRow(x=>({...x,notiz:e.target.value}))} rows={3}
                style={{width:"100%",background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:"8px 10px",color:T.text,fontSize:13,fontFamily:"inherit",outline:"none",resize:"vertical",boxSizing:"border-box"}}/>
            </div>
            <div style={{display:"flex",justifyContent:"space-between",gap:10}}>
              <button style={{...btn(T,"ghost"),fontSize:12}} onClick={()=>{
                const saved={...editSpRow};
                const neueZeile={...emptyRow(),
                  uhrzeit:saved.uhrzeit||"",
                  name:saved.name||"",
                  vorname:saved.vorname||"",
                  nachname:saved.nachname||"",
                  telefon:saved.telefon||"",
                  email:saved.email||"",
                  strasse:saved.strasse||"",
                  plz:saved.plz||"",
                  ort:saved.ort||"",
                  nr:(saved.nr||"")+"b",
                  weitererHund:true,
                };
                setRows(p=>{
                  const updated=p.map(r=>r.id===saved.id?saved:r);
                  const idx=updated.findIndex(r=>r.id===saved.id);
                  const result=[...updated];
                  result.splice(idx+1,0,neueZeile);
                  return result;
                });
                setEditSpRow(neueZeile);
              }}>🐕 Weiterer Hund</button>
              <div style={{display:"flex",gap:10}}>
                <button style={btn(T,"ghost")} onClick={()=>setEditSpRow(null)}>Abbrechen</button>
                <button style={btn(T,"primary")} onClick={()=>{
                  setRows(p=>p.map(r=>r.id===editSpRow.id?{...editSpRow}:r));
                  setEditSpRow(null);
                }}>Speichern</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}


// ── BuchungssystemPage ─────────────────────────────────────────────────────────────────────

// ── Öffentliche Buchungsseite ─────────────────────────────────────────────────

// ── Buchungssystem: Konstanten (wiederhergestellt) ──────────────────
const SYSTEM_FIELDS=[
  {id:"sys_nr",        type:"text",  label:"Shooting-Nr.", labelDe:"Shooting-Nr.", labelEn:"Shooting No.", required:false, aktiv:true, system:true, placeholder:{de:"wird vor Ort vergeben",en:"assigned on site"}},
  {id:"sys_anrede",    type:"radio", label:"Anrede",      labelDe:"Anrede",      labelEn:"Salutation",  required:true,  aktiv:true, system:true, options:["Frau","Herr","Divers"]},
  {id:"sys_name",      type:"text",  label:"Name",        labelDe:"Name",        labelEn:"Name",        required:true,  aktiv:true, system:true},
  {id:"sys_email",     type:"email", label:"E-Mail",      labelDe:"E-Mail",      labelEn:"E-Mail",      required:true,  aktiv:true, system:true},
  {id:"sys_tel",       type:"tel",   label:"Telefon",     labelDe:"Telefon",     labelEn:"Phone",       required:false, aktiv:true, system:true},
  {id:"sys_tiername",  type:"text",  label:"Tiername",    labelDe:"Tiername",    labelEn:"Pet name",    required:false, aktiv:true, system:true},
  {id:"sys_rasse",     type:"text",  label:"Rasse",       labelDe:"Rasse",       labelEn:"Breed",       required:false, aktiv:true, system:true},
  {id:"sys_alter",     type:"number",label:"Alter (Tier)",labelDe:"Alter (Tier)",labelEn:"Pet age",     required:false, aktiv:true, system:true},
  {id:"sys_alter_monate",type:"number",label:"Monate",       labelDe:"Monate",       labelEn:"Months (0-11)", required:false, aktiv:true, system:true},
  {id:"sys_geschlecht",type:"radio", label:"Geschlecht",  labelDe:"Geschlecht",  labelEn:"Gender",      required:false, aktiv:true, system:true, options:["Hündin","Rüde"]},
  {id:"sys_strasse",   type:"text",  label:"Straße",      labelDe:"Straße",      labelEn:"Street",      required:false, aktiv:false,system:true},
  {id:"sys_plz",       type:"text",  label:"PLZ",         labelDe:"PLZ",         labelEn:"Zip code",    required:false, aktiv:false,system:true},
  {id:"sys_ort",       type:"text",  label:"Ort",         labelDe:"Ort",         labelEn:"City",        required:false, aktiv:false,system:true},
];

const FIELD_TYPES=[
  {type:"text",     label:"Textfeld"},
  {type:"email",    label:"E-Mail"},
  {type:"tel",      label:"Telefon"},
  {type:"select",   label:"Auswahl"},
  {type:"radio",    label:"Radio"},
  {type:"checkbox", label:"Checkbox"},
  {type:"textarea", label:"Mehrzeiliger Text"},
  {type:"number",   label:"Zahl"},
  {type:"date",     label:"Datum"},
];


const IS=T=>({background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:"9px 12px",color:T.text,fontSize:13,fontFamily:"inherit",outline:"none",boxSizing:"border-box",width:"100%"});

// ── Signature Pad ─────────────────────────────────────────────────────────────
function SignaturePadInline({onSave,T,label="Hier unterschreiben"}){
  const ref=useRef(null);
  const drawing=useRef(false);
  const last=useRef(null);
  const [signed,setSigned]=useState(false);
  useEffect(()=>{
    const c=ref.current;if(!c)return;
    const dpr=window.devicePixelRatio||1;
    const rect=c.getBoundingClientRect();
    c.width=rect.width*dpr;c.height=rect.height*dpr;
    const ctx=c.getContext("2d");ctx.scale(dpr,dpr);
    ctx.lineWidth=2.5;ctx.lineCap="round";ctx.lineJoin="round";ctx.strokeStyle="#1a1a1a";
  },[]);
  function pos(e,c){const r=c.getBoundingClientRect(),s=e.touches?e.touches[0]:e;return{x:s.clientX-r.left,y:s.clientY-r.top};}
  function start(e){e.preventDefault();drawing.current=true;const p=pos(e,ref.current);last.current=p;const ctx=ref.current.getContext("2d");ctx.beginPath();ctx.arc(p.x,p.y,1,0,Math.PI*2,false);ctx.fill();}
  function move(e){
    e.preventDefault();if(!drawing.current)return;
    const c=ref.current,ctx=c.getContext("2d"),p=pos(e,c);
    ctx.beginPath();ctx.moveTo(last.current.x,last.current.y);ctx.lineTo(p.x,p.y);ctx.stroke();
    last.current=p;setSigned(true);
  }
  function clear(){const c=ref.current;c.getContext("2d").clearRect(0,0,c.width,c.height);setSigned(false);onSave&&onSave(null);}
  function save(){if(signed)onSave&&onSave(ref.current.toDataURL());}
  return(
    <div>
      <div style={{fontSize:12,color:T?.muted||"#8A8075",marginBottom:6}}>{label}</div>
      <div style={{border:"2px dashed #ccc",borderRadius:8,overflow:"hidden",background:"#fff"}}>
        <canvas ref={ref} style={{display:"block",width:"100%",height:150,touchAction:"none",cursor:"crosshair"}}
          onMouseDown={start} onMouseMove={move} onMouseUp={()=>{drawing.current=false;save();}}
          onTouchStart={start} onTouchMove={move} onTouchEnd={()=>{drawing.current=false;save();}}/>
      </div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginTop:6}}>
        <span style={{fontSize:11,color:"#8A8075"}}>{signed?"✅ Unterschrift erfasst":"Bitte oben unterschreiben"}</span>
        <button onClick={clear} style={{fontSize:11,color:"#8A8075",background:"none",border:"none",cursor:"pointer",padding:"2px 8px"}}>Löschen</button>
      </div>
    </div>
  );
}

// ── Öffentliche Buchungsseite ─────────────────────────────────────────────────
function PublicBookingPage({config,shootingType,onBooked,forceVorort}){
  const [lang,setLang]=useState("de");
  const urlParams=new URLSearchParams(typeof window!=="undefined"?window.location.search:"");
  const vorOrtModus=!!forceVorort||urlParams.get("modus")==="vorort";
  const landingModus=urlParams.get("modus")==="landing"; // Landingpage-Modus
  const geschenkModus=urlParams.get("geschenk")==="1";  // Schenkende(r): Bezahlung, keine Vereinbarung, Termin freiwillig
  const einloesenModus=urlParams.get("geschenk")==="2";  // Beschenkte(r): Termin + Vereinbarung, keine Bezahlung
  const [beschenkteAngaben,setBeschenkteAngaben]=useState({besteller:"",name:"",email:"",handy:""});
  const prefilledDatum=urlParams.get("datum")||null;
  const prefilledSlot=urlParams.get("slot")||null;
  const [showLanding,setShowLanding]=useState(landingModus&&!vorOrtModus&&!prefilledDatum);
  const [step,setStep]=useState(
    prefilledDatum&&prefilledSlot?"form":vorOrtModus?"form":"slots"
  );
  const [selectedSlot,setSelectedSlot]=useState(prefilledSlot||null);
  const [selectedDate,setSelectedDate]=useState(prefilledDatum||null);
  const [formData,setFormData]=useState({});
  const [errors,setErrors]=useState({});
  const [signature,setSignature]=useState(null);
  const [submitted,setSubmitted]=useState(false);
  const [zahlMethode,setZahlMethode]=useState("paypal");
  // Mehrere Tiere
  const TIER_FELDER=["sys_tiername","sys_rasse","sys_alter","sys_alter_monate","sys_geschlecht"];
  const isTierFeld=f=>!!(f&&(f.proTier||TIER_FELDER.includes(f.id)));
  const [tiere,setTiere]=useState([{id:"tier_0"}]); // mind. 1 Tier
  const [agreeOpen,setAgreeOpen]=useState(false); // Vereinbarung klappbar
  const [confirmPdf,setConfirmPdf]=useState(null); // vom Server zurückgegebene PDF zum Download
  function addTier(){setTiere(p=>[...p,{id:"tier_"+uid()}]);}
  function removeTier(tid){if(tiere.length<=1)return;setTiere(p=>p.filter(t=>t.id!==tid));}
  function setTierField(tid,fid,val){setFormData(f=>({...f,[tid+"_"+fid]:val}));}
  function getTierField(tid,fid){return formData[tid+"_"+fid]||"";}

  const st=shootingType;
  // Shooting-Nr. nur im Vor-Ort-Modus zeigen. Bei Vorabbuchung mit Zeitslot
  // steht dort nur "wird vor Ort vergeben", das verwirrt nur.
  const _vorortJetzt=!!forceVorort||new URLSearchParams(typeof window!=="undefined"?window.location.search:"").get("modus")==="vorort";
  const activeFelder=(st.felder||[]).filter(f=>f.aktiv&&!(f.id==="sys_nr"&&!_vorortJetzt));
  const primaryColor=config.primaryColor||"#C9A96E";
  const txt={
    de:{
      title:"Termin buchen",back:"← Zurück",next:"Weiter →",
      bookNow:"Jetzt buchen",slots:"Verfügbare Termine",
      chooseTime:"Uhrzeit wählen",yourData:"Deine Angaben",
      sign:"Vereinbarung & Unterschrift",signHere:"Hier unterschreiben",
      agree:"Ich habe die Vereinbarung gelesen und stimme zu.",
      required:"Pflichtfeld",submit:"Weiter zur Bezahlung",
      done:"Buchung bestätigt!",doneText:"Vielen Dank! Deine Buchung wurde erfasst. Du kannst dir unten deine Buchungsbestätigung als PDF herunterladen.",
      noSlots:"Aktuell keine Termine verfügbar.",pleaseSign:"Bitte unterschreibe die Vereinbarung.",
      pleaseAgree:"Bitte stimme der Vereinbarung zu.",
      payment:"Bezahlung",payWith:"Bezahlen mit",payNow:"Jetzt bezahlen",
      paypal:"PayPal",ueberweisung:"Überweisung",bar:"Barzahlung vor Ort",
      ibanInfo:"Bitte überweise den Betrag mit dem Verwendungszweck:",
      payDone:"Zahlung bestätigt",
    },
    en:{
      title:"Book appointment",back:"← Back",next:"Next →",
      bookNow:"Book now",slots:"Available appointments",
      chooseTime:"Choose time",yourData:"Your details",
      sign:"Agreement & Signature",signHere:"Sign here",
      agree:"I have read the agreement and agree.",
      required:"Required",submit:"Continue to payment",
      done:"Booking confirmed!",doneText:"Thank you! Your booking has been recorded. You can download your booking confirmation as PDF below.",
      noSlots:"No appointments available at the moment.",pleaseSign:"Please sign the agreement.",
      pleaseAgree:"Please agree to the terms.",
      payment:"Payment",payWith:"Pay with",payNow:"Pay now",
      paypal:"PayPal",ueberweisung:"Bank transfer",bar:"Cash on site",
      ibanInfo:"Please transfer the amount with the reference:",
      payDone:"Payment confirmed",
    },
  };
  const t=txt[lang]||txt.de;

  function setField(id,val){setFormData(f=>({...f,[id]:val}));}

  function validateForm(){
    const e={};
    activeFelder.forEach(f=>{
      if(!f.required)return;
      if(isTierFeld(f)){
        tiere.forEach(tier=>{
          // Alter-Feld: entweder Jahre ODER Monate reicht
          if(f.id==="sys_alter"||f.id==="sf6"||f.id==="sf6b"||(f.label||"").toLowerCase().startsWith("alter")){
            const jahre=formData[tier.id+"_"+f.id];
            const monate=formData[tier.id+"_sys_alter_monate"]||getTierField(tier.id,"sys_alter_monate");
            if(!jahre&&!monate){e[tier.id+"_"+f.id]=lang==="en"?"Please enter age (years or months)":"Bitte Alter angeben (Jahre oder Monate)";}
          } else {
            const val=formData[tier.id+"_"+f.id];
            if(!val){e[tier.id+"_"+f.id]=t.required;}
          }
        });
      } else {
        if(!formData[f.id]){e[f.id]=t.required;}
      }
    });
    // E-Mail pruefen: Aufbau und die haeufigsten Vertipper in der Endung.
    // Ohne gueltige Adresse kommt weder beim Kunden noch bei uns etwas an.
    const mailFeld=activeFelder.find(f=>f.id==="sys_email"||f.type==="email");
    if(mailFeld&&formData[mailFeld.id]&&!e[mailFeld.id]){
      const adr=String(formData[mailFeld.id]).trim();
      const aufbau=/^[^\s@]+@[^\s@.]+(\.[^\s@.]+)+$/.test(adr);
      if(!aufbau){
        e[mailFeld.id]=lang==="en"?"Please check the e-mail address":"Bitte E-Mail-Adresse prüfen";
      }else{
        const endung=adr.split(".").pop().toLowerCase();
        const bekannt=["de","com","net","org","at","ch","eu","io","info","biz","email","me","co","uk","fr","it","es","nl","be","dk","se","pl","cz"];
        const vertipper={neg:"net",ent:"net",ner:"net",nte:"net",con:"com",comm:"com",cim:"com",xom:"com",vom:"com",cm:"com",dw:"de",ed:"de",du:"de",se:null,dr:"de"};
        if(vertipper[endung]){
          e[mailFeld.id]=lang==="en"
            ?`Did you mean .${vertipper[endung]}? (.${endung} does not exist)`
            :`Meintest du .${vertipper[endung]}? Die Endung .${endung} gibt es nicht.`;
        }else if(!bekannt.includes(endung)&&endung.length<2){
          e[mailFeld.id]=lang==="en"?"Please check the e-mail address":"Bitte E-Mail-Adresse prüfen";
        }
      }
    }
    setErrors(e);
    return Object.keys(e).length===0;
  }

  function handleSubmit(){
    if(!geschenkModus&&!signature){alert(t.pleaseSign);return;}
    // Tierdaten aus separaten States zusammenführen
    const allTierData=tiere.map((tier,i)=>{
      const td={};
      activeFelder.filter(isTierFeld).forEach(f=>{td[f.id]=formData[tier.id+"_"+f.id]||"";});
      return td;
    });
    const stornoToken=uid()+uid(); // zufälliger Token für Stornierungslink
    const booking={
      id:uid(),
      shootingType:st.name,
      datum:selectedDate,
      uhrzeit:selectedSlot,
      vorOrt:vorOrtModus,
      tiere:allTierData,
      formData:geschenkModus?{...formData,sys_vorname:beschenkteAngaben.besteller,sys_name:beschenkteAngaben.besteller,beschenkte_name:beschenkteAngaben.name,beschenkte_email:beschenkteAngaben.email,beschenkte_handy:beschenkteAngaben.handy,_geschenk:true}:formData,
      geschenk:geschenkModus?{name:beschenkteAngaben.name,email:beschenkteAngaben.email,handy:beschenkteAngaben.handy}:undefined,
      signature,
      lang,
      timestamp:new Date().toISOString(),
      status:"neu",
      stornoToken,
      // Betrag mitschicken, damit Mail und PDF denselben Preis zeigen wie
      // der Zahlungsschritt (Shootinggebuehr plus Aufpreis je weiterem Hund).
      preis:preisGesamt,
      preisAufschluesselung:{
        grund:Number(st?.preis)||0,
        weitereHunde:Math.max(0,(allTierData?.length||1)-1),
        proWeiterenHund:Number(st?.preisWeitererHund)||0,
      },
    };
    setSubmitted(true);
    setStep("done");
    if(onBooked){
      Promise.resolve(onBooked(booking)).then(res=>{
        if(res&&res.pdf_base64){setConfirmPdf({data:res.pdf_base64,name:res.filename||"Anmeldung.pdf"});}
      }).catch(()=>{});
    }
  }

  const groupedSlots={};
  (st.slots||[]).forEach(s=>{
    const d=new Date(s.datum);
    if(d<new Date())return;
    groupedSlots[s.datum]=s.zeiten.filter(z=>!s.booked?.includes(z));
  });
  const hasSlots=Object.keys(groupedSlots).length>0;

  const pageStyle={minHeight:"100vh",background:"#f5f3ef",fontFamily:"Inter,system-ui,sans-serif",color:"#1a1814"};
  // Vor-Ort-Modus (Spontanbuchung am Tablet): volle Breite in Hoch- und Querformat
  const cardStyle={background:"#fff",borderRadius:16,padding:28,boxShadow:"0 2px 20px rgba(0,0,0,0.08)",maxWidth:vorOrtModus?"100%":560,margin:"0 auto"};
  const inpStyle={background:"#f5f3ef",border:"1px solid #e0ddd8",borderRadius:8,padding:"10px 14px",color:"#1a1814",fontSize:14,fontFamily:"inherit",outline:"none",boxSizing:"border-box",width:"100%",boxSizing:"border-box"};
  // Gesamtpreis: Shootinggebuehr plus Aufpreis fuer jedes weitere Tier.
  const preisGesamt=(Number(st?.preis)||0)
    +Math.max(0,(tiere?.length||1)-1)*(Number(st?.preisWeitererHund)||0);
  const hatPreis=!!(st&&Number(st.preis)>0)&&!vorOrtModus&&!einloesenModus&&(st.zahlungsart!=="vorort");
  const steps=geschenkModus?[...(!vorOrtModus?["slots"]:[]),"geschenk_angaben",...(hatPreis?["zahlung"]:[])]:([...(vorOrtModus||(einloesenModus&&prefilledSlot)?[]:["slots"]),"form","sign",...(hatPreis?["zahlung"]:[])]);
  const stepLabels=geschenkModus?{de:[...(!vorOrtModus?["Termin"]:[]),"Beschenkte",...(hatPreis?["Bezahlung"]:[])],en:[...(!vorOrtModus?["Date"]:[]),"Recipient",...(hatPreis?["Payment"]:[])]}:{de:[...(vorOrtModus||(einloesenModus&&prefilledSlot)?[]:["Termin"]),"Angaben","Vereinbarung",...(hatPreis?["Bezahlung"]:[])],en:[...(vorOrtModus||(einloesenModus&&prefilledSlot)?[]:["Date"]),"Details","Agreement",...(hatPreis?["Payment"]:[])]};

  // ── Landingpage-Modus ────────────────────────────────────────────
  if(showLanding){
    const ev=(config.events||[]).find(e=>e.id===st.eventId)||{};
    const a=ev.adresse||{};
    const ortZeilen=[ev.location,a.strasse,[a.plz,a.ort].filter(Boolean).join(" ")].filter(Boolean);
    const beschr=(st.hp_beschreibung||"").trim();
    const beschrIsHtml=/<[a-z]/i.test(beschr);
    const beschrClean=beschr.replace(/^(<br\s*\/?>\s*)+/i,"").replace(/(\s*<br\s*\/?>)+$/i,"");
    const beschrZeilen=(!beschrIsHtml&&beschr)?beschr.split("\n").map(z=>z.trim()).filter(Boolean).map(z=>z.replace(/^[•\-]\s*/,"")):[];
    const datumStr=(()=>{if(!ev.date)return"";const fmt=(d,y)=>new Date(d).toLocaleDateString("de-DE",{day:"2-digit",month:"long",...(y?{year:"numeric"}:{})});if(ev.dateBis&&ev.dateBis!==ev.date){const y1=new Date(ev.date).getFullYear(),y2=new Date(ev.dateBis).getFullYear();return y1===y2?fmt(ev.date,false)+" – "+fmt(ev.dateBis,true):fmt(ev.date,true)+" – "+fmt(ev.dateBis,true);}return fmt(ev.date,true);})();
    const mapQ=[a.strasse,[a.plz,a.ort].filter(Boolean).join(" ")].filter(Boolean).join(", ");
    const mapSrc=mapQ?`https://maps.google.com/maps?q=${encodeURIComponent(mapQ)}&output=embed`:"";
    return(
      <div style={{fontFamily:"inherit",background:"#F8F5F0",minHeight:"100vh",color:"#1a1814"}}>
        {/* Header */}
        <div style={{background:"#1a1814",padding:`clamp(12px, 3.5vw, ${Math.max(20,Math.round((st.style?.logoHeight||150)*0.2))}px) 24px`,textAlign:"center"}}>
          {config.logo
            ?<img src={(()=>{const bg=config.heroBg||"#1a1814";const hex=bg.replace("#","");const lum=(parseInt(hex.substr(0,2),16)*0.299+parseInt(hex.substr(2,2),16)*0.587+parseInt(hex.substr(4,2),16)*0.114);return lum>128?(config.logoDark||config.logo):config.logo;})()}  alt={config.studioName||""} style={{height:"auto",width:"auto",maxHeight:st.style?.logoHeight||150,maxWidth:`min(${st.style?.logoMaxWidth||500}px, 50vw)`,objectFit:"contain",display:"block",margin:"0 auto"}}/>
            :<div style={{fontFamily:"Georgia,serif",fontSize:16,color:primaryColor,letterSpacing:"0.08em"}}>{config.studioName||"STUDIO"}</div>
          }
        </div>
        {/* Inhalt */}
        <div style={{maxWidth:vorOrtModus?1000:960,margin:"0 auto",padding:vorOrtModus?"28px 16px 48px":"48px 24px 72px"}}>
          <div style={{fontFamily:"Georgia,serif",fontSize:"clamp(24px,4vw,38px)",fontWeight:400,color:"#1a1814",textAlign:"center",marginBottom:st.hp_slogan?8:36,lineHeight:1.2}}>{st.name}</div>
          {st.hp_slogan&&<div style={{textAlign:"center",fontSize:15,color:"#8A8075",fontStyle:"italic",marginBottom:36}} dangerouslySetInnerHTML={{__html:st.hp_slogan}}/>}
          {/* Datum+Ort links, Karte rechts */}
          <div style={{display:"grid",gridTemplateColumns:"1fr 1.6fr",gap:16,marginBottom:16,alignItems:"stretch",minHeight:240}}>
            <div style={{background:"#fff",border:"1px solid #e8e4de",padding:"22px 24px",display:"flex",flexDirection:"column",gap:20}}>
              {datumStr&&<div>
                <div style={{fontSize:9,letterSpacing:"0.12em",textTransform:"uppercase",color:primaryColor,marginBottom:8}}>Datum</div>
                <div style={{display:"flex",alignItems:"flex-start",gap:8,fontSize:14,color:"#1a1814",lineHeight:1.5}}>
                  <svg width="14" height="14" style={{flexShrink:0,marginTop:2,opacity:0.4}} viewBox="0 0 24 24" fill="none" stroke="#1a1814" strokeWidth="1.5" strokeLinecap="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
                  <span>{datumStr}</span>
                </div>
              </div>}
              {ortZeilen.length>0&&<div>
                <div style={{fontSize:9,letterSpacing:"0.12em",textTransform:"uppercase",color:primaryColor,marginBottom:8}}>Ort</div>
                {ortZeilen.map((z,i)=><div key={i} style={{display:"flex",alignItems:"flex-start",gap:8,fontSize:14,color:"#1a1814",lineHeight:1.5,marginBottom:4}}>
                  <svg width="14" height="14" style={{flexShrink:0,marginTop:2,opacity:0.4}} viewBox="0 0 24 24" fill="none" stroke="#1a1814" strokeWidth="1.5" strokeLinecap="round"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/><circle cx="12" cy="9" r="2.5"/></svg>
                  <span>{z}</span>
                </div>)}
              </div>}
            </div>
            {mapSrc
              ?<div style={{border:"1px solid #e8e4de",overflow:"hidden",position:"relative"}}>
                <iframe src={mapSrc} style={{position:"absolute",top:0,left:0,width:"100%",height:"100%",border:"none"}} allowFullScreen loading="lazy"/>
              </div>
              :<div style={{background:"#e8e4de",border:"1px solid #e0ddd8",display:"flex",alignItems:"center",justifyContent:"center",color:"#8A8075",fontSize:13}}>Keine Adresse hinterlegt</div>
            }
          </div>
          {/* Infos */}
          {(beschrZeilen.length>0||beschrIsHtml)&&<div style={{background:"#fff",border:"1px solid #e8e4de",padding:"20px 24px",marginBottom:16}}>
            <div style={{fontSize:9,letterSpacing:"0.12em",textTransform:"uppercase",color:primaryColor,marginBottom:12}}>Infos</div>
            {beschrIsHtml
              ?<div style={{fontSize:14,color:"#3a3630",lineHeight:1.6}} dangerouslySetInnerHTML={{__html:beschrClean}}/>
              :<div style={{display:"flex",flexDirection:"column",gap:0}}>
              {beschrZeilen.map((z,i)=><div key={i} style={{display:"flex",alignItems:"flex-start",gap:10,fontSize:14,color:"#3a3630",lineHeight:1.5,paddingBottom:8,marginBottom:i<beschrZeilen.length-1?0:0,borderBottom:i<beschrZeilen.length-1?"1px solid #f0ede8":"none"}}>
                <div style={{width:5,height:5,borderRadius:"50%",background:primaryColor,flexShrink:0,marginTop:6}}/>
                <span>{z}</span>
              </div>)}
            </div>}
          </div>}
          {/* CTA */}
          <div style={{background:"#1a1814",padding:"22px 28px",display:"flex",alignItems:"center",justifyContent:"space-between",gap:16,flexWrap:"wrap"}}>
            <div>
              <div style={{fontFamily:"Georgia,serif",fontSize:17,color:"#fff",fontWeight:400,marginBottom:4}}>Jetzt Termin sichern</div>
              <div style={{fontSize:13,color:"#aaa"}}>Wähle deinen Wunschtermin und buche entspannt vor.</div>
            </div>
            <button onClick={()=>setShowLanding(false)} style={{background:primaryColor,color:"#fff",fontFamily:"inherit",fontSize:11,fontWeight:400,letterSpacing:"0.12em",textTransform:"uppercase",padding:"13px 32px",border:"none",cursor:"pointer",whiteSpace:"nowrap"}}>
              Termin buchen →
            </button>
          </div>
        </div>
      </div>
    );
  }

  return(
    <div style={pageStyle}>
      {/* Header */}
      <div style={{background:"#1a1814",padding:"16px 24px",display:"flex",alignItems:"center",justifyContent:"center",position:"relative"}}>
        <div style={{textAlign:"center"}}>
          {config.logo
            ? <img src={(()=>{const bg=config.heroBg||"#1a1814";const hex=bg.replace("#","");const lum=(parseInt(hex.substr(0,2),16)*0.299+parseInt(hex.substr(2,2),16)*0.587+parseInt(hex.substr(4,2),16)*0.114);return lum>128?(config.logoDark||config.logo):config.logo;})()}  alt={config.studioName||"Logo"} style={{height:"auto",width:"auto",maxHeight:st.style?.logoHeight||150,maxWidth:`min(${st.style?.logoMaxWidth||500}px, 50vw)`,objectFit:"contain",display:"block",margin:"0 auto"}}/>
            : <div style={{fontFamily:"Georgia,serif",fontSize:st.style?.logoFontSize||20,color:primaryColor,letterSpacing:"0.05em"}}>{config.studioName||"STUDIO"}</div>
          }
          {!config.logo&&<div style={{fontSize:11,color:"#7A7570"}}>{config.studioName}</div>}
        </div>
        <div style={{display:"flex",gap:6,position:"absolute",right:16,bottom:10}}>
          {(config.sprachen||["de","en"]).map(l=>(
            <button key={l} onClick={()=>setLang(l)}
              style={{padding:"4px 10px",borderRadius:6,border:`1px solid ${lang===l?primaryColor:"#3a3a3a"}`,background:lang===l?primaryColor+"22":"transparent",color:lang===l?primaryColor:"#7A7570",fontSize:12,cursor:"pointer",fontFamily:"inherit",fontWeight:lang===l?600:400}}>
              {l.toUpperCase()}
            </button>
          ))}
        </div>
      </div>

      <div style={{maxWidth:vorOrtModus?1000:960,margin:"0 auto",padding:"32px 16px"}}>
        {/* Shooting Type Header */}
        <div style={{textAlign:"center",marginBottom:28}}>
          <div style={{fontFamily:"Georgia,serif",fontSize:st.style?.titelSize||28,color:"#1a1814",marginBottom:6}}>{st.name}</div>
          {(()=>{
            // Mehrtages-Datum aus verknüpftem Event
            const ev=(config?.events||[]).find(e=>e.id===st.eventId)||null;
            if(ev?.date){
              const fmt=(d,withY)=>new Date(d).toLocaleDateString(lang==="en"?"en-GB":"de-DE",{day:"2-digit",month:"long",...(withY?{year:"numeric"}:{})});
              const datumStr=ev.dateBis&&ev.dateBis!==ev.date
                ?`${fmt(ev.date,false)} – ${fmt(ev.dateBis,true)}`
                :fmt(ev.date,true);
              return <div style={{fontSize:13,color:"#8A8075",marginBottom:6}}>{datumStr}</div>;
            }
            return null;
          })()}
          {(()=>{const bt=st.beschreibung?.[lang]||st.beschreibung?.de||"";const btClean=bt.replace(/^(<br\s*\/?>\s*)+/i,"").replace(/(\s*<br\s*\/?>)+$/i,"");if(!btClean.trim())return null;return /<[a-z]/i.test(btClean)?<div style={{fontSize:st.style?.beschrSize||14,color:"#8A8075",maxWidth:440,margin:"0 auto",lineHeight:1.6}} dangerouslySetInnerHTML={{__html:btClean}}/>:<div style={{fontSize:st.style?.beschrSize||14,color:"#8A8075",maxWidth:440,margin:"0 auto",lineHeight:1.6,whiteSpace:"pre-line"}}>{btClean}</div>;})()}
        </div>

        {/* Step indicator */}
        {step!=="done"&&(
          <div style={{display:"flex",alignItems:"center",justifyContent:"center",gap:0,marginBottom:28,maxWidth:400,margin:"0 auto 28px"}}>
            {steps.map((s,i)=>(
              <div key={s} style={{display:"flex",alignItems:"center",flex:1}}>
                <div style={{display:"flex",flexDirection:"column",alignItems:"center",flex:1}}>
                  <div style={{width:32,height:32,borderRadius:"50%",background:step===s?primaryColor:steps.indexOf(step)>i?"#1a1814":"#e0ddd8",color:step===s?"#1a1814":steps.indexOf(step)>i?primaryColor:"#8A8075",display:"flex",alignItems:"center",justifyContent:"center",fontSize:13,fontWeight:700,transition:"all 0.3s"}}>{i+1}</div>
                  <div style={{fontSize:10,color:step===s?"#1a1814":"#8A8075",marginTop:4,fontWeight:step===s?600:400}}>{stepLabels[lang]?.[i]||stepLabels.de[i]}</div>
                </div>
                {i<steps.length-1&&<div style={{height:2,background:steps.indexOf(step)>i?primaryColor:"#e0ddd8",flex:2,transition:"background 0.3s"}}/>}
              </div>
            ))}
          </div>
        )}

        <div style={cardStyle}>
          {/* STEP 1: Zeitslots */}
          {step==="slots"&&(
            <div>
              <div style={{fontFamily:"Georgia,serif",fontSize:18,color:"#1a1814",marginBottom:20}}>{t.slots}</div>
              {/* Info-Text über Zeitslots */}
              {(()=>{const infoText=st.slotInfo?.[lang]||st.slotInfo?.de||"";if(!infoText.trim())return null;
                const isHtml=/<[a-z]/i.test(infoText);
                const infoClean=infoText.replace(/^(<br\s*\/?>\s*)+/i,"").replace(/(\s*<br\s*\/?>)+$/i,"");
                if(isHtml){
                  return <div style={{background:"#f5f3ef",borderRadius:10,padding:"14px 16px",marginBottom:20,fontSize:13,color:"#1a1814",lineHeight:1.7}} dangerouslySetInnerHTML={{__html:infoClean}}/>;
                }
                const lines=infoText.split("\n").filter(l=>l.trim());
                return(
                  <div style={{background:"#f5f3ef",borderRadius:10,padding:"14px 16px",marginBottom:20,borderLeft:`3px solid ${primaryColor}`}}>
                    {lines.map((line,i)=>(
                      <div key={i} style={{display:"flex",alignItems:"flex-start",gap:8,fontSize:13,color:"#1a1814",lineHeight:1.7,marginBottom:i<lines.length-1?4:0}}>
                        <span style={{color:primaryColor,fontWeight:700,marginTop:1,flexShrink:0}}>·</span>
                        <span>{line.trim()}</span>
                      </div>
                    ))}
                  </div>
                );
              })()}
              {!hasSlots?(
                <div style={{textAlign:"center",padding:32,color:"#8A8075"}}>{t.noSlots}</div>
              ):(
                Object.entries(groupedSlots).sort().map(([datum,zeiten])=>{
                  const d=new Date(datum);
                  const dayName=d.toLocaleDateString(lang==="en"?"en-GB":"de-DE",{weekday:"long",day:"2-digit",month:"long",year:"numeric"});
                  return(
                    <div key={datum} style={{marginBottom:20}}>
                      <div style={{fontSize:13,fontWeight:600,color:"#1a1814",marginBottom:10,paddingBottom:6,borderBottom:"1px solid #e0ddd8"}}>{dayName}</div>
                      <div style={{display:"flex",flexWrap:"wrap",gap:8}}>
                        {zeiten.map(z=>{
                          const isSel=selectedDate===datum&&selectedSlot===z;
                          return(
                            <button key={z} onClick={()=>{setSelectedDate(datum);setSelectedSlot(z);}}
                              style={{padding:"8px 16px",borderRadius:8,border:`2px solid ${isSel?primaryColor:"#e0ddd8"}`,background:isSel?primaryColor+"22":"#fff",color:isSel?primaryColor:"#1a1814",fontSize:13,fontWeight:isSel?600:400,cursor:"pointer",fontFamily:"inherit",transition:"all 0.15s"}}>
                              {z}
                            </button>
                          );
                        })}
                      </div>
                    </div>
                  );
                })
              )}
              {hasSlots&&(
                <div style={{display:"flex",justifyContent:"flex-end",marginTop:20}}>
                  <button onClick={()=>{if(!selectedSlot&&!geschenkModus){alert(lang==="en"?"Please select a time.":"Bitte eine Uhrzeit wählen.");return;}if(geschenkModus){setStep("geschenk_angaben");}else{setStep("form");}}}
                    style={{padding:"10px 24px",borderRadius:8,border:"none",background:primaryColor,color:"#1a1814",fontSize:14,fontWeight:600,cursor:"pointer",fontFamily:"inherit"}}>
                    {geschenkModus&&!selectedSlot?(lang==="en"?"Continue without a date":"Ohne Termin weiter"):t.next}
                  </button>
                </div>
              )}
              {geschenkModus&&(
                <div style={{fontSize:12,color:"#8A8075",textAlign:"right",marginTop:8}}>
                  {lang==="en"
                    ?"Optional — the recipient can pick a date later."
                    :"Termin ist freiwillig. Die beschenkte Person kann ihn auch später aussuchen."}
                </div>
              )}
            </div>
          )}

          {/* STEP 2: Formular */}
          {step==="geschenk_angaben"&&(
            <div style={{animation:"fadeIn 0.3s"}}>
              <h3 style={{fontFamily:"Georgia,serif",color:primaryColor,marginBottom:8,fontSize:16}}>🎁 Angaben zur beschenkten Person</h3>
              <p style={{fontSize:13,color:"#8A8075",marginBottom:20}}>Bitte gib Name und Handynummer der beschenkten Person an. Die Shooting-Vereinbarung schicken wir nach Rücksprache mit dir zu.</p>
              <div style={{marginBottom:14}}>
                <label style={{fontSize:12,color:"#8A8075",fontWeight:600,display:"block",marginBottom:5}}>Ihr Name (Besteller) *</label>
                <input type="text" value={beschenkteAngaben.besteller} onChange={e=>setBeschenkteAngaben(p=>({...p,besteller:e.target.value}))}
                  placeholder="Ihr Vorname" style={{...inpStyle}}/>
              </div>
              <div style={{borderTop:"1px solid #e0ddd8",margin:"16px 0 16px",paddingTop:4}}><span style={{fontSize:11,color:"#8A8075",fontWeight:600,textTransform:"uppercase",letterSpacing:"0.05em"}}>Angaben zur beschenkten Person</span></div>
              {[
                {k:"name",label:"Name der Beschenkten",ph:"Vorname Nachname",type:"text",req:true},
                {k:"handy",label:"Handynummer der Beschenkten",ph:"+49 171 ...",type:"tel",req:true},
                {k:"email",label:"E-Mail der Beschenkten (optional)",ph:"email@beispiel.de",type:"email",req:false},
              ].map(({k,label,ph,type,req})=>(
                <div key={k} style={{marginBottom:14}}>
                  <label style={{fontSize:12,color:"#8A8075",fontWeight:600,display:"block",marginBottom:5}}>{label}{req?" *":""}</label>
                  <input type={type} value={beschenkteAngaben[k]} onChange={e=>setBeschenkteAngaben(p=>({...p,[k]:e.target.value}))}
                    placeholder={ph} style={{...inpStyle}}/>
                </div>
              ))}
              <button onClick={()=>{
                if(!beschenkteAngaben.besteller.trim()){alert("Bitte Ihren Namen eingeben.");return;}
                if(!beschenkteAngaben.name.trim()){alert("Bitte den Namen der Beschenkten eingeben.");return;}
                if(!beschenkteAngaben.handy.trim()){alert("Bitte die Handynummer der Beschenkten eingeben.");return;}
                handleSubmit();
                setStep(hatPreis?"zahlung":"done");
              }} style={{width:"100%",padding:"14px",borderRadius:10,border:"none",background:primaryColor,color:"#1a1814",fontSize:15,fontWeight:700,cursor:"pointer",fontFamily:"inherit",marginTop:8}}>
                {hatPreis?"Weiter zur Bezahlung →":"Buchung abschließen"}
              </button>
              <button onClick={()=>setStep("slots")} style={{background:"none",border:"none",color:"#8A8075",cursor:"pointer",fontSize:13,fontFamily:"inherit",marginTop:12,display:"block",textAlign:"center",width:"100%"}}>{t.back}</button>
            </div>
          )}
          {step==="form"&&(
            <div>
              <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:20}}>
                {!vorOrtModus&&<button onClick={()=>setStep("slots")} style={{background:"none",border:"none",color:"#8A8075",cursor:"pointer",fontSize:13,fontFamily:"inherit"}}>{t.back}</button>}
                <div style={{fontFamily:"Georgia,serif",fontSize:18,color:"#1a1814",flex:1}}>{t.yourData}</div>
              </div>
              <div style={{background:"#f5f3ef",borderRadius:8,padding:"10px 14px",marginBottom:20,fontSize:12,color:"#8A8075"}}>
                📅 {vorOrtModus?(lang==="en"?"On site":"Vor Ort"):`${new Date(selectedDate).toLocaleDateString(lang==="en"?"en-GB":"de-DE",{weekday:"long",day:"2-digit",month:"long"})} · ${selectedSlot}`} · {st.name}
              </div>
              {(()=>{
                const kundenFelder=activeFelder.filter(f=>!isTierFeld(f));
                const tierFelder=activeFelder.filter(isTierFeld);
                function renderField(f,val,onChange,errKey){
                  // sys_alter_monate wird inline neben Alter gerendert — hier überspringen
                  if(f.id==="sys_alter_monate")return null;
                  // sys_name als zwei getrennte Felder (Vorname / Nachname); sys_name bleibt als "Vorname Nachname" zusammengesetzt.
                  // ID kann bei event-basierten Typen "sys_name_<eventId>_<i>" lauten oder das Label ist schlicht "Name" — alle Varianten abdecken.
                  if(f.id==="sys_name"||f.id.startsWith("sys_name_")||(!isTierFeld(f)&&(f.labelDe||f.label||"").trim().toLowerCase()==="name")){
                    const vorname=formData["sys_vorname"]||"";
                    const nachname=formData["sys_nachname"]||"";
                    const setVN=(vn,nn)=>{const full=(vn+" "+nn).trim();setFormData(fd=>({...fd,sys_vorname:vn,sys_nachname:nn,sys_name:full,[f.id]:full}));};
                    const lblN=lang==="en"?(f.labelEn||f.label):f.labelDe||f.label;
                    return(
                      <div key={f.id}>
                        <label style={{fontSize:12,color:"#8A8075",fontWeight:600,display:"block",marginBottom:5}}>
                          {lblN}{f.required&&<span style={{color:"#C0655A",marginLeft:3}}>*</span>}
                        </label>
                        <div style={{display:"flex",gap:8}}>
                          <input type="text" value={vorname} onChange={e=>setVN(e.target.value,nachname)} placeholder={lang==="en"?"First name":"Vorname"} style={inpStyle}/>
                          <input type="text" value={nachname} onChange={e=>setVN(vorname,e.target.value)} placeholder={lang==="en"?"Last name":"Nachname"} style={inpStyle}/>
                        </div>
                        {errors[errKey]&&<div style={{fontSize:11,color:"#C0655A",marginTop:3}}>⚠ {errors[errKey]}</div>}
                      </div>
                    );
                  }
                  const lbl=lang==="en"?(f.labelEn||f.label):f.labelDe||f.label;
                  const placeholder=f.placeholder?.[lang]||f.placeholder?.de||"";
                  return(
                    <div key={f.id}>
                      <label style={{fontSize:12,color:"#8A8075",fontWeight:600,display:"block",marginBottom:5}}>
                        {lbl}{f.required&&<span style={{color:"#C0655A",marginLeft:3}}>*</span>}
                      </label>
                      {f.type==="select"&&(<select value={val} onChange={e=>onChange(e.target.value)} style={inpStyle}><option value="">— Bitte auswählen —</option>{(f.options||[]).map(o=><option key={o} value={o}>{o}</option>)}</select>)}
                      {f.type==="radio"&&(
                        <div style={{display:"flex",gap:6,paddingTop:4,flexWrap:"wrap"}}>
                          {(f.options||[]).map(o=>(
                            <label key={o} onClick={()=>onChange(o)}
                              style={{display:"flex",alignItems:"center",gap:6,cursor:"pointer",fontSize:13,
                                color:val===o?"#1a1814":"#8A8075",fontWeight:val===o?600:400,
                                padding:"5px 10px",borderRadius:8,
                                border:`2px solid ${val===o?primaryColor:"#e0ddd8"}`,
                                background:val===o?primaryColor+"22":"transparent",
                                transition:"all 0.15s",userSelect:"none",whiteSpace:"nowrap"}}>
                              <span style={{width:14,height:14,borderRadius:"50%",border:`2px solid ${val===o?primaryColor:"#ccc"}`,display:"inline-flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                                {val===o&&<span style={{width:6,height:6,borderRadius:"50%",background:primaryColor,display:"block"}}/>}
                              </span>
                              {o}
                            </label>
                          ))}
                        </div>
                      )}
                      {f.type==="checkbox"&&(<label style={{display:"flex",alignItems:"center",gap:8,cursor:"pointer",fontSize:14}}><input type="checkbox" checked={!!val} onChange={e=>onChange(e.target.checked)} style={{accentColor:primaryColor,width:16,height:16}}/>{f.checkboxLabel?.[lang]||f.checkboxLabel?.de||lbl}</label>)}
                      {f.type==="textarea"&&(<textarea value={val} onChange={e=>onChange(e.target.value)} placeholder={placeholder} style={{...inpStyle,resize:"vertical",minHeight:80}}/>)}
                      {!["select","radio","checkbox","textarea"].includes(f.type)&&(
                        (f.id==="sys_alter"||f.id==="sf6"||f.id==="sf6b"||(f.label||"").toLowerCase().startsWith("alter"))?(
                          <div style={{display:"flex",gap:8}}>
                            <div style={{flex:1}}>
                              <input type="text" inputMode="numeric" value={val} onChange={e=>{const v=e.target.value.replace(/[^0-9]/g,"");onChange(v);}} placeholder={placeholder||"Jahre"}
                                style={{...inpStyle,textAlign:"center"}}/>
                              <div style={{fontSize:10,color:"#8A8075",textAlign:"center",marginTop:3}}>Jahre</div>
                            </div>
                            <div style={{flex:1}}>
                              {(()=>{
                                // errKey format: "tierId_fieldId" for tier fields, else "fieldId"
                                const _tId=errKey&&errKey.includes("_")&&errKey!==f.id?errKey.split("_").slice(0,-1).join("_"):null;
                                const _val=_tId?getTierField(_tId,"sys_alter_monate")||"":formData["sys_alter_monate"]||"";
                                const _onChange=e=>{if(_tId)setTierField(_tId,"sys_alter_monate",e.target.value);else setField("sys_alter_monate",e.target.value);};
                                const _monateFeld=activeFelder.find(x=>x.id==="sys_alter_monate");const _mp=_monateFeld?.placeholder?.[lang]||_monateFeld?.placeholder?.de||"Monate";return <input type="text" inputMode="numeric" value={_val} onChange={e=>{const v=e.target.value.replace(/[^0-9]/g,"");if(v===""||parseInt(v)<=11)_onChange({target:{value:v}});}} placeholder={_mp} style={{...inpStyle,textAlign:"center"}}/>;
                              })()}
                              <div style={{fontSize:10,color:"#8A8075",textAlign:"center",marginTop:3}}>Monate</div>
                            </div>
                          </div>
                        ):((f.labelDe||f.label||"").toLowerCase().includes("rasse")?(
                          (()=>{
                            const _rl=(config&&Array.isArray(config.rassenListe)&&config.rassenListe.length?config.rassenListe:DEFAULT_RASSEN);
                            return <RasseFeld liste={_rl} val={val} onChange={onChange} placeholder={placeholder} style={inpStyle}/>;
                          })()
                        ):(
                          <input type={f.type} value={val} onChange={e=>onChange(e.target.value)} placeholder={placeholder} style={inpStyle}/>
                        ))
                      )}
                      {errors[errKey]&&<div style={{fontSize:11,color:"#C0655A",marginTop:3}}>⚠ {errors[errKey]}</div>}
                    </div>
                  );
                }
                return(
                  <div style={{display:"flex",flexDirection:"column",gap:14}}>
                    {/* Kundendaten */}
                    {kundenFelder.map(f=>renderField(f,formData[f.id]||"",v=>setField(f.id,v),f.id))}
                    {/* Tierdaten */}
                    {tierFelder.length>0&&(
                      <div>
                        <div style={{fontSize:13,fontWeight:600,color:"#1a1814",marginBottom:10,marginTop:6,paddingTop:14,borderTop:"1px solid #e0ddd8"}}>
                          🐾 {lang==="en"?"Pet details":"Tierdaten"}
                        </div>
                        {tiere.map((tier,tidx)=>(
                          <div key={tier.id} style={{background:"#f5f3ef",borderRadius:10,padding:14,marginBottom:12,position:"relative"}}>
                            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10}}>
                              <div style={{fontSize:12,fontWeight:600,color:primaryColor}}>
                                {lang==="en"?`Pet ${tidx+1}`:`Tier ${tidx+1}`}
                              </div>
                              {tiere.length>1&&(
                                <button onClick={()=>removeTier(tier.id)}
                                  style={{background:"none",border:"none",cursor:"pointer",color:"#C0655A",fontSize:18,lineHeight:1,padding:"0 4px"}}>×</button>
                              )}
                            </div>
                            <div style={{display:"flex",flexDirection:"column",gap:12}}>
                              {tierFelder.map(f=>renderField(
                                f,
                                getTierField(tier.id,f.id),
                                v=>setTierField(tier.id,f.id,v),
                                tier.id+"_"+f.id
                              ))}
                            </div>
                          </div>
                        ))}
                        <button onClick={addTier}
                          style={{display:"flex",alignItems:"center",gap:8,padding:"10px 16px",borderRadius:10,border:`2px dashed ${primaryColor}`,background:"transparent",color:primaryColor,fontSize:13,fontWeight:600,cursor:"pointer",fontFamily:"inherit",width:"100%",justifyContent:"center"}}>
                          + {lang==="en"?"Add another pet":"Weiteres Tier hinzufügen"}
                        </button>
                      </div>
                    )}
                  </div>
                );
              })()}
              {/* Newsletter Opt-in */}
              <label style={{display:"flex",alignItems:"flex-start",gap:14,marginTop:24,cursor:"pointer",
                background:formData["sys_newsletter"]?primaryColor+"22":"#faf8f4",
                border:`2px solid ${formData["sys_newsletter"]?primaryColor:"#e0ddd8"}`,
                borderRadius:12,padding:"18px 20px",transition:"background .15s,border-color .15s"}}>
                <input type="checkbox" checked={!!formData["sys_newsletter"]}
                  onChange={e=>setFormData(p=>({...p,sys_newsletter:e.target.checked}))}
                  style={{accentColor:primaryColor,width:24,height:24,marginTop:2,cursor:"pointer",flexShrink:0}}/>
                <span style={{display:"block"}}>
                  <span style={{display:"block",fontSize:15,fontWeight:700,color:"#1a1814",marginBottom:4}}>
                    {lang==="en"?"✉ Yes, keep me posted":"✉ Ja, haltet mich auf dem Laufenden"}
                  </span>
                  <span style={{display:"block",fontSize:13,color:"#5a544c",lineHeight:1.55}}>
                    {lang==="en"
                      ?"Newsletter with upcoming events and offers. Can be cancelled anytime."
                      :"Newsletter mit kommenden Veranstaltungen und Angeboten. Jederzeit abbestellbar."}
                  </span>
                </span>
              </label>
              <div style={{display:"flex",justifyContent:"flex-end",marginTop:18}}>
                <button onClick={()=>{if(validateForm())setStep("sign");}}
                  style={{padding:"10px 24px",borderRadius:8,border:"none",background:primaryColor,color:"#1a1814",fontSize:14,fontWeight:600,cursor:"pointer",fontFamily:"inherit"}}>
                  {t.next}
                </button>
              </div>
            </div>
          )}

          {/* STEP 3: Vereinbarung + Unterschrift */}
          {step==="sign"&&(
            <div>
              <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:20}}>
                <button onClick={()=>setStep("form")} style={{background:"none",border:"none",color:"#8A8075",cursor:"pointer",fontSize:13,fontFamily:"inherit"}}>{t.back}</button>
                <div style={{fontFamily:"Georgia,serif",fontSize:18,color:"#1a1814"}}>{t.sign}</div>
              </div>
              {/* Vereinbarungstext */}
              {!geschenkModus&&<div style={{background:"#f5f3ef",border:"1px solid #e0ddd8",borderRadius:8,marginBottom:20,overflow:"hidden"}}>
                <button onClick={()=>setAgreeOpen(o=>!o)} style={{width:"100%",display:"flex",alignItems:"center",justifyContent:"space-between",background:"none",border:"none",padding:16,cursor:"pointer",fontFamily:"inherit",color:"#1a1814",textAlign:"left"}}>
                  <strong>{lang==="en"?"Shooting agreement":"Shooting-Vereinbarung"}</strong>
                  <span style={{fontSize:12,color:"#8A8075"}}>{agreeOpen?(lang==="en"?"▲ hide":"▲ ausblenden"):(lang==="en"?"▼ show":"▼ anzeigen")}</span>
                </button>
                {agreeOpen&&(
                  <div style={{padding:"0 16px 16px",fontFamily:(st.vereinbarungStyle?.fontFamily||"Georgia,serif"),fontSize:(st.vereinbarungStyle?.fontSize||13),color:"#1a1814",lineHeight:(st.vereinbarungStyle?.lineHeight||1.7),textAlign:(st.vereinbarungStyle?.align||"left"),maxHeight:260,overflowY:"auto"}}>
                    <div dangerouslySetInnerHTML={{__html:mdToHtml(st.vereinbarung?.[lang]||st.vereinbarung?.de||"")}}/>
                    {formData["sys_name"]&&(
                      <div style={{marginTop:12,paddingTop:12,borderTop:"1px solid #e0ddd8",fontSize:12,color:"#8A8075"}}>
                        Auftraggeber: {formData["sys_name"]} · Termin: {vorOrtModus?(lang==="en"?"On site":"Vor Ort"):`${new Date(selectedDate).toLocaleDateString("de-DE")} ${selectedSlot}`}
                      </div>
                    )}
                  </div>
                )}
              </div>}
              {!geschenkModus&&<>
              {/* Unterschrift */}
              <div style={{marginBottom:16}}>
                <SignaturePadInline onSave={setSignature} T={null} label={lang==="en"?"Sign here":"Hier unterschreiben"}/>
              </div>
              {/* Zustimmung */}
              <label style={{display:"flex",alignItems:"flex-start",gap:10,cursor:"pointer",fontSize:13,color:"#1a1814",marginBottom:20}}>
                <input type="checkbox" checked={!!formData._agree} onChange={e=>setFormData(f=>({...f,_agree:e.target.checked}))}
                  style={{accentColor:primaryColor,width:16,height:16,marginTop:2,flexShrink:0,cursor:"pointer"}}/>
                <span>{t.agree}</span>
              </label></>}
              <button onClick={()=>{
                  if(!geschenkModus&&!formData._agree){alert(t.pleaseAgree);return;}
                  if(!geschenkModus&&!signature){alert(t.pleaseSign);return;}
                  handleSubmit();
                  setStep(hatPreis?"zahlung":"done");
                }}
                style={{width:"100%",padding:"14px",borderRadius:10,border:"none",background:primaryColor,color:"#1a1814",fontSize:15,fontWeight:700,cursor:"pointer",fontFamily:"inherit",letterSpacing:"0.02em"}}>
                {hatPreis?(lang==="en"?"Continue to payment":"Weiter zur Bezahlung"):(vorOrtModus?(lang==="en"?"Complete form":"Formular abschliessen"):(lang==="en"?"Complete booking":"Buchung abschliessen"))}
              </button>
            </div>
          )}

          {/* STEP 4: Fertig */}
          {step==="zahlung"&&(()=>{
            const z=config.zahlung||{};
            const preis=preisGesamt;
            const aufpreis=Math.max(0,(tiere?.length||1)-1)*(Number(st.preisWeitererHund)||0);
            const aktiveMethoden=[
              z.paypal?.aktiv&&"paypal",
              z.ueberweisung?.aktiv&&"ueberweisung",
              z.bar?.aktiv&&"bar",
            ].filter(Boolean);
            const methode=zahlMethode||aktiveMethoden[0]||"paypal";
            const setMethode=(v)=>setZahlMethode(v);
            const ref=`FOTO-${(formData["sys_name"]||"").split(" ").pop().toUpperCase()}-${selectedDate?.replace(/-/g,"")}-${selectedSlot?.replace(":","")}`
            return(
              <div>
                <div style={{fontFamily:"Georgia,serif",fontSize:18,color:"#1a1814",marginBottom:16}}>{t.payment}</div>
                <div style={{background:"#f5f3ef",borderRadius:8,padding:"10px 14px",marginBottom:20,fontSize:12,color:"#8A8075"}}>
                  📅 {vorOrtModus?(lang==="en"?"On site":"Vor Ort"):`${new Date(selectedDate).toLocaleDateString(lang==="en"?"en-GB":"de-DE",{weekday:"long",day:"2-digit",month:"long"})} · ${selectedSlot}`} · {st.name}
                  {preis>0&&<span style={{float:"right",fontWeight:700,color:"#1a1814",fontSize:14}}>{preis.toFixed(2)} €</span>}
                </div>
                {aufpreis>0&&(
                  <div style={{fontSize:12,color:"#8A8075",marginTop:-12,marginBottom:20}}>
                    {(Number(st.preis)||0).toFixed(2)} € {lang==="en"?"shooting":"Shooting"}
                    {" + "}{tiere.length-1}× {(Number(st.preisWeitererHund)||0).toFixed(2)} €{" "}
                    {lang==="en"?(tiere.length-1===1?"additional dog":"additional dogs"):(tiere.length-1===1?"weiterer Hund":"weitere Hunde")}
                  </div>
                )}
                {aktiveMethoden.length>1&&(
                  <div style={{display:"flex",gap:8,marginBottom:20,flexWrap:"wrap"}}>
                    {aktiveMethoden.map(m=>(
                      <button key={m} onClick={()=>setMethode(m)}
                        style={{flex:1,padding:"12px 8px",borderRadius:10,border:`2px solid ${methode===m?primaryColor:"#e0ddd8"}`,background:methode===m?primaryColor+"22":"#fff",color:methode===m?primaryColor:"#1a1814",fontSize:13,fontWeight:methode===m?700:400,cursor:"pointer",fontFamily:"inherit",transition:"all 0.15s",textAlign:"center"}}>
                        {m==="paypal"?"💳 PayPal":m==="ueberweisung"?"🏦 "+t.ueberweisung:"💵 "+t.bar}
                      </button>
                    ))}
                  </div>
                )}
                {methode==="paypal"&&z.paypal&&(
                  <div style={{textAlign:"center"}}>
                    <div style={{fontSize:13,color:"#8A8075",marginBottom:16,lineHeight:1.6}}>
                      {lang==="en"?"You will be redirected to PayPal to complete the payment.":"Du wirst zu PayPal weitergeleitet, um die Zahlung abzuschließen."}
                    </div>
                    <button onClick={()=>{
                      // Link so aufbauen wie bei der Zahlungserinnerung, sonst
                      // fuehren Leerzeichen, fehlendes https oder ein Slash am
                      // Ende zu einer PayPal-Fehlermeldung. Leerzeichen auch aus
                      // der Mitte entfernen, die schleichen sich beim Kopieren
                      // aus der PayPal-App gerne ein.
                      let basis=String(z.paypal.link||"").replace(/\s+/g,"").replace(/\/+$/,"");
                      if(!basis){alert(lang==="en"?"No PayPal link configured.":"Kein PayPal-Link hinterlegt.");return;}
                      if(!/^https?:\/\//i.test(basis))basis="https://"+basis.replace(/^\/+/,"");
                      const betrag=preis%1===0?String(Math.round(preis)):preis.toFixed(2);
                      window.open(basis+"/"+betrag+"EUR","_blank");
                      setTimeout(()=>setStep("done"),1500);
                    }} style={{padding:"14px 32px",borderRadius:10,border:"none",background:"#0070BA",color:"#fff",fontSize:15,fontWeight:700,cursor:"pointer",fontFamily:"inherit",width:"100%"}}>
                      💳 {t.payNow} — {preis.toFixed(2)} €
                    </button>
                    <div style={{fontSize:11,color:"#8A8075",marginTop:10}}>{lang==="en"?"After payment you will receive a confirmation.":"Nach der Zahlung erhältst du eine Bestätigung."}</div>
                  </div>
                )}
                {methode==="ueberweisung"&&z.ueberweisung&&(
                  <div style={{background:"#f5f3ef",border:"1px solid #e0ddd8",borderRadius:10,padding:16}}>
                    <div style={{fontSize:13,color:"#8A8075",marginBottom:12}}>{t.ibanInfo}</div>
                    <div style={{display:"flex",flexDirection:"column",gap:8,fontSize:13}}>
                      {[["Empfänger",z.ueberweisung.inhaber],["IBAN",z.ueberweisung.iban],["BIC",z.ueberweisung.bic],["Betrag",`${preis.toFixed(2)} €`],["Verwendungszweck",ref]].map(([l,v])=>(
                        <div key={l} style={{display:"flex",justifyContent:"space-between",padding:"9px 0",borderBottom:"1px solid #e0ddd8"}}>
                          <span style={{color:"#8A8075"}}>{l}</span>
                          <span style={{fontWeight:600,color:"#1a1814",fontFamily:l==="IBAN"||l==="BIC"||l==="Verwendungszweck"?"monospace":"inherit"}}>{v}</span>
                        </div>
                      ))}
                    </div>
                    <button onClick={()=>setStep("done")} style={{marginTop:16,width:"100%",padding:"12px",borderRadius:10,border:"none",background:primaryColor,color:"#1a1814",fontSize:14,fontWeight:700,cursor:"pointer",fontFamily:"inherit"}}>
                      ✓ {lang==="en"?"I have transferred the amount":"Ich habe überwiesen"}
                    </button>
                  </div>
                )}
                {methode==="bar"&&(
                  <div style={{textAlign:"center",padding:"20px 0"}}>
                    <div style={{fontSize:32,marginBottom:12}}>💵</div>
                    <div style={{fontSize:14,color:"#1a1814",marginBottom:8}}>{lang==="en"?"Please pay on site.":"Bitte bezahle vor Ort."}</div>
                    <div style={{fontSize:22,fontWeight:700,color:primaryColor,marginBottom:20}}>{preis.toFixed(2)} €</div>
                    <button onClick={()=>setStep("done")} style={{padding:"12px 32px",borderRadius:10,border:"none",background:primaryColor,color:"#1a1814",fontSize:14,fontWeight:700,cursor:"pointer",fontFamily:"inherit"}}>
                      ✓ {lang==="en"?"Understood":"Verstanden"}
                    </button>
                  </div>
                )}
              </div>
            );
          })()}

          {step==="done"&&(
            <div style={{padding:"8px 0"}}>
              <div style={{textAlign:"center",marginBottom:20}}>
                <div style={{fontSize:48,marginBottom:8}}>🎉</div>
                <div style={{fontFamily:"Georgia,serif",fontSize:22,color:"#1a1814",marginBottom:6}}>{t.done}</div>
                <div style={{fontSize:13,color:"#8A8075",lineHeight:1.6}}>{t.doneText}</div>
              </div>
              {confirmPdf?(
                <button onClick={()=>{
                  const a=document.createElement("a");
                  a.href="data:application/pdf;base64,"+confirmPdf.data;
                  a.download=confirmPdf.name;
                  document.body.appendChild(a);a.click();a.remove();
                }} style={{width:"100%",padding:"14px",borderRadius:10,border:"none",background:primaryColor,color:"#1a1814",fontSize:15,fontWeight:700,cursor:"pointer",fontFamily:"inherit",marginBottom:16}}>
                  ⬇ {lang==="en"?"Download confirmation (PDF)":"Bestätigung als PDF herunterladen"}
                </button>
              ):(
                <button onClick={()=>{
                  // Lokaler HTML-Druck als Fallback
                  const w=window.open("","_blank");if(!w)return;
                  const termin=vorOrtModus?"Vor Ort":`${selectedDate||""} ${selectedSlot||""}`;
                  const felder=activeFelder.filter(f=>!f.id.startsWith("sys_tier")).map(f=>`<tr><td style="color:#8A8075;padding:4px 8px">${f.label?.de||f.label||f.id}</td><td style="padding:4px 8px">${formData[f.id]||""}</td></tr>`).join("");
                  w.document.write(`<html><head><title>Buchungsbestätigung</title></head><body style="font-family:Georgia,serif;padding:40px;max-width:600px;margin:0 auto"><h1 style="color:#A8843E;font-size:24px">Buchungsbestätigung</h1><p style="color:#8A8075">${st.name}</p><table style="width:100%;border-collapse:collapse;margin:20px 0"><tr><td style="color:#8A8075;padding:4px 8px">Termin</td><td style="padding:4px 8px">${termin}</td></tr>${felder}</table><p style="font-size:12px;color:#8A8075;margin-top:30px">Danke für deine Buchung!</p></body></html>`);
                  w.document.close();setTimeout(()=>{w.print();},400);
                }} style={{width:"100%",padding:"14px",borderRadius:10,border:"none",background:primaryColor,color:"#1a1814",fontSize:15,fontWeight:700,cursor:"pointer",fontFamily:"inherit",marginBottom:16}}>
                  ⬇ {lang==="en"?"Download confirmation (PDF)":"Bestätigung als PDF herunterladen"}
                </button>
              )}
              {/* Bestätigung mit allen Daten + Unterschrift */}
              <div style={{background:"#f5f3ef",borderRadius:12,padding:20,fontSize:13,color:"#1a1814",marginBottom:16}}>
                <div style={{fontWeight:700,fontSize:14,marginBottom:12,paddingBottom:8,borderBottom:"1px solid #e0ddd8"}}>
                  {lang==="en"?"Booking confirmation":"Buchungsbestätigung"}
                </div>
                <div style={{display:"grid",gridTemplateColumns:"auto 1fr",gap:"4px 16px",marginBottom:12}}>
                  <span style={{color:"#8A8075"}}>{lang==="en"?"Date":"Termin"}:</span>
                  <span style={{fontWeight:600}}>{vorOrtModus?(lang==="en"?"On site":"Vor Ort"):(selectedDate?new Date(selectedDate).toLocaleDateString(lang==="en"?"en-GB":"de-DE",{weekday:"long",day:"2-digit",month:"long",year:"numeric"}):"")}{!vorOrtModus&&selectedSlot?" · "+selectedSlot:""}</span>
                  <span style={{color:"#8A8075"}}>{lang==="en"?"Type":"Art"}:</span>
                  <span style={{fontWeight:600}}>{st.name}</span>
                  {formData["sys_name"]&&<><span style={{color:"#8A8075"}}>Name:</span><span style={{fontWeight:600}}>{formData["sys_name"]}</span></>}
                  {formData["sys_email"]&&<><span style={{color:"#8A8075"}}>E-Mail:</span><span>{formData["sys_email"]}</span></>}
                  {formData["sys_tel"]&&<><span style={{color:"#8A8075"}}>{lang==="en"?"Phone":"Telefon"}:</span><span>{formData["sys_tel"]}</span></>}
                </div>
                {tiere.length>0&&tiere.some(tier=>getTierField(tier.id,"sys_rasse")||getTierField(tier.id,"sys_tiername"))&&(
                  <div style={{paddingTop:10,borderTop:"1px solid #e0ddd8"}}>
                    <div style={{fontWeight:600,marginBottom:6}}>🐾 {lang==="en"?"Pets":"Tiere"}</div>
                    {tiere.map((tier,i)=>(
                      <div key={tier.id} style={{fontSize:12,color:"#8A8075",marginBottom:3}}>
                        {lang==="en"?`Pet ${i+1}`:`Tier ${i+1}`}: {[getTierField(tier.id,"sys_tiername"),getTierField(tier.id,"sys_rasse"),getTierField(tier.id,"sys_geschlecht")].filter(Boolean).join(" · ")}
                      </div>
                    ))}
                  </div>
                )}
                {signature&&(
                  <div style={{marginTop:14,paddingTop:12,borderTop:"1px solid #e0ddd8"}}>
                    <div style={{fontSize:12,color:"#8A8075",marginBottom:6}}>{lang==="en"?"Signature":"Unterschrift"}:</div>
                    <img src={signature} alt="Unterschrift" style={{maxWidth:"100%",maxHeight:80,border:"1px solid #e0ddd8",borderRadius:6,background:"#fff"}}/>
                  </div>
                )}
              </div>
              {/* Kalender-Buttons — nur bei Vorab-Buchungen mit Datum */}
              {!vorOrtModus&&selectedDate&&selectedSlot&&(()=>{
                const titel=encodeURIComponent(`${st.name} – ${config.studioName||"Fotoshooting"}`);
                const datum=selectedDate.replace(/-/g,"");
                const startDT=`${datum}T${selectedSlot.replace(":","") }00`;
                const endDT=`${datum}T${(()=>{const [h,m]=selectedSlot.split(":").map(Number);const t=h*60+m+60;return `${String(Math.floor(t/60)).padStart(2,"0")}${String(t%60).padStart(2,"0")}`;})()}00`;
                const details=encodeURIComponent(`${st.name}${config.studioName?" bei "+config.studioName:""}`);
                const googleUrl=`https://calendar.google.com/calendar/render?action=TEMPLATE&text=${titel}&dates=${startDT}/${endDT}&details=${details}`;
                const outlookUrl=`https://outlook.live.com/calendar/0/deeplink/compose?subject=${titel}&startdt=${selectedDate}T${selectedSlot}:00&enddt=${selectedDate}T${(()=>{const [h,m]=selectedSlot.split(":").map(Number);const t=h*60+m+60;return `${String(Math.floor(t/60)).padStart(2,"0")}:${String(t%60).padStart(2,"0")}`;})()}:00&body=${details}`;
                function downloadICS(){
                  const ics=[
                    "BEGIN:VCALENDAR","VERSION:2.0","CALSCALE:GREGORIAN",
                    "BEGIN:VEVENT",
                    `SUMMARY:${decodeURIComponent(titel)}`,
                    `DTSTART:${startDT}`,`DTEND:${endDT}`,
                    `DESCRIPTION:${decodeURIComponent(details)}`,
                    `LOCATION:${config.studioName||""}`,
                    "END:VEVENT","END:VCALENDAR"
                  ].join("\n");
                  const a=document.createElement("a");
                  a.href="data:text/calendar;charset=utf-8,"+encodeURIComponent(ics);
                  a.download="termin.ics";a.click();
                }
                return(
                  <div style={{marginTop:12}}>
                    <div style={{fontSize:12,color:"#8A8075",textAlign:"center",marginBottom:8}}>
                      📅 {lang==="en"?"Save appointment to calendar:":"Termin im Kalender speichern:"}
                    </div>
                    <div style={{display:"flex",gap:8,flexWrap:"wrap",justifyContent:"center"}}>
                      <a href={googleUrl} target="_blank" rel="noreferrer"
                        style={{display:"inline-flex",alignItems:"center",gap:6,padding:"8px 14px",borderRadius:8,background:"#4285F4",color:"#fff",fontSize:12,fontWeight:600,textDecoration:"none",fontFamily:"inherit"}}>
                        🗓️ Google Calendar
                      </a>
                      <a href={outlookUrl} target="_blank" rel="noreferrer"
                        style={{display:"inline-flex",alignItems:"center",gap:6,padding:"8px 14px",borderRadius:8,background:"#0078D4",color:"#fff",fontSize:12,fontWeight:600,textDecoration:"none",fontFamily:"inherit"}}>
                        📧 Outlook
                      </a>
                      <button onClick={downloadICS}
                        style={{display:"inline-flex",alignItems:"center",gap:6,padding:"8px 14px",borderRadius:8,background:"#1a1814",color:"#fff",fontSize:12,fontWeight:600,border:"none",cursor:"pointer",fontFamily:"inherit"}}>
                        🍎 Apple / iCal
                      </button>
                    </div>
                  </div>
                );
              })()}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

// ── Formular Builder (Admin) ──────────────────────────────────────────────────
function FormVorlagenModal({st,onApply,onClose,T}){
  const [vorlagen,setVorlagen]=useState(()=>{try{return JSON.parse(localStorage.getItem("sd_form_vorlagen")||"[]")||[];}catch{return [];}});
  const [name,setName]=useState("");
  function persist(v){setVorlagen(v);try{localStorage.setItem("sd_form_vorlagen",JSON.stringify(v));}catch{}}
  function speichern(){
    const n=name.trim();if(!n){alert("Bitte einen Namen für das Muster eingeben.");return;}
    const v={id:uid(),name:n,felder:JSON.parse(JSON.stringify(st.felder||[])),vereinbarung:{...(st.vereinbarung||{})},beschreibung:{...(st.beschreibung||{})},slotInfo:{...(st.slotInfo||{})},created:new Date().toISOString().slice(0,10)};
    persist([...vorlagen,v]);setName("");alert("Muster gespeichert.");
  }
  function loeschen(id){if(confirm("Dieses Muster löschen?"))persist(vorlagen.filter(v=>v.id!==id));}
  const IS={background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:"9px 12px",color:T.text,fontSize:13,fontFamily:"inherit",outline:"none",boxSizing:"border-box",width:"100%"};
  return(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.7)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:200,padding:20}} onClick={onClose}>
      <div onClick={e=>e.stopPropagation()} style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:16,padding:24,width:"100%",maxWidth:520,maxHeight:"90vh",overflowY:"auto"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
          <div style={{fontFamily:"Georgia,serif",fontSize:18,color:T.accent}}>Musterformulare</div>
          <button style={btn(T,"ghost",true)} onClick={onClose}>✕</button>
        </div>
        <div style={{fontSize:12,color:T.muted,marginBottom:8}}>Ein Muster speichert die Felder und die Texte (Beschreibung, Slot-Info, Vereinbarung) dieses Formulars. Beim Anwenden kannst du wählen: „Felder + Texte" ersetzt beides, „Nur Texte" übernimmt nur die Texte und lässt die Felder unverändert.</div>
        <div style={{display:"flex",gap:8,marginBottom:20,flexWrap:"wrap"}}>
          <input value={name} onChange={e=>setName(e.target.value)} placeholder="Name des Musters, z.B. Hundeshooting Standard" style={{...IS,flex:1,minWidth:200}}/>
          <button style={btn(T,"primary")} onClick={speichern}>Als Muster speichern</button>
        </div>
        <div style={{fontSize:11,color:T.muted,fontWeight:700,textTransform:"uppercase",letterSpacing:"0.1em",marginBottom:10}}>Gespeicherte Muster</div>
        {vorlagen.length===0&&<div style={{fontSize:13,color:T.muted}}>Noch keine Muster gespeichert.</div>}
        <div style={{display:"flex",flexDirection:"column",gap:8}}>
          {vorlagen.map(v=>(
            <div key={v.id} style={{display:"flex",alignItems:"center",gap:8,background:T.bg,border:`1px solid ${T.border}`,borderRadius:10,padding:"10px 12px"}}>
              <div style={{flex:1}}>
                <div style={{fontSize:13,fontWeight:600,color:T.text}}>{v.name}</div>
                <div style={{fontSize:11,color:T.muted}}>{(v.felder||[]).length} Felder · gespeichert {v.created||""}</div>
              </div>
              <button style={btn(T,"primary",true)} onClick={()=>onApply(v,"alles")}>Felder + Texte</button>
              <button style={btn(T,"ghost",true)} onClick={()=>onApply(v,"texte")}>Nur Texte</button>
              <button style={btn(T,"danger",true)} onClick={()=>loeschen(v.id)}>✕</button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

function EventQRModal({shootingType,onClose,T}){
  const st=shootingType||{};
  const defBase=(()=>{try{return localStorage.getItem("sd_qr_url")||localStorage.getItem("sd_server_url")||"";}catch{return "";}})();
  const [base,setBase]=useState(defBase);
  useEffect(()=>{try{if(base)localStorage.setItem("sd_qr_url",base);}catch{}},[base]);
  const slug=st.buchungsUrl||(n=>(n||"").toLowerCase().replace(/ä/g,"ae").replace(/ö/g,"oe").replace(/ü/g,"ue").replace(/ß/g,"ss").replace(/[^a-z0-9]+/g,"-").replace(/^-+|-+$/g,""))(st.name);
  const b=base.trim().replace(/\/+$/,"");
  const vorab=b?`${b}/buchen/${slug}`:"";
  const vorort=vorab?`${vorab}?modus=vorort`:"";
  const name=st.name||"Veranstaltung";

  function makeCanvas(u,size,cb){
    if(!u)return;
    const qrUrl=`https://api.qrserver.com/v1/create-qr-code/?size=${size}x${size}&margin=20&ecc=H&data=${encodeURIComponent(u)}`;
    const img=new Image();img.crossOrigin="anonymous";
    img.onload=()=>{
      const c=document.createElement("canvas");c.width=size;c.height=size;
      const ctx=c.getContext("2d");
      ctx.drawImage(img,0,0,size,size);
      const words=name.split(" ");const zeilen=[];let z="";
      words.forEach(w=>{const t=z?z+" "+w:w;if(t.length>13&&z){zeilen.push(z);z=w;}else z=t;});
      if(z)zeilen.push(z);
      const fs=size*0.038,pad=size*0.022,lh=fs+size*0.012;
      const bw=Math.max(...zeilen.map(l=>l.length))*fs*0.55+pad*2;
      const bh=zeilen.length*lh+pad*2;
      const bx=size/2-bw/2,by=size/2-bh/2;
      ctx.fillStyle="#ffffff";ctx.beginPath();
      ctx.roundRect(bx-4,by-4,bw+8,bh+8,5);ctx.fill();
      ctx.fillStyle="#1a1a1a";ctx.font=`${Math.round(fs)}px Arial,sans-serif`;ctx.textAlign="center";
      zeilen.forEach((l,i)=>ctx.fillText(l,size/2,by+pad+fs+(i*lh)));
      cb(c);
    };
    img.onerror=()=>alert("QR-Code konnte nicht geladen werden. Prüfe deine Internetverbindung.");
    img.src=qrUrl;
  }

  function herunterladen(u,dateiname){
    makeCanvas(u,600,c=>{const a=document.createElement("a");a.href=c.toDataURL("image/png");a.download=dateiname;a.click();});
  }
  function drucken(u,titel){
    makeCanvas(u,600,c=>{
      const dataUrl=c.toDataURL("image/png");
      const w=window.open("","_blank");if(!w)return;
      w.document.write(`<html><head><title>${name} ${titel}</title></head><body style="font-family:Arial,sans-serif;text-align:center;padding:40px"><h1 style="font-size:26px;margin-bottom:6px">${name}</h1><p style="font-size:16px;color:#555;margin-top:0">${titel}</p><img src="${dataUrl}" style="width:360px;height:360px"><p style="font-size:12px;color:#999;margin-top:18px;word-break:break-all">${u}</p></body></html>`);
      w.document.close();setTimeout(()=>{try{w.print();}catch(e){}},600);
    });
  }

  function Card({titel,beschr,u,dateiname,nurText}){
    const canvasRef=useRef(null);
    useEffect(()=>{
      if(!u||!canvasRef.current)return;
      makeCanvas(u,380,c=>{
        const ctx2=canvasRef.current.getContext("2d");
        ctx2.clearRect(0,0,380,380);
        ctx2.drawImage(c,0,0,380,380);
      });
    },[u]);
    return(
      <div style={{flex:1,minWidth:220,textAlign:"center",background:T.bg,border:`1px solid ${T.border}`,borderRadius:12,padding:14}}>
        <div style={{fontFamily:"Georgia,serif",fontSize:15,color:T.accent,marginBottom:2}}>{titel}</div>
        <div style={{fontSize:11,color:T.muted,marginBottom:10}}>{beschr}</div>
        {nurText?(
          u?<div style={{background:"#fff",padding:12,borderRadius:10,wordBreak:"break-all",fontSize:12,color:"#333",textAlign:"left",margin:"0 auto",maxWidth:220}}>{u}</div>
          :<div style={{color:T.muted,fontSize:12,padding:24}}>Bitte oben die Adresse eingeben.</div>
        ):(
          u?(
          <div style={{background:"#fff",padding:8,borderRadius:10,display:"inline-block"}}>
            <canvas ref={canvasRef} width={380} height={380} style={{width:190,height:190,display:"block"}}/>
          </div>
        ):<div style={{color:T.muted,fontSize:12,padding:24}}>Bitte oben die Adresse eingeben.</div>
        )}
        {u&&<div style={{fontSize:10,color:T.muted,marginTop:8,wordBreak:"break-all"}}>{u}</div>}
        {u&&(
          <div style={{display:"flex",gap:6,justifyContent:"center",marginTop:10,flexWrap:"wrap"}}>
            <button style={btn(T,"ghost",true)} onClick={()=>{try{navigator.clipboard.writeText(u);alert("Link kopiert!");}catch(e){}}}>Link kopieren</button>
            <button style={btn(T,"ghost",true)} onClick={()=>herunterladen(u,dateiname)}>⬇ Herunterladen</button>
            <button style={btn(T,"primary",true)} onClick={()=>drucken(u,titel)}>Drucken</button>
          </div>
        )}
      </div>
    );
  }

  const slug2=(n=>(n||"").toLowerCase().replace(/ä/g,"ae").replace(/ö/g,"oe").replace(/ü/g,"ue").replace(/ß/g,"ss").replace(/[^a-z0-9]+/g,"-").replace(/^-+|-+$/g,""))(name);
  return(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.7)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:200,padding:20}} onClick={onClose}>
      <div onClick={e=>e.stopPropagation()} style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:16,padding:24,width:"100%",maxWidth:660,maxHeight:"90vh",overflowY:"auto"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
          <div style={{fontFamily:"Georgia,serif",fontSize:18,color:T.accent}}>QR-Code für {name}</div>
          <button style={btn(T,"ghost",true)} onClick={onClose}>✕</button>
        </div>
        <div style={{fontSize:12,color:T.muted,marginBottom:8}}>Internet-Adresse deiner Buchungsseite. Der Veranstaltungsname erscheint automatisch in der Mitte des QR-Codes.</div>
        <input value={base} onChange={e=>setBase(e.target.value)} placeholder="https://deinedomain.de"
          style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:"9px 12px",color:T.text,fontSize:13,fontFamily:"inherit",outline:"none",boxSizing:"border-box",width:"100%",marginBottom:16}}/>
        <div style={{display:"flex",gap:14,flexWrap:"wrap"}}>
          <div style={{display:"flex",flexDirection:"column",gap:14,flex:1}}>
            <Card titel="QR Code Mobil" beschr="Vor Ort — ohne Zeitauswahl" u={vorort} dateiname={`QR_VorOrt_${slug2}.png`}/>
            <Card titel="Link Mobil" beschr="Scannen → URL zum Kopieren (Insta)" u={vorort?`${b}/link?url=${encodeURIComponent(vorort)}&name=${encodeURIComponent(name)}`:""} dateiname={`QR_LinkMobil_${slug2}.png`}/>
          </div>
          <div style={{display:"flex",flexDirection:"column",gap:14,flex:1}}>
            <Card titel="QR Code Fest" beschr="Vorab buchen — mit Zeitauswahl" u={vorab} dateiname={`QR_Vorab_${slug2}.png`}/>
            <Card titel="Link Fest" beschr="Scannen → URL zum Kopieren (Insta)" u={vorab?`${b}/link?url=${encodeURIComponent(vorab)}&name=${encodeURIComponent(name)}`:""} dateiname={`QR_LinkFest_${slug2}.png`}/>
          </div>
        </div>
      </div>
    </div>
  );
}

function mdToHtml(text){
  const esc=s=>String(s||"").replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;");
  let t=String(text||"");
  t=t.replace(/!\[([^\]]*)\]\(([^)]+)\)/g,(m,alt,url)=>`<img src="${url}" alt="${esc(alt)}" style="max-width:100%;border-radius:6px;margin:8px 0;display:block"/>`);
  t=t.replace(/\[([^\]]+)\]\(([^)]+)\)/g,(m,l,u)=>`<a href="${u}" style="color:#A8843E;font-weight:600">${esc(l)}</a>`);
  t=t.replace(/\[(\d+)px?\](.*?)\[\/size\]/gs,(m,px,inner)=>`<span style="font-size:${px}px">${inner}</span>`);
  t=t.replace(/\*\*(.+?)\*\*/gs,(m,inner)=>`<strong>${inner}</strong>`);
  t=t.replace(/(?<![a-zA-Z])_(.+?)_(?![a-zA-Z])/gs,(m,inner)=>`<em>${inner}</em>`);
  return t.split(/\n/).map(line=>line.trim()===""?'<br style="line-height:0.8"/>':line+"<br/>").join("");
}


// ── RichEditor ─────────────────────────────────────────────────────────────────
function RichEditor({T,label,hint,aktuell,storageKey,onChange2,minH=120}){
  const edRef=useRef(null);
  const [offen,setOffen]=useState(false);
  const [vorlagen,setVorlagen]=useState(()=>{try{return JSON.parse(localStorage.getItem(storageKey)||"[]");}catch{return [];}});
  const [neuName,setNeuName]=useState("");
  const kastenRef=useRef(null);
  // Der Vorlagenkasten blieb offen, weil ihn nichts wieder zumacht.
  // Klick daneben und Escape schliessen ihn jetzt.
  useEffect(()=>{
    if(!offen)return;
    const daneben=e=>{if(kastenRef.current&&!kastenRef.current.contains(e.target))setOffen(false);};
    const taste=e=>{if(e.key==="Escape")setOffen(false);};
    document.addEventListener("mousedown",daneben);
    document.addEventListener("keydown",taste);
    return()=>{document.removeEventListener("mousedown",daneben);
               document.removeEventListener("keydown",taste);};
  },[offen]);
  const isUpdating=useRef(false);
  const lineHRef=useRef("1.7");
  const [lineHDisplay,setLineHDisplay]=useState("1.7");

  // HTML ins Editor-Div schreiben wenn aktuell sich ändert (von außen)
  useEffect(()=>{
    const el=edRef.current;
    if(!el||isUpdating.current)return;
    // Solange der Cursor im Feld steht, nichts von aussen hineinschreiben.
    // Ein Neuzeichnen wuerde sonst mitten im Tippen den Inhalt ersetzen und
    // damit die Markierung zerstoeren.
    if(typeof document!=="undefined"&&document.activeElement===el)return;
    const html=aktuell||"";
    const m=html.match(/^<div style="line-height:([^"]+)">/);
    if(m){lineHRef.current=m[1];setLineHDisplay(m[1]);el.style.lineHeight=m[1];}
    const inner=m?html.replace(/^<div style="line-height:[^"]*">/,"").replace(/<\/div>$/,""):html;
    if(el.innerHTML!==inner)el.innerHTML=inner;
  },[aktuell]);

  function persist(v){setVorlagen(v);try{localStorage.setItem(storageKey,JSON.stringify(v));}catch{}}

  // Die Markierung geht verloren, sobald der Mauszeiger auf einen Knopf der
  // Leiste drueckt. Deshalb wird sie vorher gemerkt und vor dem Befehl wieder
  // hergestellt. Ohne das passiert beim Klick schlicht nichts.
  const merkBereich=useRef(null);
  function bereichMerken(){
    const sel=window.getSelection();
    if(sel&&sel.rangeCount&&edRef.current&&edRef.current.contains(sel.anchorNode))
      merkBereich.current=sel.getRangeAt(0).cloneRange();
  }
  function bereichZurueck(){
    const el=edRef.current;if(!el)return;
    el.focus();
    const r=merkBereich.current;
    if(!r||!el.contains(r.commonAncestorContainer))return;
    const sel=window.getSelection();
    sel.removeAllRanges();sel.addRange(r);
  }
  function exec(cmd,val){
    bereichZurueck();
    document.execCommand(cmd,false,val);
    bereichMerken();
    onInput();
  }
  // Listen aufloesen. removeFormat ruehrt ul und ol nicht an, die muessen
  // ueber den Umschalter weg. Ob eine Liste vorliegt, sagt der Browser selbst
  // zuverlaessiger als eine Suche im Baum: bei markiertem Gesamttext liegt
  // der Ankerpunkt naemlich am Textfeld und nicht in der Liste.
  function formatWeg(){
    bereichZurueck();
    // Ohne Markierung wirkt der Befehl nur auf die eine Zeile, in der der
    // Cursor steht. Bei einer Liste ueber mehrere Zeilen bleibt der Rest
    // dann stehen und es sieht aus, als wuerde nichts passieren. Deshalb:
    // nichts markiert heisst alles im Feld.
    const el=edRef.current;
    const aus=window.getSelection();
    if(el&&aus&&(aus.rangeCount===0||aus.getRangeAt(0).collapsed)){
      const r=document.createRange();
      r.selectNodeContents(el);
      aus.removeAllRanges();
      aus.addRange(r);
    }
    try{
      if(document.queryCommandState("insertUnorderedList"))
        document.execCommand("insertUnorderedList",false,null);
      if(document.queryCommandState("insertOrderedList"))
        document.execCommand("insertOrderedList",false,null);
    }catch(e){/* aeltere Browser koennen queryCommandState nicht */}
    document.execCommand("removeFormat",false,null);
    bereichMerken();
    onInput();
  }
  // Knopf gedrueckt: Fokus im Textfeld lassen, sonst ist die Markierung weg.
  const halten={onMouseDown:e=>e.preventDefault()};

  function onInput(){
    isUpdating.current=true;
    const html=edRef.current?.innerHTML||"";
    const lh=lineHRef.current;
    const wrapped=lh!=="1.7"?`<div style="line-height:${lh}">${html}</div>`:html;
    onChange2(wrapped);
    setTimeout(()=>{isUpdating.current=false;},0);
  }

  const BTN={background:"none",border:`1px solid ${T.border}`,borderRadius:5,padding:"3px 7px",fontSize:12,cursor:"pointer",color:T.text,fontFamily:"inherit"};
  const SEP={width:1,height:18,background:T.border,margin:"0 3px"};

  return(
    <div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:5}}>
        <label style={{fontSize:12,color:T.muted,fontWeight:600}}>{label}{hint&&<span style={{fontSize:10,color:T.muted,fontWeight:400,marginLeft:4}}>{hint}</span>}</label>
        <div ref={kastenRef} style={{position:"relative"}}>
          <button style={btn(T,"ghost",true)} onClick={()=>setOffen(o=>!o)}><Ic n="folder" s={12}/> Vorlagen</button>
          {offen&&(
            <div onClick={e=>e.stopPropagation()} style={{position:"absolute",right:0,top:"100%",zIndex:50,background:T.surface,border:`1px solid ${T.border}`,borderRadius:10,padding:12,minWidth:260,boxShadow:"0 4px 16px rgba(0,0,0,0.18)"}}>
              <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",gap:8,marginBottom:8}}>
                <span style={{fontWeight:700,fontSize:12,color:T.muted}}>{label}</span>
                <button onClick={()=>setOffen(false)} title="Schließen"
                  style={{background:"none",border:"none",color:T.muted,cursor:"pointer",fontSize:16,lineHeight:1,padding:"0 2px"}}>×</button>
              </div>
              {vorlagen.length===0&&<div style={{fontSize:12,color:T.muted,marginBottom:8}}>Noch keine gespeichert.</div>}
              {vorlagen.map((v,i)=>(
                <div key={i} style={{display:"flex",alignItems:"center",gap:6,marginBottom:6}}>
                  <span style={{flex:1,fontSize:12,color:T.text,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{v.name}</span>
                  <button style={btn(T,"primary",true)} onClick={()=>{onChange2(v.text);if(edRef.current)edRef.current.innerHTML=v.text;setOffen(false);}}>Laden</button>
                  <button style={btn(T,"danger",true)} onClick={()=>persist(vorlagen.filter((_,j)=>j!==i))}>✕</button>
                </div>
              ))}
              <div style={{borderTop:`1px solid ${T.border}`,paddingTop:8,marginTop:8,display:"flex",gap:6}}>
                <input value={neuName} onChange={e=>setNeuName(e.target.value)} placeholder="Name der Vorlage"
                  style={{flex:1,background:T.bg,border:`1px solid ${T.border}`,borderRadius:6,padding:"5px 8px",color:T.text,fontSize:12,fontFamily:"inherit",outline:"none"}}/>
                <button style={btn(T,"ghost",true)} onClick={()=>{if(!neuName.trim())return;persist([...vorlagen,{name:neuName.trim(),text:aktuell||""}]);setNeuName("");setOffen(false);}}>Speichern</button>
              </div>
              <div style={{display:"flex",justifyContent:"flex-end",marginTop:8}}>
                <button style={btn(T,"ghost",true)} onClick={()=>{setNeuName("");setOffen(false);}}>Abbrechen</button>
              </div>
            </div>
          )}
        </div>
      </div>
      {/* Toolbar */}
      <div style={{display:"flex",alignItems:"center",gap:3,flexWrap:"wrap",padding:"5px 8px",background:T.bg,border:`1px solid ${T.border}`,borderRadius:"8px 8px 0 0",borderBottom:"none"}}>
        <button {...halten} style={{...BTN,fontWeight:700}} title="Fett" onClick={()=>exec("bold")}><b>B</b></button>
        <button {...halten} style={{...BTN,fontStyle:"italic"}} title="Kursiv" onClick={()=>exec("italic")}><i>I</i></button>
        <button {...halten} style={{...BTN,textDecoration:"underline"}} title="Unterstrichen" onClick={()=>exec("underline")}><u>U</u></button>
        <div style={SEP}/>
        <button {...halten} style={BTN} title="Überschrift 1" onClick={()=>exec("formatBlock","h2")}>H1</button>
        <button {...halten} style={BTN} title="Überschrift 2" onClick={()=>exec("formatBlock","h3")}>H2</button>
        <button {...halten} style={BTN} title="Normal" onClick={()=>exec("formatBlock","p")}>¶</button>
        <div style={SEP}/>
        <button {...halten} style={BTN} title="Aufzählung" onClick={()=>exec("insertUnorderedList")}>• —</button>
        <button {...halten} style={BTN} title="Nummerierte Liste" onClick={()=>exec("insertOrderedList")}>1.</button>
        <div style={SEP}/>
        <select title="Schriftgröße" style={{...BTN,padding:"3px 4px"}} onFocus={bereichMerken} onChange={e=>{exec("fontSize",e.target.value);e.target.value=""}}>
          <option value="">Größe</option>
          {[1,2,3,4,5,6,7].map(s=><option key={s} value={s}>{[8,10,12,14,18,24,36][s-1]}px</option>)}
        </select>
        <select title="Zeilenabstand" style={{...BTN,padding:"3px 4px"}} value={lineHDisplay} onChange={e=>{
          const val=e.target.value;if(!val)return;
          lineHRef.current=val;setLineHDisplay(val);
          const el=edRef.current;if(!el)return;
          el.style.lineHeight=val;
          onInput();
        }}>
          <option value="1.7">Zeilenabstand</option>
          {["1.0","1.2","1.5","1.8","2.0","2.5","3.0","3.5","4.0"].map(v=><option key={v} value={v}>{v}</option>)}
        </select>
        <div style={SEP}/>
        <button {...halten} style={BTN} title="Linksbündig" onClick={()=>exec("justifyLeft")}>≡L</button>
        <button {...halten} style={BTN} title="Zentriert" onClick={()=>exec("justifyCenter")}>≡C</button>
        <button {...halten} style={BTN} title="Rechtsbündig" onClick={()=>exec("justifyRight")}>≡R</button>
        <div style={SEP}/>
        <button {...halten} style={{...BTN,color:"#e53"}} title="Formatierung und Listen löschen (ohne Markierung: das ganze Feld)" onClick={formatWeg}>✕</button>
      </div>
      {/* Editierbarer Bereich */}
      <div
        ref={edRef}
        contentEditable
        suppressContentEditableWarning
        onInput={onInput}
        onKeyUp={bereichMerken}
        onMouseUp={bereichMerken}
        onBlur={bereichMerken}
        style={{minHeight:minH,padding:"10px 12px",border:`1px solid ${T.border}`,borderRadius:"0 0 8px 8px",fontSize:13,fontFamily:"inherit",color:T.text,background:T.bg,outline:"none",lineHeight:1.7,overflowY:"auto"}}
      />
      <style>{`[contenteditable] ul,[contenteditable] ol{list-style-position:inside;padding-left:0}`}</style>
    </div>
  );
}

function TextVorlageZeile({T,label,hint,aktuell,storageKey,onChange2,minH=70,placeholder="",taId,toolbar,taStyle}){
  const [offen,setOffen]=useState(false);
  const [vorlagen,setVorlagen]=useState(()=>{try{return JSON.parse(localStorage.getItem(storageKey)||"[]");}catch{return [];}});
  const [neuName,setNeuName]=useState("");
  const taRef=useRef(null);
  const [h,setH]=useState(()=>{try{const v=localStorage.getItem(storageKey+"_h");return v?parseInt(v,10):0;}catch(e){return 0;}});
  const saveH=()=>{const el=taRef.current;if(!el)return;const nh=el.offsetHeight;if(nh&&nh!==h){setH(nh);try{localStorage.setItem(storageKey+"_h",String(nh));}catch(e){}}};
  function persist(v){setVorlagen(v);try{localStorage.setItem(storageKey,JSON.stringify(v));}catch{}}
  const IS2=IS(T);
  return(
    <div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:5}}>
        <label style={{fontSize:12,color:T.muted,fontWeight:600}}>{label}{hint&&<span style={{fontSize:10,color:T.muted,fontWeight:400,marginLeft:4}}>{hint}</span>}</label>
        <div style={{position:"relative"}}>
          <button style={btn(T,"ghost",true)} onClick={()=>setOffen(o=>!o)}><Ic n="folder" s={12}/> Vorlagen</button>
          {offen&&(
            <div onClick={e=>e.stopPropagation()} style={{position:"absolute",right:0,top:"100%",zIndex:50,background:T.surface,border:`1px solid ${T.border}`,borderRadius:10,padding:12,minWidth:260,boxShadow:"0 4px 16px rgba(0,0,0,0.18)"}}>
              <div style={{fontWeight:700,fontSize:12,color:T.muted,marginBottom:8}}>{label}</div>
              {vorlagen.length===0&&<div style={{fontSize:12,color:T.muted,marginBottom:8}}>Noch keine gespeichert.</div>}
              {vorlagen.map((v,i)=>(
                <div key={i} style={{display:"flex",alignItems:"center",gap:6,marginBottom:6}}>
                  <span style={{flex:1,fontSize:12,color:T.text,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{v.name}</span>
                  <button style={btn(T,"primary",true)} onClick={()=>{onChange2(v.text);setOffen(false);}}>Laden</button>
                  <button style={btn(T,"danger",true)} onClick={()=>persist(vorlagen.filter((_,j)=>j!==i))}>✕</button>
                </div>
              ))}
              <div style={{borderTop:`1px solid ${T.border}`,paddingTop:8,marginTop:8,display:"flex",gap:6}}>
                <input value={neuName} onChange={e=>setNeuName(e.target.value)} placeholder="Name der Vorlage"
                  style={{flex:1,background:T.bg,border:`1px solid ${T.border}`,borderRadius:6,padding:"5px 8px",color:T.text,fontSize:12,fontFamily:"inherit",outline:"none"}}/>
                <button style={btn(T,"ghost",true)} onClick={()=>{if(!neuName.trim())return;persist([...vorlagen,{name:neuName.trim(),text:aktuell||""}]);setNeuName("");setOffen(false);}}>Speichern</button>
              </div>
            </div>
          )}
        </div>
      </div>
      {toolbar}
      <textarea ref={taRef} id={taId} value={aktuell||""} onChange={e=>onChange2(e.target.value)} onMouseUp={saveH} placeholder={placeholder} style={{...IS2,resize:"vertical",minHeight:minH,height:h||undefined,lineHeight:1.7,...(taStyle||{})}}/>
    </div>
  );
}

function FormularBuilder({shootingType,onChange,T,isStandard,onSetStandard,config,setConfig,interessenten=[],onShowInteressenten,onEventDatum}){
  const st=shootingType;
  const [showQR,setShowQR]=useState(false);
  const [showVorlagen,setShowVorlagen]=useState(false);
  const [showSlotReserv,setShowSlotReserv]=useState(false);
  const [tab,setTab]=useState("felder");
  const dragId=useRef(null);
  const [dragOver,setDragOver]=useState(null);
  const [translating,setTranslating]=useState(false);
  const [transErr,setTransErr]=useState("");

  function toggleFeld(id){
    onChange({...st,felder:st.felder.map(f=>f.id===id?{...f,aktiv:!f.aktiv}:f)});
  }
  function toggleRequired(id){
    onChange({...st,felder:st.felder.map(f=>f.id===id?{...f,required:!f.required}:f)});
  }
  function toggleProTier(id){
    onChange({...st,felder:st.felder.map(f=>f.id===id?{...f,proTier:!f.proTier}:f)});
  }
  function addCustomField(){
    const nf={id:uid(),type:"text",label:"Neues Feld",labelDe:"Neues Feld",labelEn:"New field",required:false,aktiv:true,system:false,options:[]};
    onChange({...st,felder:[...st.felder,nf]});
  }
  function updateFeld(id,key,val){
    onChange({...st,felder:st.felder.map(f=>f.id===id?{...f,[key]:val,labelDe:key==="label"?val:f.labelDe}:f)});
  }
  function deleteFeld(id){
    onChange({...st,felder:st.felder.filter(f=>f.id!==id)});
  }
  function onDragStart(id){dragId.current=id;}
  function onDragEnter(id){setDragOver(id);}
  function onDragEnd(){
    if(dragId.current&&dragOver&&dragId.current!==dragOver){
      const felder=[...st.felder];
      const fromIdx=felder.findIndex(f=>f.id===dragId.current);
      const toIdx=felder.findIndex(f=>f.id===dragOver);
      const [moved]=felder.splice(fromIdx,1);
      felder.splice(toIdx,0,moved);
      onChange({...st,felder});
    }
    dragId.current=null;setDragOver(null);
  }
  const [slotStart,setSlotStart]=useState("09:00");
  const [slotEnd,setSlotEnd]=useState("17:00");
  const [slotDauer,setSlotDauer]=useState(30);
  function timeToMin(t){const [h,m]=t.split(":").map(Number);return h*60+m;}
  function minToTime(t){return `${String(Math.floor(t/60)).padStart(2,"0")}:${String(t%60).padStart(2,"0")}`;}
  function genZeiten(start,end,dauer){
    if(!dauer||dauer<=0)return[];
    const s=timeToMin(start),e=timeToMin(end);
    if(s>=e)return[];
    const zeiten=[];
    for(let t=s;t+dauer<=e;t+=dauer)zeiten.push(minToTime(t));
    return zeiten;
  }
  function addSlotDay(){
    let d;
    try{
      if(st.eventId){
        const evs=JSON.parse(localStorage.getItem("sd_events")||"[]");
        const ev=Array.isArray(evs)?evs.find(e=>e.id===st.eventId):null;
        if(ev&&ev.date){
          const used=new Set((st.slots||[]).map(s=>s.datum));
          const end=ev.dateBis||ev.date;
          let cur=ev.date;
          while(cur<=end){ if(!used.has(cur))break; const nx=new Date(cur);nx.setDate(nx.getDate()+1);cur=nx.toISOString().slice(0,10); }
          d=(cur<=end)?cur:ev.date;
        }
      }
    }catch(e){}
    if(!d){const datum=new Date();datum.setDate(datum.getDate()+7);d=datum.toISOString().slice(0,10);}
    const zeiten=genZeiten(slotStart,slotEnd,slotDauer);
    onChange({...st,slots:[...(st.slots||[]),{id:uid(),datum:d,zeiten,booked:[],von:slotStart,bis:slotEnd}]});
  }
  function updateSlot(slotId,key,val){
    onChange({...st,slots:(st.slots||[]).map(s=>s.id===slotId?{...s,[key]:val,...(key==="datum"?{booked:[]}:{})}:s)});
  }
  function deleteSlot(slotId){
    onChange({...st,slots:(st.slots||[]).filter(s=>s.id!==slotId)});
  }
  function addZeit(slotId){
    const zeit=window.prompt("Uhrzeit (HH:MM):");
    if(!zeit||!/^\d{1,2}:\d{2}$/.test(zeit.trim()))return;
    const z=zeit.trim().replace(/^(\d):/, "0$1:");
    onChange({...st,slots:(st.slots||[]).map(s=>s.id===slotId?{...s,zeiten:[...new Set([...s.zeiten,z])].sort()}:s)});
  }
  function removeZeit(slotId,z){
    onChange({...st,slots:(st.slots||[]).map(s=>s.id===slotId?{...s,zeiten:s.zeiten.filter(t=>t!==z)}:s)});
  }

  const IS2=IS(T);
  // Interesse an- oder ausschalten. Beim Ausschalten wird aus der Vormerkung
  // eine echte Veranstaltung, deshalb wandert das Datum in den
  // Veranstaltungsdatensatz. Veranstaltungsplan, Kalender und Abrechnung
  // lesen alle dieses eine Feld.
  function interesseUmschalten(){
    const neuAktiv=!st.interessenliste;
    if(neuAktiv){onChange({...st,interessenliste:true});return;}
    const opts=(st.terminoptionen||[]).map(o=>typeof o==="object"?o:{datum:o,min:""}).filter(o=>o.datum);
    let neu={...st,interessenliste:false};
    if(opts.length===1&&!(st.slots||[]).some(x=>x.datum===opts[0].datum)){
      const zeiten=genZeiten(slotStart,slotEnd,slotDauer);
      neu={...neu,terminoptionen:[],slots:[...(st.slots||[]),{id:uid(),datum:opts[0].datum,zeiten,booked:[],von:slotStart,bis:slotEnd}]};
    }else if(opts.length===1){
      neu={...neu,terminoptionen:[]};
    }
    const tage=[...new Set([...(neu.slots||[]).map(x=>x.datum),...opts.map(o=>o.datum)].filter(Boolean))].sort();
    onChange(neu);
    if(tage.length&&onEventDatum)onEventDatum(tage[0],tage.length>1?tage[tage.length-1]:"");
  }

  const TABS=[{id:"felder",l:"Felder"},{id:"slots",l:"Zeitslots"},{id:"vereinbarung",l:"Vereinbarung"},{id:"texte",l:"Texte"},{id:"zahlung",l:"💳 Zahlung"},...(st.interessenliste?[{id:"interesse_pf",l:"📋 Pflichtfelder"}]:[])];

  return(
    <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:12,padding:20}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",gap:10,marginBottom:16,flexWrap:"wrap"}}>
        <div style={{fontFamily:"Georgia,serif",fontSize:15,color:T.accent}}>{st.name} — Formular</div>
        <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
          <button style={btn(T,"ghost",true)} onClick={()=>setShowVorlagen(true)}>Musterformulare</button>
          <button style={btn(T,"ghost",true)} onClick={()=>setShowSlotReserv(true)}>📧 Slot reservieren</button>
          <button style={btn(T,"primary",true)} onClick={()=>setShowQR(true)}>📱 QR-Code für Veranstaltung</button>
        </div>
      </div>
      <div style={{display:"flex",gap:6,marginBottom:20,flexWrap:"wrap",alignItems:"center"}}>
        {TABS.map(t=><button key={t.id} style={btn(T,tab===t.id?"active":"ghost",true)} onClick={()=>setTab(t.id)}>{t.l}</button>)}
        <div style={{display:"flex",alignItems:"center",gap:6,marginLeft:8,padding:"6px 14px",borderRadius:8,border:`1px solid ${T.border}`,background:T.bg,cursor:"pointer"}} onClick={()=>onChange({...st,hp_aktiv:st.hp_aktiv!==true})}>
          <span style={{fontSize:13,color:T.muted}}>🌐 HP</span>
          <div style={{width:38,height:20,borderRadius:10,background:st.hp_aktiv!==false?"#4caf50":T.border,position:"relative",transition:"background 0.2s",flexShrink:0}}>
            <div style={{position:"absolute",top:3,left:st.hp_aktiv!==false?19:3,width:14,height:14,borderRadius:"50%",background:"#fff",transition:"left 0.2s",boxShadow:"0 1px 3px rgba(0,0,0,0.3)"}}/>
          </div>
        </div>
        <div style={{display:"flex",alignItems:"center",gap:6,padding:"6px 14px",borderRadius:8,border:`1px solid ${st.interessenliste?"#f59e0b":T.border}`,background:T.bg,cursor:"pointer"}} onClick={()=>{
  interesseUmschalten();
}}>
          <span style={{fontSize:13,color:st.interessenliste?"#f59e0b":T.muted}}>📋 Interesse</span>
          <div style={{width:38,height:20,borderRadius:10,background:st.interessenliste?"#f59e0b":T.border,position:"relative",transition:"background 0.2s",flexShrink:0}}>
            <div style={{position:"absolute",top:3,left:st.interessenliste?19:3,width:14,height:14,borderRadius:"50%",background:"#fff",transition:"left 0.2s",boxShadow:"0 1px 3px rgba(0,0,0,0.3)"}}/>
          </div>
        </div>
      </div>
      {showQR&&<EventQRModal shootingType={st} onClose={()=>setShowQR(false)} T={T}/>}
      {showVorlagen&&<FormVorlagenModal st={st} onApply={(v,mode)=>{const texts={vereinbarung:{...st.vereinbarung,...(v.vereinbarung||{})},beschreibung:{...st.beschreibung,...(v.beschreibung||{})},slotInfo:{...st.slotInfo,...(v.slotInfo||{})}};if(mode==="texte"){onChange({...st,...texts});}else{onChange({...st,felder:JSON.parse(JSON.stringify(v.felder||[])),...texts});}setShowVorlagen(false);}} onClose={()=>setShowVorlagen(false)} T={T}/>}
      {showSlotReserv&&<SlotReservierenModal shootingType={st} onClose={()=>setShowSlotReserv(false)} T={T}/>}

      {/* Felder */}
      {tab==="felder"&&(
        <div>
          {onSetStandard&&(
            <label style={{display:"flex",alignItems:"center",gap:10,padding:"10px 12px",marginBottom:12,background:isStandard?T.accent+"18":T.bg,borderRadius:8,border:`1px solid ${isStandard?T.accent:T.border}`,cursor:"pointer"}}>
              <input type="checkbox" checked={!!isStandard} onChange={e=>onSetStandard(e.target.checked)} style={{accentColor:T.accent,width:16,height:16,flexShrink:0}}/>
              <div style={{flex:1}}>
                <div style={{fontSize:12,color:T.text,fontWeight:600}}>⭐ Als Standard-Formular</div>
                <div style={{fontSize:11,color:T.muted}}>Die Felder dieses Formulars werden bei neuen Veranstaltungen automatisch übernommen.</div>
              </div>
              {isStandard&&<span style={{fontSize:11,color:T.accent,fontWeight:700,flexShrink:0}}>aktiv</span>}
            </label>
          )}
          <div style={{fontSize:12,color:T.muted,marginBottom:12}}>Wähle welche Felder im Buchungsformular erscheinen und ob sie Pflichtfelder sind. Markiere ein Feld als "🐾 pro Tier", damit es pro Hund wiederholt wird — dann kann der Kunde mehrere Tiere hinzufügen.</div>
          <div style={{display:"flex",flexDirection:"column",gap:8,marginBottom:14}}>
            {st.felder.map(f=>(
              <div key={f.id}
                draggable
                onDragStart={()=>onDragStart(f.id)}
                onDragEnter={()=>onDragEnter(f.id)}
                onDragOver={e=>e.preventDefault()}
                onDragEnd={onDragEnd}
                style={{display:"flex",alignItems:"center",gap:10,padding:"10px 12px",background:f.aktiv?T.bg:T.border+"22",borderRadius:8,border:`2px solid ${dragOver===f.id?T.accent:f.aktiv?T.border:T.border+"44"}`,opacity:dragId.current===f.id?0.4:f.aktiv?1:0.6,transition:"border-color 0.15s, opacity 0.15s",cursor:"grab"}}>
                <span title="Ziehen zum Sortieren" style={{color:T.muted,fontSize:14,cursor:"grab",flexShrink:0,userSelect:"none"}}>⠿</span>
                <input type="checkbox" checked={f.aktiv} onChange={()=>toggleFeld(f.id)} style={{accentColor:T.accent,width:16,height:16,flexShrink:0}}/>
                <div style={{flex:1}}>
                  {f.system?(
                    <div>
                      <span style={{fontSize:13,color:T.text}}>{f.labelDe||f.label}</span>
                      <div style={{marginTop:4}}>
                        <input value={f.placeholder?.de||""} onChange={e=>updateFeld(f.id,"placeholder",{...(f.placeholder||{}),de:e.target.value})} placeholder="Platzhalter, z.B. Max Mustermann" style={{...IS2,padding:"3px 7px",fontSize:11,width:"100%"}}/>
                      </div>
                    </div>
                  ):(
                    <input value={f.label} onChange={e=>updateFeld(f.id,"label",e.target.value)} style={{...IS2,padding:"4px 8px",fontSize:13,background:"transparent",border:`1px solid ${T.border}`}}/>
                  )}
                  {!f.system&&(
                    <div style={{display:"flex",gap:8,marginTop:4}}>
                      <input value={f.labelEn||""} onChange={e=>updateFeld(f.id,"labelEn",e.target.value)} placeholder="English label" style={{...IS2,padding:"3px 7px",fontSize:11}}/>
                      <select value={f.type} onChange={e=>updateFeld(f.id,"type",e.target.value)} style={{...IS2,padding:"3px 7px",fontSize:11,width:"auto"}}>
                        {FIELD_TYPES.map(ft=><option key={ft.type} value={ft.type}>{ft.label}</option>)}
                      </select>
                    </div>
                  )}
                  {!f.system&&f.type!=="select"&&f.type!=="radio"&&f.type!=="checkbox"&&(
                    <div style={{display:"flex",gap:8,marginTop:4}}>
                      <input value={f.placeholder?.de||""} onChange={e=>updateFeld(f.id,"placeholder",{...(f.placeholder||{}),de:e.target.value})} placeholder="Platzhalter Deutsch" style={{...IS2,padding:"3px 7px",fontSize:11}}/>
                      <input value={f.placeholder?.en||""} onChange={e=>updateFeld(f.id,"placeholder",{...(f.placeholder||{}),en:e.target.value})} placeholder="Placeholder English" style={{...IS2,padding:"3px 7px",fontSize:11}}/>
                    </div>
                  )}
                  {(f.type==="select"||f.type==="radio")&&(
                    <div style={{marginTop:4}}>
                      <input value={(f.options||[]).join(",")} onChange={e=>updateFeld(f.id,"options",e.target.value.split(",").map(x=>x.trim()))}
                        placeholder="Option1, Option2, Option3" style={{...IS2,padding:"3px 7px",fontSize:11}}/>
                    </div>
                  )}
                </div>
                <label style={{display:"flex",alignItems:"center",gap:5,fontSize:11,color:T.muted,cursor:"pointer",flexShrink:0}}>
                  <input type="checkbox" checked={f.required} onChange={()=>toggleRequired(f.id)} style={{accentColor:T.accent}}/>
                  Pflicht
                </label>
                <label style={{display:"flex",alignItems:"center",gap:5,fontSize:11,color:T.muted,cursor:"pointer",flexShrink:0}}>
                  <input type="checkbox" checked={!!f.proTier} onChange={()=>toggleProTier(f.id)} style={{accentColor:T.accent}}/>
                  🐾 pro Tier
                </label>
                {!f.system&&<button style={btn(T,"danger",true)} onClick={()=>deleteFeld(f.id)}>✕</button>}
                {f.system&&<span style={{fontSize:10,color:T.muted,flexShrink:0}}>System</span>}
              </div>
            ))}
          </div>
          <button style={btn(T,"ghost",true)} onClick={addCustomField}>+ Eigenes Feld hinzufügen</button>
        </div>
      )}

      {/* Pflichtfelder Interessentenliste */}
      {tab==="interesse_pf"&&(
        <div>
          <div style={{fontSize:13,color:T.muted,marginBottom:16}}>Lege fest welche Felder im Interessenformular Pflicht sind. Name und E-Mail sind immer Pflicht.</div>
          <div style={{display:"flex",flexDirection:"column",gap:8}}>
            {[
              ["shooting","🎯 Shooting-Auswahl"],
              ["telefon","📞 Telefon"],
              ["tier","🐾 Tier (Tiername, Rasse, Alter, Geschlecht)"],
              ["wuensche","💬 Wünsche und Anregungen"],
            ].map(([key,label])=>(
              <label key={key} style={{display:"flex",alignItems:"center",gap:10,padding:"12px 14px",border:`1px solid ${st.interessePflicht?.[key]?"#f59e0b":T.border}`,borderRadius:10,cursor:"pointer",background:st.interessePflicht?.[key]?"#fef9ee":T.bg,transition:"all 0.15s"}}>
                <input type="checkbox"
                  checked={!!(st.interessePflicht?.[key])}
                  onChange={e=>onChange({...st,interessePflicht:{...(st.interessePflicht||{}),[key]:e.target.checked}})}
                  style={{accentColor:"#f59e0b",width:16,height:16,flexShrink:0}}/>
                <div>
                  <div style={{fontSize:13,fontWeight:600,color:T.text}}>{label}</div>
                  <div style={{fontSize:11,color:T.muted,marginTop:2}}>{st.interessePflicht?.[key]?"Pflichtfeld — muss ausgefüllt werden":"Optional"}</div>
                </div>
              </label>
            ))}
          </div>
          <div style={{marginTop:16,padding:"12px 14px",background:T.bg,border:`1px solid ${T.border}`,borderRadius:10,fontSize:12,color:T.muted}}>
            <strong>Immer Pflicht:</strong> Name, E-Mail
          </div>
        </div>
      )}
      {/* Zeitslots */}
      {tab==="slots"&&(
        <div>
          {st.interessenliste&&(
            <div style={{background:"#fef9ee",border:"1px solid #f59e0b44",borderRadius:10,padding:16,marginBottom:20}}>
              {(()=>{
                const _liste=(interessenten||[]).filter(i=>i.shootingType===(st.name||""));
                return(
                  <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:4,flexWrap:"wrap"}}>
                    <div style={{fontSize:13,fontWeight:700,color:"#b45309"}}>📋 Terminoptionen für Interessenten</div>
                    <button onClick={()=>onShowInteressenten&&onShowInteressenten()} disabled={!onShowInteressenten}
                      title="Interessentenliste öffnen"
                      style={{border:"1px solid #f59e0b",background:"#f59e0b22",color:"#b45309",borderRadius:999,
                        padding:"3px 12px",fontSize:12,fontWeight:700,cursor:onShowInteressenten?"pointer":"default",fontFamily:"inherit"}}>
                      {_liste.length} Interessent{_liste.length!==1?"en":""} ›
                    </button>
                  </div>
                );
              })()}
              <div style={{fontSize:11,color:"#92400e",marginBottom:12}}>Interessenten wählen ihren Wunschtermin. Nur Datum, keine Uhrzeit. Wenn die Veranstaltung spruchreif ist, kannst du hier Zeitslots vergeben und die Optionen entfernen.</div>
              {(st.terminoptionen||[]).map((opt,i)=>{
                const datum=typeof opt==="object"?opt.datum||"":opt;
                const min=typeof opt==="object"?opt.min||"":"";
                const update=(key,val)=>{const n=[...(st.terminoptionen||[])];n[i]={...((typeof opt==="object")?opt:{datum:opt,min:""}),[key]:val};onChange({...st,terminoptionen:n});};
                return(
                  <div key={i} style={{display:"flex",gap:8,marginBottom:8,alignItems:"center"}}>
                    <input type="date" value={datum} onChange={e=>{
                      const neuesDatum=e.target.value;
                      update("datum",neuesDatum);
                      // Automatisch Slot anlegen wenn noch keiner für dieses Datum existiert
                      if(neuesDatum&&!(st.slots||[]).find(s=>s.datum===neuesDatum)){
                        const zeiten=genZeiten(slotStart,slotEnd,slotDauer);
                        const neuerSlot={id:uid(),datum:neuesDatum,zeiten,booked:[],von:slotStart,bis:slotEnd};
                        const n=[...(st.terminoptionen||[])];n[i]={...((typeof opt==="object")?opt:{datum:opt,min:""}),datum:neuesDatum};
                        onChange({...st,terminoptionen:n,slots:[...(st.slots||[]),neuerSlot]});
                      }
                    }}
                      style={{padding:"7px 10px",border:"1px solid #f59e0b88",borderRadius:7,fontSize:13,background:"#fff",color:"#1a1a1a",fontFamily:"inherit"}}/>
                    {(()=>{
                      const _n=(interessenten||[]).filter(i=>i.shootingType===(st.name||"")&&i.terminwahl===datum).length;
                      const _min=Number(min)||0;
                      const _voll=_min>0&&_n>=_min;
                      return(
                        <button onClick={()=>onShowInteressenten&&onShowInteressenten()} disabled={!onShowInteressenten}
                          title="Interessentenliste öffnen"
                          style={{border:`1px solid ${_voll?"#22c55e":"#f59e0b88"}`,background:_voll?"#22c55e22":"#fff",
                            color:_voll?"#15803d":"#92400e",borderRadius:999,padding:"4px 11px",fontSize:12,fontWeight:700,
                            whiteSpace:"nowrap",width:145,textAlign:"center",flexShrink:0,
                            cursor:onShowInteressenten?"pointer":"default",fontFamily:"inherit"}}>
                          {_n} Interessent{_n!==1?"en":""} ›
                        </button>
                      );
                    })()}
                    <div style={{display:"flex",alignItems:"center",gap:4}}>
                      <span style={{fontSize:11,color:"#92400e",whiteSpace:"nowrap"}}>Min.</span>
                      <input type="number" min="1" max="999" value={min} onChange={e=>update("min",e.target.value)}
                        placeholder="—" style={{width:54,padding:"7px 8px",border:"1px solid #f59e0b88",borderRadius:7,fontSize:13,background:"#fff",color:"#1a1a1a",fontFamily:"inherit"}}/>
                    </div>
                    <button onClick={()=>{const n=[...(st.terminoptionen||[])];n.splice(i,1);onChange({...st,terminoptionen:n});}}
                      style={{background:"none",border:"none",color:"#b45309",cursor:"pointer",fontSize:16,padding:"0 4px"}}
                      onMouseEnter={e=>e.currentTarget.style.color="#e53"}
                      onMouseLeave={e=>e.currentTarget.style.color="#b45309"}>✕</button>
                  </div>
                );
              })}
              <button onClick={()=>onChange({...st,terminoptionen:[...(st.terminoptionen||[]),{datum:"",min:""}]})}
                style={{background:"none",border:"1px dashed #f59e0b",borderRadius:7,padding:"6px 14px",fontSize:12,color:"#b45309",cursor:"pointer",marginTop:4}}>
                + Datum hinzufügen
              </button>
            </div>
          )}
          {!st.interessenliste&&(()=>{
            // Interesse ist aus, die Vormerkungen bleiben aber erreichbar,
            // damit die Shootingvereinbarung noch verschickt werden kann.
            const _liste=(interessenten||[]).filter(i=>i.shootingType===(st.name||""));
            if(_liste.length===0)return null;
            return(
              <div style={{background:"#fef9ee",border:"1px solid #f59e0b44",borderRadius:10,padding:"12px 16px",marginBottom:20,display:"flex",alignItems:"center",gap:12,flexWrap:"wrap"}}>
                <div style={{fontSize:13,fontWeight:700,color:"#b45309"}}>📋 Vorgemerkte Interessenten</div>
                <button onClick={()=>onShowInteressenten&&onShowInteressenten()} disabled={!onShowInteressenten}
                  title="Interessentenliste öffnen"
                  style={{border:"1px solid #f59e0b",background:"#f59e0b22",color:"#b45309",borderRadius:999,
                    padding:"4px 12px",fontSize:12,fontWeight:700,width:145,textAlign:"center",flexShrink:0,
                    cursor:onShowInteressenten?"pointer":"default",fontFamily:"inherit"}}>
                  {_liste.length} Interessent{_liste.length!==1?"en":""} ›
                </button>
                <span style={{fontSize:11,color:"#92400e",flex:1,minWidth:200}}>
                  Interesse ist ausgeschaltet, die Veranstaltung ist also buchbar. Die Vormerkungen bleiben erhalten, bis du sie benachrichtigst oder löschst.
                </span>
              </div>
            );
          })()}
          <div style={{fontSize:12,color:T.muted,marginBottom:12}}>Verfügbare Termine und Uhrzeiten für diesen Shooting-Typ.</div>
          <div style={{display:"flex",gap:10,marginBottom:14,padding:"12px 14px",background:T.bg,borderRadius:8,border:`1px solid ${T.border}`,flexWrap:"wrap",alignItems:"center"}}>
            <div style={{display:"flex",flexDirection:"column",gap:3}}>
              <label style={{fontSize:10,color:T.muted,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.07em"}}>Startzeit</label>
              <input type="time" value={slotStart} onChange={e=>setSlotStart(e.target.value)} style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:6,padding:"5px 8px",color:T.text,fontSize:12,fontFamily:"inherit",outline:"none"}}/>
            </div>
            <div style={{display:"flex",flexDirection:"column",gap:3}}>
              <label style={{fontSize:10,color:T.muted,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.07em"}}>Dauer (Min.)</label>
              <input type="number" min={5} max={120} step={5} value={slotDauer||""} onChange={e=>{const v=e.target.value;setSlotDauer(v===''?'':Number(v));}} style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:6,padding:"5px 8px",color:T.text,fontSize:12,fontFamily:"inherit",outline:"none",width:70}}/>
            </div>
            <div style={{display:"flex",flexDirection:"column",gap:3}}>
              <label style={{fontSize:10,color:T.muted,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.07em"}}>Endzeit</label>
              <input type="time" value={slotEnd} onChange={e=>setSlotEnd(e.target.value)} style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:6,padding:"5px 8px",color:T.text,fontSize:12,fontFamily:"inherit",outline:"none"}}/>
            </div>
            <div style={{fontSize:11,color:T.muted,alignSelf:"flex-end",paddingBottom:6}}>
              {(()=>{const z=genZeiten(slotStart,slotEnd,slotDauer);return `→ ${z.length} Slots: ${z.slice(0,3).join(", ")}${z.length>3?"...":""}`;})()}
            </div>
          </div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
          {(st.slots||[]).map(slot=>{
            const toMin=t=>{const p=String(t).split(":");return (+p[0])*60+(+p[1]||0);};
            const toStr=m=>`${String(Math.floor(m/60)).padStart(2,"0")}:${String(m%60).padStart(2,"0")}`;
            const z=[...slot.zeiten].sort((a,b)=>toMin(a)-toMin(b));
            const von=slot.von||z[0]||"";
            let bis=slot.bis;
            if(!bis&&z.length>=2)bis=toStr(toMin(z[z.length-1])+(toMin(z[1])-toMin(z[0])));
            else if(!bis&&z.length===1)bis=z[0];
            const dauer=z.length>=2?toMin(z[1])-toMin(z[0]):slotDauer;
            return(
              <div key={slot.id} style={{background:"#6dbf6a18",borderRadius:10,padding:14,border:"1px solid #6dbf6a55"}}>
                <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:8}}>
                  <input type="date" value={slot.datum} onChange={e=>updateSlot(slot.id,"datum",e.target.value)} style={{...IS2,flex:1,padding:"7px 10px"}}/>
                  <button style={btn(T,"danger",true)} onClick={()=>deleteSlot(slot.id)}>✕</button>
                </div>
                {z.length>0&&(
                  <div style={{display:"flex",gap:6,marginBottom:10,flexWrap:"wrap"}}>
                    <span style={{fontSize:11,background:"#6dbf6a33",border:"1px solid #6dbf6a55",borderRadius:6,padding:"3px 8px",color:"#3a7a38"}}>🕐 {von}–{bis} Uhr</span>
                    <span style={{fontSize:11,background:"#6dbf6a33",border:"1px solid #6dbf6a55",borderRadius:6,padding:"3px 8px",color:"#3a7a38"}}>⏱ {dauer} Min.</span>
                    <span style={{fontSize:11,background:"#6dbf6a33",border:"1px solid #6dbf6a55",borderRadius:6,padding:"3px 8px",color:"#3a7a38"}}>📋 {z.length} Slots</span>
                    {(slot.booked||[]).length>0&&<span style={{fontSize:11,background:"#e5393522",border:"1px solid #e5393555",borderRadius:6,padding:"3px 8px",color:"#b71c1c"}}>🔴 {(slot.booked||[]).length} reserviert</span>}
                  </div>
                )}
                <div style={{display:"flex",flexWrap:"wrap",gap:5}}>
                  {z.map(zeit=>{const isReserv=(slot.booked||[]).includes(zeit);return(
                    <div key={zeit} title={isReserv?"Reserviert / gebucht — klicken zum Freigeben":"Frei — klicken zum Reservieren"} style={{display:"flex",alignItems:"center",gap:3,background:isReserv?"#e5393522":"#6dbf6a22",border:`1px solid ${isReserv?"#e5393555":"#6dbf6a55"}`,borderRadius:6,padding:"4px 9px"}}>
                      <span onClick={()=>{const cfg=JSON.parse(localStorage.getItem("sd_buchung_config")||"{}");const sts=cfg.shootingTypes||[];const idx=sts.findIndex(x=>x.id===st.id);if(idx<0)return;const sIdx=sts[idx].slots.findIndex(s=>s.id===slot.id);if(sIdx<0)return;const booked=sts[idx].slots[sIdx].booked||[];if(isReserv){sts[idx].slots[sIdx].booked=booked.filter(z=>z!==zeit);}else{sts[idx].slots[sIdx].booked=[...booked,zeit];}cfg.shootingTypes=sts;localStorage.setItem("sd_buchung_config",JSON.stringify(cfg));onChange({...st,slots:sts[idx].slots});}} style={{fontSize:12,color:isReserv?"#b71c1c":"#3a7a38",fontWeight:600,cursor:"pointer",userSelect:"none"}}>{isReserv?"🔴 ":"⚪ "}{zeit}</span>
                      <button onClick={()=>removeZeit(slot.id,zeit)} style={{background:"none",border:"none",cursor:"pointer",color:isReserv?"#b71c1c":"#3a7a38",fontSize:11,padding:0,lineHeight:1,opacity:0.6}}>✕</button>
                    </div>
                  );})}
                  <button style={btn(T,"ghost",true)} onClick={()=>addZeit(slot.id)}>+ Zeit</button>
                </div>
              </div>
            );
          })}
          </div>
          <button style={btn(T,"ghost",true)} onClick={addSlotDay}>+ Tag hinzufügen</button>
        </div>
      )}

      {/* Vereinbarung */}
      {tab==="vereinbarung"&&(()=>{
        const LANG_NAMES={de:"Deutsch",en:"English",...Object.fromEntries(SD_LANGS.map(l=>[l.id,l.name]))};
        // Get active sprachen from parent config - passed via closure won't work, use window hack
        // Instead show DE always + all non-DE langs that have text OR allow adding
        const allLangs=["de","en",...SD_LANGS.map(l=>l.id)];
        async function translateAll(){
          const deText=st.vereinbarung?.de||"";
          const deSlot=st.slotInfo?.de||"";
          if(!deText.trim()&&!deSlot.trim()){setTransErr("Bitte zuerst den deutschen Text eingeben.");return;}
          setTranslating(true);setTransErr("");
          const targets=allLangs.filter(l=>l!=="de");
          try{
            const srv=(()=>{
              let u=(localStorage.getItem("sd_server_url")||"").trim().replace(/\/+$/,"");
              if(!u||(location.protocol==="https:"&&u.startsWith("http://")))u=location.origin;
              return u;
            })();
            const resp=await fetch(srv+"/api/ki-uebersetzen",{
              method:"POST",
              headers:{"Content-Type":"application/json"},
              body:JSON.stringify({vereinbarung:deText,slotInfo:deSlot,sprachen:targets}),
            });
            const data=await resp.json();
            if(!data||!data.ok){setTransErr("Fehler: "+((data&&data.fehler)||"Antwort leer"));setTranslating(false);return;}
            const t=data.sprachen||{};
            const newVer={...st.vereinbarung};
            const newSlot={...st.slotInfo};
            targets.forEach(l=>{if(t[l]?.vereinbarung)newVer[l]=t[l].vereinbarung;if(t[l]?.slotInfo)newSlot[l]=t[l].slotInfo;});
            onChange({...st,vereinbarung:newVer,slotInfo:newSlot});
          }catch(e){setTransErr("Fehler: "+e.message);}
          setTranslating(false);
        }
        const vs=st.vereinbarungStyle||{};
        const vsFont=Number(vs.fontSize)||13;
        const vsLine=Number(vs.lineHeight)||1.7;
        const vsAlign=vs.align||"left";
        const vsFontFam=vs.fontFamily||"Georgia,serif";
        const VER_FONTS=[["Georgia,serif","Georgia"],["Arial,sans-serif","Arial"],["Helvetica,sans-serif","Helvetica"],["Verdana,sans-serif","Verdana"],["Trebuchet MS,sans-serif","Trebuchet MS"],["Times New Roman,serif","Times New Roman"],["Courier New,monospace","Courier New"]];
        const setVS=patch=>onChange({...st,vereinbarungStyle:{...(st.vereinbarungStyle||{}),...patch}});
        function wrapVer(before,after){
          const ta=document.getElementById("sd-vereinb-de-ta");
          if(!ta)return;
          const a=ta.selectionStart,b=ta.selectionEnd;
          const cur=st.vereinbarung?.de||"";
          const sel=cur.slice(a,b)||"Text";
          const newText=cur.slice(0,a)+before+sel+after+cur.slice(b);
          onChange({...st,vereinbarung:{...st.vereinbarung,de:newText}});
          setTimeout(()=>{ta.focus();ta.setSelectionRange(a+before.length,a+before.length+sel.length);},10);
        }
        const verToolbar=(
          <div style={{display:"flex",gap:6,alignItems:"center",margin:"4px 0 6px",flexWrap:"wrap"}}>
            <button onClick={()=>wrapVer("**","**")} title="Fett" style={{background:"transparent",border:`1px solid ${T.border}`,borderRadius:5,padding:"3px 9px",cursor:"pointer",color:T.text,fontSize:12,fontFamily:"inherit",fontWeight:"bold"}}>B</button>
            <button onClick={()=>wrapVer("_","_")} title="Kursiv" style={{background:"transparent",border:`1px solid ${T.border}`,borderRadius:5,padding:"3px 9px",cursor:"pointer",color:T.text,fontSize:12,fontFamily:"inherit",fontStyle:"italic"}}>I</button>
            <select onChange={e=>{if(e.target.value){wrapVer(`[${e.target.value}]`,"[/size]");e.target.value="";}}} style={{...IS(T),width:80,padding:"3px 6px",fontSize:11}} title="Größe auf markierten Text">
              <option value="">Größe</option>
              {[11,12,13,14,16,18,20,24].map(s=><option key={s} value={s+"px"}>{s}px</option>)}
            </select>
            <span style={{fontSize:10,color:T.muted}}>Text markieren, dann Knopf</span>
          </div>
        );
        return(
          <div style={{display:"flex",flexDirection:"column",gap:14}}>
            <div style={{background:T.tile,border:`1px solid ${T.border}`,borderRadius:10,padding:14,display:"flex",flexDirection:"column",gap:12}}>
              <div style={{fontSize:12,fontWeight:700,color:T.text}}>🎨 Darstellung im Buchungsformular</div>
              <div style={{display:"flex",gap:12,flexWrap:"wrap"}}>
                <div style={{flex:1,minWidth:130}}>
                  <label style={{fontSize:11,color:T.muted,fontWeight:600,display:"block",marginBottom:4}}>Schriftgröße: {vsFont}px</label>
                  <input type="range" min="10" max="24" step="1" value={vsFont} onChange={e=>setVS({fontSize:Number(e.target.value)})} style={{width:"100%",accentColor:T.accent}}/>
                </div>
                <div style={{flex:1,minWidth:130}}>
                  <label style={{fontSize:11,color:T.muted,fontWeight:600,display:"block",marginBottom:4}}>Zeilenabstand: {vsLine}</label>
                  <input type="range" min="1" max="2.5" step="0.1" value={vsLine} onChange={e=>setVS({lineHeight:Number(e.target.value)})} style={{width:"100%",accentColor:T.accent}}/>
                </div>
              </div>
              <div>
                <label style={{fontSize:11,color:T.muted,fontWeight:600,display:"block",marginBottom:4}}>Schriftart</label>
                <select value={vsFontFam} onChange={e=>setVS({fontFamily:e.target.value})} style={{...IS(T),padding:"7px 10px",fontSize:12}}>
                  {VER_FONTS.map(([v,l])=><option key={v} value={v} style={{fontFamily:v}}>{l}</option>)}
                </select>
              </div>
              <div>
                <label style={{fontSize:11,color:T.muted,fontWeight:600,display:"block",marginBottom:4}}>Ausrichtung</label>
                <div style={{display:"flex",gap:8}}>
                  {[["left","Links"],["center","Mittig"],["right","Rechts"]].map(([v,lbl])=>(
                    <button key={v} onClick={()=>setVS({align:v})}
                      style={{flex:1,padding:"8px",borderRadius:8,border:`2px solid ${vsAlign===v?T.accent:T.border}`,background:vsAlign===v?T.accentDim:"transparent",color:T.text,fontSize:12,fontWeight:600,cursor:"pointer",fontFamily:"inherit"}}>{lbl}</button>
                  ))}
                </div>
              </div>
            </div>
            <div>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:5}}>
                <label style={{fontSize:12,color:T.muted,fontWeight:600}}>🇩🇪 Deutsch (Quelle)</label>
                <button style={btn(T,"primary",true)} onClick={translateAll} disabled={translating}>{translating?"⏳ Übersetze...":"✨ Automatisch übersetzen"}</button>
              </div>
              {verToolbar}
              <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(280px,1fr))",gap:14,alignItems:"stretch"}}>
                <TextVorlageZeile T={T} label="Bearbeiten" hint="" taId="sd-vereinb-de-ta" taStyle={{fontFamily:vsFontFam,minHeight:300}} aktuell={st.vereinbarung?.de||""} storageKey="sd_txt_vereinb_de" minH={300} onChange2={v=>onChange({...st,vereinbarung:{...st.vereinbarung,de:v}})}/>
                <div style={{display:"flex",flexDirection:"column"}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:6}}>
                    <label style={{fontSize:12,color:T.muted,fontWeight:600}}>Vorschau</label>
                    <button style={{...btn(T,"ghost",true),visibility:"hidden",pointerEvents:"none"}}>📁 Vorlagen</button>
                  </div>
                  <div style={{flex:1,minHeight:300,border:`1px solid ${T.border}`,borderRadius:8,padding:14,background:"#fff",color:"#1a1814",overflowY:"auto",fontFamily:vsFontFam,fontSize:vsFont,lineHeight:vsLine,textAlign:vsAlign}} dangerouslySetInnerHTML={{__html:mdToHtml(st.vereinbarung?.de||"")||"<span style='color:#aaa'>Vorschau …</span>"}}/>
                </div>
              </div>
              {transErr&&<div style={{fontSize:11,color:T.danger,marginTop:4}}>{transErr}</div>}
              <div style={{fontSize:11,color:T.muted,marginTop:4}}>Markiere Text und nutze B / I / Größe. Klicke auf "Automatisch übersetzen" um alle Sprachen zu befüllen.</div>
            </div>
            {allLangs.filter(l=>l!=="de").map(l=>(
              <div key={l}>
                <TextVorlageZeile T={T}
                  label={`${LANG_NAMES[l]||l.toUpperCase()}${st.vereinbarung?.[l]?" ✓":""}`}
                  hint=""
                  aktuell={st.vereinbarung?.[l]||""}
                  storageKey={`sd_txt_vereinb_${l}`}
                  minH={80}
                  onChange2={v=>onChange({...st,vereinbarung:{...st.vereinbarung,[l]:v}})}/>
              </div>
            ))}
          </div>
        );
      })()}

      {/* Beschreibungstexte */}
      {tab==="texte"&&(
        <div style={{display:"flex",flexDirection:"column",gap:16}}>
          <div style={{display:"flex",flexDirection:"column",gap:6,paddingBottom:14,borderBottom:`1px solid ${T.border}`}}>
            <button style={{...btn(T,"primary",true),alignSelf:"flex-start"}} onClick={()=>{
              if(!st.buchungsUrl){alert("Diese Shooting-Art hat keinen Slug (Buchungs-URL) — die Landingpage kann nicht hochgeladen werden.");return;}
              const ev=(()=>{try{return JSON.parse(localStorage.getItem("sd_events")||"[]").find(e=>e.id===st.eventId)||{};}catch{return {};}})();
              generateLandingPageFromEvent({
                id:ev.id||"",
                name:ev.name||st.name,
                fotoart:ev.shootingart||ev.fotoart||st.name,
                date:ev.date||"",
                dateBis:ev.dateBis||"",
                location:ev.location||"",
                locationLat:f.locationLat||ev.locationLat||null,
                locationLng:f.locationLng||ev.locationLng||null,
                info:ev.info||st.beschreibung?.de||"",
                kopfbereich:st.kopfbereich||"",
                kopfbereich_en:st.kopfbereich_en||"",
                event_info_en:st.event_info_en||"",
                event_info:st.event_info||"",
                adresse:ev.adresse||{},
                kontakt:ev.kontakt||{},
                buchungsUrl:st.buchungsUrl,
                hp_beschreibung:st.hp_beschreibung||"",
                slug:st.buchungsUrl||"",
              },{scarcityText:st.scarcityText||""});
            }}><Ic n="globe" s={13}/> Landingpage aktualisieren</button>
            <div style={{fontSize:11,color:T.muted}}>Lädt die Landingpage mit den aktuellen Texten neu hoch und öffnet sie zur Kontrolle.</div>
          </div>
          <div style={{marginBottom:14}}>
            <div style={{fontSize:12,fontWeight:600,color:T.muted,marginBottom:6}}>📢 Scarcity-Text (Landing Page, unter "Jetzt Termin sichern")</div>
            <input type="text" value={st.scarcityText||""} onChange={e=>onChange({...st,scarcityText:e.target.value})} placeholder="Nur noch wenige Termine — Sonntag, 06. September 2026" style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:"8px 12px",color:T.text,fontSize:13,fontFamily:"inherit",outline:"none",width:"100%",boxSizing:"border-box"}}/>
            <div style={{fontSize:11,color:T.muted,marginTop:4}}>Leer lassen = kein Text wird angezeigt</div>
          </div>
          <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:12,flexWrap:"wrap"}}>
            <span style={{fontSize:13,color:T.text,fontWeight:600}}>Dritte Sprache</span>
            <select value={SD_L3(config)} disabled={!setConfig} onChange={e=>{
                const v=e.target.value;
                setConfig&&setConfig(c=>({...c,sprachen:v?["de","en",v]:["de","en"]}));
              }} style={{...IS(T),width:220,fontSize:12}}>
              <option value="">Keine</option>
              {SD_LANGS.map(l=><option key={l.id} value={l.id}>{l.name}</option>)}
            </select>
            <span style={{fontSize:11,color:T.muted}}>
              Deutsch und English sind immer aktiv. Die Auswahl gilt für alle Shootings und blendet in jeder Reihe eine dritte Spalte ein.
            </span>
          </div>
          <div style={{display:"flex",flexDirection:"column",gap:14}}>
            <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:14}}>
              <div style={{borderLeft:"3px solid #22c55e",background:"#22c55e14",border:"1px solid #22c55e33",borderLeftWidth:3,borderRadius:8,padding:10}}>
                <RichEditor T={T} label="Info Event" hint="(Landingpage: &quot;Das Event&quot;)" aktuell={st.event_info||""} storageKey="sd_txt_event_info" onChange2={v=>onChange({...st,event_info:v})}/>
              </div>
              <div style={{borderLeft:"3px solid #22c55e",background:"#22c55e14",border:"1px solid #22c55e33",borderLeftWidth:3,borderRadius:8,padding:10}}>
                <RichEditor T={T} label="Info Event (English)" aktuell={st.event_info_en||""} storageKey="sd_txt_event_info_en" onChange2={v=>onChange({...st,event_info_en:v})}/>
              </div>
              {SD_L3(config)&&(
                <div style={{borderLeft:"3px solid #22c55e",background:"#22c55e14",border:"1px solid #22c55e33",borderLeftWidth:3,borderRadius:8,padding:10}}>
                  <RichEditor T={T} label={"Info Event ("+SD_LANG_NAME(SD_L3(config))+")"} aktuell={st.event_info_l3||""} storageKey="sd_txt_event_info_l3" onChange2={v=>onChange({...st,event_info_l3:v})}/>
                </div>
              )}
            </div>
            <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:14}}>
              <div style={{borderLeft:"3px solid #3b82f6",background:"#3b82f614",border:"1px solid #3b82f633",borderLeftWidth:3,borderRadius:8,padding:10}}>
                <RichEditor T={T} label="Beschreibung Deutsch" hint="(unter dem Shooting-Namen)" aktuell={st.beschreibung?.de||""} storageKey="sd_txt_beschr_de" onChange2={v=>onChange({...st,beschreibung:{...st.beschreibung,de:v}})}/>
              </div>
              <div style={{borderLeft:"3px solid #3b82f6",background:"#3b82f614",border:"1px solid #3b82f633",borderLeftWidth:3,borderRadius:8,padding:10}}>
                <RichEditor T={T} label="Description (English)" aktuell={st.beschreibung?.en||""} storageKey="sd_txt_beschr_en" onChange2={v=>onChange({...st,beschreibung:{...st.beschreibung,en:v}})}/>
              </div>
              {SD_L3(config)&&(
                <div style={{borderLeft:"3px solid #3b82f6",background:"#3b82f614",border:"1px solid #3b82f633",borderLeftWidth:3,borderRadius:8,padding:10}}>
                  <RichEditor T={T} label={"Beschreibung ("+SD_LANG_NAME(SD_L3(config))+")"} aktuell={st.beschreibung?.l3||""} storageKey="sd_txt_beschr_l3" onChange2={v=>onChange({...st,beschreibung:{...st.beschreibung,l3:v}})}/>
                </div>
              )}
            </div>
            <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:14}}>
              <div style={{borderLeft:"3px solid #ef4444",background:"#ef444414",border:"1px solid #ef444433",borderLeftWidth:3,borderRadius:8,padding:10}}>
                <RichEditor T={T} label="Text Kopfbereich" hint="(Landingpage, unter dem Eventnamen)" aktuell={st.kopfbereich||""} storageKey="sd_txt_kopfbereich" onChange2={v=>onChange({...st,kopfbereich:v})}/>
              </div>
              <div style={{borderLeft:"3px solid #ef4444",background:"#ef444414",border:"1px solid #ef444433",borderLeftWidth:3,borderRadius:8,padding:10}}>
                <RichEditor T={T} label="Text Header (English)" aktuell={st.kopfbereich_en||""} storageKey="sd_txt_kopfbereich_en" onChange2={v=>onChange({...st,kopfbereich_en:v})}/>
              </div>
              {SD_L3(config)&&(
                <div style={{borderLeft:"3px solid #ef4444",background:"#ef444414",border:"1px solid #ef444433",borderLeftWidth:3,borderRadius:8,padding:10}}>
                  <RichEditor T={T} label={"Text Header ("+SD_LANG_NAME(SD_L3(config))+")"} aktuell={st.kopfbereich_l3||""} storageKey="sd_txt_kopfbereich_l3" onChange2={v=>onChange({...st,kopfbereich_l3:v})}/>
                </div>
              )}
            </div>
            <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:14}}>
              <div style={{borderLeft:"3px solid #eab308",background:"#eab30814",border:"1px solid #eab30833",borderLeftWidth:3,borderRadius:8,padding:10}}>
                <RichEditor T={T} label="Text über Zeitslot" hint="(eine Zeile = ein Punkt in der Liste)" aktuell={st.slotInfo?.de||""} storageKey="sd_txt_slotinfo_de" onChange2={v=>onChange({...st,slotInfo:{...st.slotInfo,de:v}})}/>
              </div>
              <div style={{borderLeft:"3px solid #eab308",background:"#eab30814",border:"1px solid #eab30833",borderLeftWidth:3,borderRadius:8,padding:10}}>
                <RichEditor T={T} label="Slot Info (English)" aktuell={st.slotInfo?.en||""} storageKey="sd_txt_slotinfo_en" onChange2={v=>onChange({...st,slotInfo:{...st.slotInfo,en:v}})}/>
              </div>
              {SD_L3(config)&&(
                <div style={{borderLeft:"3px solid #eab308",background:"#eab30814",border:"1px solid #eab30833",borderLeftWidth:3,borderRadius:8,padding:10}}>
                  <RichEditor T={T} label={"Slot Info ("+SD_LANG_NAME(SD_L3(config))+")"} aktuell={st.slotInfo?.l3||""} storageKey="sd_txt_slotinfo_l3" onChange2={v=>onChange({...st,slotInfo:{...st.slotInfo,l3:v}})}/>
                </div>
              )}
            </div>
            <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:14}}>
              <div style={{borderLeft:"3px solid #a855f7",background:"#a855f714",border:"1px solid #a855f733",borderLeftWidth:3,borderRadius:8,padding:10}}>
                <RichEditor T={T} label="Homepage Widget" hint="(Beschreibung für Homepage, Kurztext in der Kachel)" aktuell={st.hp_beschreibung||""} storageKey="sd_txt_hp_beschr" onChange2={v=>onChange({...st,hp_beschreibung:v})}/>
              </div>
              <div style={{borderLeft:"3px solid #a855f7",background:"#a855f714",border:"1px solid #a855f733",borderLeftWidth:3,borderRadius:8,padding:10}}>
                <RichEditor T={T} label="Homepage Widget Slogan" hint="(unter dem Shooting-Namen)" aktuell={st.hp_slogan||""} storageKey="sd_txt_hp_slogan" onChange2={v=>onChange({...st,hp_slogan:v})}/>
              </div>
            </div>
          </div>
          {st.interessenliste&&(
            <div style={{background:"#fef9ee",border:"1px solid #f59e0b44",borderRadius:10,padding:16}}>
              <div style={{fontSize:12,fontWeight:700,color:"#b45309",marginBottom:8}}>📋 Infotext Interessenten-Seite</div>
              <div style={{fontSize:11,color:"#92400e",marginBottom:10}}>Wird angezeigt wenn ein Interessent dieses Shooting auswählt — z.B. Preise, Ablauf, was ihn erwartet.</div>
              <RichEditor T={T} label="" aktuell={st.interesse_info||""} storageKey="sd_txt_interesse_info" minH={100} onChange2={v=>onChange({...st,interesse_info:v})}/>
            </div>
          )}
          <div style={{borderTop:`1px solid ${T.border}`,paddingTop:14}}>
            <label style={{fontSize:12,color:T.muted,fontWeight:600,display:"block",marginBottom:8}}>Größen (Buchungsseite)</label>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:16}}>
              {[
                {k:"logoHeight",label:"Logo-Höhe (px)",def:60,min:20,max:200},
                {k:"logoMaxWidth",label:"Logo-Breite max (px)",def:220,min:60,max:500},
                {k:"titelSize",label:"Veranstaltungsname (px)",def:28,min:14,max:60},
                {k:"beschrSize",label:"Beschreibung (px)",def:14,min:10,max:30},
              ].map(({k,label,def,min,max})=>(
                <div key={k} style={{padding:"12px 14px",background:T.bg,borderRadius:8,border:`1px solid ${T.border}`}}>
                  <label style={{fontSize:11,color:T.muted,fontWeight:600,display:"block",marginBottom:8}}>{label}</label>
                  <div style={{display:"flex",alignItems:"center",gap:10}}>
                    <input type="range" min={min} max={max} value={st.style?.[k]||def}
                      onChange={e=>onChange({...st,style:{...(st.style||{}),[k]:Number(e.target.value)}})}
                      style={{flex:1,accentColor:T.accent}}/>
                    <span style={{fontSize:13,color:T.text,minWidth:34,textAlign:"right",fontWeight:600}}>{st.style?.[k]||def}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div style={{borderTop:`1px solid ${T.border}`,paddingTop:14}}>
            <label style={{fontSize:12,color:T.muted,fontWeight:600,display:"block",marginBottom:5}}>Buchungs-URL Slug</label>
            <div style={{display:"flex",alignItems:"center",gap:8}}>
              <span style={{fontSize:12,color:T.muted}}>deinedomain.de/buchen/</span>
              <input value={st.buchungsUrl||""} onChange={e=>onChange({...st,buchungsUrl:(n=>(n||"").toLowerCase().replace(/ä/g,"ae").replace(/ö/g,"oe").replace(/ü/g,"ue").replace(/ß/g,"ss").replace(/[^a-z0-9]+/g,"-").replace(/^-+|-+$/g,""))(e.target.value)})} style={{...IS(T),flex:1}}/>
            </div>
            <div style={{fontSize:10,color:T.muted,marginTop:4}}>deinedomain.de/buchen/<strong>{st.buchungsUrl||"..."}</strong></div>
          </div>
        </div>
      )}

      {/* Zahlung */}
      {tab==="zahlung"&&(
        <div style={{display:"flex",flexDirection:"column",gap:16}}>
          <div style={{fontSize:13,color:T.muted}}>Lege fest wie Kunden für dieses Shooting bezahlen.</div>

          {/* Auf Homepage anzeigen */}
          <div style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:10,padding:16,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <div>
              <div style={{fontSize:13,fontWeight:700,color:T.text}}>🌐 Auf Homepage anzeigen</div>
              <div style={{fontSize:11,color:T.muted,marginTop:2}}>Dieses Shooting im Homepage-Widget anzeigen</div>
            </div>
            <div onClick={()=>onChange({...st,hp_aktiv:st.hp_aktiv!==true})}
              style={{width:44,height:24,borderRadius:12,background:st.hp_aktiv!==false?"#4caf50":T.border,position:"relative",cursor:"pointer",transition:"background 0.2s",flexShrink:0}}>
              <div style={{position:"absolute",top:3,left:st.hp_aktiv!==false?21:3,width:18,height:18,borderRadius:"50%",background:"#fff",transition:"left 0.2s",boxShadow:"0 1px 3px rgba(0,0,0,0.3)"}}/>
            </div>
          </div>

          {/* Interessenliste */}
          <div style={{background:T.bg,border:`1px solid ${st.interessenliste?"#f59e0b":T.border}`,borderRadius:10,padding:16}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              <div>
                <div style={{fontSize:13,fontWeight:700,color:T.text}}>📋 Interessenliste aktiv</div>
                <div style={{fontSize:11,color:T.muted,marginTop:2}}>Interessenten können sich unverbindlich vormerken lassen</div>
              </div>
              <div onClick={()=>{
  interesseUmschalten();
}}
                style={{width:44,height:24,borderRadius:12,background:st.interessenliste?"#f59e0b":T.border,position:"relative",cursor:"pointer",transition:"background 0.2s",flexShrink:0}}>
                <div style={{position:"absolute",top:3,left:st.interessenliste?21:3,width:18,height:18,borderRadius:"50%",background:"#fff",transition:"left 0.2s",boxShadow:"0 1px 3px rgba(0,0,0,0.3)"}}/>
              </div>
            </div>
            {st.interessenliste&&(
              <div style={{marginTop:16,borderTop:`1px solid ${T.border}`,paddingTop:16}}>
                <div style={{fontSize:11,color:T.muted}}>Terminoptionen (Datum) im Tab <strong>Zeitslots</strong> einpflegen. Pflichtfelder im Tab <strong>📋 Pflichtfelder</strong> konfigurieren.</div>
              </div>
            )}
          </div>
          <div style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:10,padding:16}}>
            <div style={{fontSize:12,fontWeight:700,color:T.text,marginBottom:12}}>Zahlungsart</div>
            <div style={{display:"flex",gap:12,flexWrap:"wrap"}}>
              {[
                {id:"vorab",label:"💳 Vorab",desc:"Kunde zahlt nach Buchung per Überweisung oder PayPal."},
                {id:"vorort",label:"💵 Vor Ort",desc:"Kunde zahlt am Shooting-Tag. Kein Zahlungsschritt im Formular."},
              ].map(opt=>{
                const aktiv=(st.zahlungsart||"vorab")===opt.id;
                return(
                  <div key={opt.id} onClick={()=>onChange({...st,zahlungsart:opt.id})}
                    style={{flex:1,minWidth:180,padding:"16px 18px",borderRadius:10,border:`2px solid ${aktiv?T.accent:T.border}`,background:aktiv?T.accentDim:"transparent",cursor:"pointer",transition:"all 0.15s"}}>
                    <div style={{fontSize:14,fontWeight:700,color:aktiv?T.accent:T.text,marginBottom:6}}>{opt.label}</div>
                    <div style={{fontSize:12,color:T.muted,lineHeight:1.5}}>{opt.desc}</div>
                    {aktiv&&<div style={{marginTop:10,fontSize:11,color:T.accent,fontWeight:600}}>✓ Aktiv</div>}
                  </div>
                );
              })}
            </div>
          </div>
          {(st.zahlungsart==="vorort")&&(
            <div style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:10,padding:16}}>
              <div style={{fontSize:12,fontWeight:700,color:T.text,marginBottom:8}}>Hinweistext im Buchungsformular</div>
              <textarea
                value={st.vorortHinweis||"Die Shootinggebühr von {preis} € bezahlen Sie bequem vor Ort (Bar oder Kartenzahlung)."}
                onChange={e=>onChange({...st,vorortHinweis:e.target.value})}
                rows={3}
                style={{width:"100%",background:T.surface,border:`1px solid ${T.border}`,borderRadius:8,padding:"9px 12px",color:T.text,fontSize:13,resize:"vertical",outline:"none",fontFamily:"inherit",lineHeight:1.6,boxSizing:"border-box"}}/>
              <div style={{fontSize:10,color:T.muted,marginTop:4}}>{"{preis}"} wird durch den Betrag ersetzt.</div>
            </div>
          )}
          <div style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:10,padding:16}}>
            <div style={{fontSize:12,fontWeight:700,color:T.text,marginBottom:8}}>Shootinggebühr (€)</div>
            <input type="number" value={st.preis||0}
              onChange={e=>onChange({...st,preis:Number(e.target.value)})}
              style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:8,padding:"9px 12px",color:T.accent,fontSize:16,fontWeight:700,fontFamily:"inherit",outline:"none",width:120}}/>
            <div style={{fontSize:11,color:T.muted,marginTop:6}}>0 = kostenlos, kein Zahlungsschritt.</div>
            <div style={{fontSize:12,fontWeight:700,color:T.text,margin:"16px 0 8px"}}>
              Aufpreis je weiterem Hund (€){st.eventId?" — kommt aus der Veranstaltung":""}
            </div>
            <input type="number" value={st.preisWeitererHund||0} disabled={!!st.eventId}
              onChange={e=>onChange({...st,preisWeitererHund:Number(e.target.value)})}
              style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:8,padding:"9px 12px",color:T.accent,fontSize:16,fontWeight:700,fontFamily:"inherit",outline:"none",width:140}}/>
            <div style={{fontSize:11,color:T.muted,marginTop:6}}>
              Gilt ab dem zweiten Tier. Bei 99 € Gebühr und 49 € Aufpreis zahlt ein Kunde
              mit drei Hunden 197 €. 0 = kein Aufpreis.
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ── Buchungen Verwaltung ──────────────────────────────────────────────────────
function SlotReservierenModal({shootingType,onClose,T}){
  const st=shootingType||{};
  const [email,setEmail]=useState("");
  const [name,setName]=useState("");
  const [telefon,setTelefon]=useState("");
  const [slot,setSlot]=useState(null);
  const [status,setStatus]=useState("");
  const [sending,setSending]=useState(false);
  const [zahlungModus,setZahlungModus]=useState("jetzt");
  const [nameSugg,setNameSugg]=useState([]);
  const [lokalBelegt,setLokalBelegt]=useState(new Set());
  const allKunden=(()=>{try{return JSON.parse(localStorage.getItem("sd_customers")||"[]");}catch{return [];}})();

  function onNameChange(v){
    setName(v);
    if(v.length>=2){
      const vl=v.toLowerCase();
      setNameSugg(allKunden.filter(k=>(k.name||"").toLowerCase().includes(vl)).slice(0,6));
    } else setNameSugg([]);
  }
  function pickKunde(k){
    setName(k.name||"");
    setEmail(k.email||"");
    setTelefon(k.telefon||k.phone||"");
    setNameSugg([]);
  }
  const VORORT_DEFAULT="Die Shootinggebühr von {preis} € bezahlen Sie bequem vor Ort (Bar oder Kartenzahlung).";
  const [vorortText,setVorortText]=useState(()=>{try{return localStorage.getItem("sd_vorort_text")||"";}catch{return "";}});
  function saveVorortText(v){setVorortText(v);try{localStorage.setItem("sd_vorort_text",v);}catch{}}

  // Manuell belegte Zeiten aus dem Veranstaltungsplan laden
  const manuellBelegt=(()=>{
    try{
      const plaene=JSON.parse(localStorage.getItem("sd_shootingplaene")||"{}");
      const evId=st.eventId||"";
      const plan=evId?(plaene[evId]||null):null;
      const eintraege=plan?.eintraege||plan?.teilnehmer||[];
      // Set von "datum|uhrzeit" Strings
      const belegt=new Set();
      eintraege.forEach(e=>{
        if(e.datum&&e.uhrzeit)belegt.add(`${e.datum}|${e.uhrzeit}`);
        // Auch nur Uhrzeit ohne Datum
        if(e.uhrzeit)belegt.add(`|${e.uhrzeit}`);
      });
      return belegt;
    }catch{return new Set();}
  })();

  const slots=((st.slots)||[]).flatMap(s=>
    ((s.zeiten)||[]).filter(z=>{
      if((s.booked||[]).includes(z))return false; // online gebucht
      if(manuellBelegt.has(`${s.datum}|${z}`))return false; // manuell belegt (mit Datum)
      if(lokalBelegt.has(`${s.datum}|${z}`))return false; // gerade reserviert
      return true;
    }).map(z=>({datum:s.datum||"",zeit:z}))
  ).filter(s=>{try{return s.datum&&new Date(s.datum)>=new Date(new Date().toDateString());}catch{return false;}});

  const serverUrl=(()=>{try{return(localStorage.getItem("sd_server_url")||"").trim().replace(/\/+$/,"");}catch{return "";}})();
  const baseUrl=(()=>{try{return localStorage.getItem("sd_qr_url")||serverUrl||"";}catch{return "";}})();
  const smtp=(()=>{try{const s=JSON.parse(localStorage.getItem("sd_smtp_info")||localStorage.getItem("sd_smtp_buchung")||localStorage.getItem("sd_smtp_settings")||"{}");return {...s,from_email:"info@m-h-photo.de"};}catch{return {};}})();
  const cfg=(()=>{try{return JSON.parse(localStorage.getItem("sd_buchung_config")||"{}");}catch{return {};}})();
  const iban=cfg.zahlung?.ueberweisung?.iban||smtp.iban||smtp.ueberweisung_iban||"";
  const ibanInhaber=cfg.zahlung?.ueberweisung?.inhaber||"";
  const paypal=cfg.zahlung?.paypal?.link||smtp.paypal||"";
  const studioName=(()=>{try{return JSON.parse(localStorage.getItem("sd_buchung_config")||"{}").studioName||"";}catch{return "";}})();
  const preis=Number(st.preis)||0;
  const slug=st.buchungsUrl||(st.name||"").toLowerCase().replace(/ä/g,"ae").replace(/ö/g,"oe").replace(/ü/g,"ue").replace(/ß/g,"ss").replace(/[^a-z0-9]+/g,"-").replace(/^-+|-+$/g,"");
  const link=slot&&baseUrl?`${baseUrl.replace(/\/+$/,"")}/buchen/${slug}?datum=${slot.datum}&slot=${encodeURIComponent(slot.zeit)}`:"";

  async function senden(){
    if(!email){alert("Bitte E-Mail-Adresse eingeben.");return;}
    if(!slot){alert("Bitte einen Zeitslot auswählen.");return;}
    if(!link){alert("Bitte Server-URL in den Einstellungen eintragen.");return;}
    setSending(true);setStatus("");
    try{
      let zahlText="";
      if(preis>0){
        if(zahlungModus==="vorort"){
          const _vt=(vorortText||VORORT_DEFAULT).replace("{preis}",preis.toFixed(2));
          zahlText=`\n\n💵 ${_vt}`;
        } else {
          zahlText=`\n\n💳 Zahlungsbetrag: ${preis.toFixed(2)} €${iban?`\n\nÜberweisung:\n${ibanInhaber?`Name: ${ibanInhaber}\n`:""}IBAN: ${iban}\nBetreff: ${name||email} – ${st.name}`:""}${paypal?`\n\nPayPal: ${paypal}`:""}`;
        }
      } else {
        zahlText="\n\nDieses Shooting ist kostenlos.";
      }
      // Vorlage laden
      const _vlAll=(()=>{try{return JSON.parse(localStorage.getItem("sd_email_vorlagen")||"{}");}catch{return {};}})();
      const _vl=_vlAll.slotreservierung||{};
      const _datumFmt=new Date(slot.datum).toLocaleDateString("de-DE",{weekday:"long",day:"2-digit",month:"long",year:"numeric"});
      const _repl=(s)=>s.replace(/{{name}}/g,name||"").replace(/{{datum}}/g,_datumFmt).replace(/{{uhrzeit}}/g,slot.zeit).replace(/{{(shooting|event|veranstaltung)}}/g,st.name).replace(/{{link}}/g,link).replace(/{{studio}}/g,studioName);
      const _defaultText=`Hallo${name?" "+name:""},\n\nIch habe für dich folgenden Termin reserviert:\n\n📅 ${_datumFmt}\n🕐 ${slot.zeit}\n📷 ${st.name}${zahlText}\n\n✍️ Bitte fülle jetzt dein Buchungsformular aus und unterschreibe die Vereinbarung:\n${link}\n\nBei Fragen stehe ich gerne zur Verfügung.\n\nHerzliche Grüße\n${studioName}`;
      const text=_vl.text?_repl(_vl.text)+zahlText:_defaultText;
      const _subjectDefault=`Terminreservierung: ${st.name} am ${new Date(slot.datum).toLocaleDateString("de-DE")}`;
      const _subject=_vl.betreff?_repl(_vl.betreff):_subjectDefault;
      const r=await fetch(`${serverUrl}/api/newsletter`,{
        method:"POST",headers:{"Content-Type":"application/json"},
        body:JSON.stringify({
          smtp,
          subject:_subject,
          text,
          html:buildScattoDeskMailHtml(text,_getSig().logo,_getSig().text),
          logo:_getSig().logo,
          recipients:[{email,name:name||email}],
        })
      });
      const d=await r.json();
      if(d.ok||d.sent){
        setLokalBelegt(prev=>new Set([...prev,`${slot.datum}|${slot.zeit}`]));
        setSlot(null);
        setStatus("✅ E-Mail gesendet! Slot ist nun als belegt markiert.");
        // Slot als gebucht markieren
        try{
          const cfg2=JSON.parse(localStorage.getItem("sd_buchung_config")||"{}");
          const sts=cfg2.shootingTypes||[];
          const idx=sts.findIndex(s=>s.id===st.id);
          if(idx>=0){
            const slotIdx=sts[idx].slots?.findIndex(s=>s.datum===slot.datum);
            if(slotIdx>=0){
              if(!sts[idx].slots[slotIdx].booked)sts[idx].slots[slotIdx].booked=[];
              sts[idx].slots[slotIdx].booked.push(slot.zeit);
              cfg2.shootingTypes=sts;
              localStorage.setItem("sd_buchung_config",JSON.stringify(cfg2));
            }
          }
        }catch(ex){console.error("Slot-Markierung fehlgeschlagen:",ex);}
        // In Veranstaltungsplan eintragen
        try{
          const evId=st.eventId||"";
          if(evId){
            const plaene=JSON.parse(localStorage.getItem("sd_shootingplaene")||"{}");
            const plan=plaene[evId]||{eventId:evId,event_name:st.name||"",rows:[]};
            const rows=plan.rows||[];
            const nr=String(rows.length+1).padStart(2,"0");
            // Kundendaten aus Kontakten holen
            const kunden=JSON.parse(localStorage.getItem("sd_customers")||"[]");
            const kd=kunden.find(k=>k.email===email||k.name===name)||{};
            const tier=kd.tiere?.[0]||{};
            rows.push({
              id:"slot_"+Date.now(),
              nr,
              uhrzeit:slot.zeit,
              name:name||kd.name||"",
              email:email||kd.email||"",
              telefon:telefon||kd.telefon||kd.phone||"",
              strasse:kd.strasse||"",
              plz:kd.plz||"",
              ort:kd.ort||"",
              hund:tier.rasse||"",
              rasse:tier.name||"",
              geschlecht:tier.geschlecht||"",
              alter:tier.alter||"",
              alterMonate:tier.alterMonate||"",
              datum:slot.datum,
            });
            plaene[evId]={...plan,rows};
            localStorage.setItem("sd_shootingplaene",JSON.stringify(plaene));
          }
        }catch(ex){console.error("Veranstaltungsplan-Eintrag fehlgeschlagen:",ex);}
      }
      else setStatus("❌ Fehler: "+(d.error||JSON.stringify(d)));
    }catch(e){setStatus("❌ "+e.message);}
    setSending(false);
  }

  const IS={background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:"8px 12px",color:T.text,fontSize:13,fontFamily:"inherit",outline:"none",boxSizing:"border-box",width:"100%"};

  return(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.7)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:200,padding:20}} onClick={onClose}>
      <div onClick={e=>e.stopPropagation()} style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:16,padding:24,width:"100%",maxWidth:500,maxHeight:"90vh",overflowY:"auto"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
          <div style={{fontFamily:"Georgia,serif",fontSize:18,color:T.accent}}>Slot reservieren & Link senden</div>
          <button style={btn(T,"ghost",true)} onClick={onClose}>✕</button>
        </div>
        <div style={{fontSize:12,color:T.muted,marginBottom:16}}>Wähle einen Zeitslot und sende dem Kunden einen persönlichen Link zum Buchungsformular inkl. Zahlungsaufforderung.</div>

        <div style={{marginBottom:12}}>
          <label style={{fontSize:12,color:T.muted,fontWeight:600,display:"block",marginBottom:5}}>Zeitslot</label>
          {slots.length>0?(
            <select value={slot?`${slot.datum}|${slot.zeit}`:""}
              onChange={e=>{const[d,z]=e.target.value.split("|");setSlot(e.target.value?{datum:d,zeit:z}:null);}}
              style={IS}>
              <option value="">— Bitte wählen —</option>
              {slots.map((s,i)=><option key={i} value={`${s.datum}|${s.zeit}`}>{new Date(s.datum).toLocaleDateString("de-DE",{weekday:"short",day:"2-digit",month:"2-digit"})} · {s.zeit}</option>)}
            </select>
          ):<div style={{fontSize:12,color:T.muted,padding:"8px 0"}}>Keine freien Zeitslots verfügbar. Bitte zuerst Slots anlegen.</div>}
        </div>

        <div style={{marginBottom:10}}>
          <label style={{fontSize:12,color:T.muted,fontWeight:600,display:"block",marginBottom:5}}>Name des Kunden (optional)</label>
          <div style={{position:"relative"}}>
            <input value={name} onChange={e=>onNameChange(e.target.value)} placeholder="Max Mustermann" style={IS}/>
            {nameSugg.length>0&&<div style={{position:"absolute",top:"100%",left:0,right:0,background:T.surface,border:`1px solid ${T.border}`,borderRadius:8,zIndex:100,maxHeight:180,overflowY:"auto",boxShadow:"0 4px 12px rgba(0,0,0,0.15)"}}>
              {nameSugg.map(k=><div key={k.id} onClick={()=>pickKunde(k)} style={{padding:"8px 12px",cursor:"pointer",fontSize:13,borderBottom:`1px solid ${T.border}22`}} onMouseEnter={e=>e.currentTarget.style.background=T.bg} onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
                <div style={{fontWeight:600,color:T.text}}>{k.name}</div>
                <div style={{fontSize:11,color:T.muted}}>{k.email}</div>
              </div>)}
            </div>}
          </div>
          <label style={{fontSize:12,color:T.muted,fontWeight:600,display:"block",marginTop:10,marginBottom:5}}>Telefon / Handy</label>
          <input value={telefon} onChange={e=>setTelefon(e.target.value)} placeholder="+491718199782" style={IS}/>
        </div>
        <div style={{marginBottom:16}}>
          <label style={{fontSize:12,color:T.muted,fontWeight:600,display:"block",marginBottom:5}}>E-Mail des Kunden</label>
          <input value={email} onChange={e=>setEmail(e.target.value)} placeholder="kunde@email.de" type="email" style={IS}/>
        </div>

        {preis>0&&(
          <div style={{marginBottom:16}}>
            <label style={{fontSize:12,color:T.muted,fontWeight:600,display:"block",marginBottom:8}}>Zahlungsweise</label>
            <div style={{display:"flex",gap:8}}>
              {[["jetzt","💳 Jetzt bezahlen"],["vorort","💵 Vor Ort bezahlen"]].map(([v,l])=>(
                <button key={v} onClick={()=>setZahlungModus(v)}
                  style={{flex:1,padding:"10px 12px",borderRadius:8,border:`1px solid ${zahlungModus===v?T.accent:T.border}`,background:zahlungModus===v?T.accentDim:"transparent",color:zahlungModus===v?T.accent:T.muted,cursor:"pointer",fontSize:13,fontWeight:zahlungModus===v?600:400,transition:"all 0.15s"}}>
                  {l}
                </button>
              ))}
            </div>
            <div style={{fontSize:11,color:T.muted,marginTop:6}}>
              {zahlungModus==="jetzt"
                ?"Der Kunde erhält Zahlungsdaten per E-Mail und soll vor dem Shooting überweisen."
                :"Der Kunde zahlt direkt vor Ort — keine Zahlungsaufforderung in der E-Mail."}
              {zahlungModus==="vorort"&&(
                <div style={{marginTop:10}}>
                  <label style={{fontSize:11,color:T.muted,fontWeight:600,display:"block",marginBottom:4}}>Hinweistext in der E-Mail</label>
                  <textarea
                    value={vorortText||VORORT_DEFAULT}
                    onChange={e=>saveVorortText(e.target.value)}
                    placeholder={VORORT_DEFAULT}
                    rows={3}
                    style={{width:"100%",background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:"8px 10px",color:T.text,fontSize:12,resize:"vertical",outline:"none",fontFamily:"inherit",lineHeight:1.5}}/>
                  <div style={{fontSize:10,color:T.muted,marginTop:3}}>{"{preis}"} wird durch den Betrag ersetzt · <button onClick={()=>saveVorortText("")} style={{background:"none",border:"none",color:T.muted,cursor:"pointer",fontSize:10,padding:0,textDecoration:"underline"}}>Zurücksetzen</button></div>
                </div>
              )}
            </div>
          </div>
        )}

        {link&&(
          <div style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:12,marginBottom:16}}>
            <div style={{fontSize:11,color:T.muted,marginBottom:4}}>Persönlicher Buchungslink:</div>
            <div style={{fontSize:11,color:T.accent,wordBreak:"break-all"}}>{link}</div>
            <button style={{...btn(T,"ghost",true),marginTop:8,fontSize:11}} onClick={()=>{try{navigator.clipboard.writeText(link);alert("Link kopiert!");}catch{}}}>Link kopieren</button>
          </div>
        )}

        {preis>0&&zahlungModus==="jetzt"&&(
          <div style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:12,marginBottom:16,fontSize:12,color:T.muted}}>
            <div style={{fontWeight:600,color:T.text,marginBottom:4}}>Zahlungsdaten in der E-Mail:</div>
            <div>Betrag: <strong style={{color:T.accent}}>{preis.toFixed(2)} €</strong></div>
            {iban&&<div>{ibanInhaber&&<span>{ibanInhaber} · </span>}IBAN: {iban}</div>}
            {paypal&&<div>PayPal: {paypal}</div>}
            {!iban&&!paypal&&<div style={{color:"orange"}}>⚠️ Keine Zahlungsdaten hinterlegt. Bitte in Einstellungen → SMTP ergänzen.</div>}
          </div>
        )}

        {status&&<div style={{fontSize:13,marginBottom:12,color:status.startsWith("✅")?T.success:"#e53"}}>{status}</div>}

        <div style={{display:"flex",gap:8}}>
          <button style={btn(T,"ghost")} onClick={onClose}>Schließen</button>
          <button style={{...btn(T,"primary"),flex:1,justifyContent:"center"}} onClick={senden} disabled={sending}>
            {sending?"⏳ Sende...":"📧 E-Mail senden"}
          </button>
        </div>
      </div>
    </div>
  );
}

function ManuelBuchungModal({config,shootingType,onSave,onClose,T}){
  const st=shootingType||{};
  const [slot,setSlot]=useState(null);
  const [datum,setDatum]=useState("");
  const [formData,setFormData]=useState({});
  const [sendEmail,setSendEmail]=useState(false);
  const [emailStatus,setEmailStatus]=useState("");

  const slots=(st.slots||[]).flatMap(s=>
    (s.zeiten||[]).filter(z=>!s.booked?.includes(z)).map(z=>({datum:s.datum,zeit:z}))
  ).filter(s=>new Date(s.datum)>=new Date(new Date().toDateString()));

  const IS={background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:"8px 12px",
    color:T.text,fontSize:13,fontFamily:"inherit",outline:"none",boxSizing:"border-box",width:"100%"};

  async function speichern(){
    if(!datum){alert("Bitte ein Datum wählen.");return;}
    const booking={
      id:uid(),
      shootingType:st.name,
      datum:slot?.datum||datum,
      uhrzeit:slot?.zeit||"",
      formData,
      tiere:[],
      signature:"",
      lang:"de",
      timestamp:new Date().toISOString(),
      status:"neu",
      manuell:true,
    };

    if(sendEmail&&formData.sys_email){
      setEmailStatus("⏳ Sende...");
      try{
        const smtp=(()=>{try{const s=JSON.parse(localStorage.getItem("sd_smtp_info")||localStorage.getItem("sd_smtp_buchung")||localStorage.getItem("sd_smtp_settings")||"{}");return {...s,from_email:"info@m-h-photo.de"};}catch{return {};}})();
        const serverUrl=(localStorage.getItem("sd_server_url")||"").trim().replace(/\/+$/,"");
        const preis=Number(st.preis)||0;
        const zahlText=preis>0?`\n\nZahlungsbetrag: ${preis.toFixed(2)} €\nBitte überweise den Betrag an:\nName: ${smtp.from||config.studioName||""}\nIBAN: ${config.zahlung?.ueberweisung?.iban||""}\nBetreff: ${formData.sys_name||""} – ${st.name}`:"";
        const _bText=`Hallo ${formData.sys_name||""},\n\nIhr Termin wurde bestätigt:\n\nVeranstaltung: ${st.name}\nDatum: ${slot?.datum||datum}\nUhrzeit: ${slot?.zeit||"–"}${zahlText}\n\nBis bald!\n${config.studioName||""}`;
        await fetch(`${serverUrl}/api/newsletter`,{method:"POST",headers:{"Content-Type":"application/json"},
          body:JSON.stringify({
            smtp,
            subject:`Buchungsbestätigung: ${st.name}`,
            text:_bText,
            html:buildScattoDeskMailHtml(_bText,_getSig().logo,_getSig().text),
            logo:_getSig().logo,
            recipients:[{email:formData.sys_email,name:formData.sys_name||""}],
          })
        });
        setEmailStatus("✅ E-Mail gesendet");
      }catch(e){setEmailStatus("❌ "+e.message);}
    }
    onSave(booking);
    onClose();
  }

  return(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.7)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:200,padding:20}} onClick={onClose}>
      <div onClick={e=>e.stopPropagation()} style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:16,padding:24,width:"100%",maxWidth:520,maxHeight:"90vh",overflowY:"auto"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
          <div style={{fontFamily:"Georgia,serif",fontSize:18,color:T.accent}}>Manuelle Buchung</div>
          <button style={btn(T,"ghost",true)} onClick={onClose}>✕</button>
        </div>
        <div style={{fontSize:12,color:T.muted,marginBottom:16}}>Buchung für einen Kunden anlegen der telefonisch gebucht hat.</div>

        <div style={{marginBottom:12}}>
          <label style={{fontSize:12,color:T.muted,fontWeight:600,display:"block",marginBottom:5}}>Zeitslot wählen</label>
          {slots.length>0?(
            <select value={slot?`${slot.datum}|${slot.zeit}`:""}
              onChange={e=>{const[d,z]=e.target.value.split("|");setSlot({datum:d,zeit:z});setDatum(d);}}
              style={IS}>
              <option value="">— Bitte wählen —</option>
              {slots.map((s,i)=><option key={i} value={`${s.datum}|${s.zeit}`}>{new Date(s.datum).toLocaleDateString("de-DE")} · {s.zeit}</option>)}
            </select>
          ):(
            <div>
              <div style={{fontSize:12,color:T.muted,marginBottom:6}}>Keine Slots verfügbar — Datum manuell eingeben:</div>
              <input type="date" value={datum} onChange={e=>setDatum(e.target.value)} style={IS}/>
            </div>
          )}
        </div>

        <div style={{display:"flex",flexDirection:"column",gap:10,marginBottom:16}}>
          {[
            {id:"sys_name",label:"Name"},
            {id:"sys_email",label:"E-Mail"},
            {id:"sys_tel",label:"Telefon"},
            {id:"sys_tiername",label:"Tiername"},
            {id:"sys_rasse",label:"Rasse"},
          ].map(f=>(
            <div key={f.id}>
              <label style={{fontSize:12,color:T.muted,fontWeight:600,display:"block",marginBottom:3}}>{f.label}</label>
              <input value={formData[f.id]||""} onChange={e=>setFormData(p=>({...p,[f.id]:e.target.value}))} style={IS}/>
            </div>
          ))}
        </div>

        <div style={{background:T.bg,borderRadius:8,padding:12,marginBottom:16}}>
          <label style={{display:"flex",alignItems:"center",gap:8,cursor:"pointer",fontSize:13,color:T.text}}>
            <input type="checkbox" checked={sendEmail} onChange={e=>setSendEmail(e.target.checked)} style={{accentColor:T.accent,width:16,height:16}}/>
            Zahlungsdaten per E-Mail senden
          </label>
          {sendEmail&&<div style={{fontSize:11,color:T.muted,marginTop:6}}>
            Sendet eine Bestätigungs-E-Mail mit Zahlungsinfos an {formData.sys_email||"(E-Mail noch nicht eingegeben)"}.
          </div>}
          {emailStatus&&<div style={{fontSize:12,marginTop:6,color:emailStatus.startsWith("✅")?T.success:T.danger}}>{emailStatus}</div>}
        </div>

        <div style={{display:"flex",gap:8}}>
          <button style={btn(T,"ghost")} onClick={onClose}>Abbrechen</button>
          <button style={{...btn(T,"primary"),flex:1,justifyContent:"center"}} onClick={speichern}>Buchung anlegen</button>
        </div>
      </div>
    </div>
  );
}

function BezahlungAnfordernModal({bk, config, T, onClose}){
  const bk_name=bk.formData?.sys_name||bk.formData?.sys_vorname||"Kunde";
  const bk_email=bk.formData?.sys_email||Object.values(bk.formData||{}).find(v=>typeof v==="string"&&v.includes("@"))||"";
  const bankd=(()=>{try{return JSON.parse(localStorage.getItem("sd_buchung_config")||"null")?.bankdaten||{};}catch{return {};}})();
  const st=config?.shootingTypes?.find(s=>s.name===bk.shootingType)||{};
  const defPreis=st.preis||0;
  const [betrag,setBetrag]=useState(String(defPreis||""));
  const [sending,setSending]=useState(false);
  const [sent,setSent]=useState(false);
  const paypalLink=config?.zahlung?.paypal?.link||bankd.paypal||"";
  const iban=(config?.zahlung?.ueberweisung?.iban||bankd.iban||"").replace(/\s/g,"");
  const bic=config?.zahlung?.ueberweisung?.bic||bankd.bic||"";
  const inhaber=config?.zahlung?.ueberweisung?.inhaber||bankd.kontoinhaber||config?.studioName||"";
  const verwendungszweck=`${bk_name} – ${bk.shootingType||"Shooting"} ${bk.datum||""}`.trim();
  const betragNum=parseFloat(betrag)||0;

  // EPC-QR-Code generieren (GiroCode Standard)
  function genEpcQr(){
    if(!iban||betragNum<=0)return null;
    const lines=[
      "BCD","002","1","SCT",
      bic,inhaber,iban,
      `EUR${betragNum.toFixed(2)}`,
      "","",verwendungszweck,""
    ];
    return lines.join("\n");
  }

  // QR via qrserver.com API
  const epcData=genEpcQr();
  const qrUrl=epcData?`https://api.qrserver.com/v1/create-qr-code/?size=180x180&data=${encodeURIComponent(epcData)}`:null;

  async function sendMail(){
    if(!bk_email){alert("Keine E-Mail-Adresse vorhanden.");return;}
    if(betragNum<=0){alert("Bitte Betrag eingeben.");return;}
    setSending(true);
    const serverUrl=(localStorage.getItem("sd_server_url")||"").trim().replace(/\/+$/,"");
    const smtp=(()=>{try{return JSON.parse(localStorage.getItem("sd_smtp_settings")||"{}");}catch{return {};}})();
    const vorlagen=(()=>{try{return JSON.parse(localStorage.getItem("sd_email_vorlagen")||"{}");}catch{return {};}})();
    const tmpl=vorlagen.bezahlung_anfordern||{
      betreff:"Zahlungsanforderung – "+bk.shootingType,
      text:"Hallo {{name}},\n\nfür dein Shooting am {{datum}} um {{uhrzeit}} Uhr ist noch ein offener Betrag von {{betrag}} € offen.\n\nDu kannst bequem per PayPal oder Überweisung bezahlen:\n\n💳 PayPal:\n{{paypal_link}}\n\n🏦 Überweisung:\nEmpfänger: {{kontoinhaber}}\nIBAN: {{iban}}\nBIC: {{bic}}\nBetrag: {{betrag}} €\nVerwendungszweck: {{verwendungszweck}}\n\nVielen Dank!\n\nHerzliche Grüße\n{{studio}}"
    };
    const replace=(s)=>s
      .replace(/{{name}}/g,bk_name)
      .replace(/{{vorname}}/g,bk.formData?.sys_vorname||bk_name)
      .replace(/{{datum}}/g,(()=>{const d=bk.datum||"";if(!/^\d{4}-\d{2}-\d{2}/.test(d))return d;const x=new Date(d);return isNaN(x)?d:x.toLocaleDateString("de-DE",{day:"2-digit",month:"2-digit",year:"numeric"});})())
      .replace(/{{uhrzeit}}/g,bk.uhrzeit||"")
      .replace(/{{(shooting|event|veranstaltung)}}/g,bk.shootingType||"")
      .replace(/{{betrag}}/g,betragNum.toFixed(2))
      .replace(/{{paypal_link}}/g,paypalLink?(paypalLink.replace(/.*paypal\.me\/([^\/]+).*/,"https://www.paypal.com/paypalme/$1/")+betragNum.toFixed(2)):"(kein PayPal konfiguriert)")
      .replace(/{{kontoinhaber}}/g,inhaber)
      .replace(/{{iban}}/g,iban)
      .replace(/{{bic}}/g,bic)
      .replace(/{{verwendungszweck}}/g,verwendungszweck)
      .replace(/{{studio}}/g,config?.studioName||smtp.from||"");
    const betreff=replace(tmpl.betreff||"");
    const text=replace(tmpl.text||"");
    try{
      await fetch(`${serverUrl}/api/newsletter`,{
        method:"POST",
        headers:{"Content-Type":"application/json"},
        body:JSON.stringify({smtp,recipients:[{name:bk_name,email:bk_email}],subject:betreff,text,
          html:buildScattoDeskMailHtml(text,_getSig().logo,_getSig().text),logo:_getSig().logo})
      });
      setSent(true);
    }catch(e){alert("Fehler beim Senden: "+e.message);}
    setSending(false);
  }

  const IS2={background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:"8px 12px",color:T.text,fontSize:13,fontFamily:"inherit",outline:"none",width:"100%"};
  return(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.55)",zIndex:9999,display:"flex",alignItems:"center",justifyContent:"center",padding:16}} onClick={onClose}>
      <div style={{background:T.surface,borderRadius:14,padding:24,maxWidth:460,width:"100%",boxShadow:"0 8px 40px rgba(0,0,0,0.3)"}} onClick={e=>e.stopPropagation()}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:18}}>
          <div style={{fontFamily:"Georgia,serif",fontSize:16,color:T.accent}}>💳 Bezahlung anfordern</div>
          <button onClick={onClose} style={{background:"none",border:"none",fontSize:18,cursor:"pointer",color:T.muted}}>✕</button>
        </div>
        <div style={{fontSize:12,color:T.muted,marginBottom:16}}>{bk_name} · {bk_email}</div>
        {sent?(
          <div style={{textAlign:"center",padding:"24px 0"}}>
            <div style={{fontSize:32,marginBottom:8}}>✅</div>
            <div style={{fontSize:14,color:T.text,marginBottom:4}}>Mail gesendet!</div>
            <div style={{fontSize:12,color:T.muted,marginBottom:16}}>An {bk_email}</div>
            <button style={btn(T,"ghost")} onClick={onClose}>Schließen</button>
          </div>
        ):(
          <>
            <div style={{marginBottom:14}}>
              <label style={{fontSize:12,color:T.muted,fontWeight:600,display:"block",marginBottom:5}}>Betrag (€)</label>
              <input value={betrag} onChange={e=>setBetrag(e.target.value)} type="number" min="0" step="0.01" placeholder="0.00" style={IS2}/>
            </div>
            {qrUrl&&betragNum>0&&(
              <div style={{marginBottom:16,padding:14,background:T.bg,borderRadius:10,display:"flex",gap:16,alignItems:"center"}}>
                <img src={qrUrl} alt="EPC QR-Code" style={{width:100,height:100,borderRadius:6,flexShrink:0}}/>
                <div>
                  <div style={{fontSize:11,fontWeight:700,color:T.muted,textTransform:"uppercase",letterSpacing:"0.06em",marginBottom:4}}>GiroCode QR</div>
                  <div style={{fontSize:11,color:T.text,lineHeight:1.6}}>
                    <div>{inhaber}</div>
                    <div style={{fontFamily:"monospace"}}>{iban}</div>
                    <div style={{fontFamily:"monospace"}}>{bic}</div>
                    <div style={{fontWeight:600,color:T.accent}}>{betragNum.toFixed(2)} €</div>
                  </div>
                </div>
              </div>
            )}
            {!iban&&<div style={{fontSize:11,color:T.muted,marginBottom:10,padding:"8px 12px",background:T.bg,borderRadius:6}}>⚠️ Keine IBAN in Bankdaten hinterlegt → Einstellungen → Bankverbindung</div>}
            {!paypalLink&&<div style={{fontSize:11,color:T.muted,marginBottom:10,padding:"8px 12px",background:T.bg,borderRadius:6}}>⚠️ Kein PayPal-Link hinterlegt → Einstellungen → Bankverbindung</div>}
            <button style={{...btn(T,"primary"),width:"100%",justifyContent:"center"}} onClick={sendMail} disabled={sending||betragNum<=0}>
              {sending?"⏳ Wird gesendet…":"📧 Mail senden"}
            </button>
          </>
        )}
      </div>
    </div>
  );
}

function BuchungenView({buchungen,setBuchungen,config,T,onExportToShootingplan,onDeepDelete,activeSTName}){
  const [sel,setSel]=useState(null);
  const [checked,setChecked]=useState(new Set());
  const [zipping,setZipping]=useState(false);
  const [showManuell,setShowManuell]=useState(false);
  const [bezahlBk,setBezahlBk]=useState(null);
  const [stFilter,setStFilter]=useState(()=>{
    const v=localStorage.getItem("sd_bp_stfilter");
    if(v){localStorage.removeItem("sd_bp_stfilter");return v;}
    return activeSTName||"";
  });
  useEffect(()=>{ if(activeSTName) setStFilter(activeSTName); },[activeSTName]);
  const gefilterte=stFilter?buchungen.filter(b=>b.shootingType===stFilter):buchungen;

  const aktiverST=config?.shootingTypes?.find(s=>s.eventId)||config?.shootingTypes?.[0];

  if(buchungen.length===0)return(
    <div style={{textAlign:"center",padding:40,color:T.muted}}>
      <div style={{fontSize:32,marginBottom:12}}>📭</div>
      <div style={{marginBottom:16}}>Noch keine Buchungen eingegangen.</div>
      <button style={btn(T,"primary")} onClick={()=>setShowManuell(true)}>+ Manuelle Buchung anlegen</button>
      {showManuell&&<ManuelBuchungModal config={config} shootingType={aktiverST} T={T}
        onSave={b=>setBuchungen(p=>[...p,b])} onClose={()=>setShowManuell(false)}/>}
    </div>
  );

  function toggleCheck(id,e){e.stopPropagation();setChecked(s=>{const n=new Set(s);n.has(id)?n.delete(id):n.add(id);return n;});}
  function alleMarkieren(){setChecked(checked.size===gefilterte.length?new Set():new Set(gefilterte.map(b=>b.id)));}

  function buildHTML(bk){
    const st=config?.shootingTypes?.find(s=>s.name===bk.shootingType)||{};
    const vereinb=st.vereinbarung?.de||"";
    const name=bk.formData?.sys_name||"Unbekannt";
    const termin=bk.datum?`${bk.datum} ${bk.uhrzeit||""}`.trim():"Vor Ort";
    const fmap={};(st.felder||[]).forEach(f=>{fmap[f.id]=f.labelDe||f.label||f.id;});
    const SYS={sys_anrede:"Anrede",sys_vorname:"Vorname",sys_nachname:"Nachname",sys_email:"E-Mail",sys_tel:"Telefon",sys_telefon:"Telefon",sys_strasse:"Straße",sys_plz:"PLZ",sys_ort:"Ort"};
    const lblOf=(k)=>{if(k==="_agree")return "Vereinbarung akzeptiert";if(SYS[k])return SYS[k];if(fmap[k])return fmap[k];return k.replace(/_[a-z0-9]+_\d+$/i,"").replace("sys_","");};
    const tierVal=(t,kw)=>{for(const key in t){const lbl=(fmap[key]||"").toLowerCase();if(lbl.includes(kw)&&t[key])return t[key];}return "";};
    const _hasBothNames=(bk.formData?.sys_vorname||bk.formData?.vorname)&&(bk.formData?.sys_nachname||bk.formData?.nachname);
    const felderHTML=Object.entries(bk.formData||{}).filter(([k,v])=>!k.startsWith("tier_")&&k!=="sys_name"&&!(_hasBothNames&&(k==="name"||k==="sys_fullname"))&&v!==""&&v!=null&&v!==false)
      .map(([k,v])=>`<tr><td style="padding:5px 8px;color:#888;width:130px">${lblOf(k)}</td><td style="padding:5px 8px">${v===true?"Ja":String(v)}</td></tr>`).join("");
    const tiereHTML=(bk.tiere||[]).length>0?`<h3 style="font-size:13px;color:#A8843E;margin:16px 0 6px">🐾 Tiere</h3>${(bk.tiere||[]).map((t,i)=>`<div style="font-size:12px;color:#555;margin-bottom:3px">Tier ${i+1}: ${[tierVal(t,"tiername"),tierVal(t,"rasse"),tierVal(t,"geschlecht")].filter(Boolean).join(" · ")}</div>`).join("")}`:"";
    return `<!DOCTYPE html><html><head><meta charset="utf-8"><title>Buchung ${name}</title>
    <style>body{font-family:Georgia,serif;color:#1a1814;max-width:650px;margin:40px auto;padding:24px;font-size:13px}
    h1{font-size:20px;color:#A8843E}h2{font-size:14px;color:#A8843E;border-bottom:1px solid #e0ddd8;padding-bottom:5px;margin:20px 0 10px}
    table{width:100%;border-collapse:collapse}td{padding:5px 8px;border-bottom:1px solid #f0ede8;font-size:12px;vertical-align:top}
    .vereinb{background:#f5f3ef;border-radius:6px;padding:14px;font-size:12px;line-height:1.7;color:#444;margin:10px 0 16px}
    .sig-box img{max-width:200px;border:1px solid #e0ddd8;border-radius:4px;background:#fff}
    </style></head><body>
    <h1>${config?.studioName||"Fotoshooting"}</h1>
    <p style="color:#888;font-size:11px">Buchungsbestätigung · ${new Date().toLocaleDateString("de-DE")}</p>
    <h2>Buchungsdetails</h2>
    <table><tr><td style="color:#888;width:130px">Termin</td><td><strong>${termin}</strong></td></tr>
    <tr><td style="color:#888">Shooting</td><td><strong>${bk.shootingType||""}</strong></td></tr>${felderHTML}</table>
    ${tiereHTML}
    ${vereinb?`<h2>Vereinbarung</h2><div class="vereinb">${vereinb.split("\n").join("<br/>")}</div>`:""}
    ${bk.signature?`<div class="sig-box"><p style="font-size:11px;color:#888">Unterschrift:</p><img src="${bk.signature}" alt="Unterschrift"/></div>`:""}
    </body></html>`;
  }

  async function downloadZIP(){
    if(checked.size===0){alert("Bitte zuerst Buchungen auswählen.");return;}
    setZipping(true);
    try{
      // JSZip laden
      if(!window.JSZip){
        await new Promise((res,rej)=>{
          const s=document.createElement("script");
          s.src="https://cdnjs.cloudflare.com/ajax/libs/jszip/3.10.1/jszip.min.js";
          s.onload=res;s.onerror=rej;document.head.appendChild(s);
        });
      }
      const zip=new window.JSZip();
      const serverUrl=(localStorage.getItem("sd_server_url")||"").trim().replace(/\/+$/,"");
      const ausgewählt=buchungen.filter(bk=>checked.has(bk.id));

      for(const bk of ausgewählt){
        const st=config?.shootingTypes?.find(s=>s.name===bk.shootingType)||{};
        const vereinb=st.vereinbarung?.de||"";
        const studio={studioname:config?.studioName||""};
        const name=(bk.formData?.sys_name||"Buchung").replace(/\s+/g,"_");
        const datum=(bk.datum||"").replace(/-/g,"");
        const dateiname=`${datum}_${name}.pdf`;

        if(serverUrl){
          // Echtes PDF vom Server
          try{
            const r=await fetch(`${serverUrl}/api/buchung-pdf`,{
              method:"POST",
              headers:{"Content-Type":"application/json"},
              body:JSON.stringify({booking:bk,studio,vereinbarung:vereinb})
            });
            if(r.ok){
              const buf=await r.arrayBuffer();
              zip.file(dateiname,buf);
              continue;
            }
          }catch{}
        }
        // Fallback: HTML
        zip.file(dateiname.replace(".pdf",".html"),buildHTML(bk));
      }

      const blob=await zip.generateAsync({type:"blob"});
      const a=document.createElement("a");
      a.href=URL.createObjectURL(blob);
      a.download=`Buchungen_${new Date().toISOString().slice(0,10)}.zip`;
      a.click();
      setChecked(new Set());
    }catch(e){alert("ZIP-Erstellung fehlgeschlagen: "+e.message);}
    setZipping(false);
  }

  const b=sel?buchungen.find(x=>x.id===sel):null;
  return(
    <div style={{display:"grid",gridTemplateColumns:sel?"1fr 1fr":"1fr",gap:16}}>
      {showManuell&&<ManuelBuchungModal config={config} shootingType={aktiverST} T={T}
        onSave={b=>setBuchungen(p=>[...p,b])} onClose={()=>setShowManuell(false)}/>}
      <div>
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:12,flexWrap:"wrap",gap:8}}>
          <div style={{display:"flex",alignItems:"center",gap:10,flexWrap:"wrap"}}>
            <div style={{fontFamily:"Georgia,serif",fontSize:15,color:T.accent}}>{gefilterte.length} Buchungen</div>
            <select value={stFilter} onChange={e=>{setStFilter(e.target.value);setChecked(new Set());setSel(null);}}
              style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:"6px 10px",color:T.text,fontSize:12,fontFamily:"inherit",outline:"none"}}>
              <option value="">Alle Veranstaltungen ({buchungen.length})</option>
              {(config?.shootingTypes||[]).filter(s=>s.name).map(s=>{
                const n=buchungen.filter(b=>b.shootingType===s.name).length;
                return <option key={s.id} value={s.name}>{s.name} ({n})</option>;
              })}
            </select>
          </div>
          <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
            <button style={btn(T,"primary",true)} onClick={()=>setShowManuell(true)}>+ Manuelle Buchung</button>
            <button style={btn(T,"ghost",true)} onClick={alleMarkieren}>
              {checked.size===gefilterte.length&&gefilterte.length>0?"☑ Alle abwählen":"☐ Alle markieren"}
            </button>
            {checked.size>0&&(
              <>
                <button style={btn(T,"primary",true)} onClick={downloadZIP} disabled={zipping}>
                  {zipping?"⏳ Wird erstellt…":`⬇ ${checked.size} als ZIP`}
                </button>
                <button style={btn(T,"danger",true)} onClick={()=>{
                  if(!confirm(`${checked.size} Buchung(en) wirklich löschen?\n\nDie Personen werden auch aus dem Veranstaltungsplan und der Abrechnung entfernt.`))return;
                  const zuLoeschen=buchungen.filter(b=>checked.has(b.id));
                  // Gelöschte IDs merken damit Server-Sync sie nicht wieder hinzufügt
                  const deleted=new Set(JSON.parse(localStorage.getItem("sd_buchungen_deleted")||"[]"));
                  checked.forEach(id=>deleted.add(id));
                  localStorage.setItem("sd_buchungen_deleted",JSON.stringify([...deleted]));
                  setBuchungen(p=>p.filter(b=>!checked.has(b.id)));
                  let mit=0;
                  try{mit=onDeepDelete?onDeepDelete(zuLoeschen)||0:0;}catch(e){console.warn("Bereinigung fehlgeschlagen:",e);}
                  setChecked(new Set());
                  if(mit>0)alert(`${zuLoeschen.length} Buchung(en) gelöscht.\nDazu ${mit} Eintrag/Einträge aus Veranstaltungsplan und Abrechnung entfernt.`);
                }}>🗑 {checked.size} löschen</button>
              </>
            )}
            <button style={btn(T,"primary",true)} onClick={()=>{
              const evName=stFilter||config?.studioName||"Buchungen";
              const evType=stFilter||config?.shootingTypes?.find(s=>s.aktiv)?.name||"Underglass";
              onExportToShootingplan(gefilterte,evName,evType);
            }}>→ Shootingplan</button>
          </div>
        </div>
        {gefilterte.length===0&&(
          <div style={{textAlign:"center",padding:30,color:T.muted,fontSize:13}}>Keine Buchungen für „{stFilter}".</div>
        )}
        {gefilterte.map(bk=>(
          <div key={bk.id} onClick={()=>setSel(bk.id===sel?null:bk.id)}
            style={{background:sel===bk.id?T.accentDim:checked.has(bk.id)?T.accentDim+"88":T.bg,border:`1px solid ${sel===bk.id||checked.has(bk.id)?T.accent+"55":T.border}`,borderRadius:10,padding:14,marginBottom:8,cursor:"pointer",transition:"all 0.15s"}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
              <div style={{display:"flex",alignItems:"flex-start",gap:10}}>
                <input type="checkbox" checked={checked.has(bk.id)} onChange={e=>toggleCheck(bk.id,e)}
                  onClick={e=>e.stopPropagation()}
                  style={{marginTop:2,accentColor:T.accent,width:16,height:16,cursor:"pointer"}}/>
                <div>
                  <div style={{fontSize:13,fontWeight:600,color:T.text}}>{bk.formData?.sys_name||"—"}</div>
                  <div style={{fontSize:11,color:T.muted}}>{bk.formData?.sys_email||""}</div>
                  <div style={{fontSize:11,color:T.muted}}>{bk.shootingType}{bk.datum?` · ${bk.datum}`:""}{ bk.uhrzeit?` · ${bk.uhrzeit}`:""}</div>
                </div>
              </div>
              <div style={{display:"flex",flexDirection:"column",alignItems:"flex-end",gap:4}}>
                <span style={{fontSize:10,background:T.success+"22",color:T.success,padding:"2px 8px",borderRadius:20}}>Neu</span>
                {bk.signature&&<span style={{fontSize:10,color:T.accent}}>✍️ signiert</span>}
              </div>
            </div>
          </div>
        ))}
      </div>
      {b&&(
        <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:12,padding:16}}>
          <div style={{fontFamily:"Georgia,serif",fontSize:14,color:T.accent,marginBottom:14}}>Detail</div>
          <div style={{fontSize:12,color:T.muted,marginBottom:12}}>{b.shootingType} · {b.datum} · {b.uhrzeit}</div>
          {(()=>{
            const stD=config?.shootingTypes?.find(s=>s.name===b.shootingType);
            const fmap={};(stD?.felder||[]).forEach(f=>{fmap[f.id]=f.labelDe||f.label||f.id;});
            const SYS={sys_vorname:"Vorname",sys_nachname:"Nachname",sys_email:"E-Mail",sys_tel:"Telefon",sys_telefon:"Telefon",sys_strasse:"Straße",sys_plz:"PLZ",sys_ort:"Ort",sys_rasse:"Rasse",sys_tiername:"Tiername",sys_geschlecht:"Geschlecht",sys_alter:"Alter",sys_anrede:"Anrede"};
            const hide=new Set(["sys_name"]);
            const label=(k)=>{
              if(k==="_agree")return "Vereinbarung akzeptiert";
              if(SYS[k])return SYS[k];
              if(fmap[k])return fmap[k];
              const m=k.match(/^tier_\d+_(.+)$/);
              if(m)return fmap[m[1]]||SYS[m[1]]||"Tier";
              return k.replace(/_[a-z0-9]+_\d+$/i,"").replace("sys_","");
            };
            const zeile=(k,v)=>(
              <div key={k} style={{display:"flex",justifyContent:"space-between",padding:"5px 0",borderBottom:`1px solid ${T.border}22`,fontSize:12,gap:12}}>
                <span style={{color:T.muted}}>{label(k)}</span>
                <span style={{color:T.text,fontWeight:500,textAlign:"right"}}>{v===true?"Ja":String(v)}</span>
              </div>
            );
            // Felder weiterer Tiere tragen den Tier-Schluessel im Namen.
            // Sie werden gesammelt und pro Tier als eigener Block gezeigt,
            // statt einzeln mit ihrem technischen Schluessel dazwischen.
            const eintraege=Object.entries(b.formData||{})
              .filter(([k,v])=>!hide.has(k)&&v!==""&&v!=null&&v!==false);
            const basis=[],tierGruppen={},tierReihenfolge=[];
            eintraege.forEach(([k,v])=>{
              const m=k.match(/^tier_([^_]+)_(.+)$/);
              if(m&&m[1]!=="0"){
                if(!tierGruppen[m[1]]){tierGruppen[m[1]]=[];tierReihenfolge.push(m[1]);}
                tierGruppen[m[1]].push([k,m[2],v]);
              }else basis.push([k,v]);
            });
            return(<>
              {basis.map(([k,v])=>zeile(k,v))}
              {tierReihenfolge.map((tid,i)=>(
                <div key={tid} style={{marginTop:10}}>
                  <div style={{fontSize:11,fontWeight:700,color:T.accent,padding:"6px 0 2px"}}>{"\uD83D\uDC3E "+(i+2)+". Tier"}</div>
                  {tierGruppen[tid].map(([k,feld,v])=>(
                    <div key={k} style={{display:"flex",justifyContent:"space-between",padding:"5px 0",borderBottom:`1px solid ${T.border}22`,fontSize:12,gap:12}}>
                      <span style={{color:T.muted}}>{fmap[feld]||SYS[feld]||feld}</span>
                      <span style={{color:T.text,fontWeight:500,textAlign:"right"}}>{v===true?"Ja":String(v)}</span>
                    </div>
                  ))}
                </div>
              ))}
            </>);
          })()}
          {b.signature&&(
            <div style={{marginTop:12}}>
              <div style={{fontSize:11,color:T.muted,marginBottom:4}}>Unterschrift:</div>
              <img src={b.signature} alt="Unterschrift" style={{maxWidth:"100%",border:`1px solid ${T.border}`,borderRadius:6}}/>
            </div>
          )}
          {/* Vereinbarung PDF Button */}
          <button style={{...btn(T,"ghost"),marginTop:12,width:"100%",justifyContent:"center"}}
            onClick={e=>{e.stopPropagation();setBezahlBk(b);}}>
            💳 Bezahlung anfordern
          </button>
          <button style={{...btn(T,"primary"),marginTop:8,width:"100%",justifyContent:"center"}}
            onClick={()=>{
              const st=config?.shootingTypes?.find(s=>s.name===b.shootingType)||{};
              const vereinb=st.vereinbarung?.de||"";
              const name=b.formData?.sys_name||"";
              const sName=config?.studioName||"Fotoshooting";
              const dateiname=`Vereinbarung_${name.replace(/\s+/g,"_")}_${b.datum||""}_${b.shootingType||""}`;
              const fmap={};(st.felder||[]).forEach(f=>{fmap[f.id]=f.labelDe||f.label||f.id;});
              const SYS={sys_anrede:"Anrede",sys_vorname:"Vorname",sys_nachname:"Nachname",sys_email:"E-Mail",sys_tel:"Telefon",sys_telefon:"Telefon",sys_strasse:"Straße",sys_plz:"PLZ",sys_ort:"Ort"};
              const lblOf=(k)=>{if(k==="_agree")return "Vereinbarung akzeptiert";if(SYS[k])return SYS[k];if(fmap[k])return fmap[k];return k.replace(/_[a-z0-9]+_\d+$/i,"").replace("sys_","");};
              const _hasBothNames2=(b.formData?.sys_vorname||b.formData?.vorname)&&(b.formData?.sys_nachname||b.formData?.nachname);
              const felderHTML=Object.entries(b.formData||{})
                .filter(([k,v])=>!k.startsWith("tier_")&&k!=="sys_name"&&!(_hasBothNames2&&(k==="name"||k==="sys_fullname"))&&v!==""&&v!=null&&v!==false)
                .map(([k,v])=>`<tr><td style="padding:5px 8px;color:#888;width:130px">${lblOf(k)}</td><td style="padding:5px 8px">${v===true?"Ja":String(v)}</td></tr>`)
                .join("");
              const tiere=b.tiere||[];
              const tierVal=(t,kw)=>{for(const key in t){const lbl=(fmap[key]||"").toLowerCase();if(lbl.includes(kw)&&t[key])return t[key];}return "";};
              const tiereHTML=tiere.length>0?`
                <h3 style="font-size:13px;color:#A8843E;margin:16px 0 6px">🐾 Tiere</h3>
                ${tiere.map((t,i)=>`<div style="font-size:12px;color:#555;margin-bottom:3px">
                  Tier ${i+1}: ${[tierVal(t,"tiername"),tierVal(t,"rasse"),(v=>v?v+" Jahre":"")(tierVal(t,"alter")),tierVal(t,"geschlecht")].filter(Boolean).join(" · ")}
                </div>`).join("")}`:"";
              const html=`<!DOCTYPE html><html><head><meta charset="utf-8">
              <title>${dateiname}</title>
              <style>
                body{font-family:Georgia,serif;color:#1a1814;max-width:650px;margin:40px auto;padding:24px;font-size:13px}
                h1{font-size:20px;color:#A8843E;margin-bottom:2px}
                .meta{font-size:11px;color:#888;margin-bottom:20px}
                h2{font-size:14px;color:#A8843E;border-bottom:1px solid #e0ddd8;padding-bottom:5px;margin:20px 0 10px}
                h3{font-size:13px;color:#A8843E;margin:16px 0 6px}
                table{width:100%;border-collapse:collapse;margin-bottom:12px}
                td{padding:5px 8px;border-bottom:1px solid #f0ede8;font-size:12px;vertical-align:top}
                .vereinb{background:#f5f3ef;border-radius:6px;padding:14px;font-size:12px;line-height:1.7;color:#444;margin:10px 0 16px}
                .sig-box{margin-top:16px;padding-top:14px;border-top:1px solid #e0ddd8}
                .sig-box img{max-width:100%;border:1px solid #e0ddd8;border-radius:4px;background:#fff}
                .confirm{margin-top:20px;padding:10px 14px;background:#f0faf0;border:1px solid #c3e6c3;border-radius:6px;font-size:11px;color:#3a7a3a}
                .footer{margin-top:32px;font-size:10px;color:#aaa;text-align:center;border-top:1px solid #eee;padding-top:12px}
                @media print{button{display:none}.no-print{display:none}}
              </style></head><body>
              <h1>${sName}</h1>
              <div class="meta">Shooting-Vereinbarung · Erstellt: ${new Date().toLocaleDateString("de-DE",{day:"2-digit",month:"long",year:"numeric"})}</div>
              <div class="no-print" style="margin-bottom:16px">
                <button onclick="window.print()" style="padding:7px 16px;background:#A8843E;color:#fff;border:none;border-radius:6px;cursor:pointer;font-size:12px">🖨️ Als PDF speichern</button>
                <span style="font-size:11px;color:#888;margin-left:10px">Datei: <strong>${dateiname}.pdf</strong></span>
              </div>
              <h2>Buchungsdetails</h2>
              <table>
                <tr><td style="color:#888;width:130px">Shooting-Art</td><td><strong>${b.shootingType||""}</strong></td></tr>
                <tr><td style="color:#888">Datum</td><td><strong>${b.datum?new Date(b.datum).toLocaleDateString("de-DE",{weekday:"long",day:"2-digit",month:"long",year:"numeric"}):""}</strong></td></tr>
                <tr><td style="color:#888">Uhrzeit</td><td><strong>${b.uhrzeit||""}</strong></td></tr>
                ${felderHTML}
              </table>
              ${tiereHTML}
              ${vereinb?`<h2>Vereinbarung</h2><div class="vereinb">${vereinb.split("\n").join("<br/>")}</div>`:""}
              ${b.signature?`<div class="sig-box"><div style="font-size:11px;color:#888;margin-bottom:6px">Unterschrift des Auftraggebers:</div><img src="${b.signature}" alt="Unterschrift" style="max-height:100px"/></div>`:""}
              <div class="confirm">✅ Diese Vereinbarung wurde digital unterzeichnet am ${new Date().toLocaleDateString("de-DE")} um ${new Date().toLocaleTimeString("de-DE",{hour:"2-digit",minute:"2-digit"})} Uhr.</div>
              <div class="footer">${sName} · ${b.formData?.sys_email||""}</div>
              </body></html>`;
              const w=window.open("","_blank");
              if(!w){
                alert("Popup-Blocker aktiv — bitte in der Adressleiste oben das Popup erlauben und nochmal klicken.");
                return;
              }
              w.document.write(html);
              w.document.close();
            }}>
            📄 Unterzeichnete Vereinbarung als PDF
          </button>
        </div>
      )}
    {bezahlBk&&<BezahlungAnfordernModal bk={bezahlBk} config={config} T={T} onClose={()=>setBezahlBk(null)}/>}
    </div>
  );
}

// ── Haupt App ─────────────────────────────────────────────────────────────────
const DEFAULT_CONFIG={
  studioName:"ScattoDesk Fotografie",
  logo:"",
  primaryColor:"#C9A96E",
  sprachen:["de","en"],
  zahlung:{
    paypal:{aktiv:true, link:"https://paypal.me/deinname"},
    ueberweisung:{aktiv:true, iban:"DE00 0000 0000 0000 0000 00", bic:"XXXXDEXX", inhaber:"Dein Name"},
    bar:{aktiv:false},
  },
  shootingTypes:[
    {
      id:"st_ug", name:"Underglass", aktiv:true, buchungsUrl:"underglass",
      preis:30,
      beschreibung:{de:"Einzigartiges Shooting unter Glasplatten.",en:"Unique shooting under glass panels."},
      slotInfo:{de:"",en:""},
      slots:[],
      felder:[
        {id:"sf1a",type:"radio",label:"Anrede",labelDe:"Anrede",labelEn:"Salutation",required:true,aktiv:true,system:true,options:["Frau","Herr","Divers"]},
        {id:"sf1",type:"text", label:"Name",        labelDe:"Name",        labelEn:"Name",       required:true, aktiv:true, system:true},
        {id:"sf2",type:"email",label:"E-Mail",      labelDe:"E-Mail",      labelEn:"E-Mail",     required:true, aktiv:true, system:true},
        {id:"sf3",type:"tel",  label:"Telefon",     labelDe:"Telefon",     labelEn:"Phone",      required:false,aktiv:true, system:true},
        {id:"sf4",type:"text", label:"Tiername",    labelDe:"Tiername",    labelEn:"Pet name",   required:false,aktiv:true, system:true},
        {id:"sf5",type:"text", label:"Rasse",       labelDe:"Rasse",       labelEn:"Breed",      required:false,aktiv:true, system:true},
        {id:"sf6",type:"number",label:"Alter (Tier)",labelDe:"Alter (Tier)",labelEn:"Pet age",   required:false,aktiv:true, system:true},
        {id:"sf7",type:"radio",label:"Geschlecht",  labelDe:"Geschlecht",  labelEn:"Gender",     required:false,aktiv:true, system:true,options:["Hündin","Rüde"]},
        {id:"sf8",type:"text", label:"Straße",      labelDe:"Straße",      labelEn:"Street",     required:false,aktiv:false,system:true},
        {id:"sf9",type:"text", label:"PLZ",         labelDe:"PLZ",         labelEn:"Zip",        required:false,aktiv:false,system:true},
        {id:"sf10",type:"text",label:"Ort",         labelDe:"Ort",         labelEn:"City",       required:false,aktiv:false,system:true},
      ],
      vereinbarung:{de:"Hiermit bestätigt der Auftraggeber die Buchung und stimmt den AGB zu.",en:"The client confirms the booking and agrees to the terms."},
    },
    {
      id:"st_st", name:"Studio", aktiv:true, buchungsUrl:"studio",
      preis:50,
      beschreibung:{de:"Professionelles Studio-Shooting.",en:"Professional studio shooting."},
      slotInfo:{de:"",en:""},
      slots:[],
      felder:[
        {id:"sf1ba",type:"radio",label:"Anrede",labelDe:"Anrede",labelEn:"Salutation",required:true,aktiv:true,system:true,options:["Frau","Herr","Divers"]},
        {id:"sf1b",type:"text", label:"Name",   labelDe:"Name",   labelEn:"Name",  required:true, aktiv:true,system:true},
        {id:"sf2b",type:"email",label:"E-Mail", labelDe:"E-Mail", labelEn:"E-Mail",required:true, aktiv:true,system:true},
        {id:"sf3b",type:"tel",  label:"Telefon",labelDe:"Telefon",labelEn:"Phone", required:false,aktiv:true,system:true},
        {id:"sf4b",type:"text", label:"Tiername",labelDe:"Tiername",labelEn:"Pet name",required:false,aktiv:true,system:true},
        {id:"sf5b",type:"text", label:"Rasse",  labelDe:"Rasse",  labelEn:"Breed", required:false,aktiv:true,system:true},
        {id:"sf6b",type:"number",label:"Alter (Tier)",labelDe:"Alter (Tier)",labelEn:"Pet age",required:false,aktiv:true,system:true},
        {id:"sf7b",type:"radio",label:"Geschlecht",labelDe:"Geschlecht",labelEn:"Gender",required:false,aktiv:true,system:true,options:["Hündin","Rüde"]},
      ],
      vereinbarung:{de:"Hiermit bestätigt der Auftraggeber die Buchung und stimmt den AGB zu.",en:"The client confirms the booking and agrees to the terms."},
    },
    {
      id:"st_ve", name:"Veranstaltung", aktiv:true, buchungsUrl:"veranstaltung",
      preis:25,
      beschreibung:{de:"Shooting auf Veranstaltungen.",en:"Shooting at events."},
      slotInfo:{de:"",en:""},
      slots:[],
      felder:[
        {id:"sf1ca",type:"radio",label:"Anrede",labelDe:"Anrede",labelEn:"Salutation",required:true,aktiv:true,system:true,options:["Frau","Herr","Divers"]},
        {id:"sf1c",type:"text", label:"Name",   labelDe:"Name",   labelEn:"Name",  required:true, aktiv:true,system:true},
        {id:"sf2c",type:"email",label:"E-Mail", labelDe:"E-Mail", labelEn:"E-Mail",required:true, aktiv:true,system:true},
        {id:"sf3c",type:"tel",  label:"Telefon",labelDe:"Telefon",labelEn:"Phone", required:false,aktiv:true,system:true},
        {id:"sf4c",type:"text", label:"Tiername",labelDe:"Tiername",labelEn:"Pet name",required:false,aktiv:true,system:true},
        {id:"sf5c",type:"text", label:"Rasse",  labelDe:"Rasse",  labelEn:"Breed", required:false,aktiv:true,system:true},
      ],
      vereinbarung:{de:"Hiermit bestätigt der Auftraggeber die Buchung und stimmt den AGB zu.",en:"The client confirms the booking and agrees to the terms."},
    },
    {
      id:"st_so", name:"Sonstiges", aktiv:true, buchungsUrl:"sonstiges",
      preis:40,
      beschreibung:{de:"Individuelles Shooting nach Absprache.",en:"Individual shooting by arrangement."},
      slotInfo:{de:"",en:""},
      slots:[],
      felder:[
        {id:"sf1da",type:"radio",label:"Anrede",labelDe:"Anrede",labelEn:"Salutation",required:true,aktiv:true,system:true,options:["Frau","Herr","Divers"]},
        {id:"sf1d",type:"text", label:"Name",   labelDe:"Name",   labelEn:"Name",  required:true, aktiv:true,system:true},
        {id:"sf2d",type:"email",label:"E-Mail", labelDe:"E-Mail", labelEn:"E-Mail",required:true, aktiv:true,system:true},
        {id:"sf3d",type:"tel",  label:"Telefon",labelDe:"Telefon",labelEn:"Phone", required:false,aktiv:true,system:true},
        {id:"sf4d",type:"text", label:"Tiername",labelDe:"Tiername",labelEn:"Pet name",required:false,aktiv:true,system:true},
        {id:"sf5d",type:"text", label:"Rasse",  labelDe:"Rasse",  labelEn:"Breed", required:false,aktiv:true,system:true},
      ],
      vereinbarung:{de:"Hiermit bestätigt der Auftraggeber die Buchung und stimmt den AGB zu.",en:"The client confirms the booking and agrees to the terms."},
    },
  ],
};


// ── Telegram Benachrichtigung ─────────────────────────────────────────────────
async function sendTelegramNotification(booking, config){
  try{
    const settings=JSON.parse(localStorage.getItem("sd_api_settings")||"{}");
    const token=settings.telegram_token;
    const chatId=settings.telegram_chat_id;
    if(!token||!chatId)return; // Nicht konfiguriert — still ignorieren

    const name=booking.formData?.sys_name||"Unbekannt";
    const anrede=booking.formData?.sys_anrede||"";
    const telefon=booking.formData?.sys_tel||"";
    const email=booking.formData?.sys_email||"";
    const tiere=(booking.tiere||[]).map((t,i)=>{
      const parts=[t.sys_tiername,t.sys_rasse,t.sys_geschlecht].filter(Boolean);
      return `🐾 Tier ${i+1}: ${parts.join(" · ")||"—"}`;
    }).join("\n");
    const datum=booking.datum?new Date(booking.datum).toLocaleDateString("de-DE",{weekday:"long",day:"2-digit",month:"long",year:"numeric"}):"";
    const studioName=config?.studioName||"ScattoDesk";

    const text=[
      `🔔 *Neue Buchung — ${studioName}*`,
      ``,
      `👤 ${anrede?anrede+" ":""}${name}`,
      telefon?`📞 ${telefon}`:"",
      email?`✉️ ${email}`:"",
      ``,
      `📷 *${booking.shootingType||""}*`,
      datum?`📅 ${datum}`:""  ,
      booking.uhrzeit?`⏰ ${booking.uhrzeit}`:"",
      ``,
      tiere||"",
      booking.signature?`✍️ Vereinbarung unterzeichnet`:"",
      booking.formData?.sys_newsletter?`📬 Newsletter erwünscht`:"",
    ].filter(l=>l!==undefined&&l!=="").join("\n");

    await fetch(`https://api.telegram.org/bot${token}/sendMessage`,{
      method:"POST",
      headers:{"Content-Type":"application/json"},
      body:JSON.stringify({chat_id:chatId,text,parse_mode:"Markdown"}),
    });
  }catch(e){
    console.warn("Telegram Notification fehlgeschlagen:",e.message);
  }
}


// ── Mustervorlage ─────────────────────────────────────────────────────────────
function MustervorlageView({T}){
  const STORAGE_KEY = "sd_mustervorlagen";
  function loadAll(){try{return JSON.parse(localStorage.getItem(STORAGE_KEY)||"[]")||[];}catch{return [];}}
  function saveAll(v){try{localStorage.setItem(STORAGE_KEY,JSON.stringify(v));}catch{}}

  const [vorlagen, setVorlagen] = useState(loadAll);
  const [aktiveId, setAktiveId] = useState(()=>{const l=loadAll();return l[0]?.id||null;});
  const [neuName, setNeuName] = useState("");
  const neuNameRef = useRef(null);

  const aktive = vorlagen.find(v=>v.id===aktiveId) || null;

  function updVorlage(key, val){
    if(!aktiveId) return;
    setVorlagen(prev=>{
      const next = prev.map(v=>v.id===aktiveId ? {...v,[key]:val} : v);
      saveAll(next);
      return next;
    });
  }
  function updStyle(key, val){
    if(!aktiveId) return;
    setVorlagen(prev=>{
      const next = prev.map(v=>v.id===aktiveId ? {...v,style:{...(v.style||{}),[key]:val}} : v);
      saveAll(next);
      return next;
    });
  }
  function neueVorlage(){
    const name=(neuNameRef.current?.value||neuName).trim();
    if(!name) return;
    const nv = {id:"mv_"+Date.now(), name, beschreibung_de:"", hp_beschreibung:"", vereinbarung:"", event_info:"", style:{}};
    const next = [...vorlagen, nv];
    setVorlagen(next);
    saveAll(next);
    setAktiveId(nv.id);
    setNeuName("");
    if(neuNameRef.current) neuNameRef.current.value="";
  }
  function loeschen(id){
    if(!confirm("Vorlage löschen?")) return;
    const next = vorlagen.filter(v=>v.id!==id);
    setVorlagen(next);
    saveAll(next);
    if(aktiveId===id) setAktiveId(next[0]?.id||null);
  }

  const TA = {width:"100%",background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:"8px 12px",color:T.text,fontSize:13,resize:"vertical",minHeight:90,lineHeight:1.6,outline:"none",fontFamily:"inherit"};
  const LBL = {fontSize:12,color:T.muted,fontWeight:600,display:"block",marginBottom:5};
  const SECTION = {background:T.surface,border:`1px solid ${T.border}`,borderRadius:12,padding:20,marginBottom:16};
  const STAG = {fontSize:12,color:T.accent,fontWeight:700,textTransform:"uppercase",letterSpacing:"0.08em",marginBottom:16};

  return(
    <div style={{maxWidth:800}}>
      <div style={{fontFamily:"Georgia,serif",fontSize:20,color:T.accent,marginBottom:6}}>Mustervorlagen</div>
      <div style={{fontSize:13,color:T.muted,marginBottom:20}}>
        Lege mehrere Vorlagen an. Beim Einrichten eines neuen Events kannst du eine davon auswählen.
      </div>

      <div style={{display:"grid",gridTemplateColumns:"200px 1fr",gap:20,alignItems:"start"}}>
        {/* Sidebar: Vorlagen-Liste */}
        <div>
          <div style={{fontSize:11,color:T.muted,fontWeight:700,textTransform:"uppercase",letterSpacing:"0.1em",marginBottom:10}}>Vorlagen</div>
          {vorlagen.length===0 && <div style={{fontSize:12,color:T.muted,marginBottom:10}}>Noch keine Vorlage.</div>}
          {vorlagen.map(v=>(
            <div key={v.id} style={{display:"flex",alignItems:"center",gap:4,marginBottom:4}}>
              <div onClick={()=>setAktiveId(v.id)}
                style={{flex:1,padding:"9px 12px",borderRadius:8,cursor:"pointer",fontSize:13,
                  background:aktiveId===v.id?T.accentDim:"transparent",
                  border:`1px solid ${aktiveId===v.id?T.accent+"55":"transparent"}`,
                  color:aktiveId===v.id?T.accent:T.text,
                  fontWeight:aktiveId===v.id?600:400,transition:"all 0.15s"}}>
                {v.name}
              </div>
              <button onClick={()=>loeschen(v.id)}
                style={{background:"transparent",border:"none",color:T.muted,cursor:"pointer",fontSize:14,padding:"4px 6px",borderRadius:4}}
                title="Löschen">✕</button>
            </div>
          ))}
          <div style={{marginTop:12,paddingTop:12,borderTop:`1px solid ${T.border}`}}>
            <input ref={neuNameRef} defaultValue={neuName}
              onChange={e=>setNeuName(e.target.value)}
              placeholder="Name der Vorlage..."
              onKeyDown={e=>e.key==="Enter"&&neueVorlage()}
              style={{...TA,minHeight:"auto",padding:"7px 10px",marginBottom:6,fontSize:12}}/>
            <button onClick={neueVorlage}
              style={{width:"100%",padding:"7px",borderRadius:8,background:T.accent,color:"#1a1814",border:"none",cursor:"pointer",fontSize:12,fontWeight:700}}>
              + Neue Vorlage
            </button>
          </div>
        </div>

        {/* Hauptbereich: Vorlage bearbeiten */}
        {aktive ? (
          <div>
            <div style={{...SECTION}}>
              <div style={STAG}>Layout-Größen (Buchungsseite)</div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:14}}>
                {[
                  {k:"logoHeight",   label:"Logo-Höhe (px)",         def:60,  min:20, max:200},
                  {k:"logoMaxWidth", label:"Logo-Breite max (px)",   def:220, min:60, max:500},
                  {k:"titelSize",    label:"Veranstaltungsname (px)",def:28,  min:14, max:60},
                  {k:"beschrSize",   label:"Beschreibung (px)",      def:14,  min:10, max:30},
                ].map(({k,label,def,min,max})=>(
                  <div key={k} style={{padding:"11px 13px",background:T.bg,borderRadius:8,border:`1px solid ${T.border}`}}>
                    <label style={{fontSize:11,color:T.muted,fontWeight:600,display:"block",marginBottom:7}}>{label}</label>
                    <div style={{display:"flex",alignItems:"center",gap:10}}>
                      <input type="range" min={min} max={max} value={(aktive.style||{})[k]||def}
                        onChange={e=>updStyle(k,Number(e.target.value))}
                        style={{flex:1,accentColor:T.accent}}/>
                      <span style={{fontSize:13,color:T.text,minWidth:34,textAlign:"right",fontWeight:600}}>{(aktive.style||{})[k]||def}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div style={SECTION}>
              <div style={STAG}>Standard-Texte</div>
              <div style={{marginBottom:14}}>
                <label style={LBL}>Beschreibung Deutsch</label>
                <textarea value={aktive.beschreibung_de||""} onChange={e=>updVorlage("beschreibung_de",e.target.value)}
                  placeholder="Standard-Beschreibung für neue Events..."
                  style={TA}/>
              </div>
              <div style={{marginBottom:14}}>
                <label style={LBL}>Event-Info (erscheint auf der Landingpage unter &quot;Das Event&quot;)</label>
                <textarea value={aktive.event_info||""} onChange={e=>updVorlage("event_info",e.target.value)}
                  placeholder={"- 11-18 Uhr\n- Grundpreis 99€ (inkl. 1 Bild)\n- Jedes weitere Bild 49€"}
                  style={TA}/>
              </div>
              <div style={{marginBottom:14}}>
                <label style={LBL}>Homepage-Beschreibung</label>
                <textarea value={aktive.hp_beschreibung||""} onChange={e=>updVorlage("hp_beschreibung",e.target.value)}
                  placeholder={"• Underglass Shooting\n• Preis: 99€\n• 1 Bild inklusive\n• Weitere Bilder: 49€"}
                  style={TA}/>
                <div style={{fontSize:10,color:T.muted,marginTop:3}}>Aufzählungszeichen mit • (Alt+8)</div>
              </div>
              <div>
                <label style={LBL}>Shootingvereinbarung</label>
                <textarea value={aktive.vereinbarung||""} onChange={e=>updVorlage("vereinbarung",e.target.value)}
                  placeholder="Standard-Vereinbarungstext..."
                  style={{...TA, minHeight:140}}/>
              </div>
            </div>

            <div style={{fontSize:12,color:T.muted,padding:"10px 14px",background:T.accentDim,borderRadius:8,border:`1px solid ${T.accent}44`}}>
              💡 Änderungen werden sofort gespeichert.
            </div>
          </div>
        ) : (
          <div style={{color:T.muted,fontSize:13,paddingTop:20}}>← Vorlage auswählen oder neue anlegen</div>
        )}
      </div>
    </div>
  );
}

function BuchungssystemKacheln({events,sortEvents,config,oeffneEventFormular,btn,T,fmtDateRange}){
  const [bsArchivOpen,setBsArchivOpen]=useState(false);
  const bsAktiv=sortEvents(events.filter(ev=>!ev.abgeschlossen&&!ev.abgesagt));
  const bsArchiv=sortEvents(events.filter(ev=>ev.abgeschlossen||ev.abgesagt));
  return(<>
    {bsArchivOpen&&(
      <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.55)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:300}}>
        <div style={{background:T.surface,borderRadius:14,width:"80vw",maxHeight:"80vh",overflow:"hidden",display:"flex",flexDirection:"column",border:`1px solid ${T.border}`}}>
          <div style={{padding:"16px 20px",borderBottom:`1px solid ${T.border}`,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <div style={{fontFamily:"Georgia,serif",fontSize:18,color:T.accent}}>Archiv – Abgeschlossene Veranstaltungen</div>
            <button onClick={()=>setBsArchivOpen(false)} style={{background:"none",border:"none",fontSize:20,cursor:"pointer",color:T.muted}}>×</button>
          </div>
          <div style={{overflowY:"auto",padding:20,display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(240px,1fr))",gap:14}}>
            {bsArchiv.map(ev=>(
              <div key={ev.id} onClick={()=>{setBsArchivOpen(false);oeffneEventFormular(ev);}}
                style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:10,padding:14,cursor:"pointer"}}>
                <div style={{fontFamily:"Georgia,serif",fontSize:14,fontWeight:700,color:T.muted,marginBottom:4}}>{ev.name}</div>
                <div style={{fontSize:11,color:T.muted}}>{ev.date?fmtDateRange(ev):""}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    )}
    <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(240px,1fr))",gap:16,alignItems:"stretch"}}>
      {bsAktiv.length===0&&<div style={{color:T.muted,fontSize:14}}>Keine aktiven Veranstaltungen.</div>}
      {bsAktiv.map(ev=>{
        const st=config.shootingTypes.find(s=>s.eventId===ev.id);
        return(
          <div key={ev.id} onClick={()=>oeffneEventFormular(ev)}
            style={{background:st?.interessenliste?"#fef9ee":T.surface,border:`1px solid ${st?.interessenliste?"#f59e0b88":T.border}`,borderRadius:14,padding:18,cursor:"pointer",transition:"border-color 0.15s",display:"flex",flexDirection:"column"}}
            onMouseEnter={e=>e.currentTarget.style.borderColor=st?.interessenliste?"#f59e0b":T.accent}
            onMouseLeave={e=>e.currentTarget.style.borderColor=st?.interessenliste?"#f59e0b88":T.border}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:6}}>
              <div style={{fontFamily:"Georgia,serif",fontSize:17,fontWeight:700,color:T.text}}>{st?.interessenliste&&<span style={{fontSize:13,marginRight:5}}>📋</span>}{ev.name||"Ohne Namen"}</div>
            </div>
            <div style={{fontSize:12,color:T.muted,marginBottom:14}}>{ev.date?fmtDateRange(ev):""}{(ev.shootingart||ev.fotoart)?` · ${ev.shootingart||ev.fotoart}`:""}</div>
            <div style={{fontSize:12,color:T.muted,marginTop:"auto",marginBottom:12,display:"flex",alignItems:"center",justifyContent:"space-between"}}><span>{st?"Formular bereit":"Noch nicht eingerichtet"}</span>{st&&<span style={{fontSize:10,padding:"3px 9px",borderRadius:10,background:st.hp_aktiv===true?"#4caf50":"#e57373",color:"#fff",fontWeight:700,flexShrink:0}}>🌐 {st.hp_aktiv===true?"aktiv":"inaktiv"}</span>}</div>
            <button style={{...btn(T,"primary",true),width:"100%",justifyContent:"center"}} onClick={()=>oeffneEventFormular(ev)}>Öffnen</button>
          </div>
        );
      })}
      <InteressentenSeiteKachel config={config} T={T}/>
      {bsArchiv.length>0&&(
        <div onClick={()=>setBsArchivOpen(true)}
          style={{background:T.surface,border:`2px dashed ${T.border}`,borderRadius:14,padding:18,cursor:"pointer",transition:"border-color 0.15s",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",gap:10}}
          onMouseEnter={e=>e.currentTarget.style.borderColor=T.accent}
          onMouseLeave={e=>e.currentTarget.style.borderColor=T.border}>
          <div style={{fontSize:32}}>🗄️</div>
          <div style={{fontFamily:"Georgia,serif",fontSize:17,fontWeight:700,color:T.muted}}>Archiv</div>
          <div style={{fontSize:12,color:T.muted}}>{bsArchiv.length} Veranstaltung{bsArchiv.length!==1?"en":""}</div>
        </div>
      )}
    </div>
  </>);
}

function InteressentenSeiteKachel({config,T}){
  const [offen,setOffen]=useState(false);
  const [wahl,setWahl]=useState(null); // null = Liste, sonst {name,url}

  const serverUrl=(localStorage.getItem("sd_server_url")||"").trim().replace(/\/+$/,"");
  const hatInteresse=(config.shootingTypes||[]).some(s=>s.interessenliste);
  if(!hatInteresse||!serverUrl)return null;

  const slugify=s=>(s||"").toLowerCase().trim()
    .replace(/\u00e4/g,"ae").replace(/\u00f6/g,"oe").replace(/\u00fc/g,"ue").replace(/\u00df/g,"ss")
    .replace(/[^a-z0-9]+/g,"-").replace(/^-+|-+$/g,"");

  const sammel={name:"Alle Events gebündelt",url:`${serverUrl}/interesse`,
    hinweis:"Der Besucher wählt sein Event selbst aus einer Liste.",sammel:true};
  const einzel=(config.shootingTypes||[]).filter(s=>s.interessenliste&&s.name).map(s=>({
    name:s.name,url:`${serverUrl}/interesse?shooting=${encodeURIComponent(slugify(s.name))}`,
    hinweis:"Direkt für dieses Event, ohne Auswahl."}));
  const alle=[sammel,...einzel];

  const qrUrl=e=>`${serverUrl}/link?url=${encodeURIComponent(e.url)}&name=${encodeURIComponent(e.name)}`;
  const schliessen=()=>{setOffen(false);setWahl(null);};

  return(<>
    <div onClick={()=>setOffen(true)}
      style={{background:"#eff6ff",border:"1px solid #3b82f688",borderRadius:14,padding:18,display:"flex",flexDirection:"column",gap:10,cursor:"pointer"}}>
      <div style={{display:"flex",alignItems:"center",gap:8}}>
        <span style={{fontSize:20}}>📋</span>
        <div style={{fontFamily:"Georgia,serif",fontSize:17,fontWeight:700,color:"#1d4ed8"}}>Interessenten-Seite</div>
        <span style={{marginLeft:"auto",fontSize:11,color:"#3b82f6"}}>Links &amp; QR →</span>
      </div>
      <div style={{fontSize:12,color:"#3b82f6"}}>{serverUrl}/interesse</div>
      <div style={{fontSize:11,color:"#6b7280",marginTop:"auto"}}>
        Sammelseite oder {einzel.length} Einzellink{einzel.length!==1?"s":""} für einzelne Events.
      </div>
    </div>

    {offen&&(
      <div onClick={schliessen}
        style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.7)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:200,padding:20}}>
        <div onClick={e=>e.stopPropagation()}
          style={{background:"#fff",borderRadius:16,padding:26,maxWidth:440,width:"100%",maxHeight:"88vh",overflowY:"auto"}}>

          {!wahl?(<>
            <div style={{fontFamily:"Georgia,serif",fontSize:19,color:"#1d4ed8",marginBottom:4}}>Interessenten-Seite</div>
            <div style={{fontSize:12,color:"#888",marginBottom:18}}>Welchen Link brauchst du?</div>
            <div style={{display:"flex",flexDirection:"column",gap:8}}>
              {alle.map((e,i)=>(
                <div key={i} onClick={()=>setWahl(e)}
                  style={{border:`1px solid ${e.sammel?"#3b82f688":"#f59e0b88"}`,background:e.sammel?"#eff6ff":"#fef9ee",
                    borderRadius:10,padding:"13px 15px",cursor:"pointer",display:"flex",alignItems:"center",gap:10}}>
                  <span style={{fontSize:16}}>{e.sammel?"📋":"📌"}</span>
                  <div style={{flex:1,minWidth:0}}>
                    <div style={{fontSize:14,fontWeight:700,color:e.sammel?"#1d4ed8":"#b45309"}}>{e.name}</div>
                    <div style={{fontSize:11,color:"#6b7280",marginTop:2}}>{e.hinweis}</div>
                  </div>
                  <span style={{color:"#9ca3af",fontSize:16,flexShrink:0}}>›</span>
                </div>
              ))}
            </div>
            <button onClick={schliessen}
              style={{width:"100%",marginTop:18,background:"none",border:"1px solid #ddd",borderRadius:8,padding:"9px 20px",fontSize:13,cursor:"pointer",color:"#666"}}>Schließen</button>
          </>):(<>
            <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:14}}>
              <button onClick={()=>setWahl(null)}
                style={{background:"none",border:"none",color:"#3b82f6",fontSize:13,cursor:"pointer",padding:0,fontFamily:"inherit"}}>‹ zurück</button>
            </div>
            <div style={{fontFamily:"Georgia,serif",fontSize:18,color:wahl.sammel?"#1d4ed8":"#b45309",marginBottom:4,textAlign:"center"}}>{wahl.name}</div>
            <div style={{fontSize:12,color:"#888",marginBottom:16,textAlign:"center"}}>Scannen → URL zum Kopieren auf dem Handy</div>
            <img src={`https://api.qrserver.com/v1/create-qr-code/?size=260x260&margin=12&data=${encodeURIComponent(qrUrl(wahl))}`}
              style={{width:220,height:220,borderRadius:8,margin:"0 auto 14px",display:"block"}} alt="QR Code"/>
            <div style={{fontSize:11,color:"#888",wordBreak:"break-all",marginBottom:16,textAlign:"center",padding:"0 8px"}}>{wahl.url}</div>
            <div style={{display:"flex",gap:8}}>
              <button onClick={()=>navigator.clipboard.writeText(wahl.url).then(()=>alert("Link kopiert!"))}
                style={{flex:1,background:wahl.sammel?"#3b82f6":"#f59e0b",color:"#fff",border:"none",borderRadius:8,padding:"10px 12px",fontSize:13,fontWeight:600,cursor:"pointer"}}>🔗 Link kopieren</button>
              <button onClick={()=>window.open(wahl.url,"_blank")}
                style={{flex:1,background:"none",color:"#666",border:"1px solid #ddd",borderRadius:8,padding:"10px 12px",fontSize:13,fontWeight:600,cursor:"pointer"}}>↗ Öffnen</button>
            </div>
          </>)}
        </div>
      </div>
    )}
  </>);
}

function STNameEditor({st,T,setConfig,setEvents}){
  const [editing,setEditing]=useState(false);
  const [val,setVal]=useState(st.name);
  const save=()=>{
    setConfig(c=>({...c,shootingTypes:c.shootingTypes.map(s=>s.id===st.id?{...s,name:val}:s)}));
    if(setEvents&&st.eventId)setEvents(evs=>evs.map(e=>e.id===st.eventId?{...e,name:val}:e));
    setEditing(false);
  };
  return(
    <div style={{background:st.interessenliste?"#f59e0b33":T.accentDim,border:`1px solid ${st.interessenliste?"#f59e0b":T.accent+"55"}`,borderRadius:8,padding:"10px 14px",display:"flex",alignItems:"center",gap:6}}>
      {st.interessenliste&&<span style={{fontSize:10}}>📋</span>}
      {editing?(
        <input autoFocus value={val} onChange={e=>setVal(e.target.value)}
          onBlur={save}
          onKeyDown={e=>{if(e.key==="Enter")save();if(e.key==="Escape")setEditing(false);}}
          style={{flex:1,background:"transparent",border:"none",outline:"none",fontSize:13,fontWeight:600,color:st.interessenliste?"#b45309":T.accent,fontFamily:"inherit"}}/>
      ):(
        <span title="Klicken zum Bearbeiten" onClick={()=>setEditing(true)}
          style={{flex:1,fontSize:13,fontWeight:600,color:st.interessenliste?"#b45309":T.accent,cursor:"text"}}>
          {st.name}
        </span>
      )}
      {!editing&&<span onClick={()=>setEditing(true)} style={{fontSize:11,color:T.muted,cursor:"pointer",flexShrink:0}}>✏️</span>}
    </div>
  );
}

function BuchungssystemPage({T:propT, onExportToShootingplan, onOpenShootingplan, focusId, focusView, onFocusConsumed, events=[], setEvents}){
  // Beim Löschen einer Buchung auch Veranstaltungsplan und Abrechnung bereinigen
  function entferneAusPlanUndAbrechnung(bks){
    const ids=new Set(bks.map(b=>b.id).filter(Boolean));
    const namen=new Set();
    bks.forEach(b=>{
      let felder=[];
      try{const _cfg=JSON.parse(localStorage.getItem("sd_buchung_config")||"{}");
        const _st=(_cfg.shootingTypes||[]).find(s=>s.name===b.shootingType);
        felder=Array.isArray(_st&&_st.felder)?_st.felder:[];}catch(e){}
      const m=mapBookingFelder(b,felder);
      [m.name,b.geschenk?.name,[m.vorname,m.nachname].filter(Boolean).join(" ")]
        .forEach(n=>{const x=String(n||"").trim().toLowerCase();if(x)namen.add(x);});
    });
    const trifft=r=>(r._buchungId&&ids.has(r._buchungId))
      ||namen.has(String(r.name||"").trim().toLowerCase());

    let entfernt=0;
    // Veranstaltungsplan
    try{
      const plaene=JSON.parse(localStorage.getItem("sd_shootingplaene")||"{}");
      let geaendert=false;
      Object.keys(plaene).forEach(evId=>{
        const rows=Array.isArray(plaene[evId])?plaene[evId]:[];
        const neu=rows.filter(r=>!trifft(r));
        if(neu.length!==rows.length){entfernt+=rows.length-neu.length;plaene[evId]=neu;geaendert=true;}
      });
      if(geaendert){
        localStorage.setItem("sd_shootingplaene",JSON.stringify(plaene));
        const su=(localStorage.getItem("sd_server_url")||"").trim().replace(/\/+$/,"");
        if(su)fetch(su+"/api/shootingplaene",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(plaene)}).catch(()=>{});
      }
    }catch(e){console.warn("Veranstaltungsplan bereinigen fehlgeschlagen:",e);}

    // Abrechnung (Teilnehmer im Event)
    if(setEvents){
      setEvents(prev=>prev.map(ev=>{
        const tn=Array.isArray(ev.teilnehmer)?ev.teilnehmer:[];
        const neu=tn.filter(t=>!trifft(t));
        if(neu.length===tn.length)return ev;
        entfernt+=tn.length-neu.length;
        return {...ev,teilnehmer:neu};
      }));
    }
    return entfernt;
  }

  const [dark,setDark]=useState(true);
  const T=propT||(dark?DARK:LIGHT);
  const {dir:evSortDir,toggle:evSortToggle,sortEvents}=useEventSort();
  // Solange false, wird die lokale Config nicht zum Server geschoben
  const configBereit=useRef(false);

  const [config,setConfig]=useState(()=>{
    try{
      const saved=JSON.parse(localStorage.getItem("sd_buchung_config")||"null");
      if(!saved){
        // Automatisch vom Server laden falls localStorage leer
        const serverUrl=(localStorage.getItem("sd_server_url")||window.location.origin).trim().replace(/\/+$/,"");
        fetch(`${serverUrl}/api/get-config`).then(r=>r.json()).then(data=>{
          if(data&&data.shootingTypes){
            localStorage.setItem("sd_buchung_config",JSON.stringify(data));
            window.location.reload();
          }
        }).catch(()=>{});
        return DEFAULT_CONFIG;
      }
      // Doppelte Formulare entfernen (pro Veranstaltung nur eines)
      const seen=new Set();
      let sts=(saved.shootingTypes||[]).filter(s=>{
        const key=s.eventId?("ev:"+s.eventId):("id:"+s.id);
        if(seen.has(key))return false;
        seen.add(key);return true;
      });
      // Fehlende Shooting-Typen aus DEFAULT_CONFIG ergänzen
      const existingNames=new Set(sts.map(s=>s.name));
      const missing=DEFAULT_CONFIG.shootingTypes.filter(s=>!existingNames.has(s.name));
      sts=[...sts,...missing];
      // sys_nr zu bestehenden Formularen hinzufügen falls noch nicht vorhanden
      sts=sts.map(s=>{
        if(Array.isArray(s.felder)&&!s.felder.find(f=>f.id==="sys_nr")){
          const nrFeld=SYSTEM_FIELDS.find(f=>f.id==="sys_nr");
          return {...s,felder:[nrFeld,...s.felder]};
        }
        return s;
      });
      return {...saved,shootingTypes:sts};
    }
    catch{return DEFAULT_CONFIG;}
  });
  const [buchungen,setBuchungen]=useState(()=>{
    try{return JSON.parse(localStorage.getItem("sd_buchungen")||"null")||[];}
    catch{return [];}
  });
  useEffect(()=>{localStorage.setItem("sd_buchungen",JSON.stringify(buchungen));},[buchungen]);
  const [interessenten,setInteressenten]=useState([]);
  useEffect(()=>{
    const serverUrl=(localStorage.getItem("sd_server_url")||"").trim().replace(/\/+$/,"");
    if(!serverUrl)return;
    fetch(`${serverUrl}/api/interessenten`).then(r=>r.ok?r.json():null).then(d=>{if(Array.isArray(d))setInteressenten(d);}).catch(()=>{});
  },[]);
  // Server-Buchungen beim Öffnen laden und zusammenführen + alle 30s automatisch prüfen
  useEffect(()=>{
    const serverUrl=(localStorage.getItem("sd_server_url")||"").trim().replace(/\/+$/,"");
    if(!serverUrl)return;

    // Belegte Slots vom Server uebernehmen. Der Server markiert sie bei jeder
    // Online-Buchung. Ohne das hier wuerde unser Config-Push sie ueberschreiben.
    function syncBelegteSlots(){
      return fetch(`${serverUrl}/api/buchung-config`)
        .then(r=>r.ok?r.json():null)
        .then(srv=>{
          if(!srv||!Array.isArray(srv.shootingTypes))return;
          setConfig(lokal=>{
            let geaendert=false;
            const sts=(lokal.shootingTypes||[]).map(st=>{
              const srvSt=srv.shootingTypes.find(x=>x.id===st.id||x.name===st.name);
              if(!srvSt||!Array.isArray(srvSt.slots))return st;
              const slots=(st.slots||[]).map(sl=>{
                const srvSl=(srvSt.slots||[]).find(x=>x.id===sl.id||x.datum===sl.datum);
                if(!srvSl)return sl;
                const vorhanden=sl.booked||[];
                // Nur ergaenzen, nie entfernen. Freigeben bleibt manuell moeglich.
                const neu=(srvSl.booked||[]).filter(z=>!vorhanden.includes(z)
                  &&(sl.zeiten||[]).includes(z));
                if(neu.length===0)return sl;
                geaendert=true;
                return {...sl,booked:[...vorhanden,...neu]};
              });
              return {...st,slots};
            });
            return geaendert?{...lokal,shootingTypes:sts}:lokal;
          });
        })
        .catch(()=>{});
    }

    function syncBuchungen(){
      fetch(`${serverUrl}/api/buchungen`)
        .then(r=>r.json())
        .then(serverBuch=>{
          if(!Array.isArray(serverBuch)||serverBuch.length===0)return;
          const deleted=new Set(JSON.parse(localStorage.getItem("sd_buchungen_deleted")||"[]"));
          setBuchungen(local=>{
            const ids=new Set(local.map(b=>b.id));
            const neu=serverBuch.filter(b=>b.id&&!ids.has(b.id)&&!deleted.has(b.id));
            return neu.length===0?local:[...local,...neu];
          });
        }).catch(()=>{});
    }

    // Erst die belegten Slots holen, dann darf gepusht werden
    syncBelegteSlots().then(()=>{configBereit.current=true;});
    syncBuchungen();
    const timer=setInterval(()=>{syncBelegteSlots();syncBuchungen();},30000);
    return ()=>clearInterval(timer);
  },[]);
  // Config automatisch auf Server synchronisieren
  useEffect(()=>{
    // Erst pushen, wenn wir den Serverstand der belegten Slots geholt haben.
    // Sonst ueberschreibt der erste Push Buchungen, die waehrend unserer
    // Abwesenheit reingekommen sind.
    if(!configBereit.current)return;
    // Vollständige Rassenliste sammeln: aus allen Profilen (rassen + aus Einträgen) sowie der alten Liste
    let rassenListe=[];
    try{
      const _set=new Set();
      const _profs=JSON.parse(localStorage.getItem("sd_profiles")||"[]");
      (Array.isArray(_profs)?_profs:[]).forEach(p=>{
        (p.rassen||[]).forEach(r=>{if(r)_set.add(r);});
        (p.eintraege||[]).forEach(e=>{if(e&&e.rasse)_set.add(e.rasse);});
      });
      try{(JSON.parse(localStorage.getItem("sd_rassen_profil")||"{}").rassen||[]).forEach(r=>{if(r)_set.add(r);});}catch{}
      rassenListe=[..._set].sort((a,b)=>a.localeCompare(b,"de"));
    }catch{}
    const cfgMitRassen={...config,rassenListe};
    // Auch lokal mit Rassenliste speichern, damit das Formular (auch aus dem Cache) sie hat
    localStorage.setItem("sd_buchung_config",JSON.stringify(cfgMitRassen));
    try{
      const serverUrl=(localStorage.getItem("sd_server_url")||"").trim().replace(/\/+$/,"");
      if(serverUrl){
        fetch(`${serverUrl}/api/buchung-config`,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(cfgMitRassen)}).catch(()=>{});
      }
    }catch{}
  },[config]);
  useEffect(()=>{localStorage.setItem("sd_buchungen",JSON.stringify(buchungen));},[buchungen]);

  const [view,setView]=useState(()=>{const v=localStorage.getItem("sd_bp_nav");if(v){localStorage.removeItem("sd_bp_nav");return v;}return "admin";});
  const [activeSTId,setActiveSTId]=useState(()=>{
    const shooting=localStorage.getItem("sd_bp_shooting");
    if(shooting){
      localStorage.removeItem("sd_bp_shooting");
      const found=config.shootingTypes.find(s=>s.name===shooting);
      if(found)return found.id;
    }
    return config.shootingTypes[0]?.id;
  });
  const [previewSTId,setPreviewSTId]=useState(config.shootingTypes[0]?.id);
  const [selEventId,setSelEventId]=useState(null);
  const [previewVorort,setPreviewVorort]=useState(false);

  const activeST=config.shootingTypes.find(s=>s.id===activeSTId)||config.shootingTypes[0];
  const previewST=config.shootingTypes.find(s=>s.id===previewSTId)||config.shootingTypes[0];

  // Kachel öffnen: Formular der Veranstaltung suchen oder neu anlegen
  const [vorlagenDialog, setVorlagenDialog] = useState(null); // {ev} wenn Dialog offen

  function applyVorlage(ev, vorlageId){
    const tpl=config.shootingTypes.find(s=>s.id===config.standardFormularId)||config.shootingTypes.find(s=>s.name==="Veranstaltung")||config.shootingTypes[0]||{};
    const slug=(n=>(n||"").toLowerCase().replace(/ä/g,"ae").replace(/ö/g,"oe").replace(/ü/g,"ue").replace(/ß/g,"ss").replace(/[^a-z0-9]+/g,"-").replace(/^-+|-+$/g,""))(ev.name)||"veranstaltung";
    let mv = {};
    if(vorlageId){
      const alle=(()=>{try{return JSON.parse(localStorage.getItem("sd_mustervorlagen")||"[]")||[];}catch{return [];}})();
      mv = alle.find(v=>v.id===vorlageId) || {};
    }
    const st={
      ...JSON.parse(JSON.stringify(tpl)),
      id:"st_ev_"+ev.id, eventId:ev.id, name:ev.name||"Veranstaltung",
      buchungsUrl:slug, preis:(ev.preise&&Number(ev.preise.shootingGebuehr))||0,
      preisWeitererHund:(ev.preise&&Number(ev.preise.preisWeitererHund))||0,
      slots:[], aktiv:true, hp_aktiv:true,
      // Textfelder immer leer beim Erstellen
      event_info:"", beschreibung:{de:"",en:"",fr:"",it:"",es:"",nl:"",pl:"",pt:"",tr:"",cs:"",hu:"",sv:""}, slotInfo:{de:"",en:"",fr:"",it:"",es:"",nl:"",pl:"",pt:"",tr:"",cs:"",hu:"",sv:""}, hp_beschreibung:"", vereinbarung:{de:"",en:"",fr:"",it:"",es:"",nl:"",pl:"",pt:"",tr:"",cs:"",hu:"",sv:""}, vorortHinweis:"",
      ...(mv.beschreibung_de?{beschreibung:{de:mv.beschreibung_de,en:""}}:{}),
      ...(mv.hp_beschreibung?{hp_beschreibung:mv.hp_beschreibung}:{}),
      ...(mv.vereinbarung?{vereinbarung:{...tpl.vereinbarung,de:mv.vereinbarung}}:{}),
      ...(mv.event_info?{event_info:mv.event_info}:{}),
      ...(mv.style?{style:mv.style}:{}),
    };
    if(Array.isArray(st.felder))st.felder=st.felder.map((f,i)=>({...f,id:(f.id||"f")+"_"+ev.id+"_"+i}));
    setConfig(c=>({...c,shootingTypes:[...c.shootingTypes,st]}));
    setVorlagenDialog(null);
    setActiveSTId(st.id);
    setPreviewSTId(st.id);
    setSelEventId(ev.id);
  }

  function oeffneEventFormular(ev){
    if(!ev)return;
    let st=config.shootingTypes.find(s=>s.eventId===ev.id);
    if(!st){
      // Prüfen ob Vorlagen vorhanden
      const alle=(()=>{try{return JSON.parse(localStorage.getItem("sd_mustervorlagen")||"[]")||[];}catch{return [];}})();
      if(alle.length>0){
        setVorlagenDialog({ev});
        return;
      }
      // Keine Vorlagen: direkt ohne Vorlage anlegen
      applyVorlage(ev, null);
      return;
    }
    setActiveSTId(st.id);
    setPreviewSTId(st.id);
    setSelEventId(ev.id);
  }

  // Beim Öffnen aus einer Veranstaltung direkt deren Buchungsplan-Formular anzeigen
  useEffect(()=>{
    if(focusId&&config.shootingTypes.some(s=>s.id===focusId)){
      const st=config.shootingTypes.find(s=>s.id===focusId);
      setActiveSTId(focusId);
      setPreviewSTId(focusId);
      if(st&&st.eventId)setSelEventId(st.eventId);
      setView(focusView||"admin");
      onFocusConsumed&&onFocusConsumed();
    }
  },[focusId]);

  // Preis kommt immer aus der Veranstaltung, nie aus dem Buchungsplan
  useEffect(()=>{
    setConfig(c=>{
      let changed=false;
      const st2=c.shootingTypes.map(s=>{
        if(s.eventId){
          const ev=events.find(e=>e.id===s.eventId);
          if(ev){
            const p=(ev.preise&&Number(ev.preise.shootingGebuehr))||0;
            const pw=(ev.preise&&Number(ev.preise.preisWeitererHund))||0;
            if(s.preis!==p||s.preisWeitererHund!==pw){changed=true;return {...s,preis:p,preisWeitererHund:pw};}
          }
        }
        return s;
      });
      return changed?{...c,shootingTypes:st2}:c;
    });
  },[events]);

  function updateST(updated){
    setConfig(c=>({...c,shootingTypes:c.shootingTypes.map(s=>s.id===updated.id?updated:s)}));
  }

  async function stornoBooking(bookingId, manuell=false){
    const bk=buchungen.find(b=>b.id===bookingId);
    if(!bk)return;
    if(!manuell&&!confirm(`Buchung von ${bk.formData?.sys_name||"Kunde"} wirklich stornieren?`))return;

    // Status auf storniert setzen
    setBuchungen(p=>p.map(b=>b.id===bookingId?{...b,status:"storniert"}:b));

    // Slot wieder freigeben
    try{
      const cfg=JSON.parse(localStorage.getItem("sd_buchung_config")||"{}");
      const st=(cfg.shootingTypes||[]).find(s=>s.name===bk.shootingType);
      if(st){
        const updated={...cfg,shootingTypes:(cfg.shootingTypes||[]).map(s=>{
          if(s.name!==bk.shootingType)return s;
          return {...s,slots:(s.slots||[]).map(sl=>{
            if(sl.datum!==bk.datum)return sl;
            return {...sl,booked:(sl.booked||[]).filter(z=>z!==bk.uhrzeit)};
          })};
        })};
        localStorage.setItem("sd_buchung_config",JSON.stringify(updated));
        setConfig(updated);
      }
    }catch(e){console.error("Slot-Freigabe fehlgeschlagen:",e);}

    // Shootingplan aktualisieren
    try{
      const st2=(config.shootingTypes||[]).find(s=>s.name===bk.shootingType);
      if(st2&&st2.eventId){
        const plaene=JSON.parse(localStorage.getItem("sd_shootingplaene")||"{}");
        const rows=Array.isArray(plaene[st2.eventId])?plaene[st2.eventId]:[];
        plaene[st2.eventId]=rows.map(r=>r._buchungId===bookingId?{...r,storniert:true,notiz:"storniert"}:r);
        localStorage.setItem("sd_shootingplaene",JSON.stringify(plaene));
      }
    }catch(e){}

    // E-Mails senden
    try{
      const smtp=JSON.parse(localStorage.getItem("sd_smtp_buchung")||localStorage.getItem("sd_smtp_settings")||"{}");
      const cfg2=JSON.parse(localStorage.getItem("sd_buchung_config")||"{}");
      const studio=cfg2.studioName||"";
      const srvUrl=(localStorage.getItem("sd_server_url")||"").replace(/\/+$/,"");
      const kundeEmail=bk.formData?.sys_email||"";
      const kundeName=bk.formData?.sys_name||"Kunde";
      const datumStr=bk.datum?(()=>{try{return new Date(bk.datum).toLocaleDateString("de-DE",{day:"2-digit",month:"2-digit",year:"numeric"});}catch{return bk.datum;}})():"";
      const studioEmail=smtp.from_email||smtp.user||"";

      // Mail an Kunde
      if(kundeEmail){
        const text_stor_k=`Hallo ${kundeName},\n\ndein Termin am ${datumStr} um ${bk.uhrzeit||""} Uhr (${bk.shootingType}) wurde erfolgreich storniert.\n\nBei Fragen stehe ich gerne zur Verfügung.\n\nHerzliche Grüße\n${studio}`;
        await fetch(`${srvUrl}/api/newsletter`,{method:"POST",headers:{"Content-Type":"application/json"},
          body:JSON.stringify({smtp,recipients:[{name:kundeName,email:kundeEmail}],
            subject:`Stornierungsbestätigung – ${bk.shootingType}`,
            text:`Hallo ${kundeName},

dein Termin am ${datumStr} um ${bk.uhrzeit||""} Uhr (${bk.shootingType}) wurde erfolgreich storniert.

Bei Fragen stehe ich gerne zur Verfügung.

Herzliche Grüße
${studio}`,
            html:buildScattoDeskMailHtml(text_stor_k,_getSig().logo,_getSig().text),logo:_getSig().logo,
          })});
      }

      // Mail an Studio
      if(studioEmail){
        const text_stor_s=`Stornierung eingegangen:\n\nKunde: ${kundeName}\nE-Mail: ${kundeEmail}\nVeranstaltung: ${bk.shootingType}\nDatum: ${datumStr} ${bk.uhrzeit||""}\nSlot freigegeben.`;
        await fetch(`${srvUrl}/api/newsletter`,{method:"POST",headers:{"Content-Type":"application/json"},
          body:JSON.stringify({smtp,recipients:[{name:studio,email:studioEmail}],
            subject:`⚠️ Stornierung: ${kundeName} – ${bk.shootingType} ${datumStr}`,
            text:`Stornierung eingegangen:

Kunde: ${kundeName}
E-Mail: ${kundeEmail}
Veranstaltung: ${bk.shootingType}
Datum: ${datumStr}
Uhrzeit: ${bk.uhrzeit||""}

Der Slot wurde wieder freigegeben.`,
            html:buildScattoDeskMailHtml(text_stor_s,_getSig().logo,_getSig().text),logo:_getSig().logo,
          })});
      }
    }catch(e){console.error("Storno-Mail fehlgeschlagen:",e);}

    if(!manuell)alert("✅ Buchung storniert, E-Mails versendet, Slot freigegeben.");
  }

  async function handleBooked(booking){
    setBuchungen(p=>[...p,booking]);
    sendTelegramNotification(booking, config);

    // Automatisch in Shootingplan eintragen
    try{
      const st=config.shootingTypes.find(s=>s.name===booking.shootingType);
      if(st&&st.eventId){
        const plaene=JSON.parse(localStorage.getItem("sd_shootingplaene")||"{}");
        const rows=Array.isArray(plaene[st.eventId])?plaene[st.eventId]:[];
        // Duplikat prüfen (gleiche Buchungs-ID)
        if(!rows.find(r=>r._buchungId===booking.id)){
          const m=mapBookingFelder(booking, st.felder);
          const neu={
            id:uid(),
            _buchungId:booking.id,
            nr:String(rows.length+1).padStart(2,"0"),
            uhrzeit:booking.uhrzeit||"",
            name:m.name||"",
            vorname:m.vorname||"",
            nachname:m.nachname||"",
            hund:m.hund||"",
            rasse:m.rasse||"",
            geschlecht:m.geschlecht||"",
            alter:m.alter||"",
            alterMonate:m.alterMonate||"",
            telefon:m.telefon||"",
            email:m.email||"",
            strasse:m.strasse||"",plz:m.plz||"",ort:m.ort||"",notiz:"",cal:"",jot:"",
          };
          plaene[st.eventId]=[...rows,neu];
          localStorage.setItem("sd_shootingplaene",JSON.stringify(plaene));
        }
      }
    }catch(e){console.error("Shootingplan-Sync fehlgeschlagen:",e);}

    // An Server schicken: erzeugt Anmelde-PDF und mailt an Kunde + Studio
    try{
      const smtp=JSON.parse(localStorage.getItem("sd_smtp_settings")||"{}");
      const stMatch=(config.shootingTypes||[]).find(s=>s.name===booking.shootingType)||{};
      const ver=stMatch.vereinbarung?.[booking.lang]||stMatch.vereinbarung?.de||"";
      const studioEmail=smtp.from_email||smtp.user||"";
      const url=(localStorage.getItem("sd_server_url")||"http://167.233.88.11")+"/api/buchung";
      const r=await fetch(url,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({
        booking,
        studio:{studioname:config.studioName||"", studio_logo:config.logo||"", studio_email:studioEmail},
        logo:config.logo||null,
        smtp,
        vereinbarung:ver,
        studioEmail,
        zahlungsart:(stMatch.zahlungsart||"vorab"),
        stornoLink:booking.stornoToken?(((localStorage.getItem("sd_server_url")||"").trim().replace(/[/]+$/,"")||window.location.origin)+"/storno/"+booking.stornoToken):"",
      })});
      const res=await r.json().catch(()=>({}));
      if(res&&res.hinweise&&res.hinweise.length){console.warn("Buchung-Hinweise vom Server:",res.hinweise);}
      return res;
    }catch(e){console.error("Buchung an Server fehlgeschlagen:",e);return null;}
  }

  function exportToShootingplan(bks){
    if(onExportToShootingplan){onExportToShootingplan(bks);return;}
    // Demo: JSON download
    const rows=bks.map(b=>({
      nr:"",uhrzeit:b.uhrzeit,
      name:b.formData?.sys_name||"",
      rasse:b.formData?.sys_rasse||"",
      hund:b.formData?.sys_tiername||"",
      alter:b.formData?.sys_alter||"",
      geschlecht:b.formData?.sys_geschlecht||"",
      telefon:b.formData?.sys_tel||"",
      email:b.formData?.sys_email||"",
      strasse:b.formData?.sys_strasse||"",
      plz:b.formData?.sys_plz||"",
      ort:b.formData?.sys_ort||"",
    }));
    const blob=new Blob([JSON.stringify({event_name:"Import aus Buchungssystem",rows:rows.map(r=>Object.values(r))},null,2)],{type:"application/json"});
    const a=document.createElement("a");a.href=URL.createObjectURL(blob);a.download="buchungen_shootingplan.json";a.click();
  }

  const NAV=[
    {id:"admin",         label:"⚙️ Formular-Builder"},
    {id:"mustervorlage", label:"📋 Mustervorlage"},
    {id:"buchungen",     label:`📥 Buchungen (${buchungen.length})`},
    {id:"preview",       label:"👁️ Vorschau (Kundensicht)"},
  ];

  return(
    <div style={{minHeight:"100vh",background:T.bg,color:T.text,fontFamily:"Inter,system-ui,sans-serif",fontSize:14}}>
      {/* Header */}
      <div style={{background:T.surface,borderBottom:`1px solid ${T.border}`,padding:"0 28px",display:"flex",alignItems:"center",justifyContent:"space-between",height:52,position:"sticky",top:0,zIndex:40}}>
        <div style={{display:"flex",alignItems:"center",gap:20}}>
          <div style={{fontFamily:"Georgia,serif",fontSize:16,color:T.accent}}>Buchungssystem</div>
          <div style={{display:"flex",gap:4}}>
            {NAV.map(n=>(
              <button key={n.id} style={btn(T,view===n.id?"active":"ghost",true)} onClick={()=>setView(n.id)}>{n.label}</button>
            ))}
          </div>
        </div>
        <div style={{display:"flex",gap:8,alignItems:"center"}}>
          <button style={{background:"#c0392b",color:"#fff",border:"none",borderRadius:6,padding:"6px 16px",fontWeight:700,fontSize:13,cursor:"pointer"}} onClick={()=>{
            const serverUrl=(localStorage.getItem("sd_server_url")||"").trim().replace(/\/+$/,"");
            if(!serverUrl){alert("Keine Server-URL konfiguriert.");return;}
            const cfg=JSON.parse(localStorage.getItem("sd_buchung_config")||"null");
            if(!cfg){alert("Keine Config gefunden.");return;}
            fetch(serverUrl+"/api/buchung-config",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(cfg)}).then(r=>r.json()).then(d=>alert(d.ok?"✅ Gespeichert!":"Fehler: "+JSON.stringify(d))).catch(e=>alert("Fehler: "+e));
          }}>💾 Änderung speichern</button>
          {!propT&&<button style={btn(T,"ghost",true)} onClick={()=>setDark(d=>!d)}>{dark?"☀️":"🌙"}</button>}
        </div>
      </div>

      <div style={{padding:28}}>
        {/* Interessenten */}
        {view==="interessenten"&&(()=>{
          const stName=activeST?.name||"";
          const liste=interessenten.filter(i=>i.shootingType===stName);
          const serverUrl=(localStorage.getItem("sd_server_url")||"").trim().replace(/\/+$/,"");
          const smtp=(()=>{try{return JSON.parse(localStorage.getItem("sd_smtp_buchung")||localStorage.getItem("sd_smtp_settings")||"{}");}catch{return {};}})();

          const zuBuchung=async(int)=>{
            // Der Link zeigt immer die aktuelle Landingpage. Der Text der Mail
            // benutzt aber {{datum}} und damit den gemerkten Wunschtermin.
            // Wurde der Termin inzwischen verschoben, stuenden in einer Mail
            // zwei verschiedene Daten. Deshalb hier nachfragen.
            const nochAngeboten=(activeST?.terminoptionen||[]).some(o=>(typeof o==="object"?o.datum:o)===int.terminwahl);
            if(int.terminwahl&&!nochAngeboten){
              if(!confirm(
                "Achtung: "+int.name+" ist auf den "+int.terminwahl+" vorgemerkt, "+
                "dieser Termin wird nicht mehr angeboten.\n\n"+
                "Der Link führt zur aktuellen Landingpage mit den richtigen Terminen. "+
                "Falls in deiner Vorlage der Platzhalter für das Datum steht, würde in "+
                "der Mail aber noch der alte Termin stehen.\n\n"+
                "Besser: erst oben im Auswahlfeld auf den neuen Termin umtragen.\n\n"+
                "Trotzdem jetzt senden?"))return;
            }
            if(!confirm(`${int.name} benachrichtigen und Landingpage-Link schicken?`))return;
            // Landingpage-URL ermitteln
            const ev=events?.find(e=>e.id===activeST?.eventId);
            const evSlug=ev?.slug||ev?.name?.toLowerCase().replace(/[^a-z0-9]+/g,"-").replace(/^-|-$/g,"")||"";
            const buchungsUrl=`https://buchen.m-h-photo.de/landing/${evSlug}`;
            // Vorlage buchungsbestaetigung verwenden
            const _vorlagen=(()=>{try{return JSON.parse(localStorage.getItem("sd_email_vorlagen")||"{}");}catch{return {};}})();
            const _defTmpl={betreff:"Buchungsbestätigung – {{shooting}}",text:"Hallo {{name}},\n\nvielen Dank für deine Buchung!\n\n📅 {{datum}}\n🕐 {{uhrzeit}}\n📷 {{shooting}}\n\nBei Fragen stehe ich gerne zur Verfügung.\n\nHerzliche Grüße\n{{studio}}"};
            const _tmpl=_vorlagen.buchungsbestaetigung||_defTmpl;
            const _studio=config?.studioName||smtp.from||"Markus Heber Photography";
            const _rep=(s)=>s
              .replace(/{{name}}/g,int.name||"").replace(/{{vorname}}/g,vornameAus(int.name))
              .replace(/{{(shooting|event|veranstaltung)}}/g,stName||"").replace(/{{datum}}/g,int.terminwahl||"")
              .replace(/{{uhrzeit}}/g,"").replace(/{{preis}}/g,"")
              .replace(/{{studio}}/g,_studio)
              .replace(/{{buchungslink}}/g,buchungsUrl)
              .replace(/{{link}}/g,buchungsUrl);
            const _betreff=_rep(_tmpl.betreff);
            const _text=_rep(_tmpl.text)+`\n\n🔗 Jetzt Slot buchen:\n${buchungsUrl}`;
            const _html=`<p>${_rep(_tmpl.text).replace(/\n/g,"<br/>")}</p><p><a href="${buchungsUrl}" style="background:#c8860a;color:#fff;padding:10px 20px;border-radius:6px;text-decoration:none;font-weight:bold;">Jetzt Slot buchen</a></p>`;
            // Mail schicken wenn Email vorhanden
            if(int.email&&smtp.host){
              await fetch(`${serverUrl}/api/newsletter`,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({smtp,recipients:[{name:int.name,email:int.email}],subject:_betreff,text:_text,html:_html,logo:""})}).catch(()=>{});
            }
            // Aus Interessentenliste entfernen
            const neu=interessenten.filter(i=>i.id!==int.id);
            setInteressenten(neu);
            fetch(`${serverUrl}/api/interessenten`,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(neu)}).catch(()=>{});
            alert(`${int.name} wurde benachrichtigt. Nach der Slot-Buchung erscheint er in den Buchungen.`);
          };

          const loeschen=(int)=>{
            if(!confirm(`${int.name} löschen?`))return;
            const neu=interessenten.filter(i=>i.id!==int.id);
            setInteressenten(neu);
            fetch(`${serverUrl}/api/interessenten`,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(neu)}).catch(()=>{});
          };

          // Interessent auf einen anderen Termin umtragen
          const terminAendern=(int,neuerTermin)=>{
            const neu=interessenten.map(i=>i.id===int.id?{...i,terminwahl:neuerTermin}:i);
            setInteressenten(neu);
            fetch(`${serverUrl}/api/interessenten`,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(neu)}).catch(()=>{});
          };

          const terminoptionen=(activeST?.terminoptionen||[]).map(o=>typeof o==="object"?o:{datum:o,min:""});
          const stimmen={};
          terminoptionen.forEach(o=>{stimmen[o.datum]=0;});
          liste.forEach(i=>{if(i.terminwahl&&stimmen[i.terminwahl]!==undefined)stimmen[i.terminwahl]++;});
          const maxStimmen=Math.max(1,...Object.values(stimmen));

          return(
            <div style={{padding:"0 28px 28px"}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
                <div style={{display:"flex",alignItems:"center",gap:12}}>
                  <button onClick={()=>{
                    if(activeST?.id)setActiveSTId(activeST.id);
                    if(activeST?.eventId)setSelEventId(activeST.eventId);
                    setView("admin");
                  }} style={{background:"none",border:`1px solid ${T.border}`,borderRadius:8,padding:"5px 12px",cursor:"pointer",color:T.muted,fontSize:13,fontFamily:"inherit"}}>← {stName}</button>
                  <div>
                    <div style={{fontFamily:"Georgia,serif",fontSize:15,color:T.accent}}>{stName} — Interessenten</div>
                    <div style={{fontSize:12,color:T.muted,marginTop:2}}>{liste.length} Vormerkung{liste.length!==1?"en":""}</div>
                  </div>
                </div>
              </div>

              {terminoptionen.length>0&&(
                <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:12,padding:16,marginBottom:16}}>
                  <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:12}}>
                    <div style={{fontSize:12,fontWeight:700,color:T.text}}>Stimmenauswertung</div>
                    {/* Terminvorschlaege hier loeschen koennen, ohne den Reiter
                        "Interesse" extra wieder einschalten zu muessen. */}
                    <button
                      onClick={()=>{
                        if(!window.confirm("Alle Terminvorschläge löschen?\n\nDie Stimmenauswertung verschwindet damit. Die Interessenten selbst bleiben erhalten."))return;
                        setConfig(c=>({...c,shootingTypes:(c.shootingTypes||[]).map(x=>
                          x.id===activeST.id?{...x,terminoptionen:[]}:x)}));
                      }}
                      style={{background:"none",border:`1px solid ${T.border}`,borderRadius:7,
                              padding:"4px 10px",cursor:"pointer",color:T.muted,fontSize:11,
                              fontFamily:"inherit"}}>
                      Terminvorschläge löschen
                    </button>
                  </div>
                  {terminoptionen.map((opt,i)=>{
                    const d=opt.datum;
                    const monate=["Januar","Februar","März","April","Mai","Juni","Juli","August","September","Oktober","November","Dezember"];
                    const label=d&&/^\d{4}-\d{2}-\d{2}$/.test(d)?(()=>{const p=d.split("-");return p[2]+". "+monate[parseInt(p[1])-1]+" "+p[0];})():d;
                    const n=stimmen[d]||0;
                    const erreicht=opt.min&&n>=parseInt(opt.min);
                    return(
                    <div key={i} style={{marginBottom:24}}>
                      <div style={{display:"flex",justifyContent:"space-between",fontSize:14,color:T.text,marginBottom:8}}>
                        <span style={{fontWeight:600}}>{label}</span>
                        <div style={{display:"flex",gap:10,alignItems:"center"}}>
                          {opt.min&&<span style={{fontSize:12,color:erreicht?"#27ae60":"#e53",fontWeight:700}}>{n}/{opt.min} Min.</span>}
                          <span style={{fontWeight:700,color:T.accent,fontSize:14}}>{n} Stimme{n!==1?"n":""}</span>
                        </div>
                      </div>
                      <div style={{height:18,background:T.border,borderRadius:6,overflow:"hidden"}}> 
                        <div style={{height:"100%",width:opt.min?Math.min((n/parseInt(opt.min))*100,100)+"%":(n>0?"100%":"0%"),background:erreicht?"#27ae60":"#f59e0b",borderRadius:6,transition:"width 0.3s"}}/>
                      </div>
                      {opt.min&&<div style={{fontSize:10,color:T.muted,marginTop:3,textAlign:"right"}}>{Math.round((n/parseInt(opt.min))*100)}%</div>}
                    </div>
                    );
                  })}
                </div>
              )}

              {liste.length===0&&<p style={{color:T.muted,fontSize:13}}>Noch keine Interessenten für dieses Shooting.</p>}
              <div style={{display:"flex",flexDirection:"column",gap:8}}>
                {liste.map(int=>(
                  <div key={int.id} style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:12,padding:"14px 16px",display:"flex",alignItems:"center",gap:16}}>
                    <div style={{width:36,height:36,borderRadius:"50%",background:T.accentDim,display:"flex",alignItems:"center",justifyContent:"center",fontSize:13,fontWeight:600,color:T.accent,flexShrink:0}}>
                      {(int.name||"?")[0].toUpperCase()}
                    </div>
                    <div style={{flex:1,minWidth:0}}>
                      <div style={{fontSize:14,fontWeight:600,color:T.text}}>{int.name}</div>
                      <div style={{fontSize:12,color:T.muted,marginTop:2}}>{[int.email,int.telefon].filter(Boolean).join(" · ")}</div>
                      <div style={{display:"flex",alignItems:"center",gap:6,marginTop:3}}>
                        <span style={{fontSize:11,color:"#f59e0b"}}>📅</span>
                        <select value={int.terminwahl||""} onChange={e=>terminAendern(int,e.target.value)}
                          title="Interessent auf einen anderen Termin umtragen"
                          style={{fontSize:11,fontWeight:600,color:"#f59e0b",background:"#f59e0b14",
                            border:"1px solid #f59e0b44",borderRadius:6,padding:"2px 6px",
                            fontFamily:"inherit",cursor:"pointer",outline:"none"}}>
                          <option value="">— kein Termin —</option>
                          {/* gespeicherten Termin mit anzeigen, auch wenn er nicht mehr angeboten wird */}
                          {(int.terminwahl&&!(activeST?.terminoptionen||[]).some(o=>(typeof o==="object"?o.datum:o)===int.terminwahl))
                            && <option value={int.terminwahl}>{int.terminwahl} (nicht mehr im Angebot)</option>}
                          {(activeST?.terminoptionen||[]).map(o=>{
                            const d=typeof o==="object"?o.datum:o;
                            return <option key={d} value={d}>{d}</option>;
                          })}
                        </select>
                      </div>
                      {int.tiere&&int.tiere.length>0&&<div style={{fontSize:11,color:T.muted,marginTop:2}}>{int.tiere.map(t=>[t.tiername,t.rasse].filter(Boolean).join(" · ")).join(" | ")}</div>}
                      {int.wuensche&&<div style={{fontSize:11,color:T.muted,marginTop:3,fontStyle:"italic"}}>"{int.wuensche}"</div>}
                    </div>
                    <div style={{fontSize:11,color:T.muted,flexShrink:0,marginRight:8}}>{int.datum?new Date(int.datum).toLocaleDateString("de-DE"):""}</div>
                    <button onClick={()=>zuBuchung(int)} style={{padding:"6px 14px",borderRadius:8,border:`1px solid #27ae60`,background:"#27ae6018",color:"#27ae60",fontSize:12,fontWeight:600,cursor:"pointer",whiteSpace:"nowrap"}}>Zu Buchung</button>
                    <button onClick={()=>loeschen(int)} style={{padding:"6px 10px",borderRadius:8,border:`1px solid ${T.border}`,background:"none",color:T.muted,fontSize:12,cursor:"pointer"}} onMouseEnter={e=>{e.currentTarget.style.borderColor="#e53";e.currentTarget.style.color="#e53";}} onMouseLeave={e=>{e.currentTarget.style.borderColor=T.border;e.currentTarget.style.color=T.muted;}}>✕</button>
                  </div>
                ))}
              </div>
              {liste.length>0&&(
                <div style={{marginTop:16,padding:"12px 16px",background:"#f59e0b18",border:"1px solid #f59e0b44",borderRadius:8,fontSize:12,color:"#b45309"}}>
                  "Zu Buchung" schickt dem Interessenten eine Mail mit dem Link zur Landingpage der Veranstaltung.
                </div>
              )}
            </div>
          );
        })()}
        {/* Admin: Formular-Builder */}
        {view==="admin"&&selEventId===null&&(
          <div>
            <div style={{display:"flex",justifyContent:"flex-end",marginBottom:12}}>
              <SortBtn dir={evSortDir} toggle={evSortToggle} T={T}/>
            </div>
            <BuchungssystemKacheln events={events} sortEvents={sortEvents} config={config} oeffneEventFormular={oeffneEventFormular} btn={btn} T={T} fmtDateRange={fmtDateRange}/>
          </div>
        )}
        {view==="admin"&&selEventId!==null&&(
          <div>
            <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:14}}>
              <button style={btn(T,"ghost",true)} onClick={()=>setSelEventId(null)}>← Übersicht</button>
              {activeST?.eventId&&(
                <button style={btn(T,"ghost",true)}
                  title="Veranstaltungsplan dieser Veranstaltung öffnen"
                  onClick={()=>onOpenShootingplan&&onOpenShootingplan({eventId:activeST.eventId})}>
                  📅 Zum Veranstaltungsplan
                </button>
              )}
            </div>
            {activeST&&(
              <div style={{fontSize:12,color:T.muted,marginBottom:14,background:T.surface,border:`1px solid ${T.border}`,borderRadius:8,padding:"9px 12px"}}>
                {activeST.preis>0
                  ? `Shootinggebühr: ${Number(activeST.preis).toFixed(2)} €`
                    +(Number(activeST.preisWeitererHund)>0?` · je weiterer Hund: ${Number(activeST.preisWeitererHund).toFixed(2)} €`:"")
                    +`. Die Preise kommen aus der Veranstaltung und werden hier nicht eingestellt.`
                  : "Keine Shootinggebühr hinterlegt. Der Preis kommt aus der Veranstaltung."}
              </div>
            )}
            <div style={{display:"grid",gridTemplateColumns:"200px 1fr",gap:20,alignItems:"start"}}>
              {/* Shooting-Typ Auswahl */}
              <div>
                <div style={{fontSize:11,color:T.muted,fontWeight:700,textTransform:"uppercase",letterSpacing:"0.1em",marginBottom:10}}>Aktive Veranstaltung</div>
                {config.shootingTypes.filter(s=>s.eventId).map(st=>(
                  <div key={st.id} style={{marginBottom:4,display:activeSTId===st.id?"block":"none"}}>
                    <><STNameEditor st={st} T={T} setConfig={setConfig} setEvents={setEvents}/>
                      {activeSTId===st.id&&(
                        <div style={{display:"flex",flexDirection:"column",gap:6,marginTop:6}}>
                          <button style={{...btn(T,"ghost",true),width:"100%",justifyContent:"center",fontSize:11}} onClick={()=>{
                            const ev=events.find(e=>e.id===st.eventId)||{};
                            generateLandingPageFromEvent({
                              id:ev.id||"",name:ev.name||st.name,fotoart:ev.shootingart||ev.fotoart||st.name,
                              date:ev.date||"",dateBis:ev.dateBis||"",location:ev.location||"",
                              info:ev.info||st.beschreibung?.de||"",event_info:st.event_info||"",
                              kopfbereich:st.kopfbereich||"",kopfbereich_en:st.kopfbereich_en||"",
                              event_info_en:st.event_info_en||"",
                              adresse:ev.adresse||{},kontakt:ev.kontakt||{},buchungsUrl:st.buchungsUrl,
                              hp_beschreibung:st.hp_beschreibung||"",slug:st.buchungsUrl||"",
                            });
                          }}>
                            <svg width="12" height="12" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"><circle cx="8" cy="8" r="6"/><line x1="2" y1="8" x2="14" y2="8"/><path d="M8 2c-2 2-2.5 4-2.5 6s.5 4 2.5 6"/><path d="M8 2c2 2 2.5 4 2.5 6s-.5 4-2.5 6"/></svg>
                            Landingpage Vorschau
                          </button>
                          <div style={{marginTop:8}}/>
                          <button style={{...btn(T,"ghost",true),width:"100%",justifyContent:"center",fontSize:11,marginBottom:4}} onClick={()=>{
                            const serverUrl=(localStorage.getItem("sd_server_url")||"").trim().replace(/\/+$/,"");
                            const slug=st.buchungsUrl||"";
                            if(!serverUrl||!slug){alert("Bitte Server-URL in den Einstellungen eintragen.");return;}
                            const url=`${serverUrl}/landing/${slug}`;
                            try{navigator.clipboard.writeText(url).then(()=>alert(`Link kopiert: ${url}`));}
                            catch{alert(`Link: ${url}`);}
                          }}>
                            🔗 Link kopieren
                          </button>
                          <button style={{...btn(T,"ghost",true),width:"100%",justifyContent:"center",fontSize:11,marginTop:8}} onClick={()=>{
                            const ev2=events.find(e=>e.id===st.eventId)||{};
                            if(!ev2.name){alert("Keine Veranstaltung gefunden.");return;}
                            const apiSettings=JSON.parse(localStorage.getItem("sd_api_settings")||"{}");
                            const unterordner=Array.isArray(apiSettings.subFolders)?apiSettings.subFolders:["Shootingvereinbarungen","Rechnungen","Bilder"];
                            const basis=apiSettings.basePath||"E:\\Fotografie\\Scatto\\Veranstaltungen";
                            fetch("https://localhost/api/ordner",{method:"POST",headers:{"Content-Type":"application/json"},
                              body:JSON.stringify({name:ev2.name,datum:ev2.date,unterordner,basis})
                            }).then(r=>r.json()).then(d=>{
                              if(d.ok)alert("✓ Ordner angelegt: "+d.pfad);
                              else alert("Fehler: "+(d.fehler||JSON.stringify(d)));
                            }).catch(e=>alert("Fehler: "+e.message+"\nLäuft lokaler server.py?"));
                          }}>
                            📁 Ordner anlegen
                          </button>
                        </div>
                      )}
                    </>
                  </div>
                ))}
                <div style={{marginTop:16,paddingTop:16,borderTop:`1px solid ${T.border}`}}>
                  <div style={{fontSize:11,color:T.muted,fontWeight:700,textTransform:"uppercase",letterSpacing:"0.1em",marginBottom:8}}>Allgemein</div>
                  <div style={{display:"flex",flexDirection:"column",gap:8}}>
                    <div>
                      <label style={{fontSize:11,color:T.muted,display:"block",marginBottom:3}}>Studio-Name</label>
                      <input value={config.studioName||""} onChange={e=>setConfig(c=>({...c,studioName:e.target.value}))} style={{...IS(T),padding:"6px 10px",fontSize:12}}/>
                    </div>
                    <div style={{marginTop:12,paddingTop:12,borderTop:`1px solid ${T.border}`}}>
                      <div style={{fontSize:11,color:T.muted,fontWeight:700,textTransform:"uppercase",letterSpacing:"0.07em",marginBottom:8}}>Zahlungsarten</div>
                      {[["paypal","💳 PayPal"],["ueberweisung","🏦 Überweisung"],["bar","💵 Barzahlung"]].map(([k,l])=>(
                        <div key={k} style={{marginBottom:10}}>
                          <label style={{display:"flex",alignItems:"center",gap:6,cursor:"pointer",fontSize:12,color:T.text,marginBottom:4}}>
                            <input type="checkbox" checked={config.zahlung?.[k]?.aktiv||false}
                              onChange={e=>setConfig(c=>({...c,zahlung:{...c.zahlung,[k]:{...(c.zahlung?.[k]||{}),aktiv:e.target.checked}}}))}
                              style={{accentColor:T.accent}}/>
                            {l}
                          </label>
                          {k==="paypal"&&config.zahlung?.paypal?.aktiv&&(
                            <input value={config.zahlung?.paypal?.link||""} placeholder="https://paypal.me/deinname"
                              onChange={e=>setConfig(c=>({...c,zahlung:{...c.zahlung,paypal:{...c.zahlung?.paypal,link:e.target.value}}}))}
                              style={{...IS(T),padding:"5px 8px",fontSize:11}}/>
                          )}
                          {k==="ueberweisung"&&config.zahlung?.ueberweisung?.aktiv&&(
                            <div style={{display:"flex",flexDirection:"column",gap:4}}>
                              <input value={config.zahlung?.ueberweisung?.inhaber||""} placeholder="Kontoinhaber"
                                onChange={e=>setConfig(c=>({...c,zahlung:{...c.zahlung,ueberweisung:{...c.zahlung?.ueberweisung,inhaber:e.target.value}}}))}
                                style={{...IS(T),padding:"5px 8px",fontSize:11}}/>
                              <input value={config.zahlung?.ueberweisung?.iban||""} placeholder="IBAN"
                                onChange={e=>setConfig(c=>({...c,zahlung:{...c.zahlung,ueberweisung:{...c.zahlung?.ueberweisung,iban:e.target.value}}}))}
                                style={{...IS(T),padding:"5px 8px",fontSize:11,fontFamily:"monospace"}}/>
                              <input value={config.zahlung?.ueberweisung?.bic||""} placeholder="BIC"
                                onChange={e=>setConfig(c=>({...c,zahlung:{...c.zahlung,ueberweisung:{...c.zahlung?.ueberweisung,bic:e.target.value}}}))}
                                style={{...IS(T),padding:"5px 8px",fontSize:11,fontFamily:"monospace"}}/>
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                    <div>
                      <label style={{fontSize:11,color:T.muted,display:"block",marginBottom:3}}>Logo (PNG/JPG)</label>
                      <div style={{display:"flex",gap:8,alignItems:"center"}}>
                        {config.logo&&<img src={config.logo} alt="Logo" style={{height:32,borderRadius:4,border:`1px solid ${T.border}`}}/>}
                        <label style={{...btn(T,"ghost",true),cursor:"pointer"}}>
                          📁 Auswählen
                          <input type="file" accept="image/png,image/jpeg,image/svg+xml" style={{display:"none"}} onChange={e=>{
                            const file=e.target.files[0];if(!file)return;
                            const reader=new FileReader();
                            reader.onload=ev=>{
                              // Logo auf max 200KB komprimieren
                              const img=new Image();
                              img.onload=()=>{
                                const canvas=document.createElement("canvas");
                                const MAX=600;
                                let w=img.width,h=img.height;
                                if(w>MAX||h>MAX){const r=Math.min(MAX/w,MAX/h);w=Math.round(w*r);h=Math.round(h*r);}
                                canvas.width=w;canvas.height=h;
                                canvas.getContext("2d").drawImage(img,0,0,w,h);
                                const compressed=canvas.toDataURL("image/png",0.85);
                                setConfig(c=>({...c,logo:compressed}));
                              };
                              img.src=ev.target.result;
                            };
                            reader.readAsDataURL(file);
                          }}/>
                        </label>
                        {config.logo&&<button style={btn(T,"danger",true)} onClick={()=>setConfig(c=>({...c,logo:""}))}>✕</button>}
                      </div>
                    </div>
                    <div>
                      <label style={{fontSize:11,color:T.muted,display:"block",marginBottom:3}}>Akzentfarbe</label>
                      <input type="color" value={config.primaryColor||"#C9A96E"} onChange={e=>setConfig(c=>({...c,primaryColor:e.target.value}))} style={{width:"100%",height:36,borderRadius:6,border:`1px solid ${T.border}`,cursor:"pointer"}}/>
                    </div>
                  </div>
                </div>
              </div>
              {/* Formular-Builder für aktiven Shooting-Typ */}
              {activeST&&<FormularBuilder shootingType={activeST} onChange={updateST} T={T} config={config} setConfig={setConfig} interessenten={interessenten} onShowInteressenten={()=>setView("interessenten")}
      onEventDatum={(von,bis)=>{
        const evId=activeST&&activeST.eventId;
        if(!evId||!setEvents)return;
        const ev=(events||[]).find(e=>e.id===evId);
        if(!ev)return;
        if(ev.date&&ev.date!==von&&!window.confirm(
          "Die Veranstaltung hat bereits das Datum "+new Date(ev.date).toLocaleDateString("de-DE")+
          ".\n\nSoll es auf "+new Date(von).toLocaleDateString("de-DE")+(bis?" bis "+new Date(bis).toLocaleDateString("de-DE"):"")+
          " geaendert werden?\n\nVeranstaltungsplan, Kalender und Abrechnung uebernehmen das Datum."))return;
        setEvents(prev=>prev.map(e=>e.id===evId?{...e,date:von,dateBis:bis||"",interessenliste_event:false}:e));
      }} isStandard={config.standardFormularId===activeST.id} onSetStandard={(val)=>setConfig(c=>({...c,standardFormularId:val?activeST.id:null}))}/>}
            </div>
          </div>
        )}

        {/* Mustervorlage */}
        {view==="mustervorlage"&&<MustervorlageView T={T}/>}

        {/* Buchungen */}
        {view==="buchungen"&&(
          <BuchungenView key={activeSTId} buchungen={buchungen} setBuchungen={setBuchungen} config={config} T={T} onExportToShootingplan={exportToShootingplan} onStorno={stornoBooking} onDeepDelete={entferneAusPlanUndAbrechnung} activeSTName={activeST?.name}/>
        )}

        {/* Vorlage-Auswahl Dialog */}
        {vorlagenDialog&&(()=>{
          const alle=(()=>{try{return JSON.parse(localStorage.getItem("sd_mustervorlagen")||"[]")||[];}catch{return [];}})();
          return(
            <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.55)",zIndex:1000,display:"flex",alignItems:"center",justifyContent:"center"}}>
              <div style={{background:"var(--surface,#1e1e1e)",border:"1px solid #333",borderRadius:16,padding:28,minWidth:360,maxWidth:480,width:"90%",boxShadow:"0 8px 40px rgba(0,0,0,0.5)"}}>
                <div style={{fontFamily:"Georgia,serif",fontSize:18,marginBottom:6}}>Vorlage auswählen</div>
                <div style={{fontSize:13,color:"#888",marginBottom:20}}>
                  Für: <strong>{vorlagenDialog.ev?.name}</strong>
                </div>
                <div style={{display:"flex",flexDirection:"column",gap:8,marginBottom:20}}>
                  {alle.map(v=>(
                    <button key={v.id}
                      onClick={()=>applyVorlage(vorlagenDialog.ev, v.id)}
                      style={{padding:"12px 16px",borderRadius:10,border:"1px solid #444",background:"transparent",color:"inherit",cursor:"pointer",textAlign:"left",fontSize:14,fontWeight:500,transition:"all 0.15s"}}
                      onMouseEnter={e=>{e.currentTarget.style.borderColor="#C9A96E";e.currentTarget.style.color="#C9A96E";}}
                      onMouseLeave={e=>{e.currentTarget.style.borderColor="#444";e.currentTarget.style.color="inherit";}}>
                      📋 {v.name}
                    </button>
                  ))}
                  <button
                    onClick={()=>applyVorlage(vorlagenDialog.ev, null)}
                    style={{padding:"12px 16px",borderRadius:10,border:"1px dashed #555",background:"transparent",color:"#888",cursor:"pointer",textAlign:"left",fontSize:13,marginTop:4}}>
                    Ohne Vorlage fortfahren
                  </button>
                </div>
                <button onClick={()=>setVorlagenDialog(null)}
                  style={{fontSize:12,color:"#666",background:"transparent",border:"none",cursor:"pointer"}}>
                  Abbrechen
                </button>
              </div>
            </div>
          );
        })()}

        {/* Vorschau */}
        {view==="preview"&&(
          <div>
            <div style={{display:"flex",gap:8,marginBottom:12,alignItems:"center",flexWrap:"wrap"}}>
              <span style={{fontSize:12,color:T.muted}}>Vorschau für:</span>
              {config.shootingTypes.filter(s=>s.aktiv&&s.eventId).map(st=>(
                <button key={st.id} style={btn(T,previewSTId===st.id?"active":"ghost",true)} onClick={()=>setPreviewSTId(st.id)}>{st.name}</button>
              ))}
              <span style={{fontSize:11,color:T.muted,marginLeft:8}}>👆 Echte Buchungen landen direkt in "Buchungen"</span>
            </div>
            <div style={{display:"flex",gap:8,marginBottom:20,alignItems:"center",flexWrap:"wrap"}}>
              <span style={{fontSize:12,color:T.muted}}>Buchungsweg:</span>
              <button style={btn(T,!previewVorort?"active":"ghost",true)} onClick={()=>setPreviewVorort(false)}>Vorab (mit Zeitauswahl)</button>
              <button style={btn(T,previewVorort?"active":"ghost",true)} onClick={()=>setPreviewVorort(true)}>Vor Ort (ohne Zeit)</button>
            </div>
            <div style={{border:`2px solid ${T.border}`,borderRadius:16,overflow:"hidden"}}>
              {previewST&&<PublicBookingPage key={previewVorort?"vorort":"vorab"} config={config} shootingType={previewST} forceVorort={previewVorort} onBooked={handleBooked}/>}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

// ── Haupt App ─────────────────────────────────────────────────────────────────




// ── Gutscheine ────────────────────────────────────────────────────────────────


// ── VertragEinstellungen ───────────────────────────────────────────────────────
function VertragEinstellungen({T}){
  const DEF_PARAS=[
    {titel:"§1 Vertragsgegenstand",text:"Der Auftraggeber beauftragt den Fotografen mit der Durchführung eines Tier-Fotoshootings."},
    {titel:"§2 Vergütung und Zahlungsbedingungen",text:"• Der Fotograf stellt eine Rechnung mit Ausweis der Umsatzsteuer\n• Der Rechnungsbetrag ist nach Rechnungserhalt ohne Abzug per Überweisung zu zahlen.\n• Jedes zusätzliche Bild über das vereinbarte Kontingent hinaus wird mit 39,00 € pro Bild berechnet.\n• Fahrten bis zu 15 km sind inklusive, darüber hinaus erfolgt die Abrechnung über einen Reisekostenrechner.\n• Nachbestellungen weiterer Bilder sind jederzeit zu den jeweils gültigen Konditionen möglich."},
    {titel:"§3 Leistungsumfang",text:"Das vereinbarte Fotoshooting umfasst:\nErstellung professioneller Tierfotografien\nAuswahl und Bearbeitung der Bilder durch den Fotografen\nBereitstellung der finalen Bilder als digitale Dateien\nHochauflösende Dateien ohne Logo für private Druckzwecke\nWeboptimierte Dateien mit Logo\nBereitstellung über eine passwortgeschützte Online-Galerie (Cloud)"},
    {titel:"§4 Durchführung des Shootings",text:"• Der Fotograf verpflichtet sich, zum vereinbarten Termin am festgelegten Ort zu erscheinen und das Shooting professionell durchzuführen.\n• Der Auftraggeber verpflichtet sich, die Tiere in einem geeigneten Zustand (gesund, gepflegt, betreuungsfähig) bereitzustellen und während des Shootings angemessen zu begleiten."},
    {titel:"§5 Bildbearbeitung und Urheberrecht",text:"• Die Auswahl der finalen Bilder für die Kundenauswahl sowie Art und Stil der Bildbearbeitung obliegen dem Fotografen.\n• Der Fotograf ist berechtigt, Farb-, Kontrast- und Belichtungskorrekturen sowie Retuschen vorzunehmen.\n• Rohdateien (unbearbeitete Bilder) verbleiben ausschließlich beim Fotografen; ein Anspruch auf Herausgabe besteht nicht.\n\nDas Urheberrecht an sämtlichen Bildern verbleibt uneingeschränkt beim Fotografen.\nEine Veränderung oder Bearbeitung der Bilder durch den Auftraggeber oder Dritte – insbesondere durch Filter, Effekte oder Verfremdungen – ist nicht gestattet."},
    {titel:"§6 Nutzungsrechte Fotograf",text:"Der Auftraggeber räumt dem Fotografen das zeitlich, räumlich und inhaltlich uneingeschränkte Nutzungsrecht an den entstandenen Bildern ein.\n\n• Eigenwerbung\n• Portfolio (online und print)\n• Social Media\n• Website\n• Präsentationsmappen, Fotobücher und Agenturen"},
    {titel:"§7 Nutzungsrechte Auftraggeber",text:"Der Auftraggeber erhält ein einfaches, nicht übertragbares Nutzungsrecht für private und nichtkommerzielle Zwecke.\n\nErlaubt ist insbesondere:\n• Private Ausdrucke\n• Veröffentlichung in sozialen Netzwerken und auf privaten Webseiten\n\nDabei gilt:\n• Für Online-Veröffentlichungen ist ausschließlich die weboptimierte Datei mit Logo zu verwenden.\n• Der Fotograf ist immer als Urheber zu benennen.\n\nEine kommerzielle Nutzung bedarf einer gesonderten schriftlichen Vereinbarung."},
    {titel:"§8 Bildauswahl und Lieferung",text:"• Die Vorauswahl der Bilder wird innerhalb von 2-3 Werktagen nach dem Shooting in einer Online-Galerie bereitgestellt.\n• Der Auswahl-Link ist 14 Werktage gültig.\n• Die Lieferung erfolgt per Cloud-Download\n• optional zusätzlich auf USB-Stick per Postversand"},
    {titel:"§9 Lieferzeit",text:"Die endgültige Lieferung der Bilder erfolgt spätestens 4-6 Wochen nach Bildauswahl und vollständigem Zahlungseingang."},
    {titel:"§10 Reklamation und Haftung",text:"Der Fotograf gestaltet die Bilder nach eigenem künstlerischem Ermessen. Reklamationen hinsichtlich Bildstil, Farbgebung oder Gestaltung sind ausgeschlossen.\n\nDem Auftraggeber sind Stil und Qualität der bisherigen Arbeiten des Fotografen bekannt."},
    {titel:"§11 Schlussbestimmungen",text:"Änderungen oder Ergänzungen dieses Vertrages bedürfen der Schriftform.\n\nSollten einzelne Bestimmungen dieses Vertrages ganz oder teilweise unwirksam sein, bleibt die Wirksamkeit der übrigen Regelungen unberührt.\n\nEs gilt das Recht der Bundesrepublik Deutschland."},
  ];

  const [vs,setVs]=useState(()=>JSON.parse(localStorage.getItem("sd_vertrag_settings")||"{}"));
  const [paras,setParas]=useState(()=>JSON.parse(localStorage.getItem("sd_vertrag_paragraphen")||"null")||DEF_PARAS);
  const [seite,setSeite]=useState(1);
  // In der Vorschau stehen nur Beispielwerte. Das Eurozeichen kommt aus
  // derselben Hilfsfunktion wie im echten Vertrag.
  const eurZ=v=>{const t=String(v??"").trim();return (t===""||!isNaN(parseFloat(t)))?" \u20ac":"";};
  const fahrtkosten="";
  const timerRef=useRef(null);
  const [pages,setPages]=useState(["","","","",""]);

  const ISv={padding:"7px 10px",border:`1px solid ${T.border}`,borderRadius:7,fontSize:13,background:T.bg,color:T.text,width:"100%",boxSizing:"border-box",fontFamily:"inherit"};
  const studioLogo=(JSON.parse(localStorage.getItem("sd_api_settings")||"{}").studio_logo)||(JSON.parse(localStorage.getItem("sd_buchung_config")||"{}").logo)||"";

  const css=`<!DOCTYPE html><html><head><meta charset="UTF-8"><style>
    *{box-sizing:border-box;margin:0;padding:0}
    body{font-family:"Helvetica Neue",Helvetica,Arial,sans-serif;color:#222;font-size:12pt;line-height:1.7;padding:20mm 18mm;background:#fff}
    h2{color:#1a4a6e;font-size:14pt;font-weight:600;margin:28px 0 12px}
    p{margin:0 0 10px}ul{margin:8px 0 14px;padding-left:20px}li{margin-bottom:7px}
  </style></head><body>`;

  const logoHtml=studioLogo
    ?`<img src="${studioLogo}" style="max-height:75px;max-width:190px;object-fit:contain" alt="Logo"/>`
    :`<div style="font-size:9pt;font-weight:700;color:#1a4a6e;text-align:right">${vs.name||"Markus Heber Photography"}<br/><span style="font-weight:300">PHOTOGRAPHY</span></div>`;

  const buildPages=(vsCur,parasCur)=>{
    const v=vsCur||vs;
    const p=parasCur||paras;
    const logo=studioLogo?`<img src="${studioLogo}" style="max-height:75px;max-width:190px;object-fit:contain" alt="Logo"/>`:`<div style="font-size:9pt;font-weight:700;color:#1a4a6e;text-align:right">${v.name||"Markus Heber Photography"}<br/><span style="font-weight:300">PHOTOGRAPHY</span></div>`;

    const base=`<!DOCTYPE html><html><head><meta charset="UTF-8"><style>*{box-sizing:border-box;margin:0;padding:0}body{font-family:"Helvetica Neue",Helvetica,Arial,sans-serif;color:#222;font-size:12pt;line-height:1.7;padding:20mm 18mm;background:#fff}h2{color:#1a4a6e;font-size:14pt;font-weight:600;margin:28px 0 12px}p{margin:0 0 10px}ul{margin:8px 0 14px;padding-left:20px}li{margin-bottom:7px}</style></head><body>`;

    const p1=base+`
      <div style="display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:20px">
        <div style="color:#1a4a6e;font-size:21pt;font-weight:300">Fotografievertrag – Tierfotografie</div>
        <div>${logo}</div>
      </div>
      <p style="color:#666;margin-bottom:12px">zwischen</p>
      <div style="margin-bottom:14px;line-height:1.8"><b>${v.name||"Markus Heber Photography"}</b><br/>${v.strasse||"Moltkestraße 22"}${v.plz||v.stadt?", "+(v.plz||"")+" "+(v.stadt||""):""}<br/>${v.tel?"Telefon: "+v.tel+"<br/>":""}${v.email||""}</div>
      <p style="color:#666;margin-bottom:10px">– nachfolgend <b>„Fotograf"</b> genannt -</p>
      <p style="margin-bottom:10px">und</p>
      <p style="margin-bottom:20px"><b>Vertragspartner (Tierhalter)</b></p>
      <table style="border-collapse:collapse;width:100%;margin-bottom:10px;font-size:12pt">
        <tr><td style="padding:9px 0;width:80px">Name:</td><td style="padding:9px 0"><span style="display:inline-block;min-width:420px;border-bottom:1px solid #333;padding:0 4px">Max Mustermann</span></td></tr>
        <tr><td style="padding:9px 0">Adresse:</td><td style="padding:9px 0"><span style="display:inline-block;min-width:420px;border-bottom:1px solid #333;padding:0 4px">Musterstraße 1</span></td></tr>
        <tr><td style="padding:9px 0">PLZ/ Ort:</td><td style="padding:9px 0"><span style="display:inline-block;min-width:100px;border-bottom:1px solid #333;margin-right:20px;padding:0 4px">12345</span><span style="display:inline-block;min-width:220px;border-bottom:1px solid #333;padding:0 4px">Musterstadt</span></td></tr>
        <tr><td style="padding:9px 0">Telefon:</td><td style="padding:9px 0"><span style="display:inline-block;min-width:220px;border-bottom:1px solid #333;padding:0 4px">0171 1234567</span></td></tr>
        <tr><td style="padding:9px 0">E-Mail:</td><td style="padding:9px 0"><span style="display:inline-block;min-width:220px;border-bottom:1px solid #333;padding:0 4px">max@beispiel.de</span></td></tr>
      </table>
      <div style="height:32px"></div>
      <div style="margin-bottom:20px;font-size:12pt;white-space:nowrap">
        Rasse: <span style="display:inline-block;min-width:192px;border-bottom:1px solid #333;vertical-align:bottom;text-align:center;padding:0 3px">Labrador</span>&nbsp;
        Name: <span style="display:inline-block;min-width:110px;border-bottom:1px solid #333;vertical-align:bottom;text-align:center;padding:0 3px">Bello</span>&nbsp;
        Alter: <span style="display:inline-block;min-width:50px;border-bottom:1px solid #333;vertical-align:bottom;text-align:center;padding:0 3px">3 J</span>&nbsp;
        Geschlecht: <span style="display:inline-block;min-width:60px;border-bottom:1px solid #333;vertical-align:bottom;text-align:center;padding:0 3px">Rüde</span>
      </div>
      <div style="height:36px"></div>
      <p style="color:#666">– nachfolgend <b>„Auftraggeber"</b> genannt –</p>
    </body></html>`;

    const p2=base+`
      <h2>${p[0].titel}</h2>
      <p>${p[0].text}</p>
      <div style="line-height:2.4;margin-bottom:16px">
        <div><b>Datum:</b> <span style="display:inline-block;min-width:120px;border-bottom:1px solid #333;vertical-align:bottom;padding:0 3px">5.7.2026</span></div>
        <div><b>Uhrzeit:</b> <span style="display:inline-block;min-width:90px;border-bottom:1px solid #333;vertical-align:bottom;padding:0 3px">10:00</span></div>
        <div><b>Ort:</b> &nbsp;&nbsp;&nbsp;&nbsp;<span style="display:inline-block;min-width:360px;border-bottom:1px solid #333;vertical-align:bottom;padding:0 3px"></span></div>
      </div>
      <div style="padding-left:80px;margin-bottom:16px;line-height:2.4">
        <div>Anzahl der enthaltenen Bilder: <span style="display:inline-block;min-width:80px;max-width:100px;border-bottom:1px solid #333;vertical-align:bottom;text-align:center;padding:0 3px">3</span> pro Tier</div>
        <div>Einzelpreis pro Tier: <span style="display:inline-block;min-width:100px;border-bottom:1px solid #333;vertical-align:bottom;text-align:center;padding:0 3px">160</span> € &nbsp;&nbsp;&nbsp;&nbsp; Zusatztier: <span style="display:inline-block;min-width:70px;border-bottom:1px solid #333;vertical-align:bottom;text-align:center;padding:0 3px"></span> €</div>
      </div>
      <p>Bei Anfahrt über 15 km wird die An/ Abfahrt per Reisekostenrechner ermittelt:</p>
      <div style="padding-left:80px;margin-bottom:20px;line-height:2.4">
        <div>KM gesamt: <span style="display:inline-block;min-width:80px;border-bottom:1px solid #333;vertical-align:bottom;text-align:center;padding:0 3px"></span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Fahrtkosten: <span style="display:inline-block;min-width:80px;border-bottom:1px solid #333;vertical-align:bottom;text-align:center;padding:0 3px"></span>${eurZ(fahrtkosten)}</div>
      </div>
      <p><b>Die Gesamtvergütung für das vereinbarte Fotoshooting beträgt:</b></p>
      <div style="font-size:18pt;font-weight:700;margin-bottom:20px;text-align:center">Gesamtpreis: <span style="display:inline-block;min-width:120px;border-bottom:2px solid #333;vertical-align:bottom;padding:0 6px">277,00</span>${eurZ(fahrtkosten)}</div>
      <p style="margin-bottom:30px">Art und Umfang der Aufnahmen richten sich nach den individuell vereinbarten Leistungen dieses Vertrages</p>
      <h2>${p[1].titel}</h2>
      <div style="white-space:pre-line">${p[1].text}</div>
    </body></html>`;

    const p3=base+`
      <h2>${p[2].titel}</h2>
      <div style="white-space:pre-line;margin-bottom:10px">${p[2].text}</div>
      <p style="margin-bottom:6px">Zusatzleistungen / besondere Vereinbarungen:</p>
      <div style="border-bottom:1px solid #555;min-height:26px;margin-bottom:12px"></div>
      <div style="border-bottom:1px solid #555;min-height:26px;margin-bottom:36px"></div>
      <h2>${p[3].titel}</h2>
      <div style="white-space:pre-line;margin-bottom:30px">${p[3].text}</div>
      <h2>${p[4].titel}</h2>
      <div style="white-space:pre-line">${p[4].text}</div>
    </body></html>`;

    const p4=base+`
      <h2>${p[5].titel}</h2>
      <div style="white-space:pre-line;margin-bottom:30px">${p[5].text}</div>
      <h2>${p[6].titel}</h2>
      <div style="white-space:pre-line;margin-bottom:30px">${p[6].text}</div>
      <h2>${p[7].titel}</h2>
      <div style="white-space:pre-line">${p[7].text}</div>
    </body></html>`;

    const p5=base+`
      <h2>${p[8].titel}</h2>
      <div style="white-space:pre-line;margin-bottom:30px">${p[8].text}</div>
      <h2>${p[9].titel}</h2>
      <div style="white-space:pre-line;margin-bottom:30px">${p[9].text}</div>
      <h2>${p[10].titel}</h2>
      <div style="white-space:pre-line;margin-bottom:60px">${p[10].text}</div>
      <p style="margin-bottom:100px"><b>Ort, Datum:</b> <span style="display:inline-block;min-width:240px;border-bottom:1px solid #333;vertical-align:bottom;padding:0 3px"></span></p>
      <div style="border-top:1px solid #333;margin-bottom:12px"></div>
      <div style="display:flex;justify-content:space-between;font-size:12pt">
        <span>Auftraggeber (Unterschrift)</span>
        <span>Fotograf (Unterschrift)</span>
      </div>
    </body></html>`;

    setPages([p1,p2,p3,p4,p5]);
  };

  useEffect(()=>{buildPages(vs,paras);},[]);

  const updVs=(k,val)=>{
    const nv={...vs,[k]:val};
    setVs(nv);
    localStorage.setItem("sd_vertrag_settings",JSON.stringify(nv));
    clearTimeout(timerRef.current);
    timerRef.current=setTimeout(()=>buildPages(nv,paras),300);
  };
  const updParaTitel=(i,val)=>{
    const np=paras.map((p,j)=>j===i?{...p,titel:val}:p);
    setParas(np);
    localStorage.setItem("sd_vertrag_paragraphen",JSON.stringify(np));
    clearTimeout(timerRef.current);
    timerRef.current=setTimeout(()=>buildPages(vs,np),300);
  };
  const updParaText=(i,val)=>{
    const np=paras.map((p,j)=>j===i?{...p,text:val}:p);
    setParas(np);
    localStorage.setItem("sd_vertrag_paragraphen",JSON.stringify(np));
    clearTimeout(timerRef.current);
    timerRef.current=setTimeout(()=>buildPages(vs,np),300);
  };

  return(
    <div style={{display:"flex",height:"calc(100vh - 130px)",margin:"-32px",marginTop:0,overflow:"hidden"}}>
      <div style={{width:"50%",overflowY:"auto",padding:24,display:"flex",flexDirection:"column",gap:14,borderRight:`1px solid ${T.border}`,background:T.bg}}>
        <div style={{fontFamily:"Georgia,serif",fontSize:15,color:T.accent}}>Fotograf Stammdaten</div>
        <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:10,padding:14,display:"flex",flexDirection:"column",gap:8}}>
          {[["name","Studioname / Name"],["strasse","Adresse"],["plz","PLZ"],["stadt","Ort"],["tel","Telefon"],["email","E-Mail"],["web","Website"],["ort","Standard-Ort für Vertrag"]].map(([k,lbl])=>(
            <div key={k}>
              <label style={{fontSize:11,color:T.muted,display:"block",marginBottom:2}}>{lbl}</label>
              <input style={ISv} value={vs[k]||""} onChange={e=>updVs(k,e.target.value)}/>
            </div>
          ))}
        </div>
        <div style={{fontFamily:"Georgia,serif",fontSize:15,color:T.accent,marginTop:4}}>Paragraphen (§1 – §11)</div>
        {paras.map((p,i)=>(
          <div key={i} style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:8,padding:12,display:"flex",flexDirection:"column",gap:6}}>
            <input style={{...ISv,fontWeight:600}} value={p.titel} onChange={e=>updParaTitel(i,e.target.value)}/>
            <textarea style={{...ISv,minHeight:90,resize:"vertical",lineHeight:1.6}} value={p.text} onChange={e=>updParaText(i,e.target.value)}/>
          </div>
        ))}
      </div>
      <div style={{width:"50%",display:"flex",flexDirection:"column",background:"#b0b0b0"}}>
        <div style={{display:"flex",alignItems:"center",justifyContent:"center",gap:12,padding:"10px 0",background:"#888",flexShrink:0}}>
          <button onClick={()=>setSeite(s=>Math.max(1,s-1))} disabled={seite===1} style={{background:seite===1?"#666":"#fff",color:seite===1?"#999":"#333",border:"none",borderRadius:6,padding:"5px 14px",cursor:seite===1?"default":"pointer",fontWeight:600}}>‹</button>
          <span style={{color:"#fff",fontSize:13,fontWeight:600,minWidth:80,textAlign:"center"}}>Seite {seite} von 5</span>
          <button onClick={()=>setSeite(s=>Math.min(5,s+1))} disabled={seite===5} style={{background:seite===5?"#666":"#fff",color:seite===5?"#999":"#333",border:"none",borderRadius:6,padding:"5px 14px",cursor:seite===5?"default":"pointer",fontWeight:600}}>›</button>
        </div>
        <div style={{flex:1,overflowY:"auto",padding:16}}>
          <div style={{width:560,margin:"0 auto",background:"#fff",boxShadow:"0 3px 16px rgba(0,0,0,0.3)",overflow:"hidden",height:792}}>
            <iframe key={seite+pages[seite-1].length} srcDoc={pages[seite-1]} style={{width:794,height:1123,border:"none",display:"block",transform:"scale(0.705)",transformOrigin:"top left",pointerEvents:"none"}} title={"Seite "+seite}/>
          </div>
        </div>
      </div>
    </div>
  );
}

// ── VertragModal ───────────────────────────────────────────────────────────────
function VertragModal({kunde, onClose, T, termin}){
  const tm=termin||{};
  const k=kunde||{};
  const vs=JSON.parse(localStorage.getItem("sd_vertrag_settings")||"{}");
  // Logo fuer den Vertrag: eigenes Vertrags-Logo hat Vorrang, danach die bekannten Quellen.
  // Nur data:-URLs werden akzeptiert, damit das Bild auch im iframe und im Druck sicher da ist.
  const _isData=v=>typeof v==="string"&&v.startsWith("data:image");
  const [vertragLogo,setVertragLogo]=useState(()=>{
    const eigen=localStorage.getItem("sd_vertrag_logo")||"";
    if(_isData(eigen))return eigen;
    const cfg=(()=>{try{return JSON.parse(localStorage.getItem("sd_buchung_config")||"{}");}catch{return {};}})();
    const api=(()=>{try{return JSON.parse(localStorage.getItem("sd_api_settings")||"{}");}catch{return {};}})();
    const kandidaten=[api.studio_logo,cfg.logoDark,cfg.logo];
    return kandidaten.find(_isData)||"";
  });
  const studioLogo=vertragLogo;
  // Bild einlesen, auf maxBreite herunterrechnen und als PNG (mit Transparenz) ablegen.
  // Ohne das Verkleinern sprengt eine Handy-Aufnahme oder ein 300-dpi-Scan schnell den localStorage.
  const ladeVertragLogo=(datei,setter,key,maxBreite)=>{
    if(!datei)return;
    const maxW=maxBreite||700;
    const r=new FileReader();
    r.onload=()=>{
      const img=new Image();
      img.onload=()=>{
        const skal=Math.min(1,maxW/(img.width||maxW));
        const w=Math.max(1,Math.round(img.width*skal));
        const h=Math.max(1,Math.round(img.height*skal));
        const cv=document.createElement("canvas");
        cv.width=w; cv.height=h;
        const ctx=cv.getContext("2d");
        ctx.imageSmoothingQuality="high";
        ctx.drawImage(img,0,0,w,h);
        const out=cv.toDataURL("image/png");
        try{
          localStorage.setItem(key,out);
        }catch(e){
          alert("Der lokale Speicher ist voll ("+Math.round(out.length/1024)+" KB konnten nicht abgelegt werden).\n\nBitte unter Kunden alte Vertrags-Dokumente loeschen oder ein kleineres Bild verwenden.");
          return;
        }
        setter(out);
      };
      img.onerror=()=>alert("Die Datei konnte nicht als Bild gelesen werden.");
      img.src=r.result;
    };
    r.onerror=()=>alert("Datei konnte nicht gelesen werden.");
    r.readAsDataURL(datei);
  };

  const [name,setName]=useState(k.name||[k.vorname,k.nachname].filter(Boolean).join(" ")||"");
  const [adresse,setAdresse]=useState(k.strasse||k.adresse||"");
  const [plz,setPlz]=useState(k.plz||"");
  const [ort2,setOrt2]=useState(k.ort||"");
  // Kundendatensaetze speichern die Nummer je nach Herkunft unter telefon, phone, handy oder mobil.
  const [telefon,setTelefon]=useState(k.telefon||k.phone||k.handy||k.mobil||"");
  const [email,setEmail]=useState(k.email||"");
  const [tiere,setTiere]=useState(()=>{
    const alle=(k.tiere||[]).filter(t=>t&&(t.rasse||t.name));
    // Wurden beim Termin einzelne Hunde angehakt, kommen nur die in den
    // Vertrag. Ohne Auswahl gelten alle Hunde des Kunden.
    const gew=Array.isArray(tm.hunde)?tm.hunde:[];
    const treffer=gew.length?alle.filter(t=>gew.includes(t.name||t.rasse)):alle;
    const liste=(treffer.length?treffer:alle);
    return liste.length>0
      ?liste.map(t=>({rasse:t.rasse||"",name:t.name||"",alter:t.alter||"",geschlecht:t.geschlecht||""}))
      :[{rasse:"",name:"",alter:"",geschlecht:""}];
  });
  const [datum,setDatum]=useState(tm.datum||new Date().toLocaleDateString("de-DE"));
  const [uhrzeit,setUhrzeit]=useState(tm.uhrzeit||"10:00");
  const [shootingOrt,setShootingOrt]=useState(tm.ort||vs.ort||"");
  const [bilder,setBilder]=useState("-");
  const [einzelpreis,setEinzelpreis]=useState(tm.preis!=null&&tm.preis!==""?String(tm.preis):"160");
  // Preis je zusaetzlichem Bild und Aufschlag fuer ein weiteres Tier.
  // Beides frei einstellbar und wird als Standard fuer den naechsten
  // Vertrag gemerkt.
  const [preisProBild,setPreisProBild]=useState(()=>localStorage.getItem("sd_vertrag_preis_bild")||"39");
  const [preisZusatztier,setPreisZusatztier]=useState(()=>localStorage.getItem("sd_vertrag_preis_zusatztier")||"55");
  const [zusatzAnz,setZusatzAnz]=useState("");
  const [zusatz,setZusatz]=useState(()=>{
    // Weitere Fototermine als eine Zeile mit Datumsangaben.
    const daten=(Array.isArray(tm.serie)?tm.serie:[])
      .slice(1) // der erste Fototermin ist der Haupttermin, kein Zusatztermin
      .map(z=>{
        const iso=String((z&&z.datum)||"").slice(0,10);
        return iso.length===10?`${iso.slice(8,10)}.${iso.slice(5,7)}.${iso.slice(0,4)}`:"";
      })
      .filter(Boolean);
    return daten.length?"Zusatztermine: "+daten.join(", "):"";
  });
  const [kmGesamt,setKmGesamt]=useState("");
  const [fahrtkosten,setFahrtkosten]=useState("");
  const [gesamtpreis,setGesamtpreis]=useState("");
  const [ortDatum,setOrtDatum]=useState("");
  const [sigHoehe,setSigHoehe]=useState(()=>parseInt(localStorage.getItem("sd_vertrag_sig_hoehe")||"55")||55);
  // Vertikale Feinjustierung der PNG-Unterschrift. Negativ = nach oben, damit die Linie frei bleibt.
  const [sigOffset,setSigOffset]=useState(()=>{
    const v=localStorage.getItem("sd_vertrag_sig_offset");
    return v===null?-10:(parseInt(v)||0);
  });
  const [sigKunde,setSigKunde]=useState("");
  const [sigFotograf,setSigFotograf]=useState(()=>{
    const g=localStorage.getItem("sd_vertrag_sig_fotograf")||"";
    return g.startsWith("data:image")?g:"";
  });

  // ── Versand ans Handy ───────────────────────────────────────────────────────
  const [sendOffen,setSendOffen]=useState(false);
  const [sendMail,setSendMail]=useState("");
  const [sendKopie,setSendKopie]=useState(()=>localStorage.getItem("sd_vertrag_kopie_an")||"");
  const [sendBetreff,setSendBetreff]=useState("");
  const [sendText,setSendText]=useState("");
  // Platzhalter aus der Vorlage mit den Daten dieses Vertrags fuellen.
  // {{link}} wird zu {link}, den Rest setzt der Server beim Versand ein.
  // Kartenlink zum Shootingort. Koordinaten sind genauer, deshalb haben sie
  // Vorrang. Sonst wird die eingetippte Adresse gesucht.
  const mapsLink=(()=>{
    if(tm.lat!=null&&tm.lng!=null&&tm.lat!==""&&tm.lng!=="")
      return `https://www.google.com/maps/search/?api=1&query=${tm.lat},${tm.lng}`;
    const o=(shootingOrt||"").trim();
    return o?`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(o)}`:"";
  })();

  const platzhalter=roh=>{
    const cfg=(()=>{try{return JSON.parse(localStorage.getItem("sd_buchung_config")||"{}");}catch{return {};}})();
    const t=(tiere&&tiere[0])||{};
    const werte={
      name,
      vorname:(name||"").trim().split(/\s+/)[0]||"",
      datum,uhrzeit,
      ort:shootingOrt,location:shootingOrt,
      preis:gp,
      tier:t.name||"",rasse:t.rasse||"",
      maps:mapsLink,
      studio:cfg.studioName||cfg.studioname||"Markus Heber Photography",
    };
    return String(roh||"")
      .replace(/\{\{link\}\}/g,"{link}")
      .replace(/\{\{(\w+)\}\}/g,(_m,k)=>(k in werte?werte[k]:""));
  };
  // Bisherige Sendungen zu diesem Kunden, damit im Fenster steht, was schon raus ist
  const versandKey=k.id?"sd_vertrag_versand_"+k.id:"";
  const [versand,setVersand]=useState(()=>{
    if(!versandKey)return [];
    try{return JSON.parse(localStorage.getItem(versandKey)||"[]");}catch{return [];}
  });
  const [vStatus,setVStatus]=useState({});
  const srvUrl=()=>{
    let u=(localStorage.getItem("sd_server_url")||"").trim().replace(/\/+$/,"");
    if(!u||(window.location.protocol==="https:"&&u.startsWith("http://")))u=window.location.origin;
    return u;
  };
  // Beim Oeffnen nachfragen, ob inzwischen unterschrieben wurde
  useEffect(()=>{
    const tokens=versand.map(x=>x.token).filter(Boolean);
    if(!tokens.length)return;
    let abgebrochen=false;
    fetch(srvUrl()+"/api/vertrag-status",{
      method:"POST",headers:{"Content-Type":"application/json"},
      body:JSON.stringify({tokens}),
    }).then(r=>r.json()).then(d=>{
      if(!abgebrochen&&d&&d.ok)setVStatus(d.vertraege||{});
    }).catch(()=>{});
    return()=>{abgebrochen=true;};
  },[versand.length]);

  const letzter=versand.length?versand[versand.length-1]:null;
  const letzterStatus=letzter?(vStatus[letzter.token]||null):null;
  const dtKurz=w=>{try{return new Date(w).toLocaleDateString("de-DE");}catch{return "";}};
  const unterschrieben=letzterStatus&&letzterStatus.status==="signiert";
  const ueberholt=letzterStatus&&letzterStatus.status==="ersetzt";

  const [sendState,setSendState]=useState("");   // "" | "senden" | "ok" | "fehler"
  const [sendMsg,setSendMsg]=useState("");
  const [sendLink,setSendLink]=useState("");

  const oeffneSenden=()=>{
    const vl=(()=>{try{return (JSON.parse(localStorage.getItem("sd_email_vorlagen")||"{}")||{}).vertragsmail||{};}catch{return {};}})();
    setSendBetreff(platzhalter(vl.betreff||"Dein Fotografievertrag – {{datum}}"));
    setSendText(platzhalter(vl.text||
      "Hallo {{vorname}},\n\nhier ist dein Fotografievertrag für das Shooting am {{datum}} um {{uhrzeit}} Uhr.\n\nÜber diesen Link kannst du ihn in Ruhe durchlesen und direkt am Handy unterschreiben:\n\n{{link}}\n\nTreffpunkt: {{ort}}\n{{maps}}\n\nHerzliche Grüße\n{{studio}}"));
    setSendMail(email||"");
    setSendState(""); setSendMsg(""); setSendLink("");
    setSendOffen(true);
  };

  const vertragSenden=async()=>{
    const an=(sendMail||"").trim();
    if(an.indexOf("@")<1){setSendState("fehler");setSendMsg("Bitte eine gueltige E-Mail-Adresse eintragen.");return;}
    if(!sigFotograf){setSendState("fehler");setSendMsg("Deine eigene Unterschrift fehlt noch. Sie muss auf dem Vertrag stehen, bevor er rausgeht.");return;}
    let srv=(localStorage.getItem("sd_server_url")||"").trim().replace(/\/+$/,"");
    if(!srv||(window.location.protocol==="https:"&&srv.startsWith("http://")))srv=window.location.origin;
    let smtp={};try{smtp=JSON.parse(localStorage.getItem("sd_smtp_buchung")||localStorage.getItem("sd_smtp_settings")||"{}");}catch{}
    let cfg={};try{cfg=JSON.parse(localStorage.getItem("sd_buchung_config")||"{}");}catch{}
    localStorage.setItem("sd_vertrag_kopie_an",(sendKopie||"").trim());
    setSendState("senden");setSendMsg("");
    try{
      const r=await fetch(srv+"/api/vertrag-senden",{
        method:"POST",headers:{"Content-Type":"application/json"},
        body:JSON.stringify({
          name,email:an,kundeId:k.id||"",
          meldeAn:(sendKopie||"").trim(),
          dateiname:dateiBasis(),
          html:buildHtml(true),
          betreff:sendBetreff.replace(/\{name\}/g,name||""),
          text:sendText.replace(/\{name\}/g,name||""),
          studio:cfg.studioName||cfg.studioname||"Markus Heber Photography",
          basis:(cfg.buchungsUrlBasis||"").replace(/\/+$/,"")||undefined,
          smtp,
        }),
      });
      const d=await r.json();
      if(d.ok){
        setSendState("ok");
        setSendLink(d.link||"");
        setSendMsg("Der Vertrag ist an "+an+" unterwegs."
          +(d.ersetzt>0?" "+d.ersetzt+" ältere"+(d.ersetzt===1?"r Link wurde":" Links wurden")+" gesperrt.":""));
        // Im Kundenarchiv vermerken, damit der Vorgang auffindbar bleibt
        if(k.id){
          try{
            const key="sd_vertrag_versand_"+k.id;
            const alt=JSON.parse(localStorage.getItem(key)||"[]");
            alt.push({token:d.token,link:d.link,an,datum:new Date().toISOString(),dateiname:dateiBasis()});
            localStorage.setItem(key,JSON.stringify(alt));
            setVersand(alt);
          }catch{}
        }
      }else{
        setSendState("fehler");
        setSendMsg(d.fehler||"Versand fehlgeschlagen.");
        if(d.link)setSendLink(d.link);
      }
    }catch(e){
      setSendState("fehler");
      setSendMsg("Server nicht erreichbar.");
    }
  };

  const addTier=()=>setTiere(p=>[...p,{rasse:"",name:"",alter:"",geschlecht:""}]);
  const delTier=i=>setTiere(p=>p.filter((_,j)=>j!==i));
  const updTier=(i,fk,v)=>setTiere(p=>p.map((t,j)=>j===i?{...t,[fk]:v}:t));

  const IS3={padding:"7px 10px",border:`1px solid ${T.border}`,borderRadius:5,fontSize:13,background:T.bg,color:T.text,fontFamily:"inherit",boxSizing:"border-box"};
  const Lbl=({children})=><label style={{fontSize:11,color:T.muted,display:"block",marginBottom:3}}>{children}</label>;

  const zusatzZahl=parseInt(zusatzAnz)||0;
  const pZ=parseFloat(String(preisZusatztier).replace(",","."))||0;
  // Der Einzelpreis ist der Paketpreis inklusive der Bilder pro Tier. Die
  // Bilderzahl wird deshalb nicht noch einmal berechnet. Dazu kommen nur
  // der Aufschlag je Zusatztier und die Fahrtkosten.
  const gpAuto=((parseFloat(einzelpreis)||0)+zusatzZahl*pZ+(parseFloat(fahrtkosten)||0)).toFixed(2).replace(".",",");
  const gp=gesamtpreis||gpAuto;
  // "-/-" statt eines Betrags: dann passt das Eurozeichen dahinter nicht.
  // Leere Felder behalten es, damit das ausgedruckte Formular ausfuellbar bleibt.
  const eurZ=v=>{const t=String(v??"").trim();return (t===""||!isNaN(parseFloat(t)))?" \u20ac":"";};
  const u=(val,w)=>`<span style="display:inline-block;min-width:${w||80}px;border-bottom:1px solid #333;vertical-align:bottom;padding:0 3px">${val||""}</span>`;

  // Dateiname nach Schema: "Vertrag - Nachname Vorname - Shootingdatum"
  // Wird sowohl fuer das Archiv in der Kundenkartei als auch als <title> verwendet,
  // damit der Druckdialog beim PDF-Speichern denselben Namen vorschlaegt.
  const dateiBasis=()=>{
    const teile=String(k.name||"").trim().split(/\s+/).filter(Boolean);
    const person=teile.length>1
      ?[teile[teile.length-1],...teile.slice(0,-1)].join(" ")
      :(teile[0]||"Kunde");
    const iso=deToIso(datum);
    const dat=iso
      ?`${iso.slice(8,10)}.${iso.slice(5,7)}.${iso.slice(0,4)}`
      :(String(datum||"").trim()||new Date().toLocaleDateString("de-DE"));
    // Zeichen entfernen, die Windows im Dateinamen nicht erlaubt
    return `Vertrag - ${person} - ${dat}`.replace(/[\\/:*?"<>|]/g,"-");
  };

  const buildHtml=(fuerVersand)=>{
    const logoHtml=studioLogo
      ?`<img src="${studioLogo}" style="max-height:75px;max-width:190px;object-fit:contain" alt="Logo"/>`
      :`<div style="font-size:9pt;font-weight:700;color:#1a4a6e;text-align:right;line-height:1.4">${vs.name||"Markus Heber Photography"}<br/><span style="font-weight:300;letter-spacing:3px">PHOTOGRAPHY</span></div>`;

    const tierZeilen=tiere.map(t=>`
      <div style="margin-bottom:20px;font-size:12pt;white-space:nowrap">
        Rasse: <span style="display:inline-block;min-width:192px;border-bottom:1px solid #333;vertical-align:bottom;text-align:center;padding:0 3px">${t.rasse||""}</span>&nbsp; Name: <span style="display:inline-block;min-width:110px;border-bottom:1px solid #333;vertical-align:bottom;text-align:center;padding:0 3px">${t.name||""}</span>&nbsp; Alter: <span style="display:inline-block;min-width:55px;border-bottom:1px solid #333;vertical-align:bottom;text-align:center;padding:0 3px">${t.alter||""}</span>&nbsp; Geschlecht: <span style="display:inline-block;min-width:60px;border-bottom:1px solid #333;vertical-align:bottom;text-align:center;padding:0 3px">${t.geschlecht||""}</span>
      </div>`).join("");

    // Beim Versand ans Handy bleibt das Kundenfeld leer und bekommt eine Marke,
    // an der der Server spaeter die Unterschrift einsetzt.
    const sigKundeHtml=fuerVersand
      ?`<!--SIG_KUNDE-->`
      :(sigKunde?`<img src="${sigKunde}" style="height:50px;display:block;position:relative;top:${sigOffset}px" alt="Unterschrift Kunde"/>`:``);
    const sigFotografHtml=sigFotograf?`<img src="${sigFotograf}" style="height:${sigHoehe}px;display:block;margin-bottom:0;position:relative;top:${sigOffset}px" alt="Unterschrift Fotograf"/>`:``;

    return `<!DOCTYPE html><html><head><meta charset="UTF-8"><title>${dateiBasis()}</title><style>
      *{box-sizing:border-box;margin:0;padding:0}
      body{font-family:"Helvetica Neue",Helvetica,Arial,sans-serif;color:#222;font-size:12pt;line-height:1.7;background:#fff}
      h2{color:#1a4a6e;font-size:14pt;font-weight:600;margin:30px 0 14px}
      p{margin:0 0 10px}
      ul{margin:8px 0 14px;padding-left:20px}
      li{margin-bottom:8px}
      .page{padding:20mm 18mm;min-height:257mm}
      .pb{page-break-before:always}
      @page{size:A4;margin:0}
      @media print{body{-webkit-print-color-adjust:exact;print-color-adjust:exact}.pb{page-break-before:always}}
    </style></head><body>

    <!-- SEITE 1 -->
    <div class="page">
      <div style="display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:20px">
        <div style="color:#1a4a6e;font-size:21pt;font-weight:300">Fotografievertrag – Tierfotografie</div>
        <div>${logoHtml}</div>
      </div>
      <p style="color:#666;margin-bottom:12px">zwischen</p>
      <div style="margin-bottom:14px;line-height:1.8;font-size:12pt">
        <b>${vs.name||"Markus Heber Photography"}</b><br/>
        ${vs.strasse||"Moltkestraße 22"}${vs.plz||vs.stadt?", "+(vs.plz||"")+" "+(vs.stadt||""):vs.strasse?"":", 90429 Nürnberg"}<br/>
        ${vs.tel?"Telefon: "+vs.tel+"<br/>":""}
        E-Mail: ${vs.email||"info@m-h-photo.de"}<br/>
        Website: ${vs.web||"www.m-h-photo.de"}
      </div>
      <p style="color:#666;margin-bottom:10px">– nachfolgend <b>„Fotograf"</b> genannt -</p>
      <p style="margin-bottom:10px">und</p>
      <p style="margin-bottom:20px"><b>Vertragspartner (Tierhalter)</b></p>

      <table style="border-collapse:collapse;width:100%;margin-bottom:10px;font-size:12pt">
        <tr><td style="padding:9px 0;width:80px">Name:</td><td style="padding:9px 0"><span style="display:inline-block;min-width:420px;border-bottom:1px solid #333;padding:0 4px">${name}</span></td></tr>
        <tr><td style="padding:9px 0">Adresse:</td><td style="padding:9px 0"><span style="display:inline-block;min-width:420px;border-bottom:1px solid #333;padding:0 4px">${adresse}</span></td></tr>
        <tr><td style="padding:9px 0">PLZ/ Ort:</td><td style="padding:9px 0">
          <span style="display:inline-block;min-width:100px;border-bottom:1px solid #333;margin-right:20px;padding:0 4px">${plz}</span>
          <span style="display:inline-block;min-width:220px;border-bottom:1px solid #333;padding:0 4px">${ort2}</span>
        </td></tr>
        <tr><td style="padding:9px 0">Telefon:</td><td style="padding:9px 0"><span style="display:inline-block;min-width:220px;border-bottom:1px solid #333;padding:0 4px">${telefon}</span></td></tr>
        <tr><td style="padding:9px 0">E-Mail:</td><td style="padding:9px 0"><span style="display:inline-block;min-width:220px;border-bottom:1px solid #333;padding:0 4px">${email}</span></td></tr>
      </table>
      <div style="height:32px"></div>

      <div style="margin-bottom:20px">${tierZeilen}</div>
      <div style="height:36px"></div>
      <p style="color:#666">– nachfolgend <b>„Auftraggeber"</b> genannt –</p>
    </div>

    <!-- SEITE 2 -->
    <div class="page pb">
      <h2>§1 Vertragsgegenstand</h2>
      <p>Der Auftraggeber beauftragt den Fotografen mit der Durchführung eines Tier-Fotoshootings.</p>
      <div style="line-height:2.4;margin-bottom:16px">
        <div><b>Datum:</b> ${u(datum,120)}</div>
        <div><b>Uhrzeit:</b> ${u(uhrzeit,90)}</div>
        <div><b>Ort:</b> &nbsp;&nbsp;&nbsp;&nbsp;${u(shootingOrt,360)}</div>
      </div>
      <div style="padding-left:80px;margin-bottom:16px;line-height:2.4">
        <div>Anzahl der enthaltenen Bilder: <span style="display:inline-block;min-width:80px;max-width:100px;border-bottom:1px solid #333;vertical-align:bottom;text-align:center;padding:0 3px">${bilder}</span> pro Tier</div>
        <div>Einzelpreis pro Tier: <span style="display:inline-block;min-width:100px;border-bottom:1px solid #333;vertical-align:bottom;text-align:center;padding:0 3px">${einzelpreis}</span>${eurZ(einzelpreis)} &nbsp;&nbsp;&nbsp;&nbsp; Zusatztier: <span style="display:inline-block;min-width:70px;border-bottom:1px solid #333;vertical-align:bottom;text-align:center;padding:0 3px">${zusatzAnz}</span>${eurZ(zusatzAnz)}</div>
      </div>
      <p style="margin-bottom:10px">Bei Anfahrt über 15 km wird die An/ Abfahrt per Reisekostenrechner ermittelt:</p>
      <div style="padding-left:80px;margin-bottom:20px;line-height:2.4">
        <div>KM gesamt: <span style="display:inline-block;min-width:80px;border-bottom:1px solid #333;vertical-align:bottom;text-align:center;padding:0 3px">${kmGesamt||""}</span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Fahrtkosten: <span style="display:inline-block;min-width:80px;border-bottom:1px solid #333;vertical-align:bottom;text-align:center;padding:0 3px">${fahrtkosten||""}</span>${eurZ(fahrtkosten)}</div>
      </div>
      <p style="margin-bottom:8px"><b>Die Gesamtvergütung für das vereinbarte Fotoshooting beträgt:</b></p>
      <div style="font-size:18pt;font-weight:700;margin-bottom:20px;text-align:center">Gesamtpreis: <span style="display:inline-block;min-width:120px;border-bottom:2px solid #333;vertical-align:bottom;padding:0 6px">${gp}</span>${eurZ(gp)}</div>
      <p style="margin-bottom:30px">Art und Umfang der Aufnahmen richten sich nach den individuell vereinbarten Leistungen dieses Vertrages</p>

      <h2>§2 Vergütung und Zahlungsbedingungen</h2>
      <ul>
        <li>Der Fotograf stellt eine Rechnung mit Ausweis der Umsatzsteuer</li>
        <li>Der Rechnungsbetrag ist nach Rechnungserhalt ohne Abzug per Überweisung zu zahlen.</li>
        <li>Jedes zusätzliche Bild über das vereinbarte Kontingent hinaus wird mit <b>39,00 € pro Bild</b> berechnet.</li>
        <li>Fahrten bis zu 15 km sind inklusive, darüber hinaus erfolgt die Abrechnung über einen Reisekostenrechner.</li>
        <li>Nachbestellungen weiterer Bilder sind jederzeit zu den jeweils gültigen Konditionen möglich.</li>
      </ul>
    </div>

    <!-- SEITE 3 -->
    <div class="page pb">
      <h2>§3 Leistungsumfang</h2>
      <p>Das vereinbarte Fotoshooting umfasst:</p>
      <p>Erstellung professioneller Tierfotografien</p>
      <p>Auswahl und Bearbeitung der Bilder durch den Fotografen Bereitstellung der finalen Bilder als digitale Dateien Hochauflösende Dateien ohne Logo für private Druckzwecke Weboptimierte Dateien mit Logo</p>
      <p style="margin-bottom:10px">Bereitstellung über eine passwortgeschützte Online-Galerie (Cloud)</p>
      <p style="margin-bottom:10px">Art und Umfang der Aufnahmen richten sich nach den individuell vereinbarten Leistungen dieses Vertrages</p>
      <p style="margin-bottom:6px">Zusatzleistungen / besondere Vereinbarungen:</p>
      <!-- Drei linierte Zeilen mit fester Gesamthoehe. Der Text laeuft ueber
           die Linien, leere Zeilen bleiben als Linie stehen. Nichts darunter
           verschiebt sich, egal wie viel geschrieben wird. -->
      <div style="height:78px;overflow:hidden;margin-bottom:36px;
                  line-height:26px;font-size:11pt;white-space:pre-line;
                  background-image:repeating-linear-gradient(to bottom,
                    transparent 0,transparent 25px,#555 25px,#555 26px);
                  background-size:100% 26px">${zusatz}</div>

      <h2>§4 Durchführung des Shootings</h2>
      <ul style="margin-bottom:30px">
        <li>Der Fotograf verpflichtet sich, zum vereinbarten Termin am festgelegten Ort zu erscheinen und das Shooting professionell durchzuführen.</li>
        <li>Der Auftraggeber verpflichtet sich, die Tiere in einem geeigneten Zustand (gesund, gepflegt, betreuungsfähig) bereitzustellen und während des Shootings angemessen zu begleiten.</li>
      </ul>

      <h2>§5 Bildbearbeitung und Urheberrecht</h2>
      <ul style="margin-bottom:14px">
        <li>Die Auswahl der finalen Bilder für die Kundenauswahl sowie Art und Stil der Bildbearbeitung obliegen dem Fotografen.</li>
        <li>Der Fotograf ist berechtigt, Farb-, Kontrast- und Belichtungskorrekturen sowie Retuschen vorzunehmen.</li>
        <li>Rohdateien (unbearbeitete Bilder) verbleiben ausschließlich beim Fotografen; ein Anspruch auf Herausgabe besteht nicht.</li>
      </ul>
      <p>Das Urheberrecht an sämtlichen Bildern verbleibt uneingeschränkt beim Fotografen.</p>
      <p>Eine Veränderung oder Bearbeitung der Bilder durch den Auftraggeber oder Dritte – insbesondere durch Filter, Effekte oder Verfremdungen – ist nicht gestattet.</p>
    </div>

    <!-- SEITE 4 -->
    <div class="page pb">
      <h2>§6 Nutzungsrechte Fotograf</h2>
      <p>Der Auftraggeber räumt dem Fotografen das zeitlich, räumlich und inhaltlich uneingeschränkte Nutzungsrecht an den entstandenen Bildern ein.</p>
      <p>Der Fotograf ist berechtigt, die Bilder insbesondere zu verwenden für:</p>
      <ul style="margin-bottom:30px">
        <li>Eigenwerbung</li><li>Portfolio (online und print)</li><li>Social Media</li><li>Website</li><li>Präsentationsmappen, Fotobücher und Agenturen</li>
      </ul>

      <h2>§7 Nutzungsrechte Auftraggeber</h2>
      <p>Der Auftraggeber erhält ein einfaches, nicht übertragbares Nutzungsrecht für <b>private und nichtkommerzielle Zwecke.</b></p>
      <p>Erlaubt ist insbesondere:</p>
      <ul style="margin-bottom:14px"><li>Private Ausdrucke</li><li>Veröffentlichung in sozialen Netzwerken und auf privaten Webseiten</li></ul>
      <p>Dabei gilt:</p>
      <ul style="margin-bottom:14px">
        <li>Für Online-Veröffentlichungen ist ausschließlich die weboptimierte Datei mit Logo zu verwenden.</li>
        <li>Der Fotograf ist immer als Urheber zu benennen.</li>
      </ul>
      <p style="margin-bottom:30px">Eine kommerzielle Nutzung bedarf einer gesonderten schriftlichen Vereinbarung.</p>

      <h2>§8 Bildauswahl und Lieferung</h2>
      <ul>
        <li>Die Vorauswahl der Bilder wird innerhalb von <b>2-3 Werktagen</b> nach dem Shooting in einer Online-Galerie bereitgestellt.</li>
        <li>Der Auswahl-Link ist <b>14 Werktage</b> gültig.</li>
        <li>Die Lieferung erfolgt per Cloud-Download</li>
        <li>optional zusätzlich auf USB-Stick per Postversand</li>
      </ul>
    </div>

    <!-- SEITE 5 -->
    <div class="page pb">
      <h2>§9 Lieferzeit</h2>
      <p style="margin-bottom:30px">Die endgültige Lieferung der Bilder erfolgt spätestens 4-6 Wochen nach Bildauswahl und vollständigem Zahlungseingang.</p>

      <h2>§10 Reklamation und Haftung</h2>
      <p>Der Fotograf gestaltet die Bilder nach eigenem künstlerischem Ermessen. Reklamationen hinsichtlich Bildstil, Farbgebung oder Gestaltung sind ausgeschlossen.</p>
      <p style="margin-bottom:30px">Dem Auftraggeber sind Stil und Qualität der bisherigen Arbeiten des Fotografen bekannt.</p>

      <h2>§11 Schlussbestimmungen</h2>
      <p>Änderungen oder Ergänzungen dieses Vertrages bedürfen der Schriftform.</p>
      <p>Sollten einzelne Bestimmungen dieses Vertrages ganz oder teilweise unwirksam sein, bleibt die Wirksamkeit der übrigen Regelungen unberührt.</p>
      <p style="margin-bottom:60px">Es gilt das Recht der Bundesrepublik Deutschland.</p>

      <p style="margin-bottom:100px;font-size:13pt"><b>Ort, Datum:</b> ${
        fuerVersand&&!ortDatum
          ? `<span style="display:inline-block;min-width:240px;border-bottom:1px solid #333;vertical-align:bottom;padding:0 3px"><!--ORT_DATUM--></span>`
          : u(ortDatum,240)
      }</p>

      <div style="display:flex;justify-content:space-between;padding:0 30px">
        <div style="width:40%">
          <div style="height:70px;display:flex;align-items:flex-end;overflow:hidden">${sigKundeHtml}</div>
          <div style="border-top:1px solid #333;padding-top:8px;font-size:12pt;white-space:nowrap">Auftraggeber (Unterschrift)</div>
        </div>
        <div style="width:40%">
          <div style="height:70px;display:flex;align-items:flex-end;overflow:hidden">${sigFotografHtml}</div>
          <div style="border-top:1px solid #333;padding-top:8px;font-size:12pt;white-space:nowrap">Fotograf (Unterschrift)</div>
        </div>
      </div>
    </div>

    </body></html>`;
  };

  const doPrint=()=>{
    // Aus einem iframe heraus uebernimmt Firefox den Dateinamen nicht in den
    // Druckauftrag - der Windows-PDF-Dialog bleibt dann leer. Deshalb wird der
    // Vertrag in einem eigenen Fenster geoeffnet, dessen Titel den Namen liefert.
    // Druck direkt aus der A4-Vorschau. Kein zusaetzliches Fenster.
    // Firefox uebernimmt dabei keinen Dateinamen in den Speichern-Dialog,
    // das laesst sich aus einem iframe heraus nicht beeinflussen.
    const iframe=document.querySelector("#vertrag-print-frame");
    if(iframe&&iframe.contentWindow){
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
    }
    if(k.id){
      const docKey="sd_docs_"+k.id;
      const bestehend=(()=>{try{return JSON.parse(localStorage.getItem(docKey)||"[]");}catch{return [];}})();
      const datum=new Date().toLocaleDateString("de-DE");
      const dateiname=dateiBasis()+".html";
      const htmlBlob="data:text/html;charset=utf-8,"+encodeURIComponent(buildHtml());
      const neu={id:uid(),name:dateiname,typ:"vertrag",datum,data:htmlBlob,quelle:"scatto"};
      localStorage.setItem(docKey,JSON.stringify([...bestehend,neu]));
    }
  };

  const SigPad=({label,value,onChange})=>{
    const canvasRef=useRef(null);
    const drawing=useRef(false);
    const getPos=(e,canvas)=>{
      const r=canvas.getBoundingClientRect();
      const touch=e.touches?e.touches[0]:e;
      return{x:(touch.clientX-r.left)*(canvas.width/r.width),y:(touch.clientY-r.top)*(canvas.height/r.height)};
    };
    const start=e=>{drawing.current=true;const c=canvasRef.current;const ctx=c.getContext("2d");const p=getPos(e,c);ctx.beginPath();ctx.moveTo(p.x,p.y);};
    const draw=e=>{if(!drawing.current)return;const c=canvasRef.current;const ctx=c.getContext("2d");const p=getPos(e,c);ctx.lineWidth=2;ctx.lineCap="round";ctx.strokeStyle="#1a1a2e";ctx.lineTo(p.x,p.y);ctx.stroke();};
    const stop=()=>{if(!drawing.current)return;drawing.current=false;onChange(canvasRef.current.toDataURL());};
    const clear=()=>{const c=canvasRef.current;c.getContext("2d").clearRect(0,0,c.width,c.height);onChange("");};
    return(
      <div style={{display:"flex",flexDirection:"column",gap:4}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <label style={{fontSize:11,color:T.muted}}>{label}</label>
          <button onClick={clear} style={{fontSize:10,color:T.muted,background:"none",border:"none",cursor:"pointer"}}>löschen</button>
        </div>
        <canvas ref={canvasRef} width={240} height={70}
          style={{border:`1px solid ${T.border}`,borderRadius:5,background:"#fff",touchAction:"none",cursor:"crosshair",width:"100%",height:70}}
          onMouseDown={start} onMouseMove={draw} onMouseUp={stop} onMouseLeave={stop}
          onTouchStart={start} onTouchMove={draw} onTouchEnd={stop}
        />
      </div>
    );
  };

  return(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.55)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:300}}>
      <div style={{background:T.surface,borderRadius:14,width:"95vw",height:"92vh",display:"flex",flexDirection:"column",overflow:"hidden",border:`1px solid ${T.border}`}}>
        <div style={{padding:"12px 20px",borderBottom:`1px solid ${T.border}`,display:"flex",justifyContent:"space-between",alignItems:"center",flexShrink:0}}>
          <div style={{fontFamily:"Georgia,serif",fontSize:16,color:T.accent}}>Vertrag — {k.name||"Neuer Kunde"}</div>
          <div style={{display:"flex",gap:8}}>
            {letzter&&(
              <div style={{display:"flex",alignItems:"center",gap:6,fontSize:12,fontWeight:600,
                           color:unterschrieben?T.success:T.success,alignSelf:"center"}}>
                <span style={{fontSize:14}}>✓</span>
                <span>{unterschrieben
                  ?"Unterschrieben "+dtKurz(letzterStatus.signiertAm)
                  :"Gesendet "+dtKurz(letzter.datum)}</span>
              </div>
            )}
            <button onClick={oeffneSenden} style={{background:"none",color:T.accent,border:`1px solid ${T.accent}`,borderRadius:8,padding:"7px 14px",fontSize:12,fontWeight:600,cursor:"pointer"}}>📱 Zum Unterschreiben senden</button>
            <button onClick={doPrint} style={{background:T.accent,color:"#fff",border:"none",borderRadius:8,padding:"7px 16px",fontSize:12,fontWeight:600,cursor:"pointer"}}>Drucken / PDF speichern</button>
            <button onClick={onClose} style={{background:"none",border:`1px solid ${T.border}`,borderRadius:8,padding:"7px 12px",fontSize:12,cursor:"pointer",color:T.text}}>× Schließen</button>
          </div>
        </div>
        <div style={{display:"flex",flex:1,overflow:"hidden"}}>
          <div style={{width:300,minWidth:300,overflowY:"auto",padding:14,display:"flex",flexDirection:"column",gap:8,borderRight:`1px solid ${T.border}`,background:T.bg}}>
            <div style={{fontSize:10,fontWeight:700,color:T.muted,textTransform:"uppercase",letterSpacing:".06em"}}>Kundendaten</div>
            {[["Name",name,setName],["Adresse",adresse,setAdresse],["PLZ",plz,setPlz],["Ort",ort2,setOrt2],["Telefon",telefon,setTelefon],["E-Mail",email,setEmail]].map(([lbl,val,set])=>(
              <div key={lbl}><Lbl>{lbl}</Lbl><input style={{...IS3,width:"100%"}} value={val} onChange={e=>set(e.target.value)}/></div>
            ))}
            <div style={{fontSize:10,fontWeight:700,color:T.muted,textTransform:"uppercase",letterSpacing:".06em",marginTop:4}}>Tiere</div>
            {tiere.map((t,i)=>(
              <div key={i} style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:8,padding:8}}>
                <div style={{display:"flex",justifyContent:"space-between",marginBottom:4}}>
                  <span style={{fontSize:11,fontWeight:600,color:T.text}}>Tier {i+1}</span>
                  {tiere.length>1&&<button onClick={()=>delTier(i)} style={{background:"none",border:"none",color:T.muted,cursor:"pointer",fontSize:14}}>×</button>}
                </div>
                {[["rasse","Rasse"],["name","Name"],["alter","Alter"],["geschlecht","Geschlecht"]].map(([fk,fl])=>(
                  <div key={fk} style={{marginBottom:4}}><input style={{...IS3,width:"100%",textAlign:"center"}} placeholder={fl} value={t[fk]} onChange={e=>updTier(i,fk,e.target.value)}/></div>
                ))}
              </div>
            ))}
            <button onClick={addTier} style={{background:"none",border:`1px dashed ${T.border}`,borderRadius:7,padding:"6px",fontSize:12,cursor:"pointer",color:T.muted}}>+ Weiterer Hund</button>
            <div style={{fontSize:10,fontWeight:700,color:T.muted,textTransform:"uppercase",letterSpacing:".06em",marginTop:4}}>Shooting</div>
            <div>
              <Lbl>Datum</Lbl>
              <input type="date" style={{...IS3,width:"100%"}} value={deToIso(datum)}
                onChange={e=>setDatum(isoToDe(e.target.value))}/>
            </div>
            {[["Uhrzeit",uhrzeit,setUhrzeit],["Ort",shootingOrt,setShootingOrt]].map(([lbl,val,set])=>(
              <div key={lbl}><Lbl>{lbl}</Lbl><input style={{...IS3,width:"100%"}} value={val} onChange={e=>set(e.target.value)}/></div>
            ))}
            <div style={{fontSize:10,fontWeight:700,color:T.muted,textTransform:"uppercase",letterSpacing:".06em",marginTop:4}}>Leistungen</div>
            {/* Anzahl links, zugehoeriger Preis direkt daneben */}
            <div style={{display:"flex",gap:8}}>
              <div style={{flex:1}}><Lbl>Bilder pro Tier / je Termin</Lbl>
                <input style={{...IS3,width:"100%",textAlign:"center"}} maxLength={3} value={bilder}
                  onChange={e=>setBilder(e.target.value)}/></div>
              <div style={{flex:1}}><Lbl>Preis je Bild (€)</Lbl>
                <input style={{...IS3,width:"100%"}} inputMode="decimal" value={preisProBild}
                  onChange={e=>{setPreisProBild(e.target.value);localStorage.setItem("sd_vertrag_preis_bild",e.target.value);}}/></div>
            </div>
            <div><Lbl>Einzelpreis (€)</Lbl>
              <input style={{...IS3,width:"100%"}} inputMode="decimal" placeholder="-/- für keins" value={einzelpreis}
                onChange={e=>setEinzelpreis(e.target.value)}/></div>
            <div style={{display:"flex",gap:8}}>
              <div style={{flex:1}}><Lbl>Zusatztier (Anz.)</Lbl>
                <input style={{...IS3,width:"100%"}} inputMode="decimal" placeholder="-/- für keins" value={zusatzAnz}
                  onChange={e=>setZusatzAnz(e.target.value)}/></div>
              <div style={{flex:1}}><Lbl>Preis Zusatztier (€)</Lbl>
                <input style={{...IS3,width:"100%"}} inputMode="decimal" value={preisZusatztier}
                  onChange={e=>{setPreisZusatztier(e.target.value);localStorage.setItem("sd_vertrag_preis_zusatztier",e.target.value);}}/></div>
            </div>
            <div><Lbl>Zusatzleistungen</Lbl><textarea style={{...IS3,width:"100%",minHeight:46,resize:"vertical"}} value={zusatz} onChange={e=>setZusatz(e.target.value)}/></div>
            <div style={{fontSize:10,fontWeight:700,color:T.muted,textTransform:"uppercase",letterSpacing:".06em",marginTop:4}}>Fahrtkosten</div>
            {[["KM gesamt",kmGesamt,setKmGesamt],["Fahrtkosten (€)",fahrtkosten,setFahrtkosten]].map(([lbl,val,set])=>(
              <div key={lbl}><Lbl>{lbl}</Lbl><input style={{...IS3,width:"100%"}} value={val} onChange={e=>set(e.target.value)}/></div>
            ))}
            <div><Lbl>Gesamtpreis (€) — leer = auto</Lbl><input style={{...IS3,width:"100%"}} value={gesamtpreis} onChange={e=>setGesamtpreis(e.target.value)} placeholder="automatisch"/></div>
            <div><Lbl>Ort, Datum (Unterschrift)</Lbl><input style={{...IS3,width:"100%"}} value={ortDatum} onChange={e=>setOrtDatum(e.target.value)} placeholder="Nürnberg, TT.MM.JJJJ"/></div>
            <div style={{fontSize:10,fontWeight:700,color:T.muted,textTransform:"uppercase",letterSpacing:".06em",marginTop:4}}>Logo im Vertrag</div>
            <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:8,padding:8,display:"flex",flexDirection:"column",gap:6}}>
              {vertragLogo
                ?<img src={vertragLogo} alt="Logo" style={{maxHeight:60,maxWidth:"100%",objectFit:"contain",background:"#fff",borderRadius:4,padding:4}}/>
                :<div style={{fontSize:11,color:T.muted}}>Kein Logo hinterlegt – im Vertrag steht solange der Schriftzug.</div>}
              <label style={{...btn(T,"ghost",true),textAlign:"center",cursor:"pointer",display:"block"}}>
                {vertragLogo?"Logo ändern":"Logo hochladen (PNG)"}
                <input type="file" accept="image/png,image/jpeg,image/webp" style={{display:"none"}}
                  onChange={e=>{ladeVertragLogo(e.target.files&&e.target.files[0],setVertragLogo,"sd_vertrag_logo",600);e.target.value="";}}/>
              </label>
              {vertragLogo&&<button style={{...btn(T,"ghost",true),color:"#e55"}} onClick={()=>{localStorage.removeItem("sd_vertrag_logo");setVertragLogo("");}}>Logo entfernen</button>}
              <div style={{fontSize:10,color:T.muted,lineHeight:1.4}}>Auf weissem Papier ist ein helles Logo unsichtbar. Bitte die dunkle Variante nehmen.</div>
            </div>

            <div style={{fontSize:10,fontWeight:700,color:T.muted,textTransform:"uppercase",letterSpacing:".06em",marginTop:4}}>Digitale Unterschriften</div>
            <SigPad label="Auftraggeber" value={sigKunde} onChange={setSigKunde}/>
            <SigPad label="Fotograf" value={sigFotograf} onChange={setSigFotograf}/>
            <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:8,padding:8,display:"flex",flexDirection:"column",gap:6}}>
              <div style={{fontSize:11,color:T.text,fontWeight:600}}>Eigene Unterschrift als PNG</div>
              {sigFotograf&&<img src={sigFotograf} alt="Unterschrift" style={{height:Math.min(sigHoehe,70),objectFit:"contain",alignSelf:"flex-start",background:"#fff",borderRadius:4,padding:4}}/>}
              <label style={{...btn(T,"ghost",true),textAlign:"center",cursor:"pointer",display:"block"}}>
                {sigFotograf?"Unterschrift ändern":"PNG hochladen"}
                <input type="file" accept="image/png,image/webp" style={{display:"none"}}
                  onChange={e=>{ladeVertragLogo(e.target.files&&e.target.files[0],setSigFotograf,"sd_vertrag_sig_fotograf",700);e.target.value="";}}/>
              </label>
              <div>
                <Lbl>Höhe: {sigHoehe} px</Lbl>
                <input type="range" min={25} max={110} value={sigHoehe} style={{width:"100%"}}
                  onChange={e=>{const v=parseInt(e.target.value)||55;setSigHoehe(v);localStorage.setItem("sd_vertrag_sig_hoehe",String(v));}}/>
              </div>
              <div>
                <Lbl>Position: {sigOffset > 0 ? "+" : ""}{sigOffset} px {sigOffset < 0 ? "(höher)" : sigOffset > 0 ? "(tiefer)" : ""}</Lbl>
                <input type="range" min={-60} max={20} value={sigOffset} style={{width:"100%"}}
                  onChange={e=>{const v=parseInt(e.target.value)||0;setSigOffset(v);localStorage.setItem("sd_vertrag_sig_offset",String(v));}}/>
              </div>
              {sigFotograf&&<button style={{...btn(T,"ghost",true),color:"#e55"}} onClick={()=>{localStorage.removeItem("sd_vertrag_sig_fotograf");setSigFotograf("");}}>Unterschrift entfernen</button>}
              <div style={{fontSize:10,color:T.muted,lineHeight:1.4}}>PNG mit transparentem Hintergrund verwenden, sonst wird die Linie überdeckt. Bleibt für alle weiteren Verträge gespeichert.</div>
            </div>
          </div>
          <div style={{flex:1,overflowY:"auto",background:"#b0b0b0",padding:20}}>
            <div style={{fontSize:10,color:"#555",textAlign:"center",marginBottom:12,textTransform:"uppercase",letterSpacing:".06em"}}>Vorschau A4</div>
            <div style={{width:794,margin:"0 auto",boxShadow:"0 4px 20px rgba(0,0,0,0.35)"}}>
              <iframe
                id="vertrag-print-frame"
                key={name+datum+uhrzeit+shootingOrt+bilder+einzelpreis+preisProBild+preisZusatztier+zusatzAnz+zusatz+kmGesamt+fahrtkosten+gesamtpreis+ortDatum+sigKunde+sigFotograf+sigHoehe+sigOffset+vertragLogo.slice(0,64)+JSON.stringify(tiere)+email+telefon+adresse+plz+ort2}
                srcDoc={buildHtml()}
                style={{width:"794px",height:"4200px",border:"none",display:"block"}}
                title="Vertrag Vorschau"
              />
            </div>
          </div>
        </div>
      </div>

      {sendOffen&&(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.55)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:400}}
             onMouseDown={e=>{if(e.target===e.currentTarget)setSendOffen(false);}}>
          <div style={{background:T.surface,borderRadius:14,border:`1px solid ${T.border}`,width:"min(560px,94vw)",maxHeight:"90vh",overflowY:"auto",padding:22}}>
            <div style={{fontFamily:"Georgia,serif",fontSize:17,color:T.accent,marginBottom:4}}>Vertrag zum Unterschreiben senden</div>
            <div style={{fontSize:12,color:T.muted,lineHeight:1.6,marginBottom:16}}>
              Der Kunde bekommt einen Link und sieht den Vertrag genau so, wie er hier in der Vorschau steht. Deine Unterschrift ist bereits drauf.
            </div>

            {letzter&&(
              <div style={{background:T.bg,border:`1px solid ${unterschrieben?T.success:T.border}`,borderRadius:8,
                           padding:"11px 13px",marginBottom:16,fontSize:12,lineHeight:1.7,color:T.text}}>
                <div style={{display:"flex",alignItems:"center",gap:7,fontWeight:600,
                             color:T.success,marginBottom:4}}>
                  <span style={{fontSize:15}}>✓</span>
                  <span>{unterschrieben
                    ?"Am "+dtKurz(letzterStatus.signiertAm)+" unterschrieben"
                    :"Am "+dtKurz(letzter.datum)+" gesendet"}</span>
                </div>
                <div style={{color:T.muted}}>
                  An {letzter.an}
                  {ueberholt&&" · durch einen neueren Vertrag ersetzt"}
                  {!unterschrieben&&letzterStatus&&letzterStatus.aufrufe>0&&
                    " · "+letzterStatus.aufrufe+"× geöffnet"}
                  {!unterschrieben&&letzterStatus&&!letzterStatus.aufrufe&&
                    " · noch nicht geöffnet"}
                  {versand.length>1&&" · "+versand.length+" Sendungen insgesamt"}
                </div>
                {letzter.link&&(
                  <div style={{marginTop:6,wordBreak:"break-all"}}>
                    <a href={letzter.link} target="_blank" rel="noopener noreferrer"
                       style={{color:T.accent,fontSize:11}}>{letzter.link}</a>
                  </div>
                )}
                {unterschrieben&&(
                  <div style={{marginTop:8,color:T.muted,fontSize:11}}>
                    Das unterschriebene PDF liegt in deinem Postfach. Ein erneuter Versand legt einen neuen Vertrag an.
                  </div>
                )}
              </div>
            )}

            <div style={{marginBottom:12}}>
              <Lbl>E-Mail-Adresse des Kunden</Lbl>
              <input style={{...IS3,width:"100%"}} value={sendMail} onChange={e=>setSendMail(e.target.value)} placeholder="kunde@beispiel.de"/>
            </div>
            <div style={{marginBottom:12}}>
              <Lbl>Unterschriebenes PDF an mich schicken an</Lbl>
              <input style={{...IS3,width:"100%"}} value={sendKopie}
                     onChange={e=>setSendKopie(e.target.value)}
                     placeholder="leer lassen = an die Absenderadresse"/>
              <div style={{fontSize:10,color:T.muted,marginTop:3,lineHeight:1.5}}>
                Bleibt für die nächsten Verträge gespeichert. Der Kunde bekommt das PDF ohnehin an seine eigene Adresse.
              </div>
            </div>

            <div style={{marginBottom:12}}>
              <Lbl>Betreff</Lbl>
              <input style={{...IS3,width:"100%"}} value={sendBetreff} onChange={e=>setSendBetreff(e.target.value)}/>
            </div>
            <div style={{marginBottom:8}}>
              <Lbl>Text</Lbl>
              <textarea style={{...IS3,width:"100%",minHeight:150,resize:"vertical",lineHeight:1.6}}
                        value={sendText} onChange={e=>setSendText(e.target.value)}/>
            </div>
            <div style={{fontSize:10,color:T.muted,marginBottom:16,lineHeight:1.5}}>
              Betreff und Text kommen aus der Vorlage <strong>Vertragsmail</strong> unter Einstellungen → E-Mail-Vorlagen. Die Platzhalter sind hier schon eingesetzt. Änderungen gelten nur für diesen einen Versand. {"{link}"} füllt der Server beim Absenden; fehlt er, wird der Link unten angehängt.
            </div>

            {!sigFotograf&&(
              <div style={{fontSize:12,color:T.warning,background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:"10px 12px",marginBottom:14,lineHeight:1.5}}>
                Deine eigene Unterschrift fehlt. Trag sie links unter „Fotograf“ ein, bevor der Vertrag rausgeht.
              </div>
            )}

            {sendMsg&&(
              <div style={{fontSize:12,marginBottom:14,lineHeight:1.6,
                           color:sendState==="ok"?T.success:T.danger}}>
                {sendMsg}
                {sendLink&&(
                  <div style={{marginTop:8,wordBreak:"break-all"}}>
                    <a href={sendLink} target="_blank" rel="noopener noreferrer" style={{color:T.accent}}>{sendLink}</a>
                  </div>
                )}
              </div>
            )}

            <div style={{display:"flex",justifyContent:"flex-end",gap:8}}>
              <button onClick={()=>setSendOffen(false)}
                      style={{background:"none",border:`1px solid ${T.border}`,borderRadius:8,padding:"8px 14px",fontSize:12,cursor:"pointer",color:T.text}}>
                {sendState==="ok"?"Fertig":"Abbrechen"}
              </button>
              <button onClick={vertragSenden} disabled={sendState==="senden"}
                      style={{background:T.accent,color:"#fff",border:"none",borderRadius:8,padding:"8px 18px",fontSize:12,fontWeight:600,
                              cursor:sendState==="senden"?"default":"pointer",opacity:sendState==="senden"?0.6:1}}>
                {sendState==="senden"?"Wird gesendet…":sendState==="ok"?"Erneut senden":"Senden"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ── App Shell ─────────────────────────────────────────────────────────────────

// ── Statistik Module ─────────────────────────────────────────────────────────

// ── Statistik Module ─────────────────────────────────────────────────────────
const ALTERS=["unter 1","0,5","1","1,5","2","2,5","3","4","5","6","7","8","8,5","9","10","11","12","13","14","15","16","17","18","19","20"];
const COLORS=["#C9A96E","#6A9BC3","#6DBF6A","#D4A84B","#C0655A","#9B7AC3","#4BBDB5","#C36A8A","#A0C878","#C3906A","#6AB5C3","#C3C36A"];
// Rassenfeld mit echten Vorschlaegen: filtert ab dem ersten Buchstaben.
// Ersetzt das native <datalist>, das je nach Browser die komplette Liste zeigt.
function RasseFeld({liste=[],val="",onChange,placeholder,style}){
  const [offen,setOffen]=useState(false);
  const [aktiv,setAktiv]=useState(-1);
  const such=String(val||"").trim().toLowerCase();
  const treffer=such
    ?liste.filter(r=>String(r||"").toLowerCase().includes(such))
          .sort((a,b)=>{
            const av=String(a).toLowerCase().startsWith(such)?0:1;
            const bv=String(b).toLowerCase().startsWith(such)?0:1;
            return av-bv||String(a).localeCompare(String(b),"de");
          }).slice(0,8)
    :[];
  const exakt=treffer.length===1&&String(treffer[0]).toLowerCase()===such;
  const zeigen=offen&&treffer.length>0&&!exakt;
  const waehlen=r=>{onChange(r);setOffen(false);setAktiv(-1);};
  return(
    <div style={{position:"relative"}}>
      <input type="text" value={val} placeholder={placeholder} style={style}
        autoComplete="off"
        onChange={e=>{onChange(e.target.value);setOffen(true);setAktiv(-1);}}
        onFocus={()=>setOffen(true)}
        onBlur={()=>setTimeout(()=>setOffen(false),150)}
        onKeyDown={e=>{
          if(!zeigen)return;
          if(e.key==="ArrowDown"){e.preventDefault();setAktiv(i=>Math.min(i+1,treffer.length-1));}
          else if(e.key==="ArrowUp"){e.preventDefault();setAktiv(i=>Math.max(i-1,0));}
          else if(e.key==="Enter"&&aktiv>=0){e.preventDefault();waehlen(treffer[aktiv]);}
          else if(e.key==="Escape"){setOffen(false);}
        }}/>
      {zeigen&&(
        <div style={{position:"absolute",top:"100%",left:0,right:0,zIndex:40,background:"#fff",
                     border:"1px solid #e0ddd8",borderRadius:8,marginTop:2,overflow:"hidden",
                     boxShadow:"0 6px 18px rgba(0,0,0,0.10)",maxHeight:240,overflowY:"auto"}}>
          {treffer.map((r,i)=>(
            <div key={r} onMouseDown={e=>{e.preventDefault();waehlen(r);}}
                 onMouseEnter={()=>setAktiv(i)}
                 style={{padding:"8px 10px",fontSize:13,cursor:"pointer",
                         background:i===aktiv?"#f0ece4":"transparent",color:"#1a1814"}}>{r}</div>
          ))}
        </div>
      )}
    </div>
  );
}

const DEFAULT_RASSEN=["Golden Retriever","Labrador","Beagle","Mischling","Französische Bulldogge","Kurzhaar Collie","Dackel","Husky","Border Collie","Pudel","Schäferhund","Boxer","Dobermann","Rottweiler","Chihuahua","Malteser","Yorkshire Terrier","Spitz","Dalmatiner","Setter","Shih Tzu","Cavalier King Charles","Berner Sennenhund","Australischer Shepherd","Jack Russell","Corgi","Bulldogge","Weimaraner","Ridgeback","Samoyed"];
function newProfile(name="Neues Profil",tierart="Tier"){return{id:uid(),name,tierart,tierLabel:"Rasse",shootingTypes:[{id:uid(),name:"Underglass",aktiv:true},{id:uid(),name:"Studio",aktiv:true},{id:uid(),name:"Veranstaltung",aktiv:true},{id:uid(),name:"Sonstiges",aktiv:true}],geschlechter:[{id:uid(),name:"Hündin",aktiv:true},{id:uid(),name:"Rüde",aktiv:true}],felder:{rasse:{label:"Rasse",aktiv:true},geschlecht:{label:"Geschlecht",aktiv:true},alter:{label:"Alter",aktiv:true},shooting:{label:"Shooting",aktiv:true}},rassen:[...DEFAULT_RASSEN],eintraege:[]};}
const SEED_PROFILE=newProfile("Hunde","Hund");
const inpStyle=T=>({background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:"9px 12px",color:T.text,fontSize:13,fontFamily:"inherit",outline:"none",boxSizing:"border-box",width:"100%"});
function countBy(arr,key){const m={};arr.forEach(h=>{let v=h[key]||"Unbekannt";if(key==="alter"&&v!=="Unbekannt"&&/^[0-9]+(,[0-9]+)?$/.test(v.trim()))v=v.trim()+" J";m[v]=(m[v]||0)+1;});return Object.entries(m).map(([label,value])=>({label,value})).sort((a,b)=>b.value-a.value);}
// Jahre- und Monatsfeld zu einem Wert zusammenfassen, den die Statistik einordnen kann.
// Ohne das landet ein Welpe mit 0 Jahren / 4 Monaten im Balken "0 J".
function alterAusJahrenUndMonaten(jahre,monate){
  const j=parseFloat(String(jahre??"").replace(",","."))||0;
  const m=parseFloat(String(monate??"").replace(",","."))||0;
  if(!j&&!m)return "";
  // Unter einem Jahr in Monaten ausweisen - bei Welpen ist der Monat die relevante Einheit.
  if(j<1&&m>0&&j+m/12<1)return Math.round(m)+" M";
  // Ab einem Jahr immer das volle Jahr, angefangene Jahre werden abgeschnitten.
  // 1 Jahr 8 Monate ist damit "1 J", nicht "1,5 J". countBy haengt " J" an.
  return String(Math.floor(j+m/12));
}
// Sortierindex fuer Altersbalken. countBy haengt an reine Zahlen " J" an,
// deshalb muss das vor dem Nachschlagen in ALTERS wieder abgeschnitten werden.
function alterSortIndex(label){
  const s=String(label||"").trim();
  // Monatsangaben zuerst, aufsteigend, danach die Jahresskala.
  const mm=s.match(/^([0-9]+)\s*M$/i);
  if(mm)return -100+parseInt(mm[1],10);
  const j=s.replace(/\s*J$/i,"").trim();
  const i=ALTERS.indexOf(j);
  if(i>=0)return i;
  // Jahreswerte ausserhalb der Skala trotzdem numerisch einsortieren
  const n=parseFloat(j.replace(",","."));
  return isNaN(n)?999:900+n;
}
function normalizeAlter(val){if(!val||val==="")return"?";const s=String(val).trim().replace(".",",");if(ALTERS.includes(s))return s;const n=parseFloat(s.replace(",","."));if(isNaN(n))return s;let best=ALTERS[0],bestDiff=Infinity;ALTERS.forEach(a=>{const d=Math.abs(parseFloat(a.replace(",","."))-n);if(d<bestDiff){bestDiff=d;best=a;}});return best;}

function PieChart({data,dark}){
  const total=data.reduce((s,d)=>s+d.value,0);
  if(!total)return <p style={{color:"#7A7570",fontSize:12,padding:8}}>Keine Daten</p>;
  let cum=-90;
  const cx=90,cy=90,r=72,ir=42;
  const slices=data.map((d,i)=>{
    const angle=(d.value/total)*360,s=cum;cum+=angle;
    const rad=a=>(a*Math.PI)/180;
    const x1=cx+r*Math.cos(rad(s)),y1=cy+r*Math.sin(rad(s));
    const x2=cx+r*Math.cos(rad(s+angle)),y2=cy+r*Math.sin(rad(s+angle));
    const xi1=cx+ir*Math.cos(rad(s)),yi1=cy+ir*Math.sin(rad(s));
    const xi2=cx+ir*Math.cos(rad(s+angle)),yi2=cy+ir*Math.sin(rad(s+angle));
    const lg=angle>180?1:0;
    return{...d,color:COLORS[i%COLORS.length],pct:Math.round((d.value/total)*100),
      path:`M${xi1} ${yi1} L${x1} ${y1} A${r} ${r} 0 ${lg} 1 ${x2} ${y2} L${xi2} ${yi2} A${ir} ${ir} 0 ${lg} 0 ${xi1} ${yi1}Z`};
  });
  const tc=dark?"#F0EBE3":"#1A1814",mc=dark?"#7A7570":"#8A8075";
  return(
    <div>
      <svg width={180} height={180} style={{display:"block",margin:"0 auto 10px"}}>
        {slices.map((s,i)=><path key={i} d={s.path} fill={s.color} opacity={0.9}/>)}
        <text x={cx} y={cy-7} textAnchor="middle" fontSize="9" fill={mc}>Gesamt</text>
        <text x={cx} y={cy+9} textAnchor="middle" fontSize="16" fontWeight="700" fill={tc}>{total}</text>
      </svg>
      <div style={{display:"flex",flexDirection:"column",gap:4}}>
        {slices.map((s,i)=>(
          <div key={i} style={{display:"flex",alignItems:"center",gap:6}}>
            <div style={{width:9,height:9,borderRadius:2,background:s.color,flexShrink:0}}/>
            <span style={{fontSize:11,color:mc,flex:1,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}} title={s.label}>{s.label}</span>
            <span style={{fontSize:11,fontWeight:600,color:tc,flexShrink:0}}>{s.value}</span>
            <span style={{fontSize:10,color:mc,flexShrink:0}}>({s.pct}%)</span>
          </div>
        ))}
      </div>
    </div>
  );
}

// ── Chart Block ───────────────────────────────────────────────────────────────
// ── PDFModal ─────────────────────────────────────────────────────────────────
function PDFModal({eintraege,charts,profile,onClose,T}){
  const [selected,setSelected]=useState(()=>new Set());
  const [viewMap,setViewMap]=useState({});
  const [limitMap,setLimitMap]=useState({});
  const [includeList,setIncludeList]=useState(false);
  const [printing,setPrinting]=useState(false);

  function toggle(id){setSelected(s=>{const n=new Set(s);n.has(id)?n.delete(id):n.add(id);return n;});}
  function getView(id){return viewMap[id]||"bar";}
  function getLimit(id){return limitMap[id]||null;}
  function setView(id,v){setViewMap(m=>({...m,[id]:v}));}
  function setLimit(id,l){setLimitMap(m=>({...m,[id]:m[id]===l?null:l}));}

  const PCOLS=["#C9A96E","#6A9BC3","#6DBF6A","#D4A84B","#C0655A","#9B7AC3","#4BBDB5","#C36A8A","#A0C878","#C3906A","#6AB5C3","#C3C36A"];

  function barSVG(data,title){
    const W=520,ROW=22,PAD=4,LBLW=160,BARW=260;
    const total=data.reduce((s,d)=>s+d.value,0)||1;
    const max=Math.max(...data.map(d=>d.value),1);
    const H=data.length*ROW+40;
    const rows=data.map((d,i)=>{
      const bw=Math.round((d.value/max)*BARW);
      const pct=Math.round((d.value/total)*100);
      return `<g transform="translate(0,${i*ROW+30})">
        <text x="${LBLW-4}" y="15" text-anchor="end" font-size="10" fill="#555" font-family="Arial">${d.label}</text>
        <rect x="${LBLW}" y="4" width="${bw}" height="14" rx="3" fill="${PCOLS[i%PCOLS.length]}"/>
        <text x="${LBLW+bw+6}" y="15" font-size="10" fill="#333" font-weight="600" font-family="Arial">${d.value} (${pct}%)</text>
      </g>`;
    }).join('');
    return `<svg width="${W}" height="${H}" xmlns="http://www.w3.org/2000/svg">
      <text x="10" y="18" font-size="13" font-weight="700" fill="#b8952a" font-family="Georgia,serif">${title}</text>
      <g transform="translate(0,28)">${rows}</g></svg>`;
  }

  function pieSVG(data,title){
    const W=520,CX=160,CY=170,R=120;
    const total=data.reduce((s,d)=>s+d.value,0)||1;
    let angle=-Math.PI/2;
    const slices=data.map((d,i)=>{
      const a=(d.value/total)*2*Math.PI;
      const x1=CX+R*Math.cos(angle),y1=CY+R*Math.sin(angle);
      angle+=a;
      const x2=CX+R*Math.cos(angle),y2=CY+R*Math.sin(angle);
      const large=a>Math.PI?1:0;
      const pct=Math.round((d.value/total)*100);
      const mid=angle-a/2;
      const lx=CX+(R+28)*Math.cos(mid),ly=CY+(R+28)*Math.sin(mid);
      return `<path d="M${CX},${CY} L${x1},${y1} A${R},${R} 0 ${large},1 ${x2},${y2} Z" fill="${PCOLS[i%PCOLS.length]}" stroke="white" stroke-width="1.5"/>
        ${pct>=3?`<text x="${lx}" y="${ly}" text-anchor="middle" font-size="9" fill="#333" font-family="Arial">${pct}%</text>`:''}`;
    }).join('');
    const legend=data.slice(0,20).map((d,i)=>`<g transform="translate(${320+Math.floor(i/10)*95},${40+(i%10)*18})">
      <rect width="12" height="12" fill="${PCOLS[i%PCOLS.length]}" rx="2"/>
      <text x="16" y="10" font-size="10" fill="#333" font-family="Arial">${d.label} (${d.value})</text></g>`).join('');
    return `<svg width="${W}" height="320" xmlns="http://www.w3.org/2000/svg">
      <text x="10" y="18" font-size="13" font-weight="700" fill="#b8952a" font-family="Georgia,serif">${title}</text>
      <g transform="translate(0,30)">${slices}${legend}</g></svg>`;
  }

  function doPrint(){
    setPrinting(true);
    const selCharts=charts.filter(c=>selected.has(c.id));
    const svgs=selCharts.map(c=>{
      const v=viewMap[c.id]||"bar";
      const lim=limitMap[c.id]||null;
      const sorted=[...c.data].sort((a,b)=>b.value-a.value);
      const data=lim?sorted.slice(0,lim):c.data;
      const limLabel=lim?` (Top ${lim})`:"";
      const fullTitle=`${profile.name} — ${c.title}${limLabel}`;
      const svg=v==="pie"?pieSVG(data,fullTitle):barSVG(data,fullTitle);
      return `<div style="break-inside:avoid;margin-bottom:16px">${svg}</div>`;
    }).join('');
    const listHtml=includeList?`<div style="break-before:page;margin-top:20px">
      <h3 style="font-size:13px;margin-bottom:8px;font-family:Georgia,serif;color:#b8952a">Alle Einträge (${eintraege.length})</h3>
      <table style="width:100%;border-collapse:collapse;font-size:10px">
        <thead><tr style="background:#f5f0ea">${['Rasse','Geschlecht','Alter','Shooting'].map(h=>`<th style="padding:4px 8px;text-align:left;border-bottom:2px solid #b8952a">${h}</th>`).join('')}</tr></thead>
        <tbody>${eintraege.map((e,i)=>`<tr style="background:${i%2?'#faf8f5':'white'}">${[e.rasse||'',e.geschlecht||'',e.alter||'',e.shootingTyp||''].map(v=>`<td style="padding:3px 8px;border-bottom:1px solid #eee">${v}</td>`).join('')}</tr>`).join('')}</tbody>
      </table></div>`:'';
    const html=`<!DOCTYPE html><html><head><title>Statistik ${profile.name}</title>
      <style>body{font-family:Arial,sans-serif;margin:20px;color:#333}@page{margin:15mm}@media print{body{margin:0}}</style>
      </head><body>
      <h2 style="font-family:Georgia,serif;color:#b8952a;margin-bottom:2px;font-size:22px">${profile.name} — Statistik</h2>
      <p style="font-size:12px;color:#888;margin-bottom:32px">${eintraege.length} Einträge · ${new Date().toLocaleDateString('de-DE')}</p>
      <div style="display:grid;grid-template-columns:1fr 1fr;gap:24px">${svgs}</div>
      ${listHtml}</body></html>`;
    const w=window.open('','_blank');
    w.document.write(html);w.document.close();
    setTimeout(()=>{w.print();setPrinting(false);},600);
  }

  return(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.7)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:200,padding:20}}>
      <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:14,padding:24,width:"100%",maxWidth:520,maxHeight:"85vh",overflowY:"auto",display:"flex",flexDirection:"column",gap:12}}>
        <div style={{fontFamily:"Georgia,serif",fontSize:18,color:T.accent}}>📄 PDF Export</div>
        <div style={{fontSize:12,color:T.muted}}>Wähle Grafiken und Darstellungsart:</div>
        <div style={{display:"flex",flexDirection:"column",gap:6}}>
          {charts.map(c=>(
            <div key={c.id} style={{display:"flex",alignItems:"center",gap:8,padding:"8px 10px",border:`1px solid ${selected.has(c.id)?T.accent+"55":T.border}`,borderRadius:8,background:selected.has(c.id)?T.accentDim:"transparent"}}>
              <input type="checkbox" checked={selected.has(c.id)} onChange={()=>toggle(c.id)} style={{accentColor:T.accent,width:14,height:14,flexShrink:0}}/>
              <span style={{fontSize:12,color:T.text,flex:1}}>{c.title}</span>
              <div style={{display:"flex",gap:3}}>
                {[["bar","▬"],["pie","◉"]].map(([v,l])=>(
                  <button key={v} onClick={()=>setView(c.id,v)}
                    style={{padding:"2px 8px",fontSize:11,borderRadius:5,border:`1px solid ${getView(c.id)===v?T.accent:T.border}`,background:getView(c.id)===v?T.accentDim:"none",cursor:"pointer",color:getView(c.id)===v?T.accent:T.muted}}>
                    {l}
                  </button>
                ))}
                <div style={{width:1,background:T.border,margin:"0 2px"}}/>
                {[[10,"T10"],[20,"T20"]].map(([l,lbl])=>(
                  <button key={l} onClick={()=>setLimit(c.id,l)}
                    style={{padding:"2px 8px",fontSize:11,borderRadius:5,border:`1px solid ${getLimit(c.id)===l?T.accent:T.border}`,background:getLimit(c.id)===l?T.accentDim:"none",cursor:"pointer",color:getLimit(c.id)===l?T.accent:T.muted}}>
                    {lbl}
                  </button>
                ))}
              </div>
            </div>
          ))}
        </div>
        <label style={{display:"flex",alignItems:"center",gap:8,fontSize:12,color:T.text,cursor:"pointer",padding:"8px 10px",border:`1px solid ${includeList?T.accent+"55":T.border}`,borderRadius:8,background:includeList?T.accentDim:"transparent"}}>
          <input type="checkbox" checked={includeList} onChange={e=>setIncludeList(e.target.checked)} style={{accentColor:T.accent}}/>
          Detailliste aller Einträge anhängen ({eintraege.length})
        </label>
        <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
          <button onClick={onClose} style={{background:"none",border:`1px solid ${T.border}`,borderRadius:8,padding:"8px 16px",fontSize:13,cursor:"pointer",color:T.text}}>Abbrechen</button>
          <button disabled={printing||selected.size===0} onClick={doPrint}
            style={{background:T.accent,color:"#fff",border:"none",borderRadius:8,padding:"8px 20px",fontSize:13,fontWeight:600,cursor:"pointer"}}>
            {printing?"Öffnet...":"📄 Drucken / PDF"}
          </button>
        </div>
      </div>
    </div>
  );
}

function ChartBlock({title,data,T,view,setView}){
  const [labelW,setLabelW]=useState(100);
  const startX=useRef(0),startW=useRef(100);
  function onMouseDown(e){
    e.preventDefault();startX.current=e.clientX;startW.current=labelW;
    const onMove=ev=>setLabelW(Math.max(60,Math.min(240,startW.current+(ev.clientX-startX.current))));
    const onUp=()=>{document.removeEventListener("mousemove",onMove);document.removeEventListener("mouseup",onUp);};
    document.addEventListener("mousemove",onMove);document.addEventListener("mouseup",onUp);
  }
  const max=Math.max(...data.map(d=>d.value),1);
  const total=data.reduce((s,d)=>s+d.value,0);
  return(
    <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:12,padding:14,marginBottom:12}}>
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:12}}>
        <div style={{fontFamily:"Georgia,serif",fontSize:13,color:T.accent}}>{title}</div>
        <div style={{display:"flex",gap:4,alignItems:"center"}}>
          <div onMouseDown={onMouseDown} title="Labelbreite ziehen — Namen vollständig anzeigen" style={{padding:"3px 7px",borderRadius:6,border:`1px solid ${T.border}`,cursor:"col-resize",display:"flex",alignItems:"center",color:T.accent,fontSize:13,userSelect:"none",marginRight:4,background:T.bg}}>⇔</div>
          <button style={btn(T,view==="bar"?"active":"ghost",true)} onClick={()=>setView("bar")} title="Balkendiagramm">▬</button>
          <button style={btn(T,view==="pie"?"active":"ghost",true)} onClick={()=>setView("pie")} title="Kreisdiagramm">◉</button>
          <button style={btn(T,view==="top10"?"active":"ghost",true)} onClick={()=>setView("top10")} title="Top 10">T10</button>
          <button style={btn(T,view==="top20"?"active":"ghost",true)} onClick={()=>setView("top20")} title="Top 20">T20</button>
        </div>
      </div>
      {view==="bar"?(
        <div style={{display:"flex",flexDirection:"column",gap:6}}>
          {data.map((d,i)=>(
            <div key={i} style={{display:"flex",alignItems:"center",gap:8}}>
              <div style={{width:labelW,fontSize:11,color:T.muted,textAlign:"right",flexShrink:0,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}} title={d.label}>{d.label}</div>
              <div style={{flex:1,height:18,background:T.border,borderRadius:3,overflow:"hidden"}}>
                <div style={{height:"100%",width:`${(d.value/max)*100}%`,background:COLORS[i%COLORS.length],borderRadius:3,minWidth:d.value>0?2:0}}/>
              </div>
              <div style={{width:60,fontSize:11,color:T.text,fontWeight:600,flexShrink:0}}>
                {d.value} <span style={{fontSize:10,color:T.muted,fontWeight:400}}>({total?Math.round((d.value/total)*100):0}%)</span>
              </div>
            </div>
          ))}
          {data.length===0&&<p style={{color:T.muted,fontSize:12}}>Keine Daten</p>}
        </div>
      ):view==="top10"||view==="top20"?(
        <div style={{display:"flex",flexDirection:"column",gap:4}}>
          {[...data].sort((a,b)=>b.value-a.value).slice(0,view==="top10"?10:20).map((d,i)=>{
            const maxTop=[...data].sort((a,b)=>b.value-a.value)[0]?.value||1;
            return(
              <div key={i} style={{display:"flex",alignItems:"center",gap:8}}>
                <div style={{width:24,fontSize:11,fontWeight:700,color:i<3?T.accent:T.muted,textAlign:"right",flexShrink:0}}>{i+1}.</div>
                <div style={{width:8,flexShrink:0}}/>
                <div style={{width:labelW,fontSize:11,color:T.text,flexShrink:0,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}} title={d.label}>{d.label}</div>
                <div style={{flex:1,height:16,background:T.border,borderRadius:3,overflow:"hidden"}}>
                  <div style={{height:"100%",width:`${(d.value/maxTop)*100}%`,background:i===0?T.accent:i===1?COLORS[1]:i===2?COLORS[2]:COLORS[i%COLORS.length],borderRadius:3}}/>
                </div>
                <div style={{width:50,fontSize:11,color:T.text,fontWeight:600,flexShrink:0,textAlign:"right"}}>{d.value}×</div>
              </div>
            );
          })}
          {data.length===0&&<p style={{color:T.muted,fontSize:12}}>Keine Daten</p>}
        </div>
      ):<PieChart data={data} dark={T===DARK}/>}
    </div>
  );
}

// ── Import Modal ──────────────────────────────────────────────────────────────
function ImportModal({profile,onImport,onClose,T}){
  const [preview,setPreview]=useState(null);
  const [error,setError]=useState("");
  const [defaultShoot,setDefaultShoot]=useState(profile.shootingTypes.find(s=>s.aktiv)?.name||"");
  const fileRef=useRef(null);

  function parseFile(e){
    const file=e.target.files[0];if(!file)return;
    const reader=new FileReader();
    reader.onload=ev=>{
      try{
        const data=JSON.parse(ev.target.result);
        if(!Array.isArray(data)){setError("❌ Muss ein JSON-Array sein.");return;}

        let mapped=[];

        // Format A: Array von Arrays [Rasse, Geschlecht, ShootingTyp, Alter, Anzahl]
        if(Array.isArray(data[0])){
          data.forEach(row=>{
            const [rasse,geschlecht,shootingTyp,alter,anzahl]=row;
            const n=Math.max(1,Number(anzahl)||1);
            for(let i=0;i<n;i++){
              mapped.push({
                id:uid(),
                rasse:(rasse||"Unbekannt").trim(),
                geschlecht:(geschlecht||"").trim(),
                alter:normalizeAlter(String(alter||"")),
                shootingTyp:(shootingTyp||defaultShoot||"").trim(),
              });
            }
          });
        } else {
          // Format B: Array von Objekten {hund/rasse, geschlecht, fotoart/shootingTyp, alter}
          const sample=data[0]||{};
          const isStatistik=sample.hasOwnProperty("hund")||sample.hasOwnProperty("fotoart")||sample.hasOwnProperty("geschlecht")||sample.hasOwnProperty("rasse");
          if(!isStatistik){setError("❌ Format nicht erkannt. Erwartet: {hund, alter, geschlecht, fotoart} oder [[Rasse, Geschlecht, ShootingTyp, Alter, Anzahl]]");return;}
          mapped=data.filter(r=>r.hund||r.rasse).map(r=>({
            id:uid(),
            rasse:(r.hund||r.rasse||"Unbekannt").trim(),
            geschlecht:(r.geschlecht||"").trim(),
            alter:normalizeAlter(r.alter),
            shootingTyp:(r.fotoart||r.shootingTyp||defaultShoot||"").trim(),
          }));
        }

        if(mapped.length===0){setError("❌ Keine gültigen Einträge gefunden.");return;}
        setError("");
        setPreview({data:mapped,count:mapped.length,source:file.name});
      } catch{setError("❌ Ungültige JSON-Datei.");}
    };
    reader.readAsText(file,"utf-8");
    e.target.value="";
  }

  function doImport(mode){
    if(!preview)return;
    // Wenn shootingTyp leer, Default setzen
    const final=preview.data.map(e=>({...e,shootingTyp:e.shootingTyp||defaultShoot}));
    onImport(final,mode);
    onClose();
  }

  const activeShootings=profile.shootingTypes.filter(s=>s.aktiv&&s.name);

  return(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.78)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:100,padding:20}}>
      <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:16,padding:28,width:"100%",maxWidth:520}}>
        <div style={{fontFamily:"Georgia,serif",fontSize:20,color:T.accent,marginBottom:6}}>Shootingplaner Import</div>
        <p style={{fontSize:13,color:T.muted,marginBottom:20}}>Importiere eine Statistik-JSON aus dem Veranstaltungsplan. Format: <code style={{background:T.bg,padding:"1px 5px",borderRadius:4,fontSize:12}}>{`{hund, alter, geschlecht, fotoart}`}</code></p>

        {/* Default Shooting-Typ */}
        <div style={{marginBottom:16}}>
          <label style={{fontSize:11,color:T.muted,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.07em",display:"block",marginBottom:6}}>Standard Shooting-Typ (falls nicht in Datei)</label>
          <select value={defaultShoot} onChange={e=>setDefaultShoot(e.target.value)} style={inpStyle(T)}>
            {activeShootings.map(s=><option key={s.id} value={s.name}>{s.name}</option>)}
          </select>
        </div>

        <button style={{...btn(T,"primary"),marginBottom:12,width:"100%",justifyContent:"center"}} onClick={()=>fileRef.current.click()}>
          📂 JSON-Datei wählen
        </button>
        <input ref={fileRef} type="file" accept=".json" onChange={parseFile} style={{display:"none"}}/>

        {error&&<div style={{background:T.danger+"22",border:`1px solid ${T.danger}44`,borderRadius:8,padding:"10px 14px",fontSize:13,color:T.danger,marginBottom:12}}>{error}</div>}

        {preview&&(
          <div style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:10,padding:14,marginBottom:16}}>
            <div style={{fontSize:12,fontWeight:600,color:T.success,marginBottom:8}}>✅ {preview.count} Einträge erkannt aus: {preview.source}</div>
            <div style={{maxHeight:160,overflowY:"auto"}}>
              {preview.data.slice(0,8).map((e,i)=>(
                <div key={i} style={{display:"flex",gap:10,fontSize:11,color:T.muted,padding:"3px 0",borderBottom:`1px solid ${T.border}22`}}>
                  <span style={{color:T.text,fontWeight:600,minWidth:130}}>{e.rasse}</span>
                  <span>{gSym(e.geschlecht,profile)}</span>
                  <span>{e.alter}{e.alter!=="unter 1"&&e.alter!=="?"?" J.":""}</span>
                  <span style={{color:T.accent}}>{e.shootingTyp}</span>
                </div>
              ))}
              {preview.data.length>8&&<div style={{fontSize:11,color:T.muted,paddingTop:4}}>... und {preview.data.length-8} weitere</div>}
            </div>
          </div>
        )}

        <div style={{display:"flex",justifyContent:"flex-end",gap:8}}>
          <button style={btn(T,"ghost")} onClick={onClose}>Abbrechen</button>
          {preview&&(
            <>
              <button style={btn(T,"ghost")} onClick={()=>doImport("add")} title="Bestehende Daten behalten, neue hinzufügen">+ Hinzufügen</button>
              <button style={btn(T,"primary")} onClick={()=>doImport("replace")} title="Alle bestehenden Daten ersetzen">↺ Ersetzen</button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

// ── Profil-Verwaltung Modal ───────────────────────────────────────────────────
function ProfilModal({profile,isNew,onSave,onClose,T}){
  const [p,setP]=useState(profile||newProfile());
  const up=(k,v)=>setP(x=>({...x,[k]:v}));
  function updateST(id,f,v){setP(x=>({...x,shootingTypes:x.shootingTypes.map(s=>s.id===id?{...s,[f]:v}:s)}));}
  function addST(){setP(x=>({...x,shootingTypes:[...x.shootingTypes,{id:uid(),name:"",aktiv:true}]}));}
  function removeST(id){setP(x=>({...x,shootingTypes:x.shootingTypes.filter(s=>s.id!==id)}));}
  function updateG(id,f,v){setP(x=>({...x,geschlechter:x.geschlechter.map(g=>g.id===id?{...g,[f]:v}:g)}));}
  function addG(){setP(x=>({...x,geschlechter:[...x.geschlechter,{id:uid(),name:"",aktiv:true}]}));}
  function removeG(id){setP(x=>({...x,geschlechter:x.geschlechter.filter(g=>g.id!==id)}));}
  function toggleF(k){setP(x=>({...x,felder:{...x.felder,[k]:{...x.felder[k],aktiv:!x.felder[k].aktiv}}}))}
  function labelF(k,v){setP(x=>({...x,felder:{...x.felder,[k]:{...x.felder[k],label:v}}}))}
  const [tab,setTab]=useState("allgemein");
  const TABS=[{id:"allgemein",l:"Allgemein"},{id:"shooting",l:"Shootings"},{id:"geschlecht",l:"Geschlecht"},{id:"felder",l:"Felder"}];
  const row={display:"flex",alignItems:"center",gap:10,marginBottom:8};
  const IS=inpStyle(T);
  return(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.78)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:100,padding:20}}>
      <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:16,padding:28,width:"100%",maxWidth:520,maxHeight:"88vh",display:"flex",flexDirection:"column"}}>
        <div style={{fontFamily:"Georgia,serif",fontSize:20,color:T.accent,marginBottom:16}}>{isNew?"Neues Profil":"Profil bearbeiten"}</div>
        <div style={{display:"flex",gap:6,marginBottom:20,flexWrap:"wrap"}}>
          {TABS.map(t=><button key={t.id} style={btn(T,tab===t.id?"active":"ghost",true)} onClick={()=>setTab(t.id)}>{t.l}</button>)}
        </div>
        <div style={{flex:1,overflowY:"auto"}}>
          {tab==="allgemein"&&(
            <div style={{display:"flex",flexDirection:"column",gap:12}}>
              <div>
                <label style={{fontSize:11,color:T.muted,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.07em",display:"block",marginBottom:5}}>Profilname *</label>
                <input value={p.name} onChange={e=>up("name",e.target.value)} placeholder="z.B. Hunde, Katzen..." style={IS}/>
                <label style={{display:"flex",alignItems:"center",gap:8,cursor:"pointer",fontSize:13,color:T.text,marginTop:10}}>
                  <input type="checkbox" checked={p.geschlechtSymbol||false} onChange={e=>up("geschlechtSymbol",e.target.checked)} style={{accentColor:T.accent}}/>
                  ♀/♂ Symbol statt Text anzeigen
                </label>
              </div>
              <div>
                <label style={{fontSize:11,color:T.muted,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.07em",display:"block",marginBottom:5}}>Tierart</label>
                <input value={p.tierart} onChange={e=>up("tierart",e.target.value)} placeholder="Hund, Katze, Vogel..." style={IS}/>
              </div>
              <div>
                <label style={{fontSize:11,color:T.muted,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.07em",display:"block",marginBottom:5}}>Bezeichnung für Rasse-Feld</label>
                <input value={p.tierLabel} onChange={e=>up("tierLabel",e.target.value)} placeholder="Rasse / Tierart / Kategorie" style={IS}/>
              </div>
            </div>
          )}
          {tab==="shooting"&&(
            <div>
              {p.shootingTypes.map(st=>(
                <div key={st.id} style={row}>
                  <input type="checkbox" checked={st.aktiv} onChange={e=>updateST(st.id,"aktiv",e.target.checked)} style={{accentColor:T.accent,width:16,height:16,flexShrink:0}}/>
                  <input value={st.name} onChange={e=>updateST(st.id,"name",e.target.value)} placeholder="Name..." style={{...IS,flex:1}}/>
                  <button style={btn(T,"danger",true)} onClick={()=>removeST(st.id)}>✕</button>
                </div>
              ))}
              <button style={{...btn(T,"ghost",true),marginTop:4}} onClick={addST}>+ Hinzufügen</button>
            </div>
          )}
          {tab==="geschlecht"&&(
            <div>
              {p.geschlechter.map(g=>(
                <div key={g.id} style={row}>
                  <input type="checkbox" checked={g.aktiv} onChange={e=>updateG(g.id,"aktiv",e.target.checked)} style={{accentColor:T.accent,width:16,height:16,flexShrink:0}}/>
                  <input value={g.name} onChange={e=>updateG(g.id,"name",e.target.value)} placeholder="z.B. Hündin, Kater, Weiblich..." style={{...IS,flex:1}}/>
                  <button style={btn(T,"danger",true)} onClick={()=>removeG(g.id)}>✕</button>
                </div>
              ))}
              <button style={{...btn(T,"ghost",true),marginTop:4}} onClick={addG}>+ Hinzufügen</button>
            </div>
          )}
          {tab==="felder"&&Object.entries(p.felder).map(([k,f])=>(
            <div key={k} style={{...row,opacity:f.aktiv?1:0.55}}>
              <input type="checkbox" checked={f.aktiv} onChange={()=>toggleF(k)} style={{accentColor:T.accent,width:16,height:16,flexShrink:0}}/>
              <input value={f.label} onChange={e=>labelF(k,e.target.value)} style={{...IS,flex:1}}/>
              <span style={{fontSize:11,color:T.muted,flexShrink:0,minWidth:60}}>({k})</span>
            </div>
          ))}
        </div>
        <div style={{display:"flex",justifyContent:"flex-end",gap:10,marginTop:16}}>
          <button style={btn(T,"ghost")} onClick={onClose}>Abbrechen</button>
          <button style={btn(T,"primary")} onClick={()=>{if(!p.name)return;onSave(p);}}>Speichern</button>
        </div>
      </div>
    </div>
  );
}

// ── Eingabe ───────────────────────────────────────────────────────────────────
function Eingabe({profile,onUpdate,T,charts=[],onEditProfil,onProfilSwitch}){
  const [showArtDropdown,setShowArtDropdown]=useState(false);
  const [showMerge,setShowMerge]=useState(false);
  const [showRassenEditor,setShowRassenEditor]=useState(false);
  const [form,setForm]=useState({rasse:"",neueRasse:"",geschlecht:"",alter:"1",shootingTyp:""});
  const [search,setSearch]=useState("");
  const [showDrop,setShowDrop]=useState(false);
  const [showRassenMgr,setShowRassenMgr]=useState(false);
  const [neuRasse,setNeuRasse]=useState("");
  const [showImport,setShowImport]=useState(false);
  const [showPDF,setShowPDF]=useState(false);
  const fileRef=useRef(null);
  const s=(k,v)=>setForm(f=>({...f,[k]:v}));

  const activeShootings=profile.shootingTypes.filter(st=>st.aktiv&&st.name);
  const activeGeschlechter=profile.geschlechter.filter(g=>g.aktiv&&g.name);
  const felder=profile.felder;

  useEffect(()=>{
    setForm(f=>({
      ...f,
      shootingTyp:f.shootingTyp||activeShootings[0]?.name||"",
      geschlecht:f.geschlecht||activeGeschlechter[0]?.name||"",
    }));
  },[profile.id]);

  const allRassen=[...new Set([...profile.rassen,...profile.eintraege.map(e=>e.rasse).filter(Boolean)])].sort();
  const filtered=allRassen.filter(r=>r.toLowerCase().includes(search.toLowerCase())&&search.length>0);
  const effectiveRasse=form.neueRasse.trim()||form.rasse;

  function save(){
    if(!effectiveRasse)return;
    const newRassen=form.neueRasse.trim()&&!profile.rassen.includes(form.neueRasse.trim())
      ?[...profile.rassen,form.neueRasse.trim()].sort():profile.rassen;
    onUpdate({
      ...profile,
      rassen:newRassen,
      eintraege:[...profile.eintraege,{id:uid(),rasse:effectiveRasse,geschlecht:form.geschlecht||activeGeschlechter[0]?.name||"",alter:form.alterEinheit==="Monate"?`${form.alter} M`:form.alter?`${form.alter} J`:"",shootingTyp:form.shootingTyp||activeShootings[0]?.name||""}],
    });
    setForm(f=>({...f,rasse:"",neueRasse:""}));setSearch("");
  }

  function addRasse(){
    const r=neuRasse.trim();if(!r||profile.rassen.includes(r))return;
    onUpdate({...profile,rassen:[...profile.rassen,r].sort()});setNeuRasse("");
  }

  function importRassenFile(e){
    const file=e.target.files[0];if(!file)return;
    const reader=new FileReader();
    reader.onload=ev=>{
      try{
        let names=[];
        if(file.name.endsWith(".txt"))names=ev.target.result.split(/\r?\n/).map(l=>l.trim()).filter(l=>l.length>0);
        else{const d=JSON.parse(ev.target.result);if(Array.isArray(d))d.forEach(item=>{if(typeof item==="string")names.push(item);else if(item.name)names.push(item.name);else if(item.rasse)names.push(item.rasse);});}
        const unique=[...new Set([...profile.rassen,...names.filter(n=>n)])].sort();
        onUpdate({...profile,rassen:unique});
        alert(`✅ ${names.length} Rassen importiert.`);
      }catch{alert("❌ Fehler beim Lesen.");}
    };
    reader.readAsText(file,"utf-8");e.target.value="";
  }

  function handleShootingImport(data,mode){
    const newEintraege=mode==="replace"?data:[...profile.eintraege,...data];
    // Neue Rassen aus Import zur Rasseliste hinzufügen
    const newRassen=[...new Set([...profile.rassen,...data.map(e=>e.rasse).filter(Boolean)])].sort();
    onUpdate({...profile,eintraege:newEintraege,rassen:newRassen});
  }

  const IS=inpStyle(T);
  const lbl={fontSize:10,color:T.muted,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.07em",display:"block",marginBottom:2};

  return(
    <>
      {/* Block 1: Tierdaten + Shooting + Hinzufügen */}
      <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:12,padding:"14px 18px",marginBottom:10}}>
        <div style={{fontSize:11,color:T.accent,fontWeight:600,marginBottom:12}}>Daten</div>
        <div style={{display:"flex",flexDirection:"column",gap:0}}>
        {/* Zeile 1: Felder */}
        <div style={{display:"flex",gap:32,alignItems:"flex-end",flexWrap:"nowrap",rowGap:12,marginBottom:30}}>
          {felder.rasse?.aktiv&&(
            <div style={{position:"relative",width:245,flexShrink:0}}>
              <label style={lbl}>{felder.rasse.label} suchen *</label>
              <input value={search} onChange={e=>{setSearch(e.target.value);s("rasse",e.target.value);setShowDrop(true);}}
                onFocus={()=>setShowDrop(true)} onBlur={()=>setTimeout(()=>setShowDrop(false),150)}
                placeholder="Tippen..." style={{...IS,padding:"8px 10px"}}/>
              {showDrop&&filtered.length>0&&(
                <div style={{position:"absolute",top:"calc(100% + 2px)",left:0,right:0,background:T.surface,border:`1px solid ${T.border}`,borderRadius:8,zIndex:50,maxHeight:180,overflowY:"auto",boxShadow:"0 6px 24px rgba(0,0,0,0.5)"}}>
                  {filtered.slice(0,10).map(r=>(
                    <div key={r} onClick={()=>{s("rasse",r);s("neueRasse","");setSearch(r);setShowDrop(false);}}
                      style={{padding:"8px 12px",cursor:"pointer",fontSize:13,color:T.text,borderBottom:`1px solid ${T.border}22`}}
                      onMouseEnter={e=>e.currentTarget.style.background=T.tileHover}
                      onMouseLeave={e=>e.currentTarget.style.background="transparent"}>{r}</div>
                  ))}
                </div>
              )}
            </div>
          )}
          {felder.rasse?.aktiv&&(
            <div style={{width:245,flexShrink:0}}>
              <label style={lbl}>Neue {felder.rasse.label}</label>
              <input value={form.neueRasse} onChange={e=>s("neueRasse",e.target.value)} placeholder="Nicht in Liste?" style={{...IS,padding:"8px 10px"}}/>
            </div>
          )}
          {felder.rasse?.aktiv&&(
            <div style={{flexShrink:0}}>
              <label style={{...lbl,color:"transparent"}}>.</label>
              <button style={{...btn(T,"ghost",true),padding:"8px 12px",fontSize:11,whiteSpace:"nowrap"}} onClick={()=>{
              const r=(form.neueRasse||"").trim();
              if(!r)return;
              if(!profile.rassen.includes(r))onUpdate({...profile,rassen:[...profile.rassen,r]});
              s("rasse",r);setSearch(r);s("neueRasse","");
            }}>+ Rasse hinzufügen</button>
            </div>
          )}
          <div style={{width:40,flexShrink:0}}/>
          {felder.geschlecht?.aktiv&&(
            <div style={{flexShrink:0}}>
              <label style={lbl}>{felder.geschlecht.label}</label>
              <div style={{display:"flex",gap:10,paddingTop:4}}>
                {activeGeschlechter.map(g=>(
                  <label key={g.id} style={{display:"flex",alignItems:"center",gap:5,cursor:"pointer",fontSize:13,color:form.geschlecht===g.name?T.accent:T.text,fontWeight:form.geschlecht===g.name?600:400}}>
                    <input type="radio" name={`gesc_${profile.id}`} checked={form.geschlecht===g.name} onChange={()=>s("geschlecht",g.name)} style={{accentColor:T.accent}}/>
                    {gSym(g.name,profile)||g.name}
                  </label>
                ))}
              </div>
            </div>
          )}
          <div style={{width:40,flexShrink:0}}/>
          {felder.alter?.aktiv&&(
            <div style={{flexShrink:0}}>
              <label style={lbl}>{felder.alter.label}</label>
              <div style={{display:"flex",gap:4,alignItems:"center"}}>
                <input type="text" value={form.alter} onChange={e=>s("alter",e.target.value)} placeholder="1,5" style={{...IS,padding:"8px 6px",textAlign:"center",width:50}}/>
                <select value={form.alterEinheit||"Jahre"} onChange={e=>s("alterEinheit",e.target.value)} style={{...IS,padding:"8px 10px",fontSize:13}}>
                  <option value="Jahre">Jahre</option>
                  <option value="Monate">Monate</option>
                </select>
              </div>
            </div>
          )}
          <div style={{width:40,flexShrink:0}}/>
          {felder.shooting?.aktiv&&(
            <div style={{width:160,flexShrink:0}}>
              <label style={lbl}>{felder.shooting.label}</label>
              <select value={form.shootingTyp} onChange={e=>s("shootingTyp",e.target.value)} style={{...IS,padding:"8px 10px"}}>
                {activeShootings.map(st=><option key={st.id} value={st.name}>{st.name}</option>)}
              </select>
            </div>
          )}
          <button style={{...btn(T,"primary"),padding:"8px 16px",alignSelf:"flex-end",flexShrink:0,whiteSpace:"nowrap",fontSize:12}} onClick={save}>+ zur Statistik</button>
        </div>
        {/* Zeile 2: Kacheln */}
        <div style={{display:"flex",gap:10}}>
          {[
            {icon:"📥",label:"Import",type:"btn",onClick:()=>setShowImport(true)},
            {icon:"📄",label:"PDF",type:"btn",onClick:()=>setShowPDF(true)},
          ].map(t=>(
            <button key={t.label} onClick={t.onClick} style={{width:100,height:100,display:"flex",flexDirection:"column",gap:6,alignItems:"center",justifyContent:"center",background:T.surface,border:`1px solid ${T.border}`,borderRadius:10,cursor:"pointer",flexShrink:0,fontFamily:"inherit"}}>
              <span style={{fontSize:28,lineHeight:1}}>{t.icon}</span>
              <span style={{fontSize:10,fontWeight:600,color:T.text}}>{t.label}</span>
            </button>
          ))}
          <button onClick={()=>setShowRassenEditor(true)} style={{width:100,height:100,display:"flex",flexDirection:"column",gap:6,alignItems:"center",justifyContent:"center",background:T.surface,border:`1px solid ${T.border}`,borderRadius:10,cursor:"pointer",flexShrink:0,fontFamily:"inherit"}}>
            <span style={{fontSize:28,lineHeight:1}}>🏷️</span>
            <span style={{fontSize:10,fontWeight:600,color:T.text,textAlign:"center"}}>Rassen bearbeiten</span>
          </button>
          <button onClick={()=>setShowMerge(true)} style={{width:100,height:100,display:"flex",flexDirection:"column",gap:4,alignItems:"center",justifyContent:"center",background:T.surface,border:`1px solid ${T.border}`,borderRadius:10,cursor:"pointer",flexShrink:0,fontFamily:"inherit"}}>
            <span style={{fontSize:28,lineHeight:1}}>🔀</span>
            <span style={{fontSize:10,fontWeight:600,color:T.text,textAlign:"center"}}>Zusammen-</span>
            <span style={{fontSize:10,fontWeight:600,color:T.text,textAlign:"center"}}>führen</span>
          </button>
          <div style={{flex:1}}/>
          <div style={{position:"relative",width:100,height:100,flexShrink:0}}>
            <button onClick={()=>setShowArtDropdown(v=>!v)} style={{width:"100%",height:"100%",display:"flex",flexDirection:"column",gap:6,alignItems:"center",justifyContent:"center",background:T.accentDim,border:`1px solid ${T.accent+"55"}`,borderRadius:10,cursor:"pointer",fontFamily:"inherit"}}>
              <span style={{fontSize:22,lineHeight:1}}>🐾</span>
              <span style={{fontSize:10,fontWeight:700,color:T.accent}}>{profile.name}</span>
              <span style={{fontSize:10,color:T.accent}}>▼</span>
            </button>
            {showArtDropdown&&onProfilSwitch&&(
              <div style={{position:"absolute",bottom:"calc(100% + 6px)",right:0,background:T.surface,border:`1px solid ${T.border}`,borderRadius:10,zIndex:100,boxShadow:"0 8px 24px rgba(0,0,0,0.3)",minWidth:160,overflow:"hidden"}}>
                {onProfilSwitch.profiles.map(p=>(
                  <div key={p.id} onClick={()=>{onProfilSwitch.set(p.id);setShowArtDropdown(false);}}
                    style={{padding:"10px 14px",fontSize:13,cursor:"pointer",fontWeight:p.id===profile.id?700:400,color:p.id===profile.id?T.accent:T.text,background:p.id===profile.id?T.accentDim:"transparent"}}
                    onMouseEnter={e=>e.currentTarget.style.background=T.bg}
                    onMouseLeave={e=>e.currentTarget.style.background=p.id===profile.id?T.accentDim:"transparent"}>
                    {p.name}
                  </div>
                ))}
                {onProfilSwitch.onNew&&<div onClick={()=>{onProfilSwitch.onNew();setShowArtDropdown(false);}} style={{padding:"10px 14px",fontSize:13,cursor:"pointer",color:T.accent,borderTop:"1px solid #ccc",fontWeight:600}}>+ Neues Profil</div>}
              </div>
            )}
            {showArtDropdown&&<div style={{position:"fixed",inset:0,zIndex:99}} onClick={()=>setShowArtDropdown(false)}/>}
          </div>
          <button onClick={()=>onEditProfil&&onEditProfil()} style={{width:100,height:100,display:"flex",flexDirection:"column",gap:6,alignItems:"center",justifyContent:"center",background:T.surface,border:`1px solid ${T.border}`,borderRadius:10,cursor:"pointer",flexShrink:0,fontFamily:"inherit"}}>
            <span style={{fontSize:28,lineHeight:1}}>⚙️</span>
            <span style={{fontSize:10,fontWeight:600,color:T.text}}>Einstellungen</span>
          </button>
        </div>
        </div>
      </div>

      {showImport&&<ImportModal profile={profile} onImport={handleShootingImport} onClose={()=>setShowImport(false)} T={T}/>}
      {showPDF&&<PDFModal eintraege={profile.eintraege||[]} charts={charts} profile={profile} onClose={()=>setShowPDF(false)} T={T}/>}

    {showMerge&&<MergeModal profile={profile} onUpdate={onUpdate} onClose={()=>setShowMerge(false)} T={T}/>}
    {showRassenEditor&&<RassenEditorModal profile={profile} onUpdate={onUpdate} onClose={()=>setShowRassenEditor(false)} T={T} btn={btn}/>}
    </>
  );
}

function MergeModal({profile,onUpdate,onClose,T}){
  const rassen=[...new Set(profile.eintraege.map(e=>e.rasse).filter(Boolean))].sort();
  const [von,setVon]=useState("");
  const [nach,setNach]=useState("");
  function merge(){
    if(!von||!nach||von===nach)return;
    const count=profile.eintraege.filter(e=>e.rasse===von).length;
    if(!confirm(`${count} Einträge von "${von}" nach "${nach}" umbenennen?`))return;
    onUpdate({...profile,
      eintraege:profile.eintraege.map(e=>e.rasse===von?{...e,rasse:nach}:e),
      rassen:profile.rassen.filter(r=>r!==von)
    });
    onClose();
  }
  return(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.7)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:200,padding:20}}>
      <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:14,padding:24,width:"100%",maxWidth:420,display:"flex",flexDirection:"column",gap:14}}>
        <div style={{fontFamily:"Georgia,serif",fontSize:18,color:T.accent}}>🔀 Rassen zusammenführen</div>
        <div style={{fontSize:13,color:T.muted}}>Alle Einträge der Quell-Rasse werden zur Ziel-Rasse umbenannt.</div>
        <div>
          <div style={{fontSize:11,fontWeight:700,color:T.muted,marginBottom:4,textTransform:"uppercase"}}>Von (Quelle)</div>
          <select value={von} onChange={e=>setVon(e.target.value)} style={{width:"100%",padding:"9px 10px",border:`1px solid ${T.border}`,borderRadius:8,fontSize:13,background:T.bg,color:T.text,fontFamily:"inherit"}}>
            <option value="">{"—"} Rasse wählen {"—"}</option>
            {rassen.map(r=><option key={r} value={r}>{r} ({profile.eintraege.filter(e=>e.rasse===r).length}×)</option>)}
          </select>
        </div>
        <div>
          <div style={{fontSize:11,fontWeight:700,color:T.muted,marginBottom:4,textTransform:"uppercase"}}>Nach (Ziel)</div>
          <select value={nach} onChange={e=>setNach(e.target.value)} style={{width:"100%",padding:"9px 10px",border:`1px solid ${T.border}`,borderRadius:8,fontSize:13,background:T.bg,color:T.text,fontFamily:"inherit"}}>
            <option value="">{"—"} Rasse wählen {"—"}</option>
            {rassen.filter(r=>r!==von).map(r=><option key={r} value={r}>{r} ({profile.eintraege.filter(e=>e.rasse===r).length}×)</option>)}
          </select>
        </div>
        {von&&nach&&<div style={{padding:"10px 12px",background:"#fff3e0",border:"1px solid #f59e0b55",borderRadius:8,fontSize:12,color:"#b45309"}}>
          {profile.eintraege.filter(e=>e.rasse===von).length} Einträge "{von}" {"→"} "{nach}"
        </div>}
        <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
          <button onClick={onClose} style={{background:"none",border:`1px solid ${T.border}`,borderRadius:8,padding:"8px 16px",fontSize:13,cursor:"pointer",color:T.text}}>Abbrechen</button>
          <button disabled={!von||!nach||von===nach} onClick={merge}
            style={{background:T.accent,color:"#fff",border:"none",borderRadius:8,padding:"8px 20px",fontSize:13,fontWeight:600,cursor:"pointer",opacity:(!von||!nach||von===nach)?0.5:1}}>
            Zusammenführen
          </button>
        </div>
      </div>
    </div>
  );
}

// ── Statistik View (ein Profil) ───────────────────────────────────────────────
function gSym(g,profile){
  if(!profile?.geschlechtSymbol)return g;
  const n=(g||"").toLowerCase();
  if(n.includes("weib")||n.includes("hündin")||n.includes("katze")||n.includes("stute")||n.includes("henne")||n.includes("♀"))return "♀";
  if(n.includes("männ")||n.includes("rüde")||n.includes("kater")||n.includes("hengst")||n.includes("hahn")||n.includes("♂"))return "♂";
  return g;
}
function RassenEditorModal({profile,onUpdate,onClose,T,btn}){
  const [rassenText,setRassenText]=useState((profile.rassen||[]).join("\n"));
  const [neueRasse,setNeueRasse]=useState("");
  const [hinweis,setHinweis]=useState("");
  function sortiere(arr){
    return [...new Set(arr.map(r=>r.trim()).filter(Boolean))].sort((a,b)=>a.localeCompare(b,"de"));
  }
  function addRasse(){
    const r=neueRasse.trim();
    if(!r)return;
    const vorhanden=rassenText.split("\n").map(x=>x.trim().toLowerCase());
    if(vorhanden.includes(r.toLowerCase())){setHinweis(`"${r}" steht schon in der Liste.`);setNeueRasse("");return;}
    setRassenText(t=>(t.trim()?t.replace(/\n+$/,"")+"\n":"")+r);
    setNeueRasse("");
    setHinweis(`"${r}" ergänzt. Beim Speichern wird alphabetisch sortiert.`);
  }
  function saveRassen(){
    // Duplikate raus, alphabetisch nach deutscher Sortierung (Umlaute korrekt einsortiert)
    onUpdate({...profile,rassen:sortiere(rassenText.split("\n"))});
    onClose();
  }
  function importFile(e){
    const f=e.target.files[0];if(!f)return;
    const reader=new FileReader();
    reader.onload=ev=>{setRassenText(ev.target.result);};
    reader.readAsText(f);
  }
  return(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.5)",zIndex:1000,display:"flex",alignItems:"center",justifyContent:"center"}} onClick={onClose}>
      <div style={{background:T.surface,borderRadius:16,padding:24,width:500,maxWidth:"90vw",maxHeight:"80vh",display:"flex",flexDirection:"column",gap:12}} onClick={e=>e.stopPropagation()}>
        <div style={{fontFamily:"Georgia,serif",fontSize:18,color:T.accent}}>🏷️ Rassen bearbeiten – {profile.name}</div>
        <div style={{fontSize:12,color:T.muted}}>Eine Rasse pro Zeile · beim Speichern wird sortiert und entdoppelt</div>
        <div style={{display:"flex",gap:8}}>
          <input value={neueRasse} onChange={e=>{setNeueRasse(e.target.value);setHinweis("");}}
            onKeyDown={e=>{if(e.key==="Enter"){e.preventDefault();addRasse();}}}
            placeholder="Neue Rasse eintragen und hinzufügen"
            style={{flex:1,padding:"8px 10px",borderRadius:8,border:`1px solid ${T.border}`,background:T.bg,color:T.text,fontSize:13,outline:"none"}}/>
          <button style={btn(T,"primary")} onClick={addRasse} disabled={!neueRasse.trim()}>+ Hinzufügen</button>
        </div>
        {hinweis&&<div style={{fontSize:11,color:T.muted}}>{hinweis}</div>}
        <textarea value={rassenText} onChange={e=>setRassenText(e.target.value)} style={{flex:1,minHeight:300,padding:10,borderRadius:8,border:`1px solid ${T.border}`,background:T.bg,color:T.text,fontSize:12,fontFamily:"monospace",resize:"vertical"}}/>
        <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
          <label style={{...btn(T,"ghost"),cursor:"pointer"}}>📂 .txt importieren<input type="file" accept=".txt" style={{display:"none"}} onChange={importFile}/></label>
          <div style={{flex:1}}/>
          <button style={btn(T,"ghost")} onClick={onClose}>Abbrechen</button>
          <button style={btn(T,"primary")} onClick={saveRassen}>💾 Speichern</button>
        </div>
      </div>
    </div>
  );
}
function StatistikView({profile,onUpdate,T,dark,onEditProfil,onProfilSwitch}){
  const lsKey=`sd_statistik_layout_${profile.id}`;
  const [views,setViews]=useState(()=>{try{return JSON.parse(localStorage.getItem(lsKey)||"{}").views||{};}catch{return {};}});
  const [vis,setVis]=useState(()=>{try{return JSON.parse(localStorage.getItem(lsKey)||"{}").vis||{};}catch{return {};}});
  const [showPDF,setShowPDF]=useState(false);
  const [sortKey,setSortKey]=useState("rasse");
  const [sortDir,setSortDir]=useState(1);
  const [editRow,setEditRow]=useState(null);

  function updateEintrag(id,field,value){
    onUpdate({...profile,eintraege:profile.eintraege.map(e=>e.id===id?{...e,[field]:value}:e)});
  }
  function deleteEintrag(id){
    if(!confirm("Eintrag löschen?"))return;
    onUpdate({...profile,eintraege:profile.eintraege.filter(e=>e.id!==id)});
    setEditRow(null);
  }

  useEffect(()=>{try{const cur=JSON.parse(localStorage.getItem(lsKey)||"{}");localStorage.setItem(lsKey,JSON.stringify({...cur,views}));}catch{}},[views]);
  useEffect(()=>{try{const cur=JSON.parse(localStorage.getItem(lsKey)||"{}");localStorage.setItem(lsKey,JSON.stringify({...cur,vis}));}catch{}},[vis]);

  const getView=id=>views[id]||"bar";
  const setView=(id,v)=>setViews(p=>({...p,[id]:v}));
  const isVis=id=>vis[id]!==false;
  const toggleVis=id=>setVis(p=>({...p,[id]:p[id]===false}));

  const eintraege=profile.eintraege;
  const [showTabelle,setShowTabelle]=useState(false);
  const felder=profile.felder;
  const activeShootings=profile.shootingTypes.filter(s=>s.aktiv&&s.name);
  const shootingsInEintraegen=[...new Set(eintraege.map(e=>e.shootingTyp).filter(Boolean))];
  const alleShootings=[...activeShootings,...shootingsInEintraegen.filter(n=>!activeShootings.find(s=>s.name===n)).map(n=>({id:n,name:n,aktiv:true}))];
  const activeGeschlechter=(profile.geschlechter||[]).filter(g=>g.aktiv&&g.name);
  const allRassen=[...new Set([...(profile.rassen||[]),...(profile.eintraege||[]).map(e=>e.rasse).filter(Boolean)])].sort();
  const rasseLabel=felder.rasse?.label||"Rasse";
  const alterLabel=felder.alter?.label||"Alter";
  const geschlechtLabel=felder.geschlecht?.label||"Geschlecht";

  const CHARTS=[];
  if(felder.rasse?.aktiv){
    CHARTS.push({id:"rasse_g",col:0,title:`${rasseLabel} — Gesamt`,data:countBy(eintraege,"rasse")});
    alleShootings.forEach(st=>CHARTS.push({id:`rasse_${st.id}`,col:0,title:`${rasseLabel} — ${st.name}`,data:countBy(eintraege.filter(e=>e.shootingTyp===st.name),"rasse")}));
  }
  if(felder.alter?.aktiv){
    CHARTS.push({id:"alter_g",col:1,title:`${alterLabel} — Gesamt`,data:countBy(eintraege,"alter").sort((a,b)=>alterSortIndex(a.label)-alterSortIndex(b.label))});
    alleShootings.forEach(st=>CHARTS.push({id:`alter_${st.id}`,col:1,title:`${alterLabel} — ${st.name}`,data:countBy(eintraege.filter(e=>e.shootingTyp===st.name),"alter").sort((a,b)=>alterSortIndex(a.label)-alterSortIndex(b.label))}));
  }
  if(felder.geschlecht?.aktiv) CHARTS.push({id:"geschlecht",col:2,title:`${geschlechtLabel} — Gesamt`,data:countBy(eintraege,"geschlecht")});
  if(felder.shooting?.aktiv)   CHARTS.push({id:"shooting",col:2,title:`${felder.shooting.label||"Shooting"} — Gesamt`,data:countBy(eintraege,"shootingTyp")});

  const COLS=[
    {label:rasseLabel,  ids:CHARTS.filter(c=>c.col===0).map(c=>c.id)},
    {label:alterLabel,  ids:CHARTS.filter(c=>c.col===1).map(c=>c.id)},
    {label:"Übersicht", ids:CHARTS.filter(c=>c.col===2).map(c=>c.id)},
  ].filter(col=>col.ids.length>0);

  function toggleSort(k){if(sortKey===k)setSortDir(d=>d*-1);else{setSortKey(k);setSortDir(1);}}
  const dedup={};
  eintraege.forEach(e=>{
    const alterDisplay=e.alterEinheit&&e.alterEinheit!=="Jahre"?`${e.alter} ${e.alterEinheit}`:e.alter;
    const key=`${e.rasse}|${e.geschlecht}|${alterDisplay}|${e.shootingTyp}`;
    if(!dedup[key])dedup[key]={rasse:e.rasse,geschlecht:e.geschlecht,alter:alterDisplay,shootingTyp:e.shootingTyp,anzahl:0,id:key};
    dedup[key].anzahl++;
  });
  const tableData=Object.values(dedup).sort((a,b)=>{
    const av=sortKey==="anzahl"?a.anzahl:(a[sortKey]||"").toString().toLowerCase();
    const bv=sortKey==="anzahl"?b.anzahl:(b[sortKey]||"").toString().toLowerCase();
    if(av<bv)return -1*sortDir;if(av>bv)return 1*sortDir;return 0;
  });
  const SortTh=({label,k})=>(
    <th onClick={()=>toggleSort(k)} style={{padding:"10px 14px",textAlign:"left",fontSize:11,fontWeight:600,color:sortKey===k?T.accent:T.muted,textTransform:"uppercase",letterSpacing:"0.07em",borderBottom:`1px solid ${T.border}`,cursor:"pointer",whiteSpace:"nowrap",userSelect:"none"}}>
      {label}{sortKey===k?(sortDir===1?" ↑":" ↓"):""}
    </th>
  );

  return(
    <div>
      {/* KPIs */}
      <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:12,marginBottom:24}}>
        {[
          {l:`${profile.tierart} gesamt`,v:eintraege.length,i:"🐾"},
          ...profile.geschlechter.filter(g=>g.aktiv&&g.name).map(g=>({l:g.name,v:eintraege.filter(e=>e.geschlecht===g.name).length,i:"⚧"})),
          {l:"Rassen",v:new Set(eintraege.map(e=>e.rasse)).size,i:"🏷️"},
        ].slice(0,4).map((s,i)=>(
          <div key={i} style={{background:T.tile,border:`1px solid ${T.tileBorder}`,borderRadius:12,padding:"14px 12px",textAlign:"center"}}>
            <div style={{fontSize:20,marginBottom:4}}>{s.i}</div>
            <div style={{fontFamily:"Georgia,serif",fontSize:22,color:T.accent}}>{s.v}</div>
            <div style={{fontSize:10,color:T.muted,marginTop:2,textTransform:"uppercase",letterSpacing:"0.07em",lineHeight:1.3}}>{s.l}</div>
          </div>
        ))}
      </div>

      <Eingabe profile={profile} onUpdate={onUpdate} T={T} charts={CHARTS} onEditProfil={onEditProfil} onProfilSwitch={onProfilSwitch}/>

      {/* Charts */}
      <div style={{display:"grid",gridTemplateColumns:`repeat(${COLS.length},1fr)`,gap:16,marginBottom:24,alignItems:"start"}}>
        {COLS.map(col=>(
          <div key={col.label}>
            <div style={{marginBottom:10}}>
              <div style={{fontSize:12,fontWeight:700,color:T.muted,textTransform:"uppercase",letterSpacing:"0.1em",marginBottom:8}}>{col.label}</div>
              <div style={{display:"flex",flexWrap:"wrap",gap:5}}>
                {CHARTS.filter(c=>col.ids.includes(c.id)).map(c=>(
                  <button key={c.id} style={btn(T,isVis(c.id)?"active":"ghost",true)} onClick={()=>toggleVis(c.id)}>
                    {isVis(c.id)?"✓ ":""}{c.title.split("—")[1]?.trim()||c.title}
                  </button>
                ))}
              </div>
            </div>
            <div>
              {CHARTS.filter(c=>col.ids.includes(c.id)&&isVis(c.id)).map(c=>(
                <ChartBlock key={c.id} title={c.title} data={c.data} T={T} view={getView(c.id)} setView={v=>setView(c.id,v)}/>
              ))}
              {CHARTS.filter(c=>col.ids.includes(c.id)&&isVis(c.id)).length===0&&(
                <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:12,padding:24,textAlign:"center",color:T.muted,fontSize:12}}>Keine Auswertung aktiv</div>
              )}
            </div>
          </div>
        ))}
      </div>

      {/* Tabelle */}
      <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:12,overflow:"hidden"}}>
        <div style={{padding:"14px 18px",borderBottom:showTabelle?`1px solid ${T.border}`:"none",display:"flex",alignItems:"center",justifyContent:"space-between",cursor:"pointer"}} onClick={()=>setShowTabelle(t=>!t)}>
          <div style={{fontWeight:700,fontSize:14,color:T.text}}>📋 Alle Einträge ({eintraege.length})</div>
          <span style={{color:T.muted,fontSize:13}}>{showTabelle?"▲ Zuklappen":"▼ Aufklappen"}</span>
        </div>
        {showTabelle&&<div style={{overflowX:"auto"}}>
          <table style={{width:"100%",borderCollapse:"collapse"}}>
            <thead>
              <tr style={{background:T.bg}}>
                {felder.rasse?.aktiv&&<SortTh label={rasseLabel} k="rasse"/>}
                {felder.geschlecht?.aktiv&&<SortTh label={geschlechtLabel} k="geschlecht"/>}
                {felder.shooting?.aktiv&&<SortTh label={felder.shooting.label||"Shooting"} k="shootingTyp"/>}
                <SortTh label="Anzahl" k="anzahl"/>
                <th style={{padding:"10px 14px",borderBottom:`1px solid ${T.border}`}}/>
              </tr>
            </thead>
            <tbody>
              {tableData.map(e=>{
                const isOpen=editRow===e.id;
                const einzeln=profile.eintraege.filter(x=>x.rasse===e.rasse&&x.geschlecht===e.geschlecht&&x.alter===e.alter&&x.shootingTyp===e.shootingTyp);
                return(
                  <Fragment key={e.id}>
                    <tr onClick={()=>setEditRow(isOpen?null:e.id)} onMouseEnter={x=>x.currentTarget.style.background=T.tileHover} onMouseLeave={x=>x.currentTarget.style.background=isOpen?T.accentDim:"transparent"} style={{transition:"background 0.1s",cursor:"pointer",background:isOpen?T.accentDim:"transparent"}}>
                      {felder.rasse?.aktiv&&<td style={{padding:"10px 14px",fontWeight:600,color:T.text,borderBottom:`1px solid ${T.border}22`}}>🐾 {e.rasse}</td>}
                      {felder.geschlecht?.aktiv&&<td style={{padding:"10px 14px",borderBottom:`1px solid ${T.border}22`}}><span style={{display:"inline-block",padding:"2px 9px",borderRadius:20,fontSize:11,fontWeight:600,background:T.info+"22",color:T.info}}>{gSym(e.geschlecht,profile)}</span></td>}
                      {felder.shooting?.aktiv&&<td style={{padding:"10px 14px",borderBottom:`1px solid ${T.border}22`}}><span style={{display:"inline-block",padding:"2px 9px",borderRadius:20,fontSize:11,fontWeight:600,background:T.accentDim,color:T.accent}}>{e.shootingTyp}</span></td>}
                      <td style={{padding:"10px 14px",borderBottom:`1px solid ${T.border}22`}}><span style={{display:"inline-block",padding:"2px 10px",borderRadius:20,fontSize:12,fontWeight:700,background:T.accent+"22",color:T.accent}}>{e.anzahl}×</span></td>
                      <td style={{padding:"10px 14px",borderBottom:`1px solid ${T.border}22`,textAlign:"right"}}>
                        <span style={{fontSize:11,color:T.muted,marginRight:8}}>{isOpen?"▲":"✏️"}</span>
                        <button style={btn(T,"danger",true)} onClick={ev=>{ev.stopPropagation();if(confirm("Alle Einträge dieser Kombination löschen?"))onUpdate({...profile,eintraege:profile.eintraege.filter(x=>!(x.rasse===e.rasse&&x.geschlecht===e.geschlecht&&x.alter===e.alter&&x.shootingTyp===e.shootingTyp))});}}> ✕</button>
                      </td>
                    </tr>
                    {isOpen&&einzeln.map((ei,idx)=>(
                      <tr key={ei.id} style={{background:T.bg}}>
                        <td colSpan={5} style={{padding:"8px 24px",borderBottom:`1px solid ${T.border}22`}}>
                          <div style={{display:"flex",gap:10,alignItems:"center",flexWrap:"wrap"}}>
                            <span style={{fontSize:11,color:T.muted,minWidth:20}}>#{idx+1}</span>
                            <select value={ei.rasse||""} onChange={ev=>updateEintrag(ei.id,"rasse",ev.target.value)}
                              style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:6,padding:"4px 8px",color:T.text,fontSize:12,fontFamily:"inherit",outline:"none"}}>
                              {allRassen.map(r=><option key={r} value={r}>{r}</option>)}
                            </select>
                            <select value={ei.geschlecht||""} onChange={ev=>updateEintrag(ei.id,"geschlecht",ev.target.value)}
                              style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:6,padding:"4px 8px",color:T.text,fontSize:12,fontFamily:"inherit",outline:"none"}}>
                              {activeGeschlechter.map(g=><option key={g.id} value={g.name}>{g.name}</option>)}
                            </select>
                            <div style={{display:"flex",gap:4,alignItems:"center"}}>
                              <input value={(ei.alter||"").replace(/ [JM]$/,"")} onChange={ev=>{
                                const einheit=(ei.alter||"").endsWith(" M")?" M":" J";
                                updateEintrag(ei.id,"alter",ev.target.value?ev.target.value+einheit:"");
                              }} placeholder="Alter"
                                style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:6,padding:"4px 8px",color:T.text,fontSize:12,fontFamily:"inherit",outline:"none",width:50}}/>
                              <select value={(ei.alter||"").endsWith(" M")?"M":"J"} onChange={ev=>{
                                const num=(ei.alter||"").replace(/ [JM]$/,"");
                                updateEintrag(ei.id,"alter",num?num+" "+ev.target.value:"");
                              }} style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:6,padding:"4px 6px",color:T.text,fontSize:12,fontFamily:"inherit",outline:"none"}}>
                                <option value="J">J</option>
                                <option value="M">M</option>
                              </select>
                            </div>
                            <select value={ei.shootingTyp||""} onChange={ev=>updateEintrag(ei.id,"shootingTyp",ev.target.value)}
                              style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:6,padding:"4px 8px",color:T.text,fontSize:12,fontFamily:"inherit",outline:"none"}}>
                              {activeShootings.map(st=><option key={st.id} value={st.name}>{st.name}</option>)}
                            </select>
                            <button style={btn(T,"danger",true)} onClick={()=>deleteEintrag(ei.id)}>✕</button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </Fragment>
                );
              })}
              {tableData.length===0&&<tr><td colSpan={6} style={{padding:40,textAlign:"center",color:T.muted}}>Noch keine Einträge. Füge Daten manuell hinzu oder importiere eine Statistik-JSON.</td></tr>}
            </tbody>
          </table>
        </div>}
      </div>

      {showPDF&&<PDFModal eintraege={eintraege} charts={CHARTS.filter(c=>isVis(c.id)&&c.data.length>0)} profile={profile} onClose={()=>setShowPDF(false)} T={T}/>}
    </div>
  );
}

// ── ReisekostenPage ───────────────────────────────────────────────────────────
// ── ShootingKartePage ───────────────────────────────────────────────────────
function ShootingKartePage({bookings,customers,events,T}){
  const containerRef=useRef(null);
  const initDone=useRef(false);
  const [karteKey,setKarteKey]=useState(0);

  useEffect(()=>{
    return()=>{initDone.current=false;};
  },[]);

  useEffect(()=>{
    if(!containerRef.current||initDone.current)return;
    initDone.current=true;
    const el=containerRef.current;
    window._karteNeuLaden=()=>{initDone.current=false;el.innerHTML="";setKarteKey(k=>k+1);};

    if(!document.getElementById('leaflet-css')){
      const css=document.createElement('link');
      css.id='leaflet-css';css.rel='stylesheet';
      css.href='https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
      document.head.appendChild(css);
    }

    // Daten aufbereiten
    const allPins=[];
    try{
      const bk=JSON.parse(localStorage.getItem('sd_bookings')||'[]');
      const cu=JSON.parse(localStorage.getItem('sd_customers')||'[]');
      const ev=JSON.parse(localStorage.getItem('sd_events')||'[]');
      const poi=JSON.parse(localStorage.getItem('sd_karte_poi')||'[]');
      bk.forEach(b=>{
        if(!b.location)return;
        const c=cu.find(x=>x.id===b.customerId);
        allPins.push({id:b.id,typ:'shooting',label:b.location,kunde:c?c.name:'',datum:b.date?b.date.slice(0,10):'',info:b.notes||'',adresse:b.location,color:'#27ae60',icon:'📷',lat:b.locationLat||null,lng:b.locationLng||null});
      });
      ev.forEach(e=>{
        const adr=[e.adresse&&e.adresse.strasse,e.adresse&&e.adresse.plz,e.adresse&&e.adresse.ort].filter(Boolean).join(', ')||e.location||'';
        if(!adr)return;
        allPins.push({id:e.id,typ:'event',label:e.name||e.location||'Veranstaltung',kunde:'',datum:e.date?e.date.slice(0,10):'',info:e.location||'',adresse:adr,color:'#4a8db5',icon:'🎪'});
      });
      poi.forEach(p=>allPins.push({...p,typ:'poi',color:'#b8952a',icon:p.icon||'📍'}));
    }catch(e){}

    const setup=()=>{
      el.innerHTML=`
        <div style="display:grid;grid-template-columns:340px 1fr;height:calc(100vh - 70px);gap:0">
          <div style="overflow-y:auto;padding:16px;display:flex;flex-direction:column;gap:12px;background:${T.bg}">

            <div style="background:${T.surface};border:1px solid ${T.border};border-radius:10px;padding:14px">
              <div style="font-size:10px;font-weight:700;color:${T.muted};text-transform:uppercase;letter-spacing:.06em;margin-bottom:10px">Filter</div>
              <input id="sk_suche" placeholder="Suchen..." style="width:100%;box-sizing:border-box;padding:7px 10px;border:1px solid ${T.border};border-radius:7px;font-size:13px;background:${T.bg};color:${T.text};font-family:inherit;margin-bottom:8px"/>
              <div style="display:flex;gap:6px;flex-wrap:wrap">
                <button class="sk_filter" data-f="alle" style="padding:4px 10px;border-radius:20px;border:1px solid ${T.accent};background:${T.accent};color:#fff;font-size:12px;cursor:pointer;font-family:inherit">Alle</button>
                <button class="sk_filter" data-f="shooting" style="padding:4px 10px;border-radius:20px;border:1px solid ${T.border};background:none;color:${T.muted};font-size:12px;cursor:pointer;font-family:inherit">📷 Shootings</button>
                <button class="sk_filter" data-f="event" style="padding:4px 10px;border-radius:20px;border:1px solid ${T.border};background:none;color:${T.muted};font-size:12px;cursor:pointer;font-family:inherit">🎪 Events</button>
                <button class="sk_filter" data-f="poi" style="padding:4px 10px;border-radius:20px;border:1px solid ${T.border};background:none;color:${T.muted};font-size:12px;cursor:pointer;font-family:inherit">📍 POI</button>
              </div>
            </div>

            <div id="sk_detail" style="display:none;background:${T.surface};border:1px solid ${T.accent}44;border-radius:10px;padding:14px">
              <div style="font-size:10px;font-weight:700;color:${T.muted};text-transform:uppercase;letter-spacing:.06em;margin-bottom:10px">Details</div>
              <div id="sk_detail_body"></div>
            </div>

            <div style="background:${T.surface};border:1px solid ${T.border};border-radius:10px;padding:14px">
              <div style="font-size:10px;font-weight:700;color:${T.muted};text-transform:uppercase;letter-spacing:.06em;margin-bottom:10px">POI hinzufügen</div>
              <input id="sk_poi_label" placeholder="Name" style="width:100%;box-sizing:border-box;padding:7px 10px;border:1px solid ${T.border};border-radius:7px;font-size:13px;background:${T.bg};color:${T.text};font-family:inherit;margin-bottom:6px"/>
              <input id="sk_poi_adresse" placeholder="Adresse (oder Karte klicken)" style="width:100%;box-sizing:border-box;padding:7px 10px;border:1px solid ${T.border};border-radius:7px;font-size:13px;background:${T.bg};color:${T.text};font-family:inherit;margin-bottom:6px"/>
              <textarea id="sk_poi_info" placeholder="Notiz (optional)" rows="3" style="width:100%;box-sizing:border-box;padding:7px 10px;border:1px solid ${T.border};border-radius:7px;font-size:13px;background:${T.bg};color:${T.text};font-family:inherit;margin-bottom:8px;resize:vertical;line-height:1.5"></textarea>
              <div style="display:flex;gap:6px;flex-wrap:wrap;margin-bottom:8px">
                ${['📍','📷','🏠','🌲','🏔️','🏖️','🏛️','⭐'].map(ic=>`<button class="sk_icon" data-ic="${ic}" style="font-size:18px;background:none;border:1px solid ${T.border};border-radius:6px;padding:3px 6px;cursor:pointer" title="${ic}">${ic}</button>`).join('')}
              </div>
              <button id="sk_poi_add" style="background:${T.accent};color:#fff;border:none;border-radius:8px;padding:9px;font-size:13px;font-weight:700;width:100%;cursor:pointer;font-family:inherit">+ POI speichern</button>
              <button id="sk_export_rk" style="background:none;border:1px solid ${T.accent};border-radius:8px;padding:9px;font-size:13px;font-weight:700;width:100%;cursor:pointer;font-family:inherit;color:${T.accent};margin-top:6px">🚗 → Reiseplaner</button>
              <div style="font-size:11px;color:${T.muted};margin-top:6px;text-align:center">Oder: Klick auf Karte = Stecknadel setzen</div>
            </div>

            <div id="sk_liste" style="background:${T.surface};border:1px solid ${T.border};border-radius:10px;padding:14px;display:flex;flex-direction:column;gap:6px">
              <div style="font-size:10px;font-weight:700;color:${T.muted};text-transform:uppercase;letter-spacing:.06em;margin-bottom:6px">Pins (<span id="sk_count">0</span>)</div>
            </div>
          </div>

          <div id="sk_map" style="height:100%;min-height:600px;position:relative">
            <div style="position:absolute;bottom:30px;left:50%;transform:translateX(-50%);background:rgba(0,0,0,0.6);color:#fff;font-size:11px;padding:5px 12px;border-radius:20px;pointer-events:none;white-space:nowrap;z-index:500">Klick auf Karte → Stecknadel setzen</div>
          </div>
        </div>`;

      const g=id=>document.getElementById(id);
      let aktFilter='alle';
      let aktIcon='📍';
      let pendingLatLng=null;
      const pinsWithCoords=[];

      // Icon auswählen
      document.querySelectorAll('.sk_icon').forEach(btn=>{
        btn.onclick=()=>{
          aktIcon=btn.dataset.ic;
          document.querySelectorAll('.sk_icon').forEach(b=>b.style.borderColor=T.border);
          btn.style.borderColor=T.accent;
        };
      });

      // Filter
      document.querySelectorAll('.sk_filter').forEach(btn=>{
        btn.onclick=()=>{
          aktFilter=btn.dataset.f;
          document.querySelectorAll('.sk_filter').forEach(b=>{b.style.background='none';b.style.color=T.muted;b.style.borderColor=T.border;});
          btn.style.background=T.accent;btn.style.color='#fff';btn.style.borderColor=T.accent;
          renderPins();
        };
      });

      // Suche
      g('sk_suche').oninput=()=>renderPins();

      // Karte
      const map=window.L.map('sk_map').setView([51.1657,10.4515],6);
      window.L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',{attribution:'\u00a9 OpenStreetMap',maxZoom:19}).addTo(map);

      // Stecknadel-Icon erzeugen
      function makeIcon(ic,color){
        const svg=`<svg xmlns="http://www.w3.org/2000/svg" width="28" height="36" viewBox="0 0 28 36">
          <path d="M14 0C6.27 0 0 6.27 0 14c0 10.5 14 22 14 22S28 24.5 28 14C28 6.27 21.73 0 14 0z" fill="${color}"/>
          <circle cx="14" cy="14" r="9" fill="white" opacity="0.9"/>
          <text x="14" y="18" font-size="11" text-anchor="middle">${ic}</text>
        </svg>`;
        return window.L.divIcon({html:svg,iconSize:[28,36],iconAnchor:[14,36],popupAnchor:[0,-36],className:''});
      }

      // Geocode
      async function geocode(q){
        try{
          const r=await fetch('https://nominatim.openstreetmap.org/search?q='+encodeURIComponent(q)+'&format=json&limit=1',{headers:{'Accept-Language':'de'}});
          const d=await r.json();
          if(d&&d[0])return{lat:parseFloat(d[0].lat),lng:parseFloat(d[0].lon)};
        }catch{}
        return null;
      }

      // Detail anzeigen
      window._curPoi=null;
      function showDetail(p){
        window._curPoi=p;
        const _esc=s=>(s||"").replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/"/g,"&quot;").replace(/\n/g," ");
        const mapsUrl="https://maps.google.com/?q="+p.lat+","+p.lng;
        const mapsLabel="https://maps.google.com/?q="+encodeURIComponent((p.adresse||p.label||"").replace(/\n/g," "));
        g('sk_detail').style.display='block';
        g('sk_detail_body').innerHTML=`
          <div style="font-weight:700;font-size:14px;color:${T.accent};margin-bottom:6px">${p.icon||'📍'} ${_esc(p.label)}</div>
          ${p.datum?`<div style="font-size:12px;color:${T.muted};margin-bottom:3px">📅 ${new Date(p.datum).toLocaleDateString('de-DE')}</div>`:''}
          ${p.kunde?`<div style="font-size:12px;color:${T.text};margin-bottom:3px">👤 ${_esc(p.kunde)}</div>`:''}
          ${p.adresse?`<div style="font-size:12px;color:${T.muted};margin-bottom:8px">📍 ${_esc(p.adresse)}</div>`:''}
          ${p.info?`<div style="font-size:12px;color:${T.muted};margin-bottom:8px;padding:6px;background:${T.bg};border-radius:6px">${_esc(p.info)}</div>`:''}
          <div style="display:flex;flex-direction:column;gap:6px">
            <a href="${mapsLabel}" target="_blank" style="display:block;text-align:center;padding:8px;background:#4285f4;color:#fff;border-radius:7px;font-size:12px;font-weight:600;text-decoration:none">🗺 In Google Maps öffnen</a>
            <button onclick="navigator.clipboard.writeText('https://maps.google.com/?q='+(window._curPoi?encodeURIComponent((window._curPoi.adresse||window._curPoi.label||'').replace(/\\n/g,' ')):'')).then(()=>{this.textContent='✓ Kopiert!';setTimeout(()=>this.textContent='🔗 Maps-Link kopieren',2000)})" style="padding:8px;background:none;border:1px solid ${T.border};border-radius:7px;font-size:12px;cursor:pointer;font-family:inherit;color:${T.text}">🔗 Maps-Link kopieren</button>
            <button onclick="if(window._curPoi){localStorage.setItem('sd_rk_prefill_ziel',window._curPoi.adresse||window._curPoi.label||'');alert('Ziel übernommen – bitte zu Reiseplaner wechseln.')}" style="padding:8px;background:none;border:1px solid ${T.accent};border-radius:7px;font-size:12px;cursor:pointer;font-family:inherit;color:${T.accent};font-weight:600">🚗 → Reiseplaner</button>
            ${p.typ==='poi'?`<button onclick="editPoi('${p.id}')" style="padding:8px;background:none;border:1px solid ${T.accent};border-radius:7px;font-size:12px;cursor:pointer;color:${T.accent};font-family:inherit">✏️ Bearbeiten</button><button onclick="deletePoi('${p.id}')" style="padding:8px;background:none;border:1px solid #e53;border-radius:7px;font-size:12px;cursor:pointer;color:#e53;font-family:inherit">🗑 POI löschen</button>`:''}
          </div>`;
      }

      window.deletePoi=(id)=>{
        if(!confirm('POI löschen?'))return;
        const poi=JSON.parse(localStorage.getItem('sd_karte_poi')||'[]').filter(p=>p.id!==id);
        localStorage.setItem('sd_karte_poi',JSON.stringify(poi));
        g('sk_detail').style.display='none';
        window._karteNeuLaden&&window._karteNeuLaden();
      };

      window.editPoi=(id)=>{
        const poi=JSON.parse(localStorage.getItem('sd_karte_poi')||'[]');
        const p=poi.find(x=>x.id===id);
        if(!p)return;
        const emojis=['📍','🌲','🏠','🏞','🌳','🐕','🎪','📷','🌄','🏔','🌊','🌿','🏡','⛺','🌻','🎯','🅿','🚗','🏙','🌅'];
        const overlay=document.createElement('div');
        overlay.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,0.7);z-index:9999;display:flex;align-items:center;justify-content:center';
        const box=document.createElement('div');
        box.style.cssText='background:'+T.surface+';border:1px solid '+T.border+';border-radius:14px;padding:24px;width:380px;max-width:90vw';
        const nameInp=document.createElement('input');nameInp.id='poi_edit_name';nameInp.value=p.label||'';nameInp.style.cssText='width:100%;box-sizing:border-box;padding:8px 10px;border:1px solid '+T.border+';border-radius:8px;font-size:13px;background:'+T.bg+';color:'+T.text+';font-family:inherit;margin-bottom:12px;display:block';
        const emojiInp=document.createElement('input');emojiInp.id='poi_selected_emoji';emojiInp.type='hidden';emojiInp.value=p.icon||'📍';
        const notizInp=document.createElement('input');notizInp.id='poi_edit_notiz';notizInp.value=p.notiz||'';notizInp.style.cssText='width:100%;box-sizing:border-box;padding:8px 10px;border:1px solid '+T.border+';border-radius:8px;font-size:13px;background:'+T.bg+';color:'+T.text+';font-family:inherit;margin-bottom:16px;display:block';
        const grid=document.createElement('div');grid.style.cssText='display:flex;flex-wrap:wrap;gap:6px;margin-bottom:12px';
        emojis.forEach(e=>{
          const btn=document.createElement('button');
          btn.textContent=e;
          btn.style.cssText='font-size:20px;padding:6px;border:1px solid '+T.border+';border-radius:7px;cursor:pointer;background:'+(e===p.icon?T.accent+'33':'transparent');
          btn.onclick=()=>{grid.querySelectorAll('button').forEach(b=>b.style.background='transparent');btn.style.background=T.accent+'33';emojiInp.value=e;};
          grid.appendChild(btn);
        });
        const btnRow=document.createElement('div');btnRow.style.cssText='display:flex;gap:8px;justify-content:flex-end';
        const btnAbb=document.createElement('button');btnAbb.textContent='Abbrechen';btnAbb.style.cssText='padding:8px 16px;border:1px solid '+T.border+';border-radius:8px;background:transparent;cursor:pointer;font-family:inherit;color:'+T.muted;btnAbb.onclick=()=>document.body.removeChild(overlay);
        const btnSav=document.createElement('button');btnSav.textContent='Speichern';btnSav.style.cssText='padding:8px 16px;border:none;border-radius:8px;background:'+T.accent+';color:#fff;cursor:pointer;font-family:inherit;font-weight:700';btnSav.onclick=()=>{const name=nameInp.value.trim();if(!name)return;const emoji=emojiInp.value||'📍';const notiz=notizInp.value;const poi2=JSON.parse(localStorage.getItem('sd_karte_poi')||'[]');const upd=poi2.map(x=>x.id===id?{...x,label:name,icon:emoji,notiz}:x);localStorage.setItem('sd_karte_poi',JSON.stringify(upd));document.body.removeChild(overlay);g('sk_detail').style.display='none';window._karteNeuLaden&&window._karteNeuLaden();};
        btnRow.appendChild(btnAbb);btnRow.appendChild(btnSav);
        const mkDiv=(txt,css)=>{const d=document.createElement('div');d.style.cssText=css;d.textContent=txt;return d;};
        box.appendChild(mkDiv('📍 POI bearbeiten','font-size:16px;font-weight:700;color:'+T.accent+';margin-bottom:16px'));
        box.appendChild(mkDiv('Name','font-size:12px;color:'+T.muted+';margin-bottom:4px'));
        box.appendChild(nameInp);
        box.appendChild(mkDiv('Symbol','font-size:12px;color:'+T.muted+';margin-bottom:6px'));
        box.appendChild(grid);
        box.appendChild(emojiInp);
        box.appendChild(mkDiv('Notiz','font-size:12px;color:'+T.muted+';margin-bottom:4px'));
        box.appendChild(notizInp);
        box.appendChild(btnRow);
        overlay.appendChild(box);
        document.body.appendChild(overlay);
      };

      window._savePoiEdit=(id)=>{
        const name=document.getElementById('poi_edit_name').value.trim();
        const emoji=document.getElementById('poi_selected_emoji').value||'📍';
        const notiz=document.getElementById('poi_edit_notiz').value;
        if(!name)return;
        const poi=JSON.parse(localStorage.getItem('sd_karte_poi')||'[]');
        const updated=poi.map(x=>x.id===id?{...x,label:name,icon:emoji,notiz}:x);
        localStorage.setItem('sd_karte_poi',JSON.stringify(updated));
        document.querySelectorAll('[style*="position:fixed"][style*="z-index:9999"]').forEach(el=>el.remove());
        g('sk_detail').style.display='none';
        location.reload();
      };

      // Pins rendern
      const markerMap={};
      function renderPins(){
        const suche=g('sk_suche').value.toLowerCase();
        Object.values(markerMap).forEach(m=>m.remove());
        const count=g('sk_count');
        let n=0;
        const liste=g('sk_liste');
        // Listeneinträge leeren außer Header
        while(liste.children.length>1)liste.removeChild(liste.lastChild);

        pinsWithCoords.filter(p=>{
          if(aktFilter!=='alle'&&p.typ!==aktFilter)return false;
          if(suche&&!p.label.toLowerCase().includes(suche)&&!(p.kunde||'').toLowerCase().includes(suche))return false;
          return true;
        }).forEach(p=>{
          const m=window.L.marker([p.lat,p.lng],{icon:makeIcon(p.icon||'📍',p.color||'#b8952a')}).addTo(map);
          m.on('click',()=>showDetail(p));
          markerMap[p.id]=m;
          n++;
          // Listeneintrag
          const row=document.createElement('div');
          row.style.cssText='display:flex;align-items:center;gap:8px;padding:6px 8px;border-radius:7px;cursor:pointer;font-size:12px;color:'+T.text+';border:1px solid transparent';
          row.innerHTML='<span style="font-size:16px">'+(p.icon||'📍')+'</span><div style="flex:1;min-width:0"><div style="font-weight:600;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">'+p.label+'</div>'+(p.kunde?'<div style="font-size:11px;color:'+T.muted+'">'+p.kunde+'</div>':'')+'</div>';
          row.onmouseenter=()=>{row.style.background=T.bg;row.style.borderColor=T.border;};
          row.onmouseleave=()=>{row.style.background='transparent';row.style.borderColor='transparent';};
          row.onclick=()=>{map.setView([p.lat,p.lng],14);showDetail(p);};
          liste.appendChild(row);
        });
        count.textContent=n;
      }

      // Klick auf Karte = neuer POI
      let clickMarker=null;
      map.on('click',e=>{
        pendingLatLng={lat:e.latlng.lat,lng:e.latlng.lng};
        g('sk_poi_adresse').value=e.latlng.lat.toFixed(5)+', '+e.latlng.lng.toFixed(5);
        g('sk_poi_label').focus();
        if(clickMarker)clickMarker.remove();
        clickMarker=window.L.marker([e.latlng.lat,e.latlng.lng]).addTo(map).bindPopup('📍 Klick-Position').openPopup();
      });

      // POI speichern
      g('sk_poi_add').onclick=async()=>{
        const label=g('sk_poi_label').value.trim();
        if(!label){alert('Bitte Name eingeben.');return;}
        let lat,lng;
        if(pendingLatLng){lat=pendingLatLng.lat;lng=pendingLatLng.lng;}
        else{
          const adr=g('sk_poi_adresse').value.trim();
          if(!adr){alert('Bitte Adresse eingeben oder Karte klicken.');return;}
          const geo=await geocode(adr);
          if(!geo){alert('Adresse nicht gefunden.');return;}
          lat=geo.lat;lng=geo.lng;
        }
        const neu={id:Date.now().toString(36),typ:'poi',label,adresse:g('sk_poi_adresse').value.trim(),info:g('sk_poi_info').value.trim(),icon:aktIcon,lat,lng,color:'#b8952a'};
        const poi=JSON.parse(localStorage.getItem('sd_karte_poi')||'[]');
        poi.push(neu);
        localStorage.setItem('sd_karte_poi',JSON.stringify(poi));
        g('sk_poi_label').value='';g('sk_poi_adresse').value='';g('sk_poi_info').value='';
        pendingLatLng=null;
        pinsWithCoords.push(neu);
        renderPins();
      };

      // Alle bestehenden Pins geocodieren
      async function loadPins(){
        for(let i=0;i<allPins.length;i++){
          const p=allPins[i];
          if(p.lat&&p.lng){pinsWithCoords.push(p);}
          else{
            const geo=await geocode(p.adresse);
            if(geo)pinsWithCoords.push({...p,...geo});
            if(i<allPins.length-1)await new Promise(r=>setTimeout(r,300));
          }
        }
        renderPins();
        if(clickMarker){clickMarker.remove();clickMarker=null;}
      }

      g('sk_export_rk').onclick=()=>{
        const adr=g('sk_poi_adresse').value.trim()||g('sk_poi_label').value.trim();
        if(!adr){alert('Bitte zuerst einen Ort wählen.');return;}
        localStorage.setItem('sd_rk_prefill_ziel',adr);
        alert('✅ Ziel übernommen. Bitte zu Reiseplaner wechseln.');
      };

      loadPins();
    };

    if(!window.L){
      const s=document.createElement('script');
      s.src='https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
      s.onload=()=>setTimeout(setup,100);
      document.head.appendChild(s);
    } else setTimeout(setup,100);
  },[]);

  return <div ref={containerRef} style={{height:'calc(100vh - 60px)'}}/>;
}

function ReisekostenPage({T}){
  const containerRef=useRef(null);
  const initDone=useRef(false);

  useEffect(()=>{
    if(!containerRef.current||initDone.current)return;
    initDone.current=true;
    const el=containerRef.current;

    if(!document.getElementById('leaflet-css')){
      const css=document.createElement('link');
      css.id='leaflet-css';css.rel='stylesheet';
      css.href='https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
      document.head.appendChild(css);
    }

    const setup=()=>{
      el.innerHTML=`
        <div style="display:grid;grid-template-columns:380px 1fr;height:calc(100vh - 70px);gap:0">
          <div style="overflow-y:auto;padding:16px;display:flex;flex-direction:column;gap:12px;background:${T.bg}">
            <div style="background:${T.surface};border:1px solid ${T.border};border-radius:10px;padding:14px">
              <div style="font-size:10px;font-weight:700;color:${T.muted};text-transform:uppercase;letter-spacing:.06em;margin-bottom:10px">Route</div>
              <label style="font-size:11px;color:${T.muted};display:block;margin-bottom:3px">Startadresse</label>
              <div style="display:flex;gap:6px;margin-bottom:8px">
                <input id="rk_st" style="flex:1;padding:7px 10px;border:1px solid ${T.border};border-radius:7px;font-size:13px;background:${T.bg};color:${T.text};font-family:inherit" placeholder="Moltkestr. 22, 90429 N\u00fcrnberg"/>
                <button id="rk_save" style="background:${T.accent};color:#fff;border:none;border-radius:7px;padding:0 10px;font-size:17px;cursor:pointer">\u2605</button>
              </div>
              <label style="font-size:11px;color:${T.muted};display:block;margin-bottom:3px">Zieladresse</label>
              <div style="position:relative;margin-bottom:10px;width:100%;box-sizing:border-box">
                <input id="rk_zi" style="width:100%;max-width:100%;padding:7px 10px;border:1px solid ${T.border};border-radius:7px;font-size:13px;background:${T.bg};color:${T.text};font-family:inherit;box-sizing:border-box" placeholder="z.B. IKEA M\u00fcnchen"/>
                <div id="rk_sug" style="display:none;position:absolute;left:0;right:0;top:100%;background:${T.surface};border:1px solid ${T.border};border-radius:8px;z-index:1000;max-height:160px;overflow-y:auto"></div>
              </div>
              <div id="rk_wp_list"></div>
              <button id="rk_add_wp" style="background:none;border:1px dashed ${T.border};border-radius:7px;padding:6px 10px;font-size:12px;color:${T.muted};cursor:pointer;width:100%;margin-bottom:8px;font-family:inherit">+ Zwischenstation hinzufügen</button>
              <button id="rk_btn" style="background:${T.accent};color:#fff;border:none;border-radius:8px;padding:10px;font-size:13px;font-weight:700;width:100%;cursor:pointer;font-family:inherit">Route berechnen + Karte anzeigen</button>
              <div style="margin-top:6px;display:flex;align-items:center;gap:6px">
                <input type="checkbox" id="rk_alt" style="accent-color:${T.accent};width:14px;height:14px"/>
                <label for="rk_alt" style="font-size:12px;color:${T.muted};cursor:pointer">Alternativrouten anzeigen</label>
              </div>
              <div id="rk_info" style="display:none;background:${T.bg};border-radius:7px;padding:8px 10px;font-size:12px;color:${T.muted};margin-top:8px;gap:14px"></div>
            </div>
            <div style="background:${T.surface};border:1px solid ${T.border};border-radius:10px;padding:14px">
              <div style="font-size:10px;font-weight:700;color:${T.muted};text-transform:uppercase;letter-spacing:.06em;margin-bottom:10px">Fahrtkosten</div>
              <div style="display:grid;grid-template-columns:1fr 110px 50px;align-items:center;gap:8px;padding:7px 0;border-bottom:1px solid ${T.border}"><div style="font-size:12px;color:${T.muted}">Verbrauch PKW</div><input id="rk_vb" type="number" step="0.1" placeholder="z.B. 8" style="padding:6px 8px;border:1px solid ${T.border};border-radius:7px;font-size:13px;background:${T.bg};color:${T.text};text-align:right"/><div style="font-size:11px;color:${T.muted}">l/100km</div></div>
              <div style="display:grid;grid-template-columns:1fr 110px 50px;align-items:center;gap:8px;padding:7px 0;border-bottom:1px solid ${T.border}"><div style="font-size:12px;color:${T.muted}">Entfernung einfach</div><input id="rk_ef" type="number" step="0.1" placeholder="0" style="padding:6px 8px;border:1px solid ${T.border};border-radius:7px;font-size:13px;background:${T.bg};color:${T.text};text-align:right"/><div style="font-size:11px;color:${T.muted}">km</div></div>
              <div style="display:grid;grid-template-columns:1fr 110px 50px;align-items:center;gap:8px;padding:7px 0;border-bottom:1px solid ${T.border}"><div style="font-size:12px;color:${T.muted}">Kraftstoffpreis</div><input id="rk_sp" type="number" step="0.01" placeholder="z.B. 2.30" style="padding:6px 8px;border:1px solid ${T.border};border-radius:7px;font-size:13px;background:${T.bg};color:${T.text};text-align:right"/><div style="font-size:11px;color:${T.muted}">\u20ac/l</div></div>
              <div style="display:grid;grid-template-columns:1fr 110px 50px;align-items:center;gap:8px;padding:7px 0"><div style="font-size:12px;font-weight:600;color:${T.text}">Fahrtkosten Hin+R\u00fcck</div><div id="rk_rf" style="background:#d4edda;color:#155724;border-radius:7px;padding:5px 8px;font-size:13px;font-weight:700;text-align:right">0,00</div><div style="font-size:11px;color:${T.muted}">\u20ac</div></div>
            </div>
            <div style="background:${T.surface};border:1px solid ${T.border};border-radius:10px;padding:14px">
              <div style="font-size:10px;font-weight:700;color:${T.muted};text-transform:uppercase;letter-spacing:.06em;margin-bottom:10px">Reisezeitkosten</div>
              <div style="display:grid;grid-template-columns:1fr 110px 50px;align-items:center;gap:8px;padding:7px 0;border-bottom:1px solid ${T.border}"><div style="font-size:12px;color:${T.muted}">Reisezeit einfach</div><input id="rk_rz" placeholder="1:30" style="padding:6px 8px;border:1px solid ${T.border};border-radius:7px;font-size:13px;background:${T.bg};color:${T.text};text-align:right;font-family:monospace"/><div style="font-size:11px;color:${T.muted}">h:mm</div></div>
              <div style="display:grid;grid-template-columns:1fr 110px 50px;align-items:center;gap:8px;padding:7px 0;border-bottom:1px solid ${T.border}"><div style="font-size:12px;color:${T.muted}">Kosten je Stunde</div><input id="rk_sk" type="number" step="0.5" value="30" style="padding:6px 8px;border:1px solid ${T.border};border-radius:7px;font-size:13px;background:${T.bg};color:${T.text};text-align:right"/><div style="font-size:11px;color:${T.muted}">\u20ac/h</div></div>
              <div style="display:grid;grid-template-columns:1fr 110px 50px;align-items:center;gap:8px;padding:7px 0"><div style="font-size:12px;font-weight:600;color:${T.text}">Reisekosten gesamt</div><div id="rk_rr" style="background:#d4edda;color:#155724;border-radius:7px;padding:5px 8px;font-size:13px;font-weight:700;text-align:right">0,00</div><div style="font-size:11px;color:${T.muted}">\u20ac</div></div>
            </div>
            <div style="background:${T.accent};border-radius:10px;padding:14px;display:grid;grid-template-columns:1fr auto auto;align-items:center;gap:10px">
              <div style="color:#fff;font-weight:700;font-size:14px">Gesamtreisekosten</div>
              <div id="rk_rg" style="background:rgba(255,255,255,.2);border-radius:8px;padding:8px 14px;color:#fff;font-size:20px;font-weight:800">0,00</div>
              <div style="color:rgba(255,255,255,.8);font-size:14px">\u20ac</div>
            </div>
          </div>
          <div id="rk_map" style="height:100%;min-height:600px;position:relative">
            <div style="position:absolute;bottom:30px;left:50%;transform:translateX(-50%);background:rgba(0,0,0,0.6);color:#fff;font-size:11px;padding:5px 12px;border-radius:20px;pointer-events:none;white-space:nowrap;z-index:500">Klick auf Karte = Ziel setzen</div>
          </div>
        </div>`;

      const g=id=>document.getElementById(id);
      g('rk_save').onclick=()=>localStorage.setItem('sd_reise_start',g('rk_st').value);
      g('rk_st').value=localStorage.getItem('sd_reise_start')||'';

      const fmt=n=>(n||0).toFixed(2).replace('.',',');
      const parseT=s=>{if(!s)return 0;const p=s.split(':');return(parseInt(p[0])||0)*60+(parseInt(p[1])||0);};
      const calc=()=>{
        const v=parseFloat(g('rk_vb').value)||0;
        const e=parseFloat(g('rk_ef').value)||0;
        const s=parseFloat(g('rk_sp').value)||0;
        const h=parseFloat(g('rk_sk').value)||0;
        const t=parseT(g('rk_rz').value);
        const f=e*2*v/100*s;
        const r=t*2/60*h;
        g('rk_rf').textContent=fmt(f);
        g('rk_rr').textContent=fmt(r);
        g('rk_rg').textContent=fmt(f+r);
      };
      ['rk_vb','rk_ef','rk_sp','rk_sk'].forEach(id=>g(id).addEventListener('input',calc));
      // Werte persistent speichern
      g('rk_vb').value=localStorage.getItem('sd_reise_verbrauch')||'';
      g('rk_sp').value=localStorage.getItem('sd_reise_kraftstoff')||'';
      g('rk_sk').value=localStorage.getItem('sd_reise_stundensatz')||'';
      g('rk_vb').addEventListener('change',()=>localStorage.setItem('sd_reise_verbrauch',g('rk_vb').value));
      g('rk_sp').addEventListener('change',()=>localStorage.setItem('sd_reise_kraftstoff',g('rk_sp').value));
      g('rk_sk').addEventListener('change',()=>localStorage.setItem('sd_reise_stundensatz',g('rk_sk').value));
      calc();
      g('rk_rz').addEventListener('input',e=>{
        const v=e.target.value.replace(/[^0-9:]/g,'');
        e.target.value=v;
        if(/^\d{2}$/.test(v))e.target.value=v+':';
        calc();
      });

      let sugT=null;
      const addSugDiv=(b,label,sublabel,onSelect,isKunde)=>{
        const div=document.createElement('div');
        div.style.cssText='padding:7px 10px;cursor:pointer;font-size:12px;border-bottom:1px solid '+T.border+';color:'+T.text+(isKunde?';background:'+T.accentDim:'');
        div.innerHTML='<div style="font-weight:'+(isKunde?'600':'400')+'">'+label+'</div>'+(sublabel?'<div style="font-size:11px;color:'+T.muted+'">'+sublabel+'</div>':'');
        div.onmousedown=onSelect;
        div.onmouseover=()=>div.style.background=T.bg;
        div.onmouseout=()=>div.style.background=isKunde?T.accentDim:'transparent';
        b.appendChild(div);
      };
      g('rk_zi').addEventListener('input',e=>{
        clearTimeout(sugT);
        const b=g('rk_sug');
        const val=e.target.value.toLowerCase();
        if(e.target.value.length<2){b.style.display='none';return;}
        b.innerHTML='';
        try{
          const kunden=JSON.parse(localStorage.getItem('sd_customers')||'[]');
          const matches=kunden.filter(k=>(k.name||'').toLowerCase().includes(val)||(k.strasse||'').toLowerCase().includes(val)).slice(0,3);
          if(matches.length){
            const hdr=document.createElement('div');
            hdr.style.cssText='padding:4px 10px;font-size:10px;font-weight:700;color:'+T.muted+';text-transform:uppercase;background:'+T.bg;
            hdr.textContent='Kunden';b.appendChild(hdr);
            matches.forEach(k=>{
              const adr=[k.strasse,k.plz,k.ort].filter(Boolean).join(', ');
              addSugDiv(b,k.name||'',adr,()=>{
                g('rk_zi').value=[k.strasse,(k.plz||'')+' '+(k.ort||'')].filter(x=>x.trim()).join(', ');
                delete g('rk_zi').dataset.lat;delete g('rk_zi').dataset.lon;b.style.display='none';
              },true);
            });
          }
        }catch{}
        b.style.display=b.children.length?'block':'none';
        sugT=setTimeout(async()=>{
          try{
            const r=await fetch('https://nominatim.openstreetmap.org/search?q='+encodeURIComponent(e.target.value)+'&format=json&limit=4',{headers:{'Accept-Language':'de'}});
            const d=await r.json();
            if(d.length){
              const hdr=document.createElement('div');
              hdr.style.cssText='padding:4px 10px;font-size:10px;font-weight:700;color:'+T.muted+';text-transform:uppercase;background:'+T.bg;
              hdr.textContent='Orte & Adressen';b.appendChild(hdr);
              d.forEach(x=>{
                const p=x.display_name.split(',').map(s=>s.trim());
                const label=p[0]||'';
                const sub=p.slice(1,3).join(', ');
                addSugDiv(b,label,sub,()=>{
                  g('rk_zi').value=p.slice(0,2).join(', ');
                  g('rk_zi').dataset.lat=x.lat;g('rk_zi').dataset.lon=x.lon;b.style.display='none';
                },false);
              });
              b.style.display='block';
            }
          }catch{}
        },400);
      });
      g('rk_zi').addEventListener('blur',()=>setTimeout(()=>g('rk_sug').style.display='none',200));

      const L=window.L;
      const map=L.map('rk_map').setView([51.1657,10.4515],6);
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',{attribution:'\u00a9 OpenStreetMap',maxZoom:19}).addTo(map);
      let rl=null,mk=[],clickMarker=null;
      let activeMapField=null; // zuletzt fokussiertes Feld

      // Fokus tracken
      g('rk_st').addEventListener('focus',()=>{activeMapField={el:g('rk_st'),wpData:null};});
      g('rk_zi').addEventListener('focus',()=>{activeMapField={el:g('rk_zi'),wpData:null};});

      map.on('click',async e=>{
        const{lat,lng}=e.latlng;
        if(clickMarker)clickMarker.remove();
        // Ziel-Feld bestimmen
        const targetEl=activeMapField?.el||g('rk_zi');
        const targetWp=activeMapField?.wpData||null;
        clickMarker=L.marker([lat,lng]).addTo(map).bindPopup(activeMapField?.el?.placeholder||'Ziel gesetzt').openPopup();
        if(targetWp){targetWp.lat=lat;targetWp.lon=lng;}
        else{targetEl.dataset.lat=lat;targetEl.dataset.lon=lng;}
        try{
          const r=await fetch('https://nominatim.openstreetmap.org/reverse?lat='+lat+'&lon='+lng+'&format=json',{headers:{'Accept-Language':'de'}});
          const d=await r.json();
          if(d.display_name){const parts2=d.display_name.split(',');targetEl.value=parts2.slice(0,2).join(',').trim();}
        }catch{targetEl.value=lat.toFixed(5)+', '+lng.toFixed(5);}
      });

      const geocode=async(a,el)=>{
        if(el&&el.dataset.lat&&el.dataset.lon)return[parseFloat(el.dataset.lat),parseFloat(el.dataset.lon)];
        const r=await fetch('https://nominatim.openstreetmap.org/search?q='+encodeURIComponent(a)+'&format=json&limit=1',{headers:{'Accept-Language':'de'}});
        const d=await r.json();
        if(!d.length)throw new Error('Nicht gefunden: '+a);
        return[parseFloat(d[0].lat),parseFloat(d[0].lon)];
      };

      let waypoints=[];
      let altRoutes=[];

      g('rk_add_wp').addEventListener('click',()=>{
        const wpData={addr:'',lat:null,lon:null};
        waypoints.push(wpData);
        const div=document.createElement('div');
        div.style.cssText='position:relative;margin-bottom:6px';
        div.innerHTML='<div style="display:flex;gap:4px"><input placeholder="Zwischenstation '+waypoints.length+'" style="flex:1;padding:7px 10px;border:1px solid ${T.border};border-radius:7px;font-size:13px;background:${T.bg};color:${T.text};font-family:inherit"/><button style="background:#e55;color:#fff;border:none;border-radius:7px;padding:0 8px;cursor:pointer;font-size:14px">×</button></div>';
        const wpInput=div.querySelector('input');
        wpInput.addEventListener('focus',()=>{activeMapField={el:wpInput,wpData};});
        wpInput.addEventListener('input',e=>{wpData.addr=e.target.value;wpData.lat=null;wpData.lon=null;});
        div.querySelector('button').addEventListener('click',()=>{const i=waypoints.indexOf(wpData);if(i>-1)waypoints.splice(i,1);div.remove();if(activeMapField?.wpData===wpData)activeMapField={el:g('rk_zi'),wpData:null};});
        g('rk_wp_list').appendChild(div);
        // Automatisch als aktives Feld setzen
        wpInput.focus();
        activeMapField={el:wpInput,wpData};
      });

      g('rk_btn').addEventListener('click',async()=>{
        const s=g('rk_st').value,z=g('rk_zi').value;
        if(!s||!z){alert('Bitte Start und Ziel eingeben.');return;}
        g('rk_btn').disabled=true;g('rk_btn').textContent='Wird berechnet...';
        try{
          const[sLa,sLo]=await geocode(s,g('rk_st'));
          const[zLa,zLo]=await geocode(z,g('rk_zi'));
          const wpCoords=[];
          const wpInputs=g('rk_wp_list').querySelectorAll('input');
          for(let i=0;i<waypoints.length;i++){
            const wp=waypoints[i];
            // Koordinaten bereits per Nadel gesetzt?
            if(wp.lat&&wp.lon){wpCoords.push([wp.lat,wp.lon]);continue;}
            const inputVal=wpInputs[i]?wpInputs[i].value.trim():(wp.addr||"");
            if(!inputVal)continue;
            wp.addr=inputVal;
            const[la,lo]=await geocode(inputVal,wpInputs[i]);
            wpCoords.push([la,lo]);
          }
          const allPoints=[[sLa,sLo],...wpCoords,[zLa,zLo]];
          const coordStr=allPoints.map(([la,lo])=>lo+','+la).join(';');
          const altParam=g('rk_alt')?.checked?'&alternatives=true':'';
          const r=await fetch('https://router.project-osrm.org/route/v1/driving/'+coordStr+'?overview=full&geometries=geojson'+altParam);
          const d=await r.json();
          if(!d.routes?.length)throw new Error('Keine Route gefunden');
          if(rl)rl.remove();
          altRoutes.forEach(l=>l.remove());altRoutes=[];
          mk.forEach(m=>m.remove());mk=[];
          d.routes.forEach((rt2,i)=>{
            const isMain=i===0;
            const l=L.geoJSON(rt2.geometry,{style:{color:isMain?'#E8602C':'#888',weight:isMain?5:3,opacity:isMain?.9:.5,dashArray:isMain?null:'8,5'}}).addTo(map);
            const km2=(rt2.distance/1000).toFixed(1);
            const mn2=Math.round(rt2.duration/60);
            l.bindTooltip((isMain?'Hauptroute':'Alternative '+i)+': '+km2+' km, '+Math.floor(mn2/60)+'h '+mn2%60+'min',{sticky:true});
            l.on('click',()=>{
              altRoutes.forEach((ll,j)=>ll.setStyle(j===i?{color:'#E8602C',weight:5,opacity:.9,dashArray:null}:{color:'#888',weight:3,opacity:.5,dashArray:'8,5'}));
              g('rk_ef').value=km2;
              g('rk_rz').value=Math.floor(mn2/60)+':'+String(mn2%60).padStart(2,'0');
              calc();
            });
            altRoutes.push(l);
            if(isMain)rl=l;
          });
          const rt=d.routes[0];
          const km=(rt.distance/1000).toFixed(1);
          const mn=Math.round(rt.duration/60);
          g('rk_ef').value=km;
          g('rk_rz').value=Math.floor(mn/60)+':'+String(mn%60).padStart(2,'0');
          g('rk_info').style.display='flex';
          g('rk_info').innerHTML='<span>Entfernung: <strong>'+km+' km</strong></span><span>Fahrzeit: <strong>'+Math.floor(mn/60)+'h '+mn%60+'min</strong></span>'+(d.routes.length>1?'<span style="color:#b8952a">Klick auf Route zum Wechseln</span>':'');
          mk=[L.marker([sLa,sLo]).addTo(map).bindPopup('Start'),L.marker([zLa,zLo]).addTo(map).bindPopup('Ziel')];
          wpCoords.forEach(([la,lo],i)=>{
            mk.push(L.marker([la,lo],{icon:L.divIcon({className:'',html:'<div style="background:#b8952a;color:#fff;border-radius:50%;width:26px;height:26px;display:flex;align-items:center;justify-content:center;font-size:12px;font-weight:700;border:3px solid #fff;box-shadow:0 2px 6px rgba(0,0,0,.5)">'+(i+1)+'</div>',iconSize:[26,26],iconAnchor:[13,13]})}).addTo(map).bindPopup('Zwischenstation '+(i+1)));
          });
          map.fitBounds(allPoints.map(([la,lo])=>[la,lo]),{padding:[40,40]});
          calc();
        }catch(err){alert(err.message);}
        g('rk_btn').disabled=false;g('rk_btn').textContent='Route berechnen + Karte anzeigen';
      });
      calc();
    };

    const doSetup=()=>{
      setup();
      const prefill=localStorage.getItem('sd_rk_prefill_ziel');
      if(prefill){
        setTimeout(()=>{
          const zi=document.getElementById('rk_zi');
          if(zi){zi.value=prefill;zi.dispatchEvent(new Event('input'));}
          localStorage.removeItem('sd_rk_prefill_ziel');
        },400);
      }
    };
    if(window.L){doSetup();return;}
    const sc=document.createElement('script');
    sc.src='https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
    sc.onload=doSetup;document.head.appendChild(sc);
  },[]);

  return <div ref={containerRef} style={{width:"100%",height:"calc(100vh - 70px)",minHeight:600}}/>;
}



// ── App Shell ─────────────────────────────────────────────────────────────────

// ── StatistikPage ──────────────────────────────────────────────────────────────
function StatistikPage({T}){
  return <StatistikView profile={null} onUpdate={()=>{}} T={T} dark={false}/>;
}


// ── GalTxtEd ─────────────────────────────────────────────────────────────────
// Platzhalter {{vorname}} ersetzen. Ohne Namen faellt er samt vorangehendem
// Leerzeichen weg, damit aus "Hallo {{vorname}}," sauber "Hallo," wird.
function galPers(text,vorname){
  const t=String(text||"");
  const vn=String(vorname||"").trim();
  if(vn)return t.replace(/\{\{[Vv]orname\}\}/g,vn);
  return t.replace(/[ \t]*\{\{[Vv]orname\}\}/g,"").replace(/[ \t]{2,}/g," ");
}

function GalTxtEd({value,onChange,rows,T,singleLine=false,storageKey}){
  const ref=useRef(null);
  // Textvorlagen liegen im Browser unter storageKey. Derselbe Schluessel wird
  // in den Voreinstellungen und in jeder einzelnen Galerie benutzt, damit man
  // ueberall auf dieselben Vorlagen zugreift.
  const [vorlagen,setVorlagen]=useState(()=>{
    if(!storageKey)return [];
    try{const v=JSON.parse(localStorage.getItem(storageKey)||"[]");return Array.isArray(v)?v:[];}catch{return [];}
  });
  const [gewaehlt,setGewaehlt]=useState("");
  function vorlagenSichern(neu){
    setVorlagen(neu);
    try{localStorage.setItem(storageKey,JSON.stringify(neu));}catch(e){}
  }
  function vorlageSpeichern(){
    const vorschlag=gewaehlt||"";
    const name=(window.prompt("Name der Vorlage:",vorschlag)||"").trim();
    if(!name)return;
    if(vorlagen.some(v=>v.name===name)&&!window.confirm("\u00bb"+name+"\u00ab gibt es schon. \u00dcberschreiben?"))return;
    vorlagenSichern([...vorlagen.filter(v=>v.name!==name),{name,text:value||""}].sort((a,b)=>a.name.localeCompare(b.name)));
    setGewaehlt(name);
  }
  function vorlageLoeschen(){
    if(!gewaehlt){alert("Erst eine Vorlage ausw\u00e4hlen.");return;}
    if(!window.confirm("Vorlage \u00bb"+gewaehlt+"\u00ab l\u00f6schen?"))return;
    vorlagenSichern(vorlagen.filter(v=>v.name!==gewaehlt));
    setGewaehlt("");
  }
  const ins=(b,a)=>{
    const el=ref.current;if(!el)return;
    const s=el.selectionStart,en=el.selectionEnd,sel=(value||"").slice(s,en);
    const t=(value||"").slice(0,s)+b+sel+a+(value||"").slice(en);
    onChange(t);setTimeout(()=>{el.focus();el.setSelectionRange(s+b.length,s+b.length+sel.length);},0);
  };
  const inputStyle={width:"100%",background:"rgba(0,0,0,0.06)",border:"1px solid rgba(0,0,0,0.15)",
    borderRadius:8,padding:"8px 12px",color:"inherit",fontSize:13,resize:"vertical",
    fontFamily:"inherit",lineHeight:1.6,boxShadow:"inset 0 1px 3px rgba(0,0,0,0.08)"};
  const toolbar=(
    <div style={{display:"flex",gap:4,marginBottom:4,flexWrap:"wrap"}}>
      {[["B","<b>","</b>","bold"],["I","<i>","</i>","italic"],["U","<u>","</u>","underline"]].map(([l,op,cl,st])=>(
        <button key={l} onMouseDown={e=>{e.preventDefault();ins(op,cl);}}
          style={{padding:"2px 9px",background:T.bg,border:"1px solid "+T.border,borderRadius:4,
            cursor:"pointer",color:T.text,fontSize:13,fontWeight:st==="bold"?700:400,
            fontStyle:st==="italic"?"italic":"normal",
            textDecoration:st==="underline"?"underline":"none"}}>{l}</button>
      ))}
      <select defaultValue="" onMouseDown={e=>e.stopPropagation()}
        onChange={e=>{if(!e.target.value)return;ins("<span style=\"font-size:"+e.target.value+"px\">","</span>");e.target.value="";}}
        style={{padding:"2px 6px",background:T.bg,border:"1px solid "+T.border,borderRadius:4,color:T.text,fontSize:11}}>
        <option value="" disabled>Groesse</option>
        {[10,11,12,13,14,16,18,20,22,24,28,32,36].map(sz=><option key={sz} value={sz}>{sz}px</option>)}
      </select>
      {storageKey&&(
        <>
          <select value={gewaehlt} onMouseDown={e=>e.stopPropagation()}
            onChange={e=>{
              const n=e.target.value; setGewaehlt(n);
              if(!n)return;
              const v=vorlagen.find(x=>x.name===n);
              if(!v)return;
              if((value||"").trim()&&!window.confirm("Aktuellen Text durch \u00bb"+n+"\u00ab ersetzen?")){setGewaehlt("");return;}
              onChange(v.text||"");
            }}
            style={{padding:"2px 6px",background:T.bg,border:"1px solid "+T.border,borderRadius:4,color:T.text,fontSize:11,maxWidth:150}}>
            <option value="">Vorlagen ({vorlagen.length})</option>
            {vorlagen.map(v=><option key={v.name} value={v.name}>{v.name}</option>)}
          </select>
          <button onMouseDown={e=>{e.preventDefault();vorlageSpeichern();}} title="Aktuellen Text als Vorlage sichern"
            style={{padding:"2px 9px",background:T.bg,border:"1px solid "+T.border,borderRadius:4,cursor:"pointer",color:T.text,fontSize:11}}>+ Sichern</button>
          {gewaehlt&&(
            <button onMouseDown={e=>{e.preventDefault();vorlageLoeschen();}} title="Gewählte Vorlage löschen"
              style={{padding:"2px 9px",background:T.bg,border:"1px solid "+T.border,borderRadius:4,cursor:"pointer",color:"#e55",fontSize:11}}>✕</button>
          )}
        </>
      )}
      {!singleLine&&(
        <select defaultValue="" onMouseDown={e=>e.stopPropagation()}
          onChange={e=>{if(!e.target.value)return;ins("<span style=\"line-height:"+e.target.value+"\">","</span>");e.target.value="";}}
          style={{padding:"2px 6px",background:T.bg,border:"1px solid "+T.border,borderRadius:4,color:T.text,fontSize:11}}>
          <option value="" disabled>Zeilenabstand</option>
          {["1","1.2","1.4","1.6","1.8","2","2.5"].map(s=><option key={s} value={s}>{s}</option>)}
        </select>
      )}
    </div>
  );
  if(singleLine) return(
    <div>
      {toolbar}
      <input ref={ref} value={value||""} onChange={e=>onChange(e.target.value)}
        style={{...inputStyle,fontSize:16,resize:undefined}}/>
    </div>
  );
  return(
    <div>
      {toolbar}
      <textarea ref={ref} value={value||""} onChange={e=>onChange(e.target.value)} rows={rows||4}
        style={inputStyle}/>
    </div>
  );
}

// ── GalToggle ─────────────────────────────────────────────────────────────────
function GalToggle({val,onChange,label,T}){
  return(
    <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:10}}>
      <div onClick={()=>onChange(!val)} style={{width:36,height:20,borderRadius:10,cursor:"pointer",
        background:val?T.accent:"#555",position:"relative",transition:"background .2s",flexShrink:0}}>
        <div style={{position:"absolute",top:2,left:val?18:2,width:16,height:16,borderRadius:8,
          background:"#fff",transition:"left .2s"}}/>
      </div>
      <span style={{fontSize:13,color:T.text}}>{label}</span>
    </div>
  );
}

// ── GalTri ────────────────────────────────────────────────────────────────────
function GalTri({val,onChange,opts,T}){
  return(
    <div style={{display:"flex",borderRadius:6,overflow:"hidden",border:"1px solid "+T.border,width:"fit-content"}}>
      {opts.map(([v,l])=>(
        <button key={v} onClick={()=>onChange(v)}
          style={{padding:"5px 14px",border:"none",cursor:"pointer",fontSize:12,fontWeight:500,
            background:val===v?T.accent:T.bg,color:val===v?"#fff":T.muted}}>{l}</button>
      ))}
    </div>
  );
}

// ── GalBlockAllgemein ─────────────────────────────────────────────────────────
function GalBlockAllgemein({data,setData,showVorlagen,showTitel,globalEinst,VORLAGEN,btn,T}){
  const inputStyle={width:"100%",background:"rgba(0,0,0,0.06)",border:"1px solid rgba(0,0,0,0.15)",
    borderRadius:8,padding:"8px 12px",color:"inherit",fontSize:13,
    boxShadow:"inset 0 1px 3px rgba(0,0,0,0.08)"};
  return(
    <div>
      {showVorlagen&&(
        <div style={{background:T.surface,border:"1px solid "+T.border,borderRadius:8,
          padding:12,marginBottom:20,display:"flex",gap:8,flexWrap:"wrap",alignItems:"center"}}>
          <span style={{fontSize:12,color:T.muted,fontWeight:600}}>Vorlage:</span>
          <button style={{...btn(T,"ghost"),fontSize:12}} onClick={()=>setData(d=>({...d,...VORLAGEN["feedback"]}))}>Feedbackgalerie</button>
          <button style={{...btn(T,"ghost"),fontSize:12}} onClick={()=>setData(d=>({...d,...VORLAGEN["galerie"]}))}>Download-Galerie</button>
          <button style={{...btn(T,"ghost"),fontSize:12}} onClick={()=>setData(d=>({...d,...(globalEinst["feedback"]||{})}))}>Meine FB-Vorlage</button>
          <button style={{...btn(T,"ghost"),fontSize:12}} onClick={()=>setData(d=>({...d,...(globalEinst["galerie"]||{})}))}>Meine DL-Vorlage</button>
        </div>
      )}
      {showTitel&&(
        <div style={{marginBottom:20}}>
          <label style={{fontSize:12,color:T.muted,display:"block",marginBottom:6,fontWeight:600}}>Titel</label>
          <GalTxtEd T={T} value={data.titel||""} onChange={v=>setData(d=>({...d,titel:v}))} singleLine={true}/>
        </div>
      )}
      <div style={{marginBottom:20}}>
        <label style={{fontSize:12,color:T.muted,display:"block",marginBottom:6,fontWeight:600}}>Vorname des Kunden</label>
        <input value={data.vorname||""} onChange={e=>setData(d=>({...d,vorname:e.target.value}))}
          placeholder="z.B. Sabine" style={inputStyle}/>
        <div style={{fontSize:11,color:T.muted,marginTop:4}}>Wird f&uuml;r die pers&ouml;nliche Anrede in den Texten verwendet.</div>
      </div>
      <div style={{marginBottom:20}}>
        <label style={{fontSize:12,color:T.muted,display:"block",marginBottom:6,fontWeight:600}}>Begrüssungstext</label>
        <GalTxtEd T={T} storageKey="sd_galtxt_begruessung" value={data.text_begruessung||""} onChange={v=>setData(d=>({...d,text_begruessung:v}))} rows={5}/>
        <div style={{fontSize:11,color:T.muted,marginTop:4}}>Mit <strong>{"{{vorname}}"}</strong> fügst du den Vornamen ein. Ist keiner hinterlegt, verschwindet der Platzhalter rückstandslos.</div>
      </div>
      <div style={{marginBottom:20}}>
        <label style={{fontSize:12,color:T.muted,display:"block",marginBottom:6,fontWeight:600}}>Erklaerungstext</label>
        <GalTxtEd T={T} storageKey="sd_galtxt_erklaerung" value={data.text_erklaerung||""} onChange={v=>setData(d=>({...d,text_erklaerung:v}))} rows={4}/>
      </div>
      <div style={{marginBottom:20}}>
        <label style={{fontSize:12,color:T.muted,display:"block",marginBottom:6,fontWeight:600}}>Abschlusstext</label>
        <GalTxtEd T={T} storageKey="sd_galtxt_abschluss" value={data.text_abschluss||""} onChange={v=>setData(d=>({...d,text_abschluss:v}))} rows={4}/>
      </div>
      <div style={{marginBottom:16}}>
        <label style={{fontSize:12,color:T.muted,display:"block",marginBottom:6,fontWeight:600}}>Feedback-Mail an</label>
        <input value={data.info_email||""} onChange={e=>setData(d=>({...d,info_email:e.target.value}))}
          placeholder="info@beispiel.de" style={inputStyle}/>
      </div>
      <GalToggle T={T} val={data.downloads_erlaubt||false} onChange={v=>setData(d=>({...d,downloads_erlaubt:v}))} label="Downloads erlauben"/>
      {(data.downloads_erlaubt||data.status==="download")&&(
        <div style={{marginTop:16,display:"flex",alignItems:"center",gap:12}}>
          <label style={{fontSize:12,color:T.muted,fontWeight:600,whiteSpace:"nowrap"}}>"Alle herunterladen" Farbe</label>
          <input type="color" value={data.btn_farbe||"#2a6a9a"} onChange={e=>setData(d=>({...d,btn_farbe:e.target.value}))}
            style={{width:36,height:28,border:"none",borderRadius:6,cursor:"pointer",padding:2,background:"none"}}/>
          <span style={{fontSize:12,color:T.muted}}>{data.btn_farbe||"#2a6a9a"}</span>
          <button onClick={()=>setData(d=>({...d,btn_farbe:"#2a6a9a"}))} style={{...btn(T,"ghost"),fontSize:11,padding:"3px 8px"}}>Reset</button>
        </div>
      )}
    </div>
  );
}

// ── GalBlockAbstimmung ────────────────────────────────────────────────────────
function GalBlockAbstimmung({data,setData,T}){
  return(
    <div>
      <div style={{marginBottom:16}}>
        <label style={{fontSize:12,color:T.muted,display:"block",marginBottom:8,fontWeight:600}}>Layout</label>
        <div style={{display:"flex",gap:8}}>
          {[["raster","Raster"],["ziegel","Ziegel"],["liste","Liste"]].map(([v,l])=>(
            <div key={v} onClick={()=>setData(d=>({...d,layout:v}))}
              style={{padding:"10px 18px",border:"2px solid "+((data.layout||"raster")===v?T.accent:T.border),
                borderRadius:8,cursor:"pointer",background:(data.layout||"raster")===v?T.accentDim:T.bg,
                fontSize:13,fontWeight:500,color:(data.layout||"raster")===v?T.accent:T.text}}>{l}</div>
          ))}
        </div>
      </div>
      <div style={{marginBottom:12}}>
        <label style={{fontSize:12,color:T.muted,display:"block",marginBottom:8,fontWeight:600}}>Bildgroesse</label>
        <GalTri T={T} val={data.bildgroesse||"mittel"} onChange={v=>setData(d=>({...d,bildgroesse:v}))} opts={[["klein","Klein"],["mittel","Mittel"],["gross","Gross"]]}/>
      </div>
      <GalToggle T={T} val={data.kommentare||false} onChange={v=>setData(d=>({...d,kommentare:v}))} label="Kommentare erlauben"/>
      <GalToggle T={T} val={data.dateiinfos!==false} onChange={v=>setData(d=>({...d,dateiinfos:v}))} label="Dateinamen anzeigen"/>
      <div style={{marginBottom:10}}>
        <label style={{fontSize:12,color:T.muted,display:"block",marginBottom:4,fontWeight:600}}>Max. Auswahl (0 = unbegrenzt)</label>
        <input type="number" min={0} value={data.max_auswahl||0}
          onChange={e=>setData(d=>({...d,max_auswahl:parseInt(e.target.value)||0}))}
          style={{width:80,padding:"6px 10px",background:"rgba(0,0,0,0.06)",border:"1px solid rgba(0,0,0,0.15)",borderRadius:6,color:"inherit",fontSize:13}}/>
      </div>
    </div>
  );
}

// ── GalBlockPraesentation ─────────────────────────────────────────────────────
function GalBlockPraesentation({data,setData,T}){
  return(
    <div>
      <GalToggle T={T} val={data.praesentation_modus||false} onChange={v=>setData(d=>({...d,praesentation_modus:v}))} label="Praesentations-Modus"/>
      <div style={{marginBottom:16}}>
        <label style={{fontSize:12,color:T.muted,display:"block",marginBottom:8,fontWeight:600}}>Headerbild</label>
        <GalToggle T={T} val={data.header_auto!==false} onChange={async v=>{
          setData(d=>({...d,header_auto:v}));
          const su=(localStorage.getItem("sd_server_url")||location.origin).replace(/\/+$/,"");
          try{await fetch(su+"/api/galerie/"+(data.token||"")+"/header-toggle",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({aktiv:v})});}catch(e){}
        }} label="Headerbild anzeigen"/>
        {data.header_auto!==false&&<div style={{display:"flex",gap:8,alignItems:"center",flexWrap:"wrap",marginTop:8}}>
          {data.headerbild&&<img src={(typeof window!=="undefined"?(localStorage.getItem("sd_server_url")||location.origin):"")+"/galerie-headerbild/"+(data.token||"")}
            style={{height:60,borderRadius:6,objectFit:"cover"}} onError={e=>e.target.style.display="none"}/>}
          <input type="file" accept=".jpg,.jpeg,.png,.webp" style={{display:"none"}} id="header-upload"
            onChange={async e=>{
              const f=e.target.files[0];if(!f)return;
              const fd=new FormData();fd.append("datei",f);
              const su=(localStorage.getItem("sd_server_url")||location.origin).replace(/\/+$/,"");
              try{const r=await fetch(su+"/api/galerie/"+(data.token||"")+"/headerbild-upload",{method:"POST",body:fd});
              const d=await r.json();if(d.ok){setData(dt=>({...dt,headerbild:true}));alert("Headerbild gespeichert");}
              else alert("Fehler");}catch(e){alert("Fehler");}
              e.target.value="";
            }}/>
          <label htmlFor="header-upload" style={{padding:"6px 14px",background:"#2a6a9a",color:"#fff",borderRadius:6,cursor:"pointer",fontSize:12,fontWeight:600}}>
            {data.headerbild?"Eigenes Bild ändern":"Eigenes Bild hochladen"}
          </label>
          {data.headerbild&&<button style={{padding:"6px 14px",background:"none",border:"1px solid #ef4444",borderRadius:6,color:"#ef4444",cursor:"pointer",fontSize:12}}
            onClick={async()=>{
              const su=(localStorage.getItem("sd_server_url")||location.origin).replace(/\/+$/,"");
              try{await fetch(su+"/api/galerie/"+(data.token||"")+"/headerbild-loeschen",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({})});
              setData(dt=>({...dt,headerbild:false}));}catch(e){}}}>
            Entfernen
          </button>}
          <div style={{fontSize:11,color:T.muted,width:"100%",marginTop:4}}>Ohne eigenes Bild wird das erste Galerie-Bild verwendet.</div>
        </div>}
      </div>
      <div style={{marginBottom:12}}>
        <label style={{fontSize:12,color:T.muted,display:"block",marginBottom:8,fontWeight:600}}>Spalten (0 = automatisch)</label>
        <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
          {[0,3,4,5,6,7,8,10].map(n=>(
            <button key={n} onClick={()=>setData(d=>({...d,spalten:n}))}
              style={{padding:"5px 12px",border:"2px solid "+((data.spalten||0)===n?T.accent:T.border),
                borderRadius:6,cursor:"pointer",fontSize:12,fontWeight:500,
                background:(data.spalten||0)===n?T.accentDim:T.bg,
                color:(data.spalten||0)===n?T.accent:T.text}}>
              {n===0?"Auto":n}
            </button>
          ))}
        </div>
      </div>
      <div style={{marginBottom:12}}>
        <label style={{fontSize:12,color:T.muted,display:"block",marginBottom:8,fontWeight:600}}>Bildabstand</label>
        <GalTri T={T} val={data.bildabstand||"mittel"} onChange={v=>setData(d=>({...d,bildabstand:v}))} opts={[["klein","Klein"],["mittel","Mittel"],["gross","Gross"]]}/>
      </div>
      <div style={{marginBottom:12}}>
        <label style={{fontSize:12,color:T.muted,display:"block",marginBottom:8,fontWeight:600}}>Kanten</label>
        <GalTri T={T} val={data.kanten||"rund"} onChange={v=>setData(d=>({...d,kanten:v}))} opts={[["rund","Rund"],["eckig","Eckig"]]}/>
      </div>
      <div style={{marginBottom:12}}>
        <label style={{fontSize:12,color:T.muted,display:"block",marginBottom:8,fontWeight:600}}>Hintergrund</label>
        <GalTri T={T} val={data.hintergrund||"dunkel"} onChange={v=>setData(d=>({...d,hintergrund:v}))} opts={[["hell","Hell"],["dunkel","Dunkel"]]}/>
      </div>
    </div>
  );
}

// ── GalBlockSicherheit ────────────────────────────────────────────────────────
function GalBlockSicherheit({data,setData,zeigLoeschen,onLoeschen,T}){
  const inputStyle={width:"100%",background:"rgba(0,0,0,0.06)",border:"1px solid rgba(0,0,0,0.15)",
    borderRadius:8,padding:"8px 12px",color:"inherit",fontSize:13,
    boxShadow:"inset 0 1px 3px rgba(0,0,0,0.08)"};
  return(
    <div>
      <div style={{marginBottom:14}}>
        <label style={{fontSize:12,color:T.muted,display:"block",marginBottom:4,fontWeight:600}}>Passwort (leer = kein Schutz)</label>
        <input type="password" value={data.passwort||""} onChange={e=>setData(d=>({...d,passwort:e.target.value}))}
          placeholder="Ohne Passwort" style={inputStyle}/>
      </div>
      <div style={{marginBottom:14}}>
        <label style={{fontSize:12,color:T.muted,display:"block",marginBottom:4,fontWeight:600}}>Ablaufdatum</label>
        <input type="date" value={data.ablaufdatum||""} onChange={e=>setData(d=>({...d,ablaufdatum:e.target.value}))}
          style={{background:"rgba(0,0,0,0.06)",border:"1px solid rgba(0,0,0,0.15)",borderRadius:8,padding:"8px 12px",color:"inherit",fontSize:13}}/>
      </div>
      <GalToggle T={T} val={data.wasserzeichen||false} onChange={v=>setData(d=>({...d,wasserzeichen:v}))} label="Wasserzeichen (geplant)"/>
      {zeigLoeschen&&(
        <div style={{marginTop:20,paddingTop:16,borderTop:"1px solid "+T.border}}>
          <button style={{padding:"8px 16px",background:"none",border:"1px solid #ef4444",borderRadius:6,color:"#ef4444",cursor:"pointer",fontSize:13}}
            onClick={onLoeschen}>Galerie loeschen</button>
        </div>
      )}
    </div>
  );
}

// ── GalVorschau ───────────────────────────────────────────────────────────────
function GalVorschau({data,typ}){
  const bg    = data.hintergrund==="hell"?"#f8f8f8":"#111";
  const txt   = data.hintergrund==="hell"?"#222":"#eee";
  const muted = data.hintergrund==="hell"?"#666":"#999";
  const card  = data.hintergrund==="hell"?"#fff":"#1e1e1e";
  const border= data.hintergrund==="hell"?"#ddd":"#333";
  const radius= data.kanten==="eckig"?"2px":"8px";
  const ph=["https://images.unsplash.com/photo-1548199973-03cce0bbc87b?w=400&q=60", "https://images.unsplash.com/photo-1587300003388-59208cc962cb?w=400&q=60", "https://images.unsplash.com/photo-1543466835-00a7907e9de1?w=400&q=60", "https://images.unsplash.com/photo-1601979031925-424e53b6caaa?w=400&q=60", "https://images.unsplash.com/photo-1514888286974-6c03e2ca1dba?w=400&q=60", "https://images.unsplash.com/photo-1529778873920-4da4926a72c2?w=400&q=60"];
  const anzahl=6;
  const layout=data.layout||"raster";
  const cols=layout==="liste"?"1fr":"repeat(3,1fr)";
  const imgH={"klein":80,"mittel":110,"gross":150}[data.bildgroesse||"mittel"];
  const gap={"klein":"4px","mittel":"8px","gross":"14px"}[data.bildabstand||"mittel"];
  const isDownload=typ==="galerie"||data.status==="download";
  const labels=["Ja","Vllt","Nein"];
  const colors=["#16a34a","#ca8a04","#dc2626"];
  const renderBild=(src,i)=>{
    if(layout==="liste") return(
      <div key={i} style={{display:"flex",gap:8,background:card,border:"1px solid "+border,
        borderRadius:radius,overflow:"hidden",padding:6}}>
        <img src={src} style={{width:80,height:56,objectFit:"cover",borderRadius:radius,flexShrink:0}} onError={e=>e.target.style.display="none"}/>
        <div style={{flex:1,minWidth:0}}>
          <div style={{fontSize:9,color:muted,marginBottom:4,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>Foto-{String(i+1).padStart(2,"0")}.jpg</div>
          {!isDownload&&<div style={{display:"flex",gap:3}}>{labels.map((l,j)=><button key={j} style={{flex:1,background:colors[j],color:"#fff",border:"none",borderRadius:4,fontSize:9,padding:"2px 0",cursor:"default"}}>{l}</button>)}</div>}
          {isDownload&&<a style={{fontSize:9,padding:"2px 8px",background:"#2a6a9a",color:"#fff",borderRadius:4,textDecoration:"none",display:"inline-block",marginTop:2}}>Download</a>}
        </div>
      </div>
    );
    return(
      <div key={i} style={{background:card,border:"1px solid "+border,borderRadius:radius,overflow:"hidden"}}>
        <img src={src} style={{width:"100%",height:imgH,objectFit:"cover",display:"block"}} onError={e=>e.target.style.display="none"}/>
        <div style={{fontSize:9,color:muted,padding:"2px 4px",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>Foto-{String(i+1).padStart(2,"0")}.jpg</div>
        {!isDownload&&<div style={{display:"flex",gap:2,padding:"3px 4px"}}>{labels.map((l,j)=><button key={j} style={{flex:1,background:colors[j],color:"#fff",border:"none",borderRadius:3,fontSize:8,padding:"2px 0",cursor:"default"}}>{l}</button>)}</div>}
        {isDownload&&<div style={{padding:"3px 4px"}}><a style={{fontSize:9,padding:"2px 6px",background:"#2a6a9a",color:"#fff",borderRadius:3,textDecoration:"none",display:"inline-block"}}>Download</a></div>}
      </div>
    );
  };
  return(
    <div style={{background:bg,borderRadius:10,padding:12,fontSize:13,color:txt,overflowY:"auto",minHeight:"900px"}}>
      {data.titel&&<div style={{textAlign:"center",fontWeight:700,fontSize:15,marginBottom:6}} dangerouslySetInnerHTML={{__html:data.titel}}/>}
      {data.text_begruessung&&<div style={{textAlign:"center",color:muted,fontSize:11,marginBottom:8,whiteSpace:"pre-line"}} dangerouslySetInnerHTML={{__html:galPers(data.text_begruessung,data.vorname)}}/>}
      {data.text_erklaerung&&!isDownload&&<div style={{textAlign:"center",color:muted,fontSize:10,marginBottom:8,whiteSpace:"pre-line"}} dangerouslySetInnerHTML={{__html:galPers(data.text_erklaerung,data.vorname)}}/>}
      {!isDownload&&<div style={{textAlign:"center",color:muted,fontSize:10,marginBottom:8}}>0 von {anzahl} bewertet</div>}
      <div style={{display:"grid",gridTemplateColumns:cols,gap:gap}}>{ph.map((src,i)=>renderBild(src,i))}</div>
      {!isDownload&&(
        <div style={{display:"flex",gap:8,justifyContent:"center",marginTop:10}}>
          <button style={{padding:"6px 16px",background:"#374151",color:"#fff",border:"none",borderRadius:6,fontSize:11,cursor:"default"}}>Auswahl speichern</button>
          <button style={{padding:"6px 16px",background:"#2a6a9a",color:"#fff",border:"none",borderRadius:6,fontSize:11,cursor:"default"}}>Feedback absenden</button>
        </div>
      )}
      {isDownload&&<div style={{display:"flex",justifyContent:"center",marginTop:10}}><button style={{padding:"6px 20px",background:"#2a6a9a",color:"#fff",border:"none",borderRadius:6,fontSize:11,cursor:"default"}}>Alle herunterladen</button></div>}
      {data.text_abschluss&&<div style={{textAlign:"center",color:muted,fontSize:10,marginTop:8,whiteSpace:"pre-line"}} dangerouslySetInnerHTML={{__html:galPers(data.text_abschluss,data.vorname)}}/>}
    </div>
  );
}

// ── GalMitVorschau ────────────────────────────────────────────────────────────
function GalMitVorschau({children,data,typ,T}){
  return(
    <div style={{display:"flex",gap:24,alignItems:"flex-start"}}>
      <div style={{flex:1,minWidth:0}}>{children}</div>
      <div style={{width:"45%",flexShrink:0,position:"sticky",top:0,maxHeight:"calc(100vh - 160px)",overflowY:"auto"}}>
        <div style={{fontSize:11,color:T.muted,fontWeight:600,marginBottom:8,textTransform:"uppercase",letterSpacing:0.8}}>Vorschau</div>
        <div style={{border:"1px solid "+T.border,borderRadius:10,overflow:"hidden"}}>
          <GalVorschau data={data} typ={typ}/>
        </div>
      </div>
    </div>
  );
}

// ── GalTabs ───────────────────────────────────────────────────────────────────
function GalTabs({tabs,aktiv,setAktiv,T}){
  return(
    <div style={{display:"flex",borderBottom:"2px solid "+T.border,marginBottom:20}}>
      {tabs.map(([id,label])=>(
        <button key={id} onClick={()=>setAktiv(id)}
          style={{padding:"8px 16px",border:"none",background:"none",cursor:"pointer",fontSize:13,fontWeight:500,
            color:aktiv===id?T.accent:T.muted,
            borderBottom:"2px solid "+(aktiv===id?T.accent:"transparent"),marginBottom:"-2px"}}>
          {label}
        </button>
      ))}
    </div>
  );
}

// ── GaleriePage ────────────────────────────────────────────────────────────────
function GaleriePage({T}){
  const serverUrl=(()=>{let u=(localStorage.getItem("sd_server_url")||"").trim().replace(/\/+$/,"");if(!u||(location.protocol==="https:"&&u.startsWith("http://")))u=location.origin;return u;})();
  const [galerien,setGalerien]=useState([]);
  const [galSort,setGalSort]=useState(()=>localStorage.getItem("sd_gal_sort")||"neu");
  // ── Ereignisse: was Kunden in den Galerien getan haben ─────────────────────
  const [kopiert,setKopiert]=useState("");
  const [ereignisseOffen,setEreignisseOffen]=useState(false);
  const [ereignisFilter,setEreignisFilter]=useState("alle"); // alle | aktive
  const [ereignisGelesen,setEreignisGelesen]=useState(()=>localStorage.getItem("sd_gal_ereignis_gelesen")||"");
  const alleEreignisse=(()=>{
    const raus=[];
    (galerien||[]).forEach(g=>{
      (Array.isArray(g.ereignisse)?g.ereignisse:[]).forEach(e=>{
        raus.push({...e,_token:g.token,_titel:(g.titel||"Ohne Titel").replace(/<[^>]*>/g,"")});
      });
    });
    return raus.sort((a,b)=>String(b.zeit||"").localeCompare(String(a.zeit||"")));
  })();
  const ereignisAnzahl=alleEreignisse.filter(e=>String(e.zeit||"")>ereignisGelesen).length;
  // Zeitpunkt einer Galerie: Erstelldatum, ersatzweise der letzte Download.
  const galZeit=g=>{
    const kandidaten=[g.erstellt,(g.downloads_log||[]).slice(-1)[0]?.datum];
    for(const k of kandidaten){const t=k?new Date(k).getTime():NaN;if(!isNaN(t))return t;}
    return 0;
  };
  const galSortiert=[...galerien].sort((a,b)=>{
    if(galSort==="titel")return String(a.titel||"").replace(/<[^>]*>/g,"").localeCompare(String(b.titel||"").replace(/<[^>]*>/g,""),"de");
    return galSort==="alt"?galZeit(a)-galZeit(b):galZeit(b)-galZeit(a);
  });
  const [aktive,setAktive]=useState(null);
  const [nav,setNav]=useState("uebersicht");
  const [einstellTab,setEinstellTab]=useState("allgemein");
  const [globalTab,setGlobalTab]=useState("allgemein");
  const [loading,setLoading]=useState(false);
  const [uploadInfo,setUploadInfo]=useState("");
  const [ausgewaehlt,setAusgewaehlt]=useState(new Set());
  const [dlDetail,setDlDetail]=useState(null);
  const [vollbildIdx,setVollbildIdx]=useState(null);
  const [neuerTitel,setNeuerTitel]=useState("");
  const [neuVorname,setNeuVorname]=useState("");
  const [neuerTyp,setNeuerTyp]=useState("feedback");
  const [neuBg,setNeuBg]=useState("");
  const [neuEk,setNeuEk]=useState("");
  const [neuAb,setNeuAb]=useState("");
  const [neuEmail,setNeuEmail]=useState("");
  const [globalEinst,setGlobalEinst]=useState({feedback:{"text_begruessung": "Hallo,\n\nvielen Dank fuer dein Vertrauen! Ich freue mich, dir deine Bilder zu zeigen.\n\nBitte schaue dir alle Fotos in Ruhe an und markiere deine Favoriten.", "text_erklaerung": "Ja = Dieses Bild moechte ich haben\nVielleicht = Ich bin noch unschluessig\nNein = Dieses Bild brauche ich nicht", "text_abschluss": "Vielen Dank fuer dein Feedback! Ich werde mich in Kuerze bei dir melden.", "layout": "raster", "bildgroesse": "mittel", "bildabstand": "mittel", "kanten": "rund", "hintergrund": "dunkel", "kommentare": false, "downloads_erlaubt": false, "max_auswahl": 0},galerie:{"text_begruessung": "Hallo,\n\ndeine fertigen Bilder sind bereit! Du kannst sie hier herunterladen.", "text_erklaerung": "", "text_abschluss": "Ich hoffe, du bist mit dem Ergebnis gluecklich!", "layout": "raster", "bildgroesse": "mittel", "bildabstand": "mittel", "kanten": "rund", "hintergrund": "dunkel", "kommentare": false, "downloads_erlaubt": true, "max_auswahl": 0}});
  const [globalTyp,setGlobalTyp]=useState("feedback");
  const VORLAGEN={"feedback": {"text_begruessung": "Hallo,\n\nvielen Dank fuer dein Vertrauen! Ich freue mich, dir deine Bilder zu zeigen.\n\nBitte schaue dir alle Fotos in Ruhe an und markiere deine Favoriten.", "text_erklaerung": "Ja = Dieses Bild moechte ich haben\nVielleicht = Ich bin noch unschluessig\nNein = Dieses Bild brauche ich nicht", "text_abschluss": "Vielen Dank fuer dein Feedback! Ich werde mich in Kuerze bei dir melden.", "layout": "raster", "bildgroesse": "mittel", "bildabstand": "mittel", "kanten": "rund", "hintergrund": "dunkel", "kommentare": false, "downloads_erlaubt": false, "max_auswahl": 0}, "galerie": {"text_begruessung": "Hallo,\n\ndeine fertigen Bilder sind bereit! Du kannst sie hier herunterladen.", "text_erklaerung": "", "text_abschluss": "Ich hoffe, du bist mit dem Ergebnis gluecklich!", "layout": "raster", "bildgroesse": "mittel", "bildabstand": "mittel", "kanten": "rund", "hintergrund": "dunkel", "kommentare": false, "downloads_erlaubt": true, "max_auswahl": 0}};

  useEffect(()=>{
    ladeGalerien();
    ladeGlobal();
    // Eigene IP automatisch merken
    fetch(serverUrl+"/api/meine-ip-merken",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({})}).catch(()=>{});
  },[]);
  useEffect(()=>{
    const g=globalEinst[neuerTyp]||{};
    setNeuBg(g.text_begruessung||"");
    setNeuEk(g.text_erklaerung||"");
    setNeuAb(g.text_abschluss||"");
    setNeuEmail(g.info_email||"");
  },[neuerTyp,globalEinst]);

  async function ladeGalerien(){
    try{const r=await fetch(serverUrl+"/api/galerie/alle");const d=await r.json();setGalerien(Array.isArray(d)?d:[]);}
    catch(e){console.warn(e);}
  }
  const [wzInfo,setWzInfo]=useState(null);
  const [wzBusy,setWzBusy]=useState("");
  async function ladeWz(){
    try{const r=await fetch(serverUrl+"/api/wasserzeichen-status");setWzInfo(await r.json());}
    catch(e){setWzInfo(null);}
  }
  async function wzHochladen(orientierung,datei){
    if(!datei)return;
    if(!serverUrl){alert("Keine Server-URL hinterlegt.");return;}
    setWzBusy(orientierung);
    try{
      // Als Text verschicken, nicht als Formular-Datenpaket. Das nimmt den
      // gleichen Weg wie alle anderen Anfragen und geht zuverlaessig durch.
      const daten=await new Promise((ok,fehl)=>{
        const leser=new FileReader();
        leser.onload=()=>ok(String(leser.result||"").split(",")[1]||"");
        leser.onerror=()=>fehl(new Error("Datei nicht lesbar"));
        leser.readAsDataURL(datei);
      });
      const r=await fetch(serverUrl+"/api/wasserzeichen-upload",{
        method:"POST",headers:{"Content-Type":"application/json"},
        body:JSON.stringify({orientierung,daten})});
      let d=null;
      try{d=await r.json();}catch(e){}
      if(!r.ok||!d||!d.ok)alert("Upload fehlgeschlagen (Status "+r.status+")"+((d&&d.error)?": "+d.error:""));
      await ladeWz();
    }catch(e){alert("Upload fehlgeschlagen: "+(e&&e.message?e.message:e));}
    setWzBusy("");
  }
  async function wzLoeschen(orientierung){
    if(!window.confirm("Wasserzeichen "+orientierung+"format wirklich entfernen?"))return;
    try{await fetch(serverUrl+"/api/wasserzeichen-loeschen?orientierung="+orientierung,{method:"POST"});await ladeWz();}
    catch(e){alert("Fehler");}
  }
  useEffect(()=>{if(serverUrl)ladeWz();},[serverUrl]);

  async function ladeGlobal(){
    try{const r=await fetch(serverUrl+"/api/galerie-global");const d=await r.json();
      if(d&&(d.feedback||d.galerie))setGlobalEinst(d);}
    catch(e){}
  }
  async function globalSpeichern(){
    try{
      const r=await fetch(serverUrl+"/api/galerie-global",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(globalEinst)});
      let d=null;
      try{d=await r.json();}catch(e){}
      if(!r.ok||!d||d.ok!==true){
        alert("Der Server hat die Voreinstellungen nicht angenommen"+(d&&d.error?": "+d.error:" (Status "+r.status+")")+
              "\n\nLäuft dort schon die neue Fassung?");
        return;
      }
      await ladeGlobal();   // zurücklesen, damit sichtbar ist was wirklich liegt
      await ladeWz();
      alert("Voreinstellungen gespeichert");
    }
    catch(e){alert("Server nicht erreichbar: "+e.message);}
  }
  async function ladeFull(token){
    try{const r=await fetch(serverUrl+"/api/galerie/"+token);const g=await r.json();setAktive(g);setAusgewaehlt(new Set());setNav("bilder");}
    catch(e){console.warn(e);}
  }
  useEffect(()=>{
    function onOpenGalerie(e){if(e.detail?.token)ladeFull(e.detail.token);}
    document.addEventListener("openGalerie",onOpenGalerie);
    return()=>document.removeEventListener("openGalerie",onOpenGalerie);
  },[]);
  async function galerieErstellen(){
    if(!neuerTitel.trim()){alert("Bitte Titel eingeben.");return;}
    setLoading(true);
    try{
      const basis=globalEinst[neuerTyp]||{};
      const bereinigt={...basis};
      ["text_begruessung","text_erklaerung","text_abschluss"].forEach(k=>{if(bereinigt[k]&&!bereinigt[k].trim())bereinigt[k]="";});
      const r=await fetch(serverUrl+"/api/galerie/erstellen",{method:"POST",headers:{"Content-Type":"application/json"},
        body:JSON.stringify({...bereinigt,titel:neuerTitel,vorname:neuVorname.trim(),typ:neuerTyp,text_begruessung:neuBg.trim()?neuBg:"",text_erklaerung:neuEk.trim()?neuEk:"",text_abschluss:neuAb.trim()?neuAb:"",info_email:neuEmail})});
      const d=await r.json();
      if(d.ok){await ladeGalerien();await ladeFull(d.token);setNav("bilder");setNeuerTitel("");setNeuVorname("");}
      else alert("Fehler: "+(d.error||"?"));
    }catch(e){alert("Verbindungsfehler");}
    setLoading(false);
  }
  async function bilderHochladen(dateien){
    if(!aktive||!dateien.length)return;
    const fd=new FormData();fd.append("token",aktive.token);
    for(const f of dateien)fd.append("dateien",f);
    setUploadInfo("Hochladen...");
    try{
      const r=await fetch(serverUrl+"/api/galerie/upload",{method:"POST",body:fd});
      const d=await r.json();
      if(d.ok){setUploadInfo(d.hochgeladen.length+" hochgeladen");await ladeFull(aktive.token);await ladeGalerien();}
      else setUploadInfo("Fehler");
    }catch(e){setUploadInfo("Fehler");}
    setTimeout(()=>setUploadInfo(""),3000);
  }
  async function bilderLoeschen(){
    if(!aktive||ausgewaehlt.size===0||!confirm(ausgewaehlt.size+" Bild(er) loeschen?"))return;
    try{
      const r=await fetch(serverUrl+"/api/galerie/"+aktive.token+"/bilder-loeschen",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({bilder:Array.from(ausgewaehlt)})});
      const d=await r.json();
      if(d.ok){setAusgewaehlt(new Set());await ladeFull(aktive.token);await ladeGalerien();}
    }catch(e){alert("Fehler");}
  }
  async function einstellungenSpeichern(){
    if(!aktive)return;
    try{await fetch(serverUrl+"/api/galerie/"+aktive.token+"/texte",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(aktive)});alert("Gespeichert");await ladeGalerien();}
    catch(e){alert("Fehler");}
  }
  async function downloadFreigeben(){
    if(!aktive||!confirm("Galerie freischalten? Der Feedback-Link wird ungueltig und ein neuer Galerie-Link wird erstellt."))return;
    try{
      const r=await fetch(serverUrl+"/api/galerie/"+aktive.token+"/download-freigeben",{method:"POST"});
      const d=await r.json();
      if(d.ok&&d.neuer_token){await ladeFull(d.neuer_token);await ladeGalerien();}
      else await ladeFull(aktive.token);
    }catch(e){alert("Fehler");}
  }
  async function statusSetzen(status){
    if(!aktive)return;
    try{await fetch(serverUrl+"/api/galerie/"+aktive.token+"/status-setzen",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({status})});await ladeFull(aktive.token);await ladeGalerien();}
    catch(e){alert("Fehler");}
  }
  async function galerieLoeschen(){
    if(!aktive||!confirm("Galerie loeschen?"))return;
    try{await fetch(serverUrl+"/api/galerie/"+aktive.token+"/loeschen",{method:"POST"});await ladeGalerien();setAktive(null);setNav("uebersicht");}
    catch(e){alert("Fehler");}
  }

  const sFarbe=(s)=>s==="abgeschlossen"?"#22c55e":s==="download"?"#a855f7":"#2a6a9a";
  const sLabel=(s)=>s==="abgeschlossen"?"Abgeschlossen":s==="download"?"Download":"Feedbackgalerie";
  const galUrl=(t)=>serverUrl+"/galerie/"+t;
  const fmtDt=(iso)=>{if(!iso)return"-";try{return new Date(iso).toLocaleString("de-DE",{day:"2-digit",month:"2-digit",year:"numeric",hour:"2-digit",minute:"2-digit"});}catch{return iso;}};
  const bilder=(aktive?.bilder||[]).slice().sort((a,b)=>{
    const rank=f=>{const n=(f.split("/").pop()||"").toUpperCase();if(n.startsWith("WEB"))return 0;if(n.startsWith("DRUCK"))return 1;return 2;};
    return rank(a)-rank(b)||a.localeCompare(b);
  });
  const inputStyle={width:"100%",background:"rgba(0,0,0,0.06)",border:"1px solid rgba(0,0,0,0.15)",borderRadius:8,padding:"8px 12px",color:T.text,fontSize:13,boxShadow:"inset 0 1px 3px rgba(0,0,0,0.08)"};

  const SI=({id,label})=>(
    <div onClick={()=>setNav(id)} style={{display:"flex",alignItems:"center",padding:"12px 16px",
      cursor:"pointer",borderLeft:"3px solid "+(nav===id?T.accent:"transparent"),
      background:nav===id?T.accentDim:"transparent",
      color:nav===id?T.accent:T.muted,fontSize:16,fontWeight:500,transition:"all 0.15s"}}>
      {label}
    </div>
  );

  // Fenster mit den letzten Ereignissen aller Galerien
  const EreignisFenster=()=>{
    const ICON={besuch:"👁",bewertung:"🚩",kommentar:"💬",download:"⬇",download_alle:"⬇",abgesendet:"✅"};
    const WERT={ja:"ja",vielleicht:"vielleicht",nein:"nein"};
    const FARBE={ja:"#16a34a",vielleicht:"#a16207",nein:"#dc2626"};
    const liste=ereignisFilter==="aktive"&&aktive
      ?alleEreignisse.filter(e=>e._token===aktive.token)
      :alleEreignisse;
    const wann=z=>{
      if(!z)return "";
      const d=new Date(z);if(isNaN(d))return z;
      const min=Math.floor((Date.now()-d.getTime())/60000);
      if(min<1)return "gerade eben";
      if(min<60)return `vor ${min} Min.`;
      if(min<1440)return `vor ${Math.floor(min/60)} Std.`;
      if(min<2880)return "gestern";
      return d.toLocaleDateString("de-DE")+" "+d.toLocaleTimeString("de-DE",{hour:"2-digit",minute:"2-digit"});
    };
    const text=e=>{
      const datei=<b style={{color:T.accent}}>{e.datei}</b>;
      const gal=<b style={{color:T.accent}}>{e._titel}</b>;
      if(e.art==="besuch")return<>besuchte die Galerie {gal}.</>;
      if(e.art==="bewertung")return<>markierte {datei} als <b style={{color:FARBE[e.wert]||T.text}}>{WERT[e.wert]||e.wert}</b> in {gal}.</>;
      if(e.art==="kommentar")return<>kommentierte {datei} in {gal}: „{e.text}"</>;
      if(e.art==="download")return<>lud {datei} aus {gal} herunter.</>;
      if(e.art==="download_alle")return<>lud die komplette Galerie {gal} als ZIP herunter ({e.anzahl} Dateien).</>;
      if(e.art==="abgesendet")return<>sendete das Feedback zu {gal} ab ({e.anzahl} bewertet).</>;
      return<>{e.art} in {gal}.</>;
    };
    return(
      <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.55)",zIndex:400,display:"flex",alignItems:"center",justifyContent:"center",padding:20}}
        onClick={()=>setEreignisseOffen(false)}>
        <div onClick={e=>e.stopPropagation()} style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:16,width:"100%",maxWidth:640,maxHeight:"85vh",display:"flex",flexDirection:"column",padding:24}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
            <div style={{fontFamily:"Georgia,serif",fontSize:19,color:T.text}}>Letzte Ereignisse</div>
            <button style={btn(T,"ghost",true)} onClick={()=>setEreignisseOffen(false)}>✕</button>
          </div>
          <div style={{display:"flex",gap:8,alignItems:"center",flexWrap:"wrap",marginBottom:14}}>
            <button style={{...btn(T,ereignisFilter==="alle"?"primary":"ghost",true)}}
              onClick={()=>setEreignisFilter("alle")}>Alle Galerien</button>
            <button style={{...btn(T,ereignisFilter==="aktive"?"primary":"ghost",true),opacity:aktive?1:0.45}}
              disabled={!aktive} onClick={()=>setEreignisFilter("aktive")}>Nur die geöffnete</button>
            <div style={{flex:1}}/>
            <button style={btn(T,"ghost",true)} onClick={()=>{
              const neu=new Date().toISOString();
              setEreignisGelesen(neu);localStorage.setItem("sd_gal_ereignis_gelesen",neu);
            }}>Alle als gelesen markieren</button>
          </div>
          <div style={{overflowY:"auto",flex:1,minHeight:0}}>
            {liste.length===0
              ?<div style={{color:T.muted,fontSize:13,padding:"20px 0"}}>Noch keine Ereignisse. Sobald deine Kunden die Galerien öffnen, steht hier alles, was sie tun.</div>
              :liste.map((e,i)=>{
                const neu=String(e.zeit||"")>ereignisGelesen;
                return(
                  <div key={i} style={{display:"flex",gap:12,padding:"11px 10px",borderBottom:`1px solid ${T.border}33`,
                       background:neu?T.accent+"0c":"transparent",borderRadius:8}}>
                    <div style={{width:26,height:26,flexShrink:0,borderRadius:"50%",border:`1px solid ${T.border}`,
                         display:"flex",alignItems:"center",justifyContent:"center",fontSize:13}}>{ICON[e.art]||"•"}</div>
                    <div style={{minWidth:0,flex:1}}>
                      <div style={{fontSize:12,color:T.muted,marginBottom:2}}>
                        <b style={{color:T.text}}>Besucher {e.besucher||"?"}</b> · {wann(e.zeit)}
                      </div>
                      <div style={{fontSize:13,color:T.text,lineHeight:1.5,wordBreak:"break-word"}}>{text(e)}</div>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    );
  };

  return(
    <div style={{display:"flex",height:"calc(100vh - 120px)",overflow:"hidden"}}>
      {ereignisseOffen&&<EreignisFenster/>}

      {/* ── Sidebar ── */}
      <div style={{width:220,flexShrink:0,borderRight:"1px solid "+T.border,display:"flex",flexDirection:"column",overflowY:"auto"}}>
        <SI id="uebersicht" label="Galerieübersicht"/>
        <div style={{padding:"6px 10px"}}>
          <button style={{...btn(T,"primary"),width:"100%",justifyContent:"center",fontSize:12,padding:"7px"}}
            onClick={()=>setNav("neu")}>+ Galerie erstellen</button>
        </div>
        <SI id="global" label="Voreinstellungen"/>
        {aktive&&(
          <>
            <div style={{padding:"12px 16px 4px",borderTop:"1px solid "+T.border,marginTop:8}}>
              <div style={{fontSize:18,fontWeight:700,color:T.text,lineHeight:1.3,wordBreak:"break-word",marginBottom:4}}>
                {(aktive.titel||"").replace(/<[^>]*>/g,"")}</div>
              <div style={{fontSize:11,color:sFarbe(aktive.status),fontWeight:600}}>{sLabel(aktive.status)}</div>
            </div>
            <SI id="bilder" label="Vorschau"/>
            {aktive&&(
              <a href={galUrl(aktive.token)+"?ansicht=feedback"} target="_blank" rel="noreferrer"
                title="Feedback-Ansicht in einem neuen Tab öffnen — ändert nichts am Kundenmodus"
                style={{display:"block",padding:"9px 14px",fontSize:12,color:T.muted,textDecoration:"none",
                        borderLeft:"3px solid transparent"}}
                onMouseEnter={e=>e.currentTarget.style.color=T.text}
                onMouseLeave={e=>e.currentTarget.style.color=T.muted}>
                ↗ Feedbackgalerie öffnen
              </a>
            )}
            <SI id="zugang" label="Kundenzugang"/>
            <SI id="einstellungen" label="Einstellungen"/>
          </>
        )}
      </div>

      {/* ── Rechte Seite ── */}
      <div style={{flex:1,overflowY:"auto",padding:24}}>

        {/* Neue Galerie */}
        {nav==="neu"&&(
          <div>
            <div style={{fontFamily:"Georgia,serif",fontSize:20,color:T.text,marginBottom:20}}>Neue Galerie erstellen</div>
            <GalMitVorschau T={T} data={{titel:neuerTitel,vorname:neuVorname,text_begruessung:neuBg,text_erklaerung:neuEk,text_abschluss:neuAb,hintergrund:"dunkel",layout:"raster",kanten:"rund",bildabstand:"mittel",bildgroesse:"mittel"}} typ={neuerTyp}>
              <div style={{display:"flex",gap:8,marginBottom:20}}>
                {[["feedback","Feedbackgalerie","Kunde bewertet Bilder"],["galerie","Galerie","Kunde laedt Bilder herunter"]].map(([typ,label,sub])=>(
                  <div key={typ} onClick={()=>setNeuerTyp(typ)}
                    style={{flex:1,padding:14,border:"2px solid "+(neuerTyp===typ?T.accent:T.border),
                      borderRadius:10,cursor:"pointer",background:neuerTyp===typ?T.accentDim:T.bg}}>
                    <div style={{fontWeight:700,fontSize:13,color:neuerTyp===typ?T.accent:T.text,marginBottom:3}}>{label}</div>
                    <div style={{fontSize:11,color:T.muted}}>{sub}</div>
                  </div>
                ))}
              </div>
              <div style={{marginBottom:20}}>
                <label style={{fontSize:12,color:T.muted,display:"block",marginBottom:6,fontWeight:600}}>Titel</label>
                <GalTxtEd T={T} value={neuerTitel} onChange={setNeuerTitel} singleLine={true}/>
              </div>
              <div style={{marginBottom:20}}>
                <label style={{fontSize:12,color:T.muted,display:"block",marginBottom:6,fontWeight:600}}>Vorname des Kunden</label>
                <input value={neuVorname} onChange={e=>setNeuVorname(e.target.value)} placeholder="z.B. Sabine"
                  style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:"9px 12px",color:T.text,fontSize:13,fontFamily:"inherit",outline:"none",width:"100%",boxSizing:"border-box"}}/>
              </div>
              <div style={{marginBottom:20}}>
                <label style={{fontSize:12,color:T.muted,display:"block",marginBottom:6,fontWeight:600}}>Begrüssungstext</label>
                <GalTxtEd T={T} storageKey="sd_galtxt_begruessung" value={neuBg} onChange={setNeuBg} rows={5}/>
                <div style={{fontSize:11,color:T.muted,marginTop:4}}>Mit <strong>{"{{vorname}}"}</strong> f&uuml;gst du den Vornamen ein.</div>
              </div>
              {neuerTyp==="feedback"&&(
                <div style={{marginBottom:20}}>
                  <label style={{fontSize:12,color:T.muted,display:"block",marginBottom:6,fontWeight:600}}>Erklaerungstext</label>
                  <GalTxtEd T={T} storageKey="sd_galtxt_erklaerung" value={neuEk} onChange={setNeuEk} rows={4}/>
                </div>
              )}
              <div style={{marginBottom:20}}>
                <label style={{fontSize:12,color:T.muted,display:"block",marginBottom:6,fontWeight:600}}>Abschlusstext</label>
                <GalTxtEd T={T} storageKey="sd_galtxt_abschluss" value={neuAb} onChange={setNeuAb} rows={4}/>
              </div>
              <div style={{marginBottom:20}}>
                <label style={{fontSize:12,color:T.muted,display:"block",marginBottom:6,fontWeight:600}}>Feedback-Mail an</label>
                <input value={neuEmail} onChange={e=>setNeuEmail(e.target.value)} placeholder="info@beispiel.de" style={inputStyle}/>
              </div>
              <div style={{display:"flex",gap:8}}>
                <button style={{...btn(T,"primary"),padding:"10px 28px",fontSize:14}} onClick={galerieErstellen} disabled={loading}>
                  {loading?"Wird erstellt...":"Galerie erstellen"}
                </button>
                <button style={{...btn(T,"ghost"),padding:"10px 20px"}} onClick={()=>setNav("uebersicht")}>Abbrechen</button>
              </div>
            </GalMitVorschau>
          </div>
        )}

        {/* Galerieübersicht */}
        {nav==="uebersicht"&&(
          <div>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
              <div style={{display:"flex",alignItems:"center",gap:12}}>
                <div style={{fontFamily:"Georgia,serif",fontSize:20,color:T.text}}>Alle Galerien</div>
                <button style={{...btn(T,"ghost"),fontSize:12}} onClick={()=>setEreignisseOffen(true)}>
                  🔔 Ereignisse{ereignisAnzahl>0?` (${ereignisAnzahl})`:""}
                </button>
              </div>
              <div style={{display:"flex",gap:8,alignItems:"center"}}>
                {ausgewaehlt.size>0&&(
                  <button style={{...btn(T,"ghost"),fontSize:12,color:"#ef4444"}} onClick={async()=>{
                    if(!confirm(ausgewaehlt.size+" Galerie(n) loeschen?"))return;
                    for(const token of ausgewaehlt){
                      try{await fetch(serverUrl+"/api/galerie/"+token+"/loeschen",{method:"POST"});}catch(e){}
                    }
                    setAusgewaehlt(new Set());await ladeGalerien();
                  }}>{ausgewaehlt.size} loeschen</button>
                )}
                <select value={galSort} onChange={e=>{setGalSort(e.target.value);localStorage.setItem("sd_gal_sort",e.target.value);}}
                  style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:8,padding:"7px 10px",color:T.text,fontSize:12,fontFamily:"inherit",outline:"none"}}>
                  <option value="neu">Neueste zuerst</option>
                  <option value="alt">Älteste zuerst</option>
                  <option value="titel">Nach Titel</option>
                </select>
                <button style={{...btn(T,"ghost"),fontSize:12}} onClick={ladeGalerien}>Aktualisieren</button>
              </div>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(420px,1fr))",gap:24}}>
              {galerien.length===0&&<div style={{gridColumn:"1/-1",textAlign:"center",padding:60,color:T.muted,border:"2px dashed "+T.border,borderRadius:12}}>Noch keine Galerien.</div>}
              {galSortiert.map(g=>{
                const dlLog=g.downloads_log||[];
                const hatDownloads=dlLog.length>0;
                const letzterDl=hatDownloads?dlLog[dlLog.length-1]:null;
                const gesamtDl=dlLog.reduce((s,d)=>s+(d.anzahl||0),0);
                const totalDateien=g.bilder?g.bilder.length:0;
                const alleHeruntergeladen=totalDateien>0&&gesamtDl>=totalDateien;
                const dlStatus=alleHeruntergeladen?"Alle heruntergeladen":`${gesamtDl} von ${totalDateien} Dateien`;
                const fbAnzahl=g.feedback?Object.values(g.feedback).filter(v=>v==="ja"||v==="vielleicht"||v==="nein").length:0;
                const fbAbgeschlossen=g.status==="abgeschlossen";
                return(
                <div key={g.token} style={{background:T.surface,border:"2px solid "+(ausgewaehlt.has(g.token)?T.accent:T.border),borderRadius:12,padding:"16px 24px",cursor:"pointer",position:"relative",minHeight:120}}
                  onMouseEnter={e=>e.currentTarget.style.borderColor=T.accent}
                  onMouseLeave={e=>e.currentTarget.style.borderColor=ausgewaehlt.has(g.token)?T.accent:T.border}
                  onClick={()=>{ladeFull(g.token);setNav("bilder");}}>
                  <div style={{position:"absolute",top:10,right:10}} onClick={e=>{e.stopPropagation();const ns=new Set(ausgewaehlt);ns.has(g.token)?ns.delete(g.token):ns.add(g.token);setAusgewaehlt(ns);}}>
                    <input type="checkbox" checked={ausgewaehlt.has(g.token)} onChange={()=>{}} style={{width:16,height:16,cursor:"pointer",accentColor:T.accent}}/>
                  </div>
                  <div style={{fontWeight:700,fontSize:18,color:T.text,marginBottom:2,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",paddingRight:28}}>
                    {(g.titel||"").replace(/<[^>]*>/g,"")}</div>
                  {/* Erstellungsdatum direkt unter dem Titel */}
                  <div style={{fontSize:12,color:T.muted,marginBottom:14}}>
                    {g.erstellt
                      ?"erstellt am "+new Date(g.erstellt).toLocaleDateString("de-DE",{day:"2-digit",month:"2-digit",year:"numeric"})
                        +" um "+new Date(g.erstellt).toLocaleTimeString("de-DE",{hour:"2-digit",minute:"2-digit"})
                      :"Erstelldatum unbekannt"}
                  </div>
                  {fbAnzahl>0&&(
                    <div style={{display:"flex",alignItems:"center",gap:8,fontSize:14,marginBottom:10,padding:"10px 12px",background:T.bg,borderRadius:7}}>
                      <span style={{color:T.muted,minWidth:64}}>Feedback</span>
                      <span style={{color:T.muted}}>·</span>
                      <span style={{color:T.text}}>{g.erstellt?new Date(g.erstellt).toLocaleDateString("de-DE"):"-"}</span>
                      <span style={{color:T.muted}}>·</span>
                      <span style={{color:T.text}}>{fbAnzahl} Bilder</span>
                      {fbAbgeschlossen&&<span style={{color:"#22c55e",fontWeight:700,marginLeft:"auto"}}>✓</span>}
                    </div>
                  )}
                  {hatDownloads&&letzterDl&&(
                    <div title="Klicken für die einzelnen Dateien"
                      onClick={e=>{e.stopPropagation();setDlDetail(g);}}
                      style={{display:"flex",alignItems:"center",gap:8,fontSize:14,marginBottom:10,padding:"10px 12px",background:T.bg,borderRadius:7,cursor:"pointer"}}>
                      <span style={{color:T.muted,minWidth:64}}>Download</span>
                      <span style={{color:T.muted}}>·</span>
                      <span style={{color:T.text}}>{letzterDl.datum?new Date(letzterDl.datum).toLocaleDateString("de-DE"):letzterDl.datum}</span>
                      <span style={{color:T.muted}}>·</span>
                      <span style={{color:alleHeruntergeladen?"#22c55e":T.accent,fontWeight:600}}>{dlStatus}</span>
                      <span style={{marginLeft:"auto",display:"inline-flex",alignItems:"center",gap:5,flexShrink:0,fontSize:12,fontWeight:700,color:T.accent,border:`1px solid ${T.accent}66`,background:T.accent+"1a",borderRadius:999,padding:"3px 10px"}}>
                        Dateien <span style={{fontSize:11}}>▾</span>
                      </span>
                      <span style={{color:"#22c55e",fontWeight:700,fontSize:16,flexShrink:0}}>{alleHeruntergeladen?"✓":"↓"}</span>
                    </div>
                  )}
                  {fbAnzahl===0&&!hatDownloads&&(
                    <div style={{display:"flex",justifyContent:"space-between",padding:"6px 8px",background:T.bg,borderRadius:7}}>
                      <span style={{fontSize:12,fontWeight:600,color:sFarbe(g.status)}}>{sLabel(g.status)}</span>
                      <span style={{fontSize:11,color:T.muted}}>{totalDateien} Dateien · {g.erstellt?new Date(g.erstellt).toLocaleDateString("de-DE"):"-"}</span>
                    </div>
                  )}

                </div>
                );
              })}
            </div>
            {dlDetail&&(()=>{
              // Einzeldownloads nach Tag gruppieren, neueste zuerst
              const roh=(dlDetail.downloads||[]).slice().sort((a,b)=>String(b.zeit||"").localeCompare(String(a.zeit||"")));
              const tage={};
              roh.forEach(d=>{const tag=String(d.zeit||"").slice(0,10)||"?";(tage[tag]=tage[tag]||[]).push(d);});
              const eintraege=Object.entries(tage);
              return(
                <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.55)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:400}} onClick={()=>setDlDetail(null)}>
                  <div style={{background:T.surface,borderRadius:14,width:560,maxHeight:"80vh",display:"flex",flexDirection:"column",border:`1px solid ${T.border}`}} onClick={e=>e.stopPropagation()}>
                    <div style={{padding:"16px 20px",borderBottom:`1px solid ${T.border}`,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                      <div>
                        <div style={{fontFamily:"Georgia,serif",fontSize:17,color:T.accent}}>Heruntergeladene Dateien</div>
                        <div style={{fontSize:12,color:T.muted,marginTop:2}}>{(dlDetail.titel||"").replace(/<[^>]*>/g,"")}</div>
                      </div>
                      <button onClick={()=>setDlDetail(null)} style={{background:"none",border:"none",fontSize:20,cursor:"pointer",color:T.muted}}>×</button>
                    </div>
                    <div style={{padding:"14px 20px",overflowY:"auto"}}>
                      {eintraege.length===0
                        ?<div style={{fontSize:13,color:T.muted}}>Für diese Galerie sind keine einzelnen Dateien protokolliert. Möglicherweise stammen die Downloads aus einer Zeit vor der Protokollierung.</div>
                        :eintraege.map(([tag,liste])=>(
                          <div key={tag} style={{marginBottom:16}}>
                            <div style={{fontSize:12,fontWeight:700,color:T.accent,marginBottom:6}}>
                              {tag==="?"?"Ohne Datum":new Date(tag).toLocaleDateString("de-DE")} · {liste.length} Datei{liste.length!==1?"en":""}
                            </div>
                            {liste.map((d,i)=>(
                              <div key={i} style={{display:"flex",justifyContent:"space-between",gap:12,fontSize:13,padding:"4px 0",borderBottom:`1px solid ${T.border}22`}}>
                                <span style={{color:T.text,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{d.datei}</span>
                                <span style={{color:T.muted,flexShrink:0}}>{String(d.zeit||"").slice(11,16)}</span>
                              </div>
                            ))}
                          </div>
                        ))}
                    </div>
                    <div style={{padding:"12px 20px",borderTop:`1px solid ${T.border}`,fontSize:11,color:T.muted}}>
                      Eigene Zugriffe werden über den IP-Filter ausgeklammert und tauchen hier nicht auf.
                    </div>
                  </div>
                </div>
              );
            })()}
          </div>
        )}

        {/* Voreinstellungen */}
        {nav==="global"&&(
          <div>
            <div style={{fontFamily:"Georgia,serif",fontSize:20,color:T.text,marginBottom:6}}>Voreinstellungen</div>
            <div style={{fontSize:13,color:T.muted,marginBottom:16}}>Diese Einstellungen werden automatisch fuer neue Galerien uebernommen.</div>
            <div style={{display:"flex",gap:8,marginBottom:20}}>
              {[["feedback","Feedbackgalerie"],["galerie","Download-Galerie"]].map(([typ,label])=>(
                <button key={typ} onClick={()=>setGlobalTyp(typ)}
                  style={{flex:1,padding:"8px",border:"2px solid "+(globalTyp===typ?T.accent:T.border),
                    borderRadius:8,cursor:"pointer",background:globalTyp===typ?T.accentDim:T.bg,
                    fontSize:13,fontWeight:600,color:globalTyp===typ?T.accent:T.muted}}>{label}</button>
              ))}
            </div>
            <GalTabs T={T} tabs={[["allgemein","Allgemein"],["abstimmung","Abstimmung"],["praesentation","Praesentation"],["sicherheit","Sicherheit"]]} aktiv={globalTab} setAktiv={setGlobalTab}/>
            <GalMitVorschau T={T} data={{...globalEinst[globalTyp],titel:"Mustervorlage"}} typ={globalTyp}>
              {globalTab==="allgemein"&&<GalBlockAllgemein T={T} btn={btn} data={globalEinst[globalTyp]||{}} globalEinst={globalEinst} VORLAGEN={VORLAGEN} setData={d=>setGlobalEinst(g=>({...g,[globalTyp]:typeof d==="function"?d(g[globalTyp]||{}):d}))}/>}
              {globalTab==="abstimmung"&&<GalBlockAbstimmung T={T} data={globalEinst[globalTyp]||{}} setData={d=>setGlobalEinst(g=>({...g,[globalTyp]:typeof d==="function"?d(g[globalTyp]||{}):d}))}/>}
              {globalTab==="praesentation"&&<GalBlockPraesentation T={T} data={globalEinst[globalTyp]||{}} setData={d=>setGlobalEinst(g=>({...g,[globalTyp]:typeof d==="function"?d(g[globalTyp]||{}):d}))}/>}
              {globalTab==="sicherheit"&&<>
                <GalBlockSicherheit T={T} data={globalEinst[globalTyp]||{}} setData={d=>setGlobalEinst(g=>({...g,[globalTyp]:typeof d==="function"?d(g[globalTyp]||{}):d}))}/>
              {(()=>{
                const wz=(globalEinst.wasserzeichen)||{aktiv:true,deckkraft:35};
                const setWz=u=>setGlobalEinst(g=>({...g,wasserzeichen:{...wz,...u}}));
                // Bewusst keine Unterkomponente: die wuerde bei jedem
                // Neuzeichnen neu entstehen und das Dateifeld verlieren.
                const feld=(orient,label)=>{
                  const id="wz-datei-"+orient;
                  const da=!!(wzInfo&&wzInfo[orient]);
                  return(
                  <div key={orient} style={{flex:1,minWidth:220,border:`1px solid ${T.border}`,borderRadius:10,padding:12,background:T.bg,position:"relative"}}>
                    <div style={{fontSize:12,fontWeight:700,color:T.text,marginBottom:6}}>{label}</div>
                    <div style={{fontSize:11,color:da?"#22c55e":T.muted,marginBottom:8}}>
                      {wzBusy===orient?"Wird hochgeladen ..."
                        :da?"\u2713 hinterlegt"+(wzInfo[orient+"_groesse"]?" ("+wzInfo[orient+"_groesse"].join(" \u00d7 ")+")":"")
                          :"noch keine Datei"}
                    </div>
                    <input id={id} type="file" accept="image/png,.png"
                      style={{position:"absolute",width:1,height:1,opacity:0,pointerEvents:"none"}}
                      onChange={e=>{const f=e.target.files&&e.target.files[0];e.target.value="";if(f)wzHochladen(orient,f);}}/>
                    <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                      <button type="button" style={{...btn(T,"ghost",true),fontSize:11}}
                        onClick={()=>{const el=document.getElementById(id);if(el)el.click();else alert("Dateifeld nicht gefunden");}}>
                        {da?"Ersetzen":"PNG w\u00e4hlen"}
                      </button>
                      {da&&(
                        <button type="button" onClick={()=>wzLoeschen(orient)} style={{...btn(T,"ghost",true),fontSize:11,color:"#e55"}}>Entfernen</button>
                      )}
                    </div>
                  </div>
                  );
                };
                return(
                  <div style={{marginTop:24,paddingTop:16,borderTop:"1px solid "+T.border}}>
                    <div style={{fontFamily:"Georgia,serif",fontSize:16,color:T.text,marginBottom:4}}>Wasserzeichen</div>
                    <div style={{fontSize:12,color:T.muted,marginBottom:14,lineHeight:1.6}}>
                      Wird nur in Feedbackgalerien angezeigt. Downloadgalerien bleiben unber\u00fchrt,
                      ebenso die Originaldateien. In deiner eigenen Ansicht siehst du die Bilder ohne Wasserzeichen.
                    </div>
                    <label style={{display:"flex",alignItems:"center",gap:8,fontSize:13,color:T.text,cursor:"pointer",marginBottom:14}}>
                      <input type="checkbox" checked={wz.aktiv!==false} onChange={e=>setWz({aktiv:e.target.checked})} style={{accentColor:T.accent}}/>
                      Wasserzeichen in Feedbackgalerien verwenden
                    </label>
                    <div style={{display:"flex",gap:12,flexWrap:"wrap",marginBottom:16}}>
                      {feld("hoch","Hochformat")}
                      {feld("quer","Querformat")}
                    </div>
                    <div style={{marginBottom:6,display:"flex",alignItems:"center",gap:12}}>
                      <span style={{fontSize:12,color:T.muted,minWidth:70}}>Deckkraft</span>
                      <input type="range" min={5} max={100} step={5} value={wz.deckkraft??35}
                        onChange={e=>setWz({deckkraft:Number(e.target.value)})}
                        style={{flex:1,accentColor:T.accent,maxWidth:360}}/>
                      <span style={{fontSize:13,fontWeight:700,color:T.accent,minWidth:44,textAlign:"right"}}>{wz.deckkraft??35} %</span>
                    </div>
                    <div style={{fontSize:11,color:T.muted,lineHeight:1.6}}>
                      Das passende Wasserzeichen wird nach dem Seitenverh\u00e4ltnis gew\u00e4hlt, formatf\u00fcllend
                      skaliert und mittig beschnitten. \u00c4nderst du Deckkraft oder Datei, werden die markierten
                      Vorschaubilder verworfen und beim n\u00e4chsten Aufruf neu berechnet.
                    </div>
                  </div>
                );
              })()}
              </>}
            </GalMitVorschau>
            <div style={{marginTop:20,paddingTop:16,borderTop:"1px solid "+T.border}}>
              <button style={{...btn(T,"primary"),padding:"10px 24px"}} onClick={globalSpeichern}>Voreinstellungen speichern</button>
            </div>
          </div>
        )}

        {/* Bilder-Überblick */}
        {nav==="bilder"&&aktive&&(
          <div>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
              <div style={{fontSize:15,fontWeight:600,color:T.text}} dangerouslySetInnerHTML={{__html:aktive.titel||""}}/>
              <div style={{display:"flex",gap:8,alignItems:"center"}}>
                {ausgewaehlt.size>0&&<>
                  <button style={{...btn(T,"ghost"),fontSize:12,color:"#ef4444"}} onClick={bilderLoeschen}>{ausgewaehlt.size} loeschen</button>
                  <button style={{...btn(T,"ghost"),fontSize:12}} onClick={()=>setAusgewaehlt(new Set())}>Aufheben</button>
                </>}
                <button style={{...btn(T,"ghost"),fontSize:12}}
                  onClick={()=>ausgewaehlt.size===bilder.length?setAusgewaehlt(new Set()):setAusgewaehlt(new Set(bilder))}>
                  {ausgewaehlt.size===bilder.length?"Alle ab":"Alle auswaehlen"}
                </button>
              </div>
            </div>
              <div style={{border:"2px dashed "+T.border,borderRadius:8,padding:12,marginBottom:12,display:"flex",alignItems:"center",gap:10}}>
                <input type="file" multiple accept=".jpg,.jpeg,.png,.webp,.tiff,.tif,.heic,.heif,.pdf"
                  style={{display:"none"}} id="gal-upload" onChange={e=>bilderHochladen(Array.from(e.target.files))}/>
                <label htmlFor="gal-upload" style={{...btn(T,"primary"),cursor:"pointer",fontSize:12}}>⬆ Bilder hinzufügen</label>
                {ausgewaehlt.size>0&&<button style={{...btn(T,"ghost"),fontSize:12,color:"#ef4444"}} onClick={bilderLoeschen}>🗑 {ausgewaehlt.size} Bild(er) löschen</button>}
                {uploadInfo&&<span style={{fontSize:12,color:T.accent}}>{uploadInfo}</span>}
              </div>
            {/* Vom Kunden ausgewaehlte Bilder — steht oben, weil das der Teil
                ist, mit dem weitergearbeitet wird. */}
            {(()=>{
              const ja=Object.entries(aktive.feedback||{}).filter(([,v])=>v==="ja").map(([b])=>b).sort();
              if(ja.length===0)return null;
              return(
                <div style={{marginBottom:20,background:T.surface,border:"1px solid #22c55e55",
                             borderLeft:"3px solid #22c55e",borderRadius:10,padding:16}}>
                  <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:10,flexWrap:"wrap"}}>
                    <div style={{fontWeight:700,fontSize:13,color:"#16a34a"}}>
                      Vom Kunden ausgewählt ({ja.length})
                    </div>
                    <button style={{...btn(T,"ghost",true),fontSize:11}}
                      onClick={()=>{
                        navigator.clipboard.writeText(ja.join("\n")).then(()=>setKopiert("ja")).catch(()=>{});
                        setTimeout(()=>setKopiert(""),1500);
                      }}>
                      {kopiert==="ja"?"✓ kopiert":"Dateinamen kopieren"}
                    </button>
                  </div>
                  <textarea readOnly value={ja.join("\n")} rows={Math.min(ja.length,8)}
                    onFocus={e=>e.target.select()}
                    style={{width:"100%",boxSizing:"border-box",background:T.bg,
                            border:"1px solid "+T.border,borderRadius:8,padding:"8px 10px",
                            color:T.text,fontSize:11,fontFamily:"monospace",lineHeight:1.6,
                            resize:"vertical",outline:"none"}}/>
                  <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(110px,1fr))",gap:8,marginTop:12}}>
                    {ja.map(b=>{
                      const tn=b.replace(/\.[^.]+$/,".jpg");
                      return(
                        <div key={b} style={{border:"2px solid #22c55e",borderRadius:8,overflow:"hidden",background:T.bg}}>
                          <img src={serverUrl+"/galerie-thumb/"+aktive.token+"/"+tn.split("/").map(encodeURIComponent).join("/")}
                            alt={b} loading="lazy"
                            style={{width:"100%",height:80,objectFit:"cover",display:"block"}}
                            onError={e=>{e.currentTarget.style.display="none";}}/>
                          <div style={{fontSize:9,color:T.muted,padding:"3px 5px",overflow:"hidden",
                                       textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{b}</div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })()}
            {bilder.length===0&&<div style={{textAlign:"center",padding:40,color:T.muted,fontSize:13}}>Noch keine Bilder.</div>}
            <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(130px,1fr))",gap:8}}>
              {bilder.map((bild,idx)=>{
                const sel=ausgewaehlt.has(bild);
                const fb=aktive.feedback?.[bild];
                const fbc=fb==="ja"?"#22c55e":fb==="vielleicht"?"#eab308":fb==="nein"?"#ef4444":T.border;
                const ext=bild.split(".").pop().toLowerCase();
                const istPdf=ext==="pdf";
                const tn=bild.replace(/\.[^.]+$/,".jpg");
                return(
                  <div key={bild} style={{position:"relative",border:"2px solid "+(sel?"#2a6a9a":fbc),borderRadius:8,overflow:"hidden",background:T.bg,cursor:"pointer"}}
                    onClick={e=>{if(e.shiftKey||ausgewaehlt.size>0){const ns=new Set(ausgewaehlt);if(ns.has(bild))ns.delete(bild);else ns.add(bild);setAusgewaehlt(ns);}else setVollbildIdx(idx);}}>
                    <div style={{position:"absolute",top:4,left:4,zIndex:2,width:16,height:16,borderRadius:3,
                      background:sel?"#2a6a9a":"rgba(0,0,0,0.45)",border:"1.5px solid "+(sel?"#2a6a9a":"rgba(255,255,255,0.5)"),
                      display:"flex",alignItems:"center",justifyContent:"center",color:"#fff",fontSize:10,fontWeight:700}}
                      onClick={e=>{e.stopPropagation();const ns=new Set(ausgewaehlt);if(ns.has(bild))ns.delete(bild);else ns.add(bild);setAusgewaehlt(ns);}}>
                      {sel?"v":""}
                    </div>
                    {istPdf
                      ?<img src={serverUrl+"/galerie-thumb/"+aktive.token+"/"+tn.split("/").map(encodeURIComponent).join("/")} alt={bild}
                        style={{width:"100%",height:150,objectFit:"contain",display:"block",background:"#fff"}} onError={e=>{e.target.style.display="none";e.target.nextSibling&&(e.target.nextSibling.style.display="flex");}}/>
                      :<img src={serverUrl+"/galerie-thumb/"+aktive.token+"/"+tn.split("/").map(encodeURIComponent).join("/")} alt={bild}
                        style={{width:"100%",height:90,objectFit:"cover",display:"block"}} onError={e=>e.target.style.display="none"}/>}
                    <div style={{padding:"3px 5px"}}>
                      <div style={{fontSize:9,color:T.muted,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{bild}</div>
                      {fb&&<div style={{fontSize:9,fontWeight:700,color:fbc}}>{fb==="ja"?"Ja":fb==="vielleicht"?"Vielleicht":"Nein"}</div>}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {/* Einstellungen */}
        {nav==="einstellungen"&&aktive&&(
          <div>
            <div style={{fontFamily:"Georgia,serif",fontSize:20,color:T.text,marginBottom:16}}>Galerie-Einstellungen</div>
            <GalTabs T={T} tabs={[["allgemein","Allgemein"],["abstimmung","Abstimmung"],["praesentation","Praesentation"],["sicherheit","Sicherheit"]]} aktiv={einstellTab} setAktiv={setEinstellTab}/>
            <GalMitVorschau T={T} data={aktive} typ={aktive.status==="download"?"galerie":"feedback"}>
              {einstellTab==="allgemein"&&<GalBlockAllgemein T={T} btn={btn} data={aktive} globalEinst={globalEinst} VORLAGEN={VORLAGEN} showVorlagen={true} showTitel={true} setData={d=>setAktive(a=>typeof d==="function"?d(a):{...a,...d})}/>}
              {einstellTab==="abstimmung"&&<GalBlockAbstimmung T={T} data={aktive} setData={d=>setAktive(a=>typeof d==="function"?d(a):{...a,...d})}/>}
              {einstellTab==="praesentation"&&<GalBlockPraesentation T={T} data={aktive} setData={d=>setAktive(a=>typeof d==="function"?d(a):{...a,...d})}/>}
              {einstellTab==="sicherheit"&&<GalBlockSicherheit T={T} data={aktive} setData={d=>setAktive(a=>typeof d==="function"?d(a):{...a,...d})} zeigLoeschen={true} onLoeschen={galerieLoeschen}/>}
            </GalMitVorschau>
            <div style={{marginTop:20,paddingTop:16,borderTop:"1px solid "+T.border}}>
              <button style={{...btn(T,"primary"),padding:"10px 24px"}} onClick={einstellungenSpeichern}>Aenderungen speichern</button>
            </div>
          </div>
        )}

        {/* Zugang */}
        {nav==="zugang"&&aktive&&(
          <div style={{maxWidth:540}}>
            <div style={{fontFamily:"Georgia,serif",fontSize:20,color:T.text,marginBottom:16}}>Kundenzugang</div>

            {/* Der Modus gehoert zum Link: er entscheidet, was der Kunde unter
                dieser Adresse zu sehen bekommt. */}
            <div style={{marginBottom:18,background:T.bg,border:"1px solid "+T.border,borderRadius:10,padding:14}}>
              <div style={{fontSize:12,color:T.muted,fontWeight:600,marginBottom:8,textTransform:"uppercase",letterSpacing:0.8}}>Modus</div>
              <div style={{display:"flex",borderRadius:8,overflow:"hidden",border:"1px solid "+T.border}}>
                <button onClick={()=>statusSetzen("offen")}
                  style={{flex:1,padding:"9px",border:"none",cursor:"pointer",fontSize:12,fontWeight:600,fontFamily:"inherit",
                    background:aktive.status!=="download"?T.accent:T.surface,
                    color:aktive.status!=="download"?"#fff":T.muted}}>Feedback – Kunde wählt aus</button>
                <button onClick={downloadFreigeben}
                  style={{flex:1,padding:"9px",border:"none",cursor:"pointer",fontSize:12,fontWeight:600,fontFamily:"inherit",
                    background:aktive.status==="download"?"#7c3aed":T.surface,
                    color:aktive.status==="download"?"#fff":T.muted}}>Galerie – Kunde lädt herunter</button>
              </div>
              <div style={{fontSize:11,color:T.muted,marginTop:8,lineHeight:1.5}}>
                Beim Wechsel auf Galerie wird ein neuer Link erzeugt, der alte Feedback-Link gilt dann nicht mehr.
              </div>
            </div>

            <div style={{marginBottom:20}}>
              <div style={{fontSize:12,color:T.muted,fontWeight:600,marginBottom:6,textTransform:"uppercase",letterSpacing:0.8}}>
                {aktive.status==="download"?"Galerie-Link":"Feedback-Link"}
              </div>
              <div style={{background:T.bg,border:"1px solid "+T.border,borderRadius:8,padding:10,fontFamily:"monospace",fontSize:12,color:T.muted,wordBreak:"break-all",marginBottom:8}}>
                {galUrl(aktive.token)}
              </div>
              <div style={{display:"flex",gap:8}}>
                <button style={{...btn(T,"primary"),flex:1,justifyContent:"center"}}
                  onClick={()=>{navigator.clipboard.writeText(galUrl(aktive.token));alert("Kopiert!");}}>Link kopieren</button>
                <a href={galUrl(aktive.token)} target="_blank" rel="noreferrer"
                  style={{...btn(T,"ghost"),flex:1,justifyContent:"center",textDecoration:"none"}}>Oeffnen</a>
              </div>
            </div>
            {/* Besuche und Downloads nebeneinander, damit sich beides
                vergleichen laesst, ohne zu scrollen. */}
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:20}}>
              <div>
                <div style={{fontSize:12,color:T.muted,fontWeight:600,marginBottom:8,textTransform:"uppercase",letterSpacing:0.8}}>
                  Besuche ({aktive.besuche?aktive.besuche.length:0})
                </div>
                {(!aktive.besuche||aktive.besuche.length===0)
                  ?<div style={{fontSize:12,color:T.muted}}>Noch keine Besuche.</div>
                  :[...aktive.besuche].reverse().map((b,i)=>(
                    <div key={i} style={{fontSize:12,color:T.muted,padding:"6px 0",borderBottom:"1px solid "+T.border+"33"}}>
                      {fmtDt(b.zeit)}
                    </div>
                  ))
                }
              </div>
              <div>
                <div style={{fontSize:12,color:T.muted,fontWeight:600,marginBottom:8,textTransform:"uppercase",letterSpacing:0.8}}>
                  Downloads ({aktive.downloads_log?aktive.downloads_log.length:0})
                </div>
                {(!aktive.downloads_log||aktive.downloads_log.length===0)
                  ?<div style={{fontSize:12,color:T.muted}}>Noch keine Downloads.</div>
                  :[...aktive.downloads_log].reverse().map((d,i)=>(
                    <div key={i} style={{fontSize:12,padding:"6px 0",borderBottom:"1px solid "+T.border+"33",
                         display:"flex",justifyContent:"space-between",gap:8}}>
                      <span style={{color:T.muted}}>
                        {d.datum?new Date(d.datum).toLocaleDateString("de-DE"):d.datum}
                        {d.uhrzeit?", "+d.uhrzeit:""}
                      </span>
                      <span style={{color:T.accent,fontWeight:600,whiteSpace:"nowrap"}}>
                        {d.zip?`ZIP · ${d.anzahl} Dateien`:`${d.anzahl} Datei(en)`}
                      </span>
                    </div>
                  ))
                }
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Vollbild */}
      {vollbildIdx!==null&&bilder.length>0&&aktive&&(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.96)",zIndex:1000,
          display:"flex",alignItems:"center",justifyContent:"center",flexDirection:"column"}}
          onClick={()=>setVollbildIdx(null)}>
          <button onClick={e=>{e.stopPropagation();setVollbildIdx(null);}}
            style={{position:"absolute",top:16,right:20,background:"none",border:"none",color:"#fff",fontSize:28,cursor:"pointer"}}>&#x2715;</button>
          <div style={{position:"relative",display:"flex",alignItems:"center"}}>
            <button onClick={e=>{e.stopPropagation();setVollbildIdx(i=>Math.max(0,i-1));}}
              style={{position:"absolute",left:-80,background:"rgba(255,255,255,0.15)",border:"none",color:"#fff",fontSize:28,cursor:"pointer",padding:"14px 20px",borderRadius:8}}>&#8592;</button>
            {bilder[vollbildIdx].toLowerCase().endsWith(".pdf")
              ?<div style={{textAlign:"center"}} onClick={e=>e.stopPropagation()}>
                <img src={serverUrl+"/galerie-thumb/"+aktive.token+"/"+encodeURIComponent(bilder[vollbildIdx].replace(/\.[^.]+$/,".jpg"))}
                  alt={bilder[vollbildIdx]} style={{maxWidth:"88vw",maxHeight:"75vh",objectFit:"contain",borderRadius:4,display:"block"}}
                  onError={e=>e.target.style.display="none"}/>
                <a href={serverUrl+"/galerie-datei/"+aktive.token+"/"+encodeURIComponent(bilder[vollbildIdx])}
                  target="_blank" rel="noreferrer"
                  style={{display:"inline-block",marginTop:12,padding:"8px 20px",background:"#2a6a9a",color:"#fff",borderRadius:8,textDecoration:"none",fontSize:13}}
                  onClick={e=>e.stopPropagation()}>PDF öffnen</a>
              </div>
              :<img src={serverUrl+"/galerie-datei/"+aktive.token+"/"+encodeURIComponent(bilder[vollbildIdx])}
                alt={bilder[vollbildIdx]} style={{maxWidth:"88vw",maxHeight:"82vh",objectFit:"contain",borderRadius:4}}
                onClick={e=>e.stopPropagation()}/>
            }
            <button onClick={e=>{e.stopPropagation();setVollbildIdx(i=>Math.min(bilder.length-1,i+1));}}
              style={{position:"absolute",right:-80,background:"rgba(255,255,255,0.15)",border:"none",color:"#fff",fontSize:28,cursor:"pointer",padding:"14px 20px",borderRadius:8}}>&#8594;</button>
          </div>
          <div style={{color:"#aaa",fontSize:13,marginTop:14}}>{bilder[vollbildIdx]}</div>
          <div style={{color:"#555",fontSize:11,marginTop:3}}>{vollbildIdx+1} / {bilder.length}</div>
        </div>
      )}
    </div>
  );
}


export default function App(){
  // Anzeigegroesse pro Geraet. Wird auf den Wurzelknoten angewendet, damit
  // Schrift, Abstaende und die Seitenleiste gleichmaessig mitskalieren.
  useEffect(()=>{
    const anwenden=v=>{
      const wert=Number(v)||100;
      const el=document.documentElement;
      if(wert===100){el.style.zoom="";return;}
      el.style.zoom=String(wert/100);
    };
    anwenden(localStorage.getItem("sd_ui_scale"));
    const h=e=>anwenden(e.detail);
    window.addEventListener("sd-ui-scale",h);
    return()=>window.removeEventListener("sd-ui-scale",h);
  },[]);

  // Service Worker registrieren für Cache-Kontrolle
  if(typeof window!=="undefined"&&"serviceWorker" in navigator){
    navigator.serviceWorker.register("/sw.js").catch(()=>{});
  }

  // Öffentliche Buchungsseite — wenn URL /buchen/[slug] ist
  const _pathname=window.location.pathname;
  const _buchMatch=_pathname.match(/^\/buchen\/([^/?]+)/);
  if(_buchMatch){
    const _slug=_buchMatch[1];
    const _vorort=new URLSearchParams(window.location.search).get("modus")==="vorort";

    // Config: erst localStorage, dann Server
    const PublicRouter=()=>{
      const [cfg,setCfg]=useState(()=>{try{return JSON.parse(localStorage.getItem("sd_buchung_config")||"null");}catch{return null;}});
      const [laden,setLaden]=useState(!cfg);
      const [fehler,setFehler]=useState(null);


  useEffect(()=>{
        if(cfg)return;
        // Config vom Server laden
        const serverUrl=window.location.origin;
        fetch(`${serverUrl}/api/buchung-config`)
          .then(r=>r.json())
          .then(data=>{setCfg(data);setLaden(false);})
          .catch(()=>{setFehler("Buchungsformular konnte nicht geladen werden.");setLaden(false);});
      },[]);

      // Seitentitel auf den Veranstaltungsnamen setzen. Browser schlagen beim
      // "Zum Startbildschirm hinzufuegen" meist genau diesen Titel vor, ohne
      // das haetten alle Icons denselben Namen egal welche Veranstaltung.
      useEffect(()=>{
        if(!cfg)return;
        const gefunden=(cfg.shootingTypes||[]).find(s=>s.buchungsUrl===_slug||(s.name||"").toLowerCase().replace(/\s+/g,"-")===_slug);
        document.title=gefunden?.name||"ScattoDesk";
      },[cfg]);

      if(laden) return(
        <div style={{minHeight:"100vh",background:"#F8F5F0",display:"flex",alignItems:"center",justifyContent:"center",fontFamily:"Georgia,serif",color:"#8A8075",fontSize:16}}>
          Buchungsformular wird geladen…
        </div>
      );
      if(fehler) return(
        <div style={{minHeight:"100vh",background:"#F8F5F0",display:"flex",alignItems:"center",justifyContent:"center",fontFamily:"Georgia,serif"}}>
          <div style={{textAlign:"center",color:"#8A8075"}}><div style={{fontSize:32,color:"#A8843E",marginBottom:12}}>SCATTODESK</div><div>{fehler}</div></div>
        </div>
      );
      const _norm=(s)=>(s||"").toLowerCase().replace(/ä/g,"ae").replace(/ö/g,"oe").replace(/ü/g,"ue").replace(/ß/g,"ss").replace(/[^a-z0-9]+/g,"-").replace(/^-|-$/g,"");
      const st=(cfg?.shootingTypes||[]).find(s=>s.buchungsUrl===_slug||_norm(s.name)===_slug||(s.name||"").toLowerCase().replace(/\s+/g,"-")===_slug);
      if(!st) return(
        <div style={{minHeight:"100vh",background:"#F8F5F0",display:"flex",alignItems:"center",justifyContent:"center",fontFamily:"Georgia,serif"}}>
          <div style={{textAlign:"center",color:"#8A8075"}}><div style={{fontSize:32,color:"#A8843E",marginBottom:12}}>SCATTODESK</div><div style={{fontSize:16,marginBottom:8}}>Buchungsformular nicht gefunden.</div><div style={{fontSize:13}}>Slug: <code>{_slug}</code></div></div>
        </div>
      );
      const _serverUrl=(cfg.serverUrl||(()=>{try{return localStorage.getItem("sd_server_url")||"";}catch{return "";}})("") ||window.location.origin).trim().replace(/\/+$/,"");
      const _BUCHUNG_FIX_V2="buchungen-fix-aktiv"; // Build-Marker
      const _vereinbarung=(st.vereinbarung?.de||"");
      const _studio={studioname:cfg.studioName||""};
      const _onBooked=async(booking)=>{
        try{
          const r=await fetch(`${_serverUrl}/api/buchungen`,{
            method:"POST",
            headers:{"Content-Type":"application/json"},
            body:JSON.stringify({booking,vereinbarung:_vereinbarung,studio:_studio,
              zahlungsart:(st.zahlungsart||"vorab"),
              stornoLink:booking.stornoToken?(window.location.origin+"/storno/"+booking.stornoToken):""})
          });
          const d=await r.json().catch(()=>({}));
          return d;
        }catch(e){console.warn("Buchung konnte nicht gespeichert werden:",e);return {};}
      };
      return <PublicBookingPage config={{...cfg,events:(()=>{try{return JSON.parse(localStorage.getItem("sd_events")||"[]");}catch{return [];}})()}} shootingType={st} forceVorort={_vorort} onBooked={_onBooked}/>;
    };
    return <PublicRouter/>;
  }

  const [dark,setDark]=useState(()=>{try{return localStorage.getItem("sd_dark_mode")==="false"?false:true;}catch{return true;}});
  const T=dark?DARK:LIGHT;
  const [page,setPage]=useState("dashboard");
  const mainRef=useRef(null);
  useEffect(()=>{
    const el=mainRef.current;
    if(!el)return;
    const scrollPages=["customers","statistik","calendar","buchung","reisekosten","newsletter","social","bestellungen","bildnummern","shootingkarte","gutscheine","events","einstellungen","bookings","homepage","inbox","galerien"];
    const handler=(e)=>{if(!scrollPages.includes(page))e.preventDefault();};
    el.addEventListener('wheel',handler,{passive:false});
    return()=>el.removeEventListener('wheel',handler);
  },[page]);

  // Pfeil-Hochzähler bei Zahlenfeldern global ausblenden (alle Browser)
  useEffect(()=>{
    if(document.getElementById("sd-no-spin"))return;
    const st=document.createElement("style");
    st.id="sd-no-spin";
    st.textContent='input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number]{-moz-appearance:textfield;appearance:textfield}';
    document.head.appendChild(st);
  },[]);

  // CRM State
  const [customers,setCustomers]=useState(()=>{try{
    const raw=JSON.parse(localStorage.getItem("sd_customers")||"null")||SEED_CUSTOMERS;
    // Migration: alte sevDesk-Importe legten die Adresse unter street/zip/city ab
    return raw.map(c=>({...c,strasse:c.strasse||c.street||"",plz:c.plz||c.zip||"",ort:c.ort||c.city||""}));
  }catch{return SEED_CUSTOMERS;}});
  const [bookings,setBookings]=useState(()=>{try{return JSON.parse(localStorage.getItem("sd_bookings")||"null")||SEED_BOOKINGS;}catch{return SEED_BOOKINGS;}});

  // ── Popup bei neuen Online-Anmeldungen ────────────────────────────────────
  // Prueft beim Start einmal den Server auf Buchungen, die noch nicht
  // quittiert wurden. Unabhaengig vom Buchungsplan-eigenen Abgleich, damit
  // das Popup auch erscheint, wenn man mit einer anderen Seite startet.
  const [neueAnmeldungen,setNeueAnmeldungen]=useState([]);
  useEffect(()=>{
    const serverUrl=(localStorage.getItem("sd_server_url")||"").trim().replace(/\/+$/,"")||window.location.origin;
    fetch(`${serverUrl}/api/buchungen`)
      .then(r=>r.ok?r.json():[])
      .then(liste=>{
        if(!Array.isArray(liste))return;
        const roh=localStorage.getItem("sd_anmeldungen_gesehen");
        if(roh===null){
          // Erster Start mit dieser Funktion: bestehende Buchungen als bekannt
          // markieren, sonst poppt beim ersten Mal alles Alte auf einmal auf.
          localStorage.setItem("sd_anmeldungen_gesehen",JSON.stringify(liste.filter(b=>b&&b.id).map(b=>b.id)));
          return;
        }
        let gesehen=[];
        try{gesehen=JSON.parse(roh)||[];}catch{}
        const gesehenSet=new Set(gesehen);
        const neu=liste.filter(b=>b&&b.id&&!gesehenSet.has(b.id)
          // Nur Buchungen ueber den festen QR-Code/Link zeigen. Vor-Ort-Buchungen
          // (ueber den Vor-Ort-Link/QR-Code, modus=vorort) haben ebenfalls ein
          // Datum, die Unterscheidung kommt allein aus dem vorOrt-Merker.
          &&b.vorOrt!==true)
          .sort((a,b)=>new Date(a.timestamp||0)-new Date(b.timestamp||0));
        if(neu.length>0)setNeueAnmeldungen(neu);
      })
      .catch(()=>{});
  },[]);

  function anmeldungName(b){
    const fd=b.formData||{};
    return fd.sys_name||((fd.sys_vorname||"")+" "+(fd.sys_nachname||"")).trim()||"Unbekannt";
  }
  function anmeldungDatum(b){
    if(!b.datum)return "";
    try{const d=new Date(b.datum);return isNaN(d)?b.datum:d.toLocaleDateString("de-DE",{day:"2-digit",month:"2-digit",year:"numeric"});}catch{return b.datum;}
  }
  function quittiereAnmeldungen(){
    let gesehen=[];
    try{gesehen=JSON.parse(localStorage.getItem("sd_anmeldungen_gesehen")||"[]")||[];}catch{}
    const set=new Set(gesehen);
    neueAnmeldungen.forEach(b=>{if(b&&b.id)set.add(b.id);});
    localStorage.setItem("sd_anmeldungen_gesehen",JSON.stringify([...set]));
    setNeueAnmeldungen([]);
  }
  // Server-Restore: nur wenn localStorage leer ist
  useEffect(()=>{
    const su=(localStorage.getItem("sd_server_url")||"").trim().replace(/\/+$/,"");
    if(!su)return;
    const local=JSON.parse(localStorage.getItem("sd_bookings")||"[]");
    if(local.length>0)return; // localStorage hat Daten - nicht überschreiben
    fetch(su+"/api/sync-data?key=sd_bookings").then(r=>r.json()).then(d=>{
      if(d.data&&Array.isArray(d.data)&&d.data.length>0){
        setBookings(d.data);localStorage.setItem("sd_bookings",JSON.stringify(d.data));
      }
    }).catch(()=>{});
  },[]);

  // ── Automatisches Backup bei Start und Schliessen ─────────────────────────
  // Sichert alle sd_-Schluessel aus dem localStorage auf dem Server. Reines
  // Sichern, kein automatisches Wiederherstellen -- das hatte frueher zu
  // ueberschriebenen Daten gefuehrt und wurde deshalb entfernt.
  useEffect(()=>{
    const su=(localStorage.getItem("sd_server_url")||"").trim().replace(/\/+$/,"")||window.location.origin;

    function sammleBackupDaten(){
      const daten={};
      for(let i=0;i<localStorage.length;i++){
        const k=localStorage.key(i);
        if(!k||!k.startsWith("sd_"))continue;
        const roh=localStorage.getItem(k);
        try{daten[k]=JSON.parse(roh);}catch{daten[k]=roh;}
      }
      return daten;
    }

    // Beim Start einmal sichern
    fetch(su+"/api/backup",{
      method:"POST",headers:{"Content-Type":"application/json"},
      body:JSON.stringify({daten:sammleBackupDaten(),anlass:"start"}),
    }).catch(()=>{});

    // Beim Schliessen/Reload per sendBeacon, das uebersteht das Entladen der
    // Seite -- ein normaler fetch wuerde in dem Moment oft abgebrochen.
    function beimSchliessen(){
      try{
        const payload=JSON.stringify({daten:sammleBackupDaten(),anlass:"schliessen"});
        navigator.sendBeacon(su+"/api/backup",new Blob([payload],{type:"application/json"}));
      }catch{}
    }
    window.addEventListener("beforeunload",beimSchliessen);
    window.addEventListener("pagehide",beimSchliessen);
    return()=>{
      window.removeEventListener("beforeunload",beimSchliessen);
      window.removeEventListener("pagehide",beimSchliessen);
    };
  },[]);

  const [events,setEvents]=useState(()=>{try{return JSON.parse(localStorage.getItem("sd_events")||"null")||SEED_EVENTS;}catch{return SEED_EVENTS;}});
  const [qBook,setQBook]=useState(false);
  const [qTerminWahl,setQTerminWahl]=useState(false);
  const [qEventModal,setQEventModal]=useState(false);
  const [qInteresseModal,setQInteresseModal]=useState(false);
  const [qCust,setQCust]=useState(false);

  // Statistik State (Multi-Profil)
  const [shootingplanInitData,setShootingplanInitData]=useState(null);
  const [shootingplanResetKey,setShootingplanResetKey]=useState(0);
  const [shootingplanAbrData,setShootingplanAbrData]=useState(null);

  // Verknüpfter Buchungsplan pro Veranstaltung
  const [buchungFocusId,setBuchungFocusId]=useState(null);
  const [buchungResetKey,setBuchungResetKey]=useState(0);
  const [eventsResetKey,setEventsResetKey]=useState(0);
  const [buchungFocusView,setBuchungFocusView]=useState(null);

  // Ordnerstruktur auf Server anlegen wenn neue Veranstaltung erstellt wird
  function erstelleServerOrdner(ev){
    try{
      const apiSettings=JSON.parse(localStorage.getItem("sd_api_settings")||"{}");
      const unterordner=Array.isArray(apiSettings.subFolders)?apiSettings.subFolders:["Shootingvereinbarungen","Rechnungen","Bilder"];
      const basis=apiSettings.basePath||"E:\\Fotografie\\Scatto\\Veranstaltungen";
      fetch("https://localhost/api/ordner",{
        method:"POST",
        headers:{"Content-Type":"application/json"},
        body:JSON.stringify({name:ev.name,datum:ev.date,unterordner,basis})
      }).then(r=>r.json()).then(d=>{
        if(d.ok){
          const msg=document.createElement("div");
          msg.textContent="✓ Ordner angelegt: "+d.pfad;
          Object.assign(msg.style,{position:"fixed",bottom:"24px",left:"50%",transform:"translateX(-50%)",background:"#27ae60",color:"#fff",padding:"10px 20px",borderRadius:"8px",fontSize:"13px",zIndex:"9999",boxShadow:"0 4px 12px #0004"});
          document.body.appendChild(msg);
          setTimeout(()=>msg.remove(),4000);
        } else {
          console.warn("Ordner-Fehler:",d.fehler||d);
          alert("Ordner konnte nicht angelegt werden: "+(d.fehler||JSON.stringify(d)));
        }
      }).catch(e=>{
        console.warn("Ordner-Request fehlgeschlagen:",e);
        alert("Verbindung zum lokalen Server fehlgeschlagen. Läuft server.py?");
      });
    }catch(e){console.warn(e);}
  }

  function buchungsplanFuerEvent(ev){
    if(!ev)return null;
    let cfg;
    try{cfg=JSON.parse(localStorage.getItem("sd_buchung_config")||"null");}catch{cfg=null;}
    if(!cfg||!Array.isArray(cfg.shootingTypes))return null;
    const vorhanden=cfg.shootingTypes.find(s=>s.eventId===ev.id);
    if(vorhanden)return vorhanden.id;
    const tpl=cfg.shootingTypes.find(s=>s.name==="Veranstaltung")||cfg.shootingTypes[0]||{};
    const neuId="st_ev_"+ev.id;
    const slug=(n=>(n||"").toLowerCase().replace(/ä/g,"ae").replace(/ö/g,"oe").replace(/ü/g,"ue").replace(/ß/g,"ss").replace(/[^a-z0-9]+/g,"-").replace(/^-+|-+$/g,""))(ev.name)||"veranstaltung";
    const neu={
      ...JSON.parse(JSON.stringify(tpl)),
      id:neuId,
      eventId:ev.id,
      name:ev.name||"Veranstaltung",
      buchungsUrl:slug,
      preis:(ev.preise&&Number(ev.preise.shootingGebuehr))||0,
      preisWeitererHund:(ev.preise&&Number(ev.preise.preisWeitererHund))||0,
      slots:[],
      aktiv:true,
      hp_aktiv:true,
      // Textfelder bleiben bei einer neuen Veranstaltung immer leer,
      // damit nichts aus der Vorlage uebernommen wird.
      beschreibung:{de:"",en:""},
      event_info:"",
      kopfbereich:"",
      kopfbereich_en:"",
      kopfbereich_l3:"",
      slotInfo:{de:"",en:""},
      hp_beschreibung:"",
      hp_slogan:"",
      interesse_info:"",
      vorortHinweis:"",
      ...(ev.interessenliste_event?{
        vereinbarung:{de:"",en:""},
        interessenliste:true,
        terminoptionen:ev.terminoptionen||[],
      }:{}),
    };
    if(Array.isArray(neu.felder))neu.felder=neu.felder.map((f,i)=>({...f,id:(f.id||"f")+"_"+ev.id+"_"+i}));
    const merged={...cfg,shootingTypes:[...cfg.shootingTypes,neu]};
    try{localStorage.setItem("sd_buchung_config",JSON.stringify(merged));}catch{}
    return neuId;
  }
  function oeffneBuchungsplan(ev,view){
    if(ev){const id=buchungsplanFuerEvent(ev);if(id)setBuchungFocusId(id);}
    setBuchungFocusView(view||null);
    setPage("buchung");
  }
  // Veranstaltung samt Veranstaltungsplan, Abrechnung und Buchungsplan löschen
  function deleteVeranstaltung(id){
    setEvents(p=>p.filter(e=>e.id!==id));
    try{const sp=JSON.parse(localStorage.getItem("sd_shootingplaene")||"{}");if(sp&&sp[id]){delete sp[id];localStorage.setItem("sd_shootingplaene",JSON.stringify(sp));}}catch{}
    try{const cfg=JSON.parse(localStorage.getItem("sd_buchung_config")||"null");if(cfg&&Array.isArray(cfg.shootingTypes)){cfg.shootingTypes=cfg.shootingTypes.filter(s=>s.eventId!==id);localStorage.setItem("sd_buchung_config",JSON.stringify(cfg));}}catch{}
  }
  const [profiles,setProfiles]=useState(()=>{
    try{
      const saved=JSON.parse(localStorage.getItem("sd_profiles")||"null")||[SEED_PROFILE];
      // Migration: "Sonstiges" als Shooting-Typ ergänzen falls fehlt
      return saved.map(p=>{
        const names=new Set((p.shootingTypes||[]).map(s=>s.name));
        const st=[...(p.shootingTypes||[])];
        if(!names.has("Sonstiges"))st.push({id:uid(),name:"Sonstiges",aktiv:true});
        return {...p,shootingTypes:st};
      });
    }catch{return [SEED_PROFILE];}
  });
  const [activeProfileId,setActiveProfileId]=useState(()=>{const p=JSON.parse(localStorage.getItem("sd_profiles")||"null");return p?.[0]?.id||"";});
  const [showProfilModal,setShowProfilModal]=useState(null);
  const [showProfilDropdown,setShowProfilDropdown]=useState(false);
  const [showLPHinweis,setShowLPHinweis]=useState(false);
  const [lpHinweisBlink,setLpHinweisBlink]=useState(false);
  const lpHinweisTimer=useRef([]);

  // Steuert die Phasen des LP-Hinweises: 5s ruhig stehen, 5s blinken, dann weg.
  function starteLPHinweis(){
    lpHinweisTimer.current.forEach(clearTimeout);
    setLpHinweisBlink(false);
    setShowLPHinweis(true);
    lpHinweisTimer.current=[
      setTimeout(()=>setLpHinweisBlink(true),5000),
      setTimeout(()=>{setShowLPHinweis(false);setLpHinweisBlink(false);},10000),
    ];
  }

  useEffect(()=>{
    localStorage.setItem("sd_customers",JSON.stringify(customers));
    const su=(localStorage.getItem("sd_server_url")||"").trim().replace(/\/+$/,"");
    if(su)fetch(su+"/api/sync-data",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({key:"sd_customers",data:customers})}).catch(()=>{});
  },[customers]);
  useEffect(()=>{
    localStorage.setItem("sd_bookings",JSON.stringify(bookings));
    const su=(localStorage.getItem("sd_server_url")||"").trim().replace(/\/+$/,"");
    if(su)fetch(su+"/api/sync-data",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({key:"sd_bookings",data:bookings})}).catch(()=>{});
  },[bookings]);
  useEffect(()=>{
    localStorage.setItem("sd_events",JSON.stringify(events));
    const su=(localStorage.getItem("sd_server_url")||"").trim().replace(/\/+$/,"");
    if(su)fetch(su+"/api/sync-data",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({key:"sd_events",data:events})}).catch(()=>{});
  },[events]);
  useEffect(()=>{localStorage.setItem("sd_profiles",JSON.stringify(profiles));},[profiles]);
  // Wenn an anderer Stelle Statistik-Einträge geschrieben wurden, State nachladen
  useEffect(()=>{
    const h=()=>{try{const p=JSON.parse(localStorage.getItem("sd_profiles")||"null");if(Array.isArray(p)&&p.length)setProfiles(p);}catch{}};
    window.addEventListener("sd-profiles-updated",h);
    return()=>window.removeEventListener("sd-profiles-updated",h);
  },[]);

  const activeProfile=profiles.find(p=>p.id===activeProfileId)||profiles[0];
  function updateProfile(updated){setProfiles(p=>p.map(x=>x.id===updated.id?updated:x));}
  function saveProfilModal(p){
    if(showProfilModal==="new"){setProfiles(prev=>[...prev,p]);setActiveProfileId(p.id);}
    else setProfiles(prev=>prev.map(x=>x.id===p.id?p:x));
    setShowProfilModal(null);
  }
  function deleteProfile(id){
    if(profiles.length<=1){alert("Mindestens ein Profil muss vorhanden bleiben.");return;}
    if(!confirm("Profil und alle Daten wirklich löschen?"))return;
    const remaining=profiles.filter(p=>p.id!==id);
    setProfiles(remaining);setActiveProfileId(remaining[0].id);
  }

  const NAV_ICONS={
    dashboard:   <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="1" y="1" width="6" height="6" rx="1"/><rect x="9" y="1" width="6" height="6" rx="1"/><rect x="1" y="9" width="6" height="6" rx="1"/><rect x="9" y="9" width="6" height="6" rx="1"/></svg>,
    bookings:    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="12" height="13" rx="1.5"/><line x1="5" y1="6" x2="11" y2="6"/><line x1="5" y1="9" x2="11" y2="9"/><line x1="5" y1="12" x2="8" y2="12"/></svg>,
    calendar:    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="1.5" y="3" width="13" height="11" rx="1.5"/><line x1="1.5" y1="7" x2="14.5" y2="7"/><line x1="5" y1="1.5" x2="5" y2="4.5"/><line x1="11" y1="1.5" x2="11" y2="4.5"/></svg>,
    customers:   <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="6" cy="5" r="3"/><path d="M1 14c0-3 2-5 5-5s5 2 5 5"/><circle cx="12" cy="5" r="2"/><path d="M14 13c0-2-1-3.5-2.5-4"/></svg>,
    events:      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="1.5" y="2" width="13" height="12" rx="1.5"/><line x1="5" y1="6" x2="11" y2="6"/><line x1="5" y1="9" x2="11" y2="9"/><line x1="5" y1="12" x2="8" y2="12"/><line x1="11" y1="10" x2="11" y2="14"/><line x1="9" y1="12" x2="13" y2="12"/></svg>,
    statistik:   <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><line x1="2" y1="14" x2="14" y2="14"/><rect x="3" y="8" width="2.5" height="6"/><rect x="6.75" y="5" width="2.5" height="9"/><rect x="10.5" y="2" width="2.5" height="12"/></svg>,
    shootingplan:<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="8" cy="8" r="6"/><circle cx="8" cy="8" r="2.5"/><line x1="8" y1="1.5" x2="8" y2="4"/><line x1="8" y1="12" x2="8" y2="14.5"/><line x1="1.5" y1="8" x2="4" y2="8"/><line x1="12" y1="8" x2="14.5" y2="8"/></svg>,
    buchung:     <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="1.5" width="12" height="13" rx="1.5"/><line x1="5" y1="5" x2="11" y2="5"/><line x1="5" y1="8" x2="9" y2="8"/><polyline points="8,10.5 10.5,13 14.5,8.5"/></svg>,
    homepage:    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="8" cy="8" r="6"/><line x1="2" y1="8" x2="14" y2="8"/><path d="M8 2c-2 2-2.5 4-2.5 6s.5 4 2.5 6"/><path d="M8 2c2 2 2.5 4 2.5 6s-.5 4-2.5 6"/></svg>,
    bildnummern: <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="1.5" width="12" height="13" rx="1.5"/><line x1="5" y1="5" x2="11" y2="5"/><line x1="5" y1="8" x2="11" y2="8"/><line x1="5" y1="11" x2="8" y2="11"/><circle cx="11" cy="11" r="1.8" fill="currentColor" stroke="none"/></svg>,
    gutscheine:  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="1.5" y="5" width="13" height="9" rx="1.5"/><path d="M8 5v9"/><path d="M1.5 9.5h13"/><path d="M8 5C8 3 6.5 1.5 5.2 1.5 4 1.5 3.5 2.5 4 3.5 4.6 4.6 8 5 8 5z"/><path d="M8 5c0-2 1.5-3.5 2.8-3.5 1.2 0 1.7 1 1.2 2C11.4 4.6 8 5 8 5z"/></svg>,
    newsletter:  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="1.5" y="3" width="13" height="10" rx="1.5"/><polyline points="1.5,4.5 8,9 14.5,4.5"/></svg>,
    shootingkarte:<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M8 1.5C5.5 1.5 3.5 3.5 3.5 6c0 3.5 4.5 8.5 4.5 8.5S12.5 9.5 12.5 6C12.5 3.5 10.5 1.5 8 1.5z"/><circle cx="8" cy="6" r="1.8"/></svg>,
    reisekosten: <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="1" y="7" width="14" height="5" rx="1.5"/><path d="M3 7l2-3h6l2 3"/><circle cx="4" cy="12.5" r="1.2"/><circle cx="12" cy="12.5" r="1.2"/><line x1="6" y1="14" x2="10" y2="14"/></svg>,
    einstellungen:<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="8" cy="8" r="2.2"/><path d="M8 1.5v2M8 12.5v2M1.5 8h2M12.5 8h2M3.5 3.5l1.4 1.4M11.1 11.1l1.4 1.4M12.5 3.5l-1.4 1.4M4.9 11.1l-1.4 1.4"/></svg>,
    galerien:    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="1.5" y="3" width="13" height="10" rx="1.5"/><path d="M1.5 10l3.5-3.5 2.5 2.5 2-2 4 4"/><circle cx="11" cy="6" r="1.2"/></svg>,
    social:      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M2 3.5h12v8H6.5L3.5 14v-2.5H2z"/><line x1="5" y1="6.5" x2="11" y2="6.5"/><line x1="5" y1="9" x2="9" y2="9"/></svg>,
    bestellungen:<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M1.5 2h1.7l1.3 8.2a1 1 0 0 0 1 .8h6.6a1 1 0 0 0 1-.8L14.3 5H4"/><circle cx="6" cy="13.5" r="1"/><circle cx="12" cy="13.5" r="1"/></svg>,
  };
  const nav=[
    {id:"dashboard",    label:"Übersicht"},
    {id:"customers",    label:"Kontakte",gap:true},
    {id:"calendar",     label:"Kalender",gap:true},
    {id:"bookings",     label:"Einzeltermine"},
    {id:"buchung",      label:"Buchungsplan",gap:true},
    {id:"shootingplan", label:"Veranstaltungsplan"},
    {id:"events",       label:"Abrechnung"},
    {id:"galerien",     label:"Galerien",gap:true},
    {id:"shootingkarte",label:"Shootingkarte",gap:true},
    {id:"reisekosten",  label:"Reiseplaner"},
    {id:"bildnummern",  label:"Bildnummern",gap:true},
    {id:"statistik",    label:"Statistik"},
    {id:"gutscheine",   label:"Gutscheine"},
    {id:"newsletter",   label:"Newsletter"},
    {id:"social",       label:"Social"},
    {id:"bestellungen", label:"Bestellungen"},
    {id:"einstellungen",label:"Einstellungen",gap:true},
  ];

  const pageTitle={bestellungen:"Bestellungen",dashboard:"Übersicht",calendar:"Kalender",bookings:"Einzeltermine",customers:"Kontakte",events:"Abrechnung Veranstaltung",statistik:"Statistik",shootingplan:"Veranstaltungsplan",buchung:"Buchungsplan",homepage:"Homepage Export",gutscheine:"Gutscheine",bildnummern:"Bildnummern",einstellungen:"Einstellungen",newsletter:"Newsletter",social:"Social",reisekosten:"Reiseplaner",shootingkarte:"Shootingkarte",galerien:"Galerien"};

  return(
    <>
    {neueAnmeldungen.length>0&&(
      <Modal title={neueAnmeldungen.length===1?"Neue Anmeldung":"Neue Anmeldungen"} T={T}>
        <div style={{display:"flex",flexDirection:"column",gap:10,marginBottom:20}}>
          {neueAnmeldungen.map(b=>(
            <div key={b.id} style={{display:"flex",justifyContent:"space-between",gap:12,padding:"10px 12px",background:T.bg,border:`1px solid ${T.border}`,borderRadius:8}}>
              <div>
                <div style={{fontWeight:600,color:T.text}}>{anmeldungName(b)}</div>
                <div style={{fontSize:12,color:T.muted,marginTop:2}}>{b.shootingType||"—"}</div>
              </div>
              <div style={{fontSize:12,color:T.muted,textAlign:"right",whiteSpace:"nowrap"}}>{anmeldungDatum(b)}</div>
            </div>
          ))}
        </div>
        <button style={{...btn(T,"primary"),width:"100%",justifyContent:"center",padding:"12px 16px"}} onClick={quittiereAnmeldungen}>
          Quittieren
        </button>
      </Modal>
    )}
    <div style={{display:"flex",minHeight:"100vh",background:T.bg,color:T.text,fontFamily:"Inter,system-ui,sans-serif",fontSize:14,lineHeight:1.6}}>
      <aside style={{width:260,flexShrink:0,background:T.surface,borderRight:`1px solid ${T.border}`,display:"flex",flexDirection:"column",padding:"24px 0 0",position:"sticky",top:0,height:"100vh",overflow:"hidden"}}>
        {/* Klick auf das Logo laedt die Seite neu. */}
        <div onClick={()=>window.location.reload()}
          title="Seite neu laden"
          style={{padding:"0 20px 20px",borderBottom:`1px solid ${T.border}`,marginBottom:16,cursor:"pointer"}}>
          <svg viewBox="0 0 180 52" width="220" height="80" xmlns="http://www.w3.org/2000/svg">
            <defs><linearGradient id="sgA" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stopColor="#E8D08A"/><stop offset="100%" stopColor="#A8843E"/></linearGradient></defs>
            <g transform="translate(22,26)">
              <circle cx="0" cy="0" r="20" fill="none" stroke="url(#sgA)" strokeWidth="1.5"/>
              <circle cx="0" cy="0" r="12" fill="none" stroke="url(#sgA)" strokeWidth="0.6" opacity="0.4"/>
              <g fill="none" stroke="url(#sgA)" strokeWidth="1.3" strokeLinejoin="round">
                <polygon points="20,0 10,17.32 0,8 6.73,8"/>
                <polygon points="10,17.32 -10,17.32 -6.73,8 0,8"/>
                <polygon points="-10,17.32 -20,0 -6.73,-8 -6.73,8"/>
                <polygon points="-20,0 -10,-17.32 0,-8 -6.73,-8"/>
                <polygon points="-10,-17.32 10,-17.32 6.73,-8 0,-8"/>
                <polygon points="10,-17.32 20,0 6.73,8 6.73,-8"/>
              </g>
              <circle cx="0" cy="0" r="4" fill="url(#sgA)"/>
              <circle cx="0" cy="0" r="2" fill={T.bg}/>
            </g>
            <text x="48" y="24" fontFamily="Georgia,serif" fontSize="14" fontWeight="700" letterSpacing="2" fill={T.text}>SCATTO</text>
            <line x1="48" y1="28" x2="176" y2="28" stroke="url(#sgA)" strokeWidth="0.5" opacity="0.5"/>
            <text x="49" y="40" fontFamily="Georgia,serif" fontSize="13" fontWeight="300" letterSpacing="6" fill="url(#sgA)">DESK</text>
          </svg>
          <div style={{fontSize:11,color:T.muted,marginTop:6}}>{new Date().toLocaleDateString("de-DE",{weekday:"long",day:"2-digit",month:"long",year:"numeric"})}</div>
        </div>

        <div style={{flex:1,overflowY:"auto",overflowX:"hidden"}}>
        {/* Nav */}
        {nav.map(n=>(
          <div key={n.id} onClick={()=>{
            if(n.id==="shootingplan")setShootingplanResetKey(k=>k+1);
            if(n.id==="buchung")setBuchungResetKey(k=>k+1);
            if(n.id==="events")setEventsResetKey(k=>k+1);
            if(page==="buchung"&&n.id!=="buchung"){starteLPHinweis();}
            setPage(n.id);
          }} style={{display:"flex",alignItems:"center",gap:10,padding:"10px 20px",cursor:"pointer",borderLeft:`3px solid ${page===n.id?T.accent:"transparent"}`,background:page===n.id?T.accentDim:"transparent",color:page===n.id?T.accent:T.muted,fontSize:15,fontWeight:500,transition:"all 0.15s",marginTop:n.gap?28:0}}>
            <span style={{width:16,height:16,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,opacity:page===n.id?1:0.6}}>{NAV_ICONS[n.id]}</span>
            {n.label}
          </div>
        ))}

        </div>{/* Ende scrollbarer Nav-Bereich */}


      </aside>

      <main ref={mainRef} style={{flex:1,padding:page==="calendar"?0:32,overflowY:["customers","statistik","buchung","reisekosten","newsletter","social","bestellungen","bildnummern","shootingkarte","gutscheine","einstellungen","bookings","homepage","inbox"].includes(page)?"auto":"hidden",position:"relative",maxWidth:"calc(100vw - 260px)"}}>
        {showLPHinweis&&<>
          <style>{`@keyframes lpBlinkAnim{0%,100%{opacity:1}50%{opacity:0.25}}`}</style>
          <div style={{position:"fixed",top:183,left:"calc(50% + 130px)",transform:"translateX(-50%)",zIndex:50,background:"#f59e0b",color:"#1a1814",padding:"4px 12px",display:"flex",alignItems:"center",gap:8,fontSize:11,fontWeight:600,borderRadius:6,boxShadow:"0 2px 8px rgba(0,0,0,0.15)",whiteSpace:"nowrap",animation:lpHinweisBlink?"lpBlinkAnim 0.5s ease-in-out infinite":"none"}}><span>🌐 Landingpage aktualisieren — Buchungsplan → Texte-Tab → Landingpage hochladen</span><button onClick={()=>{lpHinweisTimer.current.forEach(clearTimeout);setShowLPHinweis(false);setLpHinweisBlink(false);}} style={{background:"none",border:"none",cursor:"pointer",fontSize:13,color:"#1a1814",padding:"6px 4px",fontWeight:700}}>✕</button></div>
        </>}
        {page!=="statistik"&&page!=="shootingplan"&&page!=="buchung"&&page!=="homepage"&&(
          <div style={{marginBottom:28}}>{(()=>{
            const sh=(()=>{try{return JSON.parse(localStorage.getItem("sd_studio_header")||"null")||{};}catch{return {};}})();
            if(page==="dashboard"&&sh.logo){
              return(
                <div style={{display:"flex",flexDirection:"column",alignItems:"center",gap:8}}>
                  <img src={sh.logoDark||sh.logo} alt="Logo" style={{height:sh.logoH||150,maxWidth:400,objectFit:"contain"}}/>
                  {sh.name&&<div style={{fontFamily:sh.nameFont||"Georgia,serif",fontSize:sh.nameSize||26,fontWeight:sh.nameBold?"700":"400",fontStyle:sh.nameItalic?"italic":"normal",color:sh.nameColor||T.text}}>{sh.name}</div>}
                </div>
              );
            }
            const titel=page==="dashboard"&&sh.name?sh.name:pageTitle[page];
            return <div style={{fontFamily:page==="dashboard"?(sh.nameFont||"Georgia,serif"):"Georgia,serif",fontSize:page==="dashboard"?(sh.nameSize||26):26,fontWeight:page==="dashboard"?(sh.nameBold?"700":"400"):"700",fontStyle:page==="dashboard"?(sh.nameItalic?"italic":"normal"):"normal",color:page==="dashboard"?(sh.nameColor||T.text):T.text}}>{titel}</div>;
          })()}
          </div>
        )}
        {page==="shootingkarte"&&<ShootingKartePage bookings={bookings} customers={customers} events={events} T={T}/>}
        {page==="reisekosten"&&<ReisekostenPage T={T}/> }
        {page==="dashboard"&&<Dashboard customers={customers} setCustomers={setCustomers} bookings={bookings} setBookings={setBookings} events={events} setEvents={setEvents} setPage={setPage} T={T} onNewBooking={()=>setQTerminWahl(true)} onNewCustomer={()=>setQCust(true)} onOpenEventBookings={(ev)=>oeffneBuchungsplan(ev,"buchungen")} oeffneBuchungsplan={oeffneBuchungsplan} onOpenShootingplan={sp=>{setShootingplanInitData(sp);setPage("shootingplan");}}/>}
        {page==="calendar" &&<CalendarPage bookings={bookings} customers={customers} setCustomers={setCustomers} setBookings={setBookings} events={events} setEvents={setEvents} onDeleteEvent={deleteVeranstaltung} onCreateOrdner={erstelleServerOrdner}
          onOpenShootingplan={sp=>{
            setShootingplanInitData(sp);
            setPage("shootingplan");
          }}
          onOpenAbrechnung={id=>{
            setPage("events");
            setTimeout(()=>document.dispatchEvent(new CustomEvent("openEvent",{detail:{id}})),100);
          }}
          onOpenBuchung={(ev)=>oeffneBuchungsplan(ev)}
          T={T}/>}
        {page==="bookings" &&<BookingsPage bookings={bookings} customers={customers} setCustomers={setCustomers} setBookings={setBookings} events={events} setEvents={setEvents}
          onOpenShootingplan={sp=>{setShootingplanInitData(sp);setPage("shootingplan");}}
          onOpenBuchung={(ev)=>oeffneBuchungsplan(ev)}
          onCreateOrdner={erstelleServerOrdner}
          T={T}
          onOpenEvent={id=>{
            // Setze Event als aktiv und springe zu Events-Seite
            setPage("events");
            setTimeout(()=>document.dispatchEvent(new CustomEvent("openEvent",{detail:{id}})),100);
          }}
        />}
        {page==="customers"&&<CustomersPage customers={customers} bookings={bookings} setCustomers={setCustomers} setBookings={setBookings} T={T} events={events}/>}
        {page==="events"   &&<EventsPage key={eventsResetKey} events={events} setEvents={setEvents} T={T} onDeleteEvent={deleteVeranstaltung} onCreateOrdner={erstelleServerOrdner}
          shootingplanAbrData={shootingplanAbrData}
          onAbrDataConsumed={()=>setShootingplanAbrData(null)}
          onNewShootingplan={sp=>{
            setShootingplanInitData(sp);
            setPage("shootingplan");
          }}/>}
        {page==="shootingplan"&&<ShootingplanPage key={shootingplanResetKey} T={T} initData={shootingplanInitData} onInitConsumed={()=>setShootingplanInitData(null)}
          events={events} setEvents={setEvents} customers={customers} setCustomers={setCustomers}
          onGoToEvents={()=>setPage("events")}
          onOpenAbrechnung={evId=>{setShootingplanAbrData({evId,rows:[]});setPage("events");}}
          onGoToEvent={data=>{
            // Finde passendes Event oder erstelle Hinweis
            const ev=events.find(e=>e.name===data.name||e.date===data.date);
            if(ev){
              setShootingplanAbrData({evId:ev.id,rows:data.rows});
            } else {
              setShootingplanAbrData({evId:null,rows:data.rows,name:data.name});
            }
            setPage("events");
          }}
        />}
        {page==="bildnummern"&&<BildnummernPage T={T}/>}
        {page==="gutscheine"&&<GutscheinePage T={T}/>}
        {page==="einstellungen"&&<EinstellungenPage T={T} dark={dark} setDark={setDark} setPage={setPage}/>}
        {page==="newsletter"&&<NewsletterPage events={events} customers={customers} T={T}/>}
        {page==="social"&&<SocialPage events={events} bookings={bookings} customers={customers} T={T}/>}
        {page==="bestellungen"&&<BestellungenPage T={T}/>}
        {page==="homepage"&&<HomepagePage events={events} config={JSON.parse(localStorage.getItem("sd_buchung_config")||"{}")} T={T}/>}
        {page==="galerien"&&<GaleriePage T={T}/>}
        {page==="buchung"&&<BuchungssystemPage key={buchungResetKey} T={T} events={events} setEvents={setEvents} onOpenShootingplan={sp=>{setShootingplanInitData(sp);setPage("shootingplan");}} focusId={buchungFocusId} focusView={buchungFocusView} onFocusConsumed={()=>{setBuchungFocusId(null);setBuchungFocusView(null);}} onExportToShootingplan={(bks,evName,evType)=>{
          const sp={
            event_name:evName||"Import aus Buchungssystem",
            event_type:evType||"Underglass",
            event_date:"",event_start:"",event_end:"",
            rows:bks.map(b=>{
              let felder=[];
              try{const _cfg=JSON.parse(localStorage.getItem("sd_buchung_config")||"{}");const _st=(_cfg.shootingTypes||[]).find(s=>s.name===b.shootingType);felder=Array.isArray(_st&&_st.felder)?_st.felder:[];}catch(e){}
              const m=mapBookingFelder(b, felder);
              const _isGeschenk=!!(b.geschenk||b.formData?._geschenk);
              return {
                id:uid(),
                _buchungId:b.id||undefined,
                nr:"",
                uhrzeit:b.uhrzeit||"",
                name:_isGeschenk?(b.geschenk?.name||"🎁 Beschenkte: "+b.geschenk?.name||"🎁 Geschenk"):m.name||"",
                vorname:m.vorname||"",
                nachname:m.nachname||"",
                hund:m.hund||"",
                rasse:m.rasse||"",
                alter:String(m.alter||""),
                geschlecht:m.geschlecht||"",
                telefon:_isGeschenk?(b.geschenk?.handy||m.telefon||""):m.telefon||"",
                email:_isGeschenk?(b.geschenk?.email||m.email||""):m.email||"",
                strasse:m.strasse||"",
                plz:m.plz||"",
                ort:m.ort||"",
                cal:"",jot:"",notiz:"",
                datum:String(b.datum||"").slice(0,10), // Tag bei Mehrtagesveranstaltungen
                geschenk:_isGeschenk?b.geschenk:undefined,
                _geschenk:_isGeschenk||undefined,
              };
            }),
          };
          setShootingplanInitData(sp);
          setPage("shootingplan");
        }}/>}
        {page==="statistik"&&activeProfile&&(
          <div>
            <div style={{marginBottom:24,display:"flex",alignItems:"flex-start",justifyContent:"space-between"}}>
              <div>
                <div style={{fontFamily:"Georgia,serif",fontSize:26,fontWeight:700,color:T.text}}>
                  {activeProfile.name}
                  <span style={{fontSize:15,color:T.muted,fontWeight:400,marginLeft:10}}>{activeProfile.tierart}</span>
                </div>
                <div style={{fontSize:13,color:T.muted,marginTop:2}}>
                  {activeProfile.shootingTypes.filter(s=>s.aktiv&&s.name).map(s=>s.name).join(" · ")}
                </div>
              </div>
              <div style={{display:"flex",gap:8,alignItems:"center"}}>
              </div>
            </div>
            <StatistikView profile={activeProfile} onUpdate={updateProfile} T={T} dark={dark} onEditProfil={()=>setShowProfilModal(activeProfile)} onProfilSwitch={{profiles,set:setActiveProfileId,onNew:()=>setShowProfilModal("new")}}/>
          </div>
        )}
      </main>


      {qTerminWahl&&(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.78)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:100,padding:20}}>
          <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:16,padding:28,width:"100%",maxWidth:420}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:6}}>
              <div style={{fontFamily:"Georgia,serif",fontSize:20,color:T.accent}}>Was möchtest du anlegen?</div>
              <button style={btn(T,"ghost",true)} onClick={()=>setQTerminWahl(false)}>✕</button>
            </div>
            <p style={{fontSize:13,color:T.muted,marginBottom:20}}>Einzeltermin, Veranstaltung oder unverbindliche Interessentenliste.</p>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:10}}>
              <div onClick={()=>{setQTerminWahl(false);setQBook(true);}}
                style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:12,padding:16,cursor:"pointer",textAlign:"center",transition:"all 0.15s"}}
                onMouseEnter={e=>e.currentTarget.style.borderColor=T.accent}
                onMouseLeave={e=>e.currentTarget.style.borderColor=T.border}>
                <div style={{display:"flex",justifyContent:"center",marginBottom:10,color:T.accent}}><Ic n="calendar" s={24}/></div>
                <div style={{fontSize:13,fontWeight:700,color:T.text,marginBottom:4}}>Einzeltermin</div>
                <div style={{fontSize:11,color:T.muted,lineHeight:1.5}}>Shooting mit einem Kunden</div>
              </div>
              <div onClick={()=>{setQTerminWahl(false);setQEventModal(true);}}
                style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:12,padding:16,cursor:"pointer",textAlign:"center",transition:"all 0.15s"}}
                onMouseEnter={e=>e.currentTarget.style.borderColor=T.accent}
                onMouseLeave={e=>e.currentTarget.style.borderColor=T.border}>
                <div style={{display:"flex",justifyContent:"center",marginBottom:10,color:T.accent}}><Ic n="invoice" s={24}/></div>
                <div style={{fontSize:13,fontWeight:700,color:T.text,marginBottom:4}}>Veranstaltung</div>
                <div style={{fontSize:11,color:T.muted,lineHeight:1.5}}>Event mit mehreren Teilnehmern</div>
              </div>
              <div onClick={()=>{setQTerminWahl(false);setQInteresseModal(true);}}
                style={{background:T.bg,border:"1px solid #f59e0b44",borderRadius:12,padding:16,cursor:"pointer",textAlign:"center",transition:"all 0.15s"}}
                onMouseEnter={e=>e.currentTarget.style.borderColor="#f59e0b"}
                onMouseLeave={e=>e.currentTarget.style.borderColor="#f59e0b44"}>
                <div style={{display:"flex",justifyContent:"center",marginBottom:10,color:"#f59e0b"}}><Ic n="list" s={24}/></div>
                <div style={{fontSize:13,fontWeight:700,color:T.text,marginBottom:4}}>Interessenten</div>
                <div style={{fontSize:11,color:T.muted,lineHeight:1.5}}>Ohne festes Datum</div>
              </div>
            </div>
          </div>
        </div>
      )}
      {qBook&&<BookingModal booking={null} customers={customers} setCustomers={setCustomers} onSave={b=>{setBookings(p=>[...p,b]);setQBook(false);}} onClose={()=>setQBook(false)} T={T}/>}
      {qEventModal&&<EventModal event={null} onSave={ev=>{setEvents(p=>p.find(x=>x.id===ev.id)?p.map(x=>x.id===ev.id?ev:x):[...p,ev]);erstelleServerOrdner(ev);setQEventModal(false);}} onClose={()=>setQEventModal(false)} T={T}/>}
      {qInteresseModal&&<EventModal event={null} onSave={ev=>{setEvents(p=>[...p,ev]);setQInteresseModal(false);}} onClose={()=>setQInteresseModal(false)} T={T} datumOptional={true}/>}
      {qCust&&<CustomerModal customer={null} onSave={c=>{setCustomers(p=>[...p,c]);setQCust(false);}} onClose={()=>setQCust(false)} T={T}/>}
      {showProfilModal&&<ProfilModal profile={showProfilModal==="new"?null:showProfilModal} isNew={showProfilModal==="new"} onSave={saveProfilModal} onClose={()=>setShowProfilModal(null)} T={T}/>}
    </div>
    </>
  );
}

